function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredce6"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredce6"] = parcelRequire;
}
parcelRequire.register("4Bxju", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $35a4757aa7b3d19f$export$ffb0004e005737fa, (v) => $35a4757aa7b3d19f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $35a4757aa7b3d19f$export$34b9dba7ce09269b, (v) => $35a4757aa7b3d19f$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $35a4757aa7b3d19f$export$25062201e9e25d76, (v) => $35a4757aa7b3d19f$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $35a4757aa7b3d19f$export$ffb0004e005737fa;
var $35a4757aa7b3d19f$export$34b9dba7ce09269b;
var $35a4757aa7b3d19f$export$25062201e9e25d76;
"use strict";

var $k116o = parcelRequire("k116o");
var $35a4757aa7b3d19f$var$k = Symbol.for("react.element"), $35a4757aa7b3d19f$var$l = Symbol.for("react.fragment"), $35a4757aa7b3d19f$var$m = Object.prototype.hasOwnProperty, $35a4757aa7b3d19f$var$n = $k116o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $35a4757aa7b3d19f$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $35a4757aa7b3d19f$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$35a4757aa7b3d19f$var$m.call(a, b) && !$35a4757aa7b3d19f$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $35a4757aa7b3d19f$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $35a4757aa7b3d19f$var$n.current
    };
}
$35a4757aa7b3d19f$export$ffb0004e005737fa = $35a4757aa7b3d19f$var$l;
$35a4757aa7b3d19f$export$34b9dba7ce09269b = $35a4757aa7b3d19f$var$q;
$35a4757aa7b3d19f$export$25062201e9e25d76 = $35a4757aa7b3d19f$var$q;

});
parcelRequire.register("k116o", function(module, exports) {
"use strict";

module.exports = (parcelRequire("twj9G"));

});
parcelRequire.register("twj9G", function(module, exports) {

$parcel$export(module.exports, "Children", () => $058bc53c2bcaba9c$export$dca3b0875bd9a954, (v) => $058bc53c2bcaba9c$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $058bc53c2bcaba9c$export$16fa2f45be04daa8, (v) => $058bc53c2bcaba9c$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $058bc53c2bcaba9c$export$ffb0004e005737fa, (v) => $058bc53c2bcaba9c$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $058bc53c2bcaba9c$export$e2c29f18771995cb, (v) => $058bc53c2bcaba9c$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $058bc53c2bcaba9c$export$221d75b3f55bb0bd, (v) => $058bc53c2bcaba9c$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $058bc53c2bcaba9c$export$5f8d39834fd61797, (v) => $058bc53c2bcaba9c$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $058bc53c2bcaba9c$export$74bf444e3cd11ea5, (v) => $058bc53c2bcaba9c$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $058bc53c2bcaba9c$export$998bcd577473dd93, (v) => $058bc53c2bcaba9c$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $058bc53c2bcaba9c$export$ae55be85d98224ed, (v) => $058bc53c2bcaba9c$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cache", () => $058bc53c2bcaba9c$export$69a3209f1a06c04d, (v) => $058bc53c2bcaba9c$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cloneElement", () => $058bc53c2bcaba9c$export$e530037191fcd5d7, (v) => $058bc53c2bcaba9c$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $058bc53c2bcaba9c$export$fd42f52fd3ae1109, (v) => $058bc53c2bcaba9c$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $058bc53c2bcaba9c$export$c8a8987d4410bf2d, (v) => $058bc53c2bcaba9c$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $058bc53c2bcaba9c$export$d38cd72104c1f0e9, (v) => $058bc53c2bcaba9c$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $058bc53c2bcaba9c$export$7d1e3a5e95ceca43, (v) => $058bc53c2bcaba9c$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "createServerContext", () => $058bc53c2bcaba9c$export$a1595de6c0c14ee2, (v) => $058bc53c2bcaba9c$export$a1595de6c0c14ee2 = v);
$parcel$export(module.exports, "experimental_useEffectEvent", () => $058bc53c2bcaba9c$export$8456a2a90d23d0b5, (v) => $058bc53c2bcaba9c$export$8456a2a90d23d0b5 = v);
$parcel$export(module.exports, "forwardRef", () => $058bc53c2bcaba9c$export$257a8862b851cb5b, (v) => $058bc53c2bcaba9c$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $058bc53c2bcaba9c$export$a8257692ac88316c, (v) => $058bc53c2bcaba9c$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $058bc53c2bcaba9c$export$488013bae63b21da, (v) => $058bc53c2bcaba9c$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $058bc53c2bcaba9c$export$7c73462e0d25e514, (v) => $058bc53c2bcaba9c$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $058bc53c2bcaba9c$export$7568632d0d33d16d, (v) => $058bc53c2bcaba9c$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_Cache", () => $058bc53c2bcaba9c$export$3e796c3a8922c7cc, (v) => $058bc53c2bcaba9c$export$3e796c3a8922c7cc = v);
$parcel$export(module.exports, "unstable_DebugTracingMode", () => $058bc53c2bcaba9c$export$59dfbe9b0737609d, (v) => $058bc53c2bcaba9c$export$59dfbe9b0737609d = v);
$parcel$export(module.exports, "unstable_Offscreen", () => $058bc53c2bcaba9c$export$93910eb6913f6019, (v) => $058bc53c2bcaba9c$export$93910eb6913f6019 = v);
$parcel$export(module.exports, "unstable_act", () => $058bc53c2bcaba9c$export$88948ce120ea2619, (v) => $058bc53c2bcaba9c$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "unstable_getCacheForType", () => $058bc53c2bcaba9c$export$e1ca0f7daf85f77f, (v) => $058bc53c2bcaba9c$export$e1ca0f7daf85f77f = v);
$parcel$export(module.exports, "unstable_getCacheSignal", () => $058bc53c2bcaba9c$export$60b5d2e40643d89b, (v) => $058bc53c2bcaba9c$export$60b5d2e40643d89b = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $058bc53c2bcaba9c$export$f93f40ac0ca7e3a8, (v) => $058bc53c2bcaba9c$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "unstable_useMemoCache", () => $058bc53c2bcaba9c$export$ea0615971b736221, (v) => $058bc53c2bcaba9c$export$ea0615971b736221 = v);
$parcel$export(module.exports, "use", () => $058bc53c2bcaba9c$export$1f96ae73734a86cc, (v) => $058bc53c2bcaba9c$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useCallback", () => $058bc53c2bcaba9c$export$35808ee640e87ca7, (v) => $058bc53c2bcaba9c$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $058bc53c2bcaba9c$export$fae74005e78b1a27, (v) => $058bc53c2bcaba9c$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $058bc53c2bcaba9c$export$dc8fbce3eb94dc1e, (v) => $058bc53c2bcaba9c$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $058bc53c2bcaba9c$export$6a7bc4e911dc01cf, (v) => $058bc53c2bcaba9c$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $058bc53c2bcaba9c$export$6d9c69b0de29b591, (v) => $058bc53c2bcaba9c$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $058bc53c2bcaba9c$export$f680877a34711e37, (v) => $058bc53c2bcaba9c$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $058bc53c2bcaba9c$export$d5a552a76deda3c2, (v) => $058bc53c2bcaba9c$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $058bc53c2bcaba9c$export$aaabe4eda9ed9969, (v) => $058bc53c2bcaba9c$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $058bc53c2bcaba9c$export$e5c5a5f917a5871c, (v) => $058bc53c2bcaba9c$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $058bc53c2bcaba9c$export$1538c33de8887b59, (v) => $058bc53c2bcaba9c$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $058bc53c2bcaba9c$export$13e3392192263954, (v) => $058bc53c2bcaba9c$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $058bc53c2bcaba9c$export$b8f5890fc79d6aca, (v) => $058bc53c2bcaba9c$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $058bc53c2bcaba9c$export$60241385465d0a34, (v) => $058bc53c2bcaba9c$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $058bc53c2bcaba9c$export$306c0aa65ff9ec16, (v) => $058bc53c2bcaba9c$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $058bc53c2bcaba9c$export$7b286972b8d8ccbf, (v) => $058bc53c2bcaba9c$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $058bc53c2bcaba9c$export$83d89fbfd8236492, (v) => $058bc53c2bcaba9c$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $058bc53c2bcaba9c$export$dca3b0875bd9a954;
var $058bc53c2bcaba9c$export$16fa2f45be04daa8;
var $058bc53c2bcaba9c$export$ffb0004e005737fa;
var $058bc53c2bcaba9c$export$e2c29f18771995cb;
var $058bc53c2bcaba9c$export$221d75b3f55bb0bd;
var $058bc53c2bcaba9c$export$5f8d39834fd61797;
var $058bc53c2bcaba9c$export$74bf444e3cd11ea5;
var $058bc53c2bcaba9c$export$998bcd577473dd93;
var $058bc53c2bcaba9c$export$ae55be85d98224ed;
var $058bc53c2bcaba9c$export$69a3209f1a06c04d;
var $058bc53c2bcaba9c$export$e530037191fcd5d7;
var $058bc53c2bcaba9c$export$fd42f52fd3ae1109;
var $058bc53c2bcaba9c$export$c8a8987d4410bf2d;
var $058bc53c2bcaba9c$export$d38cd72104c1f0e9;
var $058bc53c2bcaba9c$export$7d1e3a5e95ceca43;
var $058bc53c2bcaba9c$export$a1595de6c0c14ee2;
var $058bc53c2bcaba9c$export$8456a2a90d23d0b5;
var $058bc53c2bcaba9c$export$257a8862b851cb5b;
var $058bc53c2bcaba9c$export$a8257692ac88316c;
var $058bc53c2bcaba9c$export$488013bae63b21da;
var $058bc53c2bcaba9c$export$7c73462e0d25e514;
var $058bc53c2bcaba9c$export$7568632d0d33d16d;
var $058bc53c2bcaba9c$export$3e796c3a8922c7cc;
var $058bc53c2bcaba9c$export$59dfbe9b0737609d;
var $058bc53c2bcaba9c$export$93910eb6913f6019;
var $058bc53c2bcaba9c$export$88948ce120ea2619;
var $058bc53c2bcaba9c$export$e1ca0f7daf85f77f;
var $058bc53c2bcaba9c$export$60b5d2e40643d89b;
var $058bc53c2bcaba9c$export$f93f40ac0ca7e3a8;
var $058bc53c2bcaba9c$export$ea0615971b736221;
var $058bc53c2bcaba9c$export$1f96ae73734a86cc;
var $058bc53c2bcaba9c$export$35808ee640e87ca7;
var $058bc53c2bcaba9c$export$fae74005e78b1a27;
var $058bc53c2bcaba9c$export$dc8fbce3eb94dc1e;
var $058bc53c2bcaba9c$export$6a7bc4e911dc01cf;
var $058bc53c2bcaba9c$export$6d9c69b0de29b591;
var $058bc53c2bcaba9c$export$f680877a34711e37;
var $058bc53c2bcaba9c$export$d5a552a76deda3c2;
var $058bc53c2bcaba9c$export$aaabe4eda9ed9969;
var $058bc53c2bcaba9c$export$e5c5a5f917a5871c;
var $058bc53c2bcaba9c$export$1538c33de8887b59;
var $058bc53c2bcaba9c$export$13e3392192263954;
var $058bc53c2bcaba9c$export$b8f5890fc79d6aca;
var $058bc53c2bcaba9c$export$60241385465d0a34;
var $058bc53c2bcaba9c$export$306c0aa65ff9ec16;
var $058bc53c2bcaba9c$export$7b286972b8d8ccbf;
var $058bc53c2bcaba9c$export$83d89fbfd8236492;
"use strict";
var $058bc53c2bcaba9c$var$l = Symbol.for("react.element"), $058bc53c2bcaba9c$var$n = Symbol.for("react.portal"), $058bc53c2bcaba9c$var$p = Symbol.for("react.fragment"), $058bc53c2bcaba9c$var$q = Symbol.for("react.strict_mode"), $058bc53c2bcaba9c$var$r = Symbol.for("react.profiler"), $058bc53c2bcaba9c$var$t = Symbol.for("react.provider"), $058bc53c2bcaba9c$var$u = Symbol.for("react.context"), $058bc53c2bcaba9c$var$v = Symbol.for("react.server_context"), $058bc53c2bcaba9c$var$w = Symbol.for("react.forward_ref"), $058bc53c2bcaba9c$var$x = Symbol.for("react.suspense"), $058bc53c2bcaba9c$var$y = Symbol.for("react.suspense_list"), $058bc53c2bcaba9c$var$z = Symbol.for("react.memo"), $058bc53c2bcaba9c$var$A = Symbol.for("react.lazy"), $058bc53c2bcaba9c$var$aa = Symbol.for("react.debug_trace_mode"), $058bc53c2bcaba9c$var$ba = Symbol.for("react.offscreen"), $058bc53c2bcaba9c$var$ca = Symbol.for("react.cache"), $058bc53c2bcaba9c$var$B = Symbol.for("react.default_value"), $058bc53c2bcaba9c$var$C = Symbol.iterator;
function $058bc53c2bcaba9c$var$da(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $058bc53c2bcaba9c$var$C && a[$058bc53c2bcaba9c$var$C] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $058bc53c2bcaba9c$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $058bc53c2bcaba9c$var$E = Object.assign, $058bc53c2bcaba9c$var$F = {};
function $058bc53c2bcaba9c$var$G(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $058bc53c2bcaba9c$var$F;
    this.updater = c || $058bc53c2bcaba9c$var$D;
}
$058bc53c2bcaba9c$var$G.prototype.isReactComponent = {};
$058bc53c2bcaba9c$var$G.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$058bc53c2bcaba9c$var$G.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $058bc53c2bcaba9c$var$H() {}
$058bc53c2bcaba9c$var$H.prototype = $058bc53c2bcaba9c$var$G.prototype;
function $058bc53c2bcaba9c$var$I(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $058bc53c2bcaba9c$var$F;
    this.updater = c || $058bc53c2bcaba9c$var$D;
}
var $058bc53c2bcaba9c$var$J = $058bc53c2bcaba9c$var$I.prototype = new $058bc53c2bcaba9c$var$H;
$058bc53c2bcaba9c$var$J.constructor = $058bc53c2bcaba9c$var$I;
$058bc53c2bcaba9c$var$E($058bc53c2bcaba9c$var$J, $058bc53c2bcaba9c$var$G.prototype);
$058bc53c2bcaba9c$var$J.isPureReactComponent = !0;
var $058bc53c2bcaba9c$var$K = Array.isArray, $058bc53c2bcaba9c$var$L = Object.prototype.hasOwnProperty, $058bc53c2bcaba9c$var$M = {
    current: null
}, $058bc53c2bcaba9c$var$N = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $058bc53c2bcaba9c$var$O(a, b, c) {
    var d, e = {}, f = null, g = null;
    if (null != b) for(d in void 0 !== b.ref && (g = b.ref), void 0 !== b.key && (f = "" + b.key), b)$058bc53c2bcaba9c$var$L.call(b, d) && !$058bc53c2bcaba9c$var$N.hasOwnProperty(d) && (e[d] = b[d]);
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        for(var k = Array(h), m = 0; m < h; m++)k[m] = arguments[m + 2];
        e.children = k;
    }
    if (a && a.defaultProps) for(d in h = a.defaultProps, h)void 0 === e[d] && (e[d] = h[d]);
    return {
        $$typeof: $058bc53c2bcaba9c$var$l,
        type: a,
        key: f,
        ref: g,
        props: e,
        _owner: $058bc53c2bcaba9c$var$M.current
    };
}
function $058bc53c2bcaba9c$var$ea(a, b) {
    return {
        $$typeof: $058bc53c2bcaba9c$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $058bc53c2bcaba9c$var$P(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $058bc53c2bcaba9c$var$l;
}
function $058bc53c2bcaba9c$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(c) {
        return b[c];
    });
}
var $058bc53c2bcaba9c$var$Q = /\/+/g;
function $058bc53c2bcaba9c$var$R(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $058bc53c2bcaba9c$var$escape("" + a.key) : b.toString(36);
}
function $058bc53c2bcaba9c$var$S(a, b, c, d, e) {
    var f = typeof a;
    if ("undefined" === f || "boolean" === f) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(f){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $058bc53c2bcaba9c$var$l:
                case $058bc53c2bcaba9c$var$n:
                    g = !0;
            }
    }
    if (g) return g = a, e = e(g), a = "" === d ? "." + $058bc53c2bcaba9c$var$R(g, 0) : d, $058bc53c2bcaba9c$var$K(e) ? (c = "", null != a && (c = a.replace($058bc53c2bcaba9c$var$Q, "$&/") + "/"), $058bc53c2bcaba9c$var$S(e, b, c, "", function(m) {
        return m;
    })) : null != e && ($058bc53c2bcaba9c$var$P(e) && (e = $058bc53c2bcaba9c$var$ea(e, c + (!e.key || g && g.key === e.key ? "" : ("" + e.key).replace($058bc53c2bcaba9c$var$Q, "$&/") + "/") + a)), b.push(e)), 1;
    g = 0;
    d = "" === d ? "." : d + ":";
    if ($058bc53c2bcaba9c$var$K(a)) for(var h = 0; h < a.length; h++){
        f = a[h];
        var k = d + $058bc53c2bcaba9c$var$R(f, h);
        g += $058bc53c2bcaba9c$var$S(f, b, c, k, e);
    }
    else if (k = $058bc53c2bcaba9c$var$da(a), "function" === typeof k) for(a = k.call(a), h = 0; !(f = a.next()).done;)f = f.value, k = d + $058bc53c2bcaba9c$var$R(f, h++), g += $058bc53c2bcaba9c$var$S(f, b, c, k, e);
    else if ("object" === f) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return g;
}
function $058bc53c2bcaba9c$var$T(a, b, c) {
    if (null == a) return a;
    var d = [], e = 0;
    $058bc53c2bcaba9c$var$S(a, d, "", "", function(f) {
        return b.call(c, f, e++);
    });
    return d;
}
function $058bc53c2bcaba9c$var$fa(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(c) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = c;
        }, function(c) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = c;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $058bc53c2bcaba9c$var$U = {
    current: null
};
function $058bc53c2bcaba9c$var$ha() {
    return new WeakMap;
}
function $058bc53c2bcaba9c$var$V() {
    return {
        s: 0,
        v: void 0,
        o: null,
        p: null
    };
}
var $058bc53c2bcaba9c$var$W = {
    current: null
}, $058bc53c2bcaba9c$var$X = {
    transition: null
}, $058bc53c2bcaba9c$var$Y = {
    ReactCurrentDispatcher: $058bc53c2bcaba9c$var$W,
    ReactCurrentCache: $058bc53c2bcaba9c$var$U,
    ReactCurrentBatchConfig: $058bc53c2bcaba9c$var$X,
    ReactCurrentOwner: $058bc53c2bcaba9c$var$M,
    ContextRegistry: {}
}, $058bc53c2bcaba9c$var$Z = $058bc53c2bcaba9c$var$Y.ContextRegistry;
$058bc53c2bcaba9c$export$dca3b0875bd9a954 = {
    map: $058bc53c2bcaba9c$var$T,
    forEach: function(a, b, c) {
        $058bc53c2bcaba9c$var$T(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $058bc53c2bcaba9c$var$T(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $058bc53c2bcaba9c$var$T(a, function(b) {
            return b;
        }) || [];
    },
    only: function(a) {
        if (!$058bc53c2bcaba9c$var$P(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$058bc53c2bcaba9c$export$16fa2f45be04daa8 = $058bc53c2bcaba9c$var$G;
$058bc53c2bcaba9c$export$ffb0004e005737fa = $058bc53c2bcaba9c$var$p;
$058bc53c2bcaba9c$export$e2c29f18771995cb = $058bc53c2bcaba9c$var$r;
$058bc53c2bcaba9c$export$221d75b3f55bb0bd = $058bc53c2bcaba9c$var$I;
$058bc53c2bcaba9c$export$5f8d39834fd61797 = $058bc53c2bcaba9c$var$q;
$058bc53c2bcaba9c$export$74bf444e3cd11ea5 = $058bc53c2bcaba9c$var$x;
$058bc53c2bcaba9c$export$998bcd577473dd93 = $058bc53c2bcaba9c$var$y;
$058bc53c2bcaba9c$export$ae55be85d98224ed = $058bc53c2bcaba9c$var$Y;
$058bc53c2bcaba9c$export$69a3209f1a06c04d = function(a) {
    return function() {
        var b = $058bc53c2bcaba9c$var$U.current;
        if (!b) return a.apply(null, arguments);
        var c = b.getCacheForType($058bc53c2bcaba9c$var$ha);
        b = c.get(a);
        void 0 === b && (b = $058bc53c2bcaba9c$var$V(), c.set(a, b));
        c = 0;
        for(var d = arguments.length; c < d; c++){
            var e = arguments[c];
            if ("function" === typeof e || "object" === typeof e && null !== e) {
                var f = b.o;
                null === f && (b.o = f = new WeakMap);
                b = f.get(e);
                void 0 === b && (b = $058bc53c2bcaba9c$var$V(), f.set(e, b));
            } else f = b.p, null === f && (b.p = f = new Map), b = f.get(e), void 0 === b && (b = $058bc53c2bcaba9c$var$V(), f.set(e, b));
        }
        if (1 === b.s) return b.v;
        if (2 === b.s) throw b.v;
        try {
            var g = a.apply(null, arguments);
            c = b;
            c.s = 1;
            return c.v = g;
        } catch (h) {
            throw g = b, g.s = 2, g.v = h, h;
        }
    };
};
$058bc53c2bcaba9c$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $058bc53c2bcaba9c$var$E({}, a.props), e = a.key, f = a.ref, g = a._owner;
    if (null != b) {
        void 0 !== b.ref && (f = b.ref, g = $058bc53c2bcaba9c$var$M.current);
        void 0 !== b.key && (e = "" + b.key);
        if (a.type && a.type.defaultProps) var h = a.type.defaultProps;
        for(k in b)$058bc53c2bcaba9c$var$L.call(b, k) && !$058bc53c2bcaba9c$var$N.hasOwnProperty(k) && (d[k] = void 0 === b[k] && void 0 !== h ? h[k] : b[k]);
    }
    var k = arguments.length - 2;
    if (1 === k) d.children = c;
    else if (1 < k) {
        h = Array(k);
        for(var m = 0; m < k; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    return {
        $$typeof: $058bc53c2bcaba9c$var$l,
        type: a.type,
        key: e,
        ref: f,
        props: d,
        _owner: g
    };
};
$058bc53c2bcaba9c$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $058bc53c2bcaba9c$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $058bc53c2bcaba9c$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$058bc53c2bcaba9c$export$c8a8987d4410bf2d = $058bc53c2bcaba9c$var$O;
$058bc53c2bcaba9c$export$d38cd72104c1f0e9 = function(a) {
    var b = $058bc53c2bcaba9c$var$O.bind(null, a);
    b.type = a;
    return b;
};
$058bc53c2bcaba9c$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$058bc53c2bcaba9c$export$a1595de6c0c14ee2 = function(a, b) {
    var c = !0;
    if (!$058bc53c2bcaba9c$var$Z[a]) {
        c = !1;
        var d = {
            $$typeof: $058bc53c2bcaba9c$var$v,
            _currentValue: b,
            _currentValue2: b,
            _defaultValue: b,
            _threadCount: 0,
            Provider: null,
            Consumer: null,
            _globalName: a
        };
        d.Provider = {
            $$typeof: $058bc53c2bcaba9c$var$t,
            _context: d
        };
        $058bc53c2bcaba9c$var$Z[a] = d;
    }
    d = $058bc53c2bcaba9c$var$Z[a];
    if (d._defaultValue === $058bc53c2bcaba9c$var$B) d._defaultValue = b, d._currentValue === $058bc53c2bcaba9c$var$B && (d._currentValue = b), d._currentValue2 === $058bc53c2bcaba9c$var$B && (d._currentValue2 = b);
    else if (c) throw Error("ServerContext: " + a + " already defined");
    return d;
};
$058bc53c2bcaba9c$export$8456a2a90d23d0b5 = function(a) {
    return $058bc53c2bcaba9c$var$W.current.useEffectEvent(a);
};
$058bc53c2bcaba9c$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $058bc53c2bcaba9c$var$w,
        render: a
    };
};
$058bc53c2bcaba9c$export$a8257692ac88316c = $058bc53c2bcaba9c$var$P;
$058bc53c2bcaba9c$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $058bc53c2bcaba9c$var$A,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $058bc53c2bcaba9c$var$fa
    };
};
$058bc53c2bcaba9c$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $058bc53c2bcaba9c$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$058bc53c2bcaba9c$export$7568632d0d33d16d = function(a) {
    var b = $058bc53c2bcaba9c$var$X.transition;
    $058bc53c2bcaba9c$var$X.transition = {};
    try {
        a();
    } finally{
        $058bc53c2bcaba9c$var$X.transition = b;
    }
};
$058bc53c2bcaba9c$export$3e796c3a8922c7cc = $058bc53c2bcaba9c$var$ca;
$058bc53c2bcaba9c$export$59dfbe9b0737609d = $058bc53c2bcaba9c$var$aa;
$058bc53c2bcaba9c$export$93910eb6913f6019 = $058bc53c2bcaba9c$var$ba;
$058bc53c2bcaba9c$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$058bc53c2bcaba9c$export$e1ca0f7daf85f77f = function(a) {
    var b = $058bc53c2bcaba9c$var$U.current;
    return b ? b.getCacheForType(a) : a();
};
$058bc53c2bcaba9c$export$60b5d2e40643d89b = function() {
    var a = $058bc53c2bcaba9c$var$U.current;
    return a ? a.getCacheSignal() : (a = new AbortController, a.abort(Error("This CacheSignal was requested outside React which means that it is immediately aborted.")), a.signal);
};
$058bc53c2bcaba9c$export$f93f40ac0ca7e3a8 = function() {
    return $058bc53c2bcaba9c$var$W.current.useCacheRefresh();
};
$058bc53c2bcaba9c$export$ea0615971b736221 = function(a) {
    return $058bc53c2bcaba9c$var$W.current.useMemoCache(a);
};
$058bc53c2bcaba9c$export$1f96ae73734a86cc = function(a) {
    return $058bc53c2bcaba9c$var$W.current.use(a);
};
$058bc53c2bcaba9c$export$35808ee640e87ca7 = function(a, b) {
    return $058bc53c2bcaba9c$var$W.current.useCallback(a, b);
};
$058bc53c2bcaba9c$export$fae74005e78b1a27 = function(a) {
    return $058bc53c2bcaba9c$var$W.current.useContext(a);
};
$058bc53c2bcaba9c$export$dc8fbce3eb94dc1e = function() {};
$058bc53c2bcaba9c$export$6a7bc4e911dc01cf = function(a) {
    return $058bc53c2bcaba9c$var$W.current.useDeferredValue(a);
};
$058bc53c2bcaba9c$export$6d9c69b0de29b591 = function(a, b) {
    return $058bc53c2bcaba9c$var$W.current.useEffect(a, b);
};
$058bc53c2bcaba9c$export$f680877a34711e37 = function() {
    return $058bc53c2bcaba9c$var$W.current.useId();
};
$058bc53c2bcaba9c$export$d5a552a76deda3c2 = function(a, b, c) {
    return $058bc53c2bcaba9c$var$W.current.useImperativeHandle(a, b, c);
};
$058bc53c2bcaba9c$export$aaabe4eda9ed9969 = function(a, b) {
    return $058bc53c2bcaba9c$var$W.current.useInsertionEffect(a, b);
};
$058bc53c2bcaba9c$export$e5c5a5f917a5871c = function(a, b) {
    return $058bc53c2bcaba9c$var$W.current.useLayoutEffect(a, b);
};
$058bc53c2bcaba9c$export$1538c33de8887b59 = function(a, b) {
    return $058bc53c2bcaba9c$var$W.current.useMemo(a, b);
};
$058bc53c2bcaba9c$export$13e3392192263954 = function(a, b, c) {
    return $058bc53c2bcaba9c$var$W.current.useReducer(a, b, c);
};
$058bc53c2bcaba9c$export$b8f5890fc79d6aca = function(a) {
    return $058bc53c2bcaba9c$var$W.current.useRef(a);
};
$058bc53c2bcaba9c$export$60241385465d0a34 = function(a) {
    return $058bc53c2bcaba9c$var$W.current.useState(a);
};
$058bc53c2bcaba9c$export$306c0aa65ff9ec16 = function(a, b, c) {
    return $058bc53c2bcaba9c$var$W.current.useSyncExternalStore(a, b, c);
};
$058bc53c2bcaba9c$export$7b286972b8d8ccbf = function() {
    return $058bc53c2bcaba9c$var$W.current.useTransition();
};
$058bc53c2bcaba9c$export$83d89fbfd8236492 = "18.3.0-experimental-49f741046-20230305";

});



parcelRequire.register("11Y1g", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0c04710c92712449$export$ae55be85d98224ed, (v) => $0c04710c92712449$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0c04710c92712449$export$d39a5bbd09211389, (v) => $0c04710c92712449$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0c04710c92712449$export$882461b6382ed46c, (v) => $0c04710c92712449$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0c04710c92712449$export$466bfc07425424d5, (v) => $0c04710c92712449$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0c04710c92712449$export$cd75ccfd720a3cd4, (v) => $0c04710c92712449$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0c04710c92712449$export$fa8d919ba61d84db, (v) => $0c04710c92712449$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0c04710c92712449$export$757ceba2d55c277e, (v) => $0c04710c92712449$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "preconnect", () => $0c04710c92712449$export$a0816fa17a9e79be, (v) => $0c04710c92712449$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $0c04710c92712449$export$7292efcadded39f3, (v) => $0c04710c92712449$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $0c04710c92712449$export$da407abadb9b8f86, (v) => $0c04710c92712449$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preload", () => $0c04710c92712449$export$513ccb98c53b8039, (v) => $0c04710c92712449$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "render", () => $0c04710c92712449$export$b3890eb0ae9dca99, (v) => $0c04710c92712449$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0c04710c92712449$export$502457920280e6be, (v) => $0c04710c92712449$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0c04710c92712449$export$c78a37762a8d58e1, (v) => $0c04710c92712449$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0c04710c92712449$export$dc54d992c10e8a18, (v) => $0c04710c92712449$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $0c04710c92712449$export$61bcfe829111a1d0, (v) => $0c04710c92712449$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "version", () => $0c04710c92712449$export$83d89fbfd8236492, (v) => $0c04710c92712449$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0c04710c92712449$export$ae55be85d98224ed;
var $0c04710c92712449$export$d39a5bbd09211389;
var $0c04710c92712449$export$882461b6382ed46c;
var $0c04710c92712449$export$466bfc07425424d5;
var $0c04710c92712449$export$cd75ccfd720a3cd4;
var $0c04710c92712449$export$fa8d919ba61d84db;
var $0c04710c92712449$export$757ceba2d55c277e;
var $0c04710c92712449$export$a0816fa17a9e79be;
var $0c04710c92712449$export$7292efcadded39f3;
var $0c04710c92712449$export$da407abadb9b8f86;
var $0c04710c92712449$export$513ccb98c53b8039;
var $0c04710c92712449$export$b3890eb0ae9dca99;
var $0c04710c92712449$export$502457920280e6be;
var $0c04710c92712449$export$c78a37762a8d58e1;
var $0c04710c92712449$export$dc54d992c10e8a18;
var $0c04710c92712449$export$61bcfe829111a1d0;
var $0c04710c92712449$export$83d89fbfd8236492;
"use strict";

var $9gi6K = parcelRequire("9gi6K");

var $k116o = parcelRequire("k116o");
var $0c04710c92712449$var$ca = {
    usingClientEntryPoint: !1,
    Events: null,
    Dispatcher: {
        current: null
    }
};
function $0c04710c92712449$var$q(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0c04710c92712449$var$da = Math.random().toString(36).slice(2), $0c04710c92712449$var$ea = "__reactFiber$" + $0c04710c92712449$var$da, $0c04710c92712449$var$fa = "__reactProps$" + $0c04710c92712449$var$da, $0c04710c92712449$var$ha = "__reactContainer$" + $0c04710c92712449$var$da, $0c04710c92712449$var$ia = "__reactEvents$" + $0c04710c92712449$var$da, $0c04710c92712449$var$ja = "__reactListeners$" + $0c04710c92712449$var$da, $0c04710c92712449$var$ka = "__reactHandles$" + $0c04710c92712449$var$da, $0c04710c92712449$var$la = "__reactResources$" + $0c04710c92712449$var$da, $0c04710c92712449$var$ma = "__reactMarker$" + $0c04710c92712449$var$da;
function $0c04710c92712449$var$na(a) {
    delete a[$0c04710c92712449$var$ea];
    delete a[$0c04710c92712449$var$fa];
    delete a[$0c04710c92712449$var$ia];
    delete a[$0c04710c92712449$var$ja];
    delete a[$0c04710c92712449$var$ka];
}
function $0c04710c92712449$var$oa(a) {
    var b = a[$0c04710c92712449$var$ea];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0c04710c92712449$var$ha] || c[$0c04710c92712449$var$ea]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0c04710c92712449$var$pa(a); null !== a;){
                if (c = a[$0c04710c92712449$var$ea]) return c;
                a = $0c04710c92712449$var$pa(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0c04710c92712449$var$qa(a) {
    if (a = a[$0c04710c92712449$var$ea] || a[$0c04710c92712449$var$ha]) {
        var b = a.tag;
        if (5 === b || 6 === b || 13 === b || 26 === b || 27 === b || 3 === b) return a;
    }
    return null;
}
function $0c04710c92712449$var$ra(a) {
    var b = a.tag;
    if (5 === b || 26 === b || 27 === b || 6 === b) return a.stateNode;
    throw Error($0c04710c92712449$var$q(33));
}
function $0c04710c92712449$var$sa(a) {
    return a[$0c04710c92712449$var$fa] || null;
}
function $0c04710c92712449$var$ta(a) {
    var b = a[$0c04710c92712449$var$la];
    b || (b = a[$0c04710c92712449$var$la] = {
        hoistableStyles: new Map,
        hoistableScripts: new Map
    });
    return b;
}
var $0c04710c92712449$var$ua = new Set, $0c04710c92712449$var$va = {};
function $0c04710c92712449$var$wa(a, b) {
    $0c04710c92712449$var$xa(a, b);
    $0c04710c92712449$var$xa(a + "Capture", b);
}
function $0c04710c92712449$var$xa(a, b) {
    $0c04710c92712449$var$va[a] = b;
    for(a = 0; a < b.length; a++)$0c04710c92712449$var$ua.add(b[a]);
}
var $0c04710c92712449$var$ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0c04710c92712449$var$za = Object.prototype.hasOwnProperty, $0c04710c92712449$var$Aa = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $0c04710c92712449$var$Ba = {}, $0c04710c92712449$var$Ca = {};
function $0c04710c92712449$var$Da(a) {
    if ($0c04710c92712449$var$za.call($0c04710c92712449$var$Ca, a)) return !0;
    if ($0c04710c92712449$var$za.call($0c04710c92712449$var$Ba, a)) return !1;
    if ($0c04710c92712449$var$Aa.test(a)) return $0c04710c92712449$var$Ca[a] = !0;
    $0c04710c92712449$var$Ba[a] = !0;
    return !1;
}
function $0c04710c92712449$var$Ea(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0c04710c92712449$var$Fa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0c04710c92712449$var$Ea(a, b, c, d)) return !0;
    if (d) return !1 === b ? !0 : !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0c04710c92712449$var$Ga(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0c04710c92712449$var$Ha = {}, $0c04710c92712449$var$Ia = "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ");
$0c04710c92712449$var$Ia.push("innerText", "textContent");
$0c04710c92712449$var$Ia.forEach(function(a) {
    $0c04710c92712449$var$Ha[a] = new $0c04710c92712449$var$Ga(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0c04710c92712449$var$Ha[b] = new $0c04710c92712449$var$Ga(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0c04710c92712449$var$Ha[a] = new $0c04710c92712449$var$Ga(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0c04710c92712449$var$Ha[a] = new $0c04710c92712449$var$Ga(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0c04710c92712449$var$Ha[a] = new $0c04710c92712449$var$Ga(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0c04710c92712449$var$Ha[a] = new $0c04710c92712449$var$Ga(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0c04710c92712449$var$Ha[a] = new $0c04710c92712449$var$Ga(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0c04710c92712449$var$Ha[a] = new $0c04710c92712449$var$Ga(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0c04710c92712449$var$Ha[a] = new $0c04710c92712449$var$Ga(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0c04710c92712449$var$Ja = /[\-:]([a-z])/g;
function $0c04710c92712449$var$Ka(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering transform-origin underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0c04710c92712449$var$Ja, $0c04710c92712449$var$Ka);
    $0c04710c92712449$var$Ha[b] = new $0c04710c92712449$var$Ga(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0c04710c92712449$var$Ja, $0c04710c92712449$var$Ka);
    $0c04710c92712449$var$Ha[b] = new $0c04710c92712449$var$Ga(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0c04710c92712449$var$Ja, $0c04710c92712449$var$Ka);
    $0c04710c92712449$var$Ha[b] = new $0c04710c92712449$var$Ga(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0c04710c92712449$var$Ha[a] = new $0c04710c92712449$var$Ga(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0c04710c92712449$var$Ha.xlinkHref = new $0c04710c92712449$var$Ga("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0c04710c92712449$var$Ha[a] = new $0c04710c92712449$var$Ga(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0c04710c92712449$var$La(a, b, c, d) {
    var e = $0c04710c92712449$var$Ha.hasOwnProperty(b) ? $0c04710c92712449$var$Ha[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) {
        if (d && "o" === b[0] && "n" === b[1]) {
            var f = b.replace(/Capture$/, ""), g = b !== f;
            f = f.slice(2);
            var h = $0c04710c92712449$var$sa(a);
            h = null != h ? h[b] : null;
            "function" === typeof h && a.removeEventListener(f, h, g);
            if ("function" === typeof c) {
                "function" !== typeof h && null !== h && (b in a ? a[b] = null : a.hasAttribute(b) && a.removeAttribute(b));
                a.addEventListener(f, c, g);
                return;
            }
        }
        d && b in a ? a[b] = c : ($0c04710c92712449$var$Fa(b, c, e, d) && (c = null), d && !0 === c && (c = ""), d || null === e ? $0c04710c92712449$var$Da(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
    }
}
var $0c04710c92712449$var$Ma = $k116o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0c04710c92712449$var$Na = Symbol.for("react.element"), $0c04710c92712449$var$Oa = Symbol.for("react.portal"), $0c04710c92712449$var$Pa = Symbol.for("react.fragment"), $0c04710c92712449$var$Qa = Symbol.for("react.strict_mode"), $0c04710c92712449$var$Ra = Symbol.for("react.profiler"), $0c04710c92712449$var$Sa = Symbol.for("react.provider"), $0c04710c92712449$var$Ta = Symbol.for("react.context"), $0c04710c92712449$var$Ua = Symbol.for("react.server_context"), $0c04710c92712449$var$Va = Symbol.for("react.forward_ref"), $0c04710c92712449$var$Wa = Symbol.for("react.suspense"), $0c04710c92712449$var$Xa = Symbol.for("react.suspense_list"), $0c04710c92712449$var$Ya = Symbol.for("react.memo"), $0c04710c92712449$var$Za = Symbol.for("react.lazy"), $0c04710c92712449$var$$a = Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0c04710c92712449$var$ab = Symbol.for("react.offscreen"), $0c04710c92712449$var$bb = Symbol.for("react.legacy_hidden"), $0c04710c92712449$var$cb = Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0c04710c92712449$var$db = Symbol.for("react.default_value"), $0c04710c92712449$var$eb = Symbol.for("react.memo_cache_sentinel"), $0c04710c92712449$var$fb = Symbol.iterator;
function $0c04710c92712449$var$gb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0c04710c92712449$var$fb && a[$0c04710c92712449$var$fb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0c04710c92712449$var$D = Object.assign, $0c04710c92712449$var$hb;
function $0c04710c92712449$var$ib(a) {
    if (void 0 === $0c04710c92712449$var$hb) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0c04710c92712449$var$hb = b && b[1] || "";
    }
    return "\n" + $0c04710c92712449$var$hb + a;
}
var $0c04710c92712449$var$jb = !1;
function $0c04710c92712449$var$kb(a, b) {
    if (!a || $0c04710c92712449$var$jb) return "";
    $0c04710c92712449$var$jb = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (n) {
                    var d = n;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (n) {
                    d = n;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (n) {
                d = n;
            }
            a();
        }
    } catch (n) {
        if (n && d && "string" === typeof n.stack) {
            for(var e = n.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var l = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && l.includes("<anonymous>") && (l = l.replace("<anonymous>", a.displayName));
                        return l;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0c04710c92712449$var$jb = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0c04710c92712449$var$ib(a) : "";
}
function $0c04710c92712449$var$lb(a) {
    switch(a.tag){
        case 26:
        case 27:
        case 5:
            return $0c04710c92712449$var$ib(a.type);
        case 16:
            return $0c04710c92712449$var$ib("Lazy");
        case 13:
            return $0c04710c92712449$var$ib("Suspense");
        case 19:
            return $0c04710c92712449$var$ib("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0c04710c92712449$var$kb(a.type, !1), a;
        case 11:
            return a = $0c04710c92712449$var$kb(a.type.render, !1), a;
        case 1:
            return a = $0c04710c92712449$var$kb(a.type, !0), a;
        default:
            return "";
    }
}
function $0c04710c92712449$var$mb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0c04710c92712449$var$Pa:
            return "Fragment";
        case $0c04710c92712449$var$Oa:
            return "Portal";
        case $0c04710c92712449$var$Ra:
            return "Profiler";
        case $0c04710c92712449$var$Qa:
            return "StrictMode";
        case $0c04710c92712449$var$Wa:
            return "Suspense";
        case $0c04710c92712449$var$Xa:
            return "SuspenseList";
        case $0c04710c92712449$var$cb:
            return "Cache";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0c04710c92712449$var$Ta:
            return (a.displayName || "Context") + ".Consumer";
        case $0c04710c92712449$var$Sa:
            return (a._context.displayName || "Context") + ".Provider";
        case $0c04710c92712449$var$Va:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0c04710c92712449$var$Ya:
            return b = a.displayName || null, null !== b ? b : $0c04710c92712449$var$mb(a.type) || "Memo";
        case $0c04710c92712449$var$Za:
            b = a._payload;
            a = a._init;
            try {
                return $0c04710c92712449$var$mb(a(b));
            } catch (c) {
                break;
            }
        case $0c04710c92712449$var$Ua:
            return (a.displayName || a._globalName) + ".Provider";
    }
    return null;
}
function $0c04710c92712449$var$nb(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 26:
        case 27:
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0c04710c92712449$var$mb(b);
        case 8:
            return b === $0c04710c92712449$var$Qa ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0c04710c92712449$var$ob(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0c04710c92712449$var$pb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0c04710c92712449$var$qb(a) {
    var b = $0c04710c92712449$var$pb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(g) {
                d = "" + g;
                f.call(this, g);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(g) {
                d = "" + g;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0c04710c92712449$var$rb(a) {
    a._valueTracker || (a._valueTracker = $0c04710c92712449$var$qb(a));
}
function $0c04710c92712449$var$sb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0c04710c92712449$var$pb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0c04710c92712449$var$tb(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0c04710c92712449$var$ub(a, b) {
    var c = b.checked;
    return $0c04710c92712449$var$D({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0c04710c92712449$var$vb(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0c04710c92712449$var$ob(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0c04710c92712449$var$wb(a, b) {
    b = b.checked;
    null != b && $0c04710c92712449$var$La(a, "checked", b, !1);
}
function $0c04710c92712449$var$xb(a, b) {
    $0c04710c92712449$var$wb(a, b);
    var c = $0c04710c92712449$var$ob(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0c04710c92712449$var$yb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0c04710c92712449$var$yb(a, b.type, $0c04710c92712449$var$ob(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0c04710c92712449$var$zb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0c04710c92712449$var$yb(a, b, c) {
    if ("number" !== b || $0c04710c92712449$var$tb(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0c04710c92712449$var$Ab = Array.isArray;
function $0c04710c92712449$var$Bb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0c04710c92712449$var$ob(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0c04710c92712449$var$Cb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0c04710c92712449$var$q(91));
    return $0c04710c92712449$var$D({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0c04710c92712449$var$Db(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0c04710c92712449$var$q(92));
            if ($0c04710c92712449$var$Ab(c)) {
                if (1 < c.length) throw Error($0c04710c92712449$var$q(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0c04710c92712449$var$ob(c)
    };
}
function $0c04710c92712449$var$Eb(a, b) {
    var c = $0c04710c92712449$var$ob(b.value), d = $0c04710c92712449$var$ob(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0c04710c92712449$var$Fb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0c04710c92712449$var$Hb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0c04710c92712449$var$Ib(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0c04710c92712449$var$Hb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0c04710c92712449$var$Jb, $0c04710c92712449$var$Kb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0c04710c92712449$var$Jb = $0c04710c92712449$var$Jb || document.createElement("div");
        $0c04710c92712449$var$Jb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0c04710c92712449$var$Jb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0c04710c92712449$var$Lb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0c04710c92712449$var$Mb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    scale: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0c04710c92712449$var$Nb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0c04710c92712449$var$Mb).forEach(function(a) {
    $0c04710c92712449$var$Nb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0c04710c92712449$var$Mb[b] = $0c04710c92712449$var$Mb[a];
    });
});
function $0c04710c92712449$var$Ob(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0c04710c92712449$var$Mb.hasOwnProperty(a) && $0c04710c92712449$var$Mb[a] ? ("" + b).trim() : b + "px";
}
function $0c04710c92712449$var$Pb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0c04710c92712449$var$Ob(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0c04710c92712449$var$Qb = $0c04710c92712449$var$D({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0c04710c92712449$var$Rb(a, b) {
    if (b) {
        if ($0c04710c92712449$var$Qb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0c04710c92712449$var$q(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0c04710c92712449$var$q(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0c04710c92712449$var$q(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0c04710c92712449$var$q(62));
    }
}
function $0c04710c92712449$var$Sb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0c04710c92712449$var$Tb = null;
function $0c04710c92712449$var$Ub(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0c04710c92712449$var$Vb = null, $0c04710c92712449$var$Wb = null, $0c04710c92712449$var$Xb = null;
function $0c04710c92712449$var$Yb(a) {
    if (a = $0c04710c92712449$var$qa(a)) {
        if ("function" !== typeof $0c04710c92712449$var$Vb) throw Error($0c04710c92712449$var$q(280));
        var b = a.stateNode;
        b && (b = $0c04710c92712449$var$sa(b), $0c04710c92712449$var$Vb(a.stateNode, a.type, b));
    }
}
function $0c04710c92712449$var$Zb(a) {
    $0c04710c92712449$var$Wb ? $0c04710c92712449$var$Xb ? $0c04710c92712449$var$Xb.push(a) : $0c04710c92712449$var$Xb = [
        a
    ] : $0c04710c92712449$var$Wb = a;
}
function $0c04710c92712449$var$$b() {
    if ($0c04710c92712449$var$Wb) {
        var a = $0c04710c92712449$var$Wb, b = $0c04710c92712449$var$Xb;
        $0c04710c92712449$var$Xb = $0c04710c92712449$var$Wb = null;
        $0c04710c92712449$var$Yb(a);
        if (b) for(a = 0; a < b.length; a++)$0c04710c92712449$var$Yb(b[a]);
    }
}
function $0c04710c92712449$var$ac(a, b) {
    return a(b);
}
function $0c04710c92712449$var$bc() {}
var $0c04710c92712449$var$cc = !1;
function $0c04710c92712449$var$dc(a, b, c) {
    if ($0c04710c92712449$var$cc) return a(b, c);
    $0c04710c92712449$var$cc = !0;
    try {
        return $0c04710c92712449$var$ac(a, b, c);
    } finally{
        if ($0c04710c92712449$var$cc = !1, null !== $0c04710c92712449$var$Wb || null !== $0c04710c92712449$var$Xb) $0c04710c92712449$var$bc(), $0c04710c92712449$var$$b();
    }
}
function $0c04710c92712449$var$ec(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0c04710c92712449$var$sa(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0c04710c92712449$var$q(231, b, typeof c));
    return c;
}
var $0c04710c92712449$var$fc = !1;
if ($0c04710c92712449$var$ya) try {
    var $0c04710c92712449$var$gc = {};
    Object.defineProperty($0c04710c92712449$var$gc, "passive", {
        get: function() {
            $0c04710c92712449$var$fc = !0;
        }
    });
    window.addEventListener("test", $0c04710c92712449$var$gc, $0c04710c92712449$var$gc);
    window.removeEventListener("test", $0c04710c92712449$var$gc, $0c04710c92712449$var$gc);
} catch (a) {
    $0c04710c92712449$var$fc = !1;
}
function $0c04710c92712449$var$hc(a, b, c) {
    var d = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, d);
    } catch (e) {
        this.onError(e);
    }
}
var $0c04710c92712449$var$ic = !1, $0c04710c92712449$var$jc = null, $0c04710c92712449$var$kc = !1, $0c04710c92712449$var$lc = null, $0c04710c92712449$var$mc = {
    onError: function(a) {
        $0c04710c92712449$var$ic = !0;
        $0c04710c92712449$var$jc = a;
    }
};
function $0c04710c92712449$var$nc(a, b, c, d, e, f, g, h, l) {
    $0c04710c92712449$var$ic = !1;
    $0c04710c92712449$var$jc = null;
    $0c04710c92712449$var$hc.apply($0c04710c92712449$var$mc, arguments);
}
function $0c04710c92712449$var$oc(a, b, c, d, e, f, g, h, l) {
    $0c04710c92712449$var$nc.apply(this, arguments);
    if ($0c04710c92712449$var$ic) {
        if ($0c04710c92712449$var$ic) {
            var n = $0c04710c92712449$var$jc;
            $0c04710c92712449$var$ic = !1;
            $0c04710c92712449$var$jc = null;
        } else throw Error($0c04710c92712449$var$q(198));
        $0c04710c92712449$var$kc || ($0c04710c92712449$var$kc = !0, $0c04710c92712449$var$lc = n);
    }
}
function $0c04710c92712449$var$pc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0c04710c92712449$var$qc(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0c04710c92712449$var$rc(a) {
    if ($0c04710c92712449$var$pc(a) !== a) throw Error($0c04710c92712449$var$q(188));
}
function $0c04710c92712449$var$sc(a) {
    var b = a.alternate;
    if (!b) {
        b = $0c04710c92712449$var$pc(a);
        if (null === b) throw Error($0c04710c92712449$var$q(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0c04710c92712449$var$rc(e), a;
                if (f === d) return $0c04710c92712449$var$rc(e), b;
                f = f.sibling;
            }
            throw Error($0c04710c92712449$var$q(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0c04710c92712449$var$q(189));
            }
        }
        if (c.alternate !== d) throw Error($0c04710c92712449$var$q(190));
    }
    if (3 !== c.tag) throw Error($0c04710c92712449$var$q(188));
    return c.stateNode.current === c ? a : b;
}
function $0c04710c92712449$var$tc(a) {
    a = $0c04710c92712449$var$sc(a);
    return null !== a ? $0c04710c92712449$var$uc(a) : null;
}
function $0c04710c92712449$var$uc(a) {
    var b = a.tag;
    if (5 === b || 26 === b || 27 === b || 6 === b) return a;
    for(a = a.child; null !== a;){
        b = $0c04710c92712449$var$uc(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0c04710c92712449$var$vc = $9gi6K.unstable_scheduleCallback, $0c04710c92712449$var$wc = $9gi6K.unstable_cancelCallback, $0c04710c92712449$var$xc = $9gi6K.unstable_shouldYield, $0c04710c92712449$var$yc = $9gi6K.unstable_requestPaint, $0c04710c92712449$var$E = $9gi6K.unstable_now, $0c04710c92712449$var$zc = $9gi6K.unstable_getCurrentPriorityLevel, $0c04710c92712449$var$Ac = $9gi6K.unstable_ImmediatePriority, $0c04710c92712449$var$Bc = $9gi6K.unstable_UserBlockingPriority, $0c04710c92712449$var$Cc = $9gi6K.unstable_NormalPriority, $0c04710c92712449$var$Dc = $9gi6K.unstable_LowPriority, $0c04710c92712449$var$Ec = $9gi6K.unstable_IdlePriority, $0c04710c92712449$var$Fc = null, $0c04710c92712449$var$Gc = null;
function $0c04710c92712449$var$Hc(a) {
    if ($0c04710c92712449$var$Gc && "function" === typeof $0c04710c92712449$var$Gc.onCommitFiberRoot) try {
        $0c04710c92712449$var$Gc.onCommitFiberRoot($0c04710c92712449$var$Fc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0c04710c92712449$var$Jc = Math.clz32 ? Math.clz32 : $0c04710c92712449$var$Ic, $0c04710c92712449$var$Kc = Math.log, $0c04710c92712449$var$Lc = Math.LN2;
function $0c04710c92712449$var$Ic(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0c04710c92712449$var$Kc(a) / $0c04710c92712449$var$Lc | 0) | 0;
}
var $0c04710c92712449$var$Mc = 128, $0c04710c92712449$var$Nc = 8388608;
function $0c04710c92712449$var$Oc(a) {
    var b = a & 42;
    if (0 !== b) return b;
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
            return a & 8388480;
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 125829120;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0c04710c92712449$var$Pc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0c04710c92712449$var$Oc(h) : (f &= g, 0 !== f && (d = $0c04710c92712449$var$Oc(f)));
    } else g = c & ~e, 0 !== g ? d = $0c04710c92712449$var$Oc(g) : 0 !== f && (d = $0c04710c92712449$var$Oc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 32 === e && 0 !== (f & 8388480))) return b;
    0 !== (d & 8) && (d |= c & 32);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0c04710c92712449$var$Jc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0c04710c92712449$var$Qc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
        case 8:
            return b + 250;
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
            return b + 5E3;
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0c04710c92712449$var$Rc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes & -125829121; 0 < f;){
        var g = 31 - $0c04710c92712449$var$Jc(f), h = 1 << g, l = e[g];
        if (-1 === l) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0c04710c92712449$var$Qc(h, b);
        } else l <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0c04710c92712449$var$Sc(a, b) {
    if (a.errorRecoveryDisabledLanes & b) return 0;
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0c04710c92712449$var$Tc() {
    var a = $0c04710c92712449$var$Mc;
    $0c04710c92712449$var$Mc <<= 1;
    0 === ($0c04710c92712449$var$Mc & 8388480) && ($0c04710c92712449$var$Mc = 128);
    return a;
}
function $0c04710c92712449$var$Uc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0c04710c92712449$var$Vc(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0c04710c92712449$var$Jc(b);
    a[b] = c;
}
function $0c04710c92712449$var$Wc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    a.errorRecoveryDisabledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes, e = a.expirationTimes;
    for(a = a.hiddenUpdates; 0 < c;){
        var f = 31 - $0c04710c92712449$var$Jc(c), g = 1 << f;
        b[f] = 0;
        d[f] = -1;
        e[f] = -1;
        var h = a[f];
        if (null !== h) for(a[f] = null, f = 0; f < h.length; f++){
            var l = h[f];
            null !== l && (l.lane &= -1073741825);
        }
        c &= ~g;
    }
}
function $0c04710c92712449$var$Xc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0c04710c92712449$var$Jc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0c04710c92712449$var$G = 0;
function $0c04710c92712449$var$Yc(a, b) {
    var c = $0c04710c92712449$var$G;
    try {
        return $0c04710c92712449$var$G = a, b();
    } finally{
        $0c04710c92712449$var$G = c;
    }
}
function $0c04710c92712449$var$Zc(a) {
    a &= -a;
    return 2 < a ? 8 < a ? 0 !== (a & 268435455) ? 32 : 536870912 : 8 : 2;
}
var $0c04710c92712449$var$$c, $0c04710c92712449$var$ad, $0c04710c92712449$var$bd, $0c04710c92712449$var$cd, $0c04710c92712449$var$dd, $0c04710c92712449$var$ed = !1, $0c04710c92712449$var$fd = [], $0c04710c92712449$var$gd = null, $0c04710c92712449$var$hd = null, $0c04710c92712449$var$id = null, $0c04710c92712449$var$jd = new Map, $0c04710c92712449$var$kd = new Map, $0c04710c92712449$var$ld = [], $0c04710c92712449$var$md = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0c04710c92712449$var$nd(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0c04710c92712449$var$gd = null;
            break;
        case "dragenter":
        case "dragleave":
            $0c04710c92712449$var$hd = null;
            break;
        case "mouseover":
        case "mouseout":
            $0c04710c92712449$var$id = null;
            break;
        case "pointerover":
        case "pointerout":
            $0c04710c92712449$var$jd.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0c04710c92712449$var$kd.delete(b.pointerId);
    }
}
function $0c04710c92712449$var$od(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0c04710c92712449$var$qa(b), null !== b && $0c04710c92712449$var$ad(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0c04710c92712449$var$pd(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0c04710c92712449$var$gd = $0c04710c92712449$var$od($0c04710c92712449$var$gd, a, b, c, d, e), !0;
        case "dragenter":
            return $0c04710c92712449$var$hd = $0c04710c92712449$var$od($0c04710c92712449$var$hd, a, b, c, d, e), !0;
        case "mouseover":
            return $0c04710c92712449$var$id = $0c04710c92712449$var$od($0c04710c92712449$var$id, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0c04710c92712449$var$jd.set(f, $0c04710c92712449$var$od($0c04710c92712449$var$jd.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0c04710c92712449$var$kd.set(f, $0c04710c92712449$var$od($0c04710c92712449$var$kd.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0c04710c92712449$var$qd(a) {
    var b = $0c04710c92712449$var$oa(a.target);
    if (null !== b) {
        var c = $0c04710c92712449$var$pc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0c04710c92712449$var$qc(c), null !== b) {
                    a.blockedOn = b;
                    $0c04710c92712449$var$dd(a.priority, function() {
                        $0c04710c92712449$var$bd(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0c04710c92712449$var$rd(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0c04710c92712449$var$sd(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0c04710c92712449$var$Tb = d;
            c.target.dispatchEvent(d);
            $0c04710c92712449$var$Tb = null;
        } else return b = $0c04710c92712449$var$qa(c), null !== b && $0c04710c92712449$var$ad(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0c04710c92712449$var$td(a, b, c) {
    $0c04710c92712449$var$rd(a) && c.delete(b);
}
function $0c04710c92712449$var$ud() {
    $0c04710c92712449$var$ed = !1;
    null !== $0c04710c92712449$var$gd && $0c04710c92712449$var$rd($0c04710c92712449$var$gd) && ($0c04710c92712449$var$gd = null);
    null !== $0c04710c92712449$var$hd && $0c04710c92712449$var$rd($0c04710c92712449$var$hd) && ($0c04710c92712449$var$hd = null);
    null !== $0c04710c92712449$var$id && $0c04710c92712449$var$rd($0c04710c92712449$var$id) && ($0c04710c92712449$var$id = null);
    $0c04710c92712449$var$jd.forEach($0c04710c92712449$var$td);
    $0c04710c92712449$var$kd.forEach($0c04710c92712449$var$td);
}
function $0c04710c92712449$var$vd(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0c04710c92712449$var$ed || ($0c04710c92712449$var$ed = !0, $9gi6K.unstable_scheduleCallback($9gi6K.unstable_NormalPriority, $0c04710c92712449$var$ud)));
}
function $0c04710c92712449$var$wd(a) {
    function b(e) {
        return $0c04710c92712449$var$vd(e, a);
    }
    if (0 < $0c04710c92712449$var$fd.length) {
        $0c04710c92712449$var$vd($0c04710c92712449$var$fd[0], a);
        for(var c = 1; c < $0c04710c92712449$var$fd.length; c++){
            var d = $0c04710c92712449$var$fd[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0c04710c92712449$var$gd && $0c04710c92712449$var$vd($0c04710c92712449$var$gd, a);
    null !== $0c04710c92712449$var$hd && $0c04710c92712449$var$vd($0c04710c92712449$var$hd, a);
    null !== $0c04710c92712449$var$id && $0c04710c92712449$var$vd($0c04710c92712449$var$id, a);
    $0c04710c92712449$var$jd.forEach(b);
    $0c04710c92712449$var$kd.forEach(b);
    for(c = 0; c < $0c04710c92712449$var$ld.length; c++)d = $0c04710c92712449$var$ld[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0c04710c92712449$var$ld.length && (c = $0c04710c92712449$var$ld[0], null === c.blockedOn);)$0c04710c92712449$var$qd(c), null === c.blockedOn && $0c04710c92712449$var$ld.shift();
}
var $0c04710c92712449$var$xd = $0c04710c92712449$var$Ma.ReactCurrentBatchConfig, $0c04710c92712449$var$yd = !0;
function $0c04710c92712449$var$zd(a, b, c, d) {
    var e = $0c04710c92712449$var$G, f = $0c04710c92712449$var$xd.transition;
    $0c04710c92712449$var$xd.transition = null;
    try {
        $0c04710c92712449$var$G = 2, $0c04710c92712449$var$Ad(a, b, c, d);
    } finally{
        $0c04710c92712449$var$G = e, $0c04710c92712449$var$xd.transition = f;
    }
}
function $0c04710c92712449$var$Bd(a, b, c, d) {
    var e = $0c04710c92712449$var$G, f = $0c04710c92712449$var$xd.transition;
    $0c04710c92712449$var$xd.transition = null;
    try {
        $0c04710c92712449$var$G = 8, $0c04710c92712449$var$Ad(a, b, c, d);
    } finally{
        $0c04710c92712449$var$G = e, $0c04710c92712449$var$xd.transition = f;
    }
}
function $0c04710c92712449$var$Ad(a, b, c, d) {
    if ($0c04710c92712449$var$yd) {
        var e = $0c04710c92712449$var$sd(a, b, c, d);
        if (null === e) $0c04710c92712449$var$Cd(a, b, d, $0c04710c92712449$var$Dd, c), $0c04710c92712449$var$nd(a, d);
        else if ($0c04710c92712449$var$pd(e, a, b, c, d)) d.stopPropagation();
        else if ($0c04710c92712449$var$nd(a, d), b & 4 && -1 < $0c04710c92712449$var$md.indexOf(a)) {
            for(; null !== e;){
                var f = $0c04710c92712449$var$qa(e);
                null !== f && $0c04710c92712449$var$$c(f);
                f = $0c04710c92712449$var$sd(a, b, c, d);
                null === f && $0c04710c92712449$var$Cd(a, b, d, $0c04710c92712449$var$Dd, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0c04710c92712449$var$Cd(a, b, d, null, c);
    }
}
var $0c04710c92712449$var$Dd = null;
function $0c04710c92712449$var$sd(a, b, c, d) {
    $0c04710c92712449$var$Dd = null;
    a = $0c04710c92712449$var$Ub(d);
    a = $0c04710c92712449$var$oa(a);
    if (null !== a) {
        if (b = $0c04710c92712449$var$pc(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0c04710c92712449$var$qc(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0c04710c92712449$var$Dd = a;
    return null;
}
function $0c04710c92712449$var$Ed(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($0c04710c92712449$var$zc()){
                case $0c04710c92712449$var$Ac:
                    return 2;
                case $0c04710c92712449$var$Bc:
                    return 8;
                case $0c04710c92712449$var$Cc:
                case $0c04710c92712449$var$Dc:
                    return 32;
                case $0c04710c92712449$var$Ec:
                    return 536870912;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $0c04710c92712449$var$Fd = null, $0c04710c92712449$var$Gd = null, $0c04710c92712449$var$Hd = null;
function $0c04710c92712449$var$Id() {
    if ($0c04710c92712449$var$Hd) return $0c04710c92712449$var$Hd;
    var a, b = $0c04710c92712449$var$Gd, c = b.length, d, e = "value" in $0c04710c92712449$var$Fd ? $0c04710c92712449$var$Fd.value : $0c04710c92712449$var$Fd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0c04710c92712449$var$Hd = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0c04710c92712449$var$Jd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0c04710c92712449$var$Kd() {
    return !0;
}
function $0c04710c92712449$var$Ld() {
    return !1;
}
function $0c04710c92712449$var$Md(a) {
    function b(c, d, e, f, g) {
        this._reactName = c;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var h in a)a.hasOwnProperty(h) && (c = a[h], this[h] = c ? c(f) : f[h]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0c04710c92712449$var$Kd : $0c04710c92712449$var$Ld;
        this.isPropagationStopped = $0c04710c92712449$var$Ld;
        return this;
    }
    $0c04710c92712449$var$D(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var c = this.nativeEvent;
            c && (c.preventDefault ? c.preventDefault() : "unknown" !== typeof c.returnValue && (c.returnValue = !1), this.isDefaultPrevented = $0c04710c92712449$var$Kd);
        },
        stopPropagation: function() {
            var c = this.nativeEvent;
            c && (c.stopPropagation ? c.stopPropagation() : "unknown" !== typeof c.cancelBubble && (c.cancelBubble = !0), this.isPropagationStopped = $0c04710c92712449$var$Kd);
        },
        persist: function() {},
        isPersistent: $0c04710c92712449$var$Kd
    });
    return b;
}
var $0c04710c92712449$var$Nd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0c04710c92712449$var$Od = $0c04710c92712449$var$Md($0c04710c92712449$var$Nd), $0c04710c92712449$var$Pd = $0c04710c92712449$var$D({}, $0c04710c92712449$var$Nd, {
    view: 0,
    detail: 0
}), $0c04710c92712449$var$Qd = $0c04710c92712449$var$Md($0c04710c92712449$var$Pd), $0c04710c92712449$var$Rd, $0c04710c92712449$var$Sd, $0c04710c92712449$var$Td, $0c04710c92712449$var$Vd = $0c04710c92712449$var$D({}, $0c04710c92712449$var$Pd, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0c04710c92712449$var$Ud,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0c04710c92712449$var$Td && ($0c04710c92712449$var$Td && "mousemove" === a.type ? ($0c04710c92712449$var$Rd = a.screenX - $0c04710c92712449$var$Td.screenX, $0c04710c92712449$var$Sd = a.screenY - $0c04710c92712449$var$Td.screenY) : $0c04710c92712449$var$Sd = $0c04710c92712449$var$Rd = 0, $0c04710c92712449$var$Td = a);
        return $0c04710c92712449$var$Rd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0c04710c92712449$var$Sd;
    }
}), $0c04710c92712449$var$Wd = $0c04710c92712449$var$Md($0c04710c92712449$var$Vd), $0c04710c92712449$var$Xd = $0c04710c92712449$var$D({}, $0c04710c92712449$var$Vd, {
    dataTransfer: 0
}), $0c04710c92712449$var$Yd = $0c04710c92712449$var$Md($0c04710c92712449$var$Xd), $0c04710c92712449$var$Zd = $0c04710c92712449$var$D({}, $0c04710c92712449$var$Pd, {
    relatedTarget: 0
}), $0c04710c92712449$var$$d = $0c04710c92712449$var$Md($0c04710c92712449$var$Zd), $0c04710c92712449$var$ae = $0c04710c92712449$var$D({}, $0c04710c92712449$var$Nd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0c04710c92712449$var$be = $0c04710c92712449$var$Md($0c04710c92712449$var$ae), $0c04710c92712449$var$ce = $0c04710c92712449$var$D({}, $0c04710c92712449$var$Nd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0c04710c92712449$var$de = $0c04710c92712449$var$Md($0c04710c92712449$var$ce), $0c04710c92712449$var$ee = $0c04710c92712449$var$D({}, $0c04710c92712449$var$Nd, {
    data: 0
}), $0c04710c92712449$var$fe = $0c04710c92712449$var$Md($0c04710c92712449$var$ee), $0c04710c92712449$var$ge = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0c04710c92712449$var$he = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0c04710c92712449$var$ie = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0c04710c92712449$var$je(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0c04710c92712449$var$ie[a]) ? !!b[a] : !1;
}
function $0c04710c92712449$var$Ud() {
    return $0c04710c92712449$var$je;
}
var $0c04710c92712449$var$ke = $0c04710c92712449$var$D({}, $0c04710c92712449$var$Pd, {
    key: function(a) {
        if (a.key) {
            var b = $0c04710c92712449$var$ge[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0c04710c92712449$var$Jd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0c04710c92712449$var$he[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0c04710c92712449$var$Ud,
    charCode: function(a) {
        return "keypress" === a.type ? $0c04710c92712449$var$Jd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0c04710c92712449$var$Jd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0c04710c92712449$var$le = $0c04710c92712449$var$Md($0c04710c92712449$var$ke), $0c04710c92712449$var$me = $0c04710c92712449$var$D({}, $0c04710c92712449$var$Vd, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0c04710c92712449$var$ne = $0c04710c92712449$var$Md($0c04710c92712449$var$me), $0c04710c92712449$var$oe = $0c04710c92712449$var$D({}, $0c04710c92712449$var$Pd, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0c04710c92712449$var$Ud
}), $0c04710c92712449$var$pe = $0c04710c92712449$var$Md($0c04710c92712449$var$oe), $0c04710c92712449$var$qe = $0c04710c92712449$var$D({}, $0c04710c92712449$var$Nd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0c04710c92712449$var$re = $0c04710c92712449$var$Md($0c04710c92712449$var$qe), $0c04710c92712449$var$se = $0c04710c92712449$var$D({}, $0c04710c92712449$var$Vd, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0c04710c92712449$var$te = $0c04710c92712449$var$Md($0c04710c92712449$var$se), $0c04710c92712449$var$ue = [
    9,
    13,
    27,
    32
], $0c04710c92712449$var$ve = $0c04710c92712449$var$ya && "CompositionEvent" in window, $0c04710c92712449$var$we = null;
$0c04710c92712449$var$ya && "documentMode" in document && ($0c04710c92712449$var$we = document.documentMode);
var $0c04710c92712449$var$xe = $0c04710c92712449$var$ya && "TextEvent" in window && !$0c04710c92712449$var$we, $0c04710c92712449$var$ye = $0c04710c92712449$var$ya && (!$0c04710c92712449$var$ve || $0c04710c92712449$var$we && 8 < $0c04710c92712449$var$we && 11 >= $0c04710c92712449$var$we), $0c04710c92712449$var$ze = String.fromCharCode(32), $0c04710c92712449$var$Ae = !1;
function $0c04710c92712449$var$Be(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0c04710c92712449$var$ue.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0c04710c92712449$var$Ce(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0c04710c92712449$var$De = !1;
function $0c04710c92712449$var$Ee(a, b) {
    switch(a){
        case "compositionend":
            return $0c04710c92712449$var$Ce(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0c04710c92712449$var$Ae = !0;
            return $0c04710c92712449$var$ze;
        case "textInput":
            return a = b.data, a === $0c04710c92712449$var$ze && $0c04710c92712449$var$Ae ? null : a;
        default:
            return null;
    }
}
function $0c04710c92712449$var$Fe(a, b) {
    if ($0c04710c92712449$var$De) return "compositionend" === a || !$0c04710c92712449$var$ve && $0c04710c92712449$var$Be(a, b) ? (a = $0c04710c92712449$var$Id(), $0c04710c92712449$var$Hd = $0c04710c92712449$var$Gd = $0c04710c92712449$var$Fd = null, $0c04710c92712449$var$De = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0c04710c92712449$var$ye && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0c04710c92712449$var$Ge = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0c04710c92712449$var$He(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0c04710c92712449$var$Ge[a.type] : "textarea" === b ? !0 : !1;
}
function $0c04710c92712449$var$Ie(a, b, c, d) {
    $0c04710c92712449$var$Zb(d);
    b = $0c04710c92712449$var$Je(b, "onChange");
    0 < b.length && (c = new $0c04710c92712449$var$Od("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0c04710c92712449$var$Ke = null, $0c04710c92712449$var$Le = null;
function $0c04710c92712449$var$Me(a) {
    $0c04710c92712449$var$Ne(a, 0);
}
function $0c04710c92712449$var$Oe(a) {
    var b = $0c04710c92712449$var$ra(a);
    if ($0c04710c92712449$var$sb(b)) return a;
}
function $0c04710c92712449$var$Pe(a, b) {
    if ("change" === a) return b;
}
var $0c04710c92712449$var$Qe = !1;
if ($0c04710c92712449$var$ya) {
    var $0c04710c92712449$var$Re;
    if ($0c04710c92712449$var$ya) {
        var $0c04710c92712449$var$Se = "oninput" in document;
        if (!$0c04710c92712449$var$Se) {
            var $0c04710c92712449$var$Te = document.createElement("div");
            $0c04710c92712449$var$Te.setAttribute("oninput", "return;");
            $0c04710c92712449$var$Se = "function" === typeof $0c04710c92712449$var$Te.oninput;
        }
        $0c04710c92712449$var$Re = $0c04710c92712449$var$Se;
    } else $0c04710c92712449$var$Re = !1;
    $0c04710c92712449$var$Qe = $0c04710c92712449$var$Re && (!document.documentMode || 9 < document.documentMode);
}
function $0c04710c92712449$var$Ue() {
    $0c04710c92712449$var$Ke && ($0c04710c92712449$var$Ke.detachEvent("onpropertychange", $0c04710c92712449$var$Ve), $0c04710c92712449$var$Le = $0c04710c92712449$var$Ke = null);
}
function $0c04710c92712449$var$Ve(a) {
    if ("value" === a.propertyName && $0c04710c92712449$var$Oe($0c04710c92712449$var$Le)) {
        var b = [];
        $0c04710c92712449$var$Ie(b, $0c04710c92712449$var$Le, a, $0c04710c92712449$var$Ub(a));
        $0c04710c92712449$var$dc($0c04710c92712449$var$Me, b);
    }
}
function $0c04710c92712449$var$We(a, b, c) {
    "focusin" === a ? ($0c04710c92712449$var$Ue(), $0c04710c92712449$var$Ke = b, $0c04710c92712449$var$Le = c, $0c04710c92712449$var$Ke.attachEvent("onpropertychange", $0c04710c92712449$var$Ve)) : "focusout" === a && $0c04710c92712449$var$Ue();
}
function $0c04710c92712449$var$Xe(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0c04710c92712449$var$Oe($0c04710c92712449$var$Le);
}
function $0c04710c92712449$var$Ye(a, b) {
    if ("click" === a) return $0c04710c92712449$var$Oe(b);
}
function $0c04710c92712449$var$Ze(a, b) {
    if ("input" === a || "change" === a) return $0c04710c92712449$var$Oe(b);
}
function $0c04710c92712449$var$$e(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0c04710c92712449$var$af = "function" === typeof Object.is ? Object.is : $0c04710c92712449$var$$e;
function $0c04710c92712449$var$bf(a, b) {
    if ($0c04710c92712449$var$af(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0c04710c92712449$var$za.call(b, e) || !$0c04710c92712449$var$af(a[e], b[e])) return !1;
    }
    return !0;
}
function $0c04710c92712449$var$cf(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0c04710c92712449$var$df(a, b) {
    var c = $0c04710c92712449$var$cf(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0c04710c92712449$var$cf(c);
    }
}
function $0c04710c92712449$var$ef(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0c04710c92712449$var$ef(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0c04710c92712449$var$ff() {
    for(var a = window, b = $0c04710c92712449$var$tb(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0c04710c92712449$var$tb(a.document);
    }
    return b;
}
function $0c04710c92712449$var$gf(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0c04710c92712449$var$hf(a) {
    var b = $0c04710c92712449$var$ff(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0c04710c92712449$var$ef(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0c04710c92712449$var$gf(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0c04710c92712449$var$df(c, f);
                var g = $0c04710c92712449$var$df(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0c04710c92712449$var$jf = $0c04710c92712449$var$ya && "documentMode" in document && 11 >= document.documentMode, $0c04710c92712449$var$kf = null, $0c04710c92712449$var$lf = null, $0c04710c92712449$var$mf = null, $0c04710c92712449$var$nf = !1;
function $0c04710c92712449$var$of(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0c04710c92712449$var$nf || null == $0c04710c92712449$var$kf || $0c04710c92712449$var$kf !== $0c04710c92712449$var$tb(d) || (d = $0c04710c92712449$var$kf, "selectionStart" in d && $0c04710c92712449$var$gf(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0c04710c92712449$var$mf && $0c04710c92712449$var$bf($0c04710c92712449$var$mf, d) || ($0c04710c92712449$var$mf = d, d = $0c04710c92712449$var$Je($0c04710c92712449$var$lf, "onSelect"), 0 < d.length && (b = new $0c04710c92712449$var$Od("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0c04710c92712449$var$kf)));
}
function $0c04710c92712449$var$pf(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0c04710c92712449$var$qf = {
    animationend: $0c04710c92712449$var$pf("Animation", "AnimationEnd"),
    animationiteration: $0c04710c92712449$var$pf("Animation", "AnimationIteration"),
    animationstart: $0c04710c92712449$var$pf("Animation", "AnimationStart"),
    transitionend: $0c04710c92712449$var$pf("Transition", "TransitionEnd")
}, $0c04710c92712449$var$rf = {}, $0c04710c92712449$var$sf = {};
$0c04710c92712449$var$ya && ($0c04710c92712449$var$sf = document.createElement("div").style, "AnimationEvent" in window || (delete $0c04710c92712449$var$qf.animationend.animation, delete $0c04710c92712449$var$qf.animationiteration.animation, delete $0c04710c92712449$var$qf.animationstart.animation), "TransitionEvent" in window || delete $0c04710c92712449$var$qf.transitionend.transition);
function $0c04710c92712449$var$tf(a) {
    if ($0c04710c92712449$var$rf[a]) return $0c04710c92712449$var$rf[a];
    if (!$0c04710c92712449$var$qf[a]) return a;
    var b = $0c04710c92712449$var$qf[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0c04710c92712449$var$sf) return $0c04710c92712449$var$rf[a] = b[c];
    return a;
}
var $0c04710c92712449$var$uf = $0c04710c92712449$var$tf("animationend"), $0c04710c92712449$var$vf = $0c04710c92712449$var$tf("animationiteration"), $0c04710c92712449$var$wf = $0c04710c92712449$var$tf("animationstart"), $0c04710c92712449$var$xf = $0c04710c92712449$var$tf("transitionend"), $0c04710c92712449$var$yf = new Map, $0c04710c92712449$var$zf = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0c04710c92712449$var$Af(a, b) {
    $0c04710c92712449$var$yf.set(a, b);
    $0c04710c92712449$var$wa(b, [
        a
    ]);
}
for(var $0c04710c92712449$var$Bf = 0; $0c04710c92712449$var$Bf < $0c04710c92712449$var$zf.length; $0c04710c92712449$var$Bf++){
    var $0c04710c92712449$var$Cf = $0c04710c92712449$var$zf[$0c04710c92712449$var$Bf], $0c04710c92712449$var$Df = $0c04710c92712449$var$Cf.toLowerCase(), $0c04710c92712449$var$Ef = $0c04710c92712449$var$Cf[0].toUpperCase() + $0c04710c92712449$var$Cf.slice(1);
    $0c04710c92712449$var$Af($0c04710c92712449$var$Df, "on" + $0c04710c92712449$var$Ef);
}
$0c04710c92712449$var$Af($0c04710c92712449$var$uf, "onAnimationEnd");
$0c04710c92712449$var$Af($0c04710c92712449$var$vf, "onAnimationIteration");
$0c04710c92712449$var$Af($0c04710c92712449$var$wf, "onAnimationStart");
$0c04710c92712449$var$Af("dblclick", "onDoubleClick");
$0c04710c92712449$var$Af("focusin", "onFocus");
$0c04710c92712449$var$Af("focusout", "onBlur");
$0c04710c92712449$var$Af($0c04710c92712449$var$xf, "onTransitionEnd");
$0c04710c92712449$var$xa("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0c04710c92712449$var$xa("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0c04710c92712449$var$xa("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0c04710c92712449$var$xa("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0c04710c92712449$var$wa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0c04710c92712449$var$wa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0c04710c92712449$var$wa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0c04710c92712449$var$wa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0c04710c92712449$var$wa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0c04710c92712449$var$wa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0c04710c92712449$var$Ff = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0c04710c92712449$var$Gf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0c04710c92712449$var$Ff));
function $0c04710c92712449$var$Hf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0c04710c92712449$var$oc(d, b, void 0, a);
    a.currentTarget = null;
}
function $0c04710c92712449$var$Ne(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], l = h.instance, n = h.currentTarget;
                h = h.listener;
                if (l !== f && e.isPropagationStopped()) break a;
                $0c04710c92712449$var$Hf(e, h, n);
                f = l;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                l = h.instance;
                n = h.currentTarget;
                h = h.listener;
                if (l !== f && e.isPropagationStopped()) break a;
                $0c04710c92712449$var$Hf(e, h, n);
                f = l;
            }
        }
    }
    if ($0c04710c92712449$var$kc) throw a = $0c04710c92712449$var$lc, $0c04710c92712449$var$kc = !1, $0c04710c92712449$var$lc = null, a;
}
function $0c04710c92712449$var$H(a, b) {
    var c = b[$0c04710c92712449$var$ia];
    void 0 === c && (c = b[$0c04710c92712449$var$ia] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0c04710c92712449$var$If(b, a, 2, !1), c.add(d));
}
function $0c04710c92712449$var$Jf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0c04710c92712449$var$If(c, a, d, b);
}
var $0c04710c92712449$var$Kf = "_reactListening" + Math.random().toString(36).slice(2);
function $0c04710c92712449$var$Lf(a) {
    if (!a[$0c04710c92712449$var$Kf]) {
        a[$0c04710c92712449$var$Kf] = !0;
        $0c04710c92712449$var$ua.forEach(function(c) {
            "selectionchange" !== c && ($0c04710c92712449$var$Gf.has(c) || $0c04710c92712449$var$Jf(c, !1, a), $0c04710c92712449$var$Jf(c, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0c04710c92712449$var$Kf] || (b[$0c04710c92712449$var$Kf] = !0, $0c04710c92712449$var$Jf("selectionchange", !1, b));
    }
}
function $0c04710c92712449$var$If(a, b, c, d) {
    switch($0c04710c92712449$var$Ed(b)){
        case 2:
            var e = $0c04710c92712449$var$zd;
            break;
        case 8:
            e = $0c04710c92712449$var$Bd;
            break;
        default:
            e = $0c04710c92712449$var$Ad;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0c04710c92712449$var$fc || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0c04710c92712449$var$Cd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var l = g.tag;
                if (3 === l || 4 === l) {
                    if (l = g.stateNode.containerInfo, l === e || 8 === l.nodeType && l.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0c04710c92712449$var$oa(h);
                if (null === g) return;
                l = g.tag;
                if (5 === l || 6 === l || 26 === l || 27 === l) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0c04710c92712449$var$dc(function() {
        var n = f, w = $0c04710c92712449$var$Ub(c), t = [];
        a: {
            var u = $0c04710c92712449$var$yf.get(a);
            if (void 0 !== u) {
                var v = $0c04710c92712449$var$Od, y = a;
                switch(a){
                    case "keypress":
                        if (0 === $0c04710c92712449$var$Jd(c)) break a;
                    case "keydown":
                    case "keyup":
                        v = $0c04710c92712449$var$le;
                        break;
                    case "focusin":
                        y = "focus";
                        v = $0c04710c92712449$var$$d;
                        break;
                    case "focusout":
                        y = "blur";
                        v = $0c04710c92712449$var$$d;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        v = $0c04710c92712449$var$$d;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        v = $0c04710c92712449$var$Wd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        v = $0c04710c92712449$var$Yd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        v = $0c04710c92712449$var$pe;
                        break;
                    case $0c04710c92712449$var$uf:
                    case $0c04710c92712449$var$vf:
                    case $0c04710c92712449$var$wf:
                        v = $0c04710c92712449$var$be;
                        break;
                    case $0c04710c92712449$var$xf:
                        v = $0c04710c92712449$var$re;
                        break;
                    case "scroll":
                        v = $0c04710c92712449$var$Qd;
                        break;
                    case "wheel":
                        v = $0c04710c92712449$var$te;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        v = $0c04710c92712449$var$de;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        v = $0c04710c92712449$var$ne;
                }
                var C = 0 !== (b & 4), R = !C && "scroll" === a, m = C ? null !== u ? u + "Capture" : null : u;
                C = [];
                for(var k = n, p; null !== k;){
                    var r = k;
                    p = r.stateNode;
                    r = r.tag;
                    5 !== r && 26 !== r && 27 !== r || null === p || null === m || (r = $0c04710c92712449$var$ec(k, m), null != r && C.push($0c04710c92712449$var$Mf(k, r, p)));
                    if (R) break;
                    k = k.return;
                }
                0 < C.length && (u = new v(u, y, null, c, w), t.push({
                    event: u,
                    listeners: C
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                u = "mouseover" === a || "pointerover" === a;
                v = "mouseout" === a || "pointerout" === a;
                if (u && c !== $0c04710c92712449$var$Tb && (y = c.relatedTarget || c.fromElement) && ($0c04710c92712449$var$oa(y) || y[$0c04710c92712449$var$ha])) break a;
                if (v || u) {
                    u = w.window === w ? w : (u = w.ownerDocument) ? u.defaultView || u.parentWindow : window;
                    if (v) {
                        if (y = c.relatedTarget || c.toElement, v = n, y = y ? $0c04710c92712449$var$oa(y) : null, null !== y && (R = $0c04710c92712449$var$pc(y), C = y.tag, y !== R || 5 !== C && 27 !== C && 6 !== C)) y = null;
                    } else v = null, y = n;
                    if (v !== y) {
                        C = $0c04710c92712449$var$Wd;
                        r = "onMouseLeave";
                        m = "onMouseEnter";
                        k = "mouse";
                        if ("pointerout" === a || "pointerover" === a) C = $0c04710c92712449$var$ne, r = "onPointerLeave", m = "onPointerEnter", k = "pointer";
                        R = null == v ? u : $0c04710c92712449$var$ra(v);
                        p = null == y ? u : $0c04710c92712449$var$ra(y);
                        u = new C(r, k + "leave", v, c, w);
                        u.target = R;
                        u.relatedTarget = p;
                        r = null;
                        $0c04710c92712449$var$oa(w) === n && (C = new C(m, k + "enter", y, c, w), C.target = p, C.relatedTarget = R, r = C);
                        R = r;
                        if (v && y) b: {
                            C = v;
                            m = y;
                            k = 0;
                            for(p = C; p; p = $0c04710c92712449$var$Nf(p))k++;
                            p = 0;
                            for(r = m; r; r = $0c04710c92712449$var$Nf(r))p++;
                            for(; 0 < k - p;)C = $0c04710c92712449$var$Nf(C), k--;
                            for(; 0 < p - k;)m = $0c04710c92712449$var$Nf(m), p--;
                            for(; k--;){
                                if (C === m || null !== m && C === m.alternate) break b;
                                C = $0c04710c92712449$var$Nf(C);
                                m = $0c04710c92712449$var$Nf(m);
                            }
                            C = null;
                        }
                        else C = null;
                        null !== v && $0c04710c92712449$var$Of(t, u, v, C, !1);
                        null !== y && null !== R && $0c04710c92712449$var$Of(t, R, y, C, !0);
                    }
                }
            }
            a: {
                u = n ? $0c04710c92712449$var$ra(n) : window;
                v = u.nodeName && u.nodeName.toLowerCase();
                if ("select" === v || "input" === v && "file" === u.type) var x = $0c04710c92712449$var$Pe;
                else if ($0c04710c92712449$var$He(u)) {
                    if ($0c04710c92712449$var$Qe) x = $0c04710c92712449$var$Ze;
                    else {
                        x = $0c04710c92712449$var$Xe;
                        var A = $0c04710c92712449$var$We;
                    }
                } else v = u.nodeName, !v || "input" !== v.toLowerCase() || "checkbox" !== u.type && "radio" !== u.type ? n && $0c04710c92712449$var$Sb(n.elementType, n.memoizedProps) && (x = $0c04710c92712449$var$Pe) : x = $0c04710c92712449$var$Ye;
                if (x && (x = x(a, n))) {
                    $0c04710c92712449$var$Ie(t, x, c, w);
                    break a;
                }
                A && A(a, u, n);
                "focusout" === a && (A = u._wrapperState) && A.controlled && "number" === u.type && $0c04710c92712449$var$yb(u, "number", u.value);
            }
            A = n ? $0c04710c92712449$var$ra(n) : window;
            switch(a){
                case "focusin":
                    if ($0c04710c92712449$var$He(A) || "true" === A.contentEditable) $0c04710c92712449$var$kf = A, $0c04710c92712449$var$lf = n, $0c04710c92712449$var$mf = null;
                    break;
                case "focusout":
                    $0c04710c92712449$var$mf = $0c04710c92712449$var$lf = $0c04710c92712449$var$kf = null;
                    break;
                case "mousedown":
                    $0c04710c92712449$var$nf = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0c04710c92712449$var$nf = !1;
                    $0c04710c92712449$var$of(t, c, w);
                    break;
                case "selectionchange":
                    if ($0c04710c92712449$var$jf) break;
                case "keydown":
                case "keyup":
                    $0c04710c92712449$var$of(t, c, w);
            }
            var z;
            if ($0c04710c92712449$var$ve) b: {
                switch(a){
                    case "compositionstart":
                        var B = "onCompositionStart";
                        break b;
                    case "compositionend":
                        B = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        B = "onCompositionUpdate";
                        break b;
                }
                B = void 0;
            }
            else $0c04710c92712449$var$De ? $0c04710c92712449$var$Be(a, c) && (B = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (B = "onCompositionStart");
            B && ($0c04710c92712449$var$ye && "ko" !== c.locale && ($0c04710c92712449$var$De || "onCompositionStart" !== B ? "onCompositionEnd" === B && $0c04710c92712449$var$De && (z = $0c04710c92712449$var$Id()) : ($0c04710c92712449$var$Fd = w, $0c04710c92712449$var$Gd = "value" in $0c04710c92712449$var$Fd ? $0c04710c92712449$var$Fd.value : $0c04710c92712449$var$Fd.textContent, $0c04710c92712449$var$De = !0)), A = $0c04710c92712449$var$Je(n, B), 0 < A.length && (B = new $0c04710c92712449$var$fe(B, a, null, c, w), t.push({
                event: B,
                listeners: A
            }), z ? B.data = z : (z = $0c04710c92712449$var$Ce(c), null !== z && (B.data = z))));
            if (z = $0c04710c92712449$var$xe ? $0c04710c92712449$var$Ee(a, c) : $0c04710c92712449$var$Fe(a, c)) n = $0c04710c92712449$var$Je(n, "onBeforeInput"), 0 < n.length && (w = new $0c04710c92712449$var$fe("onBeforeInput", "beforeinput", null, c, w), t.push({
                event: w,
                listeners: n
            }), w.data = z);
        }
        $0c04710c92712449$var$Ne(t, b);
    });
}
function $0c04710c92712449$var$Mf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0c04710c92712449$var$Je(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        e = e.tag;
        5 !== e && 26 !== e && 27 !== e || null === f || (e = $0c04710c92712449$var$ec(a, c), null != e && d.unshift($0c04710c92712449$var$Mf(a, e, f)), e = $0c04710c92712449$var$ec(a, b), null != e && d.push($0c04710c92712449$var$Mf(a, e, f)));
        a = a.return;
    }
    return d;
}
function $0c04710c92712449$var$Nf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag && 27 !== a.tag);
    return a ? a : null;
}
function $0c04710c92712449$var$Of(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, l = h.alternate, n = h.stateNode;
        h = h.tag;
        if (null !== l && l === d) break;
        5 !== h && 26 !== h && 27 !== h || null === n || (l = n, e ? (n = $0c04710c92712449$var$ec(c, f), null != n && g.unshift($0c04710c92712449$var$Mf(c, n, l))) : e || (n = $0c04710c92712449$var$ec(c, f), null != n && g.push($0c04710c92712449$var$Mf(c, n, l))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0c04710c92712449$var$Pf = /\r\n?/g, $0c04710c92712449$var$Qf = /\u0000|\uFFFD/g;
function $0c04710c92712449$var$Rf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0c04710c92712449$var$Pf, "\n").replace($0c04710c92712449$var$Qf, "");
}
function $0c04710c92712449$var$Sf(a, b, c) {
    b = $0c04710c92712449$var$Rf(b);
    if ($0c04710c92712449$var$Rf(a) !== b && c) throw Error($0c04710c92712449$var$q(425));
}
function $0c04710c92712449$var$Tf() {}
function $0c04710c92712449$var$Uf(a, b, c, d) {
    c = 9 === c.nodeType ? c : c.ownerDocument;
    "http://www.w3.org/1999/xhtml" === d && (d = $0c04710c92712449$var$Hb(a));
    "http://www.w3.org/1999/xhtml" === d ? "script" === a ? (b = c.createElement("div"), b.innerHTML = "<script></script>", d = b.removeChild(b.firstChild)) : "string" === typeof b.is ? d = c.createElement(a, {
        is: b.is
    }) : (d = c.createElement(a), "select" === a && (a = d, b.multiple ? a.multiple = !0 : b.size && (a.size = b.size))) : d = c.createElementNS(d, a);
    return d;
}
function $0c04710c92712449$var$Vf(a, b, c) {
    var d = $0c04710c92712449$var$Sb(b, c);
    switch(b){
        case "dialog":
            $0c04710c92712449$var$H("cancel", a);
            $0c04710c92712449$var$H("close", a);
            var e = c;
            break;
        case "iframe":
        case "object":
        case "embed":
            $0c04710c92712449$var$H("load", a);
            e = c;
            break;
        case "video":
        case "audio":
            for(e = 0; e < $0c04710c92712449$var$Ff.length; e++)$0c04710c92712449$var$H($0c04710c92712449$var$Ff[e], a);
            e = c;
            break;
        case "source":
            $0c04710c92712449$var$H("error", a);
            e = c;
            break;
        case "img":
        case "image":
        case "link":
            $0c04710c92712449$var$H("error", a);
            $0c04710c92712449$var$H("load", a);
            e = c;
            break;
        case "details":
            $0c04710c92712449$var$H("toggle", a);
            e = c;
            break;
        case "input":
            $0c04710c92712449$var$vb(a, c);
            e = $0c04710c92712449$var$ub(a, c);
            $0c04710c92712449$var$H("invalid", a);
            break;
        case "option":
            e = c;
            break;
        case "select":
            a._wrapperState = {
                wasMultiple: !!c.multiple
            };
            e = $0c04710c92712449$var$D({}, c, {
                value: void 0
            });
            $0c04710c92712449$var$H("invalid", a);
            break;
        case "textarea":
            $0c04710c92712449$var$Db(a, c);
            e = $0c04710c92712449$var$Cb(a, c);
            $0c04710c92712449$var$H("invalid", a);
            break;
        default:
            e = c;
    }
    $0c04710c92712449$var$Rb(b, e);
    var f = e, g;
    for(g in f)if (f.hasOwnProperty(g)) {
        var h = f[g];
        "style" === g ? $0c04710c92712449$var$Pb(a, h) : "dangerouslySetInnerHTML" === g ? (h = h ? h.__html : void 0, null != h && $0c04710c92712449$var$Kb(a, h)) : "children" === g ? "string" === typeof h ? "body" === b || "textarea" === b && "" === h || $0c04710c92712449$var$Lb(a, h) : "number" === typeof h && "body" !== b && $0c04710c92712449$var$Lb(a, "" + h) : "suppressContentEditableWarning" !== g && "suppressHydrationWarning" !== g && "autoFocus" !== g && ($0c04710c92712449$var$va.hasOwnProperty(g) ? null != h && "onScroll" === g && $0c04710c92712449$var$H("scroll", a) : null != h && $0c04710c92712449$var$La(a, g, h, d));
    }
    switch(b){
        case "input":
            $0c04710c92712449$var$rb(a);
            $0c04710c92712449$var$zb(a, c, !1);
            break;
        case "textarea":
            $0c04710c92712449$var$rb(a);
            $0c04710c92712449$var$Fb(a);
            break;
        case "option":
            null != c.value && a.setAttribute("value", "" + $0c04710c92712449$var$ob(c.value));
            break;
        case "select":
            a.multiple = !!c.multiple;
            b = c.value;
            null != b ? $0c04710c92712449$var$Bb(a, !!c.multiple, b, !1) : null != c.defaultValue && $0c04710c92712449$var$Bb(a, !!c.multiple, c.defaultValue, !0);
            break;
        default:
            "function" === typeof e.onClick && (a.onclick = $0c04710c92712449$var$Tf);
    }
}
function $0c04710c92712449$var$Wf(a, b, c, d, e) {
    "input" === c && "radio" === e.type && null != e.name && $0c04710c92712449$var$wb(a, e);
    $0c04710c92712449$var$Sb(c, d);
    d = $0c04710c92712449$var$Sb(c, e);
    for(var f = 0; f < b.length; f += 2){
        var g = b[f], h = b[f + 1];
        "style" === g ? $0c04710c92712449$var$Pb(a, h) : "dangerouslySetInnerHTML" === g ? $0c04710c92712449$var$Kb(a, h) : "children" === g ? $0c04710c92712449$var$Lb(a, h) : $0c04710c92712449$var$La(a, g, h, d);
    }
    switch(c){
        case "input":
            $0c04710c92712449$var$xb(a, e);
            break;
        case "textarea":
            $0c04710c92712449$var$Eb(a, e);
            break;
        case "select":
            b = a._wrapperState.wasMultiple, a._wrapperState.wasMultiple = !!e.multiple, c = e.value, null != c ? $0c04710c92712449$var$Bb(a, !!e.multiple, c, !1) : b !== !!e.multiple && (null != e.defaultValue ? $0c04710c92712449$var$Bb(a, !!e.multiple, e.defaultValue, !0) : $0c04710c92712449$var$Bb(a, !!e.multiple, e.multiple ? [] : "", !1));
    }
}
var $0c04710c92712449$var$Xf = [], $0c04710c92712449$var$Yf = -1;
function $0c04710c92712449$var$Zf(a) {
    return {
        current: a
    };
}
function $0c04710c92712449$var$I(a) {
    0 > $0c04710c92712449$var$Yf || (a.current = $0c04710c92712449$var$Xf[$0c04710c92712449$var$Yf], $0c04710c92712449$var$Xf[$0c04710c92712449$var$Yf] = null, $0c04710c92712449$var$Yf--);
}
function $0c04710c92712449$var$J(a, b) {
    $0c04710c92712449$var$Yf++;
    $0c04710c92712449$var$Xf[$0c04710c92712449$var$Yf] = a.current;
    a.current = b;
}
var $0c04710c92712449$var$$f = $0c04710c92712449$var$Zf(null), $0c04710c92712449$var$ag = $0c04710c92712449$var$Zf(null), $0c04710c92712449$var$bg = $0c04710c92712449$var$Zf(null);
function $0c04710c92712449$var$cg(a, b) {
    $0c04710c92712449$var$J($0c04710c92712449$var$bg, b);
    $0c04710c92712449$var$J($0c04710c92712449$var$ag, a);
    $0c04710c92712449$var$J($0c04710c92712449$var$$f, null);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0c04710c92712449$var$Ib(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0c04710c92712449$var$Ib(b, a);
    }
    $0c04710c92712449$var$I($0c04710c92712449$var$$f);
    $0c04710c92712449$var$J($0c04710c92712449$var$$f, b);
}
function $0c04710c92712449$var$dg() {
    $0c04710c92712449$var$I($0c04710c92712449$var$$f);
    $0c04710c92712449$var$I($0c04710c92712449$var$ag);
    $0c04710c92712449$var$I($0c04710c92712449$var$bg);
}
function $0c04710c92712449$var$eg(a) {
    var b = $0c04710c92712449$var$$f.current;
    var c = $0c04710c92712449$var$Ib(b, a.type);
    b !== c && ($0c04710c92712449$var$J($0c04710c92712449$var$ag, a), $0c04710c92712449$var$J($0c04710c92712449$var$$f, c));
}
function $0c04710c92712449$var$fg(a) {
    $0c04710c92712449$var$ag.current === a && ($0c04710c92712449$var$I($0c04710c92712449$var$$f), $0c04710c92712449$var$I($0c04710c92712449$var$ag));
}
var $0c04710c92712449$var$gg = $0c04710c92712449$var$ca.Dispatcher, $0c04710c92712449$var$hg = null, $0c04710c92712449$var$ig = null, $0c04710c92712449$var$ng = {
    prefetchDNS: $0c04710c92712449$var$jg,
    preconnect: $0c04710c92712449$var$kg,
    preload: $0c04710c92712449$var$lg,
    preinit: $0c04710c92712449$var$mg
}, $0c04710c92712449$var$og = new Map, $0c04710c92712449$var$pg = new Set;
function $0c04710c92712449$var$qg(a) {
    return "function" === typeof a.getRootNode ? a.getRootNode() : a.ownerDocument;
}
function $0c04710c92712449$var$rg() {
    var a = $0c04710c92712449$var$bg.current;
    return a ? $0c04710c92712449$var$qg(a) : null;
}
function $0c04710c92712449$var$sg() {
    var a = $0c04710c92712449$var$rg();
    if (a) return a.ownerDocument || a;
    try {
        return $0c04710c92712449$var$hg || window.document;
    } catch (b) {
        return null;
    }
}
function $0c04710c92712449$var$tg(a, b, c) {
    var d = $0c04710c92712449$var$sg();
    if ("string" === typeof c && c && d) {
        var e = $0c04710c92712449$var$ug(c);
        e = 'link[rel="' + a + '"][href="' + e + '"]';
        "string" === typeof b && (e += '[crossorigin="' + b + '"]');
        $0c04710c92712449$var$pg.has(e) || ($0c04710c92712449$var$pg.add(e), a = {
            rel: a,
            crossOrigin: b,
            href: c
        }, null === d.querySelector(e) && (b = $0c04710c92712449$var$Uf("link", a, d, "http://www.w3.org/1999/xhtml"), $0c04710c92712449$var$Vf(b, "link", a), b[$0c04710c92712449$var$ma] = !0, d.head.appendChild(b)));
    }
}
function $0c04710c92712449$var$jg(a) {
    $0c04710c92712449$var$tg("dns-prefetch", null, a);
}
function $0c04710c92712449$var$kg(a, b) {
    $0c04710c92712449$var$tg("preconnect", null == b || "string" !== typeof b.crossOrigin ? null : "use-credentials" === b.crossOrigin ? "use-credentials" : "", a);
}
function $0c04710c92712449$var$lg(a, b) {
    var c = $0c04710c92712449$var$sg();
    if ("string" === typeof a && a && "object" === typeof b && null !== b && c) {
        var d = b.as, e = $0c04710c92712449$var$ug(a), f = e = 'link[rel="preload"][as="' + d + '"][href="' + e + '"]';
        switch(d){
            case "style":
                f = $0c04710c92712449$var$vg(a);
                break;
            case "script":
                f = $0c04710c92712449$var$wg(a);
        }
        $0c04710c92712449$var$og.has(f) || (a = {
            href: a,
            rel: "preload",
            as: d,
            crossOrigin: "font" === d ? "" : b.crossOrigin,
            integrity: b.integrity,
            type: b.type
        }, $0c04710c92712449$var$og.set(f, a), null === c.querySelector(e) && (b = $0c04710c92712449$var$Uf("link", a, c, "http://www.w3.org/1999/xhtml"), $0c04710c92712449$var$Vf(b, "link", a), b[$0c04710c92712449$var$ma] = !0, c.head.appendChild(b)));
    }
}
function $0c04710c92712449$var$mg(a, b) {
    if ("string" === typeof a && a && "object" === typeof b && null !== b) {
        var c = $0c04710c92712449$var$rg(), d = b.as;
        if (c) switch(d){
            case "style":
                d = $0c04710c92712449$var$ta(c).hoistableStyles;
                var e = $0c04710c92712449$var$vg(a), f = b.precedence || "default", g = d.get(e);
                if (g) break;
                g = c.querySelector($0c04710c92712449$var$xg(e));
                g || (a = {
                    rel: "stylesheet",
                    href: a,
                    "data-precedence": f,
                    crossOrigin: b.crossOrigin
                }, (b = $0c04710c92712449$var$og.get(e)) && $0c04710c92712449$var$yg(a, b), g = $0c04710c92712449$var$Uf("link", a, c, "http://www.w3.org/1999/xhtml"), g[$0c04710c92712449$var$ma] = !0, $0c04710c92712449$var$Vf(g, "link", a), $0c04710c92712449$var$zg(g, f, c));
                g = {
                    type: "stylesheet",
                    instance: g,
                    count: 1
                };
                d.set(e, g);
                break;
            case "script":
                d = $0c04710c92712449$var$ta(c).hoistableScripts, e = $0c04710c92712449$var$wg(a), f = d.get(e), f || (f = c.querySelector("script[async]" + e), f || (a = {
                    src: a,
                    async: !0,
                    crossOrigin: b.crossOrigin,
                    integrity: b.integrity
                }, (b = $0c04710c92712449$var$og.get(e)) && $0c04710c92712449$var$Ag(a, b), f = $0c04710c92712449$var$Uf("script", a, c, "http://www.w3.org/1999/xhtml"), f[$0c04710c92712449$var$ma] = !0, $0c04710c92712449$var$Vf(f, "link", a), (c.ownerDocument || c).head.appendChild(f)), f = {
                    type: "script",
                    instance: f,
                    count: 1
                }, d.set(e, f));
        }
        else if ("style" === d || "script" === d) {
            if (c = $0c04710c92712449$var$sg()) {
                e = $0c04710c92712449$var$ug(a);
                f = e = 'link[rel="preload"][as="' + d + '"][href="' + e + '"]';
                switch(d){
                    case "style":
                        f = $0c04710c92712449$var$vg(a);
                        break;
                    case "script":
                        f = $0c04710c92712449$var$wg(a);
                }
                $0c04710c92712449$var$og.has(f) || (a = {
                    href: a,
                    rel: "preload",
                    as: d,
                    crossOrigin: "font" === d ? "" : b.crossOrigin,
                    integrity: b.integrity
                }, $0c04710c92712449$var$og.set(f, a), null === c.querySelector(e) && (b = $0c04710c92712449$var$Uf("link", a, c, "http://www.w3.org/1999/xhtml"), $0c04710c92712449$var$Vf(b, "link", a), b[$0c04710c92712449$var$ma] = !0, c.head.appendChild(b)));
            }
        }
    }
}
function $0c04710c92712449$var$Bg(a, b, c) {
    b = $0c04710c92712449$var$rg();
    if (!b) throw Error($0c04710c92712449$var$q(446));
    switch(a){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof c.precedence && "string" === typeof c.href ? (c = $0c04710c92712449$var$vg(c.href), b = $0c04710c92712449$var$ta(b).hoistableStyles, a = b.get(c), a || (a = {
                type: "style",
                instance: null,
                count: 0
            }, b.set(c, a)), a) : {
                type: "void",
                instance: null,
                count: 0
            };
        case "link":
            if ("stylesheet" === c.rel && "string" === typeof c.href && "string" === typeof c.precedence) {
                var d = $0c04710c92712449$var$vg(c.href), e = $0c04710c92712449$var$ta(b).hoistableStyles;
                a = e.get(d);
                a || (b = b.ownerDocument || b, a = {
                    type: "stylesheet",
                    instance: null,
                    count: 0
                }, e.set(d, a), $0c04710c92712449$var$og.has(d) || (c = {
                    rel: "preload",
                    as: "style",
                    href: c.href,
                    crossOrigin: c.crossOrigin,
                    integrity: c.integrity,
                    media: c.media,
                    hrefLang: c.hrefLang,
                    referrerPolicy: c.referrerPolicy
                }, $0c04710c92712449$var$og.set(d, c), b.querySelector($0c04710c92712449$var$xg(d)) || null !== b.querySelector('link[rel="preload"][as="style"][' + d + "]") || (d = $0c04710c92712449$var$Uf("link", c, b, "http://www.w3.org/1999/xhtml"), $0c04710c92712449$var$Vf(d, "link", c), d[$0c04710c92712449$var$ma] = !0, b.head.appendChild(d))));
                return a;
            }
            return null;
        case "script":
            return "string" === typeof c.src && !0 === c.async ? (c = $0c04710c92712449$var$wg(c.src), b = $0c04710c92712449$var$ta(b).hoistableScripts, a = b.get(c), a || (a = {
                type: "script",
                instance: null,
                count: 0
            }, b.set(c, a)), a) : {
                type: "void",
                instance: null,
                count: 0
            };
        default:
            throw Error($0c04710c92712449$var$q(444, a));
    }
}
function $0c04710c92712449$var$vg(a) {
    return 'href~="' + $0c04710c92712449$var$ug(a) + '"';
}
function $0c04710c92712449$var$xg(a) {
    return 'link[rel="stylesheet"][' + a + "]";
}
function $0c04710c92712449$var$wg(a) {
    return '[src="' + $0c04710c92712449$var$ug(a) + '"]';
}
function $0c04710c92712449$var$Cg(a, b, c) {
    b.count++;
    if (null === b.instance) switch(b.type){
        case "style":
            var d = $0c04710c92712449$var$vg(c.href);
            if (d = a.querySelector("style[data-" + d + "]")) return b.instance = d;
            var e = $0c04710c92712449$var$D({}, c, {
                "data-href": c.href,
                "data-precedence": c.precedence,
                href: null,
                precedence: null
            });
            d = $0c04710c92712449$var$Uf("style", e, a, "http://www.w3.org/1999/xhtml");
            d[$0c04710c92712449$var$ma] = !0;
            $0c04710c92712449$var$Vf(d, "style", e);
            $0c04710c92712449$var$zg(d, c.precedence, a);
            return b.instance = d;
        case "stylesheet":
            e = $0c04710c92712449$var$vg(c.href);
            var f = a.querySelector($0c04710c92712449$var$xg(e));
            if (f) return b.instance = f;
            d = $0c04710c92712449$var$D({}, c, {
                "data-precedence": c.precedence,
                precedence: null
            });
            (e = $0c04710c92712449$var$og.get(e)) && $0c04710c92712449$var$yg(d, e);
            f = $0c04710c92712449$var$Uf("link", d, a, "http://www.w3.org/1999/xhtml");
            f[$0c04710c92712449$var$ma] = !0;
            var g = f;
            g._p = new Promise(function(h, l) {
                g.onload = h;
                g.onerror = l;
            }).then(function() {
                return g._p.s = "l";
            }, function() {
                return g._p.s = "e";
            });
            $0c04710c92712449$var$Vf(f, "link", d);
            $0c04710c92712449$var$zg(f, c.precedence, a);
            return b.instance = f;
        case "script":
            e = $0c04710c92712449$var$wg(c.src);
            if (f = a.querySelector("script[async]" + e)) return b.instance = f;
            d = c;
            if (e = $0c04710c92712449$var$og.get(e)) d = $0c04710c92712449$var$D({}, c), $0c04710c92712449$var$Ag(d, e);
            f = $0c04710c92712449$var$Uf("script", d, a, "http://www.w3.org/1999/xhtml");
            f[$0c04710c92712449$var$ma] = !0;
            $0c04710c92712449$var$Vf(f, "link", d);
            (a.ownerDocument || a).head.appendChild(f);
            return b.instance = f;
        case "void":
            return null;
        default:
            throw Error($0c04710c92712449$var$q(443, b.type));
    }
    return b.instance;
}
function $0c04710c92712449$var$zg(a, b, c) {
    for(var d = c.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), e = d.length ? d[d.length - 1] : null, f = e, g = 0; g < d.length; g++){
        var h = d[g];
        if (h.dataset.precedence === b) f = h;
        else if (f !== e) break;
    }
    f ? f.parentNode.insertBefore(a, f.nextSibling) : (b = 9 === c.nodeType ? c.head : c, b.insertBefore(a, b.firstChild));
}
function $0c04710c92712449$var$yg(a, b) {
    null == a.crossOrigin && (a.crossOrigin = b.crossOrigin);
    null == a.referrerPolicy && (a.referrerPolicy = b.referrerPolicy);
    null == a.title && (a.title = b.title);
}
function $0c04710c92712449$var$Ag(a, b) {
    null == a.crossOrigin && (a.crossOrigin = b.crossOrigin);
    null == a.referrerPolicy && (a.referrerPolicy = b.referrerPolicy);
    null == a.integrity && (a.referrerPolicy = b.integrity);
}
function $0c04710c92712449$var$Dg(a, b, c) {
    a = a.ownerDocument || a;
    a.head.insertBefore(c, "title" === b ? a.querySelector("head > title") : null);
}
var $0c04710c92712449$var$Eg = /[\n"\\]/g;
function $0c04710c92712449$var$ug(a) {
    return a.replace($0c04710c92712449$var$Eg, function(b) {
        return "\\" + b.charCodeAt(0).toString(16);
    });
}
var $0c04710c92712449$var$Fg = null, $0c04710c92712449$var$Gg = null;
function $0c04710c92712449$var$Hg(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0c04710c92712449$var$Ig = "function" === typeof setTimeout ? setTimeout : void 0, $0c04710c92712449$var$Jg = "function" === typeof clearTimeout ? clearTimeout : void 0, $0c04710c92712449$var$Kg = "function" === typeof Promise ? Promise : void 0, $0c04710c92712449$var$Mg = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0c04710c92712449$var$Kg ? function(a) {
    return $0c04710c92712449$var$Kg.resolve(null).then(a).catch($0c04710c92712449$var$Lg);
} : $0c04710c92712449$var$Ig;
function $0c04710c92712449$var$Lg(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0c04710c92712449$var$Ng(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0c04710c92712449$var$wd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0c04710c92712449$var$wd(b);
}
function $0c04710c92712449$var$Og(a) {
    var b = a.nodeType;
    if (9 === b) $0c04710c92712449$var$Pg(a);
    else if (1 === b) switch(a.nodeName){
        case "HEAD":
        case "HTML":
        case "BODY":
            $0c04710c92712449$var$Pg(a);
            break;
        default:
            a.textContent = "";
    }
}
function $0c04710c92712449$var$Pg(a) {
    var b = a.firstChild;
    b && 10 === b.nodeType && (b = b.nextSibling);
    for(; b;){
        var c = b;
        b = b.nextSibling;
        switch(c.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $0c04710c92712449$var$Pg(c);
                $0c04710c92712449$var$na(c);
                continue;
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === c.rel.toLowerCase()) continue;
        }
        a.removeChild(c);
    }
}
function $0c04710c92712449$var$Qg(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b) {
            b = a;
            switch(b.tagName){
                case "TITLE":
                case "META":
                case "HTML":
                case "HEAD":
                case "BODY":
                    continue;
                case "LINK":
                    if ("stylesheet" === b.rel && !b.hasAttribute("data-precedence")) break;
                    continue;
                case "STYLE":
                    if (b.hasAttribute("data-precedence")) continue;
                    break;
                case "SCRIPT":
                    if (b.hasAttribute("async")) continue;
            }
            break;
        } else if (3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0c04710c92712449$var$pa(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
function $0c04710c92712449$var$Rg(a, b, c) {
    switch(a){
        case "meta":
        case "title":
            return "http://www.w3.org/2000/svg" !== c;
        case "style":
            if ("string" !== typeof b.precedence || "string" !== typeof b.href || "" === b.href || "http://www.w3.org/2000/svg" === c) break;
            return !0;
        case "link":
            if ("string" !== typeof b.rel || "string" !== typeof b.href || "" === b.href || b.onLoad || b.onError || "http://www.w3.org/2000/svg" === c) break;
            switch(b.rel){
                case "stylesheet":
                    return a = b.disabled, "string" === typeof b.precedence && null == a;
                default:
                    return !0;
            }
        case "script":
            if (!0 === b.async && !b.onLoad && !b.onError && "string" === typeof b.src && b.src && "http://www.w3.org/2000/svg" !== c) return !0;
    }
    return !1;
}
function $0c04710c92712449$var$Sg(a, b, c) {
    b = 9 === c.nodeType ? c : c.ownerDocument;
    switch(a){
        case "html":
            a = b.documentElement;
            if (!a) throw Error($0c04710c92712449$var$q(452));
            return a;
        case "head":
            a = b.head;
            if (!a) throw Error($0c04710c92712449$var$q(453));
            return a;
        case "body":
            a = b.body;
            if (!a) throw Error($0c04710c92712449$var$q(454));
            return a;
        default:
            throw Error($0c04710c92712449$var$q(451));
    }
}
var $0c04710c92712449$var$Tg = {}, $0c04710c92712449$var$Ug = $0c04710c92712449$var$Zf($0c04710c92712449$var$Tg), $0c04710c92712449$var$Vg = $0c04710c92712449$var$Zf(!1), $0c04710c92712449$var$Wg = $0c04710c92712449$var$Tg;
function $0c04710c92712449$var$Xg(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0c04710c92712449$var$Tg;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0c04710c92712449$var$Yg(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0c04710c92712449$var$Zg() {
    $0c04710c92712449$var$I($0c04710c92712449$var$Vg);
    $0c04710c92712449$var$I($0c04710c92712449$var$Ug);
}
function $0c04710c92712449$var$$g(a, b, c) {
    if ($0c04710c92712449$var$Ug.current !== $0c04710c92712449$var$Tg) throw Error($0c04710c92712449$var$q(168));
    $0c04710c92712449$var$J($0c04710c92712449$var$Ug, b);
    $0c04710c92712449$var$J($0c04710c92712449$var$Vg, c);
}
function $0c04710c92712449$var$ah(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0c04710c92712449$var$q(108, $0c04710c92712449$var$nb(a) || "Unknown", e));
    return $0c04710c92712449$var$D({}, c, d);
}
function $0c04710c92712449$var$bh(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0c04710c92712449$var$Tg;
    $0c04710c92712449$var$Wg = $0c04710c92712449$var$Ug.current;
    $0c04710c92712449$var$J($0c04710c92712449$var$Ug, a);
    $0c04710c92712449$var$J($0c04710c92712449$var$Vg, $0c04710c92712449$var$Vg.current);
    return !0;
}
function $0c04710c92712449$var$ch(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0c04710c92712449$var$q(169));
    c ? (a = $0c04710c92712449$var$ah(a, b, $0c04710c92712449$var$Wg), d.__reactInternalMemoizedMergedChildContext = a, $0c04710c92712449$var$I($0c04710c92712449$var$Vg), $0c04710c92712449$var$I($0c04710c92712449$var$Ug), $0c04710c92712449$var$J($0c04710c92712449$var$Ug, a)) : $0c04710c92712449$var$I($0c04710c92712449$var$Vg);
    $0c04710c92712449$var$J($0c04710c92712449$var$Vg, c);
}
var $0c04710c92712449$var$dh = null, $0c04710c92712449$var$eh = !1, $0c04710c92712449$var$fh = !1;
function $0c04710c92712449$var$gh(a) {
    null === $0c04710c92712449$var$dh ? $0c04710c92712449$var$dh = [
        a
    ] : $0c04710c92712449$var$dh.push(a);
}
function $0c04710c92712449$var$hh(a) {
    $0c04710c92712449$var$eh = !0;
    $0c04710c92712449$var$gh(a);
}
function $0c04710c92712449$var$ih() {
    if (!$0c04710c92712449$var$fh && null !== $0c04710c92712449$var$dh) {
        $0c04710c92712449$var$fh = !0;
        var a = 0, b = $0c04710c92712449$var$G;
        try {
            var c = $0c04710c92712449$var$dh;
            for($0c04710c92712449$var$G = 2; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0c04710c92712449$var$dh = null;
            $0c04710c92712449$var$eh = !1;
        } catch (e) {
            throw null !== $0c04710c92712449$var$dh && ($0c04710c92712449$var$dh = $0c04710c92712449$var$dh.slice(a + 1)), $0c04710c92712449$var$vc($0c04710c92712449$var$Ac, $0c04710c92712449$var$ih), e;
        } finally{
            $0c04710c92712449$var$G = b, $0c04710c92712449$var$fh = !1;
        }
    }
    return null;
}
var $0c04710c92712449$var$jh = [], $0c04710c92712449$var$kh = 0, $0c04710c92712449$var$lh = null, $0c04710c92712449$var$mh = 0, $0c04710c92712449$var$nh = [], $0c04710c92712449$var$oh = 0, $0c04710c92712449$var$ph = null, $0c04710c92712449$var$qh = 1, $0c04710c92712449$var$rh = "";
function $0c04710c92712449$var$sh(a, b) {
    $0c04710c92712449$var$jh[$0c04710c92712449$var$kh++] = $0c04710c92712449$var$mh;
    $0c04710c92712449$var$jh[$0c04710c92712449$var$kh++] = $0c04710c92712449$var$lh;
    $0c04710c92712449$var$lh = a;
    $0c04710c92712449$var$mh = b;
}
function $0c04710c92712449$var$th(a, b, c) {
    $0c04710c92712449$var$nh[$0c04710c92712449$var$oh++] = $0c04710c92712449$var$qh;
    $0c04710c92712449$var$nh[$0c04710c92712449$var$oh++] = $0c04710c92712449$var$rh;
    $0c04710c92712449$var$nh[$0c04710c92712449$var$oh++] = $0c04710c92712449$var$ph;
    $0c04710c92712449$var$ph = a;
    var d = $0c04710c92712449$var$qh;
    a = $0c04710c92712449$var$rh;
    var e = 32 - $0c04710c92712449$var$Jc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0c04710c92712449$var$Jc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0c04710c92712449$var$qh = 1 << 32 - $0c04710c92712449$var$Jc(b) + e | c << e | d;
        $0c04710c92712449$var$rh = f + a;
    } else $0c04710c92712449$var$qh = 1 << f | c << e | d, $0c04710c92712449$var$rh = a;
}
function $0c04710c92712449$var$uh(a) {
    null !== a.return && ($0c04710c92712449$var$sh(a, 1), $0c04710c92712449$var$th(a, 1, 0));
}
function $0c04710c92712449$var$vh(a) {
    for(; a === $0c04710c92712449$var$lh;)$0c04710c92712449$var$lh = $0c04710c92712449$var$jh[--$0c04710c92712449$var$kh], $0c04710c92712449$var$jh[$0c04710c92712449$var$kh] = null, $0c04710c92712449$var$mh = $0c04710c92712449$var$jh[--$0c04710c92712449$var$kh], $0c04710c92712449$var$jh[$0c04710c92712449$var$kh] = null;
    for(; a === $0c04710c92712449$var$ph;)$0c04710c92712449$var$ph = $0c04710c92712449$var$nh[--$0c04710c92712449$var$oh], $0c04710c92712449$var$nh[$0c04710c92712449$var$oh] = null, $0c04710c92712449$var$rh = $0c04710c92712449$var$nh[--$0c04710c92712449$var$oh], $0c04710c92712449$var$nh[$0c04710c92712449$var$oh] = null, $0c04710c92712449$var$qh = $0c04710c92712449$var$nh[--$0c04710c92712449$var$oh], $0c04710c92712449$var$nh[$0c04710c92712449$var$oh] = null;
}
var $0c04710c92712449$var$wh = null, $0c04710c92712449$var$xh = null, $0c04710c92712449$var$K = !1, $0c04710c92712449$var$yh = null;
function $0c04710c92712449$var$zh(a, b) {
    var c = $0c04710c92712449$var$Ah(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0c04710c92712449$var$Bh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0c04710c92712449$var$wh = a, $0c04710c92712449$var$xh = $0c04710c92712449$var$Qg(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0c04710c92712449$var$wh = a, $0c04710c92712449$var$xh = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0c04710c92712449$var$ph ? {
                id: $0c04710c92712449$var$qh,
                overflow: $0c04710c92712449$var$rh
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0c04710c92712449$var$Ah(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0c04710c92712449$var$wh = a, $0c04710c92712449$var$xh = null, !0) : !1;
        default:
            return !1;
    }
}
function $0c04710c92712449$var$Ch(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0c04710c92712449$var$Dh(a) {
    if ($0c04710c92712449$var$K) {
        var b = a.type;
        var c = a.pendingProps;
        if ("link" === b) c = "stylesheet" === c.rel && "string" !== typeof c.precedence ? !0 : !1;
        else if ("script" === b) {
            b = c.onLoad;
            var d = c.onError;
            c = !(c.async && (b || d));
        } else c = !0;
        if (c) {
            if (c = $0c04710c92712449$var$xh) {
                if (b = c, !$0c04710c92712449$var$Bh(a, c)) {
                    if ($0c04710c92712449$var$Ch(a)) throw Error($0c04710c92712449$var$q(418));
                    c = $0c04710c92712449$var$Qg(b.nextSibling);
                    d = $0c04710c92712449$var$wh;
                    c && $0c04710c92712449$var$Bh(a, c) ? $0c04710c92712449$var$zh(d, b) : (a.flags = a.flags & -4097 | 2, $0c04710c92712449$var$K = !1, $0c04710c92712449$var$wh = a);
                }
            } else {
                if ($0c04710c92712449$var$Ch(a)) throw Error($0c04710c92712449$var$q(418));
                a.flags = a.flags & -4097 | 2;
                $0c04710c92712449$var$K = !1;
                $0c04710c92712449$var$wh = a;
            }
        } else a.flags = a.flags & -4097 | 2, $0c04710c92712449$var$K = !1, $0c04710c92712449$var$wh = a;
    }
}
function $0c04710c92712449$var$Eh(a) {
    var b = a.stateNode, c = a.type, d = a.memoizedProps;
    b[$0c04710c92712449$var$ea] = a;
    b[$0c04710c92712449$var$fa] = d;
    var e = 0 !== (a.mode & 1);
    switch(c){
        case "dialog":
            $0c04710c92712449$var$H("cancel", b);
            $0c04710c92712449$var$H("close", b);
            break;
        case "iframe":
        case "object":
        case "embed":
            $0c04710c92712449$var$H("load", b);
            break;
        case "video":
        case "audio":
            for(var f = 0; f < $0c04710c92712449$var$Ff.length; f++)$0c04710c92712449$var$H($0c04710c92712449$var$Ff[f], b);
            break;
        case "source":
            $0c04710c92712449$var$H("error", b);
            break;
        case "img":
        case "image":
        case "link":
            $0c04710c92712449$var$H("error", b);
            $0c04710c92712449$var$H("load", b);
            break;
        case "details":
            $0c04710c92712449$var$H("toggle", b);
            break;
        case "input":
            $0c04710c92712449$var$vb(b, d);
            $0c04710c92712449$var$H("invalid", b);
            break;
        case "select":
            b._wrapperState = {
                wasMultiple: !!d.multiple
            };
            $0c04710c92712449$var$H("invalid", b);
            break;
        case "textarea":
            $0c04710c92712449$var$Db(b, d), $0c04710c92712449$var$H("invalid", b);
    }
    $0c04710c92712449$var$Rb(c, d);
    f = null;
    for(var g in d)if (d.hasOwnProperty(g)) {
        var h = d[g];
        "children" === g ? "string" === typeof h ? b.textContent !== h && (!0 !== d.suppressHydrationWarning && $0c04710c92712449$var$Sf(b.textContent, h, e), f = [
            "children",
            h
        ]) : "number" === typeof h && b.textContent !== "" + h && (!0 !== d.suppressHydrationWarning && $0c04710c92712449$var$Sf(b.textContent, h, e), f = [
            "children",
            "" + h
        ]) : $0c04710c92712449$var$va.hasOwnProperty(g) && null != h && "onScroll" === g && $0c04710c92712449$var$H("scroll", b);
    }
    switch(c){
        case "input":
            $0c04710c92712449$var$rb(b);
            $0c04710c92712449$var$zb(b, d, !0);
            break;
        case "textarea":
            $0c04710c92712449$var$rb(b);
            $0c04710c92712449$var$Fb(b);
            break;
        case "select":
        case "option":
            break;
        default:
            "function" === typeof d.onClick && (b.onclick = $0c04710c92712449$var$Tf);
    }
    b = f;
    a.updateQueue = b;
    return null !== b ? !0 : !1;
}
function $0c04710c92712449$var$Fh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag && 27 !== a.tag;)a = a.return;
    $0c04710c92712449$var$wh = a;
}
function $0c04710c92712449$var$Gh(a) {
    if (a !== $0c04710c92712449$var$wh) return !1;
    if (!$0c04710c92712449$var$K) return $0c04710c92712449$var$Fh(a), $0c04710c92712449$var$K = !0, !1;
    var b = !1;
    3 === a.tag || 27 === a.tag || 5 === a.tag && $0c04710c92712449$var$Hg(a.type, a.memoizedProps) || (b = !0);
    if (b && (b = $0c04710c92712449$var$xh)) {
        if ($0c04710c92712449$var$Ch(a)) throw $0c04710c92712449$var$Hh(), Error($0c04710c92712449$var$q(418));
        for(; b;)$0c04710c92712449$var$zh(a, b), b = $0c04710c92712449$var$Qg(b.nextSibling);
    }
    $0c04710c92712449$var$Fh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0c04710c92712449$var$q(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0c04710c92712449$var$xh = $0c04710c92712449$var$Qg(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0c04710c92712449$var$xh = null;
        }
    } else $0c04710c92712449$var$xh = $0c04710c92712449$var$wh ? $0c04710c92712449$var$Qg(a.stateNode.nextSibling) : null;
    return !0;
}
function $0c04710c92712449$var$Hh() {
    for(var a = $0c04710c92712449$var$xh; a;)a = $0c04710c92712449$var$Qg(a.nextSibling);
}
function $0c04710c92712449$var$Ih() {
    $0c04710c92712449$var$xh = $0c04710c92712449$var$wh = null;
    $0c04710c92712449$var$K = !1;
}
function $0c04710c92712449$var$Jh(a) {
    null === $0c04710c92712449$var$yh ? $0c04710c92712449$var$yh = [
        a
    ] : $0c04710c92712449$var$yh.push(a);
}
var $0c04710c92712449$var$Kh = [], $0c04710c92712449$var$Lh = 0, $0c04710c92712449$var$Mh = 0;
function $0c04710c92712449$var$Nh() {
    for(var a = $0c04710c92712449$var$Lh, b = $0c04710c92712449$var$Mh = $0c04710c92712449$var$Lh = 0; b < a;){
        var c = $0c04710c92712449$var$Kh[b];
        $0c04710c92712449$var$Kh[b++] = null;
        var d = $0c04710c92712449$var$Kh[b];
        $0c04710c92712449$var$Kh[b++] = null;
        var e = $0c04710c92712449$var$Kh[b];
        $0c04710c92712449$var$Kh[b++] = null;
        var f = $0c04710c92712449$var$Kh[b];
        $0c04710c92712449$var$Kh[b++] = null;
        if (null !== d && null !== e) {
            var g = d.pending;
            null === g ? e.next = e : (e.next = g.next, g.next = e);
            d.pending = e;
        }
        0 !== f && $0c04710c92712449$var$Oh(c, e, f);
    }
}
function $0c04710c92712449$var$Ph(a, b, c, d) {
    $0c04710c92712449$var$Kh[$0c04710c92712449$var$Lh++] = a;
    $0c04710c92712449$var$Kh[$0c04710c92712449$var$Lh++] = b;
    $0c04710c92712449$var$Kh[$0c04710c92712449$var$Lh++] = c;
    $0c04710c92712449$var$Kh[$0c04710c92712449$var$Lh++] = d;
    $0c04710c92712449$var$Mh |= d;
    a.lanes |= d;
    a = a.alternate;
    null !== a && (a.lanes |= d);
}
function $0c04710c92712449$var$Qh(a, b) {
    $0c04710c92712449$var$Ph(a, null, null, b);
    return $0c04710c92712449$var$Rh(a);
}
function $0c04710c92712449$var$Oh(a, b, c) {
    a.lanes |= c;
    var d = a.alternate;
    null !== d && (d.lanes |= c);
    for(var e = !1, f = a.return; null !== f;)f.childLanes |= c, d = f.alternate, null !== d && (d.childLanes |= c), 22 === f.tag && (a = f.stateNode, null === a || a._visibility & 1 || (e = !0)), a = f, f = f.return;
    e && null !== b && 3 === a.tag && (f = a.stateNode, e = 31 - $0c04710c92712449$var$Jc(c), f = f.hiddenUpdates, a = f[e], null === a ? f[e] = [
        b
    ] : a.push(b), b.lane = c | 1073741824);
}
function $0c04710c92712449$var$Rh(a) {
    if (50 < $0c04710c92712449$var$Sh) throw $0c04710c92712449$var$Sh = 0, $0c04710c92712449$var$Th = null, Error($0c04710c92712449$var$q(185));
    for(var b = a.return; null !== b;)a = b, b = a.return;
    return 3 === a.tag ? a.stateNode : null;
}
var $0c04710c92712449$var$Uh = !1;
function $0c04710c92712449$var$Vh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $0c04710c92712449$var$Wh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        callbacks: null
    });
}
function $0c04710c92712449$var$Xh(a) {
    return {
        lane: a,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0c04710c92712449$var$Yh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0c04710c92712449$var$L & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        b = $0c04710c92712449$var$Rh(a);
        $0c04710c92712449$var$Oh(a, null, c);
        return b;
    }
    $0c04710c92712449$var$Ph(a, d, b, c);
    return $0c04710c92712449$var$Rh(a);
}
function $0c04710c92712449$var$Zh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 8388480))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0c04710c92712449$var$Xc(a, c);
    }
}
function $0c04710c92712449$var$$h(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: null,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            callbacks: d.callbacks
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0c04710c92712449$var$ai(a, b, c, d) {
    var e = a.updateQueue;
    $0c04710c92712449$var$Uh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var l = h, n = l.next;
        l.next = null;
        null === g ? f = n : g.next = n;
        g = l;
        var w = a.alternate;
        null !== w && (w = w.updateQueue, h = w.lastBaseUpdate, h !== g && (null === h ? w.firstBaseUpdate = n : h.next = n, w.lastBaseUpdate = l));
    }
    if (null !== f) {
        var t = e.baseState;
        g = 0;
        w = n = l = null;
        h = f;
        do {
            var u = h.lane & -1073741825, v = u !== h.lane;
            if (v ? ($0c04710c92712449$var$M & u) === u : (d & u) === u) {
                null !== w && (w = w.next = {
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var y = a, C = h;
                    u = b;
                    var R = c;
                    switch(C.tag){
                        case 1:
                            y = C.payload;
                            if ("function" === typeof y) {
                                t = y.call(R, t, u);
                                break a;
                            }
                            t = y;
                            break a;
                        case 3:
                            y.flags = y.flags & -65537 | 128;
                        case 0:
                            y = C.payload;
                            u = "function" === typeof y ? y.call(R, t, u) : y;
                            if (null === u || void 0 === u) break a;
                            t = $0c04710c92712449$var$D({}, t, u);
                            break a;
                        case 2:
                            $0c04710c92712449$var$Uh = !0;
                    }
                }
                u = h.callback;
                null !== u && (a.flags |= 64, v && (a.flags |= 8192), v = e.callbacks, null === v ? e.callbacks = [
                    u
                ] : v.push(u));
            } else v = {
                lane: u,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === w ? (n = w = v, l = t) : w = w.next = v, g |= u;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else v = h, h = v.next, v.next = null, e.lastBaseUpdate = v, e.shared.pending = null;
            }
        }while (1);
        null === w && (l = t);
        e.baseState = l;
        e.firstBaseUpdate = n;
        e.lastBaseUpdate = w;
        null === f && (e.shared.lanes = 0);
        $0c04710c92712449$var$bi |= g;
        a.lanes = g;
        a.memoizedState = t;
    }
}
function $0c04710c92712449$var$ci(a, b) {
    if ("function" !== typeof a) throw Error($0c04710c92712449$var$q(191, a));
    a.call(b);
}
function $0c04710c92712449$var$di(a, b) {
    var c = a.callbacks;
    if (null !== c) for(a.callbacks = null, a = 0; a < c.length; a++)$0c04710c92712449$var$ci(c[a], b);
}
function $0c04710c92712449$var$ei(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0c04710c92712449$var$q(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0c04710c92712449$var$q(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(g) {
                var h = e.refs;
                null === g ? delete h[f] : h[f] = g;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0c04710c92712449$var$q(284));
        if (!c._owner) throw Error($0c04710c92712449$var$q(290, a));
    }
    return a;
}
function $0c04710c92712449$var$fi(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0c04710c92712449$var$q(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0c04710c92712449$var$gi(a) {
    var b = a._init;
    return b(a._payload);
}
function $0c04710c92712449$var$hi(a) {
    function b(m, k) {
        if (a) {
            var p = m.deletions;
            null === p ? (m.deletions = [
                k
            ], m.flags |= 16) : p.push(k);
        }
    }
    function c(m, k) {
        if (!a) return null;
        for(; null !== k;)b(m, k), k = k.sibling;
        return null;
    }
    function d(m, k) {
        for(m = new Map; null !== k;)null !== k.key ? m.set(k.key, k) : m.set(k.index, k), k = k.sibling;
        return m;
    }
    function e(m, k) {
        m = $0c04710c92712449$var$ii(m, k);
        m.index = 0;
        m.sibling = null;
        return m;
    }
    function f(m, k, p) {
        m.index = p;
        if (!a) return m.flags |= 1048576, k;
        p = m.alternate;
        if (null !== p) return p = p.index, p < k ? (m.flags |= 16777218, k) : p;
        m.flags |= 16777218;
        return k;
    }
    function g(m) {
        a && null === m.alternate && (m.flags |= 16777218);
        return m;
    }
    function h(m, k, p, r) {
        if (null === k || 6 !== k.tag) return k = $0c04710c92712449$var$ji(p, m.mode, r), k.return = m, k;
        k = e(k, p);
        k.return = m;
        return k;
    }
    function l(m, k, p, r) {
        var x = p.type;
        if (x === $0c04710c92712449$var$Pa) return w(m, k, p.props.children, r, p.key);
        if (null !== k && (k.elementType === x || "object" === typeof x && null !== x && x.$$typeof === $0c04710c92712449$var$Za && $0c04710c92712449$var$gi(x) === k.type)) return r = e(k, p.props), r.ref = $0c04710c92712449$var$ei(m, k, p), r.return = m, r;
        r = $0c04710c92712449$var$ki(p.type, p.key, p.props, null, m.mode, r);
        r.ref = $0c04710c92712449$var$ei(m, k, p);
        r.return = m;
        return r;
    }
    function n(m, k, p, r) {
        if (null === k || 4 !== k.tag || k.stateNode.containerInfo !== p.containerInfo || k.stateNode.implementation !== p.implementation) return k = $0c04710c92712449$var$li(p, m.mode, r), k.return = m, k;
        k = e(k, p.children || []);
        k.return = m;
        return k;
    }
    function w(m, k, p, r, x) {
        if (null === k || 7 !== k.tag) return k = $0c04710c92712449$var$mi(p, m.mode, r, x), k.return = m, k;
        k = e(k, p);
        k.return = m;
        return k;
    }
    function t(m, k, p) {
        if ("string" === typeof k && "" !== k || "number" === typeof k) return k = $0c04710c92712449$var$ji("" + k, m.mode, p), k.return = m, k;
        if ("object" === typeof k && null !== k) {
            switch(k.$$typeof){
                case $0c04710c92712449$var$Na:
                    return p = $0c04710c92712449$var$ki(k.type, k.key, k.props, null, m.mode, p), p.ref = $0c04710c92712449$var$ei(m, null, k), p.return = m, p;
                case $0c04710c92712449$var$Oa:
                    return k = $0c04710c92712449$var$li(k, m.mode, p), k.return = m, k;
                case $0c04710c92712449$var$Za:
                    var r = k._init;
                    return t(m, r(k._payload), p);
            }
            if ($0c04710c92712449$var$Ab(k) || $0c04710c92712449$var$gb(k)) return k = $0c04710c92712449$var$mi(k, m.mode, p, null), k.return = m, k;
            $0c04710c92712449$var$fi(m, k);
        }
        return null;
    }
    function u(m, k, p, r) {
        var x = null !== k ? k.key : null;
        if ("string" === typeof p && "" !== p || "number" === typeof p) return null !== x ? null : h(m, k, "" + p, r);
        if ("object" === typeof p && null !== p) {
            switch(p.$$typeof){
                case $0c04710c92712449$var$Na:
                    return p.key === x ? l(m, k, p, r) : null;
                case $0c04710c92712449$var$Oa:
                    return p.key === x ? n(m, k, p, r) : null;
                case $0c04710c92712449$var$Za:
                    return x = p._init, u(m, k, x(p._payload), r);
            }
            if ($0c04710c92712449$var$Ab(p) || $0c04710c92712449$var$gb(p)) return null !== x ? null : w(m, k, p, r, null);
            $0c04710c92712449$var$fi(m, p);
        }
        return null;
    }
    function v(m, k, p, r, x) {
        if ("string" === typeof r && "" !== r || "number" === typeof r) return m = m.get(p) || null, h(k, m, "" + r, x);
        if ("object" === typeof r && null !== r) {
            switch(r.$$typeof){
                case $0c04710c92712449$var$Na:
                    return m = m.get(null === r.key ? p : r.key) || null, l(k, m, r, x);
                case $0c04710c92712449$var$Oa:
                    return m = m.get(null === r.key ? p : r.key) || null, n(k, m, r, x);
                case $0c04710c92712449$var$Za:
                    var A = r._init;
                    return v(m, k, p, A(r._payload), x);
            }
            if ($0c04710c92712449$var$Ab(r) || $0c04710c92712449$var$gb(r)) return m = m.get(p) || null, w(k, m, r, x, null);
            $0c04710c92712449$var$fi(k, r);
        }
        return null;
    }
    function y(m, k, p, r) {
        for(var x = null, A = null, z = k, B = k = 0, Z = null; null !== z && B < p.length; B++){
            z.index > B ? (Z = z, z = null) : Z = z.sibling;
            var F = u(m, z, p[B], r);
            if (null === F) {
                null === z && (z = Z);
                break;
            }
            a && z && null === F.alternate && b(m, z);
            k = f(F, k, B);
            null === A ? x = F : A.sibling = F;
            A = F;
            z = Z;
        }
        if (B === p.length) return c(m, z), $0c04710c92712449$var$K && $0c04710c92712449$var$sh(m, B), x;
        if (null === z) {
            for(; B < p.length; B++)z = t(m, p[B], r), null !== z && (k = f(z, k, B), null === A ? x = z : A.sibling = z, A = z);
            $0c04710c92712449$var$K && $0c04710c92712449$var$sh(m, B);
            return x;
        }
        for(z = d(m, z); B < p.length; B++)Z = v(z, m, B, p[B], r), null !== Z && (a && null !== Z.alternate && z.delete(null === Z.key ? B : Z.key), k = f(Z, k, B), null === A ? x = Z : A.sibling = Z, A = Z);
        a && z.forEach(function(Gb) {
            return b(m, Gb);
        });
        $0c04710c92712449$var$K && $0c04710c92712449$var$sh(m, B);
        return x;
    }
    function C(m, k, p, r) {
        var x = $0c04710c92712449$var$gb(p);
        if ("function" !== typeof x) throw Error($0c04710c92712449$var$q(150));
        p = x.call(p);
        if (null == p) throw Error($0c04710c92712449$var$q(151));
        for(var A = x = null, z = k, B = k = 0, Z = null, F = p.next(); null !== z && !F.done; B++, F = p.next()){
            z.index > B ? (Z = z, z = null) : Z = z.sibling;
            var Gb = u(m, z, F.value, r);
            if (null === Gb) {
                null === z && (z = Z);
                break;
            }
            a && z && null === Gb.alternate && b(m, z);
            k = f(Gb, k, B);
            null === A ? x = Gb : A.sibling = Gb;
            A = Gb;
            z = Z;
        }
        if (F.done) return c(m, z), $0c04710c92712449$var$K && $0c04710c92712449$var$sh(m, B), x;
        if (null === z) {
            for(; !F.done; B++, F = p.next())F = t(m, F.value, r), null !== F && (k = f(F, k, B), null === A ? x = F : A.sibling = F, A = F);
            $0c04710c92712449$var$K && $0c04710c92712449$var$sh(m, B);
            return x;
        }
        for(z = d(m, z); !F.done; B++, F = p.next())F = v(z, m, B, F.value, r), null !== F && (a && null !== F.alternate && z.delete(null === F.key ? B : F.key), k = f(F, k, B), null === A ? x = F : A.sibling = F, A = F);
        a && z.forEach(function(gn) {
            return b(m, gn);
        });
        $0c04710c92712449$var$K && $0c04710c92712449$var$sh(m, B);
        return x;
    }
    function R(m, k, p, r) {
        "object" === typeof p && null !== p && p.type === $0c04710c92712449$var$Pa && null === p.key && (p = p.props.children);
        if ("object" === typeof p && null !== p) {
            switch(p.$$typeof){
                case $0c04710c92712449$var$Na:
                    a: {
                        for(var x = p.key, A = k; null !== A;){
                            if (A.key === x) {
                                x = p.type;
                                if (x === $0c04710c92712449$var$Pa) {
                                    if (7 === A.tag) {
                                        c(m, A.sibling);
                                        k = e(A, p.props.children);
                                        k.return = m;
                                        m = k;
                                        break a;
                                    }
                                } else if (A.elementType === x || "object" === typeof x && null !== x && x.$$typeof === $0c04710c92712449$var$Za && $0c04710c92712449$var$gi(x) === A.type) {
                                    c(m, A.sibling);
                                    k = e(A, p.props);
                                    k.ref = $0c04710c92712449$var$ei(m, A, p);
                                    k.return = m;
                                    m = k;
                                    break a;
                                }
                                c(m, A);
                                break;
                            } else b(m, A);
                            A = A.sibling;
                        }
                        p.type === $0c04710c92712449$var$Pa ? (k = $0c04710c92712449$var$mi(p.props.children, m.mode, r, p.key), k.return = m, m = k) : (r = $0c04710c92712449$var$ki(p.type, p.key, p.props, null, m.mode, r), r.ref = $0c04710c92712449$var$ei(m, k, p), r.return = m, m = r);
                    }
                    return g(m);
                case $0c04710c92712449$var$Oa:
                    a: {
                        for(A = p.key; null !== k;){
                            if (k.key === A) {
                                if (4 === k.tag && k.stateNode.containerInfo === p.containerInfo && k.stateNode.implementation === p.implementation) {
                                    c(m, k.sibling);
                                    k = e(k, p.children || []);
                                    k.return = m;
                                    m = k;
                                    break a;
                                } else {
                                    c(m, k);
                                    break;
                                }
                            } else b(m, k);
                            k = k.sibling;
                        }
                        k = $0c04710c92712449$var$li(p, m.mode, r);
                        k.return = m;
                        m = k;
                    }
                    return g(m);
                case $0c04710c92712449$var$Za:
                    return A = p._init, R(m, k, A(p._payload), r);
            }
            if ($0c04710c92712449$var$Ab(p)) return y(m, k, p, r);
            if ($0c04710c92712449$var$gb(p)) return C(m, k, p, r);
            $0c04710c92712449$var$fi(m, p);
        }
        return "string" === typeof p && "" !== p || "number" === typeof p ? (p = "" + p, null !== k && 6 === k.tag ? (c(m, k.sibling), k = e(k, p), k.return = m, m = k) : (c(m, k), k = $0c04710c92712449$var$ji(p, m.mode, r), k.return = m, m = k), g(m)) : c(m, k);
    }
    return R;
}
var $0c04710c92712449$var$ni = $0c04710c92712449$var$hi(!0), $0c04710c92712449$var$oi = $0c04710c92712449$var$hi(!1), $0c04710c92712449$var$pi = $0c04710c92712449$var$Zf(null), $0c04710c92712449$var$qi = $0c04710c92712449$var$Zf(0);
function $0c04710c92712449$var$ri(a, b) {
    a = $0c04710c92712449$var$si;
    $0c04710c92712449$var$J($0c04710c92712449$var$qi, a);
    $0c04710c92712449$var$J($0c04710c92712449$var$pi, b);
    $0c04710c92712449$var$si = a | b.baseLanes;
}
function $0c04710c92712449$var$ti() {
    $0c04710c92712449$var$J($0c04710c92712449$var$qi, $0c04710c92712449$var$si);
    $0c04710c92712449$var$J($0c04710c92712449$var$pi, $0c04710c92712449$var$pi.current);
}
function $0c04710c92712449$var$ui() {
    $0c04710c92712449$var$si = $0c04710c92712449$var$qi.current;
    $0c04710c92712449$var$I($0c04710c92712449$var$pi);
    $0c04710c92712449$var$I($0c04710c92712449$var$qi);
}
var $0c04710c92712449$var$vi = $0c04710c92712449$var$Zf(null), $0c04710c92712449$var$wi = null;
function $0c04710c92712449$var$xi(a) {
    var b = a.alternate;
    $0c04710c92712449$var$J($0c04710c92712449$var$vi, a);
    null === $0c04710c92712449$var$wi && (null === b || null !== $0c04710c92712449$var$pi.current ? $0c04710c92712449$var$wi = a : null !== b.memoizedState && ($0c04710c92712449$var$wi = a));
}
function $0c04710c92712449$var$yi(a) {
    if (22 === a.tag) {
        if ($0c04710c92712449$var$J($0c04710c92712449$var$vi, a), null === $0c04710c92712449$var$wi) {
            var b = a.alternate;
            null !== b && null !== b.memoizedState && ($0c04710c92712449$var$wi = a);
        }
    } else $0c04710c92712449$var$zi();
}
function $0c04710c92712449$var$zi() {
    $0c04710c92712449$var$J($0c04710c92712449$var$vi, $0c04710c92712449$var$vi.current);
}
function $0c04710c92712449$var$Ai(a) {
    $0c04710c92712449$var$I($0c04710c92712449$var$vi);
    $0c04710c92712449$var$wi === a && ($0c04710c92712449$var$wi = null);
}
var $0c04710c92712449$var$Bi = $0c04710c92712449$var$Zf(0);
function $0c04710c92712449$var$Ci(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0c04710c92712449$var$Di = [];
function $0c04710c92712449$var$Ei() {
    for(var a = 0; a < $0c04710c92712449$var$Di.length; a++)$0c04710c92712449$var$Di[a]._workInProgressVersionPrimary = null;
    $0c04710c92712449$var$Di.length = 0;
}
var $0c04710c92712449$var$Fi = Error($0c04710c92712449$var$q(460));
function $0c04710c92712449$var$Gi(a) {
    a = a.status;
    return "fulfilled" === a || "rejected" === a;
}
function $0c04710c92712449$var$Hi() {}
function $0c04710c92712449$var$Ii(a, b, c) {
    c = a[c];
    void 0 === c ? a.push(b) : c !== b && (b.then($0c04710c92712449$var$Hi, $0c04710c92712449$var$Hi), b = c);
    switch(b.status){
        case "fulfilled":
            return b.value;
        case "rejected":
            throw b.reason;
        default:
            "string" === typeof b.status ? b.then($0c04710c92712449$var$Hi, $0c04710c92712449$var$Hi) : (a = b, a.status = "pending", a.then(function(d) {
                if ("pending" === b.status) {
                    var e = b;
                    e.status = "fulfilled";
                    e.value = d;
                }
            }, function(d) {
                if ("pending" === b.status) {
                    var e = b;
                    e.status = "rejected";
                    e.reason = d;
                }
            }));
            switch(b.status){
                case "fulfilled":
                    return b.value;
                case "rejected":
                    throw b.reason;
            }
            $0c04710c92712449$var$Ji = b;
            throw $0c04710c92712449$var$Fi;
    }
}
var $0c04710c92712449$var$Ji = null, $0c04710c92712449$var$Ki = $0c04710c92712449$var$Ma.ReactCurrentDispatcher, $0c04710c92712449$var$Li = $0c04710c92712449$var$Ma.ReactCurrentBatchConfig, $0c04710c92712449$var$Mi = 0, $0c04710c92712449$var$N = null, $0c04710c92712449$var$O = null, $0c04710c92712449$var$P = null, $0c04710c92712449$var$Ni = !1, $0c04710c92712449$var$Oi = !1, $0c04710c92712449$var$Pi = !1, $0c04710c92712449$var$Qi = 0, $0c04710c92712449$var$Ri = 0, $0c04710c92712449$var$Si = null, $0c04710c92712449$var$Ti = 0;
function $0c04710c92712449$var$Q() {
    throw Error($0c04710c92712449$var$q(321));
}
function $0c04710c92712449$var$Ui(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0c04710c92712449$var$af(a[c], b[c])) return !1;
    return !0;
}
function $0c04710c92712449$var$Vi(a, b, c, d, e, f) {
    $0c04710c92712449$var$Mi = f;
    $0c04710c92712449$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0c04710c92712449$var$Ki.current = null === a || null === a.memoizedState ? $0c04710c92712449$var$Wi : $0c04710c92712449$var$Xi;
    $0c04710c92712449$var$Pi = !1;
    a = c(d, e);
    $0c04710c92712449$var$Pi = !1;
    $0c04710c92712449$var$Oi && (a = $0c04710c92712449$var$Yi(b, c, d, e));
    $0c04710c92712449$var$Zi();
    return a;
}
function $0c04710c92712449$var$Zi() {
    $0c04710c92712449$var$Ki.current = $0c04710c92712449$var$$i;
    var a = null !== $0c04710c92712449$var$O && null !== $0c04710c92712449$var$O.next;
    $0c04710c92712449$var$Mi = 0;
    $0c04710c92712449$var$P = $0c04710c92712449$var$O = $0c04710c92712449$var$N = null;
    $0c04710c92712449$var$Ni = !1;
    $0c04710c92712449$var$Ri = 0;
    $0c04710c92712449$var$Si = null;
    if (a) throw Error($0c04710c92712449$var$q(300));
}
function $0c04710c92712449$var$Yi(a, b, c, d) {
    var e = 0;
    do {
        $0c04710c92712449$var$Oi && ($0c04710c92712449$var$Si = null);
        $0c04710c92712449$var$Ri = 0;
        $0c04710c92712449$var$Oi = !1;
        if (25 <= e) throw Error($0c04710c92712449$var$q(301));
        e += 1;
        $0c04710c92712449$var$P = $0c04710c92712449$var$O = null;
        a.updateQueue = null;
        $0c04710c92712449$var$Ki.current = $0c04710c92712449$var$aj;
        var f = b(c, d);
    }while ($0c04710c92712449$var$Oi);
    return f;
}
function $0c04710c92712449$var$bj() {
    var a = 0 !== $0c04710c92712449$var$Qi;
    $0c04710c92712449$var$Qi = 0;
    return a;
}
function $0c04710c92712449$var$cj(a, b, c) {
    b.updateQueue = a.updateQueue;
    b.flags &= -2053;
    a.lanes &= ~c;
}
function $0c04710c92712449$var$dj() {
    if ($0c04710c92712449$var$Ni) {
        for(var a = $0c04710c92712449$var$N.memoizedState; null !== a;){
            var b = a.queue;
            null !== b && (b.pending = null);
            a = a.next;
        }
        $0c04710c92712449$var$Ni = !1;
    }
    $0c04710c92712449$var$Mi = 0;
    $0c04710c92712449$var$P = $0c04710c92712449$var$O = $0c04710c92712449$var$N = null;
    $0c04710c92712449$var$Oi = !1;
    $0c04710c92712449$var$Ri = $0c04710c92712449$var$Qi = 0;
    $0c04710c92712449$var$Si = null;
}
function $0c04710c92712449$var$ej() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0c04710c92712449$var$P ? $0c04710c92712449$var$N.memoizedState = $0c04710c92712449$var$P = a : $0c04710c92712449$var$P = $0c04710c92712449$var$P.next = a;
    return $0c04710c92712449$var$P;
}
function $0c04710c92712449$var$fj() {
    if (null === $0c04710c92712449$var$O) {
        var a = $0c04710c92712449$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0c04710c92712449$var$O.next;
    var b = null === $0c04710c92712449$var$P ? $0c04710c92712449$var$N.memoizedState : $0c04710c92712449$var$P.next;
    if (null !== b) $0c04710c92712449$var$P = b, $0c04710c92712449$var$O = a;
    else {
        if (null === a) {
            if (null === $0c04710c92712449$var$N.alternate) throw Error($0c04710c92712449$var$q(467));
            throw Error($0c04710c92712449$var$q(310));
        }
        $0c04710c92712449$var$O = a;
        a = {
            memoizedState: $0c04710c92712449$var$O.memoizedState,
            baseState: $0c04710c92712449$var$O.baseState,
            baseQueue: $0c04710c92712449$var$O.baseQueue,
            queue: $0c04710c92712449$var$O.queue,
            next: null
        };
        null === $0c04710c92712449$var$P ? $0c04710c92712449$var$N.memoizedState = $0c04710c92712449$var$P = a : $0c04710c92712449$var$P = $0c04710c92712449$var$P.next = a;
    }
    return $0c04710c92712449$var$P;
}
var $0c04710c92712449$var$gj;
$0c04710c92712449$var$gj = function() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
};
function $0c04710c92712449$var$hj(a) {
    if (null !== a && "object" === typeof a) {
        if ("function" === typeof a.then) {
            var b = $0c04710c92712449$var$Ri;
            $0c04710c92712449$var$Ri += 1;
            null === $0c04710c92712449$var$Si && ($0c04710c92712449$var$Si = []);
            a = $0c04710c92712449$var$Ii($0c04710c92712449$var$Si, a, b);
            null === $0c04710c92712449$var$N.alternate && (null === $0c04710c92712449$var$P ? null === $0c04710c92712449$var$N.memoizedState : null === $0c04710c92712449$var$P.next) && ($0c04710c92712449$var$Ki.current = $0c04710c92712449$var$Wi);
            return a;
        }
        if (a.$$typeof === $0c04710c92712449$var$Ta || a.$$typeof === $0c04710c92712449$var$Ua) return $0c04710c92712449$var$ij(a);
    }
    throw Error($0c04710c92712449$var$q(438, String(a)));
}
function $0c04710c92712449$var$jj(a) {
    var b = null, c = $0c04710c92712449$var$N.updateQueue;
    null !== c && (b = c.memoCache);
    if (null == b) {
        var d = $0c04710c92712449$var$N.alternate;
        null !== d && (d = d.updateQueue, null !== d && (d = d.memoCache, null != d && (b = {
            data: d.data.map(function(e) {
                return e.slice();
            }),
            index: 0
        })));
    }
    null == b && (b = {
        data: [],
        index: 0
    });
    null === c && (c = $0c04710c92712449$var$gj(), $0c04710c92712449$var$N.updateQueue = c);
    c.memoCache = b;
    c = b.data[b.index];
    if (void 0 === c) for(c = b.data[b.index] = Array(a), d = 0; d < a; d++)c[d] = $0c04710c92712449$var$eb;
    b.index++;
    return c;
}
function $0c04710c92712449$var$kj(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0c04710c92712449$var$lj(a) {
    var b = $0c04710c92712449$var$fj(), c = b.queue;
    if (null === c) throw Error($0c04710c92712449$var$q(311));
    c.lastRenderedReducer = a;
    var d = $0c04710c92712449$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, l = null, n = f;
        do {
            var w = n.lane & -1073741825;
            if (w !== n.lane ? ($0c04710c92712449$var$M & w) === w : ($0c04710c92712449$var$Mi & w) === w) null !== l && (l = l.next = {
                lane: 0,
                action: n.action,
                hasEagerState: n.hasEagerState,
                eagerState: n.eagerState,
                next: null
            }), w = n.action, $0c04710c92712449$var$Pi && a(d, w), d = n.hasEagerState ? n.eagerState : a(d, w);
            else {
                var t = {
                    lane: w,
                    action: n.action,
                    hasEagerState: n.hasEagerState,
                    eagerState: n.eagerState,
                    next: null
                };
                null === l ? (h = l = t, g = d) : l = l.next = t;
                $0c04710c92712449$var$N.lanes |= w;
                $0c04710c92712449$var$bi |= w;
            }
            n = n.next;
        }while (null !== n && n !== f);
        null === l ? g = d : l.next = h;
        $0c04710c92712449$var$af(d, b.memoizedState) || ($0c04710c92712449$var$mj = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = l;
        c.lastRenderedState = d;
    }
    null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0c04710c92712449$var$nj(a) {
    var b = $0c04710c92712449$var$fj(), c = b.queue;
    if (null === c) throw Error($0c04710c92712449$var$q(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0c04710c92712449$var$af(f, b.memoizedState) || ($0c04710c92712449$var$mj = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0c04710c92712449$var$oj() {}
function $0c04710c92712449$var$pj(a, b) {
    var c = $0c04710c92712449$var$N, d = $0c04710c92712449$var$fj(), e = b(), f = !$0c04710c92712449$var$af(($0c04710c92712449$var$O || d).memoizedState, e);
    f && (d.memoizedState = e, $0c04710c92712449$var$mj = !0);
    d = d.queue;
    $0c04710c92712449$var$qj($0c04710c92712449$var$rj.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0c04710c92712449$var$P && $0c04710c92712449$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0c04710c92712449$var$sj(9, $0c04710c92712449$var$tj.bind(null, c, d, e, b), void 0, null);
        if (null === $0c04710c92712449$var$S) throw Error($0c04710c92712449$var$q(349));
        0 !== ($0c04710c92712449$var$Mi & 60) || $0c04710c92712449$var$uj(c, b, e);
    }
    return e;
}
function $0c04710c92712449$var$uj(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0c04710c92712449$var$N.updateQueue;
    null === b ? (b = $0c04710c92712449$var$gj(), $0c04710c92712449$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0c04710c92712449$var$tj(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0c04710c92712449$var$vj(b) && $0c04710c92712449$var$wj(a);
}
function $0c04710c92712449$var$rj(a, b, c) {
    return c(function() {
        $0c04710c92712449$var$vj(b) && $0c04710c92712449$var$wj(a);
    });
}
function $0c04710c92712449$var$vj(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0c04710c92712449$var$af(a, c);
    } catch (d) {
        return !0;
    }
}
function $0c04710c92712449$var$wj(a) {
    var b = $0c04710c92712449$var$Qh(a, 2);
    null !== b && $0c04710c92712449$var$xj(b, a, 2, -1);
}
function $0c04710c92712449$var$yj(a) {
    var b = $0c04710c92712449$var$ej();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0c04710c92712449$var$kj,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0c04710c92712449$var$zj.bind(null, $0c04710c92712449$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0c04710c92712449$var$sj(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0c04710c92712449$var$N.updateQueue;
    null === b ? (b = $0c04710c92712449$var$gj(), $0c04710c92712449$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0c04710c92712449$var$Aj() {
    return $0c04710c92712449$var$fj().memoizedState;
}
function $0c04710c92712449$var$Bj(a, b, c, d) {
    var e = $0c04710c92712449$var$ej();
    $0c04710c92712449$var$N.flags |= a;
    e.memoizedState = $0c04710c92712449$var$sj(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0c04710c92712449$var$Cj(a, b, c, d) {
    var e = $0c04710c92712449$var$fj();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0c04710c92712449$var$O) {
        var g = $0c04710c92712449$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0c04710c92712449$var$Ui(d, g.deps)) {
            e.memoizedState = $0c04710c92712449$var$sj(b, c, f, d);
            return;
        }
    }
    $0c04710c92712449$var$N.flags |= a;
    e.memoizedState = $0c04710c92712449$var$sj(1 | b, c, f, d);
}
function $0c04710c92712449$var$Dj(a, b) {
    $0c04710c92712449$var$Bj(8390656, 8, a, b);
}
function $0c04710c92712449$var$qj(a, b) {
    $0c04710c92712449$var$Cj(2048, 8, a, b);
}
function $0c04710c92712449$var$Ej(a) {
    $0c04710c92712449$var$N.flags |= 4;
    var b = $0c04710c92712449$var$N.updateQueue;
    if (null === b) b = $0c04710c92712449$var$gj(), $0c04710c92712449$var$N.updateQueue = b, b.events = [
        a
    ];
    else {
        var c = b.events;
        null === c ? b.events = [
            a
        ] : c.push(a);
    }
}
function $0c04710c92712449$var$Fj(a) {
    var b = $0c04710c92712449$var$fj().memoizedState;
    $0c04710c92712449$var$Ej({
        ref: b,
        nextImpl: a
    });
    return function() {
        if (0 !== ($0c04710c92712449$var$L & 2)) throw Error($0c04710c92712449$var$q(440));
        return b.impl.apply(void 0, arguments);
    };
}
function $0c04710c92712449$var$Gj(a, b) {
    return $0c04710c92712449$var$Cj(4, 2, a, b);
}
function $0c04710c92712449$var$Hj(a, b) {
    return $0c04710c92712449$var$Cj(4, 4, a, b);
}
function $0c04710c92712449$var$Ij(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0c04710c92712449$var$Jj(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    $0c04710c92712449$var$Cj(4, 4, $0c04710c92712449$var$Ij.bind(null, b, a), c);
}
function $0c04710c92712449$var$Kj() {}
function $0c04710c92712449$var$Lj(a, b) {
    var c = $0c04710c92712449$var$fj();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== b && $0c04710c92712449$var$Ui(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0c04710c92712449$var$Mj(a, b) {
    var c = $0c04710c92712449$var$fj();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== b && $0c04710c92712449$var$Ui(b, d[1])) return d[0];
    $0c04710c92712449$var$Pi && a();
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0c04710c92712449$var$Nj(a, b, c) {
    if (0 === ($0c04710c92712449$var$Mi & 42)) return a.baseState && (a.baseState = !1, $0c04710c92712449$var$mj = !0), a.memoizedState = c;
    $0c04710c92712449$var$af(c, b) || (c = $0c04710c92712449$var$Tc(), $0c04710c92712449$var$N.lanes |= c, $0c04710c92712449$var$bi |= c, a.baseState = !0);
    return b;
}
function $0c04710c92712449$var$Oj(a, b) {
    var c = $0c04710c92712449$var$G;
    $0c04710c92712449$var$G = 0 !== c && 8 > c ? c : 8;
    a(!0);
    var d = $0c04710c92712449$var$Li.transition;
    $0c04710c92712449$var$Li.transition = {};
    try {
        a(!1), b();
    } finally{
        $0c04710c92712449$var$G = c, $0c04710c92712449$var$Li.transition = d;
    }
}
function $0c04710c92712449$var$Pj() {
    return $0c04710c92712449$var$fj().memoizedState;
}
function $0c04710c92712449$var$Qj() {
    return $0c04710c92712449$var$fj().memoizedState;
}
function $0c04710c92712449$var$Rj(a, b, c) {
    for(var d = a.return; null !== d;){
        switch(d.tag){
            case 24:
            case 3:
                var e = $0c04710c92712449$var$Sj(d);
                a = $0c04710c92712449$var$Xh(e);
                var f = $0c04710c92712449$var$Yh(d, a, e);
                if (null !== f) {
                    var g = $0c04710c92712449$var$Tj();
                    $0c04710c92712449$var$xj(f, d, e, g);
                    $0c04710c92712449$var$Zh(f, d, e);
                }
                d = $0c04710c92712449$var$Uj();
                null !== b && void 0 !== b && null !== f && d.data.set(b, c);
                a.payload = {
                    cache: d
                };
                return;
        }
        d = d.return;
    }
}
function $0c04710c92712449$var$Vj(a, b, c) {
    var d = $0c04710c92712449$var$Sj(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0c04710c92712449$var$Wj(a)) $0c04710c92712449$var$Xj(b, c);
    else if ($0c04710c92712449$var$Ph(a, b, c, d), c = $0c04710c92712449$var$Rh(a), null !== c) {
        var e = $0c04710c92712449$var$Tj();
        $0c04710c92712449$var$xj(c, a, d, e);
        $0c04710c92712449$var$Yj(c, b, d);
    }
}
function $0c04710c92712449$var$zj(a, b, c) {
    var d = $0c04710c92712449$var$Sj(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0c04710c92712449$var$Wj(a)) $0c04710c92712449$var$Xj(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0c04710c92712449$var$af(h, g)) {
                $0c04710c92712449$var$Ph(a, b, e, 0);
                null === $0c04710c92712449$var$S && $0c04710c92712449$var$Nh();
                return;
            }
        } catch (l) {} finally{}
        $0c04710c92712449$var$Ph(a, b, e, d);
        c = $0c04710c92712449$var$Rh(a);
        null !== c && (e = $0c04710c92712449$var$Tj(), $0c04710c92712449$var$xj(c, a, d, e), $0c04710c92712449$var$Yj(c, b, d));
    }
}
function $0c04710c92712449$var$Wj(a) {
    var b = a.alternate;
    return a === $0c04710c92712449$var$N || null !== b && b === $0c04710c92712449$var$N;
}
function $0c04710c92712449$var$Xj(a, b) {
    $0c04710c92712449$var$Oi = $0c04710c92712449$var$Ni = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0c04710c92712449$var$Yj(a, b, c) {
    if (0 !== (c & 8388480)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0c04710c92712449$var$Xc(a, c);
    }
}
var $0c04710c92712449$var$$i = {
    readContext: $0c04710c92712449$var$ij,
    useCallback: $0c04710c92712449$var$Q,
    useContext: $0c04710c92712449$var$Q,
    useEffect: $0c04710c92712449$var$Q,
    useImperativeHandle: $0c04710c92712449$var$Q,
    useInsertionEffect: $0c04710c92712449$var$Q,
    useLayoutEffect: $0c04710c92712449$var$Q,
    useMemo: $0c04710c92712449$var$Q,
    useReducer: $0c04710c92712449$var$Q,
    useRef: $0c04710c92712449$var$Q,
    useState: $0c04710c92712449$var$Q,
    useDebugValue: $0c04710c92712449$var$Q,
    useDeferredValue: $0c04710c92712449$var$Q,
    useTransition: $0c04710c92712449$var$Q,
    useMutableSource: $0c04710c92712449$var$Q,
    useSyncExternalStore: $0c04710c92712449$var$Q,
    useId: $0c04710c92712449$var$Q
};
$0c04710c92712449$var$$i.useCacheRefresh = $0c04710c92712449$var$Q;
$0c04710c92712449$var$$i.use = $0c04710c92712449$var$Q;
$0c04710c92712449$var$$i.useMemoCache = $0c04710c92712449$var$Q;
$0c04710c92712449$var$$i.useEffectEvent = $0c04710c92712449$var$Q;
var $0c04710c92712449$var$Wi = {
    readContext: $0c04710c92712449$var$ij,
    useCallback: function(a, b) {
        $0c04710c92712449$var$ej().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0c04710c92712449$var$ij,
    useEffect: $0c04710c92712449$var$Dj,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        $0c04710c92712449$var$Bj(4194308, 4, $0c04710c92712449$var$Ij.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0c04710c92712449$var$Bj(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        $0c04710c92712449$var$Bj(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0c04710c92712449$var$ej();
        b = void 0 === b ? null : b;
        $0c04710c92712449$var$Pi && a();
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0c04710c92712449$var$ej();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0c04710c92712449$var$Vj.bind(null, $0c04710c92712449$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0c04710c92712449$var$ej();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0c04710c92712449$var$yj,
    useDebugValue: $0c04710c92712449$var$Kj,
    useDeferredValue: function(a) {
        return $0c04710c92712449$var$ej().memoizedState = a;
    },
    useTransition: function() {
        var a = $0c04710c92712449$var$yj(!1), b = a[0];
        a = $0c04710c92712449$var$Oj.bind(null, a[1]);
        $0c04710c92712449$var$ej().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0c04710c92712449$var$N, e = $0c04710c92712449$var$ej();
        if ($0c04710c92712449$var$K) {
            if (void 0 === c) throw Error($0c04710c92712449$var$q(407));
            c = c();
        } else {
            c = b();
            if (null === $0c04710c92712449$var$S) throw Error($0c04710c92712449$var$q(349));
            0 !== ($0c04710c92712449$var$Mi & 60) || $0c04710c92712449$var$uj(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0c04710c92712449$var$Dj($0c04710c92712449$var$rj.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0c04710c92712449$var$sj(9, $0c04710c92712449$var$tj.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0c04710c92712449$var$ej(), b = $0c04710c92712449$var$S.identifierPrefix;
        if ($0c04710c92712449$var$K) {
            var c = $0c04710c92712449$var$rh;
            var d = $0c04710c92712449$var$qh;
            c = (d & ~(1 << 32 - $0c04710c92712449$var$Jc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0c04710c92712449$var$Qi++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0c04710c92712449$var$Ti++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    useCacheRefresh: function() {
        return $0c04710c92712449$var$ej().memoizedState = $0c04710c92712449$var$Rj.bind(null, $0c04710c92712449$var$N);
    }
};
$0c04710c92712449$var$Wi.use = $0c04710c92712449$var$hj;
$0c04710c92712449$var$Wi.useMemoCache = $0c04710c92712449$var$jj;
$0c04710c92712449$var$Wi.useEffectEvent = function(a) {
    var b = $0c04710c92712449$var$ej(), c = {
        impl: a
    };
    b.memoizedState = c;
    return function() {
        if (0 !== ($0c04710c92712449$var$L & 2)) throw Error($0c04710c92712449$var$q(440));
        return c.impl.apply(void 0, arguments);
    };
};
var $0c04710c92712449$var$Xi = {
    readContext: $0c04710c92712449$var$ij,
    useCallback: $0c04710c92712449$var$Lj,
    useContext: $0c04710c92712449$var$ij,
    useEffect: $0c04710c92712449$var$qj,
    useImperativeHandle: $0c04710c92712449$var$Jj,
    useInsertionEffect: $0c04710c92712449$var$Gj,
    useLayoutEffect: $0c04710c92712449$var$Hj,
    useMemo: $0c04710c92712449$var$Mj,
    useReducer: $0c04710c92712449$var$lj,
    useRef: $0c04710c92712449$var$Aj,
    useState: function() {
        return $0c04710c92712449$var$lj($0c04710c92712449$var$kj);
    },
    useDebugValue: $0c04710c92712449$var$Kj,
    useDeferredValue: function(a) {
        var b = $0c04710c92712449$var$fj();
        return $0c04710c92712449$var$Nj(b, $0c04710c92712449$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0c04710c92712449$var$lj($0c04710c92712449$var$kj)[0], b = $0c04710c92712449$var$fj().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0c04710c92712449$var$oj,
    useSyncExternalStore: $0c04710c92712449$var$pj,
    useId: $0c04710c92712449$var$Pj
};
$0c04710c92712449$var$Xi.useCacheRefresh = $0c04710c92712449$var$Qj;
$0c04710c92712449$var$Xi.useMemoCache = $0c04710c92712449$var$jj;
$0c04710c92712449$var$Xi.use = $0c04710c92712449$var$hj;
$0c04710c92712449$var$Xi.useEffectEvent = $0c04710c92712449$var$Fj;
var $0c04710c92712449$var$aj = {
    readContext: $0c04710c92712449$var$ij,
    useCallback: $0c04710c92712449$var$Lj,
    useContext: $0c04710c92712449$var$ij,
    useEffect: $0c04710c92712449$var$qj,
    useImperativeHandle: $0c04710c92712449$var$Jj,
    useInsertionEffect: $0c04710c92712449$var$Gj,
    useLayoutEffect: $0c04710c92712449$var$Hj,
    useMemo: $0c04710c92712449$var$Mj,
    useReducer: $0c04710c92712449$var$nj,
    useRef: $0c04710c92712449$var$Aj,
    useState: function() {
        return $0c04710c92712449$var$nj($0c04710c92712449$var$kj);
    },
    useDebugValue: $0c04710c92712449$var$Kj,
    useDeferredValue: function(a) {
        var b = $0c04710c92712449$var$fj();
        return null === $0c04710c92712449$var$O ? b.memoizedState = a : $0c04710c92712449$var$Nj(b, $0c04710c92712449$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0c04710c92712449$var$nj($0c04710c92712449$var$kj)[0], b = $0c04710c92712449$var$fj().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0c04710c92712449$var$oj,
    useSyncExternalStore: $0c04710c92712449$var$pj,
    useId: $0c04710c92712449$var$Pj
};
$0c04710c92712449$var$aj.useCacheRefresh = $0c04710c92712449$var$Qj;
$0c04710c92712449$var$aj.use = $0c04710c92712449$var$hj;
$0c04710c92712449$var$aj.useMemoCache = $0c04710c92712449$var$jj;
$0c04710c92712449$var$aj.useEffectEvent = $0c04710c92712449$var$Fj;
function $0c04710c92712449$var$Zj(a, b) {
    if (a && a.defaultProps) {
        b = $0c04710c92712449$var$D({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0c04710c92712449$var$ak(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0c04710c92712449$var$D({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0c04710c92712449$var$bk = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0c04710c92712449$var$pc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0c04710c92712449$var$Sj(a), e = $0c04710c92712449$var$Xh(d);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        b = $0c04710c92712449$var$Yh(a, e, d);
        null !== b && (c = $0c04710c92712449$var$Tj(), $0c04710c92712449$var$xj(b, a, d, c), $0c04710c92712449$var$Zh(b, a, d));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0c04710c92712449$var$Sj(a), e = $0c04710c92712449$var$Xh(d);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        b = $0c04710c92712449$var$Yh(a, e, d);
        null !== b && (c = $0c04710c92712449$var$Tj(), $0c04710c92712449$var$xj(b, a, d, c), $0c04710c92712449$var$Zh(b, a, d));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0c04710c92712449$var$Sj(a), d = $0c04710c92712449$var$Xh(c);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        b = $0c04710c92712449$var$Yh(a, d, c);
        null !== b && (d = $0c04710c92712449$var$Tj(), $0c04710c92712449$var$xj(b, a, c, d), $0c04710c92712449$var$Zh(b, a, c));
    }
};
function $0c04710c92712449$var$ck(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0c04710c92712449$var$bf(c, d) || !$0c04710c92712449$var$bf(e, f) : !0;
}
function $0c04710c92712449$var$dk(a, b, c) {
    var d = !1, e = $0c04710c92712449$var$Tg;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0c04710c92712449$var$ij(f) : (e = $0c04710c92712449$var$Yg(b) ? $0c04710c92712449$var$Wg : $0c04710c92712449$var$Ug.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0c04710c92712449$var$Xg(a, e) : $0c04710c92712449$var$Tg);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0c04710c92712449$var$bk;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0c04710c92712449$var$ek(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0c04710c92712449$var$bk.enqueueReplaceState(b, b.state, null);
}
function $0c04710c92712449$var$fk(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0c04710c92712449$var$Vh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0c04710c92712449$var$ij(f) : (f = $0c04710c92712449$var$Yg(b) ? $0c04710c92712449$var$Wg : $0c04710c92712449$var$Ug.current, e.context = $0c04710c92712449$var$Xg(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0c04710c92712449$var$ak(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0c04710c92712449$var$bk.enqueueReplaceState(e, e.state, null), $0c04710c92712449$var$ai(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0c04710c92712449$var$gk(a, b) {
    try {
        var c = "", d = b;
        do c += $0c04710c92712449$var$lb(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0c04710c92712449$var$hk(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0c04710c92712449$var$ik(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
function $0c04710c92712449$var$jk(a, b, c) {
    c = $0c04710c92712449$var$Xh(c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0c04710c92712449$var$kk || ($0c04710c92712449$var$kk = !0, $0c04710c92712449$var$lk = d);
        $0c04710c92712449$var$ik(a, b);
    };
    return c;
}
function $0c04710c92712449$var$mk(a, b, c) {
    c = $0c04710c92712449$var$Xh(c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0c04710c92712449$var$ik(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0c04710c92712449$var$ik(a, b);
        "function" !== typeof d && (null === $0c04710c92712449$var$nk ? $0c04710c92712449$var$nk = new Set([
            this
        ]) : $0c04710c92712449$var$nk.add(this));
        var g = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== g ? g : ""
        });
    });
    return c;
}
function $0c04710c92712449$var$ok(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0c04710c92712449$var$Xh(2), b.tag = 2, $0c04710c92712449$var$Yh(c, b, 2))), c.lanes |= 2), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0c04710c92712449$var$pk = $0c04710c92712449$var$Ma.ReactCurrentOwner, $0c04710c92712449$var$qk = Error($0c04710c92712449$var$q(461)), $0c04710c92712449$var$mj = !1;
function $0c04710c92712449$var$rk(a, b, c, d) {
    b.child = null === a ? $0c04710c92712449$var$oi(b, null, c, d) : $0c04710c92712449$var$ni(b, a.child, c, d);
}
function $0c04710c92712449$var$sk(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0c04710c92712449$var$tk(b, e);
    d = $0c04710c92712449$var$Vi(a, b, c, d, f, e);
    c = $0c04710c92712449$var$bj();
    if (null !== a && !$0c04710c92712449$var$mj) return $0c04710c92712449$var$cj(a, b, e), $0c04710c92712449$var$uk(a, b, e);
    $0c04710c92712449$var$K && c && $0c04710c92712449$var$uh(b);
    b.flags |= 1;
    $0c04710c92712449$var$rk(a, b, d, e);
    return b.child;
}
function $0c04710c92712449$var$vk(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0c04710c92712449$var$wk(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0c04710c92712449$var$xk(a, b, f, d, e);
        a = $0c04710c92712449$var$ki(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0c04710c92712449$var$bf;
        if (c(g, d) && a.ref === b.ref) return $0c04710c92712449$var$uk(a, b, e);
    }
    b.flags |= 1;
    a = $0c04710c92712449$var$ii(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0c04710c92712449$var$xk(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0c04710c92712449$var$bf(f, d) && a.ref === b.ref) {
            if ($0c04710c92712449$var$mj = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0c04710c92712449$var$mj = !0);
            else return b.lanes = a.lanes, $0c04710c92712449$var$uk(a, b, e);
        }
    }
    return $0c04710c92712449$var$yk(a, b, c, d, e);
}
function $0c04710c92712449$var$zk(a, b, c) {
    var d = b.pendingProps, e = d.children, f = 0 !== (b.stateNode._pendingVisibility & 2), g = null !== a ? a.memoizedState : null;
    $0c04710c92712449$var$Ak(a, b);
    if ("hidden" === d.mode || f) {
        if (0 !== (b.flags & 128)) {
            c = null !== g ? g.baseLanes | c : c;
            if (null !== a) {
                d = b.child = a.child;
                for(e = 0; null !== d;)e = e | d.lanes | d.childLanes, d = d.sibling;
                b.childLanes = e & ~c;
            } else b.childLanes = 0, b.child = null;
            return $0c04710c92712449$var$Bk(a, b, c);
        }
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== a && $0c04710c92712449$var$Ck(b, null), $0c04710c92712449$var$ti(), $0c04710c92712449$var$yi(b);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== a && $0c04710c92712449$var$Ck(b, null !== g ? g.cachePool : null), null !== g ? $0c04710c92712449$var$ri(b, g) : $0c04710c92712449$var$ti(), $0c04710c92712449$var$yi(b);
        else return b.lanes = b.childLanes = 1073741824, $0c04710c92712449$var$Bk(a, b, null !== g ? g.baseLanes | c : c);
    } else null !== g ? ($0c04710c92712449$var$Ck(b, g.cachePool), $0c04710c92712449$var$ri(b, g), $0c04710c92712449$var$zi(), b.memoizedState = null) : (null !== a && $0c04710c92712449$var$Ck(b, null), $0c04710c92712449$var$ti(), $0c04710c92712449$var$zi());
    $0c04710c92712449$var$rk(a, b, e, c);
    return b.child;
}
function $0c04710c92712449$var$Bk(a, b, c) {
    var d = $0c04710c92712449$var$Dk();
    d = null === d ? null : {
        parent: $0c04710c92712449$var$T._currentValue,
        pool: d
    };
    b.memoizedState = {
        baseLanes: c,
        cachePool: d
    };
    null !== a && $0c04710c92712449$var$Ck(b, null);
    $0c04710c92712449$var$ti();
    $0c04710c92712449$var$yi(b);
    return null;
}
function $0c04710c92712449$var$Ak(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0c04710c92712449$var$yk(a, b, c, d, e) {
    var f = $0c04710c92712449$var$Yg(c) ? $0c04710c92712449$var$Wg : $0c04710c92712449$var$Ug.current;
    f = $0c04710c92712449$var$Xg(b, f);
    $0c04710c92712449$var$tk(b, e);
    c = $0c04710c92712449$var$Vi(a, b, c, d, f, e);
    d = $0c04710c92712449$var$bj();
    if (null !== a && !$0c04710c92712449$var$mj) return $0c04710c92712449$var$cj(a, b, e), $0c04710c92712449$var$uk(a, b, e);
    $0c04710c92712449$var$K && d && $0c04710c92712449$var$uh(b);
    b.flags |= 1;
    $0c04710c92712449$var$rk(a, b, c, e);
    return b.child;
}
function $0c04710c92712449$var$Ek(a, b, c, d, e) {
    var f = $0c04710c92712449$var$Yg(d) ? $0c04710c92712449$var$Wg : $0c04710c92712449$var$Ug.current;
    f = $0c04710c92712449$var$Xg(b, f);
    $0c04710c92712449$var$tk(b, e);
    c = $0c04710c92712449$var$Yi(b, d, c, f);
    $0c04710c92712449$var$Zi();
    d = $0c04710c92712449$var$bj();
    if (null !== a && !$0c04710c92712449$var$mj) return $0c04710c92712449$var$cj(a, b, e), $0c04710c92712449$var$uk(a, b, e);
    $0c04710c92712449$var$K && d && $0c04710c92712449$var$uh(b);
    b.flags |= 1;
    $0c04710c92712449$var$rk(a, b, c, e);
    return b.child;
}
function $0c04710c92712449$var$Fk(a, b, c, d, e) {
    if ($0c04710c92712449$var$Yg(c)) {
        var f = !0;
        $0c04710c92712449$var$bh(b);
    } else f = !1;
    $0c04710c92712449$var$tk(b, e);
    if (null === b.stateNode) $0c04710c92712449$var$Gk(a, b), $0c04710c92712449$var$dk(b, c, d), $0c04710c92712449$var$fk(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var l = g.context, n = c.contextType;
        "object" === typeof n && null !== n ? n = $0c04710c92712449$var$ij(n) : (n = $0c04710c92712449$var$Yg(c) ? $0c04710c92712449$var$Wg : $0c04710c92712449$var$Ug.current, n = $0c04710c92712449$var$Xg(b, n));
        var w = c.getDerivedStateFromProps, t = "function" === typeof w || "function" === typeof g.getSnapshotBeforeUpdate;
        t || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || l !== n) && $0c04710c92712449$var$ek(b, g, d, n);
        $0c04710c92712449$var$Uh = !1;
        var u = b.memoizedState;
        g.state = u;
        $0c04710c92712449$var$ai(b, d, g, e);
        l = b.memoizedState;
        h !== d || u !== l || $0c04710c92712449$var$Vg.current || $0c04710c92712449$var$Uh ? ("function" === typeof w && ($0c04710c92712449$var$ak(b, c, w, d), l = b.memoizedState), (h = $0c04710c92712449$var$Uh || $0c04710c92712449$var$ck(b, c, h, d, u, l, n)) ? (t || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = l), g.props = d, g.state = l, g.context = n, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0c04710c92712449$var$Wh(a, b);
        h = b.memoizedProps;
        n = b.type === b.elementType ? h : $0c04710c92712449$var$Zj(b.type, h);
        g.props = n;
        t = b.pendingProps;
        u = g.context;
        l = c.contextType;
        "object" === typeof l && null !== l ? l = $0c04710c92712449$var$ij(l) : (l = $0c04710c92712449$var$Yg(c) ? $0c04710c92712449$var$Wg : $0c04710c92712449$var$Ug.current, l = $0c04710c92712449$var$Xg(b, l));
        var v = c.getDerivedStateFromProps;
        (w = "function" === typeof v || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== t || u !== l) && $0c04710c92712449$var$ek(b, g, d, l);
        $0c04710c92712449$var$Uh = !1;
        u = b.memoizedState;
        g.state = u;
        $0c04710c92712449$var$ai(b, d, g, e);
        var y = b.memoizedState;
        h !== t || u !== y || $0c04710c92712449$var$Vg.current || $0c04710c92712449$var$Uh ? ("function" === typeof v && ($0c04710c92712449$var$ak(b, c, v, d), y = b.memoizedState), (n = $0c04710c92712449$var$Uh || $0c04710c92712449$var$ck(b, c, n, d, u, y, l) || !1) ? (w || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, y, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, y, l)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && u === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && u === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = y), g.props = d, g.state = y, g.context = l, d = n) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && u === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && u === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0c04710c92712449$var$Hk(a, b, c, d, f, e);
}
function $0c04710c92712449$var$Hk(a, b, c, d, e, f) {
    $0c04710c92712449$var$Ak(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0c04710c92712449$var$ch(b, c, !1), $0c04710c92712449$var$uk(a, b, f);
    d = b.stateNode;
    $0c04710c92712449$var$pk.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0c04710c92712449$var$ni(b, a.child, null, f), b.child = $0c04710c92712449$var$ni(b, null, h, f)) : $0c04710c92712449$var$rk(a, b, h, f);
    b.memoizedState = d.state;
    e && $0c04710c92712449$var$ch(b, c, !0);
    return b.child;
}
function $0c04710c92712449$var$Ik(a) {
    var b = a.stateNode;
    b.pendingContext ? $0c04710c92712449$var$$g(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0c04710c92712449$var$$g(a, b.context, !1);
    $0c04710c92712449$var$cg(a, b.containerInfo);
}
function $0c04710c92712449$var$Jk(a, b, c, d, e) {
    $0c04710c92712449$var$Ih();
    $0c04710c92712449$var$Jh(e);
    b.flags |= 256;
    $0c04710c92712449$var$rk(a, b, c, d);
    return b.child;
}
var $0c04710c92712449$var$Kk = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0c04710c92712449$var$Lk(a) {
    return {
        baseLanes: a,
        cachePool: $0c04710c92712449$var$Mk()
    };
}
function $0c04710c92712449$var$Nk(a, b, c) {
    var d = b.pendingProps, e = !1, f = 0 !== (b.flags & 128), g;
    (g = f) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== ($0c04710c92712449$var$Bi.current & 2));
    g && (e = !0, b.flags &= -129);
    if (null === a) {
        if ($0c04710c92712449$var$K) {
            e ? $0c04710c92712449$var$xi(b) : $0c04710c92712449$var$zi();
            $0c04710c92712449$var$Dh(b);
            a = b.memoizedState;
            if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 2 : "$!" === a.data ? b.lanes = 16 : b.lanes = 1073741824, null;
            $0c04710c92712449$var$Ai(b);
        }
        a = d.children;
        f = d.fallback;
        if (e) return $0c04710c92712449$var$zi(), a = $0c04710c92712449$var$Ok(b, a, f, c), b.child.memoizedState = $0c04710c92712449$var$Lk(c), b.memoizedState = $0c04710c92712449$var$Kk, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return $0c04710c92712449$var$zi(), a = $0c04710c92712449$var$Ok(b, a, f, c), b.child.memoizedState = $0c04710c92712449$var$Lk(c), b.memoizedState = $0c04710c92712449$var$Kk, b.lanes = 8388608, a;
        $0c04710c92712449$var$xi(b);
        return $0c04710c92712449$var$Pk(b, a);
    }
    g = a.memoizedState;
    if (null !== g) {
        var h = g.dehydrated;
        if (null !== h) return $0c04710c92712449$var$Qk(a, b, f, d, h, g, c);
    }
    if (e) {
        $0c04710c92712449$var$zi();
        e = d.fallback;
        f = b.mode;
        g = a.child;
        h = g.sibling;
        var l = {
            mode: "hidden",
            children: d.children
        };
        0 === (f & 1) && b.child !== g ? (d = b.child, d.childLanes = 0, d.pendingProps = l, b.deletions = null) : (d = $0c04710c92712449$var$ii(g, l), d.subtreeFlags = g.subtreeFlags & 14680064);
        null !== h ? e = $0c04710c92712449$var$ii(h, e) : (e = $0c04710c92712449$var$mi(e, f, c, null), e.flags |= 2);
        e.return = b;
        d.return = b;
        d.sibling = e;
        b.child = d;
        d = e;
        e = b.child;
        f = a.child.memoizedState;
        null === f ? f = $0c04710c92712449$var$Lk(c) : (g = f.cachePool, null !== g ? (h = $0c04710c92712449$var$T._currentValue, g = g.parent !== h ? {
            parent: h,
            pool: h
        } : g) : g = $0c04710c92712449$var$Mk(), f = {
            baseLanes: f.baseLanes | c,
            cachePool: g
        });
        e.memoizedState = f;
        e.childLanes = a.childLanes & ~c;
        b.memoizedState = $0c04710c92712449$var$Kk;
        return d;
    }
    $0c04710c92712449$var$xi(b);
    e = a.child;
    a = e.sibling;
    d = $0c04710c92712449$var$ii(e, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0c04710c92712449$var$Pk(a, b) {
    b = $0c04710c92712449$var$Rk({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0c04710c92712449$var$Ok(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = $0c04710c92712449$var$Rk(b, e, 0, null);
    c = $0c04710c92712449$var$mi(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function $0c04710c92712449$var$Sk(a, b, c, d) {
    null !== d && $0c04710c92712449$var$Jh(d);
    $0c04710c92712449$var$ni(b, a.child, null, c);
    a = $0c04710c92712449$var$Pk(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0c04710c92712449$var$Qk(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return $0c04710c92712449$var$xi(b), b.flags &= -257, f = $0c04710c92712449$var$hk(Error($0c04710c92712449$var$q(422))), $0c04710c92712449$var$Sk(a, b, g, f);
        if (null !== b.memoizedState) return $0c04710c92712449$var$zi(), b.child = a.child, b.flags |= 128, null;
        $0c04710c92712449$var$zi();
        f = d.fallback;
        e = b.mode;
        d = $0c04710c92712449$var$Rk({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0c04710c92712449$var$mi(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0c04710c92712449$var$ni(b, a.child, null, g);
        b.child.memoizedState = $0c04710c92712449$var$Lk(g);
        b.memoizedState = $0c04710c92712449$var$Kk;
        return f;
    }
    $0c04710c92712449$var$xi(b);
    if (0 === (b.mode & 1)) return $0c04710c92712449$var$Sk(a, b, g, null);
    if ("$!" === e.data) {
        f = e.nextSibling && e.nextSibling.dataset;
        if (f) var h = f.dgst;
        f = h;
        d = Error($0c04710c92712449$var$q(419));
        d.digest = f;
        f = $0c04710c92712449$var$hk(d, f, void 0);
        return $0c04710c92712449$var$Sk(a, b, g, f);
    }
    h = 0 !== (g & a.childLanes);
    if ($0c04710c92712449$var$mj || h) {
        d = $0c04710c92712449$var$S;
        if (null !== d) {
            e = g & -g;
            if (0 !== (e & 42)) e = 1;
            else switch(e){
                case 2:
                    e = 1;
                    break;
                case 8:
                    e = 4;
                    break;
                case 32:
                    e = 16;
                    break;
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 64;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            if (0 !== e && e !== f.retryLane) throw f.retryLane = e, $0c04710c92712449$var$Qh(a, e), $0c04710c92712449$var$xj(d, a, e, -1), $0c04710c92712449$var$qk;
        }
        $0c04710c92712449$var$Tk();
        return $0c04710c92712449$var$Sk(a, b, g, null);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0c04710c92712449$var$Uk.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0c04710c92712449$var$xh = $0c04710c92712449$var$Qg(e.nextSibling);
    $0c04710c92712449$var$wh = b;
    $0c04710c92712449$var$K = !0;
    $0c04710c92712449$var$yh = null;
    null !== a && ($0c04710c92712449$var$nh[$0c04710c92712449$var$oh++] = $0c04710c92712449$var$qh, $0c04710c92712449$var$nh[$0c04710c92712449$var$oh++] = $0c04710c92712449$var$rh, $0c04710c92712449$var$nh[$0c04710c92712449$var$oh++] = $0c04710c92712449$var$ph, $0c04710c92712449$var$qh = a.id, $0c04710c92712449$var$rh = a.overflow, $0c04710c92712449$var$ph = b);
    b = $0c04710c92712449$var$Pk(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0c04710c92712449$var$Vk(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0c04710c92712449$var$Wk(a.return, b, c);
}
function $0c04710c92712449$var$Xk(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0c04710c92712449$var$Yk(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0c04710c92712449$var$rk(a, b, d.children, c);
    d = $0c04710c92712449$var$Bi.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0c04710c92712449$var$Vk(a, c, b);
            else if (19 === a.tag) $0c04710c92712449$var$Vk(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0c04710c92712449$var$J($0c04710c92712449$var$Bi, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0c04710c92712449$var$Ci(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0c04710c92712449$var$Xk(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0c04710c92712449$var$Ci(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0c04710c92712449$var$Xk(b, !0, c, null, f);
            break;
        case "together":
            $0c04710c92712449$var$Xk(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0c04710c92712449$var$Gk(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0c04710c92712449$var$uk(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0c04710c92712449$var$bi |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0c04710c92712449$var$q(153));
    if (null !== b.child) {
        a = b.child;
        c = $0c04710c92712449$var$ii(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0c04710c92712449$var$ii(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0c04710c92712449$var$Zk(a, b, c) {
    switch(b.tag){
        case 3:
            $0c04710c92712449$var$Ik(b);
            $0c04710c92712449$var$$k(b, $0c04710c92712449$var$T, a.memoizedState.cache);
            $0c04710c92712449$var$Ih();
            break;
        case 27:
        case 5:
            $0c04710c92712449$var$eg(b);
            break;
        case 1:
            $0c04710c92712449$var$Yg(b.type) && $0c04710c92712449$var$bh(b);
            break;
        case 4:
            $0c04710c92712449$var$cg(b, b.stateNode.containerInfo);
            break;
        case 10:
            $0c04710c92712449$var$$k(b, b.type._context, b.memoizedProps.value);
            break;
        case 13:
            var d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0c04710c92712449$var$xi(b), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0c04710c92712449$var$Nk(a, b, c);
                $0c04710c92712449$var$xi(b);
                a = $0c04710c92712449$var$uk(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0c04710c92712449$var$xi(b);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0c04710c92712449$var$Yk(a, b, c);
                b.flags |= 128;
            }
            var e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0c04710c92712449$var$J($0c04710c92712449$var$Bi, $0c04710c92712449$var$Bi.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0c04710c92712449$var$zk(a, b, c);
        case 24:
            $0c04710c92712449$var$$k(b, $0c04710c92712449$var$T, a.memoizedState.cache);
    }
    return $0c04710c92712449$var$uk(a, b, c);
}
var $0c04710c92712449$var$al = $0c04710c92712449$var$Zf(null), $0c04710c92712449$var$bl = null, $0c04710c92712449$var$cl = null, $0c04710c92712449$var$dl = null;
function $0c04710c92712449$var$el() {
    $0c04710c92712449$var$dl = $0c04710c92712449$var$cl = $0c04710c92712449$var$bl = null;
}
function $0c04710c92712449$var$$k(a, b, c) {
    $0c04710c92712449$var$J($0c04710c92712449$var$al, b._currentValue);
    b._currentValue = c;
}
function $0c04710c92712449$var$fl(a) {
    var b = $0c04710c92712449$var$al.current;
    a._currentValue = b === $0c04710c92712449$var$db ? a._defaultValue : b;
    $0c04710c92712449$var$I($0c04710c92712449$var$al);
}
function $0c04710c92712449$var$Wk(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0c04710c92712449$var$gl(a, b, c) {
    var d = a.child;
    null !== d && (d.return = a);
    for(; null !== d;){
        var e = d.dependencies;
        if (null !== e) {
            var f = d.child;
            for(var g = e.firstContext; null !== g;){
                if (g.context === b) {
                    if (1 === d.tag) {
                        g = $0c04710c92712449$var$Xh(c & -c);
                        g.tag = 2;
                        var h = d.updateQueue;
                        if (null !== h) {
                            h = h.shared;
                            var l = h.pending;
                            null === l ? g.next = g : (g.next = l.next, l.next = g);
                            h.pending = g;
                        }
                    }
                    d.lanes |= c;
                    g = d.alternate;
                    null !== g && (g.lanes |= c);
                    $0c04710c92712449$var$Wk(d.return, c, a);
                    e.lanes |= c;
                    break;
                }
                g = g.next;
            }
        } else if (10 === d.tag) f = d.type === a.type ? null : d.child;
        else if (18 === d.tag) {
            f = d.return;
            if (null === f) throw Error($0c04710c92712449$var$q(341));
            f.lanes |= c;
            e = f.alternate;
            null !== e && (e.lanes |= c);
            $0c04710c92712449$var$Wk(f, c, a);
            f = d.sibling;
        } else f = d.child;
        if (null !== f) f.return = d;
        else for(f = d; null !== f;){
            if (f === a) {
                f = null;
                break;
            }
            d = f.sibling;
            if (null !== d) {
                d.return = f.return;
                f = d;
                break;
            }
            f = f.return;
        }
        d = f;
    }
}
function $0c04710c92712449$var$tk(a, b) {
    $0c04710c92712449$var$bl = a;
    $0c04710c92712449$var$dl = $0c04710c92712449$var$cl = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0c04710c92712449$var$mj = !0), a.firstContext = null);
}
function $0c04710c92712449$var$ij(a) {
    var b = a._currentValue;
    if ($0c04710c92712449$var$dl !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0c04710c92712449$var$cl) {
            if (null === $0c04710c92712449$var$bl) throw Error($0c04710c92712449$var$q(308));
            $0c04710c92712449$var$cl = a;
            $0c04710c92712449$var$bl.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0c04710c92712449$var$cl = $0c04710c92712449$var$cl.next = a;
    }
    return b;
}
var $0c04710c92712449$var$hl = "undefined" !== typeof AbortController ? AbortController : function() {
    var a = [], b = this.signal = {
        aborted: !1,
        addEventListener: function(c, d) {
            a.push(d);
        }
    };
    this.abort = function() {
        b.aborted = !0;
        a.forEach(function(c) {
            return c();
        });
    };
}, $0c04710c92712449$var$il = $9gi6K.unstable_scheduleCallback, $0c04710c92712449$var$jl = $9gi6K.unstable_NormalPriority, $0c04710c92712449$var$T = {
    $$typeof: $0c04710c92712449$var$Ta,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0,
    _defaultValue: null,
    _globalName: null
};
function $0c04710c92712449$var$Uj() {
    return {
        controller: new $0c04710c92712449$var$hl,
        data: new Map,
        refCount: 0
    };
}
function $0c04710c92712449$var$kl(a) {
    a.refCount--;
    0 === a.refCount && $0c04710c92712449$var$il($0c04710c92712449$var$jl, function() {
        a.controller.abort();
    });
}
var $0c04710c92712449$var$ll = $0c04710c92712449$var$Ma.ReactCurrentBatchConfig, $0c04710c92712449$var$ml = $0c04710c92712449$var$Zf(null);
function $0c04710c92712449$var$Dk() {
    var a = $0c04710c92712449$var$ml.current;
    return null !== a ? a : $0c04710c92712449$var$S.pooledCache;
}
function $0c04710c92712449$var$Ck(a, b) {
    null === b ? $0c04710c92712449$var$J($0c04710c92712449$var$ml, $0c04710c92712449$var$ml.current) : $0c04710c92712449$var$J($0c04710c92712449$var$ml, b.pool);
}
function $0c04710c92712449$var$Mk() {
    var a = $0c04710c92712449$var$Dk();
    return null === a ? null : {
        parent: $0c04710c92712449$var$T._currentValue,
        pool: a
    };
}
function $0c04710c92712449$var$nl(a) {
    a.flags |= 4;
}
function $0c04710c92712449$var$ol(a) {
    a.flags |= 2097664;
}
function $0c04710c92712449$var$pl(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        var f = null;
        switch(c){
            case "input":
                e = $0c04710c92712449$var$ub(a, e);
                d = $0c04710c92712449$var$ub(a, d);
                f = [];
                break;
            case "select":
                e = $0c04710c92712449$var$D({}, e, {
                    value: void 0
                });
                d = $0c04710c92712449$var$D({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0c04710c92712449$var$Cb(a, e);
                d = $0c04710c92712449$var$Cb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0c04710c92712449$var$Tf);
        }
        $0c04710c92712449$var$Rb(c, d);
        var g;
        c = null;
        for(n in e)if (!d.hasOwnProperty(n) && e.hasOwnProperty(n) && null != e[n]) {
            if ("style" === n) {
                var h = e[n];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== n && "children" !== n && "suppressContentEditableWarning" !== n && "suppressHydrationWarning" !== n && "autoFocus" !== n && ($0c04710c92712449$var$va.hasOwnProperty(n) ? f || (f = []) : (f = f || []).push(n, null));
        }
        for(n in d){
            var l = d[n];
            h = null != e ? e[n] : void 0;
            if (d.hasOwnProperty(n) && l !== h && (null != l || null != h)) {
                if ("style" === n) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || l && l.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in l)l.hasOwnProperty(g) && h[g] !== l[g] && (c || (c = {}), c[g] = l[g]);
                    } else c || (f || (f = []), f.push(n, c)), c = l;
                } else "dangerouslySetInnerHTML" === n ? (l = l ? l.__html : void 0, h = h ? h.__html : void 0, null != l && h !== l && (f = f || []).push(n, l)) : "children" === n ? "string" !== typeof l && "number" !== typeof l || (f = f || []).push(n, "" + l) : "suppressContentEditableWarning" !== n && "suppressHydrationWarning" !== n && ($0c04710c92712449$var$va.hasOwnProperty(n) ? (null != l && "onScroll" === n && $0c04710c92712449$var$H("scroll", a), f || h === l || (f = [])) : (f = f || []).push(n, l));
            }
        }
        c && (f = f || []).push("style", c);
        var n = f;
        (b.updateQueue = n) && $0c04710c92712449$var$nl(b);
    }
}
function $0c04710c92712449$var$ql(a, b) {
    if (!$0c04710c92712449$var$K) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0c04710c92712449$var$U(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0c04710c92712449$var$rl(a, b, c) {
    var d = b.pendingProps;
    $0c04710c92712449$var$vh(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0c04710c92712449$var$U(b), null;
        case 1:
            return $0c04710c92712449$var$Yg(b.type) && $0c04710c92712449$var$Zg(), $0c04710c92712449$var$U(b), null;
        case 3:
            c = b.stateNode;
            d = null;
            null !== a && (d = a.memoizedState.cache);
            b.memoizedState.cache !== d && (b.flags |= 2048);
            $0c04710c92712449$var$fl($0c04710c92712449$var$T);
            $0c04710c92712449$var$dg();
            $0c04710c92712449$var$I($0c04710c92712449$var$Vg);
            $0c04710c92712449$var$I($0c04710c92712449$var$Ug);
            $0c04710c92712449$var$Ei();
            c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null);
            if (null === a || null === a.child) $0c04710c92712449$var$Gh(b) ? $0c04710c92712449$var$nl(b) : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0c04710c92712449$var$yh && ($0c04710c92712449$var$sl($0c04710c92712449$var$yh), $0c04710c92712449$var$yh = null));
            $0c04710c92712449$var$U(b);
            return null;
        case 26:
            return (a ? a.ref : null) !== b.ref && $0c04710c92712449$var$ol(b), null === a || a.memoizedState !== b.memoizedState ? $0c04710c92712449$var$nl(b) : null === b.memoizedState && $0c04710c92712449$var$pl(a, b, b.type, b.pendingProps), $0c04710c92712449$var$U(b), null;
        case 27:
            $0c04710c92712449$var$fg(b);
            c = $0c04710c92712449$var$bg.current;
            var e = b.type;
            if (null !== a && null != b.stateNode) $0c04710c92712449$var$pl(a, b, e, d), a.ref !== b.ref && $0c04710c92712449$var$ol(b);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0c04710c92712449$var$q(166));
                    $0c04710c92712449$var$U(b);
                    return null;
                }
                a = $0c04710c92712449$var$$f.current;
                $0c04710c92712449$var$Gh(b) ? $0c04710c92712449$var$Eh(b, a) : (b.stateNode = $0c04710c92712449$var$Sg(e, d, c), $0c04710c92712449$var$nl(b));
                null !== b.ref && $0c04710c92712449$var$ol(b);
            }
            $0c04710c92712449$var$U(b);
            return null;
        case 5:
            $0c04710c92712449$var$fg(b);
            c = b.type;
            if (null !== a && null != b.stateNode) $0c04710c92712449$var$pl(a, b, c, d), a.ref !== b.ref && $0c04710c92712449$var$ol(b);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0c04710c92712449$var$q(166));
                    $0c04710c92712449$var$U(b);
                    return null;
                }
                a = $0c04710c92712449$var$$f.current;
                if ($0c04710c92712449$var$Gh(b)) $0c04710c92712449$var$Eh(b, a) && $0c04710c92712449$var$nl(b);
                else {
                    a = $0c04710c92712449$var$Uf(c, d, $0c04710c92712449$var$bg.current, a);
                    a[$0c04710c92712449$var$ea] = b;
                    a[$0c04710c92712449$var$fa] = d;
                    a: for(e = b.child; null !== e;){
                        if (5 === e.tag || 6 === e.tag) a.appendChild(e.stateNode);
                        else if (4 !== e.tag && 27 !== e.tag && null !== e.child) {
                            e.child.return = e;
                            e = e.child;
                            continue;
                        }
                        if (e === b) break a;
                        for(; null === e.sibling;){
                            if (null === e.return || e.return === b) break a;
                            e = e.return;
                        }
                        e.sibling.return = e.return;
                        e = e.sibling;
                    }
                    b.stateNode = a;
                    a: switch($0c04710c92712449$var$Vf(a, c, d), c){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            a = !!d.autoFocus;
                            break a;
                        case "img":
                            a = !0;
                            break a;
                        default:
                            a = !1;
                    }
                    a && $0c04710c92712449$var$nl(b);
                }
                null !== b.ref && $0c04710c92712449$var$ol(b);
            }
            $0c04710c92712449$var$U(b);
            return null;
        case 6:
            if (a && null != b.stateNode) a.memoizedProps !== d && $0c04710c92712449$var$nl(b);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0c04710c92712449$var$q(166));
                a = $0c04710c92712449$var$bg.current;
                if ($0c04710c92712449$var$Gh(b)) {
                    a = b.stateNode;
                    c = b.memoizedProps;
                    a[$0c04710c92712449$var$ea] = b;
                    if (d = a.nodeValue !== c) {
                        if (e = $0c04710c92712449$var$wh, null !== e) switch(e.tag){
                            case 3:
                                $0c04710c92712449$var$Sf(a.nodeValue, c, 0 !== (e.mode & 1));
                                break;
                            case 27:
                            case 5:
                                !0 !== e.memoizedProps.suppressHydrationWarning && $0c04710c92712449$var$Sf(a.nodeValue, c, 0 !== (e.mode & 1));
                        }
                    }
                    d && $0c04710c92712449$var$nl(b);
                } else a = (9 === a.nodeType ? a : a.ownerDocument).createTextNode(d), a[$0c04710c92712449$var$ea] = b, b.stateNode = a;
            }
            $0c04710c92712449$var$U(b);
            return null;
        case 13:
            $0c04710c92712449$var$Ai(b);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0c04710c92712449$var$K && null !== $0c04710c92712449$var$xh && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0c04710c92712449$var$Hh(), $0c04710c92712449$var$Ih(), b.flags |= 98560, e = !1;
                else if (e = $0c04710c92712449$var$Gh(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!e) throw Error($0c04710c92712449$var$q(318));
                        e = b.memoizedState;
                        e = null !== e ? e.dehydrated : null;
                        if (!e) throw Error($0c04710c92712449$var$q(317));
                        e[$0c04710c92712449$var$ea] = b;
                    } else $0c04710c92712449$var$Ih(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0c04710c92712449$var$U(b);
                    e = !1;
                } else null !== $0c04710c92712449$var$yh && ($0c04710c92712449$var$sl($0c04710c92712449$var$yh), $0c04710c92712449$var$yh = null), e = !0;
                if (!e) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            c = null !== d;
            a = null !== a && null !== a.memoizedState;
            if (c) {
                d = b.child;
                e = null;
                null !== d.alternate && null !== d.alternate.memoizedState && null !== d.alternate.memoizedState.cachePool && (e = d.alternate.memoizedState.cachePool.pool);
                var f = null;
                null !== d.memoizedState && null !== d.memoizedState.cachePool && (f = d.memoizedState.cachePool.pool);
                f !== e && (d.flags |= 2048);
            }
            c !== a && c && (b.child.flags |= 8192);
            null !== b.updateQueue && (b.flags |= 4);
            $0c04710c92712449$var$U(b);
            return null;
        case 4:
            return $0c04710c92712449$var$dg(), null === a && $0c04710c92712449$var$Lf(b.stateNode.containerInfo), $0c04710c92712449$var$U(b), null;
        case 10:
            return $0c04710c92712449$var$fl(b.type._context), $0c04710c92712449$var$U(b), null;
        case 17:
            return $0c04710c92712449$var$Yg(b.type) && $0c04710c92712449$var$Zg(), $0c04710c92712449$var$U(b), null;
        case 19:
            $0c04710c92712449$var$I($0c04710c92712449$var$Bi);
            e = b.memoizedState;
            if (null === e) return $0c04710c92712449$var$U(b), null;
            d = 0 !== (b.flags & 128);
            f = e.rendering;
            if (null === f) {
                if (d) $0c04710c92712449$var$ql(e, !1);
                else {
                    if (0 !== $0c04710c92712449$var$V || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        f = $0c04710c92712449$var$Ci(a);
                        if (null !== f) {
                            b.flags |= 128;
                            $0c04710c92712449$var$ql(e, !1);
                            a = f.updateQueue;
                            null !== a && (b.updateQueue = a, b.flags |= 4);
                            b.subtreeFlags = 0;
                            a = c;
                            for(c = b.child; null !== c;)$0c04710c92712449$var$tl(c, a), c = c.sibling;
                            $0c04710c92712449$var$J($0c04710c92712449$var$Bi, $0c04710c92712449$var$Bi.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== e.tail && $0c04710c92712449$var$E() > $0c04710c92712449$var$ul && (b.flags |= 128, d = !0, $0c04710c92712449$var$ql(e, !1), b.lanes = 8388608);
                }
            } else {
                if (!d) {
                    if (a = $0c04710c92712449$var$Ci(f), null !== a) {
                        if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), $0c04710c92712449$var$ql(e, !0), null === e.tail && "hidden" === e.tailMode && !f.alternate && !$0c04710c92712449$var$K) return $0c04710c92712449$var$U(b), null;
                    } else 2 * $0c04710c92712449$var$E() - e.renderingStartTime > $0c04710c92712449$var$ul && 1073741824 !== c && (b.flags |= 128, d = !0, $0c04710c92712449$var$ql(e, !1), b.lanes = 8388608);
                }
                e.isBackwards ? (f.sibling = b.child, b.child = f) : (a = e.last, null !== a ? a.sibling = f : b.child = f, e.last = f);
            }
            if (null !== e.tail) return b = e.tail, e.rendering = b, e.tail = b.sibling, e.renderingStartTime = $0c04710c92712449$var$E(), b.sibling = null, a = $0c04710c92712449$var$Bi.current, $0c04710c92712449$var$J($0c04710c92712449$var$Bi, d ? a & 1 | 2 : a & 1), b;
            $0c04710c92712449$var$U(b);
            return null;
        case 22:
        case 23:
            return $0c04710c92712449$var$Ai(b), $0c04710c92712449$var$ui(), d = null !== b.memoizedState, null !== a ? null !== a.memoizedState !== d && (b.flags |= 8192) : d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (c & 1073741824) && 0 === (b.flags & 128) && ($0c04710c92712449$var$U(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0c04710c92712449$var$U(b), null !== b.updateQueue && (b.flags |= 4), c = null, null !== a && null !== a.memoizedState && null !== a.memoizedState.cachePool && (c = a.memoizedState.cachePool.pool), d = null, null !== b.memoizedState && null !== b.memoizedState.cachePool && (d = b.memoizedState.cachePool.pool), d !== c && (b.flags |= 2048), null !== a && $0c04710c92712449$var$I($0c04710c92712449$var$ml), null;
        case 24:
            return c = null, null !== a && (c = a.memoizedState.cache), b.memoizedState.cache !== c && (b.flags |= 2048), $0c04710c92712449$var$fl($0c04710c92712449$var$T), $0c04710c92712449$var$U(b), null;
        case 25:
            return null;
    }
    throw Error($0c04710c92712449$var$q(156, b.tag));
}
function $0c04710c92712449$var$vl(a, b) {
    $0c04710c92712449$var$vh(b);
    switch(b.tag){
        case 1:
            return $0c04710c92712449$var$Yg(b.type) && $0c04710c92712449$var$Zg(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0c04710c92712449$var$fl($0c04710c92712449$var$T), $0c04710c92712449$var$dg(), $0c04710c92712449$var$I($0c04710c92712449$var$Vg), $0c04710c92712449$var$I($0c04710c92712449$var$Ug), $0c04710c92712449$var$Ei(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 26:
        case 27:
        case 5:
            return $0c04710c92712449$var$fg(b), null;
        case 13:
            $0c04710c92712449$var$Ai(b);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0c04710c92712449$var$q(340));
                $0c04710c92712449$var$Ih();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0c04710c92712449$var$I($0c04710c92712449$var$Bi), null;
        case 4:
            return $0c04710c92712449$var$dg(), null;
        case 10:
            return $0c04710c92712449$var$fl(b.type._context), null;
        case 22:
        case 23:
            return $0c04710c92712449$var$Ai(b), $0c04710c92712449$var$ui(), null !== a && $0c04710c92712449$var$I($0c04710c92712449$var$ml), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 24:
            return $0c04710c92712449$var$fl($0c04710c92712449$var$T), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $0c04710c92712449$var$wl(a, b) {
    $0c04710c92712449$var$vh(b);
    switch(b.tag){
        case 1:
            a = b.type.childContextTypes;
            null !== a && void 0 !== a && $0c04710c92712449$var$Zg();
            break;
        case 3:
            $0c04710c92712449$var$fl($0c04710c92712449$var$T);
            $0c04710c92712449$var$dg();
            $0c04710c92712449$var$I($0c04710c92712449$var$Vg);
            $0c04710c92712449$var$I($0c04710c92712449$var$Ug);
            $0c04710c92712449$var$Ei();
            break;
        case 26:
        case 27:
        case 5:
            $0c04710c92712449$var$fg(b);
            break;
        case 4:
            $0c04710c92712449$var$dg();
            break;
        case 13:
            $0c04710c92712449$var$Ai(b);
            break;
        case 19:
            $0c04710c92712449$var$I($0c04710c92712449$var$Bi);
            break;
        case 10:
            $0c04710c92712449$var$fl(b.type._context);
            break;
        case 22:
        case 23:
            $0c04710c92712449$var$Ai(b);
            $0c04710c92712449$var$ui();
            null !== a && $0c04710c92712449$var$I($0c04710c92712449$var$ml);
            break;
        case 24:
            $0c04710c92712449$var$fl($0c04710c92712449$var$T);
    }
}
var $0c04710c92712449$var$xl = !1, $0c04710c92712449$var$yl = !1, $0c04710c92712449$var$zl = "function" === typeof WeakSet ? WeakSet : Set, $0c04710c92712449$var$Al = null;
function $0c04710c92712449$var$Bl(a, b) {
    try {
        var c = a.ref;
        if (null !== c) {
            var d = a.stateNode;
            switch(a.tag){
                case 26:
                case 27:
                case 5:
                    var e = d;
                    break;
                default:
                    e = d;
            }
            "function" === typeof c ? a.refCleanup = c(e) : c.current = e;
        }
    } catch (f) {
        $0c04710c92712449$var$W(a, b, f);
    }
}
function $0c04710c92712449$var$Cl(a, b) {
    var c = a.ref, d = a.refCleanup;
    if (null !== c) {
        if ("function" === typeof d) try {
            d();
        } catch (e) {
            $0c04710c92712449$var$W(a, b, e);
        } finally{
            a.refCleanup = null, a = a.alternate, null != a && (a.refCleanup = null);
        }
        else if ("function" === typeof c) try {
            c(null);
        } catch (e) {
            $0c04710c92712449$var$W(a, b, e);
        }
        else c.current = null;
    }
}
function $0c04710c92712449$var$Dl(a, b, c) {
    try {
        c();
    } catch (d) {
        $0c04710c92712449$var$W(a, b, d);
    }
}
var $0c04710c92712449$var$El = !1;
function $0c04710c92712449$var$Fl(a, b) {
    $0c04710c92712449$var$Fg = $0c04710c92712449$var$yd;
    a = $0c04710c92712449$var$ff();
    if ($0c04710c92712449$var$gf(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (z) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, l = -1, n = 0, w = 0, t = a, u = null;
                b: for(;;){
                    for(var v;;){
                        t !== c || 0 !== e && 3 !== t.nodeType || (h = g + e);
                        t !== f || 0 !== d && 3 !== t.nodeType || (l = g + d);
                        3 === t.nodeType && (g += t.nodeValue.length);
                        if (null === (v = t.firstChild)) break;
                        u = t;
                        t = v;
                    }
                    for(;;){
                        if (t === a) break b;
                        u === c && ++n === e && (h = g);
                        u === f && ++w === d && (l = g);
                        if (null !== (v = t.nextSibling)) break;
                        t = u;
                        u = t.parentNode;
                    }
                    t = v;
                }
                c = -1 === h || -1 === l ? null : {
                    start: h,
                    end: l
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0c04710c92712449$var$Gg = {
        focusedElem: a,
        selectionRange: c
    };
    $0c04710c92712449$var$yd = !1;
    for($0c04710c92712449$var$Al = b; null !== $0c04710c92712449$var$Al;)if (b = $0c04710c92712449$var$Al, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0c04710c92712449$var$Al = a;
    else for(; null !== $0c04710c92712449$var$Al;){
        b = $0c04710c92712449$var$Al;
        try {
            var y = b.alternate, C = b.flags;
            switch(b.tag){
                case 0:
                    if (0 !== (C & 4)) {
                        var R = b.updateQueue, m = null !== R ? R.events : null;
                        if (null !== m) for(a = 0; a < m.length; a++){
                            var k = m[a];
                            k.ref.impl = k.nextImpl;
                        }
                    }
                    break;
                case 11:
                case 15:
                    break;
                case 1:
                    if (0 !== (C & 1024) && null !== y) {
                        var p = y.memoizedProps, r = y.memoizedState, x = b.stateNode, A = x.getSnapshotBeforeUpdate(b.elementType === b.type ? p : $0c04710c92712449$var$Zj(b.type, p), r);
                        x.__reactInternalSnapshotBeforeUpdate = A;
                    }
                    break;
                case 3:
                    0 !== (C & 1024) && $0c04710c92712449$var$Og(b.stateNode.containerInfo);
                    break;
                case 5:
                case 26:
                case 27:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    if (0 !== (C & 1024)) throw Error($0c04710c92712449$var$q(163));
            }
        } catch (z) {
            $0c04710c92712449$var$W(b, b.return, z);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0c04710c92712449$var$Al = a;
            break;
        }
        $0c04710c92712449$var$Al = b.return;
    }
    y = $0c04710c92712449$var$El;
    $0c04710c92712449$var$El = !1;
    return y;
}
function $0c04710c92712449$var$Gl(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0c04710c92712449$var$Dl(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0c04710c92712449$var$Hl(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0c04710c92712449$var$Il(a, b) {
    try {
        $0c04710c92712449$var$Hl(b, a);
    } catch (c) {
        $0c04710c92712449$var$W(a, a.return, c);
    }
}
function $0c04710c92712449$var$Jl(a) {
    var b = a.updateQueue;
    if (null !== b) {
        var c = a.stateNode;
        try {
            $0c04710c92712449$var$di(b, c);
        } catch (d) {
            $0c04710c92712449$var$W(a, a.return, d);
        }
    }
}
function $0c04710c92712449$var$Kl(a) {
    var b = a.type, c = a.memoizedProps, d = a.stateNode;
    try {
        a: switch(b){
            case "button":
            case "input":
            case "select":
            case "textarea":
                c.autoFocus && d.focus();
                break a;
            case "img":
                c.src && (d.src = c.src);
        }
    } catch (e) {
        $0c04710c92712449$var$W(a, a.return, e);
    }
}
function $0c04710c92712449$var$Ll(a, b, c) {
    var d = c.flags;
    switch(c.tag){
        case 0:
        case 11:
        case 15:
            $0c04710c92712449$var$Ml(a, c);
            d & 4 && $0c04710c92712449$var$Il(c, 5);
            break;
        case 1:
            $0c04710c92712449$var$Ml(a, c);
            if (d & 4) {
                if (a = c.stateNode, null === b) try {
                    a.componentDidMount();
                } catch (h) {
                    $0c04710c92712449$var$W(c, c.return, h);
                }
                else {
                    var e = c.elementType === c.type ? b.memoizedProps : $0c04710c92712449$var$Zj(c.type, b.memoizedProps);
                    b = b.memoizedState;
                    try {
                        a.componentDidUpdate(e, b, a.__reactInternalSnapshotBeforeUpdate);
                    } catch (h) {
                        $0c04710c92712449$var$W(c, c.return, h);
                    }
                }
            }
            d & 64 && $0c04710c92712449$var$Jl(c);
            d & 512 && $0c04710c92712449$var$Bl(c, c.return);
            break;
        case 3:
            $0c04710c92712449$var$Ml(a, c);
            if (d & 64 && (d = c.updateQueue, null !== d)) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 27:
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                try {
                    $0c04710c92712449$var$di(d, a);
                } catch (h) {
                    $0c04710c92712449$var$W(c, c.return, h);
                }
            }
            break;
        case 26:
            $0c04710c92712449$var$Ml(a, c);
            d & 512 && $0c04710c92712449$var$Bl(c, c.return);
            break;
        case 27:
        case 5:
            $0c04710c92712449$var$Ml(a, c);
            null === b && d & 4 && $0c04710c92712449$var$Kl(c);
            d & 512 && $0c04710c92712449$var$Bl(c, c.return);
            break;
        case 12:
            $0c04710c92712449$var$Ml(a, c);
            break;
        case 13:
            $0c04710c92712449$var$Ml(a, c);
            d & 4 && $0c04710c92712449$var$Nl(a, c);
            break;
        case 22:
            if (0 !== (c.mode & 1)) {
                if (e = null !== c.memoizedState || $0c04710c92712449$var$xl, !e) {
                    b = null !== b && null !== b.memoizedState || $0c04710c92712449$var$yl;
                    var f = $0c04710c92712449$var$xl, g = $0c04710c92712449$var$yl;
                    $0c04710c92712449$var$xl = e;
                    ($0c04710c92712449$var$yl = b) && !g ? $0c04710c92712449$var$Ol(a, c, 0 !== (c.subtreeFlags & 8772)) : $0c04710c92712449$var$Ml(a, c);
                    $0c04710c92712449$var$xl = f;
                    $0c04710c92712449$var$yl = g;
                }
            } else $0c04710c92712449$var$Ml(a, c);
            d & 512 && ("manual" === c.memoizedProps.mode ? $0c04710c92712449$var$Bl(c, c.return) : $0c04710c92712449$var$Cl(c, c.return));
            break;
        default:
            $0c04710c92712449$var$Ml(a, c);
    }
}
function $0c04710c92712449$var$Pl(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0c04710c92712449$var$Pl(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && $0c04710c92712449$var$na(b));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0c04710c92712449$var$Ql(a) {
    return 5 === a.tag || 3 === a.tag || 26 === a.tag || 27 === a.tag || 4 === a.tag;
}
function $0c04710c92712449$var$Rl(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0c04710c92712449$var$Ql(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 27 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0c04710c92712449$var$Sl(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0c04710c92712449$var$Tf));
    else if (4 !== d && 27 !== d && (a = a.child, null !== a)) for($0c04710c92712449$var$Sl(a, b, c), a = a.sibling; null !== a;)$0c04710c92712449$var$Sl(a, b, c), a = a.sibling;
}
function $0c04710c92712449$var$Tl(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && 27 !== d && (a = a.child, null !== a)) for($0c04710c92712449$var$Tl(a, b, c), a = a.sibling; null !== a;)$0c04710c92712449$var$Tl(a, b, c), a = a.sibling;
}
var $0c04710c92712449$var$X = null, $0c04710c92712449$var$Ul = !1;
function $0c04710c92712449$var$Vl(a, b, c) {
    for(c = c.child; null !== c;)$0c04710c92712449$var$Wl(a, b, c), c = c.sibling;
}
function $0c04710c92712449$var$Wl(a, b, c) {
    if ($0c04710c92712449$var$Gc && "function" === typeof $0c04710c92712449$var$Gc.onCommitFiberUnmount) try {
        $0c04710c92712449$var$Gc.onCommitFiberUnmount($0c04710c92712449$var$Fc, c);
    } catch (h) {}
    switch(c.tag){
        case 26:
            $0c04710c92712449$var$yl || $0c04710c92712449$var$Cl(c, b);
            $0c04710c92712449$var$Vl(a, b, c);
            c.memoizedState ? c.memoizedState.count-- : c.stateNode && (c = c.stateNode, c.parentNode.removeChild(c));
            break;
        case 27:
            $0c04710c92712449$var$yl || $0c04710c92712449$var$Cl(c, b);
            var d = $0c04710c92712449$var$X, e = $0c04710c92712449$var$Ul;
            $0c04710c92712449$var$X = c.stateNode;
            $0c04710c92712449$var$Vl(a, b, c);
            c = c.stateNode;
            for(a = c.attributes; a.length;)c.removeAttributeNode(a[0]);
            $0c04710c92712449$var$na(c);
            $0c04710c92712449$var$X = d;
            $0c04710c92712449$var$Ul = e;
            break;
        case 5:
            $0c04710c92712449$var$yl || $0c04710c92712449$var$Cl(c, b);
        case 6:
            d = $0c04710c92712449$var$X;
            e = $0c04710c92712449$var$Ul;
            $0c04710c92712449$var$X = null;
            $0c04710c92712449$var$Vl(a, b, c);
            $0c04710c92712449$var$X = d;
            $0c04710c92712449$var$Ul = e;
            null !== $0c04710c92712449$var$X && ($0c04710c92712449$var$Ul ? (a = $0c04710c92712449$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0c04710c92712449$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0c04710c92712449$var$X && ($0c04710c92712449$var$Ul ? (a = $0c04710c92712449$var$X, c = c.stateNode, 8 === a.nodeType ? $0c04710c92712449$var$Ng(a.parentNode, c) : 1 === a.nodeType && $0c04710c92712449$var$Ng(a, c), $0c04710c92712449$var$wd(a)) : $0c04710c92712449$var$Ng($0c04710c92712449$var$X, c.stateNode));
            break;
        case 4:
            d = $0c04710c92712449$var$X;
            e = $0c04710c92712449$var$Ul;
            $0c04710c92712449$var$X = c.stateNode.containerInfo;
            $0c04710c92712449$var$Ul = !0;
            $0c04710c92712449$var$Vl(a, b, c);
            $0c04710c92712449$var$X = d;
            $0c04710c92712449$var$Ul = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0c04710c92712449$var$yl && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0c04710c92712449$var$Dl(c, b, g) : 0 !== (f & 4) && $0c04710c92712449$var$Dl(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0c04710c92712449$var$Vl(a, b, c);
            break;
        case 1:
            if (!$0c04710c92712449$var$yl && ($0c04710c92712449$var$Cl(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0c04710c92712449$var$W(c, b, h);
            }
            $0c04710c92712449$var$Vl(a, b, c);
            break;
        case 21:
            $0c04710c92712449$var$Vl(a, b, c);
            break;
        case 22:
            $0c04710c92712449$var$Cl(c, b);
            c.mode & 1 ? ($0c04710c92712449$var$yl = (d = $0c04710c92712449$var$yl) || null !== c.memoizedState, $0c04710c92712449$var$Vl(a, b, c), $0c04710c92712449$var$yl = d) : $0c04710c92712449$var$Vl(a, b, c);
            break;
        default:
            $0c04710c92712449$var$Vl(a, b, c);
    }
}
function $0c04710c92712449$var$Nl(a, b) {
    if (null === b.memoizedState && (a = b.alternate, null !== a && (a = a.memoizedState, null !== a && (a = a.dehydrated, null !== a)))) try {
        $0c04710c92712449$var$wd(a);
    } catch (c) {
        $0c04710c92712449$var$W(b, b.return, c);
    }
}
function $0c04710c92712449$var$Xl(a) {
    switch(a.tag){
        case 13:
        case 19:
            var b = a.stateNode;
            null === b && (b = a.stateNode = new $0c04710c92712449$var$zl);
            return b;
        case 22:
            return a = a.stateNode, b = a._retryCache, null === b && (b = a._retryCache = new $0c04710c92712449$var$zl), b;
        default:
            throw Error($0c04710c92712449$var$q(435, a.tag));
    }
}
function $0c04710c92712449$var$Yl(a, b) {
    var c = $0c04710c92712449$var$Xl(a);
    b.forEach(function(d) {
        var e = $0c04710c92712449$var$Zl.bind(null, a, d);
        c.has(d) || (c.add(d), d.then(e, e));
    });
}
function $0c04710c92712449$var$$l(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 27:
                    case 5:
                        $0c04710c92712449$var$X = h.stateNode;
                        $0c04710c92712449$var$Ul = !1;
                        break a;
                    case 3:
                        $0c04710c92712449$var$X = h.stateNode.containerInfo;
                        $0c04710c92712449$var$Ul = !0;
                        break a;
                    case 4:
                        $0c04710c92712449$var$X = h.stateNode.containerInfo;
                        $0c04710c92712449$var$Ul = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0c04710c92712449$var$X) throw Error($0c04710c92712449$var$q(160));
            $0c04710c92712449$var$Wl(f, g, e);
            $0c04710c92712449$var$X = null;
            $0c04710c92712449$var$Ul = !1;
            var l = e.alternate;
            null !== l && (l.return = null);
            e.return = null;
        } catch (n) {
            $0c04710c92712449$var$W(e, b, n);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0c04710c92712449$var$am(b, a), b = b.sibling;
}
var $0c04710c92712449$var$bm = null;
function $0c04710c92712449$var$am(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0c04710c92712449$var$$l(b, a);
            $0c04710c92712449$var$cm(a);
            if (d & 4) {
                try {
                    $0c04710c92712449$var$Gl(3, a, a.return), $0c04710c92712449$var$Hl(3, a);
                } catch (v) {
                    $0c04710c92712449$var$W(a, a.return, v);
                }
                try {
                    $0c04710c92712449$var$Gl(5, a, a.return);
                } catch (v) {
                    $0c04710c92712449$var$W(a, a.return, v);
                }
            }
            break;
        case 1:
            $0c04710c92712449$var$$l(b, a);
            $0c04710c92712449$var$cm(a);
            d & 512 && null !== c && $0c04710c92712449$var$Cl(c, c.return);
            d & 64 && $0c04710c92712449$var$xl && (a = a.updateQueue, null !== a && (c = a.callbacks, null !== c && (d = a.shared.hiddenCallbacks, a.shared.hiddenCallbacks = null === d ? c : d.concat(c))));
            break;
        case 26:
            var e = $0c04710c92712449$var$bm;
            $0c04710c92712449$var$$l(b, a);
            $0c04710c92712449$var$cm(a);
            d & 512 && null !== c && $0c04710c92712449$var$Cl(c, c.return);
            if (d & 4) {
                if (b = null !== c ? c.memoizedState : null, d = a.memoizedState, null === c) {
                    if (null === d) {
                        if (null === a.stateNode) {
                            a: {
                                c = a.type;
                                d = a.memoizedProps;
                                b = e.ownerDocument || e;
                                e = b.getElementsByTagName(c);
                                var f = d.children;
                                f = Array.isArray(f) ? 1 === f.length ? f[0] : null : f;
                                f = "function" !== typeof f && "symbol" !== typeof f && null !== f && void 0 !== f ? "" + f : "";
                                var g = 0;
                                b: for(; g < e.length; g++){
                                    var h = e[g];
                                    if (!h[$0c04710c92712449$var$ma] && "http://www.w3.org/2000/svg" !== h.namespaceURI && h.textContent === f) {
                                        var l = 0;
                                        for(t in d){
                                            var n = d[t];
                                            if (d.hasOwnProperty(t)) {
                                                switch(t){
                                                    case "children":
                                                    case "defaultValue":
                                                    case "dangerouslySetInnerHTML":
                                                    case "defaultChecked":
                                                    case "innerHTML":
                                                    case "suppressContentEditableWarning":
                                                    case "suppressHydrationWarning":
                                                    case "style":
                                                        continue;
                                                    case "className":
                                                        if (h.getAttribute("class") !== "" + n) continue b;
                                                        break;
                                                    case "httpEquiv":
                                                        if (h.getAttribute("http-equiv") !== "" + n) continue b;
                                                        break;
                                                    case "contentEditable":
                                                    case "draggable":
                                                    case "spellCheck":
                                                        if (h.getAttribute(t) !== "" + n) continue b;
                                                        break;
                                                    case "async":
                                                    case "defer":
                                                    case "disabled":
                                                    case "hidden":
                                                    case "noModule":
                                                    case "scoped":
                                                    case "itemScope":
                                                        if (n !== h.hasAttribute(t)) continue b;
                                                        break;
                                                    default:
                                                        if ($0c04710c92712449$var$Da(t)) {
                                                            var w = t;
                                                            if (null == n && h.hasAttribute(w)) continue b;
                                                            if (h.getAttribute(w) !== "" + n) continue b;
                                                        }
                                                }
                                                l++;
                                            }
                                        }
                                        if (h.attributes.length !== l) continue b;
                                        h[$0c04710c92712449$var$ma] = !0;
                                        c = h;
                                        break a;
                                    }
                                }
                                var t = $0c04710c92712449$var$Uf(c, d, b, "http://www.w3.org/1999/xhtml");
                                $0c04710c92712449$var$Vf(t, c, d);
                                t[$0c04710c92712449$var$ea] = a;
                                t[$0c04710c92712449$var$ma] = !0;
                                b.head.insertBefore(t, "title" === c ? b.querySelector("head > title") : null);
                                c = t;
                            }
                            a.stateNode = c;
                        } else $0c04710c92712449$var$Dg(e, a.type, a.stateNode);
                    } else a.stateNode = $0c04710c92712449$var$Cg(e, d, a.memoizedProps);
                } else if (b !== d) null === b ? null !== c.stateNode && (c = c.stateNode, c.parentNode.removeChild(c)) : b.count--, null === d ? $0c04710c92712449$var$Dg(e, a.type, a.stateNode) : $0c04710c92712449$var$Cg(e, d, a.memoizedProps);
                else if (null === d && null !== a.stateNode && (d = a.updateQueue, a.updateQueue = null, null !== d)) try {
                    n = a.stateNode, w = a.memoizedProps, $0c04710c92712449$var$Wf(n, d, a.type, c.memoizedProps, w), n[$0c04710c92712449$var$fa] = w;
                } catch (v) {
                    $0c04710c92712449$var$W(a, a.return, v);
                }
            }
            break;
        case 27:
            if (d & 4 && null === a.alternate) {
                t = a.stateNode;
                e = a.memoizedProps;
                for(f = t.firstChild; f;)g = f.nextSibling, h = f.nodeName, f[$0c04710c92712449$var$ma] || "HEAD" === h || "BODY" === h || "STYLE" === h || "LINK" === h && "stylesheet" === f.rel.toLowerCase() || t.removeChild(f), f = g;
                f = a.type;
                for(g = t.attributes; g.length;)t.removeAttributeNode(g[0]);
                $0c04710c92712449$var$Vf(t, f, e);
                t[$0c04710c92712449$var$ea] = a;
                t[$0c04710c92712449$var$fa] = e;
            }
        case 5:
            $0c04710c92712449$var$$l(b, a);
            $0c04710c92712449$var$cm(a);
            d & 512 && null !== c && $0c04710c92712449$var$Cl(c, c.return);
            if (a.flags & 32) {
                t = a.stateNode;
                try {
                    $0c04710c92712449$var$Lb(t, "");
                } catch (v) {
                    $0c04710c92712449$var$W(a, a.return, v);
                }
            }
            if (d & 4 && (d = a.stateNode, null != d && (t = a.memoizedProps, c = null !== c ? c.memoizedProps : t, b = a.type, e = a.updateQueue, a.updateQueue = null, null !== e))) try {
                $0c04710c92712449$var$Wf(d, e, b, c, t), d[$0c04710c92712449$var$fa] = t;
            } catch (v) {
                $0c04710c92712449$var$W(a, a.return, v);
            }
            break;
        case 6:
            $0c04710c92712449$var$$l(b, a);
            $0c04710c92712449$var$cm(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0c04710c92712449$var$q(162));
                c = a.stateNode;
                d = a.memoizedProps;
                try {
                    c.nodeValue = d;
                } catch (v) {
                    $0c04710c92712449$var$W(a, a.return, v);
                }
            }
            break;
        case 3:
            t = $0c04710c92712449$var$bm;
            $0c04710c92712449$var$bm = $0c04710c92712449$var$qg(b.containerInfo);
            $0c04710c92712449$var$$l(b, a);
            $0c04710c92712449$var$bm = t;
            $0c04710c92712449$var$cm(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0c04710c92712449$var$wd(b.containerInfo);
            } catch (v) {
                $0c04710c92712449$var$W(a, a.return, v);
            }
            break;
        case 4:
            c = $0c04710c92712449$var$bm;
            $0c04710c92712449$var$bm = $0c04710c92712449$var$qg(a.stateNode.containerInfo);
            $0c04710c92712449$var$$l(b, a);
            $0c04710c92712449$var$cm(a);
            $0c04710c92712449$var$bm = c;
            break;
        case 13:
            $0c04710c92712449$var$$l(b, a);
            $0c04710c92712449$var$cm(a);
            c = a.child;
            c.flags & 8192 && null !== c.memoizedState && (null === c.alternate || null === c.alternate.memoizedState) && ($0c04710c92712449$var$dm = $0c04710c92712449$var$E());
            d & 4 && (c = a.updateQueue, null !== c && (a.updateQueue = null, $0c04710c92712449$var$Yl(a, c)));
            break;
        case 22:
            d & 512 && null !== c && $0c04710c92712449$var$Cl(c, c.return);
            t = null !== a.memoizedState;
            n = null !== c && null !== c.memoizedState;
            if (a.mode & 1) {
                w = $0c04710c92712449$var$xl;
                var u = $0c04710c92712449$var$yl;
                $0c04710c92712449$var$xl = w || t;
                $0c04710c92712449$var$yl = u || n;
                $0c04710c92712449$var$$l(b, a);
                $0c04710c92712449$var$yl = u;
                $0c04710c92712449$var$xl = w;
            } else $0c04710c92712449$var$$l(b, a);
            $0c04710c92712449$var$cm(a);
            b = a.stateNode;
            b._current = a;
            b._visibility &= -3;
            b._visibility |= b._pendingVisibility & 2;
            if (d & 8192 && (b._visibility = t ? b._visibility & -2 : b._visibility | 1, t && (b = $0c04710c92712449$var$xl || $0c04710c92712449$var$yl, null === c || n || b || 0 !== (a.mode & 1) && $0c04710c92712449$var$em(a)), null === a.memoizedProps || "manual" !== a.memoizedProps.mode)) a: for(c = null, b = a;;){
                if (5 === b.tag || 26 === b.tag || 27 === b.tag) {
                    if (null === c) {
                        c = b;
                        try {
                            e = b.stateNode, t ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (g = b.stateNode, h = b.memoizedProps.style, l = void 0 !== h && null !== h && h.hasOwnProperty("display") ? h.display : null, g.style.display = $0c04710c92712449$var$Ob("display", l));
                        } catch (v) {
                            $0c04710c92712449$var$W(a, a.return, v);
                        }
                    }
                } else if (6 === b.tag) {
                    if (null === c) try {
                        b.stateNode.nodeValue = t ? "" : b.memoizedProps;
                    } catch (v) {
                        $0c04710c92712449$var$W(a, a.return, v);
                    }
                } else if ((22 !== b.tag && 23 !== b.tag || null === b.memoizedState || b === a) && null !== b.child) {
                    b.child.return = b;
                    b = b.child;
                    continue;
                }
                if (b === a) break a;
                for(; null === b.sibling;){
                    if (null === b.return || b.return === a) break a;
                    c === b && (c = null);
                    b = b.return;
                }
                c === b && (c = null);
                b.sibling.return = b.return;
                b = b.sibling;
            }
            d & 4 && (c = a.updateQueue, null !== c && (d = c.wakeables, null !== d && (c.wakeables = null, $0c04710c92712449$var$Yl(a, d))));
            break;
        case 19:
            $0c04710c92712449$var$$l(b, a);
            $0c04710c92712449$var$cm(a);
            d & 4 && (c = a.updateQueue, null !== c && (a.updateQueue = null, $0c04710c92712449$var$Yl(a, c)));
            break;
        case 21:
            break;
        default:
            $0c04710c92712449$var$$l(b, a), $0c04710c92712449$var$cm(a);
    }
}
function $0c04710c92712449$var$cm(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            if (27 !== a.tag) {
                b: {
                    for(var c = a.return; null !== c;){
                        if ($0c04710c92712449$var$Ql(c)) {
                            var d = c;
                            break b;
                        }
                        c = c.return;
                    }
                    throw Error($0c04710c92712449$var$q(160));
                }
                switch(d.tag){
                    case 27:
                        var e = d.stateNode, f = $0c04710c92712449$var$Rl(a);
                        $0c04710c92712449$var$Tl(a, f, e);
                        break;
                    case 5:
                        var g = d.stateNode;
                        d.flags & 32 && ($0c04710c92712449$var$Lb(g, ""), d.flags &= -33);
                        var h = $0c04710c92712449$var$Rl(a);
                        $0c04710c92712449$var$Tl(a, h, g);
                        break;
                    case 3:
                    case 4:
                        var l = d.stateNode.containerInfo, n = $0c04710c92712449$var$Rl(a);
                        $0c04710c92712449$var$Sl(a, n, l);
                        break;
                    default:
                        throw Error($0c04710c92712449$var$q(161));
                }
            }
        } catch (w) {
            $0c04710c92712449$var$W(a, a.return, w);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0c04710c92712449$var$Ml(a, b) {
    if (b.subtreeFlags & 8772) for(b = b.child; null !== b;)$0c04710c92712449$var$Ll(a, b.alternate, b), b = b.sibling;
}
function $0c04710c92712449$var$em(a) {
    for(a = a.child; null !== a;){
        var b = a;
        switch(b.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $0c04710c92712449$var$Gl(4, b, b.return);
                $0c04710c92712449$var$em(b);
                break;
            case 1:
                $0c04710c92712449$var$Cl(b, b.return);
                var c = b.stateNode;
                if ("function" === typeof c.componentWillUnmount) {
                    var d = b, e = b.return;
                    try {
                        var f = d;
                        c.props = f.memoizedProps;
                        c.state = f.memoizedState;
                        c.componentWillUnmount();
                    } catch (g) {
                        $0c04710c92712449$var$W(d, e, g);
                    }
                }
                $0c04710c92712449$var$em(b);
                break;
            case 26:
            case 27:
            case 5:
                $0c04710c92712449$var$Cl(b, b.return);
                $0c04710c92712449$var$em(b);
                break;
            case 22:
                $0c04710c92712449$var$Cl(b, b.return);
                null === b.memoizedState && $0c04710c92712449$var$em(b);
                break;
            default:
                $0c04710c92712449$var$em(b);
        }
        a = a.sibling;
    }
}
function $0c04710c92712449$var$Ol(a, b, c) {
    c = c && 0 !== (b.subtreeFlags & 8772);
    for(b = b.child; null !== b;){
        var d = b.alternate, e = a, f = b, g = f.flags;
        switch(f.tag){
            case 0:
            case 11:
            case 15:
                $0c04710c92712449$var$Ol(e, f, c);
                $0c04710c92712449$var$Il(f, 4);
                break;
            case 1:
                $0c04710c92712449$var$Ol(e, f, c);
                e = f.stateNode;
                if ("function" === typeof e.componentDidMount) try {
                    e.componentDidMount();
                } catch (l) {
                    $0c04710c92712449$var$W(f, f.return, l);
                }
                d = f.updateQueue;
                if (null !== d) {
                    var h = d.shared.hiddenCallbacks;
                    if (null !== h) for(d.shared.hiddenCallbacks = null, d = 0; d < h.length; d++)$0c04710c92712449$var$ci(h[d], e);
                }
                c && g & 64 && $0c04710c92712449$var$Jl(f);
                $0c04710c92712449$var$Bl(f, f.return);
                break;
            case 26:
            case 27:
            case 5:
                $0c04710c92712449$var$Ol(e, f, c);
                c && null === d && g & 4 && $0c04710c92712449$var$Kl(f);
                $0c04710c92712449$var$Bl(f, f.return);
                break;
            case 12:
                $0c04710c92712449$var$Ol(e, f, c);
                break;
            case 13:
                $0c04710c92712449$var$Ol(e, f, c);
                c && g & 4 && $0c04710c92712449$var$Nl(e, f);
                break;
            case 22:
                null === f.memoizedState && $0c04710c92712449$var$Ol(e, f, c);
                $0c04710c92712449$var$Bl(f, f.return);
                break;
            default:
                $0c04710c92712449$var$Ol(e, f, c);
        }
        b = b.sibling;
    }
}
function $0c04710c92712449$var$fm(a, b) {
    try {
        $0c04710c92712449$var$Hl(b, a);
    } catch (c) {
        $0c04710c92712449$var$W(a, a.return, c);
    }
}
function $0c04710c92712449$var$gm(a, b) {
    var c = null;
    null !== a && null !== a.memoizedState && null !== a.memoizedState.cachePool && (c = a.memoizedState.cachePool.pool);
    a = null;
    null !== b.memoizedState && null !== b.memoizedState.cachePool && (a = b.memoizedState.cachePool.pool);
    a !== c && (null != a && a.refCount++, null != c && $0c04710c92712449$var$kl(c));
}
function $0c04710c92712449$var$hm(a, b) {
    a = null;
    null !== b.alternate && (a = b.alternate.memoizedState.cache);
    b = b.memoizedState.cache;
    b !== a && (b.refCount++, null != a && $0c04710c92712449$var$kl(a));
}
function $0c04710c92712449$var$im(a, b, c, d) {
    if (b.subtreeFlags & 10256) for(b = b.child; null !== b;)$0c04710c92712449$var$jm(a, b, c, d), b = b.sibling;
}
function $0c04710c92712449$var$jm(a, b, c, d) {
    var e = b.flags;
    switch(b.tag){
        case 0:
        case 11:
        case 15:
            $0c04710c92712449$var$im(a, b, c, d);
            e & 2048 && $0c04710c92712449$var$fm(b, 9);
            break;
        case 3:
            $0c04710c92712449$var$im(a, b, c, d);
            e & 2048 && (a = null, null !== b.alternate && (a = b.alternate.memoizedState.cache), b = b.memoizedState.cache, b !== a && (b.refCount++, null != a && $0c04710c92712449$var$kl(a)));
            break;
        case 23:
            break;
        case 22:
            var f = b.stateNode;
            null !== b.memoizedState ? f._visibility & 4 ? $0c04710c92712449$var$im(a, b, c, d) : b.mode & 1 ? $0c04710c92712449$var$km(a, b) : (f._visibility |= 4, $0c04710c92712449$var$im(a, b, c, d)) : f._visibility & 4 ? $0c04710c92712449$var$im(a, b, c, d) : (f._visibility |= 4, $0c04710c92712449$var$lm(a, b, c, d, 0 !== (b.subtreeFlags & 10256)));
            e & 2048 && $0c04710c92712449$var$gm(b.alternate, b);
            break;
        case 24:
            $0c04710c92712449$var$im(a, b, c, d);
            e & 2048 && $0c04710c92712449$var$hm(b.alternate, b);
            break;
        default:
            $0c04710c92712449$var$im(a, b, c, d);
    }
}
function $0c04710c92712449$var$lm(a, b, c, d, e) {
    e = e && 0 !== (b.subtreeFlags & 10256);
    for(b = b.child; null !== b;){
        var f = a, g = b, h = c, l = d, n = g.flags;
        switch(g.tag){
            case 0:
            case 11:
            case 15:
                $0c04710c92712449$var$lm(f, g, h, l, e);
                $0c04710c92712449$var$fm(g, 8);
                break;
            case 23:
                break;
            case 22:
                var w = g.stateNode;
                null !== g.memoizedState ? w._visibility & 4 ? $0c04710c92712449$var$lm(f, g, h, l, e) : g.mode & 1 ? $0c04710c92712449$var$km(f, g) : (w._visibility |= 4, $0c04710c92712449$var$lm(f, g, h, l, e)) : (w._visibility |= 4, $0c04710c92712449$var$lm(f, g, h, l, e));
                e && n & 2048 && $0c04710c92712449$var$gm(g.alternate, g);
                break;
            case 24:
                $0c04710c92712449$var$lm(f, g, h, l, e);
                e && n & 2048 && $0c04710c92712449$var$hm(g.alternate, g);
                break;
            default:
                $0c04710c92712449$var$lm(f, g, h, l, e);
        }
        b = b.sibling;
    }
}
function $0c04710c92712449$var$km(a, b) {
    if (b.subtreeFlags & 10256) for(b = b.child; null !== b;){
        var c = a, d = b, e = d.flags;
        switch(d.tag){
            case 22:
                $0c04710c92712449$var$km(c, d);
                e & 2048 && $0c04710c92712449$var$gm(d.alternate, d);
                break;
            case 24:
                $0c04710c92712449$var$km(c, d);
                e & 2048 && $0c04710c92712449$var$hm(d.alternate, d);
                break;
            default:
                $0c04710c92712449$var$km(c, d);
        }
        b = b.sibling;
    }
}
function $0c04710c92712449$var$mm(a) {
    var b = a.alternate;
    if (null !== b && (a = b.child, null !== a)) {
        b.child = null;
        do b = a.sibling, a.sibling = null, a = b;
        while (null !== a);
    }
}
function $0c04710c92712449$var$nm(a) {
    var b = a.deletions;
    if (0 !== (a.flags & 16)) {
        if (null !== b) for(var c = 0; c < b.length; c++){
            var d = b[c];
            $0c04710c92712449$var$Al = d;
            $0c04710c92712449$var$om(d, a);
        }
        $0c04710c92712449$var$mm(a);
    }
    if (a.subtreeFlags & 10256) for(a = a.child; null !== a;)$0c04710c92712449$var$pm(a), a = a.sibling;
}
function $0c04710c92712449$var$pm(a) {
    switch(a.tag){
        case 0:
        case 11:
        case 15:
            $0c04710c92712449$var$nm(a);
            a.flags & 2048 && $0c04710c92712449$var$Gl(9, a, a.return);
            break;
        case 22:
            var b = a.stateNode;
            null !== a.memoizedState && b._visibility & 4 && (null === a.return || 13 !== a.return.tag) ? (b._visibility &= -5, $0c04710c92712449$var$qm(a)) : $0c04710c92712449$var$nm(a);
            break;
        default:
            $0c04710c92712449$var$nm(a);
    }
}
function $0c04710c92712449$var$qm(a) {
    var b = a.deletions;
    if (0 !== (a.flags & 16)) {
        if (null !== b) for(var c = 0; c < b.length; c++){
            var d = b[c];
            $0c04710c92712449$var$Al = d;
            $0c04710c92712449$var$om(d, a);
        }
        $0c04710c92712449$var$mm(a);
    }
    for(a = a.child; null !== a;){
        b = a;
        switch(b.tag){
            case 0:
            case 11:
            case 15:
                $0c04710c92712449$var$Gl(8, b, b.return);
                $0c04710c92712449$var$qm(b);
                break;
            case 22:
                c = b.stateNode;
                c._visibility & 4 && (c._visibility &= -5, $0c04710c92712449$var$qm(b));
                break;
            default:
                $0c04710c92712449$var$qm(b);
        }
        a = a.sibling;
    }
}
function $0c04710c92712449$var$om(a, b) {
    for(; null !== $0c04710c92712449$var$Al;){
        var c = $0c04710c92712449$var$Al;
        switch(c.tag){
            case 0:
            case 11:
            case 15:
                $0c04710c92712449$var$Gl(8, c, b);
                break;
            case 23:
            case 22:
                if (null !== c.memoizedState && null !== c.memoizedState.cachePool) {
                    var d = c.memoizedState.cachePool.pool;
                    null != d && d.refCount++;
                }
                break;
            case 24:
                $0c04710c92712449$var$kl(c.memoizedState.cache);
        }
        d = c.child;
        if (null !== d) d.return = c, $0c04710c92712449$var$Al = d;
        else a: for(c = a; null !== $0c04710c92712449$var$Al;){
            d = $0c04710c92712449$var$Al;
            var e = d.sibling, f = d.return;
            $0c04710c92712449$var$Pl(d);
            if (d === c) {
                $0c04710c92712449$var$Al = null;
                break a;
            }
            if (null !== e) {
                e.return = f;
                $0c04710c92712449$var$Al = e;
                break a;
            }
            $0c04710c92712449$var$Al = f;
        }
    }
}
var $0c04710c92712449$var$rm = {
    getCacheSignal: function() {
        return $0c04710c92712449$var$ij($0c04710c92712449$var$T).controller.signal;
    },
    getCacheForType: function(a) {
        var b = $0c04710c92712449$var$ij($0c04710c92712449$var$T), c = b.data.get(a);
        void 0 === c && (c = a(), b.data.set(a, c));
        return c;
    }
}, $0c04710c92712449$var$sm = Math.ceil, $0c04710c92712449$var$tm = "function" === typeof WeakMap ? WeakMap : Map, $0c04710c92712449$var$um = $0c04710c92712449$var$Ma.ReactCurrentDispatcher, $0c04710c92712449$var$vm = $0c04710c92712449$var$Ma.ReactCurrentCache, $0c04710c92712449$var$wm = $0c04710c92712449$var$Ma.ReactCurrentOwner, $0c04710c92712449$var$xm = $0c04710c92712449$var$Ma.ReactCurrentBatchConfig, $0c04710c92712449$var$L = 0, $0c04710c92712449$var$S = null, $0c04710c92712449$var$Y = null, $0c04710c92712449$var$M = 0, $0c04710c92712449$var$ym = 0, $0c04710c92712449$var$zm = null, $0c04710c92712449$var$Am = !1, $0c04710c92712449$var$si = 0, $0c04710c92712449$var$V = 0, $0c04710c92712449$var$Bm = null, $0c04710c92712449$var$bi = 0, $0c04710c92712449$var$Cm = 0, $0c04710c92712449$var$Dm = 0, $0c04710c92712449$var$Em = null, $0c04710c92712449$var$Fm = null, $0c04710c92712449$var$dm = 0, $0c04710c92712449$var$ul = Infinity, $0c04710c92712449$var$Gm = null, $0c04710c92712449$var$kk = !1, $0c04710c92712449$var$lk = null, $0c04710c92712449$var$nk = null, $0c04710c92712449$var$Hm = !1, $0c04710c92712449$var$Im = null, $0c04710c92712449$var$Jm = 0, $0c04710c92712449$var$Km = 0, $0c04710c92712449$var$Lm = null, $0c04710c92712449$var$Sh = 0, $0c04710c92712449$var$Th = null, $0c04710c92712449$var$Mm = -1, $0c04710c92712449$var$Nm = 0;
function $0c04710c92712449$var$Tj() {
    return 0 !== ($0c04710c92712449$var$L & 6) ? $0c04710c92712449$var$E() : -1 !== $0c04710c92712449$var$Mm ? $0c04710c92712449$var$Mm : $0c04710c92712449$var$Mm = $0c04710c92712449$var$E();
}
function $0c04710c92712449$var$Sj(a) {
    if (0 === (a.mode & 1)) return 2;
    if (0 !== ($0c04710c92712449$var$L & 2) && 0 !== $0c04710c92712449$var$M) return $0c04710c92712449$var$M & -$0c04710c92712449$var$M;
    if (null !== $0c04710c92712449$var$ll.transition) return 0 === $0c04710c92712449$var$Nm && ($0c04710c92712449$var$Nm = $0c04710c92712449$var$Tc()), $0c04710c92712449$var$Nm;
    a = $0c04710c92712449$var$G;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 32 : $0c04710c92712449$var$Ed(a.type);
    return a;
}
function $0c04710c92712449$var$xj(a, b, c, d) {
    2 === $0c04710c92712449$var$ym && a === $0c04710c92712449$var$S && ($0c04710c92712449$var$Om(a, 0), $0c04710c92712449$var$Pm(a, $0c04710c92712449$var$M));
    $0c04710c92712449$var$Vc(a, c, d);
    if (0 === ($0c04710c92712449$var$L & 2) || a !== $0c04710c92712449$var$S) a === $0c04710c92712449$var$S && (0 === ($0c04710c92712449$var$L & 2) && ($0c04710c92712449$var$Cm |= c), 4 === $0c04710c92712449$var$V && $0c04710c92712449$var$Pm(a, $0c04710c92712449$var$M)), $0c04710c92712449$var$Qm(a, d), 2 === c && 0 === $0c04710c92712449$var$L && 0 === (b.mode & 1) && ($0c04710c92712449$var$ul = $0c04710c92712449$var$E() + 500, $0c04710c92712449$var$eh && $0c04710c92712449$var$ih());
}
function $0c04710c92712449$var$Qm(a, b) {
    var c = a.callbackNode;
    $0c04710c92712449$var$Rc(a, b);
    var d = $0c04710c92712449$var$Pc(a, a === $0c04710c92712449$var$S ? $0c04710c92712449$var$M : 0);
    if (0 === d) null !== c && $0c04710c92712449$var$wc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0c04710c92712449$var$wc(c);
        if (0 !== (b & 3)) 0 === a.tag ? $0c04710c92712449$var$hh($0c04710c92712449$var$Rm.bind(null, a)) : $0c04710c92712449$var$gh($0c04710c92712449$var$Rm.bind(null, a)), $0c04710c92712449$var$Mg(function() {
            0 === ($0c04710c92712449$var$L & 6) && $0c04710c92712449$var$ih();
        }), c = null;
        else {
            switch($0c04710c92712449$var$Zc(d)){
                case 2:
                    c = $0c04710c92712449$var$Ac;
                    break;
                case 8:
                    c = $0c04710c92712449$var$Bc;
                    break;
                case 32:
                    c = $0c04710c92712449$var$Cc;
                    break;
                case 536870912:
                    c = $0c04710c92712449$var$Ec;
                    break;
                default:
                    c = $0c04710c92712449$var$Cc;
            }
            c = $0c04710c92712449$var$Sm(c, $0c04710c92712449$var$Tm.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0c04710c92712449$var$Tm(a, b) {
    $0c04710c92712449$var$Mm = -1;
    $0c04710c92712449$var$Nm = 0;
    if (0 !== ($0c04710c92712449$var$L & 6)) throw Error($0c04710c92712449$var$q(327));
    var c = a.callbackNode;
    if ($0c04710c92712449$var$Um() && a.callbackNode !== c) return null;
    var d = $0c04710c92712449$var$Pc(a, a === $0c04710c92712449$var$S ? $0c04710c92712449$var$M : 0);
    if (0 === d) return null;
    b = 0 !== (d & 60) || 0 !== (d & a.expiredLanes) || b ? $0c04710c92712449$var$Vm(a, d) : $0c04710c92712449$var$Wm(a, d);
    if (0 !== b) {
        if (2 === b) {
            var e = d, f = $0c04710c92712449$var$Sc(a, e);
            0 !== f && (d = f, b = $0c04710c92712449$var$Xm(a, e, f));
        }
        if (1 === b) throw c = $0c04710c92712449$var$Bm, $0c04710c92712449$var$Om(a, 0), $0c04710c92712449$var$Pm(a, d), $0c04710c92712449$var$Qm(a, $0c04710c92712449$var$E()), c;
        if (6 === b) $0c04710c92712449$var$Pm(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 60) && !$0c04710c92712449$var$Ym(e)) {
                b = $0c04710c92712449$var$Vm(a, d);
                if (2 === b) {
                    f = d;
                    var g = $0c04710c92712449$var$Sc(a, f);
                    0 !== g && (d = g, b = $0c04710c92712449$var$Xm(a, f, g));
                }
                if (1 === b) throw c = $0c04710c92712449$var$Bm, $0c04710c92712449$var$Om(a, 0), $0c04710c92712449$var$Pm(a, d), $0c04710c92712449$var$Qm(a, $0c04710c92712449$var$E()), c;
            }
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0c04710c92712449$var$q(345));
                case 2:
                    $0c04710c92712449$var$Zm(a, $0c04710c92712449$var$Fm, $0c04710c92712449$var$Gm);
                    break;
                case 3:
                    $0c04710c92712449$var$Pm(a, d);
                    if ((d & 125829120) === d && (d = $0c04710c92712449$var$dm + 500 - $0c04710c92712449$var$E(), 10 < d)) {
                        if (0 !== $0c04710c92712449$var$Pc(a, 0)) break;
                        a.timeoutHandle = $0c04710c92712449$var$Ig($0c04710c92712449$var$Zm.bind(null, a, $0c04710c92712449$var$Fm, $0c04710c92712449$var$Gm), d);
                        break;
                    }
                    $0c04710c92712449$var$Zm(a, $0c04710c92712449$var$Fm, $0c04710c92712449$var$Gm);
                    break;
                case 4:
                    $0c04710c92712449$var$Pm(a, d);
                    if ((d & 8388480) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;)g = 31 - $0c04710c92712449$var$Jc(d), f = 1 << g, g = b[g], g > e && (e = g), d &= ~f;
                    d = e;
                    d = $0c04710c92712449$var$E() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0c04710c92712449$var$sm(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0c04710c92712449$var$Ig($0c04710c92712449$var$Zm.bind(null, a, $0c04710c92712449$var$Fm, $0c04710c92712449$var$Gm), d);
                        break;
                    }
                    $0c04710c92712449$var$Zm(a, $0c04710c92712449$var$Fm, $0c04710c92712449$var$Gm);
                    break;
                case 5:
                    $0c04710c92712449$var$Zm(a, $0c04710c92712449$var$Fm, $0c04710c92712449$var$Gm);
                    break;
                default:
                    throw Error($0c04710c92712449$var$q(329));
            }
        }
    }
    $0c04710c92712449$var$Qm(a, $0c04710c92712449$var$E());
    return a.callbackNode === c ? 2 === $0c04710c92712449$var$ym && $0c04710c92712449$var$S === a ? (a.callbackPriority = 0, a.callbackNode = null) : $0c04710c92712449$var$Tm.bind(null, a) : null;
}
function $0c04710c92712449$var$Xm(a, b, c) {
    var d = $0c04710c92712449$var$Em, e = a.current.memoizedState.isDehydrated;
    e && ($0c04710c92712449$var$Om(a, c).flags |= 256);
    c = $0c04710c92712449$var$Vm(a, c);
    if (2 !== c) {
        if ($0c04710c92712449$var$Am && !e) return a.errorRecoveryDisabledLanes |= b, $0c04710c92712449$var$Cm |= b, 4;
        a = $0c04710c92712449$var$Fm;
        $0c04710c92712449$var$Fm = d;
        null !== a && $0c04710c92712449$var$sl(a);
    }
    return c;
}
function $0c04710c92712449$var$sl(a) {
    null === $0c04710c92712449$var$Fm ? $0c04710c92712449$var$Fm = a : $0c04710c92712449$var$Fm.push.apply($0c04710c92712449$var$Fm, a);
}
function $0c04710c92712449$var$Ym(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0c04710c92712449$var$af(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0c04710c92712449$var$Pm(a, b) {
    b &= ~$0c04710c92712449$var$Dm;
    b &= ~$0c04710c92712449$var$Cm;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0c04710c92712449$var$Jc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0c04710c92712449$var$Rm(a) {
    if (0 !== ($0c04710c92712449$var$L & 6)) throw Error($0c04710c92712449$var$q(327));
    $0c04710c92712449$var$Um();
    var b = $0c04710c92712449$var$Pc(a, 0);
    if (0 === (b & 3)) return $0c04710c92712449$var$Qm(a, $0c04710c92712449$var$E()), null;
    var c = $0c04710c92712449$var$Vm(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = b, e = $0c04710c92712449$var$Sc(a, d);
        0 !== e && (b = e, c = $0c04710c92712449$var$Xm(a, d, e));
    }
    if (1 === c) throw c = $0c04710c92712449$var$Bm, $0c04710c92712449$var$Om(a, 0), $0c04710c92712449$var$Pm(a, b), $0c04710c92712449$var$Qm(a, $0c04710c92712449$var$E()), c;
    if (6 === c) return $0c04710c92712449$var$Pm(a, b), $0c04710c92712449$var$Qm(a, $0c04710c92712449$var$E()), null;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0c04710c92712449$var$Zm(a, $0c04710c92712449$var$Fm, $0c04710c92712449$var$Gm);
    $0c04710c92712449$var$Qm(a, $0c04710c92712449$var$E());
    return null;
}
function $0c04710c92712449$var$$m(a, b) {
    var c = $0c04710c92712449$var$L;
    $0c04710c92712449$var$L |= 1;
    try {
        return a(b);
    } finally{
        $0c04710c92712449$var$L = c, 0 === $0c04710c92712449$var$L && ($0c04710c92712449$var$ul = $0c04710c92712449$var$E() + 500, $0c04710c92712449$var$eh && $0c04710c92712449$var$ih());
    }
}
function $0c04710c92712449$var$an(a) {
    null !== $0c04710c92712449$var$Im && 0 === $0c04710c92712449$var$Im.tag && 0 === ($0c04710c92712449$var$L & 6) && $0c04710c92712449$var$Um();
    var b = $0c04710c92712449$var$L;
    $0c04710c92712449$var$L |= 1;
    var c = $0c04710c92712449$var$xm.transition, d = $0c04710c92712449$var$G;
    try {
        if ($0c04710c92712449$var$xm.transition = null, $0c04710c92712449$var$G = 2, a) return a();
    } finally{
        $0c04710c92712449$var$G = d, $0c04710c92712449$var$xm.transition = c, $0c04710c92712449$var$L = b, 0 === ($0c04710c92712449$var$L & 6) && $0c04710c92712449$var$ih();
    }
}
function $0c04710c92712449$var$bn() {
    if (null !== $0c04710c92712449$var$Y) {
        if (0 === $0c04710c92712449$var$ym) var a = $0c04710c92712449$var$Y.return;
        else $0c04710c92712449$var$el(), $0c04710c92712449$var$dj(), a = $0c04710c92712449$var$Y;
        for(; null !== a;)$0c04710c92712449$var$wl(a.alternate, a), a = a.return;
        $0c04710c92712449$var$Y = null;
    }
}
function $0c04710c92712449$var$Om(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0c04710c92712449$var$Jg(c));
    $0c04710c92712449$var$bn();
    $0c04710c92712449$var$S = a;
    $0c04710c92712449$var$Y = a = $0c04710c92712449$var$ii(a.current, null);
    $0c04710c92712449$var$M = $0c04710c92712449$var$si = b;
    $0c04710c92712449$var$ym = 0;
    $0c04710c92712449$var$zm = null;
    $0c04710c92712449$var$Am = !1;
    $0c04710c92712449$var$V = 0;
    $0c04710c92712449$var$Bm = null;
    $0c04710c92712449$var$Dm = $0c04710c92712449$var$Cm = $0c04710c92712449$var$bi = 0;
    $0c04710c92712449$var$Fm = $0c04710c92712449$var$Em = null;
    $0c04710c92712449$var$Nh();
    return a;
}
function $0c04710c92712449$var$cn(a, b) {
    $0c04710c92712449$var$Ki.current = $0c04710c92712449$var$$i;
    $0c04710c92712449$var$wm.current = null;
    if (b === $0c04710c92712449$var$Fi) {
        if (null === $0c04710c92712449$var$Ji) throw Error($0c04710c92712449$var$q(459));
        a = $0c04710c92712449$var$Ji;
        $0c04710c92712449$var$Ji = null;
        b = a;
        $0c04710c92712449$var$ym = $0c04710c92712449$var$dn() ? 2 : 3;
    } else $0c04710c92712449$var$ym = b === $0c04710c92712449$var$qk ? 6 : null !== b && "object" === typeof b && "function" === typeof b.then ? 4 : 1;
    $0c04710c92712449$var$zm = b;
    null === $0c04710c92712449$var$Y && ($0c04710c92712449$var$V = 1, $0c04710c92712449$var$Bm = b);
}
function $0c04710c92712449$var$dn() {
    if (0 !== ($0c04710c92712449$var$bi & 268435455) || 0 !== ($0c04710c92712449$var$Cm & 268435455)) return !1;
    if (($0c04710c92712449$var$M & 8388480) === $0c04710c92712449$var$M) return null === $0c04710c92712449$var$wi;
    var a = $0c04710c92712449$var$vi.current;
    return null !== a && ($0c04710c92712449$var$M & 125829120) === $0c04710c92712449$var$M ? a === $0c04710c92712449$var$wi : !1;
}
function $0c04710c92712449$var$en(a) {
    a = $0c04710c92712449$var$qg(a);
    $0c04710c92712449$var$hg = a.ownerDocument || a;
    $0c04710c92712449$var$ig = $0c04710c92712449$var$gg.current;
    $0c04710c92712449$var$gg.current = $0c04710c92712449$var$ng;
    a = $0c04710c92712449$var$um.current;
    $0c04710c92712449$var$um.current = $0c04710c92712449$var$$i;
    return null === a ? $0c04710c92712449$var$$i : a;
}
function $0c04710c92712449$var$fn() {
    var a = $0c04710c92712449$var$vm.current;
    $0c04710c92712449$var$vm.current = $0c04710c92712449$var$rm;
    return a;
}
function $0c04710c92712449$var$Tk() {
    $0c04710c92712449$var$V = 4;
    null === $0c04710c92712449$var$S || 0 === ($0c04710c92712449$var$bi & 268435455) && 0 === ($0c04710c92712449$var$Cm & 268435455) || $0c04710c92712449$var$Pm($0c04710c92712449$var$S, $0c04710c92712449$var$M);
}
function $0c04710c92712449$var$Vm(a, b) {
    var c = $0c04710c92712449$var$L;
    $0c04710c92712449$var$L |= 2;
    var d = $0c04710c92712449$var$en(a.containerInfo), e = $0c04710c92712449$var$fn();
    if ($0c04710c92712449$var$S !== a || $0c04710c92712449$var$M !== b) $0c04710c92712449$var$Gm = null, $0c04710c92712449$var$Om(a, b);
    a: for(;;)try {
        if (0 !== $0c04710c92712449$var$ym && null !== $0c04710c92712449$var$Y) {
            b = $0c04710c92712449$var$Y;
            var f = $0c04710c92712449$var$zm;
            switch($0c04710c92712449$var$ym){
                case 6:
                    $0c04710c92712449$var$bn();
                    $0c04710c92712449$var$V = 6;
                    break a;
                default:
                    $0c04710c92712449$var$ym = 0, $0c04710c92712449$var$zm = null, $0c04710c92712449$var$hn(b, f);
            }
        }
        $0c04710c92712449$var$jn();
        break;
    } catch (g) {
        $0c04710c92712449$var$cn(a, g);
    }
    $0c04710c92712449$var$el();
    $0c04710c92712449$var$L = c;
    $0c04710c92712449$var$gg.current = $0c04710c92712449$var$ig;
    $0c04710c92712449$var$ig = null;
    $0c04710c92712449$var$um.current = d;
    $0c04710c92712449$var$vm.current = e;
    if (null !== $0c04710c92712449$var$Y) throw Error($0c04710c92712449$var$q(261));
    $0c04710c92712449$var$S = null;
    $0c04710c92712449$var$M = 0;
    $0c04710c92712449$var$Nh();
    return $0c04710c92712449$var$V;
}
function $0c04710c92712449$var$jn() {
    for(; null !== $0c04710c92712449$var$Y;)$0c04710c92712449$var$kn($0c04710c92712449$var$Y);
}
function $0c04710c92712449$var$Wm(a, b) {
    var c = $0c04710c92712449$var$L;
    $0c04710c92712449$var$L |= 2;
    var d = $0c04710c92712449$var$en(a.containerInfo), e = $0c04710c92712449$var$fn();
    if ($0c04710c92712449$var$S !== a || $0c04710c92712449$var$M !== b) $0c04710c92712449$var$Gm = null, $0c04710c92712449$var$ul = $0c04710c92712449$var$E() + 500, $0c04710c92712449$var$Om(a, b);
    a: do try {
        if (0 !== $0c04710c92712449$var$ym && null !== $0c04710c92712449$var$Y) {
            b = $0c04710c92712449$var$Y;
            var f = $0c04710c92712449$var$zm;
            switch($0c04710c92712449$var$ym){
                case 1:
                    $0c04710c92712449$var$ym = 0;
                    $0c04710c92712449$var$zm = null;
                    $0c04710c92712449$var$hn(b, f);
                    break;
                case 2:
                    if ($0c04710c92712449$var$Gi(f)) {
                        $0c04710c92712449$var$ym = 0;
                        $0c04710c92712449$var$zm = null;
                        $0c04710c92712449$var$ln(b);
                        break;
                    }
                    b = function() {
                        $0c04710c92712449$var$Qm(a, $0c04710c92712449$var$E());
                    };
                    f.then(b, b);
                    break a;
                case 3:
                    $0c04710c92712449$var$ym = 5;
                    break a;
                case 5:
                    $0c04710c92712449$var$Gi(f) ? ($0c04710c92712449$var$ym = 0, $0c04710c92712449$var$zm = null, $0c04710c92712449$var$ln(b)) : ($0c04710c92712449$var$ym = 0, $0c04710c92712449$var$zm = null, $0c04710c92712449$var$hn(b, f));
                    break;
                case 4:
                    $0c04710c92712449$var$ym = 0;
                    $0c04710c92712449$var$zm = null;
                    $0c04710c92712449$var$hn(b, f);
                    break;
                case 6:
                    $0c04710c92712449$var$bn();
                    $0c04710c92712449$var$V = 6;
                    break a;
                default:
                    throw Error($0c04710c92712449$var$q(462));
            }
        }
        $0c04710c92712449$var$mn();
        break;
    } catch (g) {
        $0c04710c92712449$var$cn(a, g);
    }
    while (1);
    $0c04710c92712449$var$el();
    $0c04710c92712449$var$gg.current = $0c04710c92712449$var$ig;
    $0c04710c92712449$var$ig = null;
    $0c04710c92712449$var$um.current = d;
    $0c04710c92712449$var$vm.current = e;
    $0c04710c92712449$var$L = c;
    if (null !== $0c04710c92712449$var$Y) return 0;
    $0c04710c92712449$var$S = null;
    $0c04710c92712449$var$M = 0;
    $0c04710c92712449$var$Nh();
    return $0c04710c92712449$var$V;
}
function $0c04710c92712449$var$mn() {
    for(; null !== $0c04710c92712449$var$Y && !$0c04710c92712449$var$xc();)$0c04710c92712449$var$kn($0c04710c92712449$var$Y);
}
function $0c04710c92712449$var$kn(a) {
    var b = $0c04710c92712449$var$nn(a.alternate, a, $0c04710c92712449$var$si);
    a.memoizedProps = a.pendingProps;
    null === b ? $0c04710c92712449$var$on(a) : $0c04710c92712449$var$Y = b;
    $0c04710c92712449$var$wm.current = null;
}
function $0c04710c92712449$var$ln(a) {
    var b = a.alternate;
    switch(a.tag){
        case 2:
            a.tag = 0;
        case 0:
        case 11:
            var c = a.type, d = a.pendingProps;
            d = a.elementType === c ? d : $0c04710c92712449$var$Zj(c, d);
            b = $0c04710c92712449$var$Ek(b, a, d, c, $0c04710c92712449$var$M);
            break;
        case 15:
            b = $0c04710c92712449$var$Ek(b, a, a.pendingProps, a.type, $0c04710c92712449$var$M);
            break;
        default:
            $0c04710c92712449$var$el(), $0c04710c92712449$var$dj(), $0c04710c92712449$var$wl(b, a), a = $0c04710c92712449$var$Y = $0c04710c92712449$var$tl(a, $0c04710c92712449$var$si), b = $0c04710c92712449$var$nn(b, a, $0c04710c92712449$var$si);
    }
    a.memoizedProps = a.pendingProps;
    null === b ? $0c04710c92712449$var$on(a) : $0c04710c92712449$var$Y = b;
    $0c04710c92712449$var$wm.current = null;
}
function $0c04710c92712449$var$hn(a, b) {
    $0c04710c92712449$var$el();
    $0c04710c92712449$var$dj();
    var c = a.return;
    if (null === c || null === $0c04710c92712449$var$S) $0c04710c92712449$var$V = 1, $0c04710c92712449$var$Bm = b, $0c04710c92712449$var$Y = null;
    else {
        try {
            a: {
                var d = $0c04710c92712449$var$S, e = b;
                b = $0c04710c92712449$var$M;
                a.flags |= 32768;
                if (null !== e && "object" === typeof e && "function" === typeof e.then) {
                    var f = e, g = a.tag;
                    if (0 === (a.mode & 1) && (0 === g || 11 === g || 15 === g)) {
                        var h = a.alternate;
                        h ? (a.updateQueue = h.updateQueue, a.memoizedState = h.memoizedState, a.lanes = h.lanes) : (a.updateQueue = null, a.memoizedState = null);
                    }
                    var l = $0c04710c92712449$var$vi.current;
                    if (null !== l) {
                        switch(l.tag){
                            case 13:
                                a.mode & 1 && (null === $0c04710c92712449$var$wi ? $0c04710c92712449$var$Tk() : null === l.alternate && 0 === $0c04710c92712449$var$V && ($0c04710c92712449$var$V = 3));
                                l.flags &= -257;
                                $0c04710c92712449$var$ok(l, c, a, d, b);
                                var n = l.updateQueue;
                                null === n ? l.updateQueue = new Set([
                                    f
                                ]) : n.add(f);
                                break;
                            case 22:
                                if (l.mode & 1) {
                                    l.flags |= 65536;
                                    var w = l.updateQueue;
                                    if (null === w) {
                                        var t = {
                                            transitions: null,
                                            markerInstances: null,
                                            wakeables: new Set([
                                                f
                                            ])
                                        };
                                        l.updateQueue = t;
                                    } else {
                                        var u = w.wakeables;
                                        null === u ? w.wakeables = new Set([
                                            f
                                        ]) : u.add(f);
                                    }
                                    break;
                                }
                            default:
                                throw Error($0c04710c92712449$var$q(435, l.tag));
                        }
                        l.mode & 1 && $0c04710c92712449$var$pn(d, f, b);
                        break a;
                    } else if (1 === d.tag) {
                        $0c04710c92712449$var$pn(d, f, b);
                        $0c04710c92712449$var$Tk();
                        break a;
                    } else e = Error($0c04710c92712449$var$q(426));
                } else if ($0c04710c92712449$var$K && a.mode & 1 && (f = $0c04710c92712449$var$vi.current, null !== f)) {
                    0 === (f.flags & 65536) && (f.flags |= 256);
                    $0c04710c92712449$var$ok(f, c, a, d, b);
                    $0c04710c92712449$var$Jh($0c04710c92712449$var$gk(e, a));
                    break a;
                }
                d = e = $0c04710c92712449$var$gk(e, a);
                4 !== $0c04710c92712449$var$V && ($0c04710c92712449$var$V = 2);
                null === $0c04710c92712449$var$Em ? $0c04710c92712449$var$Em = [
                    d
                ] : $0c04710c92712449$var$Em.push(d);
                d = c;
                do {
                    switch(d.tag){
                        case 3:
                            var v = e;
                            d.flags |= 65536;
                            b &= -b;
                            d.lanes |= b;
                            var y = $0c04710c92712449$var$jk(d, v, b);
                            $0c04710c92712449$var$$h(d, y);
                            break a;
                        case 1:
                            g = e;
                            var C = d.type, R = d.stateNode;
                            if (0 === (d.flags & 128) && ("function" === typeof C.getDerivedStateFromError || null !== R && "function" === typeof R.componentDidCatch && (null === $0c04710c92712449$var$nk || !$0c04710c92712449$var$nk.has(R)))) {
                                d.flags |= 65536;
                                y = b & -b;
                                d.lanes |= y;
                                v = $0c04710c92712449$var$mk(d, g, y);
                                $0c04710c92712449$var$$h(d, v);
                                break a;
                            }
                    }
                    d = d.return;
                }while (null !== d);
            }
        } catch (m) {
            throw $0c04710c92712449$var$Y = c, m;
        }
        $0c04710c92712449$var$on(a);
    }
}
function $0c04710c92712449$var$on(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0c04710c92712449$var$rl(c, b, $0c04710c92712449$var$si), null !== c) {
                $0c04710c92712449$var$Y = c;
                return;
            }
        } else {
            c = $0c04710c92712449$var$vl(c, b);
            if (null !== c) {
                c.flags &= 16383;
                $0c04710c92712449$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0c04710c92712449$var$V = 6;
                $0c04710c92712449$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0c04710c92712449$var$Y = b;
            return;
        }
        $0c04710c92712449$var$Y = b = a;
    }while (null !== b);
    0 === $0c04710c92712449$var$V && ($0c04710c92712449$var$V = 5);
}
function $0c04710c92712449$var$Zm(a, b, c) {
    var d = $0c04710c92712449$var$G, e = $0c04710c92712449$var$xm.transition;
    try {
        $0c04710c92712449$var$xm.transition = null, $0c04710c92712449$var$G = 2, $0c04710c92712449$var$qn(a, b, c, d);
    } finally{
        $0c04710c92712449$var$xm.transition = e, $0c04710c92712449$var$G = d;
    }
    return null;
}
function $0c04710c92712449$var$qn(a, b, c, d) {
    do $0c04710c92712449$var$Um();
    while (null !== $0c04710c92712449$var$Im);
    if (0 !== ($0c04710c92712449$var$L & 6)) throw Error($0c04710c92712449$var$q(327));
    var e = a.finishedWork, f = a.finishedLanes;
    if (null === e) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (e === a.current) throw Error($0c04710c92712449$var$q(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var g = e.lanes | e.childLanes;
    g |= $0c04710c92712449$var$Mh;
    $0c04710c92712449$var$Wc(a, g);
    a === $0c04710c92712449$var$S && ($0c04710c92712449$var$Y = $0c04710c92712449$var$S = null, $0c04710c92712449$var$M = 0);
    0 === (e.subtreeFlags & 10256) && 0 === (e.flags & 10256) || $0c04710c92712449$var$Hm || ($0c04710c92712449$var$Hm = !0, $0c04710c92712449$var$Km = g, $0c04710c92712449$var$Lm = c, $0c04710c92712449$var$Sm($0c04710c92712449$var$Cc, function() {
        $0c04710c92712449$var$Um();
        return null;
    }));
    c = 0 !== (e.flags & 15990);
    if (0 !== (e.subtreeFlags & 15990) || c) {
        c = $0c04710c92712449$var$xm.transition;
        $0c04710c92712449$var$xm.transition = null;
        var h = $0c04710c92712449$var$G;
        $0c04710c92712449$var$G = 2;
        var l = $0c04710c92712449$var$L;
        $0c04710c92712449$var$L |= 4;
        $0c04710c92712449$var$wm.current = null;
        $0c04710c92712449$var$Fl(a, e);
        $0c04710c92712449$var$am(e, a);
        $0c04710c92712449$var$hf($0c04710c92712449$var$Gg);
        $0c04710c92712449$var$yd = !!$0c04710c92712449$var$Fg;
        $0c04710c92712449$var$Gg = $0c04710c92712449$var$Fg = null;
        a.current = e;
        $0c04710c92712449$var$Ll(a, e.alternate, e);
        $0c04710c92712449$var$yc();
        $0c04710c92712449$var$L = l;
        $0c04710c92712449$var$G = h;
        $0c04710c92712449$var$xm.transition = c;
    } else a.current = e;
    $0c04710c92712449$var$Hm ? ($0c04710c92712449$var$Hm = !1, $0c04710c92712449$var$Im = a, $0c04710c92712449$var$Jm = f) : $0c04710c92712449$var$rn(a, g);
    g = a.pendingLanes;
    0 === g && ($0c04710c92712449$var$nk = null);
    $0c04710c92712449$var$Hc(e.stateNode, d);
    $0c04710c92712449$var$Qm(a, $0c04710c92712449$var$E());
    if (null !== b) for(d = a.onRecoverableError, e = 0; e < b.length; e++)f = b[e], g = {
        digest: f.digest,
        componentStack: f.stack
    }, d(f.value, g);
    if ($0c04710c92712449$var$kk) throw $0c04710c92712449$var$kk = !1, a = $0c04710c92712449$var$lk, $0c04710c92712449$var$lk = null, a;
    0 !== ($0c04710c92712449$var$Jm & 3) && 0 !== a.tag && $0c04710c92712449$var$Um();
    g = a.pendingLanes;
    0 !== (g & 3) ? a === $0c04710c92712449$var$Th ? $0c04710c92712449$var$Sh++ : ($0c04710c92712449$var$Sh = 0, $0c04710c92712449$var$Th = a) : $0c04710c92712449$var$Sh = 0;
    $0c04710c92712449$var$ih();
    return null;
}
function $0c04710c92712449$var$rn(a, b) {
    0 === (a.pooledCacheLanes &= b) && (b = a.pooledCache, null != b && (a.pooledCache = null, $0c04710c92712449$var$kl(b)));
}
function $0c04710c92712449$var$Um() {
    if (null !== $0c04710c92712449$var$Im) {
        var a = $0c04710c92712449$var$Im, b = $0c04710c92712449$var$Km;
        $0c04710c92712449$var$Km = 0;
        var c = $0c04710c92712449$var$Zc($0c04710c92712449$var$Jm), d = 32 > c ? 32 : c;
        c = $0c04710c92712449$var$xm.transition;
        var e = $0c04710c92712449$var$G;
        try {
            $0c04710c92712449$var$xm.transition = null;
            $0c04710c92712449$var$G = d;
            if (null === $0c04710c92712449$var$Im) var f = !1;
            else {
                d = $0c04710c92712449$var$Lm;
                $0c04710c92712449$var$Lm = null;
                var g = $0c04710c92712449$var$Im, h = $0c04710c92712449$var$Jm;
                $0c04710c92712449$var$Im = null;
                $0c04710c92712449$var$Jm = 0;
                if (0 !== ($0c04710c92712449$var$L & 6)) throw Error($0c04710c92712449$var$q(331));
                var l = $0c04710c92712449$var$L;
                $0c04710c92712449$var$L |= 4;
                $0c04710c92712449$var$pm(g.current);
                $0c04710c92712449$var$jm(g, g.current, h, d);
                $0c04710c92712449$var$L = l;
                $0c04710c92712449$var$ih();
                if ($0c04710c92712449$var$Gc && "function" === typeof $0c04710c92712449$var$Gc.onPostCommitFiberRoot) try {
                    $0c04710c92712449$var$Gc.onPostCommitFiberRoot($0c04710c92712449$var$Fc, g);
                } catch (n) {}
                f = !0;
            }
            return f;
        } finally{
            $0c04710c92712449$var$G = e, $0c04710c92712449$var$xm.transition = c, $0c04710c92712449$var$rn(a, b);
        }
    }
    return !1;
}
function $0c04710c92712449$var$sn(a, b, c) {
    b = $0c04710c92712449$var$gk(c, b);
    b = $0c04710c92712449$var$jk(a, b, 2);
    a = $0c04710c92712449$var$Yh(a, b, 2);
    b = $0c04710c92712449$var$Tj();
    null !== a && ($0c04710c92712449$var$Vc(a, 2, b), $0c04710c92712449$var$Qm(a, b));
}
function $0c04710c92712449$var$W(a, b, c) {
    if (3 === a.tag) $0c04710c92712449$var$sn(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0c04710c92712449$var$sn(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0c04710c92712449$var$nk || !$0c04710c92712449$var$nk.has(d))) {
                a = $0c04710c92712449$var$gk(c, a);
                a = $0c04710c92712449$var$mk(b, a, 2);
                b = $0c04710c92712449$var$Yh(b, a, 2);
                a = $0c04710c92712449$var$Tj();
                null !== b && ($0c04710c92712449$var$Vc(b, 2, a), $0c04710c92712449$var$Qm(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0c04710c92712449$var$pn(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0c04710c92712449$var$tm;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || ($0c04710c92712449$var$Am = !0, e.add(c), a = $0c04710c92712449$var$tn.bind(null, a, b, c), b.then(a, a));
}
function $0c04710c92712449$var$tn(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0c04710c92712449$var$Tj();
    a.pingedLanes |= a.suspendedLanes & c;
    $0c04710c92712449$var$S === a && ($0c04710c92712449$var$M & c) === c && (4 === $0c04710c92712449$var$V || 3 === $0c04710c92712449$var$V && ($0c04710c92712449$var$M & 125829120) === $0c04710c92712449$var$M && 500 > $0c04710c92712449$var$E() - $0c04710c92712449$var$dm ? 0 === ($0c04710c92712449$var$L & 2) && $0c04710c92712449$var$Om(a, 0) : $0c04710c92712449$var$Dm |= c);
    $0c04710c92712449$var$Qm(a, b);
}
function $0c04710c92712449$var$un(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 2 : (b = $0c04710c92712449$var$Nc, $0c04710c92712449$var$Nc <<= 1, 0 === ($0c04710c92712449$var$Nc & 125829120) && ($0c04710c92712449$var$Nc = 8388608)));
    var c = $0c04710c92712449$var$Tj();
    a = $0c04710c92712449$var$Qh(a, b);
    null !== a && ($0c04710c92712449$var$Vc(a, b, c), $0c04710c92712449$var$Qm(a, c));
}
function $0c04710c92712449$var$Uk(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0c04710c92712449$var$un(a, c);
}
function $0c04710c92712449$var$Zl(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        case 22:
            d = a.stateNode._retryCache;
            break;
        default:
            throw Error($0c04710c92712449$var$q(314));
    }
    null !== d && d.delete(b);
    $0c04710c92712449$var$un(a, c);
}
var $0c04710c92712449$var$nn;
$0c04710c92712449$var$nn = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0c04710c92712449$var$Vg.current) $0c04710c92712449$var$mj = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0c04710c92712449$var$mj = !1, $0c04710c92712449$var$Zk(a, b, c);
            $0c04710c92712449$var$mj = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0c04710c92712449$var$mj = !1, $0c04710c92712449$var$K && 0 !== (b.flags & 1048576) && $0c04710c92712449$var$th(b, $0c04710c92712449$var$mh, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0c04710c92712449$var$Gk(a, b);
            a = b.pendingProps;
            var e = $0c04710c92712449$var$Xg(b, $0c04710c92712449$var$Ug.current);
            $0c04710c92712449$var$tk(b, c);
            e = $0c04710c92712449$var$Vi(null, b, d, a, e, c);
            var f = $0c04710c92712449$var$bj();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0c04710c92712449$var$Yg(d) ? (f = !0, $0c04710c92712449$var$bh(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0c04710c92712449$var$Vh(b), e.updater = $0c04710c92712449$var$bk, b.stateNode = e, e._reactInternals = b, $0c04710c92712449$var$fk(b, d, a, c), b = $0c04710c92712449$var$Hk(null, b, d, !0, f, c)) : (b.tag = 0, $0c04710c92712449$var$K && f && $0c04710c92712449$var$uh(b), $0c04710c92712449$var$rk(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0c04710c92712449$var$Gk(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0c04710c92712449$var$vn(d);
                a = $0c04710c92712449$var$Zj(d, a);
                switch(e){
                    case 0:
                        b = $0c04710c92712449$var$yk(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0c04710c92712449$var$Fk(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0c04710c92712449$var$sk(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0c04710c92712449$var$vk(null, b, d, $0c04710c92712449$var$Zj(d.type, a), c);
                        break a;
                }
                throw Error($0c04710c92712449$var$q(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0c04710c92712449$var$Zj(d, e), $0c04710c92712449$var$yk(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0c04710c92712449$var$Zj(d, e), $0c04710c92712449$var$Fk(a, b, d, e, c);
        case 3:
            a: {
                $0c04710c92712449$var$Ik(b);
                if (null === a) throw Error($0c04710c92712449$var$q(387));
                e = b.pendingProps;
                f = b.memoizedState;
                d = f.element;
                $0c04710c92712449$var$Wh(a, b);
                $0c04710c92712449$var$ai(b, e, null, c);
                var g = b.memoizedState;
                e = g.cache;
                $0c04710c92712449$var$$k(b, $0c04710c92712449$var$T, e);
                e !== f.cache && $0c04710c92712449$var$gl(b, $0c04710c92712449$var$T, c);
                e = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: e,
                        isDehydrated: !1,
                        cache: g.cache
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        d = $0c04710c92712449$var$gk(Error($0c04710c92712449$var$q(423)), b);
                        b = $0c04710c92712449$var$Jk(a, b, e, c, d);
                        break a;
                    } else if (e !== d) {
                        d = $0c04710c92712449$var$gk(Error($0c04710c92712449$var$q(424)), b);
                        b = $0c04710c92712449$var$Jk(a, b, e, c, d);
                        break a;
                    } else for($0c04710c92712449$var$xh = $0c04710c92712449$var$Qg(b.stateNode.containerInfo.firstChild), $0c04710c92712449$var$wh = b, $0c04710c92712449$var$K = !0, $0c04710c92712449$var$yh = null, c = $0c04710c92712449$var$oi(b, null, e, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0c04710c92712449$var$Ih();
                    if (e === d) {
                        b = $0c04710c92712449$var$uk(a, b, c);
                        break a;
                    }
                    $0c04710c92712449$var$rk(a, b, e, c);
                }
                b = b.child;
            }
            return b;
        case 26:
            return $0c04710c92712449$var$Ak(a, b), c = b.memoizedState = $0c04710c92712449$var$Bg(b.type, null === a ? null : a.memoizedProps, b.pendingProps), null !== a || $0c04710c92712449$var$K || null !== c || (c = b.type, a = b.pendingProps, d = $0c04710c92712449$var$Uf(c, a, $0c04710c92712449$var$bg.current, "http://www.w3.org/1999/xhtml"), d[$0c04710c92712449$var$ea] = b, d[$0c04710c92712449$var$fa] = a, $0c04710c92712449$var$Vf(d, c, a), d[$0c04710c92712449$var$ma] = !0, b.stateNode = d), null;
        case 27:
            return $0c04710c92712449$var$eg(b), null === a && $0c04710c92712449$var$K && (d = b.stateNode = $0c04710c92712449$var$Sg(b.type, b.pendingProps, $0c04710c92712449$var$bg.current), $0c04710c92712449$var$wh = b, $0c04710c92712449$var$xh = $0c04710c92712449$var$Qg(d.firstChild)), d = b.pendingProps.children, null !== a || $0c04710c92712449$var$K ? $0c04710c92712449$var$rk(a, b, d, c) : b.child = $0c04710c92712449$var$ni(b, null, d, c), $0c04710c92712449$var$Ak(a, b), b.child;
        case 5:
            return $0c04710c92712449$var$eg(b), null === a && $0c04710c92712449$var$Dh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0c04710c92712449$var$Hg(d, e) ? g = null : null !== f && $0c04710c92712449$var$Hg(d, f) && (b.flags |= 32), $0c04710c92712449$var$Ak(a, b), $0c04710c92712449$var$rk(a, b, g, c), b.child;
        case 6:
            return null === a && $0c04710c92712449$var$Dh(b), null;
        case 13:
            return $0c04710c92712449$var$Nk(a, b, c);
        case 4:
            return $0c04710c92712449$var$cg(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0c04710c92712449$var$ni(b, null, d, c) : $0c04710c92712449$var$rk(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0c04710c92712449$var$Zj(d, e), $0c04710c92712449$var$sk(a, b, d, e, c);
        case 7:
            return $0c04710c92712449$var$rk(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0c04710c92712449$var$rk(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0c04710c92712449$var$rk(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0c04710c92712449$var$$k(b, d, g);
                if (null !== f) {
                    if ($0c04710c92712449$var$af(f.value, g)) {
                        if (f.children === e.children && !$0c04710c92712449$var$Vg.current) {
                            b = $0c04710c92712449$var$uk(a, b, c);
                            break a;
                        }
                    } else $0c04710c92712449$var$gl(b, d, c);
                }
                $0c04710c92712449$var$rk(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0c04710c92712449$var$tk(b, c), e = $0c04710c92712449$var$ij(e), d = d(e), b.flags |= 1, $0c04710c92712449$var$rk(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0c04710c92712449$var$Zj(d, b.pendingProps), e = $0c04710c92712449$var$Zj(d.type, e), $0c04710c92712449$var$vk(a, b, d, e, c);
        case 15:
            return $0c04710c92712449$var$xk(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0c04710c92712449$var$Zj(d, e), $0c04710c92712449$var$Gk(a, b), b.tag = 1, $0c04710c92712449$var$Yg(d) ? (a = !0, $0c04710c92712449$var$bh(b)) : a = !1, $0c04710c92712449$var$tk(b, c), $0c04710c92712449$var$dk(b, d, e), $0c04710c92712449$var$fk(b, d, e, c), $0c04710c92712449$var$Hk(null, b, d, !0, a, c);
        case 19:
            return $0c04710c92712449$var$Yk(a, b, c);
        case 22:
            return $0c04710c92712449$var$zk(a, b, c);
        case 24:
            return $0c04710c92712449$var$tk(b, c), d = $0c04710c92712449$var$ij($0c04710c92712449$var$T), null === a ? (e = $0c04710c92712449$var$Dk(), null === e && (e = $0c04710c92712449$var$S, f = $0c04710c92712449$var$Uj(), e.pooledCache = f, f.refCount++, null !== f && (e.pooledCacheLanes |= c), e = f), b.memoizedState = {
                parent: d,
                cache: e
            }, $0c04710c92712449$var$Vh(b), $0c04710c92712449$var$$k(b, $0c04710c92712449$var$T, e)) : (0 !== (a.lanes & c) && ($0c04710c92712449$var$Wh(a, b), $0c04710c92712449$var$ai(b, null, null, c)), e = a.memoizedState, f = b.memoizedState, e.parent !== d ? (e = {
                parent: d,
                cache: d
            }, b.memoizedState = e, 0 === b.lanes && (b.memoizedState = b.updateQueue.baseState = e), $0c04710c92712449$var$$k(b, $0c04710c92712449$var$T, d)) : (d = f.cache, $0c04710c92712449$var$$k(b, $0c04710c92712449$var$T, d), d !== e.cache && $0c04710c92712449$var$gl(b, $0c04710c92712449$var$T, c))), $0c04710c92712449$var$rk(a, b, b.pendingProps.children, c), b.child;
    }
    throw Error($0c04710c92712449$var$q(156, b.tag));
};
function $0c04710c92712449$var$Sm(a, b) {
    return $0c04710c92712449$var$vc(a, b);
}
function $0c04710c92712449$var$wn(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0c04710c92712449$var$Ah(a, b, c, d) {
    return new $0c04710c92712449$var$wn(a, b, c, d);
}
function $0c04710c92712449$var$wk(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0c04710c92712449$var$vn(a) {
    if ("function" === typeof a) return $0c04710c92712449$var$wk(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0c04710c92712449$var$Va) return 11;
        if (a === $0c04710c92712449$var$Ya) return 14;
    }
    return 2;
}
function $0c04710c92712449$var$ii(a, b) {
    var c = a.alternate;
    null === c ? (c = $0c04710c92712449$var$Ah(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    c.refCleanup = a.refCleanup;
    return c;
}
function $0c04710c92712449$var$tl(a, b) {
    a.flags &= 14680066;
    var c = a.alternate;
    null === c ? (a.childLanes = 0, a.lanes = b, a.child = null, a.subtreeFlags = 0, a.memoizedProps = null, a.memoizedState = null, a.updateQueue = null, a.dependencies = null, a.stateNode = null) : (a.childLanes = c.childLanes, a.lanes = c.lanes, a.child = c.child, a.subtreeFlags = 0, a.deletions = null, a.memoizedProps = c.memoizedProps, a.memoizedState = c.memoizedState, a.updateQueue = c.updateQueue, a.type = c.type, b = c.dependencies, a.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    });
    return a;
}
function $0c04710c92712449$var$ki(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0c04710c92712449$var$wk(a) && (g = 1);
    else if ("string" === typeof a) g = $0c04710c92712449$var$Rg(a, c, $0c04710c92712449$var$$f.current) ? 26 : "html" === a || "head" === a || "body" === a ? 27 : 5;
    else a: switch(a){
        case $0c04710c92712449$var$Pa:
            return $0c04710c92712449$var$mi(c.children, e, f, b);
        case $0c04710c92712449$var$Qa:
            g = 8;
            e |= 8;
            0 !== (e & 1) && (e |= 16);
            break;
        case $0c04710c92712449$var$Ra:
            return a = $0c04710c92712449$var$Ah(12, c, b, e | 2), a.elementType = $0c04710c92712449$var$Ra, a.lanes = f, a;
        case $0c04710c92712449$var$Wa:
            return a = $0c04710c92712449$var$Ah(13, c, b, e), a.elementType = $0c04710c92712449$var$Wa, a.lanes = f, a;
        case $0c04710c92712449$var$Xa:
            return a = $0c04710c92712449$var$Ah(19, c, b, e), a.elementType = $0c04710c92712449$var$Xa, a.lanes = f, a;
        case $0c04710c92712449$var$ab:
            return $0c04710c92712449$var$Rk(c, e, f, b);
        case $0c04710c92712449$var$bb:
        case $0c04710c92712449$var$$a:
        case $0c04710c92712449$var$cb:
            return a = $0c04710c92712449$var$Ah(24, c, b, e), a.elementType = $0c04710c92712449$var$cb, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0c04710c92712449$var$Sa:
                    g = 10;
                    break a;
                case $0c04710c92712449$var$Ta:
                    g = 9;
                    break a;
                case $0c04710c92712449$var$Va:
                    g = 11;
                    break a;
                case $0c04710c92712449$var$Ya:
                    g = 14;
                    break a;
                case $0c04710c92712449$var$Za:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0c04710c92712449$var$q(130, null == a ? a : typeof a, ""));
    }
    b = $0c04710c92712449$var$Ah(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0c04710c92712449$var$mi(a, b, c, d) {
    a = $0c04710c92712449$var$Ah(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0c04710c92712449$var$Rk(a, b, c, d) {
    a = $0c04710c92712449$var$Ah(22, a, d, b);
    a.elementType = $0c04710c92712449$var$ab;
    a.lanes = c;
    var e = {
        _visibility: 1,
        _pendingVisibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null,
        _current: null,
        detach: function() {
            var f = e._current;
            if (null === f) throw Error($0c04710c92712449$var$q(456));
            if (0 === (e._pendingVisibility & 2)) {
                var g = $0c04710c92712449$var$Qh(f, 2);
                null !== g && (e._pendingVisibility |= 2, $0c04710c92712449$var$xj(g, f, 2, -1));
            }
        },
        attach: function() {
            var f = e._current;
            if (null === f) throw Error($0c04710c92712449$var$q(456));
            if (0 !== (e._pendingVisibility & 2)) {
                var g = $0c04710c92712449$var$Qh(f, 2);
                null !== g && (e._pendingVisibility &= -3, $0c04710c92712449$var$xj(g, f, 2, -1));
            }
        }
    };
    a.stateNode = e;
    return a;
}
function $0c04710c92712449$var$ji(a, b, c) {
    a = $0c04710c92712449$var$Ah(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0c04710c92712449$var$li(a, b, c) {
    b = $0c04710c92712449$var$Ah(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0c04710c92712449$var$xn(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0c04710c92712449$var$Uc(0);
    this.expirationTimes = $0c04710c92712449$var$Uc(-1);
    this.entangledLanes = this.errorRecoveryDisabledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0c04710c92712449$var$Uc(0);
    this.hiddenUpdates = $0c04710c92712449$var$Uc(null);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.mutableSourceEagerHydrationData = null;
    this.incompleteTransitions = new Map;
}
function $0c04710c92712449$var$yn(a, b, c, d, e, f, g, h, l) {
    a = new $0c04710c92712449$var$xn(a, b, c, h, l);
    1 === b ? (b = 1, !0 === f && (b |= 24)) : b = 0;
    f = $0c04710c92712449$var$Ah(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    b = $0c04710c92712449$var$Uj();
    b.refCount++;
    a.pooledCache = b;
    b.refCount++;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: b
    };
    $0c04710c92712449$var$Vh(f);
    return a;
}
function $0c04710c92712449$var$zn(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0c04710c92712449$var$Oa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0c04710c92712449$var$An(a) {
    if (!a) return $0c04710c92712449$var$Tg;
    a = a._reactInternals;
    a: {
        if ($0c04710c92712449$var$pc(a) !== a || 1 !== a.tag) throw Error($0c04710c92712449$var$q(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0c04710c92712449$var$Yg(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0c04710c92712449$var$q(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0c04710c92712449$var$Yg(c)) return $0c04710c92712449$var$ah(a, c, b);
    }
    return b;
}
function $0c04710c92712449$var$Bn(a, b, c, d, e, f, g, h, l) {
    a = $0c04710c92712449$var$yn(c, d, !0, a, e, f, g, h, l);
    a.context = $0c04710c92712449$var$An(null);
    c = a.current;
    d = $0c04710c92712449$var$Sj(c);
    e = $0c04710c92712449$var$Xh(d);
    e.callback = void 0 !== b && null !== b ? b : null;
    b = $0c04710c92712449$var$Tj();
    $0c04710c92712449$var$Yh(c, e, d);
    a.current.lanes = d;
    $0c04710c92712449$var$Vc(a, d, b);
    $0c04710c92712449$var$Qm(a, b);
    return a;
}
function $0c04710c92712449$var$Cn(a, b, c, d) {
    var e = b.current, f = $0c04710c92712449$var$Sj(e);
    c = $0c04710c92712449$var$An(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0c04710c92712449$var$Xh(f);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0c04710c92712449$var$Yh(e, b, f);
    null !== a && (d = $0c04710c92712449$var$Tj(), $0c04710c92712449$var$xj(a, e, f, d), $0c04710c92712449$var$Zh(a, e, f));
    return f;
}
function $0c04710c92712449$var$Dn(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 27:
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0c04710c92712449$var$En(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0c04710c92712449$var$Fn(a, b) {
    $0c04710c92712449$var$En(a, b);
    (a = a.alternate) && $0c04710c92712449$var$En(a, b);
}
function $0c04710c92712449$var$Gn() {
    return null;
}
var $0c04710c92712449$var$Hn = $0c04710c92712449$var$ca.Dispatcher, $0c04710c92712449$var$In = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0c04710c92712449$var$Jn(a) {
    this._internalRoot = a;
}
$0c04710c92712449$var$Kn.prototype.render = $0c04710c92712449$var$Jn.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0c04710c92712449$var$q(409));
    $0c04710c92712449$var$Cn(a, b, null, null);
};
$0c04710c92712449$var$Kn.prototype.unmount = $0c04710c92712449$var$Jn.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0c04710c92712449$var$an(function() {
            $0c04710c92712449$var$Cn(null, a, null, null);
        });
        b[$0c04710c92712449$var$ha] = null;
    }
};
function $0c04710c92712449$var$Kn(a) {
    this._internalRoot = a;
}
$0c04710c92712449$var$Kn.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0c04710c92712449$var$cd();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0c04710c92712449$var$ld.length && 0 !== b && b < $0c04710c92712449$var$ld[c].priority; c++);
        $0c04710c92712449$var$ld.splice(c, 0, a);
        0 === c && $0c04710c92712449$var$qd(a);
    }
};
function $0c04710c92712449$var$Ln(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0c04710c92712449$var$Mn(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0c04710c92712449$var$Nn() {}
function $0c04710c92712449$var$On(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var n = $0c04710c92712449$var$Dn(g);
                f.call(n);
            };
        }
        var g = $0c04710c92712449$var$Bn(b, d, a, 0, null, !1, !1, "", $0c04710c92712449$var$Nn);
        a._reactRootContainer = g;
        a[$0c04710c92712449$var$ha] = g.current;
        $0c04710c92712449$var$Lf(8 === a.nodeType ? a.parentNode : a);
        $0c04710c92712449$var$an();
        return g;
    }
    $0c04710c92712449$var$Og(a);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var n = $0c04710c92712449$var$Dn(l);
            h.call(n);
        };
    }
    var l = $0c04710c92712449$var$yn(a, 0, !1, null, null, !1, !1, "", $0c04710c92712449$var$Nn);
    a._reactRootContainer = l;
    a[$0c04710c92712449$var$ha] = l.current;
    $0c04710c92712449$var$Lf(8 === a.nodeType ? a.parentNode : a);
    $0c04710c92712449$var$an(function() {
        $0c04710c92712449$var$Cn(b, l, c, d);
    });
    return l;
}
function $0c04710c92712449$var$Pn(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var l = $0c04710c92712449$var$Dn(g);
                h.call(l);
            };
        }
        $0c04710c92712449$var$Cn(b, g, a, e);
    } else g = $0c04710c92712449$var$On(c, b, a, e, d);
    return $0c04710c92712449$var$Dn(g);
}
$0c04710c92712449$var$$c = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0c04710c92712449$var$Oc(b.pendingLanes);
                0 !== c && ($0c04710c92712449$var$Xc(b, c | 2), $0c04710c92712449$var$Qm(b, $0c04710c92712449$var$E()), 0 === ($0c04710c92712449$var$L & 6) && ($0c04710c92712449$var$ul = $0c04710c92712449$var$E() + 500, $0c04710c92712449$var$ih()));
            }
            break;
        case 13:
            $0c04710c92712449$var$an(function() {
                var d = $0c04710c92712449$var$Qh(a, 2);
                if (null !== d) {
                    var e = $0c04710c92712449$var$Tj();
                    $0c04710c92712449$var$xj(d, a, 2, e);
                }
            }), $0c04710c92712449$var$Fn(a, 2);
    }
};
$0c04710c92712449$var$ad = function(a) {
    if (13 === a.tag) {
        var b = $0c04710c92712449$var$Qh(a, 134217728);
        if (null !== b) {
            var c = $0c04710c92712449$var$Tj();
            $0c04710c92712449$var$xj(b, a, 134217728, c);
        }
        $0c04710c92712449$var$Fn(a, 134217728);
    }
};
$0c04710c92712449$var$bd = function(a) {
    if (13 === a.tag) {
        var b = $0c04710c92712449$var$Sj(a), c = $0c04710c92712449$var$Qh(a, b);
        if (null !== c) {
            var d = $0c04710c92712449$var$Tj();
            $0c04710c92712449$var$xj(c, a, b, d);
        }
        $0c04710c92712449$var$Fn(a, b);
    }
};
$0c04710c92712449$var$cd = function() {
    return $0c04710c92712449$var$G;
};
$0c04710c92712449$var$dd = $0c04710c92712449$var$Yc;
$0c04710c92712449$var$Vb = function(a, b, c) {
    switch(b){
        case "input":
            $0c04710c92712449$var$xb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0c04710c92712449$var$sa(d);
                        if (!e) throw Error($0c04710c92712449$var$q(90));
                        $0c04710c92712449$var$sb(d);
                        $0c04710c92712449$var$xb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0c04710c92712449$var$Eb(a, c);
            break;
        case "select":
            b = c.value, null != b && $0c04710c92712449$var$Bb(a, !!c.multiple, b, !1);
    }
};
$0c04710c92712449$var$ac = $0c04710c92712449$var$$m;
$0c04710c92712449$var$bc = $0c04710c92712449$var$an;
$0c04710c92712449$var$ca.Events = [
    $0c04710c92712449$var$qa,
    $0c04710c92712449$var$ra,
    $0c04710c92712449$var$sa,
    $0c04710c92712449$var$Zb,
    $0c04710c92712449$var$$b,
    $0c04710c92712449$var$$m
];
var $0c04710c92712449$var$Qn = {
    findFiberByHostInstance: $0c04710c92712449$var$oa,
    bundleType: 0,
    version: "18.3.0-experimental-49f741046-20230305",
    rendererPackageName: "react-dom"
};
var $0c04710c92712449$var$Rn = {
    bundleType: $0c04710c92712449$var$Qn.bundleType,
    version: $0c04710c92712449$var$Qn.version,
    rendererPackageName: $0c04710c92712449$var$Qn.rendererPackageName,
    rendererConfig: $0c04710c92712449$var$Qn.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0c04710c92712449$var$Ma.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0c04710c92712449$var$tc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0c04710c92712449$var$Qn.findFiberByHostInstance || $0c04710c92712449$var$Gn,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.0-next-49f741046-20230305"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0c04710c92712449$var$Sn = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0c04710c92712449$var$Sn.isDisabled && $0c04710c92712449$var$Sn.supportsFiber) try {
        $0c04710c92712449$var$Fc = $0c04710c92712449$var$Sn.inject($0c04710c92712449$var$Rn), $0c04710c92712449$var$Gc = $0c04710c92712449$var$Sn;
    } catch (a) {}
}
$0c04710c92712449$export$ae55be85d98224ed = $0c04710c92712449$var$ca;
$0c04710c92712449$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0c04710c92712449$var$Ln(b)) throw Error($0c04710c92712449$var$q(200));
    return $0c04710c92712449$var$zn(a, b, null, c);
};
$0c04710c92712449$export$882461b6382ed46c = function(a, b) {
    if (!$0c04710c92712449$var$Ln(a)) throw Error($0c04710c92712449$var$q(299));
    var c = !1, d = "", e = $0c04710c92712449$var$In;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0c04710c92712449$var$yn(a, 1, !1, null, null, c, !1, d, e);
    a[$0c04710c92712449$var$ha] = b.current;
    $0c04710c92712449$var$Hn.current = $0c04710c92712449$var$ng;
    $0c04710c92712449$var$Lf(8 === a.nodeType ? a.parentNode : a);
    return new $0c04710c92712449$var$Jn(b);
};
$0c04710c92712449$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0c04710c92712449$var$q(188));
        a = Object.keys(a).join(",");
        throw Error($0c04710c92712449$var$q(268, a));
    }
    a = $0c04710c92712449$var$tc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0c04710c92712449$export$cd75ccfd720a3cd4 = function(a) {
    return $0c04710c92712449$var$an(a);
};
$0c04710c92712449$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0c04710c92712449$var$Mn(b)) throw Error($0c04710c92712449$var$q(200));
    return $0c04710c92712449$var$Pn(null, a, b, !0, c);
};
$0c04710c92712449$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0c04710c92712449$var$Ln(a)) throw Error($0c04710c92712449$var$q(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0c04710c92712449$var$In;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0c04710c92712449$var$Bn(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0c04710c92712449$var$ha] = b.current;
    $0c04710c92712449$var$Hn.current = $0c04710c92712449$var$ng;
    $0c04710c92712449$var$Lf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0c04710c92712449$var$Kn(b);
};
$0c04710c92712449$export$a0816fa17a9e79be = function() {
    var a = $0c04710c92712449$var$ca.Dispatcher.current;
    a && a.preconnect.apply(this, arguments);
};
$0c04710c92712449$export$7292efcadded39f3 = function() {
    var a = $0c04710c92712449$var$ca.Dispatcher.current;
    a && a.prefetchDNS.apply(this, arguments);
};
$0c04710c92712449$export$da407abadb9b8f86 = function() {
    var a = $0c04710c92712449$var$ca.Dispatcher.current;
    a && a.preinit.apply(this, arguments);
};
$0c04710c92712449$export$513ccb98c53b8039 = function() {
    var a = $0c04710c92712449$var$ca.Dispatcher.current;
    a && a.preload.apply(this, arguments);
};
$0c04710c92712449$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0c04710c92712449$var$Mn(b)) throw Error($0c04710c92712449$var$q(200));
    return $0c04710c92712449$var$Pn(null, a, b, !1, c);
};
$0c04710c92712449$export$502457920280e6be = function(a) {
    if (!$0c04710c92712449$var$Mn(a)) throw Error($0c04710c92712449$var$q(40));
    return a._reactRootContainer ? ($0c04710c92712449$var$an(function() {
        $0c04710c92712449$var$Pn(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0c04710c92712449$var$ha] = null;
        });
    }), !0) : !1;
};
$0c04710c92712449$export$c78a37762a8d58e1 = $0c04710c92712449$var$$m;
$0c04710c92712449$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0c04710c92712449$var$Mn(c)) throw Error($0c04710c92712449$var$q(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0c04710c92712449$var$q(38));
    return $0c04710c92712449$var$Pn(a, b, c, !1, d);
};
$0c04710c92712449$export$61bcfe829111a1d0 = $0c04710c92712449$var$Yc;
$0c04710c92712449$export$83d89fbfd8236492 = "18.3.0-next-49f741046-20230305";

});
parcelRequire.register("9gi6K", function(module, exports) {
"use strict";

module.exports = (parcelRequire("l0gh7"));

});
parcelRequire.register("l0gh7", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $f4a638eee0d654c0$export$c4744153514ff05d, (v) => $f4a638eee0d654c0$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $f4a638eee0d654c0$export$3e506c1ccc9cc1a7, (v) => $f4a638eee0d654c0$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $f4a638eee0d654c0$export$e26fe2ed2fa76875, (v) => $f4a638eee0d654c0$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $f4a638eee0d654c0$export$502329bbf4b505b1, (v) => $f4a638eee0d654c0$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $f4a638eee0d654c0$export$6e3807111c4874c4, (v) => $f4a638eee0d654c0$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $f4a638eee0d654c0$export$c27134553091fb3a, (v) => $f4a638eee0d654c0$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $f4a638eee0d654c0$export$33ee1acdc04fd2a2, (v) => $f4a638eee0d654c0$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $f4a638eee0d654c0$export$b00a404bbd5edef2, (v) => $f4a638eee0d654c0$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $f4a638eee0d654c0$export$8352ce38b91d0c62, (v) => $f4a638eee0d654c0$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $f4a638eee0d654c0$export$d66a1c1c77bd778b, (v) => $f4a638eee0d654c0$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $f4a638eee0d654c0$export$d3dfb8e4810cb555, (v) => $f4a638eee0d654c0$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $f4a638eee0d654c0$export$839f9183b0465a69, (v) => $f4a638eee0d654c0$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $f4a638eee0d654c0$export$72fdf0e06517287b, (v) => $f4a638eee0d654c0$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $f4a638eee0d654c0$export$4b844e58a3e414b4, (v) => $f4a638eee0d654c0$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $f4a638eee0d654c0$export$816d2913ae6b83b1, (v) => $f4a638eee0d654c0$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $f4a638eee0d654c0$export$61bcfe829111a1d0, (v) => $f4a638eee0d654c0$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $f4a638eee0d654c0$export$7ee8c9beb337bc3f, (v) => $f4a638eee0d654c0$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $f4a638eee0d654c0$export$b5836b71941fa3ed, (v) => $f4a638eee0d654c0$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $f4a638eee0d654c0$export$cf845f2c119da08a, (v) => $f4a638eee0d654c0$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f4a638eee0d654c0$export$c4744153514ff05d;
var $f4a638eee0d654c0$export$3e506c1ccc9cc1a7;
var $f4a638eee0d654c0$export$e26fe2ed2fa76875;
var $f4a638eee0d654c0$export$502329bbf4b505b1;
var $f4a638eee0d654c0$export$6e3807111c4874c4;
var $f4a638eee0d654c0$export$c27134553091fb3a;
var $f4a638eee0d654c0$export$33ee1acdc04fd2a2;
var $f4a638eee0d654c0$export$b00a404bbd5edef2;
var $f4a638eee0d654c0$export$8352ce38b91d0c62;
var $f4a638eee0d654c0$export$d66a1c1c77bd778b;
var $f4a638eee0d654c0$export$d3dfb8e4810cb555;
var $f4a638eee0d654c0$export$839f9183b0465a69;
var $f4a638eee0d654c0$export$72fdf0e06517287b;
var $f4a638eee0d654c0$export$4b844e58a3e414b4;
var $f4a638eee0d654c0$export$816d2913ae6b83b1;
var $f4a638eee0d654c0$export$61bcfe829111a1d0;
var $f4a638eee0d654c0$export$7ee8c9beb337bc3f;
var $f4a638eee0d654c0$export$b5836b71941fa3ed;
var $f4a638eee0d654c0$export$cf845f2c119da08a;
"use strict";
function $f4a638eee0d654c0$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $f4a638eee0d654c0$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $f4a638eee0d654c0$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $f4a638eee0d654c0$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, q = e >>> 1; d < q;){
            var m = 2 * (d + 1) - 1, D = a[m], n = m + 1, x = a[n];
            if (0 > $f4a638eee0d654c0$var$g(D, c)) n < e && 0 > $f4a638eee0d654c0$var$g(x, D) ? (a[d] = x, a[n] = c, d = n) : (a[d] = D, a[m] = c, d = m);
            else if (n < e && 0 > $f4a638eee0d654c0$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $f4a638eee0d654c0$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
$f4a638eee0d654c0$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $f4a638eee0d654c0$var$l = performance;
    $f4a638eee0d654c0$export$c4744153514ff05d = function() {
        return $f4a638eee0d654c0$var$l.now();
    };
} else {
    var $f4a638eee0d654c0$var$p = Date, $f4a638eee0d654c0$var$r = $f4a638eee0d654c0$var$p.now();
    $f4a638eee0d654c0$export$c4744153514ff05d = function() {
        return $f4a638eee0d654c0$var$p.now() - $f4a638eee0d654c0$var$r;
    };
}
var $f4a638eee0d654c0$var$t = [], $f4a638eee0d654c0$var$u = [], $f4a638eee0d654c0$var$v = 1, $f4a638eee0d654c0$var$w = null, $f4a638eee0d654c0$var$y = 3, $f4a638eee0d654c0$var$z = !1, $f4a638eee0d654c0$var$A = !1, $f4a638eee0d654c0$var$B = !1, $f4a638eee0d654c0$var$C = "function" === typeof setTimeout ? setTimeout : null, $f4a638eee0d654c0$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $f4a638eee0d654c0$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $f4a638eee0d654c0$var$G(a) {
    for(var b = $f4a638eee0d654c0$var$h($f4a638eee0d654c0$var$u); null !== b;){
        if (null === b.callback) $f4a638eee0d654c0$var$k($f4a638eee0d654c0$var$u);
        else if (b.startTime <= a) $f4a638eee0d654c0$var$k($f4a638eee0d654c0$var$u), b.sortIndex = b.expirationTime, $f4a638eee0d654c0$var$f($f4a638eee0d654c0$var$t, b);
        else break;
        b = $f4a638eee0d654c0$var$h($f4a638eee0d654c0$var$u);
    }
}
function $f4a638eee0d654c0$var$H(a) {
    $f4a638eee0d654c0$var$B = !1;
    $f4a638eee0d654c0$var$G(a);
    if (!$f4a638eee0d654c0$var$A) {
        if (null !== $f4a638eee0d654c0$var$h($f4a638eee0d654c0$var$t)) $f4a638eee0d654c0$var$A = !0, $f4a638eee0d654c0$var$I($f4a638eee0d654c0$var$J);
        else {
            var b = $f4a638eee0d654c0$var$h($f4a638eee0d654c0$var$u);
            null !== b && $f4a638eee0d654c0$var$K($f4a638eee0d654c0$var$H, b.startTime - a);
        }
    }
}
function $f4a638eee0d654c0$var$J(a, b) {
    $f4a638eee0d654c0$var$A = !1;
    $f4a638eee0d654c0$var$B && ($f4a638eee0d654c0$var$B = !1, $f4a638eee0d654c0$var$E($f4a638eee0d654c0$var$L), $f4a638eee0d654c0$var$L = -1);
    $f4a638eee0d654c0$var$z = !0;
    var c = $f4a638eee0d654c0$var$y;
    try {
        a: {
            $f4a638eee0d654c0$var$G(b);
            for($f4a638eee0d654c0$var$w = $f4a638eee0d654c0$var$h($f4a638eee0d654c0$var$t); null !== $f4a638eee0d654c0$var$w && (!($f4a638eee0d654c0$var$w.expirationTime > b) || a && !$f4a638eee0d654c0$var$M());){
                var d = $f4a638eee0d654c0$var$w.callback;
                if ("function" === typeof d) {
                    $f4a638eee0d654c0$var$w.callback = null;
                    $f4a638eee0d654c0$var$y = $f4a638eee0d654c0$var$w.priorityLevel;
                    var e = d($f4a638eee0d654c0$var$w.expirationTime <= b);
                    b = $f4a638eee0d654c0$export$c4744153514ff05d();
                    if ("function" === typeof e) {
                        $f4a638eee0d654c0$var$w.callback = e;
                        $f4a638eee0d654c0$var$G(b);
                        var q = !0;
                        break a;
                    } else $f4a638eee0d654c0$var$w === $f4a638eee0d654c0$var$h($f4a638eee0d654c0$var$t) && $f4a638eee0d654c0$var$k($f4a638eee0d654c0$var$t), $f4a638eee0d654c0$var$G(b);
                } else $f4a638eee0d654c0$var$k($f4a638eee0d654c0$var$t);
                $f4a638eee0d654c0$var$w = $f4a638eee0d654c0$var$h($f4a638eee0d654c0$var$t);
            }
            if (null !== $f4a638eee0d654c0$var$w) q = !0;
            else {
                var m = $f4a638eee0d654c0$var$h($f4a638eee0d654c0$var$u);
                null !== m && $f4a638eee0d654c0$var$K($f4a638eee0d654c0$var$H, m.startTime - b);
                q = !1;
            }
        }
        return q;
    } finally{
        $f4a638eee0d654c0$var$w = null, $f4a638eee0d654c0$var$y = c, $f4a638eee0d654c0$var$z = !1;
    }
}
var $f4a638eee0d654c0$var$N = !1, $f4a638eee0d654c0$var$O = null, $f4a638eee0d654c0$var$L = -1, $f4a638eee0d654c0$var$P = 5, $f4a638eee0d654c0$var$Q = -1;
function $f4a638eee0d654c0$var$M() {
    return $f4a638eee0d654c0$export$c4744153514ff05d() - $f4a638eee0d654c0$var$Q < $f4a638eee0d654c0$var$P ? !1 : !0;
}
function $f4a638eee0d654c0$var$R() {
    if (null !== $f4a638eee0d654c0$var$O) {
        var a = $f4a638eee0d654c0$export$c4744153514ff05d();
        $f4a638eee0d654c0$var$Q = a;
        var b = !0;
        try {
            b = $f4a638eee0d654c0$var$O(!0, a);
        } finally{
            b ? $f4a638eee0d654c0$var$S() : ($f4a638eee0d654c0$var$N = !1, $f4a638eee0d654c0$var$O = null);
        }
    } else $f4a638eee0d654c0$var$N = !1;
}
var $f4a638eee0d654c0$var$S;
if ("function" === typeof $f4a638eee0d654c0$var$F) $f4a638eee0d654c0$var$S = function() {
    $f4a638eee0d654c0$var$F($f4a638eee0d654c0$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $f4a638eee0d654c0$var$T = new MessageChannel, $f4a638eee0d654c0$var$U = $f4a638eee0d654c0$var$T.port2;
    $f4a638eee0d654c0$var$T.port1.onmessage = $f4a638eee0d654c0$var$R;
    $f4a638eee0d654c0$var$S = function() {
        $f4a638eee0d654c0$var$U.postMessage(null);
    };
} else $f4a638eee0d654c0$var$S = function() {
    $f4a638eee0d654c0$var$C($f4a638eee0d654c0$var$R, 0);
};
function $f4a638eee0d654c0$var$I(a) {
    $f4a638eee0d654c0$var$O = a;
    $f4a638eee0d654c0$var$N || ($f4a638eee0d654c0$var$N = !0, $f4a638eee0d654c0$var$S());
}
function $f4a638eee0d654c0$var$K(a, b) {
    $f4a638eee0d654c0$var$L = $f4a638eee0d654c0$var$C(function() {
        a($f4a638eee0d654c0$export$c4744153514ff05d());
    }, b);
}
$f4a638eee0d654c0$export$3e506c1ccc9cc1a7 = 5;
$f4a638eee0d654c0$export$e26fe2ed2fa76875 = 1;
$f4a638eee0d654c0$export$502329bbf4b505b1 = 4;
$f4a638eee0d654c0$export$6e3807111c4874c4 = 3;
$f4a638eee0d654c0$export$c27134553091fb3a = null;
$f4a638eee0d654c0$export$33ee1acdc04fd2a2 = 2;
$f4a638eee0d654c0$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$f4a638eee0d654c0$export$8352ce38b91d0c62 = function() {
    $f4a638eee0d654c0$var$A || $f4a638eee0d654c0$var$z || ($f4a638eee0d654c0$var$A = !0, $f4a638eee0d654c0$var$I($f4a638eee0d654c0$var$J));
};
$f4a638eee0d654c0$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $f4a638eee0d654c0$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$f4a638eee0d654c0$export$d3dfb8e4810cb555 = function() {
    return $f4a638eee0d654c0$var$y;
};
$f4a638eee0d654c0$export$839f9183b0465a69 = function() {
    return $f4a638eee0d654c0$var$h($f4a638eee0d654c0$var$t);
};
$f4a638eee0d654c0$export$72fdf0e06517287b = function(a) {
    switch($f4a638eee0d654c0$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $f4a638eee0d654c0$var$y;
    }
    var c = $f4a638eee0d654c0$var$y;
    $f4a638eee0d654c0$var$y = b;
    try {
        return a();
    } finally{
        $f4a638eee0d654c0$var$y = c;
    }
};
$f4a638eee0d654c0$export$4b844e58a3e414b4 = function() {};
$f4a638eee0d654c0$export$816d2913ae6b83b1 = function() {};
$f4a638eee0d654c0$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $f4a638eee0d654c0$var$y;
    $f4a638eee0d654c0$var$y = a;
    try {
        return b();
    } finally{
        $f4a638eee0d654c0$var$y = c;
    }
};
$f4a638eee0d654c0$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $f4a638eee0d654c0$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $f4a638eee0d654c0$var$v++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $f4a638eee0d654c0$var$f($f4a638eee0d654c0$var$u, a), null === $f4a638eee0d654c0$var$h($f4a638eee0d654c0$var$t) && a === $f4a638eee0d654c0$var$h($f4a638eee0d654c0$var$u) && ($f4a638eee0d654c0$var$B ? ($f4a638eee0d654c0$var$E($f4a638eee0d654c0$var$L), $f4a638eee0d654c0$var$L = -1) : $f4a638eee0d654c0$var$B = !0, $f4a638eee0d654c0$var$K($f4a638eee0d654c0$var$H, c - d))) : (a.sortIndex = e, $f4a638eee0d654c0$var$f($f4a638eee0d654c0$var$t, a), $f4a638eee0d654c0$var$A || $f4a638eee0d654c0$var$z || ($f4a638eee0d654c0$var$A = !0, $f4a638eee0d654c0$var$I($f4a638eee0d654c0$var$J)));
    return a;
};
$f4a638eee0d654c0$export$b5836b71941fa3ed = $f4a638eee0d654c0$var$M;
$f4a638eee0d654c0$export$cf845f2c119da08a = function(a) {
    var b = $f4a638eee0d654c0$var$y;
    return function() {
        var c = $f4a638eee0d654c0$var$y;
        $f4a638eee0d654c0$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $f4a638eee0d654c0$var$y = c;
        }
    };
};

});



parcelRequire.register("1LbwH", function(module, exports) {

$parcel$export(module.exports, "languageDataProp", () => $14831f1c512a5db9$export$27a2e78097f753f7);
$parcel$export(module.exports, "defineLanguageFacet", () => $14831f1c512a5db9$export$b57f683f43553b99);
$parcel$export(module.exports, "sublanguageProp", () => $14831f1c512a5db9$export$4afc6f37514bbb67);
$parcel$export(module.exports, "Language", () => $14831f1c512a5db9$export$ce4fe1c9e6520c1a);
$parcel$export(module.exports, "syntaxTree", () => $14831f1c512a5db9$export$7fc98e56a4ca6be1);
$parcel$export(module.exports, "LRLanguage", () => $14831f1c512a5db9$export$b243968d9fb6db03);
$parcel$export(module.exports, "ensureSyntaxTree", () => $14831f1c512a5db9$export$8694796f3a52e973);
$parcel$export(module.exports, "ParseContext", () => $14831f1c512a5db9$export$3fcb7c01ff2a41fa);
$parcel$export(module.exports, "LanguageSupport", () => $14831f1c512a5db9$export$cbdefefa8a51dd3b);
$parcel$export(module.exports, "LanguageDescription", () => $14831f1c512a5db9$export$50ab82debf88f71);
$parcel$export(module.exports, "indentUnit", () => $14831f1c512a5db9$export$9e0d0c2ce4d3ceb5);
$parcel$export(module.exports, "indentNodeProp", () => $14831f1c512a5db9$export$72c7d4c52b3c6460);
$parcel$export(module.exports, "delimitedIndent", () => $14831f1c512a5db9$export$60e82ea306899488);
$parcel$export(module.exports, "flatIndent", () => $14831f1c512a5db9$export$4764c629086182f2);
$parcel$export(module.exports, "continuedIndent", () => $14831f1c512a5db9$export$688ff433e7e7cc5c);
$parcel$export(module.exports, "foldService", () => $14831f1c512a5db9$export$40014037e3ef64a);
$parcel$export(module.exports, "foldNodeProp", () => $14831f1c512a5db9$export$9b075a85eb4377d8);
$parcel$export(module.exports, "foldInside", () => $14831f1c512a5db9$export$48672beae16a681b);
$parcel$export(module.exports, "bracketMatchingHandle", () => $14831f1c512a5db9$export$ca7d74cd5b9f1011);

var $6DlXS = parcelRequire("6DlXS");

var $hB7kI = parcelRequire("hB7kI");

var $jQ4bL = parcelRequire("jQ4bL");

var $6yW7d = parcelRequire("6yW7d");

var $luNHI = parcelRequire("luNHI");
var $14831f1c512a5db9$var$_a;
/**
Node prop stored in a parser's top syntax node to provide the
facet that stores language-specific data for that language.
*/ const $14831f1c512a5db9$export$27a2e78097f753f7 = /*@__PURE__*/ new (0, $6DlXS.NodeProp)();
/**
Helper function to define a facet (to be added to the top syntax
node(s) for a language via
[`languageDataProp`](https://codemirror.net/6/docs/ref/#language.languageDataProp)), that will be
used to associate language data with the language. You
probably only need this when subclassing
[`Language`](https://codemirror.net/6/docs/ref/#language.Language).
*/ function $14831f1c512a5db9$export$b57f683f43553b99(baseData) {
    return (0, $hB7kI.Facet).define({
        combine: baseData ? (values)=>values.concat(baseData) : undefined
    });
}
/**
Syntax node prop used to register sublanguages. Should be added to
the top level node type for the language.
*/ const $14831f1c512a5db9$export$4afc6f37514bbb67 = /*@__PURE__*/ new (0, $6DlXS.NodeProp)();
/**
A language object manages parsing and per-language
[metadata](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt). Parse data is
managed as a [Lezer](https://lezer.codemirror.net) tree. The class
can be used directly, via the [`LRLanguage`](https://codemirror.net/6/docs/ref/#language.LRLanguage)
subclass for [Lezer](https://lezer.codemirror.net/) LR parsers, or
via the [`StreamLanguage`](https://codemirror.net/6/docs/ref/#language.StreamLanguage) subclass
for stream parsers.
*/ class $14831f1c512a5db9$export$ce4fe1c9e6520c1a {
    /**
    Construct a language object. If you need to invoke this
    directly, first define a data facet with
    [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
    configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
    to the language's outer syntax node.
    */ constructor(/**
    The [language data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt) facet
    used for this language.
    */ data, parser, extraExtensions = [], /**
    A language name.
    */ name = ""){
        this.data = data;
        this.name = name;
        // Kludge to define EditorState.tree as a debugging helper,
        // without the EditorState package actually knowing about
        // languages and lezer trees.
        if (!(0, $hB7kI.EditorState).prototype.hasOwnProperty("tree")) Object.defineProperty((0, $hB7kI.EditorState).prototype, "tree", {
            get () {
                return $14831f1c512a5db9$export$7fc98e56a4ca6be1(this);
            }
        });
        this.parser = parser;
        this.extension = [
            $14831f1c512a5db9$export$789c912f57fe164c.of(this),
            (0, $hB7kI.EditorState).languageData.of((state, pos, side)=>{
                let top = $14831f1c512a5db9$var$topNodeAt(state, pos, side), data = top.type.prop($14831f1c512a5db9$export$27a2e78097f753f7);
                if (!data) return [];
                let base = state.facet(data), sub = top.type.prop($14831f1c512a5db9$export$4afc6f37514bbb67);
                if (sub) {
                    let innerNode = top.resolve(pos - top.from, side);
                    for (let sublang of sub)if (sublang.test(innerNode, state)) {
                        let data = state.facet(sublang.facet);
                        return sublang.type == "replace" ? data : data.concat(base);
                    }
                }
                return base;
            })
        ].concat(extraExtensions);
    }
    /**
    Query whether this language is active at the given position.
    */ isActiveAt(state, pos, side = -1) {
        return $14831f1c512a5db9$var$topNodeAt(state, pos, side).type.prop($14831f1c512a5db9$export$27a2e78097f753f7) == this.data;
    }
    /**
    Find the document regions that were parsed using this language.
    The returned regions will _include_ any nested languages rooted
    in this language, when those exist.
    */ findRegions(state) {
        let lang = state.facet($14831f1c512a5db9$export$789c912f57fe164c);
        if ((lang === null || lang === void 0 ? void 0 : lang.data) == this.data) return [
            {
                from: 0,
                to: state.doc.length
            }
        ];
        if (!lang || !lang.allowsNesting) return [];
        let result = [];
        let explore = (tree, from)=>{
            if (tree.prop($14831f1c512a5db9$export$27a2e78097f753f7) == this.data) {
                result.push({
                    from: from,
                    to: from + tree.length
                });
                return;
            }
            let mount = tree.prop((0, $6DlXS.NodeProp).mounted);
            if (mount) {
                if (mount.tree.prop($14831f1c512a5db9$export$27a2e78097f753f7) == this.data) {
                    if (mount.overlay) for (let r of mount.overlay)result.push({
                        from: r.from + from,
                        to: r.to + from
                    });
                    else result.push({
                        from: from,
                        to: from + tree.length
                    });
                    return;
                } else if (mount.overlay) {
                    let size = result.length;
                    explore(mount.tree, mount.overlay[0].from + from);
                    if (result.length > size) return;
                }
            }
            for(let i = 0; i < tree.children.length; i++){
                let ch = tree.children[i];
                if (ch instanceof (0, $6DlXS.Tree)) explore(ch, tree.positions[i] + from);
            }
        };
        explore($14831f1c512a5db9$export$7fc98e56a4ca6be1(state), 0);
        return result;
    }
    /**
    Indicates whether this language allows nested languages. The
    default implementation returns true.
    */ get allowsNesting() {
        return true;
    }
}
/**
@internal
*/ $14831f1c512a5db9$export$ce4fe1c9e6520c1a.setState = /*@__PURE__*/ (0, $hB7kI.StateEffect).define();
function $14831f1c512a5db9$var$topNodeAt(state, pos, side) {
    let topLang = state.facet($14831f1c512a5db9$export$789c912f57fe164c), tree = $14831f1c512a5db9$export$7fc98e56a4ca6be1(state).topNode;
    if (!topLang || topLang.allowsNesting) {
        for(let node = tree; node; node = node.enter(pos, side, (0, $6DlXS.IterMode).ExcludeBuffers))if (node.type.isTop) tree = node;
    }
    return tree;
}
/**
A subclass of [`Language`](https://codemirror.net/6/docs/ref/#language.Language) for use with Lezer
[LR parsers](https://lezer.codemirror.net/docs/ref#lr.LRParser)
parsers.
*/ class $14831f1c512a5db9$export$b243968d9fb6db03 extends $14831f1c512a5db9$export$ce4fe1c9e6520c1a {
    constructor(data, parser, name){
        super(data, parser, [], name);
        this.parser = parser;
    }
    /**
    Define a language from a parser.
    */ static define(spec) {
        let data = $14831f1c512a5db9$export$b57f683f43553b99(spec.languageData);
        return new $14831f1c512a5db9$export$b243968d9fb6db03(data, spec.parser.configure({
            props: [
                $14831f1c512a5db9$export$27a2e78097f753f7.add((type)=>type.isTop ? data : undefined)
            ]
        }), spec.name);
    }
    /**
    Create a new instance of this language with a reconfigured
    version of its parser and optionally a new name.
    */ configure(options, name) {
        return new $14831f1c512a5db9$export$b243968d9fb6db03(this.data, this.parser.configure(options), name || this.name);
    }
    get allowsNesting() {
        return this.parser.hasWrappers();
    }
}
/**
Get the syntax tree for a state, which is the current (possibly
incomplete) parse tree of the active
[language](https://codemirror.net/6/docs/ref/#language.Language), or the empty tree if there is no
language available.
*/ function $14831f1c512a5db9$export$7fc98e56a4ca6be1(state) {
    let field = state.field($14831f1c512a5db9$export$ce4fe1c9e6520c1a.state, false);
    return field ? field.tree : (0, $6DlXS.Tree).empty;
}
/**
Try to get a parse tree that spans at least up to `upto`. The
method will do at most `timeout` milliseconds of work to parse
up to that point if the tree isn't already available.
*/ function $14831f1c512a5db9$export$8694796f3a52e973(state, upto, timeout = 50) {
    var _a;
    let parse = (_a = state.field($14831f1c512a5db9$export$ce4fe1c9e6520c1a.state, false)) === null || _a === void 0 ? void 0 : _a.context;
    if (!parse) return null;
    let oldVieport = parse.viewport;
    parse.updateViewport({
        from: 0,
        to: upto
    });
    let result = parse.isDone(upto) || parse.work(timeout, upto) ? parse.tree : null;
    parse.updateViewport(oldVieport);
    return result;
}
/**
Queries whether there is a full syntax tree available up to the
given document position. If there isn't, the background parse
process _might_ still be working and update the tree further, but
there is no guarantee of that—the parser will [stop
working](https://codemirror.net/6/docs/ref/#language.syntaxParserRunning) when it has spent a
certain amount of time or has moved beyond the visible viewport.
Always returns false if no language has been enabled.
*/ function $14831f1c512a5db9$export$2c95b013b0941e86(state, upto = state.doc.length) {
    var _a;
    return ((_a = state.field($14831f1c512a5db9$export$ce4fe1c9e6520c1a.state, false)) === null || _a === void 0 ? void 0 : _a.context.isDone(upto)) || false;
}
/**
Move parsing forward, and update the editor state afterwards to
reflect the new tree. Will work for at most `timeout`
milliseconds. Returns true if the parser managed get to the given
position in that time.
*/ function $14831f1c512a5db9$export$b3bcb61c35026d72(view, upto = view.viewport.to, timeout = 100) {
    let success = $14831f1c512a5db9$export$8694796f3a52e973(view.state, upto, timeout);
    if (success != $14831f1c512a5db9$export$7fc98e56a4ca6be1(view.state)) view.dispatch({});
    return !!success;
}
/**
Tells you whether the language parser is planning to do more
parsing work (in a `requestIdleCallback` pseudo-thread) or has
stopped running, either because it parsed the entire document,
because it spent too much time and was cut off, or because there
is no language parser enabled.
*/ function $14831f1c512a5db9$export$23c0ee92d6189d3f(view) {
    var _a;
    return ((_a = view.plugin($14831f1c512a5db9$var$parseWorker)) === null || _a === void 0 ? void 0 : _a.isWorking()) || false;
}
/**
Lezer-style
[`Input`](https://lezer.codemirror.net/docs/ref#common.Input)
object for a [`Text`](https://codemirror.net/6/docs/ref/#state.Text) object.
*/ class $14831f1c512a5db9$export$78c262ab5af874ad {
    /**
    Create an input object for the given document.
    */ constructor(doc){
        this.doc = doc;
        this.cursorPos = 0;
        this.string = "";
        this.cursor = doc.iter();
    }
    get length() {
        return this.doc.length;
    }
    syncTo(pos) {
        this.string = this.cursor.next(pos - this.cursorPos).value;
        this.cursorPos = pos + this.string.length;
        return this.cursorPos - this.string.length;
    }
    chunk(pos) {
        this.syncTo(pos);
        return this.string;
    }
    get lineChunks() {
        return true;
    }
    read(from, to) {
        let stringStart = this.cursorPos - this.string.length;
        if (from < stringStart || to >= this.cursorPos) return this.doc.sliceString(from, to);
        else return this.string.slice(from - stringStart, to - stringStart);
    }
}
let $14831f1c512a5db9$var$currentContext = null;
/**
A parse context provided to parsers working on the editor content.
*/ class $14831f1c512a5db9$export$3fcb7c01ff2a41fa {
    constructor(parser, /**
    The current editor state.
    */ state, /**
    Tree fragments that can be reused by incremental re-parses.
    */ fragments = [], /**
    @internal
    */ tree, /**
    @internal
    */ treeLen, /**
    The current editor viewport (or some overapproximation
    thereof). Intended to be used for opportunistically avoiding
    work (in which case
    [`skipUntilInView`](https://codemirror.net/6/docs/ref/#language.ParseContext.skipUntilInView)
    should be called to make sure the parser is restarted when the
    skipped region becomes visible).
    */ viewport, /**
    @internal
    */ skipped, /**
    This is where skipping parsers can register a promise that,
    when resolved, will schedule a new parse. It is cleared when
    the parse worker picks up the promise. @internal
    */ scheduleOn){
        this.parser = parser;
        this.state = state;
        this.fragments = fragments;
        this.tree = tree;
        this.treeLen = treeLen;
        this.viewport = viewport;
        this.skipped = skipped;
        this.scheduleOn = scheduleOn;
        this.parse = null;
        /**
        @internal
        */ this.tempSkipped = [];
    }
    /**
    @internal
    */ static create(parser, state, viewport) {
        return new $14831f1c512a5db9$export$3fcb7c01ff2a41fa(parser, state, [], (0, $6DlXS.Tree).empty, 0, viewport, [], null);
    }
    startParse() {
        return this.parser.startParse(new $14831f1c512a5db9$export$78c262ab5af874ad(this.state.doc), this.fragments);
    }
    /**
    @internal
    */ work(until, upto) {
        if (upto != null && upto >= this.state.doc.length) upto = undefined;
        if (this.tree != (0, $6DlXS.Tree).empty && this.isDone(upto !== null && upto !== void 0 ? upto : this.state.doc.length)) {
            this.takeTree();
            return true;
        }
        return this.withContext(()=>{
            var _a;
            if (typeof until == "number") {
                let endTime = Date.now() + until;
                until = ()=>Date.now() > endTime;
            }
            if (!this.parse) this.parse = this.startParse();
            if (upto != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > upto) && upto < this.state.doc.length) this.parse.stopAt(upto);
            for(;;){
                let done = this.parse.advance();
                if (done) {
                    this.fragments = this.withoutTempSkipped((0, $6DlXS.TreeFragment).addTree(done, this.fragments, this.parse.stoppedAt != null));
                    this.treeLen = (_a = this.parse.stoppedAt) !== null && _a !== void 0 ? _a : this.state.doc.length;
                    this.tree = done;
                    this.parse = null;
                    if (this.treeLen < (upto !== null && upto !== void 0 ? upto : this.state.doc.length)) this.parse = this.startParse();
                    else return true;
                }
                if (until()) return false;
            }
        });
    }
    /**
    @internal
    */ takeTree() {
        let pos, tree;
        if (this.parse && (pos = this.parse.parsedPos) >= this.treeLen) {
            if (this.parse.stoppedAt == null || this.parse.stoppedAt > pos) this.parse.stopAt(pos);
            this.withContext(()=>{
                while(!(tree = this.parse.advance()));
            });
            this.treeLen = pos;
            this.tree = tree;
            this.fragments = this.withoutTempSkipped((0, $6DlXS.TreeFragment).addTree(this.tree, this.fragments, true));
            this.parse = null;
        }
    }
    withContext(f) {
        let prev = $14831f1c512a5db9$var$currentContext;
        $14831f1c512a5db9$var$currentContext = this;
        try {
            return f();
        } finally{
            $14831f1c512a5db9$var$currentContext = prev;
        }
    }
    withoutTempSkipped(fragments) {
        for(let r; r = this.tempSkipped.pop();)fragments = $14831f1c512a5db9$var$cutFragments(fragments, r.from, r.to);
        return fragments;
    }
    /**
    @internal
    */ changes(changes, newState) {
        let { fragments: fragments, tree: tree, treeLen: treeLen, viewport: viewport, skipped: skipped } = this;
        this.takeTree();
        if (!changes.empty) {
            let ranges = [];
            changes.iterChangedRanges((fromA, toA, fromB, toB)=>ranges.push({
                    fromA: fromA,
                    toA: toA,
                    fromB: fromB,
                    toB: toB
                }));
            fragments = (0, $6DlXS.TreeFragment).applyChanges(fragments, ranges);
            tree = (0, $6DlXS.Tree).empty;
            treeLen = 0;
            viewport = {
                from: changes.mapPos(viewport.from, -1),
                to: changes.mapPos(viewport.to, 1)
            };
            if (this.skipped.length) {
                skipped = [];
                for (let r of this.skipped){
                    let from = changes.mapPos(r.from, 1), to = changes.mapPos(r.to, -1);
                    if (from < to) skipped.push({
                        from: from,
                        to: to
                    });
                }
            }
        }
        return new $14831f1c512a5db9$export$3fcb7c01ff2a41fa(this.parser, newState, fragments, tree, treeLen, viewport, skipped, this.scheduleOn);
    }
    /**
    @internal
    */ updateViewport(viewport) {
        if (this.viewport.from == viewport.from && this.viewport.to == viewport.to) return false;
        this.viewport = viewport;
        let startLen = this.skipped.length;
        for(let i = 0; i < this.skipped.length; i++){
            let { from: from, to: to } = this.skipped[i];
            if (from < viewport.to && to > viewport.from) {
                this.fragments = $14831f1c512a5db9$var$cutFragments(this.fragments, from, to);
                this.skipped.splice(i--, 1);
            }
        }
        if (this.skipped.length >= startLen) return false;
        this.reset();
        return true;
    }
    /**
    @internal
    */ reset() {
        if (this.parse) {
            this.takeTree();
            this.parse = null;
        }
    }
    /**
    Notify the parse scheduler that the given region was skipped
    because it wasn't in view, and the parse should be restarted
    when it comes into view.
    */ skipUntilInView(from, to) {
        this.skipped.push({
            from: from,
            to: to
        });
    }
    /**
    Returns a parser intended to be used as placeholder when
    asynchronously loading a nested parser. It'll skip its input and
    mark it as not-really-parsed, so that the next update will parse
    it again.
    
    When `until` is given, a reparse will be scheduled when that
    promise resolves.
    */ static getSkippingParser(until) {
        return new class extends (0, $6DlXS.Parser) {
            createParse(input, fragments, ranges) {
                let from = ranges[0].from, to = ranges[ranges.length - 1].to;
                let parser = {
                    parsedPos: from,
                    advance () {
                        let cx = $14831f1c512a5db9$var$currentContext;
                        if (cx) {
                            for (let r of ranges)cx.tempSkipped.push(r);
                            if (until) cx.scheduleOn = cx.scheduleOn ? Promise.all([
                                cx.scheduleOn,
                                until
                            ]) : until;
                        }
                        this.parsedPos = to;
                        return new (0, $6DlXS.Tree)((0, $6DlXS.NodeType).none, [], [], to - from);
                    },
                    stoppedAt: null,
                    stopAt () {}
                };
                return parser;
            }
        };
    }
    /**
    @internal
    */ isDone(upto) {
        upto = Math.min(upto, this.state.doc.length);
        let frags = this.fragments;
        return this.treeLen >= upto && frags.length && frags[0].from == 0 && frags[0].to >= upto;
    }
    /**
    Get the context for the current parse, or `null` if no editor
    parse is in progress.
    */ static get() {
        return $14831f1c512a5db9$var$currentContext;
    }
}
function $14831f1c512a5db9$var$cutFragments(fragments, from, to) {
    return (0, $6DlXS.TreeFragment).applyChanges(fragments, [
        {
            fromA: from,
            toA: to,
            fromB: from,
            toB: to
        }
    ]);
}
class $14831f1c512a5db9$var$LanguageState {
    constructor(// A mutable parse state that is used to preserve work done during
    // the lifetime of a state when moving to the next state.
    context){
        this.context = context;
        this.tree = context.tree;
    }
    apply(tr) {
        if (!tr.docChanged && this.tree == this.context.tree) return this;
        let newCx = this.context.changes(tr.changes, tr.state);
        // If the previous parse wasn't done, go forward only up to its
        // end position or the end of the viewport, to avoid slowing down
        // state updates with parse work beyond the viewport.
        let upto = this.context.treeLen == tr.startState.doc.length ? undefined : Math.max(tr.changes.mapPos(this.context.treeLen), newCx.viewport.to);
        if (!newCx.work(20 /* Apply */ , upto)) newCx.takeTree();
        return new $14831f1c512a5db9$var$LanguageState(newCx);
    }
    static init(state) {
        let vpTo = Math.min(3000 /* InitViewport */ , state.doc.length);
        let parseState = $14831f1c512a5db9$export$3fcb7c01ff2a41fa.create(state.facet($14831f1c512a5db9$export$789c912f57fe164c).parser, state, {
            from: 0,
            to: vpTo
        });
        if (!parseState.work(20 /* Apply */ , vpTo)) parseState.takeTree();
        return new $14831f1c512a5db9$var$LanguageState(parseState);
    }
}
$14831f1c512a5db9$export$ce4fe1c9e6520c1a.state = /*@__PURE__*/ (0, $hB7kI.StateField).define({
    create: $14831f1c512a5db9$var$LanguageState.init,
    update (value, tr) {
        for (let e of tr.effects)if (e.is($14831f1c512a5db9$export$ce4fe1c9e6520c1a.setState)) return e.value;
        if (tr.startState.facet($14831f1c512a5db9$export$789c912f57fe164c) != tr.state.facet($14831f1c512a5db9$export$789c912f57fe164c)) return $14831f1c512a5db9$var$LanguageState.init(tr.state);
        return value.apply(tr);
    }
});
let $14831f1c512a5db9$var$requestIdle = (callback)=>{
    let timeout = setTimeout(()=>callback(), 500 /* MaxPause */ );
    return ()=>clearTimeout(timeout);
};
if (typeof requestIdleCallback != "undefined") $14831f1c512a5db9$var$requestIdle = (callback)=>{
    let idle = -1, timeout = setTimeout(()=>{
        idle = requestIdleCallback(callback, {
            timeout: 400 /* MinPause */ 
        });
    }, 100 /* MinPause */ );
    return ()=>idle < 0 ? clearTimeout(timeout) : cancelIdleCallback(idle);
};
const $14831f1c512a5db9$var$isInputPending = typeof navigator != "undefined" && (($14831f1c512a5db9$var$_a = navigator.scheduling) === null || $14831f1c512a5db9$var$_a === void 0 ? void 0 : $14831f1c512a5db9$var$_a.isInputPending) ? ()=>navigator.scheduling.isInputPending() : null;
const $14831f1c512a5db9$var$parseWorker = /*@__PURE__*/ (0, $jQ4bL.ViewPlugin).fromClass(class ParseWorker {
    constructor(view){
        this.view = view;
        this.working = null;
        this.workScheduled = 0;
        // End of the current time chunk
        this.chunkEnd = -1;
        // Milliseconds of budget left for this chunk
        this.chunkBudget = -1;
        this.work = this.work.bind(this);
        this.scheduleWork();
    }
    update(update) {
        let cx = this.view.state.field($14831f1c512a5db9$export$ce4fe1c9e6520c1a.state).context;
        if (cx.updateViewport(update.view.viewport) || this.view.viewport.to > cx.treeLen) this.scheduleWork();
        if (update.docChanged) {
            if (this.view.hasFocus) this.chunkBudget += 50 /* ChangeBonus */ ;
            this.scheduleWork();
        }
        this.checkAsyncSchedule(cx);
    }
    scheduleWork() {
        if (this.working) return;
        let { state: state } = this.view, field = state.field($14831f1c512a5db9$export$ce4fe1c9e6520c1a.state);
        if (field.tree != field.context.tree || !field.context.isDone(state.doc.length)) this.working = $14831f1c512a5db9$var$requestIdle(this.work);
    }
    work(deadline) {
        this.working = null;
        let now = Date.now();
        if (this.chunkEnd < now && (this.chunkEnd < 0 || this.view.hasFocus)) {
            this.chunkEnd = now + 30000 /* ChunkTime */ ;
            this.chunkBudget = 3000 /* ChunkBudget */ ;
        }
        if (this.chunkBudget <= 0) return; // No more budget
        let { state: state, viewport: { to: vpTo } } = this.view, field = state.field($14831f1c512a5db9$export$ce4fe1c9e6520c1a.state);
        if (field.tree == field.context.tree && field.context.isDone(vpTo + 100000 /* MaxParseAhead */ )) return;
        let endTime = Date.now() + Math.min(this.chunkBudget, 100 /* Slice */ , deadline && !$14831f1c512a5db9$var$isInputPending ? Math.max(25 /* MinSlice */ , deadline.timeRemaining() - 5) : 1e9);
        let viewportFirst = field.context.treeLen < vpTo && state.doc.length > vpTo + 1000;
        let done = field.context.work(()=>{
            return $14831f1c512a5db9$var$isInputPending && $14831f1c512a5db9$var$isInputPending() || Date.now() > endTime;
        }, vpTo + (viewportFirst ? 0 : 100000 /* MaxParseAhead */ ));
        this.chunkBudget -= Date.now() - now;
        if (done || this.chunkBudget <= 0) {
            field.context.takeTree();
            this.view.dispatch({
                effects: $14831f1c512a5db9$export$ce4fe1c9e6520c1a.setState.of(new $14831f1c512a5db9$var$LanguageState(field.context))
            });
        }
        if (this.chunkBudget > 0 && !(done && !viewportFirst)) this.scheduleWork();
        this.checkAsyncSchedule(field.context);
    }
    checkAsyncSchedule(cx) {
        if (cx.scheduleOn) {
            this.workScheduled++;
            cx.scheduleOn.then(()=>this.scheduleWork()).catch((err)=>(0, $jQ4bL.logException)(this.view.state, err)).then(()=>this.workScheduled--);
            cx.scheduleOn = null;
        }
    }
    destroy() {
        if (this.working) this.working();
    }
    isWorking() {
        return !!(this.working || this.workScheduled > 0);
    }
}, {
    eventHandlers: {
        focus () {
            this.scheduleWork();
        }
    }
});
/**
The facet used to associate a language with an editor state. Used
by `Language` object's `extension` property (so you don't need to
manually wrap your languages in this). Can be used to access the
current language on a state.
*/ const $14831f1c512a5db9$export$789c912f57fe164c = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine (languages) {
        return languages.length ? languages[0] : null;
    },
    enables: (language)=>[
            $14831f1c512a5db9$export$ce4fe1c9e6520c1a.state,
            $14831f1c512a5db9$var$parseWorker,
            (0, $jQ4bL.EditorView).contentAttributes.compute([
                language
            ], (state)=>{
                let lang = state.facet(language);
                return lang && lang.name ? {
                    "data-language": lang.name
                } : {};
            })
        ]
});
/**
This class bundles a [language](https://codemirror.net/6/docs/ref/#language.Language) with an
optional set of supporting extensions. Language packages are
encouraged to export a function that optionally takes a
configuration object and returns a `LanguageSupport` instance, as
the main way for client code to use the package.
*/ class $14831f1c512a5db9$export$cbdefefa8a51dd3b {
    /**
    Create a language support object.
    */ constructor(/**
    The language object.
    */ language, /**
    An optional set of supporting extensions. When nesting a
    language in another language, the outer language is encouraged
    to include the supporting extensions for its inner languages
    in its own set of support extensions.
    */ support = []){
        this.language = language;
        this.support = support;
        this.extension = [
            language,
            support
        ];
    }
}
/**
Language descriptions are used to store metadata about languages
and to dynamically load them. Their main role is finding the
appropriate language for a filename or dynamically loading nested
parsers.
*/ class $14831f1c512a5db9$export$50ab82debf88f71 {
    constructor(/**
    The name of this language.
    */ name, /**
    Alternative names for the mode (lowercased, includes `this.name`).
    */ alias, /**
    File extensions associated with this language.
    */ extensions, /**
    Optional filename pattern that should be associated with this
    language.
    */ filename, loadFunc, /**
    If the language has been loaded, this will hold its value.
    */ support){
        this.name = name;
        this.alias = alias;
        this.extensions = extensions;
        this.filename = filename;
        this.loadFunc = loadFunc;
        this.support = support;
        this.loading = null;
    }
    /**
    Start loading the the language. Will return a promise that
    resolves to a [`LanguageSupport`](https://codemirror.net/6/docs/ref/#language.LanguageSupport)
    object when the language successfully loads.
    */ load() {
        return this.loading || (this.loading = this.loadFunc().then((support)=>this.support = support, (err)=>{
            this.loading = null;
            throw err;
        }));
    }
    /**
    Create a language description.
    */ static of(spec) {
        let { load: load, support: support } = spec;
        if (!load) {
            if (!support) throw new RangeError("Must pass either 'load' or 'support' to LanguageDescription.of");
            load = ()=>Promise.resolve(support);
        }
        return new $14831f1c512a5db9$export$50ab82debf88f71(spec.name, (spec.alias || []).concat(spec.name).map((s)=>s.toLowerCase()), spec.extensions || [], spec.filename, load, support);
    }
    /**
    Look for a language in the given array of descriptions that
    matches the filename. Will first match
    [`filename`](https://codemirror.net/6/docs/ref/#language.LanguageDescription.filename) patterns,
    and then [extensions](https://codemirror.net/6/docs/ref/#language.LanguageDescription.extensions),
    and return the first language that matches.
    */ static matchFilename(descs, filename) {
        for (let d of descs)if (d.filename && d.filename.test(filename)) return d;
        let ext = /\.([^.]+)$/.exec(filename);
        if (ext) {
            for (let d of descs)if (d.extensions.indexOf(ext[1]) > -1) return d;
        }
        return null;
    }
    /**
    Look for a language whose name or alias matches the the given
    name (case-insensitively). If `fuzzy` is true, and no direct
    matchs is found, this'll also search for a language whose name
    or alias occurs in the string (for names shorter than three
    characters, only when surrounded by non-word characters).
    */ static matchLanguageName(descs, name, fuzzy = true) {
        name = name.toLowerCase();
        for (let d of descs)if (d.alias.some((a)=>a == name)) return d;
        if (fuzzy) for (let d of descs)for (let a of d.alias){
            let found = name.indexOf(a);
            if (found > -1 && (a.length > 2 || !/\w/.test(name[found - 1]) && !/\w/.test(name[found + a.length]))) return d;
        }
        return null;
    }
}
/**
Facet that defines a way to provide a function that computes the
appropriate indentation depth, as a column number (see
[`indentString`](https://codemirror.net/6/docs/ref/#language.indentString)), at the start of a given
line. A return value of `null` indicates no indentation can be
determined, and the line should inherit the indentation of the one
above it. A return value of `undefined` defers to the next indent
service.
*/ const $14831f1c512a5db9$export$5952625dce50d1f3 = /*@__PURE__*/ (0, $hB7kI.Facet).define();
/**
Facet for overriding the unit by which indentation happens. Should
be a string consisting either entirely of the same whitespace
character. When not set, this defaults to 2 spaces.
*/ const $14831f1c512a5db9$export$9e0d0c2ce4d3ceb5 = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine: (values)=>{
        if (!values.length) return "  ";
        let unit = values[0];
        if (!unit || /\S/.test(unit) || Array.from(unit).some((e)=>e != unit[0])) throw new Error("Invalid indent unit: " + JSON.stringify(values[0]));
        return unit;
    }
});
/**
Return the _column width_ of an indent unit in the state.
Determined by the [`indentUnit`](https://codemirror.net/6/docs/ref/#language.indentUnit)
facet, and [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) when that
contains tabs.
*/ function $14831f1c512a5db9$export$ad3205d09311a797(state) {
    let unit = state.facet($14831f1c512a5db9$export$9e0d0c2ce4d3ceb5);
    return unit.charCodeAt(0) == 9 ? state.tabSize * unit.length : unit.length;
}
/**
Create an indentation string that covers columns 0 to `cols`.
Will use tabs for as much of the columns as possible when the
[`indentUnit`](https://codemirror.net/6/docs/ref/#language.indentUnit) facet contains
tabs.
*/ function $14831f1c512a5db9$export$db5a40e207b40576(state, cols) {
    let result = "", ts = state.tabSize, ch = state.facet($14831f1c512a5db9$export$9e0d0c2ce4d3ceb5)[0];
    if (ch == "	") {
        while(cols >= ts){
            result += "	";
            cols -= ts;
        }
        ch = " ";
    }
    for(let i = 0; i < cols; i++)result += ch;
    return result;
}
/**
Get the indentation, as a column number, at the given position.
Will first consult any [indent services](https://codemirror.net/6/docs/ref/#language.indentService)
that are registered, and if none of those return an indentation,
this will check the syntax tree for the [indent node
prop](https://codemirror.net/6/docs/ref/#language.indentNodeProp) and use that if found. Returns a
number when an indentation could be determined, and null
otherwise.
*/ function $14831f1c512a5db9$export$a2d3c9dbce6d2211(context, pos) {
    if (context instanceof (0, $hB7kI.EditorState)) context = new $14831f1c512a5db9$export$eeab79349cc2f7c8(context);
    for (let service of context.state.facet($14831f1c512a5db9$export$5952625dce50d1f3)){
        let result = service(context, pos);
        if (result !== undefined) return result;
    }
    let tree = $14831f1c512a5db9$export$7fc98e56a4ca6be1(context.state);
    return tree ? $14831f1c512a5db9$var$syntaxIndentation(context, tree, pos) : null;
}
/**
Create a change set that auto-indents all lines touched by the
given document range.
*/ function $14831f1c512a5db9$export$2fc72a4ad8b85e40(state, from, to) {
    let updated = Object.create(null);
    let context = new $14831f1c512a5db9$export$eeab79349cc2f7c8(state, {
        overrideIndentation: (start)=>{
            var _a;
            return (_a = updated[start]) !== null && _a !== void 0 ? _a : -1;
        }
    });
    let changes = [];
    for(let pos = from; pos <= to;){
        let line = state.doc.lineAt(pos);
        pos = line.to + 1;
        let indent = $14831f1c512a5db9$export$a2d3c9dbce6d2211(context, line.from);
        if (indent == null) continue;
        if (!/\S/.test(line.text)) indent = 0;
        let cur = /^\s*/.exec(line.text)[0];
        let norm = $14831f1c512a5db9$export$db5a40e207b40576(state, indent);
        if (cur != norm) {
            updated[line.from] = indent;
            changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
    }
    return state.changes(changes);
}
/**
Indentation contexts are used when calling [indentation
services](https://codemirror.net/6/docs/ref/#language.indentService). They provide helper utilities
useful in indentation logic, and can selectively override the
indentation reported for some lines.
*/ class $14831f1c512a5db9$export$eeab79349cc2f7c8 {
    /**
    Create an indent context.
    */ constructor(/**
    The editor state.
    */ state, /**
    @internal
    */ options = {}){
        this.state = state;
        this.options = options;
        this.unit = $14831f1c512a5db9$export$ad3205d09311a797(state);
    }
    /**
    Get a description of the line at the given position, taking
    [simulated line
    breaks](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
    into account. If there is such a break at `pos`, the `bias`
    argument determines whether the part of the line line before or
    after the break is used.
    */ lineAt(pos, bias = 1) {
        let line = this.state.doc.lineAt(pos);
        let { simulateBreak: simulateBreak, simulateDoubleBreak: simulateDoubleBreak } = this.options;
        if (simulateBreak != null && simulateBreak >= line.from && simulateBreak <= line.to) {
            if (simulateDoubleBreak && simulateBreak == pos) return {
                text: "",
                from: pos
            };
            else if (bias < 0 ? simulateBreak < pos : simulateBreak <= pos) return {
                text: line.text.slice(simulateBreak - line.from),
                from: simulateBreak
            };
            else return {
                text: line.text.slice(0, simulateBreak - line.from),
                from: line.from
            };
        }
        return line;
    }
    /**
    Get the text directly after `pos`, either the entire line
    or the next 100 characters, whichever is shorter.
    */ textAfterPos(pos, bias = 1) {
        if (this.options.simulateDoubleBreak && pos == this.options.simulateBreak) return "";
        let { text: text, from: from } = this.lineAt(pos, bias);
        return text.slice(pos - from, Math.min(text.length, pos + 100 - from));
    }
    /**
    Find the column for the given position.
    */ column(pos, bias = 1) {
        let { text: text, from: from } = this.lineAt(pos, bias);
        let result = this.countColumn(text, pos - from);
        let override = this.options.overrideIndentation ? this.options.overrideIndentation(from) : -1;
        if (override > -1) result += override - this.countColumn(text, text.search(/\S|$/));
        return result;
    }
    /**
    Find the column position (taking tabs into account) of the given
    position in the given string.
    */ countColumn(line, pos = line.length) {
        return (0, $hB7kI.countColumn)(line, this.state.tabSize, pos);
    }
    /**
    Find the indentation column of the line at the given point.
    */ lineIndent(pos, bias = 1) {
        let { text: text, from: from } = this.lineAt(pos, bias);
        let override = this.options.overrideIndentation;
        if (override) {
            let overriden = override(from);
            if (overriden > -1) return overriden;
        }
        return this.countColumn(text, text.search(/\S|$/));
    }
    /**
    Returns the [simulated line
    break](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
    for this context, if any.
    */ get simulatedBreak() {
        return this.options.simulateBreak || null;
    }
}
/**
A syntax tree node prop used to associate indentation strategies
with node types. Such a strategy is a function from an indentation
context to a column number (see also
[`indentString`](https://codemirror.net/6/docs/ref/#language.indentString)) or null, where null
indicates that no definitive indentation can be determined.
*/ const $14831f1c512a5db9$export$72c7d4c52b3c6460 = /*@__PURE__*/ new (0, $6DlXS.NodeProp)();
// Compute the indentation for a given position from the syntax tree.
function $14831f1c512a5db9$var$syntaxIndentation(cx, ast, pos) {
    return $14831f1c512a5db9$var$indentFrom(ast.resolveInner(pos).enterUnfinishedNodesBefore(pos), pos, cx);
}
function $14831f1c512a5db9$var$ignoreClosed(cx) {
    return cx.pos == cx.options.simulateBreak && cx.options.simulateDoubleBreak;
}
function $14831f1c512a5db9$var$indentStrategy(tree) {
    let strategy = tree.type.prop($14831f1c512a5db9$export$72c7d4c52b3c6460);
    if (strategy) return strategy;
    let first = tree.firstChild, close;
    if (first && (close = first.type.prop((0, $6DlXS.NodeProp).closedBy))) {
        let last = tree.lastChild, closed = last && close.indexOf(last.name) > -1;
        return (cx)=>$14831f1c512a5db9$var$delimitedStrategy(cx, true, 1, undefined, closed && !$14831f1c512a5db9$var$ignoreClosed(cx) ? last.from : undefined);
    }
    return tree.parent == null ? $14831f1c512a5db9$var$topIndent : null;
}
function $14831f1c512a5db9$var$indentFrom(node, pos, base) {
    for(; node; node = node.parent){
        let strategy = $14831f1c512a5db9$var$indentStrategy(node);
        if (strategy) return strategy($14831f1c512a5db9$export$8aaeb0848a33f7c3.create(base, pos, node));
    }
    return null;
}
function $14831f1c512a5db9$var$topIndent() {
    return 0;
}
/**
Objects of this type provide context information and helper
methods to indentation functions registered on syntax nodes.
*/ class $14831f1c512a5db9$export$8aaeb0848a33f7c3 extends $14831f1c512a5db9$export$eeab79349cc2f7c8 {
    constructor(base, /**
    The position at which indentation is being computed.
    */ pos, /**
    The syntax tree node to which the indentation strategy
    applies.
    */ node){
        super(base.state, base.options);
        this.base = base;
        this.pos = pos;
        this.node = node;
    }
    /**
    @internal
    */ static create(base, pos, node) {
        return new $14831f1c512a5db9$export$8aaeb0848a33f7c3(base, pos, node);
    }
    /**
    Get the text directly after `this.pos`, either the entire line
    or the next 100 characters, whichever is shorter.
    */ get textAfter() {
        return this.textAfterPos(this.pos);
    }
    /**
    Get the indentation at the reference line for `this.node`, which
    is the line on which it starts, unless there is a node that is
    _not_ a parent of this node covering the start of that line. If
    so, the line at the start of that node is tried, again skipping
    on if it is covered by another such node.
    */ get baseIndent() {
        return this.baseIndentFor(this.node);
    }
    /**
    Get the indentation for the reference line of the given node
    (see [`baseIndent`](https://codemirror.net/6/docs/ref/#language.TreeIndentContext.baseIndent)).
    */ baseIndentFor(node) {
        let line = this.state.doc.lineAt(node.from);
        // Skip line starts that are covered by a sibling (or cousin, etc)
        for(;;){
            let atBreak = node.resolve(line.from);
            while(atBreak.parent && atBreak.parent.from == atBreak.from)atBreak = atBreak.parent;
            if ($14831f1c512a5db9$var$isParent(atBreak, node)) break;
            line = this.state.doc.lineAt(atBreak.from);
        }
        return this.lineIndent(line.from);
    }
    /**
    Continue looking for indentations in the node's parent nodes,
    and return the result of that.
    */ continue() {
        let parent = this.node.parent;
        return parent ? $14831f1c512a5db9$var$indentFrom(parent, this.pos, this.base) : 0;
    }
}
function $14831f1c512a5db9$var$isParent(parent, of) {
    for(let cur = of; cur; cur = cur.parent)if (parent == cur) return true;
    return false;
}
// Check whether a delimited node is aligned (meaning there are
// non-skipped nodes on the same line as the opening delimiter). And
// if so, return the opening token.
function $14831f1c512a5db9$var$bracketedAligned(context) {
    let tree = context.node;
    let openToken = tree.childAfter(tree.from), last = tree.lastChild;
    if (!openToken) return null;
    let sim = context.options.simulateBreak;
    let openLine = context.state.doc.lineAt(openToken.from);
    let lineEnd = sim == null || sim <= openLine.from ? openLine.to : Math.min(openLine.to, sim);
    for(let pos = openToken.to;;){
        let next = tree.childAfter(pos);
        if (!next || next == last) return null;
        if (!next.type.isSkipped) return next.from < lineEnd ? openToken : null;
        pos = next.to;
    }
}
/**
An indentation strategy for delimited (usually bracketed) nodes.
Will, by default, indent one unit more than the parent's base
indent unless the line starts with a closing token. When `align`
is true and there are non-skipped nodes on the node's opening
line, the content of the node will be aligned with the end of the
opening node, like this:

    foo(bar,
        baz)
*/ function $14831f1c512a5db9$export$60e82ea306899488({ closing: closing, align: align = true, units: units = 1 }) {
    return (context)=>$14831f1c512a5db9$var$delimitedStrategy(context, align, units, closing);
}
function $14831f1c512a5db9$var$delimitedStrategy(context, align, units, closing, closedAt) {
    let after = context.textAfter, space = after.match(/^\s*/)[0].length;
    let closed = closing && after.slice(space, space + closing.length) == closing || closedAt == context.pos + space;
    let aligned = align ? $14831f1c512a5db9$var$bracketedAligned(context) : null;
    if (aligned) return closed ? context.column(aligned.from) : context.column(aligned.to);
    return context.baseIndent + (closed ? 0 : context.unit * units);
}
/**
An indentation strategy that aligns a node's content to its base
indentation.
*/ const $14831f1c512a5db9$export$4764c629086182f2 = (context)=>context.baseIndent;
/**
Creates an indentation strategy that, by default, indents
continued lines one unit more than the node's base indentation.
You can provide `except` to prevent indentation of lines that
match a pattern (for example `/^else\b/` in `if`/`else`
constructs), and you can change the amount of units used with the
`units` option.
*/ function $14831f1c512a5db9$export$688ff433e7e7cc5c({ except: except, units: units = 1 } = {}) {
    return (context)=>{
        let matchExcept = except && except.test(context.textAfter);
        return context.baseIndent + (matchExcept ? 0 : units * context.unit);
    };
}
const $14831f1c512a5db9$var$DontIndentBeyond = 200;
/**
Enables reindentation on input. When a language defines an
`indentOnInput` field in its [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt), which must hold a regular
expression, the line at the cursor will be reindented whenever new
text is typed and the input from the start of the line up to the
cursor matches that regexp.

To avoid unneccesary reindents, it is recommended to start the
regexp with `^` (usually followed by `\s*`), and end it with `$`.
For example, `/^\s*\}$/` will reindent when a closing brace is
added at the start of a line.
*/ function $14831f1c512a5db9$export$9bcaf6e2125ee117() {
    return (0, $hB7kI.EditorState).transactionFilter.of((tr)=>{
        if (!tr.docChanged || !tr.isUserEvent("input.type") && !tr.isUserEvent("input.complete")) return tr;
        let rules = tr.startState.languageDataAt("indentOnInput", tr.startState.selection.main.head);
        if (!rules.length) return tr;
        let doc = tr.newDoc, { head: head } = tr.newSelection.main, line = doc.lineAt(head);
        if (head > line.from + $14831f1c512a5db9$var$DontIndentBeyond) return tr;
        let lineStart = doc.sliceString(line.from, head);
        if (!rules.some((r)=>r.test(lineStart))) return tr;
        let { state: state } = tr, last = -1, changes = [];
        for (let { head: head } of state.selection.ranges){
            let line = state.doc.lineAt(head);
            if (line.from == last) continue;
            last = line.from;
            let indent = $14831f1c512a5db9$export$a2d3c9dbce6d2211(state, line.from);
            if (indent == null) continue;
            let cur = /^\s*/.exec(line.text)[0];
            let norm = $14831f1c512a5db9$export$db5a40e207b40576(state, indent);
            if (cur != norm) changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
        return changes.length ? [
            tr,
            {
                changes: changes,
                sequential: true
            }
        ] : tr;
    });
}
/**
A facet that registers a code folding service. When called with
the extent of a line, such a function should return a foldable
range that starts on that line (but continues beyond it), if one
can be found.
*/ const $14831f1c512a5db9$export$40014037e3ef64a = /*@__PURE__*/ (0, $hB7kI.Facet).define();
/**
This node prop is used to associate folding information with
syntax node types. Given a syntax node, it should check whether
that tree is foldable and return the range that can be collapsed
when it is.
*/ const $14831f1c512a5db9$export$9b075a85eb4377d8 = /*@__PURE__*/ new (0, $6DlXS.NodeProp)();
/**
[Fold](https://codemirror.net/6/docs/ref/#language.foldNodeProp) function that folds everything but
the first and the last child of a syntax node. Useful for nodes
that start and end with delimiters.
*/ function $14831f1c512a5db9$export$48672beae16a681b(node) {
    let first = node.firstChild, last = node.lastChild;
    return first && first.to < last.from ? {
        from: first.to,
        to: last.type.isError ? node.to : last.from
    } : null;
}
function $14831f1c512a5db9$var$syntaxFolding(state, start, end) {
    let tree = $14831f1c512a5db9$export$7fc98e56a4ca6be1(state);
    if (tree.length < end) return null;
    let inner = tree.resolveInner(end, 1);
    let found = null;
    for(let cur = inner; cur; cur = cur.parent){
        if (cur.to <= end || cur.from > end) continue;
        if (found && cur.from < start) break;
        let prop = cur.type.prop($14831f1c512a5db9$export$9b075a85eb4377d8);
        if (prop && (cur.to < tree.length - 50 || tree.length == state.doc.length || !$14831f1c512a5db9$var$isUnfinished(cur))) {
            let value = prop(cur, state);
            if (value && value.from <= end && value.from >= start && value.to > end) found = value;
        }
    }
    return found;
}
function $14831f1c512a5db9$var$isUnfinished(node) {
    let ch = node.lastChild;
    return ch && ch.to == node.to && ch.type.isError;
}
/**
Check whether the given line is foldable. First asks any fold
services registered through
[`foldService`](https://codemirror.net/6/docs/ref/#language.foldService), and if none of them return
a result, tries to query the [fold node
prop](https://codemirror.net/6/docs/ref/#language.foldNodeProp) of syntax nodes that cover the end
of the line.
*/ function $14831f1c512a5db9$export$cbe8a3d55245b07d(state, lineStart, lineEnd) {
    for (let service of state.facet($14831f1c512a5db9$export$40014037e3ef64a)){
        let result = service(state, lineStart, lineEnd);
        if (result) return result;
    }
    return $14831f1c512a5db9$var$syntaxFolding(state, lineStart, lineEnd);
}
function $14831f1c512a5db9$var$mapRange(range, mapping) {
    let from = mapping.mapPos(range.from, 1), to = mapping.mapPos(range.to, -1);
    return from >= to ? undefined : {
        from: from,
        to: to
    };
}
/**
State effect that can be attached to a transaction to fold the
given range. (You probably only need this in exceptional
circumstances—usually you'll just want to let
[`foldCode`](https://codemirror.net/6/docs/ref/#language.foldCode) and the [fold
gutter](https://codemirror.net/6/docs/ref/#language.foldGutter) create the transactions.)
*/ const $14831f1c512a5db9$export$a123efe007ad265 = /*@__PURE__*/ (0, $hB7kI.StateEffect).define({
    map: $14831f1c512a5db9$var$mapRange
});
/**
State effect that unfolds the given range (if it was folded).
*/ const $14831f1c512a5db9$export$bf2507dc398fc1ab = /*@__PURE__*/ (0, $hB7kI.StateEffect).define({
    map: $14831f1c512a5db9$var$mapRange
});
function $14831f1c512a5db9$var$selectedLines(view) {
    let lines = [];
    for (let { head: head } of view.state.selection.ranges){
        if (lines.some((l)=>l.from <= head && l.to >= head)) continue;
        lines.push(view.lineBlockAt(head));
    }
    return lines;
}
/**
The state field that stores the folded ranges (as a [decoration
set](https://codemirror.net/6/docs/ref/#view.DecorationSet)). Can be passed to
[`EditorState.toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) and
[`fromJSON`](https://codemirror.net/6/docs/ref/#state.EditorState^fromJSON) to serialize the fold
state.
*/ const $14831f1c512a5db9$export$6955fe1f7c578abb = /*@__PURE__*/ (0, $hB7kI.StateField).define({
    create () {
        return (0, $jQ4bL.Decoration).none;
    },
    update (folded, tr) {
        folded = folded.map(tr.changes);
        for (let e of tr.effects){
            if (e.is($14831f1c512a5db9$export$a123efe007ad265) && !$14831f1c512a5db9$var$foldExists(folded, e.value.from, e.value.to)) folded = folded.update({
                add: [
                    $14831f1c512a5db9$var$foldWidget.range(e.value.from, e.value.to)
                ]
            });
            else if (e.is($14831f1c512a5db9$export$bf2507dc398fc1ab)) folded = folded.update({
                filter: (from, to)=>e.value.from != from || e.value.to != to,
                filterFrom: e.value.from,
                filterTo: e.value.to
            });
        }
        // Clear folded ranges that cover the selection head
        if (tr.selection) {
            let onSelection = false, { head: head } = tr.selection.main;
            folded.between(head, head, (a, b)=>{
                if (a < head && b > head) onSelection = true;
            });
            if (onSelection) folded = folded.update({
                filterFrom: head,
                filterTo: head,
                filter: (a, b)=>b <= head || a >= head
            });
        }
        return folded;
    },
    provide: (f)=>(0, $jQ4bL.EditorView).decorations.from(f),
    toJSON (folded, state) {
        let ranges = [];
        folded.between(0, state.doc.length, (from, to)=>{
            ranges.push(from, to);
        });
        return ranges;
    },
    fromJSON (value) {
        if (!Array.isArray(value) || value.length % 2) throw new RangeError("Invalid JSON for fold state");
        let ranges = [];
        for(let i = 0; i < value.length;){
            let from = value[i++], to = value[i++];
            if (typeof from != "number" || typeof to != "number") throw new RangeError("Invalid JSON for fold state");
            ranges.push($14831f1c512a5db9$var$foldWidget.range(from, to));
        }
        return (0, $jQ4bL.Decoration).set(ranges, true);
    }
});
/**
Get a [range set](https://codemirror.net/6/docs/ref/#state.RangeSet) containing the folded ranges
in the given state.
*/ function $14831f1c512a5db9$export$2b3c199812391e05(state) {
    return state.field($14831f1c512a5db9$export$6955fe1f7c578abb, false) || (0, $hB7kI.RangeSet).empty;
}
function $14831f1c512a5db9$var$findFold(state, from, to) {
    var _a;
    let found = null;
    (_a = state.field($14831f1c512a5db9$export$6955fe1f7c578abb, false)) === null || _a === void 0 || _a.between(from, to, (from, to)=>{
        if (!found || found.from > from) found = {
            from: from,
            to: to
        };
    });
    return found;
}
function $14831f1c512a5db9$var$foldExists(folded, from, to) {
    let found = false;
    folded.between(from, from, (a, b)=>{
        if (a == from && b == to) found = true;
    });
    return found;
}
function $14831f1c512a5db9$var$maybeEnable(state, other) {
    return state.field($14831f1c512a5db9$export$6955fe1f7c578abb, false) ? other : other.concat((0, $hB7kI.StateEffect).appendConfig.of($14831f1c512a5db9$export$2c875b83a85d0f31()));
}
/**
Fold the lines that are selected, if possible.
*/ const $14831f1c512a5db9$export$52e96be2adbea02a = (view)=>{
    for (let line of $14831f1c512a5db9$var$selectedLines(view)){
        let range = $14831f1c512a5db9$export$cbe8a3d55245b07d(view.state, line.from, line.to);
        if (range) {
            view.dispatch({
                effects: $14831f1c512a5db9$var$maybeEnable(view.state, [
                    $14831f1c512a5db9$export$a123efe007ad265.of(range),
                    $14831f1c512a5db9$var$announceFold(view, range)
                ])
            });
            return true;
        }
    }
    return false;
};
/**
Unfold folded ranges on selected lines.
*/ const $14831f1c512a5db9$export$f4cd5e9f2c073861 = (view)=>{
    if (!view.state.field($14831f1c512a5db9$export$6955fe1f7c578abb, false)) return false;
    let effects = [];
    for (let line of $14831f1c512a5db9$var$selectedLines(view)){
        let folded = $14831f1c512a5db9$var$findFold(view.state, line.from, line.to);
        if (folded) effects.push($14831f1c512a5db9$export$bf2507dc398fc1ab.of(folded), $14831f1c512a5db9$var$announceFold(view, folded, false));
    }
    if (effects.length) view.dispatch({
        effects: effects
    });
    return effects.length > 0;
};
function $14831f1c512a5db9$var$announceFold(view, range, fold = true) {
    let lineFrom = view.state.doc.lineAt(range.from).number, lineTo = view.state.doc.lineAt(range.to).number;
    return (0, $jQ4bL.EditorView).announce.of(`${view.state.phrase(fold ? "Folded lines" : "Unfolded lines")} ${lineFrom} ${view.state.phrase("to")} ${lineTo}.`);
}
/**
Fold all top-level foldable ranges. Note that, in most cases,
folding information will depend on the [syntax
tree](https://codemirror.net/6/docs/ref/#language.syntaxTree), and folding everything may not work
reliably when the document hasn't been fully parsed (either
because the editor state was only just initialized, or because the
document is so big that the parser decided not to parse it
entirely).
*/ const $14831f1c512a5db9$export$5396d9eaf1c0ba76 = (view)=>{
    let { state: state } = view, effects = [];
    for(let pos = 0; pos < state.doc.length;){
        let line = view.lineBlockAt(pos), range = $14831f1c512a5db9$export$cbe8a3d55245b07d(state, line.from, line.to);
        if (range) effects.push($14831f1c512a5db9$export$a123efe007ad265.of(range));
        pos = (range ? view.lineBlockAt(range.to) : line).to + 1;
    }
    if (effects.length) view.dispatch({
        effects: $14831f1c512a5db9$var$maybeEnable(view.state, effects)
    });
    return !!effects.length;
};
/**
Unfold all folded code.
*/ const $14831f1c512a5db9$export$5671b24df569b27d = (view)=>{
    let field = view.state.field($14831f1c512a5db9$export$6955fe1f7c578abb, false);
    if (!field || !field.size) return false;
    let effects = [];
    field.between(0, view.state.doc.length, (from, to)=>{
        effects.push($14831f1c512a5db9$export$bf2507dc398fc1ab.of({
            from: from,
            to: to
        }));
    });
    view.dispatch({
        effects: effects
    });
    return true;
};
// Find the foldable region containing the given line, if one exists
function $14831f1c512a5db9$var$foldableContainer(view, lineBlock) {
    // Look backwards through line blocks until we find a foldable region that
    // intersects with the line
    for(let line = lineBlock;;){
        let foldableRegion = $14831f1c512a5db9$export$cbe8a3d55245b07d(view.state, line.from, line.to);
        if (foldableRegion && foldableRegion.to > lineBlock.from) return foldableRegion;
        if (!line.from) return null;
        line = view.lineBlockAt(line.from - 1);
    }
}
/**
Toggle folding at cursors. Unfolds if there is an existing fold
starting in that line, tries to find a foldable range around it
otherwise.
*/ const $14831f1c512a5db9$export$b23e83f59d68c8f1 = (view)=>{
    let effects = [];
    for (let line of $14831f1c512a5db9$var$selectedLines(view)){
        let folded = $14831f1c512a5db9$var$findFold(view.state, line.from, line.to);
        if (folded) effects.push($14831f1c512a5db9$export$bf2507dc398fc1ab.of(folded), $14831f1c512a5db9$var$announceFold(view, folded, false));
        else {
            let foldRange = $14831f1c512a5db9$var$foldableContainer(view, line);
            if (foldRange) effects.push($14831f1c512a5db9$export$a123efe007ad265.of(foldRange), $14831f1c512a5db9$var$announceFold(view, foldRange));
        }
    }
    if (effects.length > 0) view.dispatch({
        effects: $14831f1c512a5db9$var$maybeEnable(view.state, effects)
    });
    return !!effects.length;
};
/**
Default fold-related key bindings.

 - Ctrl-Shift-[ (Cmd-Alt-[ on macOS): [`foldCode`](https://codemirror.net/6/docs/ref/#language.foldCode).
 - Ctrl-Shift-] (Cmd-Alt-] on macOS): [`unfoldCode`](https://codemirror.net/6/docs/ref/#language.unfoldCode).
 - Ctrl-Alt-[: [`foldAll`](https://codemirror.net/6/docs/ref/#language.foldAll).
 - Ctrl-Alt-]: [`unfoldAll`](https://codemirror.net/6/docs/ref/#language.unfoldAll).
*/ const $14831f1c512a5db9$export$39c52376a8936d67 = [
    {
        key: "Ctrl-Shift-[",
        mac: "Cmd-Alt-[",
        run: $14831f1c512a5db9$export$52e96be2adbea02a
    },
    {
        key: "Ctrl-Shift-]",
        mac: "Cmd-Alt-]",
        run: $14831f1c512a5db9$export$f4cd5e9f2c073861
    },
    {
        key: "Ctrl-Alt-[",
        run: $14831f1c512a5db9$export$5396d9eaf1c0ba76
    },
    {
        key: "Ctrl-Alt-]",
        run: $14831f1c512a5db9$export$5671b24df569b27d
    }
];
const $14831f1c512a5db9$var$defaultConfig = {
    placeholderDOM: null,
    placeholderText: "…"
};
const $14831f1c512a5db9$var$foldConfig = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine (values) {
        return (0, $hB7kI.combineConfig)(values, $14831f1c512a5db9$var$defaultConfig);
    }
});
/**
Create an extension that configures code folding.
*/ function $14831f1c512a5db9$export$2c875b83a85d0f31(config) {
    let result = [
        $14831f1c512a5db9$export$6955fe1f7c578abb,
        $14831f1c512a5db9$var$baseTheme$1
    ];
    if (config) result.push($14831f1c512a5db9$var$foldConfig.of(config));
    return result;
}
const $14831f1c512a5db9$var$foldWidget = /*@__PURE__*/ (0, $jQ4bL.Decoration).replace({
    widget: /*@__PURE__*/ new class extends (0, $jQ4bL.WidgetType) {
        toDOM(view) {
            let { state: state } = view, conf = state.facet($14831f1c512a5db9$var$foldConfig);
            let onclick = (event)=>{
                let line = view.lineBlockAt(view.posAtDOM(event.target));
                let folded = $14831f1c512a5db9$var$findFold(view.state, line.from, line.to);
                if (folded) view.dispatch({
                    effects: $14831f1c512a5db9$export$bf2507dc398fc1ab.of(folded)
                });
                event.preventDefault();
            };
            if (conf.placeholderDOM) return conf.placeholderDOM(view, onclick);
            let element = document.createElement("span");
            element.textContent = conf.placeholderText;
            element.setAttribute("aria-label", state.phrase("folded code"));
            element.title = state.phrase("unfold");
            element.className = "cm-foldPlaceholder";
            element.onclick = onclick;
            return element;
        }
    }
});
const $14831f1c512a5db9$var$foldGutterDefaults = {
    openText: "⌄",
    closedText: "›",
    markerDOM: null,
    domEventHandlers: {},
    foldingChanged: ()=>false
};
class $14831f1c512a5db9$var$FoldMarker extends (0, $jQ4bL.GutterMarker) {
    constructor(config, open){
        super();
        this.config = config;
        this.open = open;
    }
    eq(other) {
        return this.config == other.config && this.open == other.open;
    }
    toDOM(view) {
        if (this.config.markerDOM) return this.config.markerDOM(this.open);
        let span = document.createElement("span");
        span.textContent = this.open ? this.config.openText : this.config.closedText;
        span.title = view.state.phrase(this.open ? "Fold line" : "Unfold line");
        return span;
    }
}
/**
Create an extension that registers a fold gutter, which shows a
fold status indicator before foldable lines (which can be clicked
to fold or unfold the line).
*/ function $14831f1c512a5db9$export$c4dcf64f741b6228(config = {}) {
    let fullConfig = Object.assign(Object.assign({}, $14831f1c512a5db9$var$foldGutterDefaults), config);
    let canFold = new $14831f1c512a5db9$var$FoldMarker(fullConfig, true), canUnfold = new $14831f1c512a5db9$var$FoldMarker(fullConfig, false);
    let markers = (0, $jQ4bL.ViewPlugin).fromClass(class {
        constructor(view){
            this.from = view.viewport.from;
            this.markers = this.buildMarkers(view);
        }
        update(update) {
            if (update.docChanged || update.viewportChanged || update.startState.facet($14831f1c512a5db9$export$789c912f57fe164c) != update.state.facet($14831f1c512a5db9$export$789c912f57fe164c) || update.startState.field($14831f1c512a5db9$export$6955fe1f7c578abb, false) != update.state.field($14831f1c512a5db9$export$6955fe1f7c578abb, false) || $14831f1c512a5db9$export$7fc98e56a4ca6be1(update.startState) != $14831f1c512a5db9$export$7fc98e56a4ca6be1(update.state) || fullConfig.foldingChanged(update)) this.markers = this.buildMarkers(update.view);
        }
        buildMarkers(view) {
            let builder = new (0, $hB7kI.RangeSetBuilder)();
            for (let line of view.viewportLineBlocks){
                let mark = $14831f1c512a5db9$var$findFold(view.state, line.from, line.to) ? canUnfold : $14831f1c512a5db9$export$cbe8a3d55245b07d(view.state, line.from, line.to) ? canFold : null;
                if (mark) builder.add(line.from, line.from, mark);
            }
            return builder.finish();
        }
    });
    let { domEventHandlers: domEventHandlers } = fullConfig;
    return [
        markers,
        (0, $jQ4bL.gutter)({
            class: "cm-foldGutter",
            markers (view) {
                var _a;
                return ((_a = view.plugin(markers)) === null || _a === void 0 ? void 0 : _a.markers) || (0, $hB7kI.RangeSet).empty;
            },
            initialSpacer () {
                return new $14831f1c512a5db9$var$FoldMarker(fullConfig, false);
            },
            domEventHandlers: Object.assign(Object.assign({}, domEventHandlers), {
                click: (view, line, event)=>{
                    if (domEventHandlers.click && domEventHandlers.click(view, line, event)) return true;
                    let folded = $14831f1c512a5db9$var$findFold(view.state, line.from, line.to);
                    if (folded) {
                        view.dispatch({
                            effects: $14831f1c512a5db9$export$bf2507dc398fc1ab.of(folded)
                        });
                        return true;
                    }
                    let range = $14831f1c512a5db9$export$cbe8a3d55245b07d(view.state, line.from, line.to);
                    if (range) {
                        view.dispatch({
                            effects: $14831f1c512a5db9$export$a123efe007ad265.of(range)
                        });
                        return true;
                    }
                    return false;
                }
            })
        }),
        $14831f1c512a5db9$export$2c875b83a85d0f31()
    ];
}
const $14831f1c512a5db9$var$baseTheme$1 = /*@__PURE__*/ (0, $jQ4bL.EditorView).baseTheme({
    ".cm-foldPlaceholder": {
        backgroundColor: "#eee",
        border: "1px solid #ddd",
        color: "#888",
        borderRadius: ".2em",
        margin: "0 1px",
        padding: "0 1px",
        cursor: "pointer"
    },
    ".cm-foldGutter span": {
        padding: "0 1px",
        cursor: "pointer"
    }
});
/**
A highlight style associates CSS styles with higlighting
[tags](https://lezer.codemirror.net/docs/ref#highlight.Tag).
*/ class $14831f1c512a5db9$export$4819f093bdd5b4a {
    constructor(/**
    The tag styles used to create this highlight style.
    */ specs, options){
        this.specs = specs;
        let modSpec;
        function def(spec) {
            let cls = (0, $luNHI.StyleModule).newName();
            (modSpec || (modSpec = Object.create(null)))["." + cls] = spec;
            return cls;
        }
        const all = typeof options.all == "string" ? options.all : options.all ? def(options.all) : undefined;
        const scopeOpt = options.scope;
        this.scope = scopeOpt instanceof $14831f1c512a5db9$export$ce4fe1c9e6520c1a ? (type)=>type.prop($14831f1c512a5db9$export$27a2e78097f753f7) == scopeOpt.data : scopeOpt ? (type)=>type == scopeOpt : undefined;
        this.style = (0, $6yW7d.tagHighlighter)(specs.map((style)=>({
                tag: style.tag,
                class: style.class || def(Object.assign({}, style, {
                    tag: null
                }))
            })), {
            all: all
        }).style;
        this.module = modSpec ? new (0, $luNHI.StyleModule)(modSpec) : null;
        this.themeType = options.themeType;
    }
    /**
    Create a highlighter style that associates the given styles to
    the given tags. The specs must be objects that hold a style tag
    or array of tags in their `tag` property, and either a single
    `class` property providing a static CSS class (for highlighter
    that rely on external styling), or a
    [`style-mod`](https://github.com/marijnh/style-mod#documentation)-style
    set of CSS properties (which define the styling for those tags).
    
    The CSS rules created for a highlighter will be emitted in the
    order of the spec's properties. That means that for elements that
    have multiple tags associated with them, styles defined further
    down in the list will have a higher CSS precedence than styles
    defined earlier.
    */ static define(specs, options) {
        return new $14831f1c512a5db9$export$4819f093bdd5b4a(specs, options || {});
    }
}
const $14831f1c512a5db9$var$highlighterFacet = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $14831f1c512a5db9$var$fallbackHighlighter = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine (values) {
        return values.length ? [
            values[0]
        ] : null;
    }
});
function $14831f1c512a5db9$var$getHighlighters(state) {
    let main = state.facet($14831f1c512a5db9$var$highlighterFacet);
    return main.length ? main : state.facet($14831f1c512a5db9$var$fallbackHighlighter);
}
/**
Wrap a highlighter in an editor extension that uses it to apply
syntax highlighting to the editor content.

When multiple (non-fallback) styles are provided, the styling
applied is the union of the classes they emit.
*/ function $14831f1c512a5db9$export$ec1b956ff3a16361(highlighter, options) {
    let ext = [
        $14831f1c512a5db9$var$treeHighlighter
    ], themeType;
    if (highlighter instanceof $14831f1c512a5db9$export$4819f093bdd5b4a) {
        if (highlighter.module) ext.push((0, $jQ4bL.EditorView).styleModule.of(highlighter.module));
        themeType = highlighter.themeType;
    }
    if (options === null || options === void 0 ? void 0 : options.fallback) ext.push($14831f1c512a5db9$var$fallbackHighlighter.of(highlighter));
    else if (themeType) ext.push($14831f1c512a5db9$var$highlighterFacet.computeN([
        (0, $jQ4bL.EditorView).darkTheme
    ], (state)=>{
        return state.facet((0, $jQ4bL.EditorView).darkTheme) == (themeType == "dark") ? [
            highlighter
        ] : [];
    }));
    else ext.push($14831f1c512a5db9$var$highlighterFacet.of(highlighter));
    return ext;
}
/**
Returns the CSS classes (if any) that the highlighters active in
the state would assign to the given style
[tags](https://lezer.codemirror.net/docs/ref#highlight.Tag) and
(optional) language
[scope](https://codemirror.net/6/docs/ref/#language.HighlightStyle^define^options.scope).
*/ function $14831f1c512a5db9$export$8ca2b052028e8782(state, tags, scope) {
    let highlighters = $14831f1c512a5db9$var$getHighlighters(state);
    let result = null;
    if (highlighters) {
        for (let highlighter of highlighters)if (!highlighter.scope || scope && highlighter.scope(scope)) {
            let cls = highlighter.style(tags);
            if (cls) result = result ? result + " " + cls : cls;
        }
    }
    return result;
}
class $14831f1c512a5db9$var$TreeHighlighter {
    constructor(view){
        this.markCache = Object.create(null);
        this.tree = $14831f1c512a5db9$export$7fc98e56a4ca6be1(view.state);
        this.decorations = this.buildDeco(view, $14831f1c512a5db9$var$getHighlighters(view.state));
    }
    update(update) {
        let tree = $14831f1c512a5db9$export$7fc98e56a4ca6be1(update.state), highlighters = $14831f1c512a5db9$var$getHighlighters(update.state);
        let styleChange = highlighters != $14831f1c512a5db9$var$getHighlighters(update.startState);
        if (tree.length < update.view.viewport.to && !styleChange && tree.type == this.tree.type) this.decorations = this.decorations.map(update.changes);
        else if (tree != this.tree || update.viewportChanged || styleChange) {
            this.tree = tree;
            this.decorations = this.buildDeco(update.view, highlighters);
        }
    }
    buildDeco(view, highlighters) {
        if (!highlighters || !this.tree.length) return (0, $jQ4bL.Decoration).none;
        let builder = new (0, $hB7kI.RangeSetBuilder)();
        for (let { from: from, to: to } of view.visibleRanges)(0, $6yW7d.highlightTree)(this.tree, highlighters, (from, to, style)=>{
            builder.add(from, to, this.markCache[style] || (this.markCache[style] = (0, $jQ4bL.Decoration).mark({
                class: style
            })));
        }, from, to);
        return builder.finish();
    }
}
const $14831f1c512a5db9$var$treeHighlighter = /*@__PURE__*/ (0, $hB7kI.Prec).high(/*@__PURE__*/ (0, $jQ4bL.ViewPlugin).fromClass($14831f1c512a5db9$var$TreeHighlighter, {
    decorations: (v)=>v.decorations
}));
/**
A default highlight style (works well with light themes).
*/ const $14831f1c512a5db9$export$bb02a6818dd48320 = /*@__PURE__*/ $14831f1c512a5db9$export$4819f093bdd5b4a.define([
    {
        tag: (0, $6yW7d.tags).meta,
        color: "#404740"
    },
    {
        tag: (0, $6yW7d.tags).link,
        textDecoration: "underline"
    },
    {
        tag: (0, $6yW7d.tags).heading,
        textDecoration: "underline",
        fontWeight: "bold"
    },
    {
        tag: (0, $6yW7d.tags).emphasis,
        fontStyle: "italic"
    },
    {
        tag: (0, $6yW7d.tags).strong,
        fontWeight: "bold"
    },
    {
        tag: (0, $6yW7d.tags).strikethrough,
        textDecoration: "line-through"
    },
    {
        tag: (0, $6yW7d.tags).keyword,
        color: "#708"
    },
    {
        tag: [
            (0, $6yW7d.tags).atom,
            (0, $6yW7d.tags).bool,
            (0, $6yW7d.tags).url,
            (0, $6yW7d.tags).contentSeparator,
            (0, $6yW7d.tags).labelName
        ],
        color: "#219"
    },
    {
        tag: [
            (0, $6yW7d.tags).literal,
            (0, $6yW7d.tags).inserted
        ],
        color: "#164"
    },
    {
        tag: [
            (0, $6yW7d.tags).string,
            (0, $6yW7d.tags).deleted
        ],
        color: "#a11"
    },
    {
        tag: [
            (0, $6yW7d.tags).regexp,
            (0, $6yW7d.tags).escape,
            /*@__PURE__*/ (0, $6yW7d.tags).special((0, $6yW7d.tags).string)
        ],
        color: "#e40"
    },
    {
        tag: /*@__PURE__*/ (0, $6yW7d.tags).definition((0, $6yW7d.tags).variableName),
        color: "#00f"
    },
    {
        tag: /*@__PURE__*/ (0, $6yW7d.tags).local((0, $6yW7d.tags).variableName),
        color: "#30a"
    },
    {
        tag: [
            (0, $6yW7d.tags).typeName,
            (0, $6yW7d.tags).namespace
        ],
        color: "#085"
    },
    {
        tag: (0, $6yW7d.tags).className,
        color: "#167"
    },
    {
        tag: [
            /*@__PURE__*/ (0, $6yW7d.tags).special((0, $6yW7d.tags).variableName),
            (0, $6yW7d.tags).macroName
        ],
        color: "#256"
    },
    {
        tag: /*@__PURE__*/ (0, $6yW7d.tags).definition((0, $6yW7d.tags).propertyName),
        color: "#00c"
    },
    {
        tag: (0, $6yW7d.tags).comment,
        color: "#940"
    },
    {
        tag: (0, $6yW7d.tags).invalid,
        color: "#f00"
    }
]);
const $14831f1c512a5db9$var$baseTheme = /*@__PURE__*/ (0, $jQ4bL.EditorView).baseTheme({
    "&.cm-focused .cm-matchingBracket": {
        backgroundColor: "#328c8252"
    },
    "&.cm-focused .cm-nonmatchingBracket": {
        backgroundColor: "#bb555544"
    }
});
const $14831f1c512a5db9$var$DefaultScanDist = 10000, $14831f1c512a5db9$var$DefaultBrackets = "()[]{}";
const $14831f1c512a5db9$var$bracketMatchingConfig = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine (configs) {
        return (0, $hB7kI.combineConfig)(configs, {
            afterCursor: true,
            brackets: $14831f1c512a5db9$var$DefaultBrackets,
            maxScanDistance: $14831f1c512a5db9$var$DefaultScanDist,
            renderMatch: $14831f1c512a5db9$var$defaultRenderMatch
        });
    }
});
const $14831f1c512a5db9$var$matchingMark = /*@__PURE__*/ (0, $jQ4bL.Decoration).mark({
    class: "cm-matchingBracket"
}), $14831f1c512a5db9$var$nonmatchingMark = /*@__PURE__*/ (0, $jQ4bL.Decoration).mark({
    class: "cm-nonmatchingBracket"
});
function $14831f1c512a5db9$var$defaultRenderMatch(match) {
    let decorations = [];
    let mark = match.matched ? $14831f1c512a5db9$var$matchingMark : $14831f1c512a5db9$var$nonmatchingMark;
    decorations.push(mark.range(match.start.from, match.start.to));
    if (match.end) decorations.push(mark.range(match.end.from, match.end.to));
    return decorations;
}
const $14831f1c512a5db9$var$bracketMatchingState = /*@__PURE__*/ (0, $hB7kI.StateField).define({
    create () {
        return (0, $jQ4bL.Decoration).none;
    },
    update (deco, tr) {
        if (!tr.docChanged && !tr.selection) return deco;
        let decorations = [];
        let config = tr.state.facet($14831f1c512a5db9$var$bracketMatchingConfig);
        for (let range of tr.state.selection.ranges){
            if (!range.empty) continue;
            let match = $14831f1c512a5db9$export$3391942603e90cda(tr.state, range.head, -1, config) || range.head > 0 && $14831f1c512a5db9$export$3391942603e90cda(tr.state, range.head - 1, 1, config) || config.afterCursor && ($14831f1c512a5db9$export$3391942603e90cda(tr.state, range.head, 1, config) || range.head < tr.state.doc.length && $14831f1c512a5db9$export$3391942603e90cda(tr.state, range.head + 1, -1, config));
            if (match) decorations = decorations.concat(config.renderMatch(match, tr.state));
        }
        return (0, $jQ4bL.Decoration).set(decorations, true);
    },
    provide: (f)=>(0, $jQ4bL.EditorView).decorations.from(f)
});
const $14831f1c512a5db9$var$bracketMatchingUnique = [
    $14831f1c512a5db9$var$bracketMatchingState,
    $14831f1c512a5db9$var$baseTheme
];
/**
Create an extension that enables bracket matching. Whenever the
cursor is next to a bracket, that bracket and the one it matches
are highlighted. Or, when no matching bracket is found, another
highlighting style is used to indicate this.
*/ function $14831f1c512a5db9$export$cef7edfd214be605(config = {}) {
    return [
        $14831f1c512a5db9$var$bracketMatchingConfig.of(config),
        $14831f1c512a5db9$var$bracketMatchingUnique
    ];
}
/**
When larger syntax nodes, such as HTML tags, are marked as
opening/closing, it can be a bit messy to treat the whole node as
a matchable bracket. This node prop allows you to define, for such
a node, a ‘handle’—the part of the node that is highlighted, and
that the cursor must be on to activate highlighting in the first
place.
*/ const $14831f1c512a5db9$export$ca7d74cd5b9f1011 = /*@__PURE__*/ new (0, $6DlXS.NodeProp)();
function $14831f1c512a5db9$var$matchingNodes(node, dir, brackets) {
    let byProp = node.prop(dir < 0 ? (0, $6DlXS.NodeProp).openedBy : (0, $6DlXS.NodeProp).closedBy);
    if (byProp) return byProp;
    if (node.name.length == 1) {
        let index = brackets.indexOf(node.name);
        if (index > -1 && index % 2 == (dir < 0 ? 1 : 0)) return [
            brackets[index + dir]
        ];
    }
    return null;
}
function $14831f1c512a5db9$var$findHandle(node) {
    let hasHandle = node.type.prop($14831f1c512a5db9$export$ca7d74cd5b9f1011);
    return hasHandle ? hasHandle(node.node) : node;
}
/**
Find the matching bracket for the token at `pos`, scanning
direction `dir`. Only the `brackets` and `maxScanDistance`
properties are used from `config`, if given. Returns null if no
bracket was found at `pos`, or a match result otherwise.
*/ function $14831f1c512a5db9$export$3391942603e90cda(state, pos, dir, config = {}) {
    let maxScanDistance = config.maxScanDistance || $14831f1c512a5db9$var$DefaultScanDist, brackets = config.brackets || $14831f1c512a5db9$var$DefaultBrackets;
    let tree = $14831f1c512a5db9$export$7fc98e56a4ca6be1(state), node = tree.resolveInner(pos, dir);
    for(let cur = node; cur; cur = cur.parent){
        let matches = $14831f1c512a5db9$var$matchingNodes(cur.type, dir, brackets);
        if (matches && cur.from < cur.to) {
            let handle = $14831f1c512a5db9$var$findHandle(cur);
            if (handle && (dir > 0 ? pos >= handle.from && pos < handle.to : pos > handle.from && pos <= handle.to)) return $14831f1c512a5db9$var$matchMarkedBrackets(state, pos, dir, cur, handle, matches, brackets);
        }
    }
    return $14831f1c512a5db9$var$matchPlainBrackets(state, pos, dir, tree, node.type, maxScanDistance, brackets);
}
function $14831f1c512a5db9$var$matchMarkedBrackets(_state, _pos, dir, token, handle, matching, brackets) {
    let parent = token.parent, firstToken = {
        from: handle.from,
        to: handle.to
    };
    let depth = 0, cursor = parent === null || parent === void 0 ? void 0 : parent.cursor();
    if (cursor && (dir < 0 ? cursor.childBefore(token.from) : cursor.childAfter(token.to))) do if (dir < 0 ? cursor.to <= token.from : cursor.from >= token.to) {
        if (depth == 0 && matching.indexOf(cursor.type.name) > -1 && cursor.from < cursor.to) {
            let endHandle = $14831f1c512a5db9$var$findHandle(cursor);
            return {
                start: firstToken,
                end: endHandle ? {
                    from: endHandle.from,
                    to: endHandle.to
                } : undefined,
                matched: true
            };
        } else if ($14831f1c512a5db9$var$matchingNodes(cursor.type, dir, brackets)) depth++;
        else if ($14831f1c512a5db9$var$matchingNodes(cursor.type, -dir, brackets)) {
            if (depth == 0) {
                let endHandle = $14831f1c512a5db9$var$findHandle(cursor);
                return {
                    start: firstToken,
                    end: endHandle && endHandle.from < endHandle.to ? {
                        from: endHandle.from,
                        to: endHandle.to
                    } : undefined,
                    matched: false
                };
            }
            depth--;
        }
    }
    while (dir < 0 ? cursor.prevSibling() : cursor.nextSibling());
    return {
        start: firstToken,
        matched: false
    };
}
function $14831f1c512a5db9$var$matchPlainBrackets(state, pos, dir, tree, tokenType, maxScanDistance, brackets) {
    let startCh = dir < 0 ? state.sliceDoc(pos - 1, pos) : state.sliceDoc(pos, pos + 1);
    let bracket = brackets.indexOf(startCh);
    if (bracket < 0 || bracket % 2 == 0 != dir > 0) return null;
    let startToken = {
        from: dir < 0 ? pos - 1 : pos,
        to: dir > 0 ? pos + 1 : pos
    };
    let iter = state.doc.iterRange(pos, dir > 0 ? state.doc.length : 0), depth = 0;
    for(let distance = 0; !iter.next().done && distance <= maxScanDistance;){
        let text = iter.value;
        if (dir < 0) distance += text.length;
        let basePos = pos + distance * dir;
        for(let pos = dir > 0 ? 0 : text.length - 1, end = dir > 0 ? text.length : -1; pos != end; pos += dir){
            let found = brackets.indexOf(text[pos]);
            if (found < 0 || tree.resolveInner(basePos + pos, 1).type != tokenType) continue;
            if (found % 2 == 0 == dir > 0) depth++;
            else if (depth == 1) return {
                start: startToken,
                end: {
                    from: basePos + pos,
                    to: basePos + pos + 1
                },
                matched: found >> 1 == bracket >> 1
            };
            else depth--;
        }
        if (dir > 0) distance += text.length;
    }
    return iter.done ? {
        start: startToken,
        matched: false
    } : null;
}
// Counts the column offset in a string, taking tabs into account.
// Used mostly to find indentation.
function $14831f1c512a5db9$var$countCol(string, end, tabSize, startIndex = 0, startValue = 0) {
    if (end == null) {
        end = string.search(/[^\s\u00a0]/);
        if (end == -1) end = string.length;
    }
    let n = startValue;
    for(let i = startIndex; i < end; i++)if (string.charCodeAt(i) == 9) n += tabSize - n % tabSize;
    else n++;
    return n;
}
/**
Encapsulates a single line of input. Given to stream syntax code,
which uses it to tokenize the content.
*/ class $14831f1c512a5db9$export$72a09304cc8c1940 {
    /**
    Create a stream.
    */ constructor(/**
    The line.
    */ string, tabSize, /**
    The current indent unit size.
    */ indentUnit, overrideIndent){
        this.string = string;
        this.tabSize = tabSize;
        this.indentUnit = indentUnit;
        this.overrideIndent = overrideIndent;
        /**
        The current position on the line.
        */ this.pos = 0;
        /**
        The start position of the current token.
        */ this.start = 0;
        this.lastColumnPos = 0;
        this.lastColumnValue = 0;
    }
    /**
    True if we are at the end of the line.
    */ eol() {
        return this.pos >= this.string.length;
    }
    /**
    True if we are at the start of the line.
    */ sol() {
        return this.pos == 0;
    }
    /**
    Get the next code unit after the current position, or undefined
    if we're at the end of the line.
    */ peek() {
        return this.string.charAt(this.pos) || undefined;
    }
    /**
    Read the next code unit and advance `this.pos`.
    */ next() {
        if (this.pos < this.string.length) return this.string.charAt(this.pos++);
    }
    /**
    Match the next character against the given string, regular
    expression, or predicate. Consume and return it if it matches.
    */ eat(match) {
        let ch = this.string.charAt(this.pos);
        let ok;
        if (typeof match == "string") ok = ch == match;
        else ok = ch && (match instanceof RegExp ? match.test(ch) : match(ch));
        if (ok) {
            ++this.pos;
            return ch;
        }
    }
    /**
    Continue matching characters that match the given string,
    regular expression, or predicate function. Return true if any
    characters were consumed.
    */ eatWhile(match) {
        let start = this.pos;
        while(this.eat(match));
        return this.pos > start;
    }
    /**
    Consume whitespace ahead of `this.pos`. Return true if any was
    found.
    */ eatSpace() {
        let start = this.pos;
        while(/[\s\u00a0]/.test(this.string.charAt(this.pos)))++this.pos;
        return this.pos > start;
    }
    /**
    Move to the end of the line.
    */ skipToEnd() {
        this.pos = this.string.length;
    }
    /**
    Move to directly before the given character, if found on the
    current line.
    */ skipTo(ch) {
        let found = this.string.indexOf(ch, this.pos);
        if (found > -1) {
            this.pos = found;
            return true;
        }
    }
    /**
    Move back `n` characters.
    */ backUp(n) {
        this.pos -= n;
    }
    /**
    Get the column position at `this.pos`.
    */ column() {
        if (this.lastColumnPos < this.start) {
            this.lastColumnValue = $14831f1c512a5db9$var$countCol(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
            this.lastColumnPos = this.start;
        }
        return this.lastColumnValue;
    }
    /**
    Get the indentation column of the current line.
    */ indentation() {
        var _a;
        return (_a = this.overrideIndent) !== null && _a !== void 0 ? _a : $14831f1c512a5db9$var$countCol(this.string, null, this.tabSize);
    }
    /**
    Match the input against the given string or regular expression
    (which should start with a `^`). Return true or the regexp match
    if it matches.
    
    Unless `consume` is set to `false`, this will move `this.pos`
    past the matched text.
    
    When matching a string `caseInsensitive` can be set to true to
    make the match case-insensitive.
    */ match(pattern, consume, caseInsensitive) {
        if (typeof pattern == "string") {
            let cased = (str)=>caseInsensitive ? str.toLowerCase() : str;
            let substr = this.string.substr(this.pos, pattern.length);
            if (cased(substr) == cased(pattern)) {
                if (consume !== false) this.pos += pattern.length;
                return true;
            } else return null;
        } else {
            let match = this.string.slice(this.pos).match(pattern);
            if (match && match.index > 0) return null;
            if (match && consume !== false) this.pos += match[0].length;
            return match;
        }
    }
    /**
    Get the current token.
    */ current() {
        return this.string.slice(this.start, this.pos);
    }
}
function $14831f1c512a5db9$var$fullParser(spec) {
    return {
        name: spec.name || "",
        token: spec.token,
        blankLine: spec.blankLine || (()=>{}),
        startState: spec.startState || (()=>true),
        copyState: spec.copyState || $14831f1c512a5db9$var$defaultCopyState,
        indent: spec.indent || (()=>null),
        languageData: spec.languageData || {},
        tokenTable: spec.tokenTable || $14831f1c512a5db9$var$noTokens
    };
}
function $14831f1c512a5db9$var$defaultCopyState(state) {
    if (typeof state != "object") return state;
    let newState = {};
    for(let prop in state){
        let val = state[prop];
        newState[prop] = val instanceof Array ? val.slice() : val;
    }
    return newState;
}
const $14831f1c512a5db9$var$IndentedFrom = /*@__PURE__*/ new WeakMap();
/**
A [language](https://codemirror.net/6/docs/ref/#language.Language) class based on a CodeMirror
5-style [streaming parser](https://codemirror.net/6/docs/ref/#language.StreamParser).
*/ class $14831f1c512a5db9$export$5ee3cc23916207d8 extends $14831f1c512a5db9$export$ce4fe1c9e6520c1a {
    constructor(parser){
        let data = $14831f1c512a5db9$export$b57f683f43553b99(parser.languageData);
        let p = $14831f1c512a5db9$var$fullParser(parser), self;
        let impl = new class extends (0, $6DlXS.Parser) {
            createParse(input, fragments, ranges) {
                return new $14831f1c512a5db9$var$Parse(self, input, fragments, ranges);
            }
        };
        super(data, impl, [
            $14831f1c512a5db9$export$5952625dce50d1f3.of((cx, pos)=>this.getIndent(cx, pos))
        ], parser.name);
        this.topNode = $14831f1c512a5db9$var$docID(data);
        self = this;
        this.streamParser = p;
        this.stateAfter = new (0, $6DlXS.NodeProp)({
            perNode: true
        });
        this.tokenTable = parser.tokenTable ? new $14831f1c512a5db9$var$TokenTable(p.tokenTable) : $14831f1c512a5db9$var$defaultTokenTable;
    }
    /**
    Define a stream language.
    */ static define(spec) {
        return new $14831f1c512a5db9$export$5ee3cc23916207d8(spec);
    }
    getIndent(cx, pos) {
        let tree = $14831f1c512a5db9$export$7fc98e56a4ca6be1(cx.state), at = tree.resolve(pos);
        while(at && at.type != this.topNode)at = at.parent;
        if (!at) return null;
        let from = undefined;
        let { overrideIndentation: overrideIndentation } = cx.options;
        if (overrideIndentation) {
            from = $14831f1c512a5db9$var$IndentedFrom.get(cx.state);
            if (from != null && from < pos - 1e4) from = undefined;
        }
        let start = $14831f1c512a5db9$var$findState(this, tree, 0, at.from, from !== null && from !== void 0 ? from : pos), statePos, state;
        if (start) {
            state = start.state;
            statePos = start.pos + 1;
        } else {
            state = this.streamParser.startState(cx.unit);
            statePos = 0;
        }
        if (pos - statePos > 10000 /* MaxIndentScanDist */ ) return null;
        while(statePos < pos){
            let line = cx.state.doc.lineAt(statePos), end = Math.min(pos, line.to);
            if (line.length) {
                let indentation = overrideIndentation ? overrideIndentation(line.from) : -1;
                let stream = new $14831f1c512a5db9$export$72a09304cc8c1940(line.text, cx.state.tabSize, cx.unit, indentation < 0 ? undefined : indentation);
                while(stream.pos < end - line.from)$14831f1c512a5db9$var$readToken(this.streamParser.token, stream, state);
            } else this.streamParser.blankLine(state, cx.unit);
            if (end == pos) break;
            statePos = line.to + 1;
        }
        let line = cx.lineAt(pos);
        if (overrideIndentation && from == null) $14831f1c512a5db9$var$IndentedFrom.set(cx.state, line.from);
        return this.streamParser.indent(state, /^\s*(.*)/.exec(line.text)[1], cx);
    }
    get allowsNesting() {
        return false;
    }
}
function $14831f1c512a5db9$var$findState(lang, tree, off, startPos, before) {
    let state = off >= startPos && off + tree.length <= before && tree.prop(lang.stateAfter);
    if (state) return {
        state: lang.streamParser.copyState(state),
        pos: off + tree.length
    };
    for(let i = tree.children.length - 1; i >= 0; i--){
        let child = tree.children[i], pos = off + tree.positions[i];
        let found = child instanceof (0, $6DlXS.Tree) && pos < before && $14831f1c512a5db9$var$findState(lang, child, pos, startPos, before);
        if (found) return found;
    }
    return null;
}
function $14831f1c512a5db9$var$cutTree(lang, tree, from, to, inside) {
    if (inside && from <= 0 && to >= tree.length) return tree;
    if (!inside && tree.type == lang.topNode) inside = true;
    for(let i = tree.children.length - 1; i >= 0; i--){
        let pos = tree.positions[i], child = tree.children[i], inner;
        if (pos < to && child instanceof (0, $6DlXS.Tree)) {
            if (!(inner = $14831f1c512a5db9$var$cutTree(lang, child, from - pos, to - pos, inside))) break;
            return !inside ? inner : new (0, $6DlXS.Tree)(tree.type, tree.children.slice(0, i).concat(inner), tree.positions.slice(0, i + 1), pos + inner.length);
        }
    }
    return null;
}
function $14831f1c512a5db9$var$findStartInFragments(lang, fragments, startPos, editorState) {
    for (let f of fragments){
        let from = f.from + (f.openStart ? 25 : 0), to = f.to - (f.openEnd ? 25 : 0);
        let found = from <= startPos && to > startPos && $14831f1c512a5db9$var$findState(lang, f.tree, 0 - f.offset, startPos, to), tree;
        if (found && (tree = $14831f1c512a5db9$var$cutTree(lang, f.tree, startPos + f.offset, found.pos + f.offset, false))) return {
            state: found.state,
            tree: tree
        };
    }
    return {
        state: lang.streamParser.startState(editorState ? $14831f1c512a5db9$export$ad3205d09311a797(editorState) : 4),
        tree: (0, $6DlXS.Tree).empty
    };
}
class $14831f1c512a5db9$var$Parse {
    constructor(lang, input, fragments, ranges){
        this.lang = lang;
        this.input = input;
        this.fragments = fragments;
        this.ranges = ranges;
        this.stoppedAt = null;
        this.chunks = [];
        this.chunkPos = [];
        this.chunk = [];
        this.chunkReused = undefined;
        this.rangeIndex = 0;
        this.to = ranges[ranges.length - 1].to;
        let context = $14831f1c512a5db9$export$3fcb7c01ff2a41fa.get(), from = ranges[0].from;
        let { state: state, tree: tree } = $14831f1c512a5db9$var$findStartInFragments(lang, fragments, from, context === null || context === void 0 ? void 0 : context.state);
        this.state = state;
        this.parsedPos = this.chunkStart = from + tree.length;
        for(let i = 0; i < tree.children.length; i++){
            this.chunks.push(tree.children[i]);
            this.chunkPos.push(tree.positions[i]);
        }
        if (context && this.parsedPos < context.viewport.from - 100000 /* MaxDistanceBeforeViewport */ ) {
            this.state = this.lang.streamParser.startState($14831f1c512a5db9$export$ad3205d09311a797(context.state));
            context.skipUntilInView(this.parsedPos, context.viewport.from);
            this.parsedPos = context.viewport.from;
        }
        this.moveRangeIndex();
    }
    advance() {
        let context = $14831f1c512a5db9$export$3fcb7c01ff2a41fa.get();
        let parseEnd = this.stoppedAt == null ? this.to : Math.min(this.to, this.stoppedAt);
        let end = Math.min(parseEnd, this.chunkStart + 2048 /* ChunkSize */ );
        if (context) end = Math.min(end, context.viewport.to);
        while(this.parsedPos < end)this.parseLine(context);
        if (this.chunkStart < this.parsedPos) this.finishChunk();
        if (this.parsedPos >= parseEnd) return this.finish();
        if (context && this.parsedPos >= context.viewport.to) {
            context.skipUntilInView(this.parsedPos, parseEnd);
            return this.finish();
        }
        return null;
    }
    stopAt(pos) {
        this.stoppedAt = pos;
    }
    lineAfter(pos) {
        let chunk = this.input.chunk(pos);
        if (!this.input.lineChunks) {
            let eol = chunk.indexOf("\n");
            if (eol > -1) chunk = chunk.slice(0, eol);
        } else if (chunk == "\n") chunk = "";
        return pos + chunk.length <= this.to ? chunk : chunk.slice(0, this.to - pos);
    }
    nextLine() {
        let from = this.parsedPos, line = this.lineAfter(from), end = from + line.length;
        for(let index = this.rangeIndex;;){
            let rangeEnd = this.ranges[index].to;
            if (rangeEnd >= end) break;
            line = line.slice(0, rangeEnd - (end - line.length));
            index++;
            if (index == this.ranges.length) break;
            let rangeStart = this.ranges[index].from;
            let after = this.lineAfter(rangeStart);
            line += after;
            end = rangeStart + after.length;
        }
        return {
            line: line,
            end: end
        };
    }
    skipGapsTo(pos, offset, side) {
        for(;;){
            let end = this.ranges[this.rangeIndex].to, offPos = pos + offset;
            if (side > 0 ? end > offPos : end >= offPos) break;
            let start = this.ranges[++this.rangeIndex].from;
            offset += start - end;
        }
        return offset;
    }
    moveRangeIndex() {
        while(this.ranges[this.rangeIndex].to < this.parsedPos)this.rangeIndex++;
    }
    emitToken(id, from, to, size, offset) {
        if (this.ranges.length > 1) {
            offset = this.skipGapsTo(from, offset, 1);
            from += offset;
            let len0 = this.chunk.length;
            offset = this.skipGapsTo(to, offset, -1);
            to += offset;
            size += this.chunk.length - len0;
        }
        this.chunk.push(id, from, to, size);
        return offset;
    }
    parseLine(context) {
        let { line: line, end: end } = this.nextLine(), offset = 0, { streamParser: streamParser } = this.lang;
        let stream = new $14831f1c512a5db9$export$72a09304cc8c1940(line, context ? context.state.tabSize : 4, context ? $14831f1c512a5db9$export$ad3205d09311a797(context.state) : 2);
        if (stream.eol()) streamParser.blankLine(this.state, stream.indentUnit);
        else while(!stream.eol()){
            let token = $14831f1c512a5db9$var$readToken(streamParser.token, stream, this.state);
            if (token) offset = this.emitToken(this.lang.tokenTable.resolve(token), this.parsedPos + stream.start, this.parsedPos + stream.pos, 4, offset);
            if (stream.start > 10000 /* MaxLineLength */ ) break;
        }
        this.parsedPos = end;
        this.moveRangeIndex();
        if (this.parsedPos < this.to) this.parsedPos++;
    }
    finishChunk() {
        let tree = (0, $6DlXS.Tree).build({
            buffer: this.chunk,
            start: this.chunkStart,
            length: this.parsedPos - this.chunkStart,
            nodeSet: $14831f1c512a5db9$var$nodeSet,
            topID: 0,
            maxBufferLength: 2048 /* ChunkSize */ ,
            reused: this.chunkReused
        });
        tree = new (0, $6DlXS.Tree)(tree.type, tree.children, tree.positions, tree.length, [
            [
                this.lang.stateAfter,
                this.lang.streamParser.copyState(this.state)
            ]
        ]);
        this.chunks.push(tree);
        this.chunkPos.push(this.chunkStart - this.ranges[0].from);
        this.chunk = [];
        this.chunkReused = undefined;
        this.chunkStart = this.parsedPos;
    }
    finish() {
        return new (0, $6DlXS.Tree)(this.lang.topNode, this.chunks, this.chunkPos, this.parsedPos - this.ranges[0].from).balance();
    }
}
function $14831f1c512a5db9$var$readToken(token, stream, state) {
    stream.start = stream.pos;
    for(let i = 0; i < 10; i++){
        let result = token(stream, state);
        if (stream.pos > stream.start) return result;
    }
    throw new Error("Stream parser failed to advance stream.");
}
const $14831f1c512a5db9$var$noTokens = /*@__PURE__*/ Object.create(null);
const $14831f1c512a5db9$var$typeArray = [
    (0, $6DlXS.NodeType).none
];
const $14831f1c512a5db9$var$nodeSet = /*@__PURE__*/ new (0, $6DlXS.NodeSet)($14831f1c512a5db9$var$typeArray);
const $14831f1c512a5db9$var$warned = [];
const $14831f1c512a5db9$var$defaultTable = /*@__PURE__*/ Object.create(null);
for (let [legacyName, name] of [
    [
        "variable",
        "variableName"
    ],
    [
        "variable-2",
        "variableName.special"
    ],
    [
        "string-2",
        "string.special"
    ],
    [
        "def",
        "variableName.definition"
    ],
    [
        "tag",
        "tagName"
    ],
    [
        "attribute",
        "attributeName"
    ],
    [
        "type",
        "typeName"
    ],
    [
        "builtin",
        "variableName.standard"
    ],
    [
        "qualifier",
        "modifier"
    ],
    [
        "error",
        "invalid"
    ],
    [
        "header",
        "heading"
    ],
    [
        "property",
        "propertyName"
    ]
])$14831f1c512a5db9$var$defaultTable[legacyName] = /*@__PURE__*/ $14831f1c512a5db9$var$createTokenType($14831f1c512a5db9$var$noTokens, name);
class $14831f1c512a5db9$var$TokenTable {
    constructor(extra){
        this.extra = extra;
        this.table = Object.assign(Object.create(null), $14831f1c512a5db9$var$defaultTable);
    }
    resolve(tag) {
        return !tag ? 0 : this.table[tag] || (this.table[tag] = $14831f1c512a5db9$var$createTokenType(this.extra, tag));
    }
}
const $14831f1c512a5db9$var$defaultTokenTable = /*@__PURE__*/ new $14831f1c512a5db9$var$TokenTable($14831f1c512a5db9$var$noTokens);
function $14831f1c512a5db9$var$warnForPart(part, msg) {
    if ($14831f1c512a5db9$var$warned.indexOf(part) > -1) return;
    $14831f1c512a5db9$var$warned.push(part);
    console.warn(msg);
}
function $14831f1c512a5db9$var$createTokenType(extra, tagStr) {
    let tag = null;
    for (let part of tagStr.split(".")){
        let value = extra[part] || (0, $6yW7d.tags)[part];
        if (!value) $14831f1c512a5db9$var$warnForPart(part, `Unknown highlighting tag ${part}`);
        else if (typeof value == "function") {
            if (!tag) $14831f1c512a5db9$var$warnForPart(part, `Modifier ${part} used at start of tag`);
            else tag = value(tag);
        } else if (tag) $14831f1c512a5db9$var$warnForPart(part, `Tag ${part} used as modifier`);
        else tag = value;
    }
    if (!tag) return 0;
    let name = tagStr.replace(/ /g, "_"), type = (0, $6DlXS.NodeType).define({
        id: $14831f1c512a5db9$var$typeArray.length,
        name: name,
        props: [
            (0, $6yW7d.styleTags)({
                [name]: tag
            })
        ]
    });
    $14831f1c512a5db9$var$typeArray.push(type);
    return type.id;
}
function $14831f1c512a5db9$var$docID(data) {
    let type = (0, $6DlXS.NodeType).define({
        id: $14831f1c512a5db9$var$typeArray.length,
        name: "Document",
        props: [
            $14831f1c512a5db9$export$27a2e78097f753f7.add(()=>data)
        ]
    });
    $14831f1c512a5db9$var$typeArray.push(type);
    return type;
}

});
parcelRequire.register("6DlXS", function(module, exports) {

$parcel$export(module.exports, "DefaultBufferLength", () => $4d476c57e17b24ca$export$de305a849879ffa);
$parcel$export(module.exports, "NodeProp", () => $4d476c57e17b24ca$export$b8034b9bc18acd90);
$parcel$export(module.exports, "NodeType", () => $4d476c57e17b24ca$export$f06e977173f1857c);
$parcel$export(module.exports, "NodeSet", () => $4d476c57e17b24ca$export$7fad5fb00d8de02c);
$parcel$export(module.exports, "IterMode", () => $4d476c57e17b24ca$export$b0e28367f55837aa);
$parcel$export(module.exports, "Tree", () => $4d476c57e17b24ca$export$7fbedc92909ed28e);
$parcel$export(module.exports, "NodeWeakMap", () => $4d476c57e17b24ca$export$7f13b5dc44c541ae);
$parcel$export(module.exports, "TreeFragment", () => $4d476c57e17b24ca$export$3ae2ede6dca97077);
$parcel$export(module.exports, "Parser", () => $4d476c57e17b24ca$export$7acfa6ed01010e37);
$parcel$export(module.exports, "parseMixed", () => $4d476c57e17b24ca$export$5dcc455959c76221);
// FIXME profile adding a per-Tree TreeNode cache, validating it by
// parent pointer
/// The default maximum length of a `TreeBuffer` node.
const $4d476c57e17b24ca$export$de305a849879ffa = 1024;
let $4d476c57e17b24ca$var$nextPropID = 0;
class $4d476c57e17b24ca$var$Range {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
}
/// Each [node type](#common.NodeType) or [individual tree](#common.Tree)
/// can have metadata associated with it in props. Instances of this
/// class represent prop names.
class $4d476c57e17b24ca$export$b8034b9bc18acd90 {
    /// Create a new node prop type.
    constructor(config = {}){
        this.id = $4d476c57e17b24ca$var$nextPropID++;
        this.perNode = !!config.perNode;
        this.deserialize = config.deserialize || (()=>{
            throw new Error("This node type doesn't define a deserialize function");
        });
    }
    /// This is meant to be used with
    /// [`NodeSet.extend`](#common.NodeSet.extend) or
    /// [`LRParser.configure`](#lr.ParserConfig.props) to compute
    /// prop values for each node type in the set. Takes a [match
    /// object](#common.NodeType^match) or function that returns undefined
    /// if the node type doesn't get this prop, and the prop's value if
    /// it does.
    add(match) {
        if (this.perNode) throw new RangeError("Can't add per-node props to node types");
        if (typeof match != "function") match = $4d476c57e17b24ca$export$f06e977173f1857c.match(match);
        return (type)=>{
            let result = match(type);
            return result === undefined ? null : [
                this,
                result
            ];
        };
    }
}
/// Prop that is used to describe matching delimiters. For opening
/// delimiters, this holds an array of node names (written as a
/// space-separated string when declaring this prop in a grammar)
/// for the node types of closing delimiters that match it.
$4d476c57e17b24ca$export$b8034b9bc18acd90.closedBy = new $4d476c57e17b24ca$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/// The inverse of [`closedBy`](#common.NodeProp^closedBy). This is
/// attached to closing delimiters, holding an array of node names
/// of types of matching opening delimiters.
$4d476c57e17b24ca$export$b8034b9bc18acd90.openedBy = new $4d476c57e17b24ca$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/// Used to assign node types to groups (for example, all node
/// types that represent an expression could be tagged with an
/// `"Expression"` group).
$4d476c57e17b24ca$export$b8034b9bc18acd90.group = new $4d476c57e17b24ca$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/// The hash of the [context](#lr.ContextTracker.constructor)
/// that the node was parsed in, if any. Used to limit reuse of
/// contextual nodes.
$4d476c57e17b24ca$export$b8034b9bc18acd90.contextHash = new $4d476c57e17b24ca$export$b8034b9bc18acd90({
    perNode: true
});
/// The distance beyond the end of the node that the tokenizer
/// looked ahead for any of the tokens inside the node. (The LR
/// parser only stores this when it is larger than 25, for
/// efficiency reasons.)
$4d476c57e17b24ca$export$b8034b9bc18acd90.lookAhead = new $4d476c57e17b24ca$export$b8034b9bc18acd90({
    perNode: true
});
/// This per-node prop is used to replace a given node, or part of a
/// node, with another tree. This is useful to include trees from
/// different languages in mixed-language parsers.
$4d476c57e17b24ca$export$b8034b9bc18acd90.mounted = new $4d476c57e17b24ca$export$b8034b9bc18acd90({
    perNode: true
});
/// A mounted tree, which can be [stored](#common.NodeProp^mounted) on
/// a tree node to indicate that parts of its content are
/// represented by another tree.
class $4d476c57e17b24ca$export$358cdd8bd77577cc {
    constructor(/// The inner tree.
    tree, /// If this is null, this tree replaces the entire node (it will
    /// be included in the regular iteration instead of its host
    /// node). If not, only the given ranges are considered to be
    /// covered by this tree. This is used for trees that are mixed in
    /// a way that isn't strictly hierarchical. Such mounted trees are
    /// only entered by [`resolveInner`](#common.Tree.resolveInner)
    /// and [`enter`](#common.SyntaxNode.enter).
    overlay, /// The parser used to create this subtree.
    parser){
        this.tree = tree;
        this.overlay = overlay;
        this.parser = parser;
    }
}
const $4d476c57e17b24ca$var$noProps = Object.create(null);
/// Each node in a syntax tree has a node type associated with it.
class $4d476c57e17b24ca$export$f06e977173f1857c {
    /// @internal
    constructor(/// The name of the node type. Not necessarily unique, but if the
    /// grammar was written properly, different node types with the
    /// same name within a node set should play the same semantic
    /// role.
    name, /// @internal
    props, /// The id of this node in its set. Corresponds to the term ids
    /// used in the parser.
    id, /// @internal
    flags = 0){
        this.name = name;
        this.props = props;
        this.id = id;
        this.flags = flags;
    }
    /// Define a node type.
    static define(spec) {
        let props = spec.props && spec.props.length ? Object.create(null) : $4d476c57e17b24ca$var$noProps;
        let flags = (spec.top ? 1 /* NodeFlag.Top */  : 0) | (spec.skipped ? 2 /* NodeFlag.Skipped */  : 0) | (spec.error ? 4 /* NodeFlag.Error */  : 0) | (spec.name == null ? 8 /* NodeFlag.Anonymous */  : 0);
        let type = new $4d476c57e17b24ca$export$f06e977173f1857c(spec.name || "", props, spec.id, flags);
        if (spec.props) for (let src of spec.props){
            if (!Array.isArray(src)) src = src(type);
            if (src) {
                if (src[0].perNode) throw new RangeError("Can't store a per-node prop on a node type");
                props[src[0].id] = src[1];
            }
        }
        return type;
    }
    /// Retrieves a node prop for this type. Will return `undefined` if
    /// the prop isn't present on this node.
    prop(prop) {
        return this.props[prop.id];
    }
    /// True when this is the top node of a grammar.
    get isTop() {
        return (this.flags & 1 /* NodeFlag.Top */ ) > 0;
    }
    /// True when this node is produced by a skip rule.
    get isSkipped() {
        return (this.flags & 2 /* NodeFlag.Skipped */ ) > 0;
    }
    /// Indicates whether this is an error node.
    get isError() {
        return (this.flags & 4 /* NodeFlag.Error */ ) > 0;
    }
    /// When true, this node type doesn't correspond to a user-declared
    /// named node, for example because it is used to cache repetition.
    get isAnonymous() {
        return (this.flags & 8 /* NodeFlag.Anonymous */ ) > 0;
    }
    /// Returns true when this node's name or one of its
    /// [groups](#common.NodeProp^group) matches the given string.
    is(name) {
        if (typeof name == "string") {
            if (this.name == name) return true;
            let group = this.prop($4d476c57e17b24ca$export$b8034b9bc18acd90.group);
            return group ? group.indexOf(name) > -1 : false;
        }
        return this.id == name;
    }
    /// Create a function from node types to arbitrary values by
    /// specifying an object whose property names are node or
    /// [group](#common.NodeProp^group) names. Often useful with
    /// [`NodeProp.add`](#common.NodeProp.add). You can put multiple
    /// names, separated by spaces, in a single property name to map
    /// multiple node names to a single value.
    static match(map) {
        let direct = Object.create(null);
        for(let prop in map)for (let name of prop.split(" "))direct[name] = map[prop];
        return (node)=>{
            for(let groups = node.prop($4d476c57e17b24ca$export$b8034b9bc18acd90.group), i = -1; i < (groups ? groups.length : 0); i++){
                let found = direct[i < 0 ? node.name : groups[i]];
                if (found) return found;
            }
        };
    }
}
/// An empty dummy node type to use when no actual type is available.
$4d476c57e17b24ca$export$f06e977173f1857c.none = new $4d476c57e17b24ca$export$f06e977173f1857c("", Object.create(null), 0, 8 /* NodeFlag.Anonymous */ );
/// A node set holds a collection of node types. It is used to
/// compactly represent trees by storing their type ids, rather than a
/// full pointer to the type object, in a numeric array. Each parser
/// [has](#lr.LRParser.nodeSet) a node set, and [tree
/// buffers](#common.TreeBuffer) can only store collections of nodes
/// from the same set. A set can have a maximum of 2**16 (65536) node
/// types in it, so that the ids fit into 16-bit typed array slots.
class $4d476c57e17b24ca$export$7fad5fb00d8de02c {
    /// Create a set with the given types. The `id` property of each
    /// type should correspond to its position within the array.
    constructor(/// The node types in this set, by id.
    types){
        this.types = types;
        for(let i = 0; i < types.length; i++)if (types[i].id != i) throw new RangeError("Node type ids should correspond to array positions when creating a node set");
    }
    /// Create a copy of this set with some node properties added. The
    /// arguments to this method can be created with
    /// [`NodeProp.add`](#common.NodeProp.add).
    extend(...props) {
        let newTypes = [];
        for (let type of this.types){
            let newProps = null;
            for (let source of props){
                let add = source(type);
                if (add) {
                    if (!newProps) newProps = Object.assign({}, type.props);
                    newProps[add[0].id] = add[1];
                }
            }
            newTypes.push(newProps ? new $4d476c57e17b24ca$export$f06e977173f1857c(type.name, newProps, type.id, type.flags) : type);
        }
        return new $4d476c57e17b24ca$export$7fad5fb00d8de02c(newTypes);
    }
}
const $4d476c57e17b24ca$var$CachedNode = new WeakMap(), $4d476c57e17b24ca$var$CachedInnerNode = new WeakMap();
/// Options that control iteration. Can be combined with the `|`
/// operator to enable multiple ones.
var $4d476c57e17b24ca$export$b0e28367f55837aa;
(function(IterMode) {
    /// When enabled, iteration will only visit [`Tree`](#common.Tree)
    /// objects, not nodes packed into
    /// [`TreeBuffer`](#common.TreeBuffer)s.
    IterMode[IterMode["ExcludeBuffers"] = 1] = "ExcludeBuffers";
    /// Enable this to make iteration include anonymous nodes (such as
    /// the nodes that wrap repeated grammar constructs into a balanced
    /// tree).
    IterMode[IterMode["IncludeAnonymous"] = 2] = "IncludeAnonymous";
    /// By default, regular [mounted](#common.NodeProp^mounted) nodes
    /// replace their base node in iteration. Enable this to ignore them
    /// instead.
    IterMode[IterMode["IgnoreMounts"] = 4] = "IgnoreMounts";
    /// This option only applies in
    /// [`enter`](#common.SyntaxNode.enter)-style methods. It tells the
    /// library to not enter mounted overlays if one covers the given
    /// position.
    IterMode[IterMode["IgnoreOverlays"] = 8] = "IgnoreOverlays";
})($4d476c57e17b24ca$export$b0e28367f55837aa || ($4d476c57e17b24ca$export$b0e28367f55837aa = {}));
/// A piece of syntax tree. There are two ways to approach these
/// trees: the way they are actually stored in memory, and the
/// convenient way.
///
/// Syntax trees are stored as a tree of `Tree` and `TreeBuffer`
/// objects. By packing detail information into `TreeBuffer` leaf
/// nodes, the representation is made a lot more memory-efficient.
///
/// However, when you want to actually work with tree nodes, this
/// representation is very awkward, so most client code will want to
/// use the [`TreeCursor`](#common.TreeCursor) or
/// [`SyntaxNode`](#common.SyntaxNode) interface instead, which provides
/// a view on some part of this data structure, and can be used to
/// move around to adjacent nodes.
class $4d476c57e17b24ca$export$7fbedc92909ed28e {
    /// Construct a new tree. See also [`Tree.build`](#common.Tree^build).
    constructor(/// The type of the top node.
    type, /// This node's child nodes.
    children, /// The positions (offsets relative to the start of this tree) of
    /// the children.
    positions, /// The total length of this tree
    length, /// Per-node [node props](#common.NodeProp) to associate with this node.
    props){
        this.type = type;
        this.children = children;
        this.positions = positions;
        this.length = length;
        /// @internal
        this.props = null;
        if (props && props.length) {
            this.props = Object.create(null);
            for (let [prop, value] of props)this.props[typeof prop == "number" ? prop : prop.id] = value;
        }
    }
    /// @internal
    toString() {
        let mounted = this.prop($4d476c57e17b24ca$export$b8034b9bc18acd90.mounted);
        if (mounted && !mounted.overlay) return mounted.tree.toString();
        let children = "";
        for (let ch of this.children){
            let str = ch.toString();
            if (str) {
                if (children) children += ",";
                children += str;
            }
        }
        return !this.type.name ? children : (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (children.length ? "(" + children + ")" : "");
    }
    /// Get a [tree cursor](#common.TreeCursor) positioned at the top of
    /// the tree. Mode can be used to [control](#common.IterMode) which
    /// nodes the cursor visits.
    cursor(mode = 0) {
        return new $4d476c57e17b24ca$export$3ae4554f36e54a34(this.topNode, mode);
    }
    /// Get a [tree cursor](#common.TreeCursor) pointing into this tree
    /// at the given position and side (see
    /// [`moveTo`](#common.TreeCursor.moveTo).
    cursorAt(pos, side = 0, mode = 0) {
        let scope = $4d476c57e17b24ca$var$CachedNode.get(this) || this.topNode;
        let cursor = new $4d476c57e17b24ca$export$3ae4554f36e54a34(scope);
        cursor.moveTo(pos, side);
        $4d476c57e17b24ca$var$CachedNode.set(this, cursor._tree);
        return cursor;
    }
    /// Get a [syntax node](#common.SyntaxNode) object for the top of the
    /// tree.
    get topNode() {
        return new $4d476c57e17b24ca$var$TreeNode(this, 0, 0, null);
    }
    /// Get the [syntax node](#common.SyntaxNode) at the given position.
    /// If `side` is -1, this will move into nodes that end at the
    /// position. If 1, it'll move into nodes that start at the
    /// position. With 0, it'll only enter nodes that cover the position
    /// from both sides.
    ///
    /// Note that this will not enter
    /// [overlays](#common.MountedTree.overlay), and you often want
    /// [`resolveInner`](#common.Tree.resolveInner) instead.
    resolve(pos, side = 0) {
        let node = $4d476c57e17b24ca$var$resolveNode($4d476c57e17b24ca$var$CachedNode.get(this) || this.topNode, pos, side, false);
        $4d476c57e17b24ca$var$CachedNode.set(this, node);
        return node;
    }
    /// Like [`resolve`](#common.Tree.resolve), but will enter
    /// [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
    /// pointing into the innermost overlaid tree at the given position
    /// (with parent links going through all parent structure, including
    /// the host trees).
    resolveInner(pos, side = 0) {
        let node = $4d476c57e17b24ca$var$resolveNode($4d476c57e17b24ca$var$CachedInnerNode.get(this) || this.topNode, pos, side, true);
        $4d476c57e17b24ca$var$CachedInnerNode.set(this, node);
        return node;
    }
    /// Iterate over the tree and its children, calling `enter` for any
    /// node that touches the `from`/`to` region (if given) before
    /// running over such a node's children, and `leave` (if given) when
    /// leaving the node. When `enter` returns `false`, that node will
    /// not have its children iterated over (or `leave` called).
    iterate(spec) {
        let { enter: enter, leave: leave, from: from = 0, to: to = this.length } = spec;
        let mode = spec.mode || 0, anon = (mode & $4d476c57e17b24ca$export$b0e28367f55837aa.IncludeAnonymous) > 0;
        for(let c = this.cursor(mode | $4d476c57e17b24ca$export$b0e28367f55837aa.IncludeAnonymous);;){
            let entered = false;
            if (c.from <= to && c.to >= from && (!anon && c.type.isAnonymous || enter(c) !== false)) {
                if (c.firstChild()) continue;
                entered = true;
            }
            for(;;){
                if (entered && leave && (anon || !c.type.isAnonymous)) leave(c);
                if (c.nextSibling()) break;
                if (!c.parent()) return;
                entered = true;
            }
        }
    }
    /// Get the value of the given [node prop](#common.NodeProp) for this
    /// node. Works with both per-node and per-type props.
    prop(prop) {
        return !prop.perNode ? this.type.prop(prop) : this.props ? this.props[prop.id] : undefined;
    }
    /// Returns the node's [per-node props](#common.NodeProp.perNode) in a
    /// format that can be passed to the [`Tree`](#common.Tree)
    /// constructor.
    get propValues() {
        let result = [];
        if (this.props) for(let id in this.props)result.push([
            +id,
            this.props[id]
        ]);
        return result;
    }
    /// Balance the direct children of this tree, producing a copy of
    /// which may have children grouped into subtrees with type
    /// [`NodeType.none`](#common.NodeType^none).
    balance(config = {}) {
        return this.children.length <= 8 /* Balance.BranchFactor */  ? this : $4d476c57e17b24ca$var$balanceRange($4d476c57e17b24ca$export$f06e977173f1857c.none, this.children, this.positions, 0, this.children.length, 0, this.length, (children, positions, length)=>new $4d476c57e17b24ca$export$7fbedc92909ed28e(this.type, children, positions, length, this.propValues), config.makeTree || ((children, positions, length)=>new $4d476c57e17b24ca$export$7fbedc92909ed28e($4d476c57e17b24ca$export$f06e977173f1857c.none, children, positions, length)));
    }
    /// Build a tree from a postfix-ordered buffer of node information,
    /// or a cursor over such a buffer.
    static build(data) {
        return $4d476c57e17b24ca$var$buildTree(data);
    }
}
/// The empty tree
$4d476c57e17b24ca$export$7fbedc92909ed28e.empty = new $4d476c57e17b24ca$export$7fbedc92909ed28e($4d476c57e17b24ca$export$f06e977173f1857c.none, [], [], 0);
class $4d476c57e17b24ca$var$FlatBufferCursor {
    constructor(buffer, index){
        this.buffer = buffer;
        this.index = index;
    }
    get id() {
        return this.buffer[this.index - 4];
    }
    get start() {
        return this.buffer[this.index - 3];
    }
    get end() {
        return this.buffer[this.index - 2];
    }
    get size() {
        return this.buffer[this.index - 1];
    }
    get pos() {
        return this.index;
    }
    next() {
        this.index -= 4;
    }
    fork() {
        return new $4d476c57e17b24ca$var$FlatBufferCursor(this.buffer, this.index);
    }
}
/// Tree buffers contain (type, start, end, endIndex) quads for each
/// node. In such a buffer, nodes are stored in prefix order (parents
/// before children, with the endIndex of the parent indicating which
/// children belong to it).
class $4d476c57e17b24ca$export$33300581b70be371 {
    /// Create a tree buffer.
    constructor(/// The buffer's content.
    buffer, /// The total length of the group of nodes in the buffer.
    length, /// The node set used in this buffer.
    set){
        this.buffer = buffer;
        this.length = length;
        this.set = set;
    }
    /// @internal
    get type() {
        return $4d476c57e17b24ca$export$f06e977173f1857c.none;
    }
    /// @internal
    toString() {
        let result = [];
        for(let index = 0; index < this.buffer.length;){
            result.push(this.childString(index));
            index = this.buffer[index + 3];
        }
        return result.join(",");
    }
    /// @internal
    childString(index) {
        let id = this.buffer[index], endIndex = this.buffer[index + 3];
        let type = this.set.types[id], result = type.name;
        if (/\W/.test(result) && !type.isError) result = JSON.stringify(result);
        index += 4;
        if (endIndex == index) return result;
        let children = [];
        while(index < endIndex){
            children.push(this.childString(index));
            index = this.buffer[index + 3];
        }
        return result + "(" + children.join(",") + ")";
    }
    /// @internal
    findChild(startIndex, endIndex, dir, pos, side) {
        let { buffer: buffer } = this, pick = -1;
        for(let i = startIndex; i != endIndex; i = buffer[i + 3])if ($4d476c57e17b24ca$var$checkSide(side, pos, buffer[i + 1], buffer[i + 2])) {
            pick = i;
            if (dir > 0) break;
        }
        return pick;
    }
    /// @internal
    slice(startI, endI, from) {
        let b = this.buffer;
        let copy = new Uint16Array(endI - startI), len = 0;
        for(let i = startI, j = 0; i < endI;){
            copy[j++] = b[i++];
            copy[j++] = b[i++] - from;
            let to = copy[j++] = b[i++] - from;
            copy[j++] = b[i++] - startI;
            len = Math.max(len, to);
        }
        return new $4d476c57e17b24ca$export$33300581b70be371(copy, len, this.set);
    }
}
function $4d476c57e17b24ca$var$checkSide(side, pos, from, to) {
    switch(side){
        case -2 /* Side.Before */ :
            return from < pos;
        case -1 /* Side.AtOrBefore */ :
            return to >= pos && from < pos;
        case 0 /* Side.Around */ :
            return from < pos && to > pos;
        case 1 /* Side.AtOrAfter */ :
            return from <= pos && to > pos;
        case 2 /* Side.After */ :
            return to > pos;
        case 4 /* Side.DontCare */ :
            return true;
    }
}
function $4d476c57e17b24ca$var$enterUnfinishedNodesBefore(node, pos) {
    let scan = node.childBefore(pos);
    while(scan){
        let last = scan.lastChild;
        if (!last || last.to != scan.to) break;
        if (last.type.isError && last.from == last.to) {
            node = scan;
            scan = last.prevSibling;
        } else scan = last;
    }
    return node;
}
function $4d476c57e17b24ca$var$resolveNode(node, pos, side, overlays) {
    var _a;
    // Move up to a node that actually holds the position, if possible
    while(node.from == node.to || (side < 1 ? node.from >= pos : node.from > pos) || (side > -1 ? node.to <= pos : node.to < pos)){
        let parent = !overlays && node instanceof $4d476c57e17b24ca$var$TreeNode && node.index < 0 ? null : node.parent;
        if (!parent) return node;
        node = parent;
    }
    let mode = overlays ? 0 : $4d476c57e17b24ca$export$b0e28367f55837aa.IgnoreOverlays;
    // Must go up out of overlays when those do not overlap with pos
    if (overlays) {
        for(let scan = node, parent = scan.parent; parent; scan = parent, parent = scan.parent)if (scan instanceof $4d476c57e17b24ca$var$TreeNode && scan.index < 0 && ((_a = parent.enter(pos, side, mode)) === null || _a === void 0 ? void 0 : _a.from) != scan.from) node = parent;
    }
    for(;;){
        let inner = node.enter(pos, side, mode);
        if (!inner) return node;
        node = inner;
    }
}
class $4d476c57e17b24ca$var$TreeNode {
    constructor(_tree, from, // Index in parent node, set to -1 if the node is not a direct child of _parent.node (overlay)
    index, _parent){
        this._tree = _tree;
        this.from = from;
        this.index = index;
        this._parent = _parent;
    }
    get type() {
        return this._tree.type;
    }
    get name() {
        return this._tree.type.name;
    }
    get to() {
        return this.from + this._tree.length;
    }
    nextChild(i, dir, pos, side, mode = 0) {
        for(let parent = this;;){
            for(let { children: children, positions: positions } = parent._tree, e = dir > 0 ? children.length : -1; i != e; i += dir){
                let next = children[i], start = positions[i] + parent.from;
                if (!$4d476c57e17b24ca$var$checkSide(side, pos, start, start + next.length)) continue;
                if (next instanceof $4d476c57e17b24ca$export$33300581b70be371) {
                    if (mode & $4d476c57e17b24ca$export$b0e28367f55837aa.ExcludeBuffers) continue;
                    let index = next.findChild(0, next.buffer.length, dir, pos - start, side);
                    if (index > -1) return new $4d476c57e17b24ca$var$BufferNode(new $4d476c57e17b24ca$var$BufferContext(parent, next, i, start), null, index);
                } else if (mode & $4d476c57e17b24ca$export$b0e28367f55837aa.IncludeAnonymous || !next.type.isAnonymous || $4d476c57e17b24ca$var$hasChild(next)) {
                    let mounted;
                    if (!(mode & $4d476c57e17b24ca$export$b0e28367f55837aa.IgnoreMounts) && next.props && (mounted = next.prop($4d476c57e17b24ca$export$b8034b9bc18acd90.mounted)) && !mounted.overlay) return new $4d476c57e17b24ca$var$TreeNode(mounted.tree, start, i, parent);
                    let inner = new $4d476c57e17b24ca$var$TreeNode(next, start, i, parent);
                    return mode & $4d476c57e17b24ca$export$b0e28367f55837aa.IncludeAnonymous || !inner.type.isAnonymous ? inner : inner.nextChild(dir < 0 ? next.children.length - 1 : 0, dir, pos, side);
                }
            }
            if (mode & $4d476c57e17b24ca$export$b0e28367f55837aa.IncludeAnonymous || !parent.type.isAnonymous) return null;
            if (parent.index >= 0) i = parent.index + dir;
            else i = dir < 0 ? -1 : parent._parent._tree.children.length;
            parent = parent._parent;
            if (!parent) return null;
        }
    }
    get firstChild() {
        return this.nextChild(0, 1, 0, 4 /* Side.DontCare */ );
    }
    get lastChild() {
        return this.nextChild(this._tree.children.length - 1, -1, 0, 4 /* Side.DontCare */ );
    }
    childAfter(pos) {
        return this.nextChild(0, 1, pos, 2 /* Side.After */ );
    }
    childBefore(pos) {
        return this.nextChild(this._tree.children.length - 1, -1, pos, -2 /* Side.Before */ );
    }
    enter(pos, side, mode = 0) {
        let mounted;
        if (!(mode & $4d476c57e17b24ca$export$b0e28367f55837aa.IgnoreOverlays) && (mounted = this._tree.prop($4d476c57e17b24ca$export$b8034b9bc18acd90.mounted)) && mounted.overlay) {
            let rPos = pos - this.from;
            for (let { from: from, to: to } of mounted.overlay){
                if ((side > 0 ? from <= rPos : from < rPos) && (side < 0 ? to >= rPos : to > rPos)) return new $4d476c57e17b24ca$var$TreeNode(mounted.tree, mounted.overlay[0].from + this.from, -1, this);
            }
        }
        return this.nextChild(0, 1, pos, side, mode);
    }
    nextSignificantParent() {
        let val = this;
        while(val.type.isAnonymous && val._parent)val = val._parent;
        return val;
    }
    get parent() {
        return this._parent ? this._parent.nextSignificantParent() : null;
    }
    get nextSibling() {
        return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4 /* Side.DontCare */ ) : null;
    }
    get prevSibling() {
        return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4 /* Side.DontCare */ ) : null;
    }
    cursor(mode = 0) {
        return new $4d476c57e17b24ca$export$3ae4554f36e54a34(this, mode);
    }
    get tree() {
        return this._tree;
    }
    toTree() {
        return this._tree;
    }
    resolve(pos, side = 0) {
        return $4d476c57e17b24ca$var$resolveNode(this, pos, side, false);
    }
    resolveInner(pos, side = 0) {
        return $4d476c57e17b24ca$var$resolveNode(this, pos, side, true);
    }
    enterUnfinishedNodesBefore(pos) {
        return $4d476c57e17b24ca$var$enterUnfinishedNodesBefore(this, pos);
    }
    getChild(type, before = null, after = null) {
        let r = $4d476c57e17b24ca$var$getChildren(this, type, before, after);
        return r.length ? r[0] : null;
    }
    getChildren(type, before = null, after = null) {
        return $4d476c57e17b24ca$var$getChildren(this, type, before, after);
    }
    /// @internal
    toString() {
        return this._tree.toString();
    }
    get node() {
        return this;
    }
    matchContext(context) {
        return $4d476c57e17b24ca$var$matchNodeContext(this, context);
    }
}
function $4d476c57e17b24ca$var$getChildren(node, type, before, after) {
    let cur = node.cursor(), result = [];
    if (!cur.firstChild()) return result;
    if (before != null) {
        while(!cur.type.is(before))if (!cur.nextSibling()) return result;
    }
    for(;;){
        if (after != null && cur.type.is(after)) return result;
        if (cur.type.is(type)) result.push(cur.node);
        if (!cur.nextSibling()) return after == null ? result : [];
    }
}
function $4d476c57e17b24ca$var$matchNodeContext(node, context, i = context.length - 1) {
    for(let p = node.parent; i >= 0; p = p.parent){
        if (!p) return false;
        if (!p.type.isAnonymous) {
            if (context[i] && context[i] != p.name) return false;
            i--;
        }
    }
    return true;
}
class $4d476c57e17b24ca$var$BufferContext {
    constructor(parent, buffer, index, start){
        this.parent = parent;
        this.buffer = buffer;
        this.index = index;
        this.start = start;
    }
}
class $4d476c57e17b24ca$var$BufferNode {
    get name() {
        return this.type.name;
    }
    get from() {
        return this.context.start + this.context.buffer.buffer[this.index + 1];
    }
    get to() {
        return this.context.start + this.context.buffer.buffer[this.index + 2];
    }
    constructor(context, _parent, index){
        this.context = context;
        this._parent = _parent;
        this.index = index;
        this.type = context.buffer.set.types[context.buffer.buffer[index]];
    }
    child(dir, pos, side) {
        let { buffer: buffer } = this.context;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.context.start, side);
        return index < 0 ? null : new $4d476c57e17b24ca$var$BufferNode(this.context, this, index);
    }
    get firstChild() {
        return this.child(1, 0, 4 /* Side.DontCare */ );
    }
    get lastChild() {
        return this.child(-1, 0, 4 /* Side.DontCare */ );
    }
    childAfter(pos) {
        return this.child(1, pos, 2 /* Side.After */ );
    }
    childBefore(pos) {
        return this.child(-1, pos, -2 /* Side.Before */ );
    }
    enter(pos, side, mode = 0) {
        if (mode & $4d476c57e17b24ca$export$b0e28367f55837aa.ExcludeBuffers) return null;
        let { buffer: buffer } = this.context;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], side > 0 ? 1 : -1, pos - this.context.start, side);
        return index < 0 ? null : new $4d476c57e17b24ca$var$BufferNode(this.context, this, index);
    }
    get parent() {
        return this._parent || this.context.parent.nextSignificantParent();
    }
    externalSibling(dir) {
        return this._parent ? null : this.context.parent.nextChild(this.context.index + dir, dir, 0, 4 /* Side.DontCare */ );
    }
    get nextSibling() {
        let { buffer: buffer } = this.context;
        let after = buffer.buffer[this.index + 3];
        if (after < (this._parent ? buffer.buffer[this._parent.index + 3] : buffer.buffer.length)) return new $4d476c57e17b24ca$var$BufferNode(this.context, this._parent, after);
        return this.externalSibling(1);
    }
    get prevSibling() {
        let { buffer: buffer } = this.context;
        let parentStart = this._parent ? this._parent.index + 4 : 0;
        if (this.index == parentStart) return this.externalSibling(-1);
        return new $4d476c57e17b24ca$var$BufferNode(this.context, this._parent, buffer.findChild(parentStart, this.index, -1, 0, 4 /* Side.DontCare */ ));
    }
    cursor(mode = 0) {
        return new $4d476c57e17b24ca$export$3ae4554f36e54a34(this, mode);
    }
    get tree() {
        return null;
    }
    toTree() {
        let children = [], positions = [];
        let { buffer: buffer } = this.context;
        let startI = this.index + 4, endI = buffer.buffer[this.index + 3];
        if (endI > startI) {
            let from = buffer.buffer[this.index + 1];
            children.push(buffer.slice(startI, endI, from));
            positions.push(0);
        }
        return new $4d476c57e17b24ca$export$7fbedc92909ed28e(this.type, children, positions, this.to - this.from);
    }
    resolve(pos, side = 0) {
        return $4d476c57e17b24ca$var$resolveNode(this, pos, side, false);
    }
    resolveInner(pos, side = 0) {
        return $4d476c57e17b24ca$var$resolveNode(this, pos, side, true);
    }
    enterUnfinishedNodesBefore(pos) {
        return $4d476c57e17b24ca$var$enterUnfinishedNodesBefore(this, pos);
    }
    /// @internal
    toString() {
        return this.context.buffer.childString(this.index);
    }
    getChild(type, before = null, after = null) {
        let r = $4d476c57e17b24ca$var$getChildren(this, type, before, after);
        return r.length ? r[0] : null;
    }
    getChildren(type, before = null, after = null) {
        return $4d476c57e17b24ca$var$getChildren(this, type, before, after);
    }
    get node() {
        return this;
    }
    matchContext(context) {
        return $4d476c57e17b24ca$var$matchNodeContext(this, context);
    }
}
/// A tree cursor object focuses on a given node in a syntax tree, and
/// allows you to move to adjacent nodes.
class $4d476c57e17b24ca$export$3ae4554f36e54a34 {
    /// Shorthand for `.type.name`.
    get name() {
        return this.type.name;
    }
    /// @internal
    constructor(node, /// @internal
    mode = 0){
        this.mode = mode;
        /// @internal
        this.buffer = null;
        this.stack = [];
        /// @internal
        this.index = 0;
        this.bufferNode = null;
        if (node instanceof $4d476c57e17b24ca$var$TreeNode) this.yieldNode(node);
        else {
            this._tree = node.context.parent;
            this.buffer = node.context;
            for(let n = node._parent; n; n = n._parent)this.stack.unshift(n.index);
            this.bufferNode = node;
            this.yieldBuf(node.index);
        }
    }
    yieldNode(node) {
        if (!node) return false;
        this._tree = node;
        this.type = node.type;
        this.from = node.from;
        this.to = node.to;
        return true;
    }
    yieldBuf(index, type) {
        this.index = index;
        let { start: start, buffer: buffer } = this.buffer;
        this.type = type || buffer.set.types[buffer.buffer[index]];
        this.from = start + buffer.buffer[index + 1];
        this.to = start + buffer.buffer[index + 2];
        return true;
    }
    yield(node) {
        if (!node) return false;
        if (node instanceof $4d476c57e17b24ca$var$TreeNode) {
            this.buffer = null;
            return this.yieldNode(node);
        }
        this.buffer = node.context;
        return this.yieldBuf(node.index, node.type);
    }
    /// @internal
    toString() {
        return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
    }
    /// @internal
    enterChild(dir, pos, side) {
        if (!this.buffer) return this.yield(this._tree.nextChild(dir < 0 ? this._tree._tree.children.length - 1 : 0, dir, pos, side, this.mode));
        let { buffer: buffer } = this.buffer;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.buffer.start, side);
        if (index < 0) return false;
        this.stack.push(this.index);
        return this.yieldBuf(index);
    }
    /// Move the cursor to this node's first child. When this returns
    /// false, the node has no child, and the cursor has not been moved.
    firstChild() {
        return this.enterChild(1, 0, 4 /* Side.DontCare */ );
    }
    /// Move the cursor to this node's last child.
    lastChild() {
        return this.enterChild(-1, 0, 4 /* Side.DontCare */ );
    }
    /// Move the cursor to the first child that ends after `pos`.
    childAfter(pos) {
        return this.enterChild(1, pos, 2 /* Side.After */ );
    }
    /// Move to the last child that starts before `pos`.
    childBefore(pos) {
        return this.enterChild(-1, pos, -2 /* Side.Before */ );
    }
    /// Move the cursor to the child around `pos`. If side is -1 the
    /// child may end at that position, when 1 it may start there. This
    /// will also enter [overlaid](#common.MountedTree.overlay)
    /// [mounted](#common.NodeProp^mounted) trees unless `overlays` is
    /// set to false.
    enter(pos, side, mode = this.mode) {
        if (!this.buffer) return this.yield(this._tree.enter(pos, side, mode));
        return mode & $4d476c57e17b24ca$export$b0e28367f55837aa.ExcludeBuffers ? false : this.enterChild(1, pos, side);
    }
    /// Move to the node's parent node, if this isn't the top node.
    parent() {
        if (!this.buffer) return this.yieldNode(this.mode & $4d476c57e17b24ca$export$b0e28367f55837aa.IncludeAnonymous ? this._tree._parent : this._tree.parent);
        if (this.stack.length) return this.yieldBuf(this.stack.pop());
        let parent = this.mode & $4d476c57e17b24ca$export$b0e28367f55837aa.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
        this.buffer = null;
        return this.yieldNode(parent);
    }
    /// @internal
    sibling(dir) {
        if (!this.buffer) return !this._tree._parent ? false : this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + dir, dir, 0, 4 /* Side.DontCare */ , this.mode));
        let { buffer: buffer } = this.buffer, d = this.stack.length - 1;
        if (dir < 0) {
            let parentStart = d < 0 ? 0 : this.stack[d] + 4;
            if (this.index != parentStart) return this.yieldBuf(buffer.findChild(parentStart, this.index, -1, 0, 4 /* Side.DontCare */ ));
        } else {
            let after = buffer.buffer[this.index + 3];
            if (after < (d < 0 ? buffer.buffer.length : buffer.buffer[this.stack[d] + 3])) return this.yieldBuf(after);
        }
        return d < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + dir, dir, 0, 4 /* Side.DontCare */ , this.mode)) : false;
    }
    /// Move to this node's next sibling, if any.
    nextSibling() {
        return this.sibling(1);
    }
    /// Move to this node's previous sibling, if any.
    prevSibling() {
        return this.sibling(-1);
    }
    atLastNode(dir) {
        let index, parent, { buffer: buffer } = this;
        if (buffer) {
            if (dir > 0) {
                if (this.index < buffer.buffer.buffer.length) return false;
            } else {
                for(let i = 0; i < this.index; i++)if (buffer.buffer.buffer[i + 3] < this.index) return false;
            }
            ({ index: index, parent: parent } = buffer);
        } else ({ index: index, _parent: parent } = this._tree);
        for(; parent; { index: index, _parent: parent } = parent){
            if (index > -1) for(let i = index + dir, e = dir < 0 ? -1 : parent._tree.children.length; i != e; i += dir){
                let child = parent._tree.children[i];
                if (this.mode & $4d476c57e17b24ca$export$b0e28367f55837aa.IncludeAnonymous || child instanceof $4d476c57e17b24ca$export$33300581b70be371 || !child.type.isAnonymous || $4d476c57e17b24ca$var$hasChild(child)) return false;
            }
        }
        return true;
    }
    move(dir, enter) {
        if (enter && this.enterChild(dir, 0, 4 /* Side.DontCare */ )) return true;
        for(;;){
            if (this.sibling(dir)) return true;
            if (this.atLastNode(dir) || !this.parent()) return false;
        }
    }
    /// Move to the next node in a
    /// [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
    /// traversal, going from a node to its first child or, if the
    /// current node is empty or `enter` is false, its next sibling or
    /// the next sibling of the first parent node that has one.
    next(enter = true) {
        return this.move(1, enter);
    }
    /// Move to the next node in a last-to-first pre-order traveral. A
    /// node is followed by its last child or, if it has none, its
    /// previous sibling or the previous sibling of the first parent
    /// node that has one.
    prev(enter = true) {
        return this.move(-1, enter);
    }
    /// Move the cursor to the innermost node that covers `pos`. If
    /// `side` is -1, it will enter nodes that end at `pos`. If it is 1,
    /// it will enter nodes that start at `pos`.
    moveTo(pos, side = 0) {
        // Move up to a node that actually holds the position, if possible
        while(this.from == this.to || (side < 1 ? this.from >= pos : this.from > pos) || (side > -1 ? this.to <= pos : this.to < pos))if (!this.parent()) break;
        // Then scan down into child nodes as far as possible
        while(this.enterChild(1, pos, side));
        return this;
    }
    /// Get a [syntax node](#common.SyntaxNode) at the cursor's current
    /// position.
    get node() {
        if (!this.buffer) return this._tree;
        let cache = this.bufferNode, result = null, depth = 0;
        if (cache && cache.context == this.buffer) scan: for(let index = this.index, d = this.stack.length; d >= 0;){
            for(let c = cache; c; c = c._parent)if (c.index == index) {
                if (index == this.index) return c;
                result = c;
                depth = d + 1;
                break scan;
            }
            index = this.stack[--d];
        }
        for(let i = depth; i < this.stack.length; i++)result = new $4d476c57e17b24ca$var$BufferNode(this.buffer, result, this.stack[i]);
        return this.bufferNode = new $4d476c57e17b24ca$var$BufferNode(this.buffer, result, this.index);
    }
    /// Get the [tree](#common.Tree) that represents the current node, if
    /// any. Will return null when the node is in a [tree
    /// buffer](#common.TreeBuffer).
    get tree() {
        return this.buffer ? null : this._tree._tree;
    }
    /// Iterate over the current node and all its descendants, calling
    /// `enter` when entering a node and `leave`, if given, when leaving
    /// one. When `enter` returns `false`, any children of that node are
    /// skipped, and `leave` isn't called for it.
    iterate(enter, leave) {
        for(let depth = 0;;){
            let mustLeave = false;
            if (this.type.isAnonymous || enter(this) !== false) {
                if (this.firstChild()) {
                    depth++;
                    continue;
                }
                if (!this.type.isAnonymous) mustLeave = true;
            }
            for(;;){
                if (mustLeave && leave) leave(this);
                mustLeave = this.type.isAnonymous;
                if (this.nextSibling()) break;
                if (!depth) return;
                this.parent();
                depth--;
                mustLeave = true;
            }
        }
    }
    /// Test whether the current node matches a given context—a sequence
    /// of direct parent node names. Empty strings in the context array
    /// are treated as wildcards.
    matchContext(context) {
        if (!this.buffer) return $4d476c57e17b24ca$var$matchNodeContext(this.node, context);
        let { buffer: buffer } = this.buffer, { types: types } = buffer.set;
        for(let i = context.length - 1, d = this.stack.length - 1; i >= 0; d--){
            if (d < 0) return $4d476c57e17b24ca$var$matchNodeContext(this.node, context, i);
            let type = types[buffer.buffer[this.stack[d]]];
            if (!type.isAnonymous) {
                if (context[i] && context[i] != type.name) return false;
                i--;
            }
        }
        return true;
    }
}
function $4d476c57e17b24ca$var$hasChild(tree) {
    return tree.children.some((ch)=>ch instanceof $4d476c57e17b24ca$export$33300581b70be371 || !ch.type.isAnonymous || $4d476c57e17b24ca$var$hasChild(ch));
}
function $4d476c57e17b24ca$var$buildTree(data) {
    var _a;
    let { buffer: buffer, nodeSet: nodeSet, maxBufferLength: maxBufferLength = $4d476c57e17b24ca$export$de305a849879ffa, reused: reused = [], minRepeatType: minRepeatType = nodeSet.types.length } = data;
    let cursor = Array.isArray(buffer) ? new $4d476c57e17b24ca$var$FlatBufferCursor(buffer, buffer.length) : buffer;
    let types = nodeSet.types;
    let contextHash = 0, lookAhead = 0;
    function takeNode(parentStart, minPos, children, positions, inRepeat) {
        let { id: id, start: start, end: end, size: size } = cursor;
        let lookAheadAtStart = lookAhead;
        while(size < 0){
            cursor.next();
            if (size == -1 /* SpecialRecord.Reuse */ ) {
                let node = reused[id];
                children.push(node);
                positions.push(start - parentStart);
                return;
            } else if (size == -3 /* SpecialRecord.ContextChange */ ) {
                contextHash = id;
                return;
            } else if (size == -4 /* SpecialRecord.LookAhead */ ) {
                lookAhead = id;
                return;
            } else throw new RangeError(`Unrecognized record size: ${size}`);
        }
        let type = types[id], node, buffer;
        let startPos = start - parentStart;
        if (end - start <= maxBufferLength && (buffer = findBufferSize(cursor.pos - minPos, inRepeat))) {
            // Small enough for a buffer, and no reused nodes inside
            let data = new Uint16Array(buffer.size - buffer.skip);
            let endPos = cursor.pos - buffer.size, index = data.length;
            while(cursor.pos > endPos)index = copyToBuffer(buffer.start, data, index);
            node = new $4d476c57e17b24ca$export$33300581b70be371(data, end - buffer.start, nodeSet);
            startPos = buffer.start - parentStart;
        } else {
            let endPos = cursor.pos - size;
            cursor.next();
            let localChildren = [], localPositions = [];
            let localInRepeat = id >= minRepeatType ? id : -1;
            let lastGroup = 0, lastEnd = end;
            while(cursor.pos > endPos)if (localInRepeat >= 0 && cursor.id == localInRepeat && cursor.size >= 0) {
                if (cursor.end <= lastEnd - maxBufferLength) {
                    makeRepeatLeaf(localChildren, localPositions, start, lastGroup, cursor.end, lastEnd, localInRepeat, lookAheadAtStart);
                    lastGroup = localChildren.length;
                    lastEnd = cursor.end;
                }
                cursor.next();
            } else takeNode(start, endPos, localChildren, localPositions, localInRepeat);
            if (localInRepeat >= 0 && lastGroup > 0 && lastGroup < localChildren.length) makeRepeatLeaf(localChildren, localPositions, start, lastGroup, start, lastEnd, localInRepeat, lookAheadAtStart);
            localChildren.reverse();
            localPositions.reverse();
            if (localInRepeat > -1 && lastGroup > 0) {
                let make = makeBalanced(type);
                node = $4d476c57e17b24ca$var$balanceRange(type, localChildren, localPositions, 0, localChildren.length, 0, end - start, make, make);
            } else node = makeTree(type, localChildren, localPositions, end - start, lookAheadAtStart - end);
        }
        children.push(node);
        positions.push(startPos);
    }
    function makeBalanced(type) {
        return (children, positions, length)=>{
            let lookAhead = 0, lastI = children.length - 1, last, lookAheadProp;
            if (lastI >= 0 && (last = children[lastI]) instanceof $4d476c57e17b24ca$export$7fbedc92909ed28e) {
                if (!lastI && last.type == type && last.length == length) return last;
                if (lookAheadProp = last.prop($4d476c57e17b24ca$export$b8034b9bc18acd90.lookAhead)) lookAhead = positions[lastI] + last.length + lookAheadProp;
            }
            return makeTree(type, children, positions, length, lookAhead);
        };
    }
    function makeRepeatLeaf(children, positions, base, i, from, to, type, lookAhead) {
        let localChildren = [], localPositions = [];
        while(children.length > i){
            localChildren.push(children.pop());
            localPositions.push(positions.pop() + base - from);
        }
        children.push(makeTree(nodeSet.types[type], localChildren, localPositions, to - from, lookAhead - to));
        positions.push(from - base);
    }
    function makeTree(type, children, positions, length, lookAhead = 0, props) {
        if (contextHash) {
            let pair = [
                $4d476c57e17b24ca$export$b8034b9bc18acd90.contextHash,
                contextHash
            ];
            props = props ? [
                pair
            ].concat(props) : [
                pair
            ];
        }
        if (lookAhead > 25) {
            let pair = [
                $4d476c57e17b24ca$export$b8034b9bc18acd90.lookAhead,
                lookAhead
            ];
            props = props ? [
                pair
            ].concat(props) : [
                pair
            ];
        }
        return new $4d476c57e17b24ca$export$7fbedc92909ed28e(type, children, positions, length, props);
    }
    function findBufferSize(maxSize, inRepeat) {
        // Scan through the buffer to find previous siblings that fit
        // together in a TreeBuffer, and don't contain any reused nodes
        // (which can't be stored in a buffer).
        // If `inRepeat` is > -1, ignore node boundaries of that type for
        // nesting, but make sure the end falls either at the start
        // (`maxSize`) or before such a node.
        let fork = cursor.fork();
        let size = 0, start = 0, skip = 0, minStart = fork.end - maxBufferLength;
        let result = {
            size: 0,
            start: 0,
            skip: 0
        };
        scan: for(let minPos = fork.pos - maxSize; fork.pos > minPos;){
            let nodeSize = fork.size;
            // Pretend nested repeat nodes of the same type don't exist
            if (fork.id == inRepeat && nodeSize >= 0) {
                // Except that we store the current state as a valid return
                // value.
                result.size = size;
                result.start = start;
                result.skip = skip;
                skip += 4;
                size += 4;
                fork.next();
                continue;
            }
            let startPos = fork.pos - nodeSize;
            if (nodeSize < 0 || startPos < minPos || fork.start < minStart) break;
            let localSkipped = fork.id >= minRepeatType ? 4 : 0;
            let nodeStart = fork.start;
            fork.next();
            while(fork.pos > startPos){
                if (fork.size < 0) {
                    if (fork.size == -3 /* SpecialRecord.ContextChange */ ) localSkipped += 4;
                    else break scan;
                } else if (fork.id >= minRepeatType) localSkipped += 4;
                fork.next();
            }
            start = nodeStart;
            size += nodeSize;
            skip += localSkipped;
        }
        if (inRepeat < 0 || size == maxSize) {
            result.size = size;
            result.start = start;
            result.skip = skip;
        }
        return result.size > 4 ? result : undefined;
    }
    function copyToBuffer(bufferStart, buffer, index) {
        let { id: id, start: start, end: end, size: size } = cursor;
        cursor.next();
        if (size >= 0 && id < minRepeatType) {
            let startIndex = index;
            if (size > 4) {
                let endPos = cursor.pos - (size - 4);
                while(cursor.pos > endPos)index = copyToBuffer(bufferStart, buffer, index);
            }
            buffer[--index] = startIndex;
            buffer[--index] = end - bufferStart;
            buffer[--index] = start - bufferStart;
            buffer[--index] = id;
        } else if (size == -3 /* SpecialRecord.ContextChange */ ) contextHash = id;
        else if (size == -4 /* SpecialRecord.LookAhead */ ) lookAhead = id;
        return index;
    }
    let children = [], positions = [];
    while(cursor.pos > 0)takeNode(data.start || 0, data.bufferStart || 0, children, positions, -1);
    let length = (_a = data.length) !== null && _a !== void 0 ? _a : children.length ? positions[0] + children[0].length : 0;
    return new $4d476c57e17b24ca$export$7fbedc92909ed28e(types[data.topID], children.reverse(), positions.reverse(), length);
}
const $4d476c57e17b24ca$var$nodeSizeCache = new WeakMap;
function $4d476c57e17b24ca$var$nodeSize(balanceType, node) {
    if (!balanceType.isAnonymous || node instanceof $4d476c57e17b24ca$export$33300581b70be371 || node.type != balanceType) return 1;
    let size = $4d476c57e17b24ca$var$nodeSizeCache.get(node);
    if (size == null) {
        size = 1;
        for (let child of node.children){
            if (child.type != balanceType || !(child instanceof $4d476c57e17b24ca$export$7fbedc92909ed28e)) {
                size = 1;
                break;
            }
            size += $4d476c57e17b24ca$var$nodeSize(balanceType, child);
        }
        $4d476c57e17b24ca$var$nodeSizeCache.set(node, size);
    }
    return size;
}
function $4d476c57e17b24ca$var$balanceRange(// The type the balanced tree's inner nodes.
balanceType, // The direct children and their positions
children, positions, // The index range in children/positions to use
from, to, // The start position of the nodes, relative to their parent.
start, // Length of the outer node
length, // Function to build the top node of the balanced tree
mkTop, // Function to build internal nodes for the balanced tree
mkTree) {
    let total = 0;
    for(let i = from; i < to; i++)total += $4d476c57e17b24ca$var$nodeSize(balanceType, children[i]);
    let maxChild = Math.ceil(total * 1.5 / 8 /* Balance.BranchFactor */ );
    let localChildren = [], localPositions = [];
    function divide(children, positions, from, to, offset) {
        for(let i = from; i < to;){
            let groupFrom = i, groupStart = positions[i], groupSize = $4d476c57e17b24ca$var$nodeSize(balanceType, children[i]);
            i++;
            for(; i < to; i++){
                let nextSize = $4d476c57e17b24ca$var$nodeSize(balanceType, children[i]);
                if (groupSize + nextSize >= maxChild) break;
                groupSize += nextSize;
            }
            if (i == groupFrom + 1) {
                if (groupSize > maxChild) {
                    let only = children[groupFrom]; // Only trees can have a size > 1
                    divide(only.children, only.positions, 0, only.children.length, positions[groupFrom] + offset);
                    continue;
                }
                localChildren.push(children[groupFrom]);
            } else {
                let length = positions[i - 1] + children[i - 1].length - groupStart;
                localChildren.push($4d476c57e17b24ca$var$balanceRange(balanceType, children, positions, groupFrom, i, groupStart, length, null, mkTree));
            }
            localPositions.push(groupStart + offset - start);
        }
    }
    divide(children, positions, from, to, 0);
    return (mkTop || mkTree)(localChildren, localPositions, length);
}
/// Provides a way to associate values with pieces of trees. As long
/// as that part of the tree is reused, the associated values can be
/// retrieved from an updated tree.
class $4d476c57e17b24ca$export$7f13b5dc44c541ae {
    constructor(){
        this.map = new WeakMap();
    }
    setBuffer(buffer, index, value) {
        let inner = this.map.get(buffer);
        if (!inner) this.map.set(buffer, inner = new Map);
        inner.set(index, value);
    }
    getBuffer(buffer, index) {
        let inner = this.map.get(buffer);
        return inner && inner.get(index);
    }
    /// Set the value for this syntax node.
    set(node, value) {
        if (node instanceof $4d476c57e17b24ca$var$BufferNode) this.setBuffer(node.context.buffer, node.index, value);
        else if (node instanceof $4d476c57e17b24ca$var$TreeNode) this.map.set(node.tree, value);
    }
    /// Retrieve value for this syntax node, if it exists in the map.
    get(node) {
        return node instanceof $4d476c57e17b24ca$var$BufferNode ? this.getBuffer(node.context.buffer, node.index) : node instanceof $4d476c57e17b24ca$var$TreeNode ? this.map.get(node.tree) : undefined;
    }
    /// Set the value for the node that a cursor currently points to.
    cursorSet(cursor, value) {
        if (cursor.buffer) this.setBuffer(cursor.buffer.buffer, cursor.index, value);
        else this.map.set(cursor.tree, value);
    }
    /// Retrieve the value for the node that a cursor currently points
    /// to.
    cursorGet(cursor) {
        return cursor.buffer ? this.getBuffer(cursor.buffer.buffer, cursor.index) : this.map.get(cursor.tree);
    }
}
/// Tree fragments are used during [incremental
/// parsing](#common.Parser.startParse) to track parts of old trees
/// that can be reused in a new parse. An array of fragments is used
/// to track regions of an old tree whose nodes might be reused in new
/// parses. Use the static
/// [`applyChanges`](#common.TreeFragment^applyChanges) method to
/// update fragments for document changes.
class $4d476c57e17b24ca$export$3ae2ede6dca97077 {
    /// Construct a tree fragment. You'll usually want to use
    /// [`addTree`](#common.TreeFragment^addTree) and
    /// [`applyChanges`](#common.TreeFragment^applyChanges) instead of
    /// calling this directly.
    constructor(/// The start of the unchanged range pointed to by this fragment.
    /// This refers to an offset in the _updated_ document (as opposed
    /// to the original tree).
    from, /// The end of the unchanged range.
    to, /// The tree that this fragment is based on.
    tree, /// The offset between the fragment's tree and the document that
    /// this fragment can be used against. Add this when going from
    /// document to tree positions, subtract it to go from tree to
    /// document positions.
    offset, openStart = false, openEnd = false){
        this.from = from;
        this.to = to;
        this.tree = tree;
        this.offset = offset;
        this.open = (openStart ? 1 /* Open.Start */  : 0) | (openEnd ? 2 /* Open.End */  : 0);
    }
    /// Whether the start of the fragment represents the start of a
    /// parse, or the end of a change. (In the second case, it may not
    /// be safe to reuse some nodes at the start, depending on the
    /// parsing algorithm.)
    get openStart() {
        return (this.open & 1 /* Open.Start */ ) > 0;
    }
    /// Whether the end of the fragment represents the end of a
    /// full-document parse, or the start of a change.
    get openEnd() {
        return (this.open & 2 /* Open.End */ ) > 0;
    }
    /// Create a set of fragments from a freshly parsed tree, or update
    /// an existing set of fragments by replacing the ones that overlap
    /// with a tree with content from the new tree. When `partial` is
    /// true, the parse is treated as incomplete, and the resulting
    /// fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
    /// true.
    static addTree(tree, fragments = [], partial = false) {
        let result = [
            new $4d476c57e17b24ca$export$3ae2ede6dca97077(0, tree.length, tree, 0, false, partial)
        ];
        for (let f of fragments)if (f.to > tree.length) result.push(f);
        return result;
    }
    /// Apply a set of edits to an array of fragments, removing or
    /// splitting fragments as necessary to remove edited ranges, and
    /// adjusting offsets for fragments that moved.
    static applyChanges(fragments, changes, minGap = 128) {
        if (!changes.length) return fragments;
        let result = [];
        let fI = 1, nextF = fragments.length ? fragments[0] : null;
        for(let cI = 0, pos = 0, off = 0;; cI++){
            let nextC = cI < changes.length ? changes[cI] : null;
            let nextPos = nextC ? nextC.fromA : 1e9;
            if (nextPos - pos >= minGap) while(nextF && nextF.from < nextPos){
                let cut = nextF;
                if (pos >= cut.from || nextPos <= cut.to || off) {
                    let fFrom = Math.max(cut.from, pos) - off, fTo = Math.min(cut.to, nextPos) - off;
                    cut = fFrom >= fTo ? null : new $4d476c57e17b24ca$export$3ae2ede6dca97077(fFrom, fTo, cut.tree, cut.offset + off, cI > 0, !!nextC);
                }
                if (cut) result.push(cut);
                if (nextF.to > nextPos) break;
                nextF = fI < fragments.length ? fragments[fI++] : null;
            }
            if (!nextC) break;
            pos = nextC.toA;
            off = nextC.toA - nextC.toB;
        }
        return result;
    }
}
/// A superclass that parsers should extend.
class $4d476c57e17b24ca$export$7acfa6ed01010e37 {
    /// Start a parse, returning a [partial parse](#common.PartialParse)
    /// object. [`fragments`](#common.TreeFragment) can be passed in to
    /// make the parse incremental.
    ///
    /// By default, the entire input is parsed. You can pass `ranges`,
    /// which should be a sorted array of non-empty, non-overlapping
    /// ranges, to parse only those ranges. The tree returned in that
    /// case will start at `ranges[0].from`.
    startParse(input, fragments, ranges) {
        if (typeof input == "string") input = new $4d476c57e17b24ca$var$StringInput(input);
        ranges = !ranges ? [
            new $4d476c57e17b24ca$var$Range(0, input.length)
        ] : ranges.length ? ranges.map((r)=>new $4d476c57e17b24ca$var$Range(r.from, r.to)) : [
            new $4d476c57e17b24ca$var$Range(0, 0)
        ];
        return this.createParse(input, fragments || [], ranges);
    }
    /// Run a full parse, returning the resulting tree.
    parse(input, fragments, ranges) {
        let parse = this.startParse(input, fragments, ranges);
        for(;;){
            let done = parse.advance();
            if (done) return done;
        }
    }
}
class $4d476c57e17b24ca$var$StringInput {
    constructor(string){
        this.string = string;
    }
    get length() {
        return this.string.length;
    }
    chunk(from) {
        return this.string.slice(from);
    }
    get lineChunks() {
        return false;
    }
    read(from, to) {
        return this.string.slice(from, to);
    }
}
/// Create a parse wrapper that, after the inner parse completes,
/// scans its tree for mixed language regions with the `nest`
/// function, runs the resulting [inner parses](#common.NestedParse),
/// and then [mounts](#common.NodeProp^mounted) their results onto the
/// tree.
function $4d476c57e17b24ca$export$5dcc455959c76221(nest) {
    return (parse, input, fragments, ranges)=>new $4d476c57e17b24ca$var$MixedParse(parse, nest, input, fragments, ranges);
}
class $4d476c57e17b24ca$var$InnerParse {
    constructor(parser, parse, overlay, target, ranges){
        this.parser = parser;
        this.parse = parse;
        this.overlay = overlay;
        this.target = target;
        this.ranges = ranges;
        if (!ranges.length || ranges.some((r)=>r.from >= r.to)) throw new RangeError("Invalid inner parse ranges given: " + JSON.stringify(ranges));
    }
}
class $4d476c57e17b24ca$var$ActiveOverlay {
    constructor(parser, predicate, mounts, index, start, target, prev){
        this.parser = parser;
        this.predicate = predicate;
        this.mounts = mounts;
        this.index = index;
        this.start = start;
        this.target = target;
        this.prev = prev;
        this.depth = 0;
        this.ranges = [];
    }
}
const $4d476c57e17b24ca$var$stoppedInner = new $4d476c57e17b24ca$export$b8034b9bc18acd90({
    perNode: true
});
class $4d476c57e17b24ca$var$MixedParse {
    constructor(base, nest, input, fragments, ranges){
        this.nest = nest;
        this.input = input;
        this.fragments = fragments;
        this.ranges = ranges;
        this.inner = [];
        this.innerDone = 0;
        this.baseTree = null;
        this.stoppedAt = null;
        this.baseParse = base;
    }
    advance() {
        if (this.baseParse) {
            let done = this.baseParse.advance();
            if (!done) return null;
            this.baseParse = null;
            this.baseTree = done;
            this.startInner();
            if (this.stoppedAt != null) for (let inner of this.inner)inner.parse.stopAt(this.stoppedAt);
        }
        if (this.innerDone == this.inner.length) {
            let result = this.baseTree;
            if (this.stoppedAt != null) result = new $4d476c57e17b24ca$export$7fbedc92909ed28e(result.type, result.children, result.positions, result.length, result.propValues.concat([
                [
                    $4d476c57e17b24ca$var$stoppedInner,
                    this.stoppedAt
                ]
            ]));
            return result;
        }
        let inner = this.inner[this.innerDone], done = inner.parse.advance();
        if (done) {
            this.innerDone++;
            // This is a somewhat dodgy but super helpful hack where we
            // patch up nodes created by the inner parse (and thus
            // presumably not aliased anywhere else) to hold the information
            // about the inner parse.
            let props = Object.assign(Object.create(null), inner.target.props);
            props[$4d476c57e17b24ca$export$b8034b9bc18acd90.mounted.id] = new $4d476c57e17b24ca$export$358cdd8bd77577cc(done, inner.overlay, inner.parser);
            inner.target.props = props;
        }
        return null;
    }
    get parsedPos() {
        if (this.baseParse) return 0;
        let pos = this.input.length;
        for(let i = this.innerDone; i < this.inner.length; i++)if (this.inner[i].ranges[0].from < pos) pos = Math.min(pos, this.inner[i].parse.parsedPos);
        return pos;
    }
    stopAt(pos) {
        this.stoppedAt = pos;
        if (this.baseParse) this.baseParse.stopAt(pos);
        else for(let i = this.innerDone; i < this.inner.length; i++)this.inner[i].parse.stopAt(pos);
    }
    startInner() {
        let fragmentCursor = new $4d476c57e17b24ca$var$FragmentCursor(this.fragments);
        let overlay = null;
        let covered = null;
        let cursor = new $4d476c57e17b24ca$export$3ae4554f36e54a34(new $4d476c57e17b24ca$var$TreeNode(this.baseTree, this.ranges[0].from, 0, null), $4d476c57e17b24ca$export$b0e28367f55837aa.IncludeAnonymous | $4d476c57e17b24ca$export$b0e28367f55837aa.IgnoreMounts);
        scan: for(let nest, isCovered; this.stoppedAt == null || cursor.from < this.stoppedAt;){
            let enter = true, range;
            if (fragmentCursor.hasNode(cursor)) {
                if (overlay) {
                    let match = overlay.mounts.find((m)=>m.frag.from <= cursor.from && m.frag.to >= cursor.to && m.mount.overlay);
                    if (match) for (let r of match.mount.overlay){
                        let from = r.from + match.pos, to = r.to + match.pos;
                        if (from >= cursor.from && to <= cursor.to && !overlay.ranges.some((r)=>r.from < to && r.to > from)) overlay.ranges.push({
                            from: from,
                            to: to
                        });
                    }
                }
                enter = false;
            } else if (covered && (isCovered = $4d476c57e17b24ca$var$checkCover(covered.ranges, cursor.from, cursor.to))) enter = isCovered != 2 /* Cover.Full */ ;
            else if (!cursor.type.isAnonymous && cursor.from < cursor.to && (nest = this.nest(cursor, this.input))) {
                if (!cursor.tree) $4d476c57e17b24ca$var$materialize(cursor);
                let oldMounts = fragmentCursor.findMounts(cursor.from, nest.parser);
                if (typeof nest.overlay == "function") overlay = new $4d476c57e17b24ca$var$ActiveOverlay(nest.parser, nest.overlay, oldMounts, this.inner.length, cursor.from, cursor.tree, overlay);
                else {
                    let ranges = $4d476c57e17b24ca$var$punchRanges(this.ranges, nest.overlay || [
                        new $4d476c57e17b24ca$var$Range(cursor.from, cursor.to)
                    ]);
                    if (ranges.length) this.inner.push(new $4d476c57e17b24ca$var$InnerParse(nest.parser, nest.parser.startParse(this.input, $4d476c57e17b24ca$var$enterFragments(oldMounts, ranges), ranges), nest.overlay ? nest.overlay.map((r)=>new $4d476c57e17b24ca$var$Range(r.from - cursor.from, r.to - cursor.from)) : null, cursor.tree, ranges));
                    if (!nest.overlay) enter = false;
                    else if (ranges.length) covered = {
                        ranges: ranges,
                        depth: 0,
                        prev: covered
                    };
                }
            } else if (overlay && (range = overlay.predicate(cursor))) {
                if (range === true) range = new $4d476c57e17b24ca$var$Range(cursor.from, cursor.to);
                if (range.from < range.to) overlay.ranges.push(range);
            }
            if (enter && cursor.firstChild()) {
                if (overlay) overlay.depth++;
                if (covered) covered.depth++;
            } else for(;;){
                if (cursor.nextSibling()) break;
                if (!cursor.parent()) break scan;
                if (overlay && !--overlay.depth) {
                    let ranges = $4d476c57e17b24ca$var$punchRanges(this.ranges, overlay.ranges);
                    if (ranges.length) this.inner.splice(overlay.index, 0, new $4d476c57e17b24ca$var$InnerParse(overlay.parser, overlay.parser.startParse(this.input, $4d476c57e17b24ca$var$enterFragments(overlay.mounts, ranges), ranges), overlay.ranges.map((r)=>new $4d476c57e17b24ca$var$Range(r.from - overlay.start, r.to - overlay.start)), overlay.target, ranges));
                    overlay = overlay.prev;
                }
                if (covered && !--covered.depth) covered = covered.prev;
            }
        }
    }
}
function $4d476c57e17b24ca$var$checkCover(covered, from, to) {
    for (let range of covered){
        if (range.from >= to) break;
        if (range.to > from) return range.from <= from && range.to >= to ? 2 /* Cover.Full */  : 1 /* Cover.Partial */ ;
    }
    return 0 /* Cover.None */ ;
}
// Take a piece of buffer and convert it into a stand-alone
// TreeBuffer.
function $4d476c57e17b24ca$var$sliceBuf(buf, startI, endI, nodes, positions, off) {
    if (startI < endI) {
        let from = buf.buffer[startI + 1];
        nodes.push(buf.slice(startI, endI, from));
        positions.push(from - off);
    }
}
// This function takes a node that's in a buffer, and converts it, and
// its parent buffer nodes, into a Tree. This is again acting on the
// assumption that the trees and buffers have been constructed by the
// parse that was ran via the mix parser, and thus aren't shared with
// any other code, making violations of the immutability safe.
function $4d476c57e17b24ca$var$materialize(cursor) {
    let { node: node } = cursor, depth = 0;
    // Scan up to the nearest tree
    do {
        cursor.parent();
        depth++;
    }while (!cursor.tree);
    // Find the index of the buffer in that tree
    let i = 0, base = cursor.tree, off = 0;
    for(;; i++){
        off = base.positions[i] + cursor.from;
        if (off <= node.from && off + base.children[i].length >= node.to) break;
    }
    let buf = base.children[i], b = buf.buffer;
    // Split a level in the buffer, putting the nodes before and after
    // the child that contains `node` into new buffers.
    function split(startI, endI, type, innerOffset, length) {
        let i = startI;
        while(b[i + 2] + off <= node.from)i = b[i + 3];
        let children = [], positions = [];
        $4d476c57e17b24ca$var$sliceBuf(buf, startI, i, children, positions, innerOffset);
        let from = b[i + 1], to = b[i + 2];
        let isTarget = from + off == node.from && to + off == node.to && b[i] == node.type.id;
        children.push(isTarget ? node.toTree() : split(i + 4, b[i + 3], buf.set.types[b[i]], from, to - from));
        positions.push(from - innerOffset);
        $4d476c57e17b24ca$var$sliceBuf(buf, b[i + 3], endI, children, positions, innerOffset);
        return new $4d476c57e17b24ca$export$7fbedc92909ed28e(type, children, positions, length);
    }
    base.children[i] = split(0, b.length, $4d476c57e17b24ca$export$f06e977173f1857c.none, 0, buf.length);
    // Move the cursor back to the target node
    for(let d = 0; d <= depth; d++)cursor.childAfter(node.from);
}
class $4d476c57e17b24ca$var$StructureCursor {
    constructor(root, offset){
        this.offset = offset;
        this.done = false;
        this.cursor = root.cursor($4d476c57e17b24ca$export$b0e28367f55837aa.IncludeAnonymous | $4d476c57e17b24ca$export$b0e28367f55837aa.IgnoreMounts);
    }
    // Move to the first node (in pre-order) that starts at or after `pos`.
    moveTo(pos) {
        let { cursor: cursor } = this, p = pos - this.offset;
        while(!this.done && cursor.from < p){
            if (cursor.to >= pos && cursor.enter(p, 1, $4d476c57e17b24ca$export$b0e28367f55837aa.IgnoreOverlays | $4d476c57e17b24ca$export$b0e28367f55837aa.ExcludeBuffers)) ;
            else if (!cursor.next(false)) this.done = true;
        }
    }
    hasNode(cursor) {
        this.moveTo(cursor.from);
        if (!this.done && this.cursor.from + this.offset == cursor.from && this.cursor.tree) for(let tree = this.cursor.tree;;){
            if (tree == cursor.tree) return true;
            if (tree.children.length && tree.positions[0] == 0 && tree.children[0] instanceof $4d476c57e17b24ca$export$7fbedc92909ed28e) tree = tree.children[0];
            else break;
        }
        return false;
    }
}
class $4d476c57e17b24ca$var$FragmentCursor {
    constructor(fragments){
        var _a;
        this.fragments = fragments;
        this.curTo = 0;
        this.fragI = 0;
        if (fragments.length) {
            let first = this.curFrag = fragments[0];
            this.curTo = (_a = first.tree.prop($4d476c57e17b24ca$var$stoppedInner)) !== null && _a !== void 0 ? _a : first.to;
            this.inner = new $4d476c57e17b24ca$var$StructureCursor(first.tree, -first.offset);
        } else this.curFrag = this.inner = null;
    }
    hasNode(node) {
        while(this.curFrag && node.from >= this.curTo)this.nextFrag();
        return this.curFrag && this.curFrag.from <= node.from && this.curTo >= node.to && this.inner.hasNode(node);
    }
    nextFrag() {
        var _a;
        this.fragI++;
        if (this.fragI == this.fragments.length) this.curFrag = this.inner = null;
        else {
            let frag = this.curFrag = this.fragments[this.fragI];
            this.curTo = (_a = frag.tree.prop($4d476c57e17b24ca$var$stoppedInner)) !== null && _a !== void 0 ? _a : frag.to;
            this.inner = new $4d476c57e17b24ca$var$StructureCursor(frag.tree, -frag.offset);
        }
    }
    findMounts(pos, parser) {
        var _a;
        let result = [];
        if (this.inner) {
            this.inner.cursor.moveTo(pos, 1);
            for(let pos = this.inner.cursor.node; pos; pos = pos.parent){
                let mount = (_a = pos.tree) === null || _a === void 0 ? void 0 : _a.prop($4d476c57e17b24ca$export$b8034b9bc18acd90.mounted);
                if (mount && mount.parser == parser) for(let i = this.fragI; i < this.fragments.length; i++){
                    let frag = this.fragments[i];
                    if (frag.from >= pos.to) break;
                    if (frag.tree == this.curFrag.tree) result.push({
                        frag: frag,
                        pos: pos.from - frag.offset,
                        mount: mount
                    });
                }
            }
        }
        return result;
    }
}
function $4d476c57e17b24ca$var$punchRanges(outer, ranges) {
    let copy = null, current = ranges;
    for(let i = 1, j = 0; i < outer.length; i++){
        let gapFrom = outer[i - 1].to, gapTo = outer[i].from;
        for(; j < current.length; j++){
            let r = current[j];
            if (r.from >= gapTo) break;
            if (r.to <= gapFrom) continue;
            if (!copy) current = copy = ranges.slice();
            if (r.from < gapFrom) {
                copy[j] = new $4d476c57e17b24ca$var$Range(r.from, gapFrom);
                if (r.to > gapTo) copy.splice(j + 1, 0, new $4d476c57e17b24ca$var$Range(gapTo, r.to));
            } else if (r.to > gapTo) copy[j--] = new $4d476c57e17b24ca$var$Range(gapTo, r.to);
            else copy.splice(j--, 1);
        }
    }
    return current;
}
function $4d476c57e17b24ca$var$findCoverChanges(a, b, from, to) {
    let iA = 0, iB = 0, inA = false, inB = false, pos = -1000000000;
    let result = [];
    for(;;){
        let nextA = iA == a.length ? 1e9 : inA ? a[iA].to : a[iA].from;
        let nextB = iB == b.length ? 1e9 : inB ? b[iB].to : b[iB].from;
        if (inA != inB) {
            let start = Math.max(pos, from), end = Math.min(nextA, nextB, to);
            if (start < end) result.push(new $4d476c57e17b24ca$var$Range(start, end));
        }
        pos = Math.min(nextA, nextB);
        if (pos == 1e9) break;
        if (nextA == pos) {
            if (!inA) inA = true;
            else {
                inA = false;
                iA++;
            }
        }
        if (nextB == pos) {
            if (!inB) inB = true;
            else {
                inB = false;
                iB++;
            }
        }
    }
    return result;
}
// Given a number of fragments for the outer tree, and a set of ranges
// to parse, find fragments for inner trees mounted around those
// ranges, if any.
function $4d476c57e17b24ca$var$enterFragments(mounts, ranges) {
    let result = [];
    for (let { pos: pos, mount: mount, frag: frag } of mounts){
        let startPos = pos + (mount.overlay ? mount.overlay[0].from : 0), endPos = startPos + mount.tree.length;
        let from = Math.max(frag.from, startPos), to = Math.min(frag.to, endPos);
        if (mount.overlay) {
            let overlay = mount.overlay.map((r)=>new $4d476c57e17b24ca$var$Range(r.from + pos, r.to + pos));
            let changes = $4d476c57e17b24ca$var$findCoverChanges(ranges, overlay, from, to);
            for(let i = 0, pos = from;; i++){
                let last = i == changes.length, end = last ? to : changes[i].from;
                if (end > pos) result.push(new $4d476c57e17b24ca$export$3ae2ede6dca97077(pos, end, mount.tree, -startPos, frag.from >= pos || frag.openStart, frag.to <= end || frag.openEnd));
                if (last) break;
                pos = changes[i].to;
            }
        } else result.push(new $4d476c57e17b24ca$export$3ae2ede6dca97077(from, to, mount.tree, -startPos, frag.from >= startPos || frag.openStart, frag.to <= endPos || frag.openEnd));
    }
    return result;
}

});

parcelRequire.register("hB7kI", function(module, exports) {

$parcel$export(module.exports, "Text", () => $ccfb9497d8ef598f$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "findClusterBreak", () => $ccfb9497d8ef598f$export$a0fa439fd515e1ed);
$parcel$export(module.exports, "codePointAt", () => $ccfb9497d8ef598f$export$42977f40461e1360);
$parcel$export(module.exports, "codePointSize", () => $ccfb9497d8ef598f$export$a870abf234f6353c);
$parcel$export(module.exports, "fromCodePoint", () => $ccfb9497d8ef598f$export$73bfc63873071f74);
$parcel$export(module.exports, "MapMode", () => $ccfb9497d8ef598f$export$39cf3280165f92aa);
$parcel$export(module.exports, "ChangeSet", () => $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c);
$parcel$export(module.exports, "EditorSelection", () => $ccfb9497d8ef598f$export$3bb1bd44aee62999);
$parcel$export(module.exports, "Facet", () => $ccfb9497d8ef598f$export$ef7d5e9b79fa1504);
$parcel$export(module.exports, "StateField", () => $ccfb9497d8ef598f$export$34381b1ce2130245);
$parcel$export(module.exports, "Prec", () => $ccfb9497d8ef598f$export$b92464a736444411);
$parcel$export(module.exports, "Annotation", () => $ccfb9497d8ef598f$export$9279461326b8700a);
$parcel$export(module.exports, "StateEffect", () => $ccfb9497d8ef598f$export$95000d4efaa4321f);
$parcel$export(module.exports, "Transaction", () => $ccfb9497d8ef598f$export$febc5573c75cefb0);
$parcel$export(module.exports, "CharCategory", () => $ccfb9497d8ef598f$export$239a3d59567c1401);
$parcel$export(module.exports, "EditorState", () => $ccfb9497d8ef598f$export$afa855cbfaff27f2);
$parcel$export(module.exports, "combineConfig", () => $ccfb9497d8ef598f$export$4e19c0b693794a7e);
$parcel$export(module.exports, "RangeValue", () => $ccfb9497d8ef598f$export$d60f08ed93a48611);
$parcel$export(module.exports, "RangeSet", () => $ccfb9497d8ef598f$export$34cb5241245008dd);
$parcel$export(module.exports, "RangeSetBuilder", () => $ccfb9497d8ef598f$export$89e09ce03c7e8594);
$parcel$export(module.exports, "countColumn", () => $ccfb9497d8ef598f$export$20b4ab289374d0ac);
$parcel$export(module.exports, "findColumn", () => $ccfb9497d8ef598f$export$718b3d71c384ca05);
/**
The data structure for documents. @nonabstract
*/ class $ccfb9497d8ef598f$export$5f1af8db9871e1d6 {
    /**
    Get the line description around the given position.
    */ lineAt(pos) {
        if (pos < 0 || pos > this.length) throw new RangeError(`Invalid position ${pos} in document of length ${this.length}`);
        return this.lineInner(pos, false, 1, 0);
    }
    /**
    Get the description for the given (1-based) line number.
    */ line(n) {
        if (n < 1 || n > this.lines) throw new RangeError(`Invalid line number ${n} in ${this.lines}-line document`);
        return this.lineInner(n, true, 1, 0);
    }
    /**
    Replace a range of the text with the given content.
    */ replace(from, to, text) {
        let parts = [];
        this.decompose(0, from, parts, 2 /* Open.To */ );
        if (text.length) text.decompose(0, text.length, parts, 3 /* Open.To */ );
        this.decompose(to, this.length, parts, 1 /* Open.From */ );
        return $ccfb9497d8ef598f$var$TextNode.from(parts, this.length - (to - from) + text.length);
    }
    /**
    Append another document to this one.
    */ append(other) {
        return this.replace(this.length, this.length, other);
    }
    /**
    Retrieve the text between the given points.
    */ slice(from, to = this.length) {
        let parts = [];
        this.decompose(from, to, parts, 0);
        return $ccfb9497d8ef598f$var$TextNode.from(parts, to - from);
    }
    /**
    Test whether this text is equal to another instance.
    */ eq(other) {
        if (other == this) return true;
        if (other.length != this.length || other.lines != this.lines) return false;
        let start = this.scanIdentical(other, 1), end = this.length - this.scanIdentical(other, -1);
        let a = new $ccfb9497d8ef598f$var$RawTextCursor(this), b = new $ccfb9497d8ef598f$var$RawTextCursor(other);
        for(let skip = start, pos = start;;){
            a.next(skip);
            b.next(skip);
            skip = 0;
            if (a.lineBreak != b.lineBreak || a.done != b.done || a.value != b.value) return false;
            pos += a.value.length;
            if (a.done || pos >= end) return true;
        }
    }
    /**
    Iterate over the text. When `dir` is `-1`, iteration happens
    from end to start. This will return lines and the breaks between
    them as separate strings.
    */ iter(dir = 1) {
        return new $ccfb9497d8ef598f$var$RawTextCursor(this, dir);
    }
    /**
    Iterate over a range of the text. When `from` > `to`, the
    iterator will run in reverse.
    */ iterRange(from, to = this.length) {
        return new $ccfb9497d8ef598f$var$PartialTextCursor(this, from, to);
    }
    /**
    Return a cursor that iterates over the given range of lines,
    _without_ returning the line breaks between, and yielding empty
    strings for empty lines.
    
    When `from` and `to` are given, they should be 1-based line numbers.
    */ iterLines(from, to) {
        let inner;
        if (from == null) inner = this.iter();
        else {
            if (to == null) to = this.lines + 1;
            let start = this.line(from).from;
            inner = this.iterRange(start, Math.max(start, to == this.lines + 1 ? this.length : to <= 1 ? 0 : this.line(to - 1).to));
        }
        return new $ccfb9497d8ef598f$var$LineCursor(inner);
    }
    /**
    Return the document as a string, using newline characters to
    separate lines.
    */ toString() {
        return this.sliceString(0);
    }
    /**
    Convert the document to an array of lines (which can be
    deserialized again via [`Text.of`](https://codemirror.net/6/docs/ref/#state.Text^of)).
    */ toJSON() {
        let lines = [];
        this.flatten(lines);
        return lines;
    }
    /**
    @internal
    */ constructor(){}
    /**
    Create a `Text` instance for the given array of lines.
    */ static of(text) {
        if (text.length == 0) throw new RangeError("A document must have at least one line");
        if (text.length == 1 && !text[0]) return $ccfb9497d8ef598f$export$5f1af8db9871e1d6.empty;
        return text.length <= 32 /* Tree.Branch */  ? new $ccfb9497d8ef598f$var$TextLeaf(text) : $ccfb9497d8ef598f$var$TextNode.from($ccfb9497d8ef598f$var$TextLeaf.split(text, []));
    }
}
// Leaves store an array of line strings. There are always line breaks
// between these strings. Leaves are limited in size and have to be
// contained in TextNode instances for bigger documents.
class $ccfb9497d8ef598f$var$TextLeaf extends $ccfb9497d8ef598f$export$5f1af8db9871e1d6 {
    constructor(text, length = $ccfb9497d8ef598f$var$textLength(text)){
        super();
        this.text = text;
        this.length = length;
    }
    get lines() {
        return this.text.length;
    }
    get children() {
        return null;
    }
    lineInner(target, isLine, line, offset) {
        for(let i = 0;; i++){
            let string = this.text[i], end = offset + string.length;
            if ((isLine ? line : end) >= target) return new $ccfb9497d8ef598f$export$17d680238e50603e(offset, end, line, string);
            offset = end + 1;
            line++;
        }
    }
    decompose(from, to, target, open) {
        let text = from <= 0 && to >= this.length ? this : new $ccfb9497d8ef598f$var$TextLeaf($ccfb9497d8ef598f$var$sliceText(this.text, from, to), Math.min(to, this.length) - Math.max(0, from));
        if (open & 1 /* Open.From */ ) {
            let prev = target.pop();
            let joined = $ccfb9497d8ef598f$var$appendText(text.text, prev.text.slice(), 0, text.length);
            if (joined.length <= 32 /* Tree.Branch */ ) target.push(new $ccfb9497d8ef598f$var$TextLeaf(joined, prev.length + text.length));
            else {
                let mid = joined.length >> 1;
                target.push(new $ccfb9497d8ef598f$var$TextLeaf(joined.slice(0, mid)), new $ccfb9497d8ef598f$var$TextLeaf(joined.slice(mid)));
            }
        } else target.push(text);
    }
    replace(from, to, text) {
        if (!(text instanceof $ccfb9497d8ef598f$var$TextLeaf)) return super.replace(from, to, text);
        let lines = $ccfb9497d8ef598f$var$appendText(this.text, $ccfb9497d8ef598f$var$appendText(text.text, $ccfb9497d8ef598f$var$sliceText(this.text, 0, from)), to);
        let newLen = this.length + text.length - (to - from);
        if (lines.length <= 32 /* Tree.Branch */ ) return new $ccfb9497d8ef598f$var$TextLeaf(lines, newLen);
        return $ccfb9497d8ef598f$var$TextNode.from($ccfb9497d8ef598f$var$TextLeaf.split(lines, []), newLen);
    }
    sliceString(from, to = this.length, lineSep = "\n") {
        let result = "";
        for(let pos = 0, i = 0; pos <= to && i < this.text.length; i++){
            let line = this.text[i], end = pos + line.length;
            if (pos > from && i) result += lineSep;
            if (from < end && to > pos) result += line.slice(Math.max(0, from - pos), to - pos);
            pos = end + 1;
        }
        return result;
    }
    flatten(target) {
        for (let line of this.text)target.push(line);
    }
    scanIdentical() {
        return 0;
    }
    static split(text, target) {
        let part = [], len = -1;
        for (let line of text){
            part.push(line);
            len += line.length + 1;
            if (part.length == 32 /* Tree.Branch */ ) {
                target.push(new $ccfb9497d8ef598f$var$TextLeaf(part, len));
                part = [];
                len = -1;
            }
        }
        if (len > -1) target.push(new $ccfb9497d8ef598f$var$TextLeaf(part, len));
        return target;
    }
}
// Nodes provide the tree structure of the `Text` type. They store a
// number of other nodes or leaves, taking care to balance themselves
// on changes. There are implied line breaks _between_ the children of
// a node (but not before the first or after the last child).
class $ccfb9497d8ef598f$var$TextNode extends $ccfb9497d8ef598f$export$5f1af8db9871e1d6 {
    constructor(children, length){
        super();
        this.children = children;
        this.length = length;
        this.lines = 0;
        for (let child of children)this.lines += child.lines;
    }
    lineInner(target, isLine, line, offset) {
        for(let i = 0;; i++){
            let child = this.children[i], end = offset + child.length, endLine = line + child.lines - 1;
            if ((isLine ? endLine : end) >= target) return child.lineInner(target, isLine, line, offset);
            offset = end + 1;
            line = endLine + 1;
        }
    }
    decompose(from, to, target, open) {
        for(let i = 0, pos = 0; pos <= to && i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            if (from <= end && to >= pos) {
                let childOpen = open & ((pos <= from ? 1 /* Open.From */  : 0) | (end >= to ? 2 /* Open.To */  : 0));
                if (pos >= from && end <= to && !childOpen) target.push(child);
                else child.decompose(from - pos, to - pos, target, childOpen);
            }
            pos = end + 1;
        }
    }
    replace(from, to, text) {
        if (text.lines < this.lines) for(let i = 0, pos = 0; i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            // Fast path: if the change only affects one child and the
            // child's size remains in the acceptable range, only update
            // that child
            if (from >= pos && to <= end) {
                let updated = child.replace(from - pos, to - pos, text);
                let totalLines = this.lines - child.lines + updated.lines;
                if (updated.lines < totalLines >> 4 && updated.lines > totalLines >> 6) {
                    let copy = this.children.slice();
                    copy[i] = updated;
                    return new $ccfb9497d8ef598f$var$TextNode(copy, this.length - (to - from) + text.length);
                }
                return super.replace(pos, end, updated);
            }
            pos = end + 1;
        }
        return super.replace(from, to, text);
    }
    sliceString(from, to = this.length, lineSep = "\n") {
        let result = "";
        for(let i = 0, pos = 0; i < this.children.length && pos <= to; i++){
            let child = this.children[i], end = pos + child.length;
            if (pos > from && i) result += lineSep;
            if (from < end && to > pos) result += child.sliceString(from - pos, to - pos, lineSep);
            pos = end + 1;
        }
        return result;
    }
    flatten(target) {
        for (let child of this.children)child.flatten(target);
    }
    scanIdentical(other, dir) {
        if (!(other instanceof $ccfb9497d8ef598f$var$TextNode)) return 0;
        let length = 0;
        let [iA, iB, eA, eB] = dir > 0 ? [
            0,
            0,
            this.children.length,
            other.children.length
        ] : [
            this.children.length - 1,
            other.children.length - 1,
            -1,
            -1
        ];
        for(;; iA += dir, iB += dir){
            if (iA == eA || iB == eB) return length;
            let chA = this.children[iA], chB = other.children[iB];
            if (chA != chB) return length + chA.scanIdentical(chB, dir);
            length += chA.length + 1;
        }
    }
    static from(children, length = children.reduce((l, ch)=>l + ch.length + 1, -1)) {
        let lines = 0;
        for (let ch of children)lines += ch.lines;
        if (lines < 32 /* Tree.Branch */ ) {
            let flat = [];
            for (let ch of children)ch.flatten(flat);
            return new $ccfb9497d8ef598f$var$TextLeaf(flat, length);
        }
        let chunk = Math.max(32 /* Tree.Branch */ , lines >> 5 /* Tree.BranchShift */ ), maxChunk = chunk << 1, minChunk = chunk >> 1;
        let chunked = [], currentLines = 0, currentLen = -1, currentChunk = [];
        function add(child) {
            let last;
            if (child.lines > maxChunk && child instanceof $ccfb9497d8ef598f$var$TextNode) for (let node of child.children)add(node);
            else if (child.lines > minChunk && (currentLines > minChunk || !currentLines)) {
                flush();
                chunked.push(child);
            } else if (child instanceof $ccfb9497d8ef598f$var$TextLeaf && currentLines && (last = currentChunk[currentChunk.length - 1]) instanceof $ccfb9497d8ef598f$var$TextLeaf && child.lines + last.lines <= 32 /* Tree.Branch */ ) {
                currentLines += child.lines;
                currentLen += child.length + 1;
                currentChunk[currentChunk.length - 1] = new $ccfb9497d8ef598f$var$TextLeaf(last.text.concat(child.text), last.length + 1 + child.length);
            } else {
                if (currentLines + child.lines > chunk) flush();
                currentLines += child.lines;
                currentLen += child.length + 1;
                currentChunk.push(child);
            }
        }
        function flush() {
            if (currentLines == 0) return;
            chunked.push(currentChunk.length == 1 ? currentChunk[0] : $ccfb9497d8ef598f$var$TextNode.from(currentChunk, currentLen));
            currentLen = -1;
            currentLines = currentChunk.length = 0;
        }
        for (let child of children)add(child);
        flush();
        return chunked.length == 1 ? chunked[0] : new $ccfb9497d8ef598f$var$TextNode(chunked, length);
    }
}
$ccfb9497d8ef598f$export$5f1af8db9871e1d6.empty = /*@__PURE__*/ new $ccfb9497d8ef598f$var$TextLeaf([
    ""
], 0);
function $ccfb9497d8ef598f$var$textLength(text) {
    let length = -1;
    for (let line of text)length += line.length + 1;
    return length;
}
function $ccfb9497d8ef598f$var$appendText(text, target, from = 0, to = 1e9) {
    for(let pos = 0, i = 0, first = true; i < text.length && pos <= to; i++){
        let line = text[i], end = pos + line.length;
        if (end >= from) {
            if (end > to) line = line.slice(0, to - pos);
            if (pos < from) line = line.slice(from - pos);
            if (first) {
                target[target.length - 1] += line;
                first = false;
            } else target.push(line);
        }
        pos = end + 1;
    }
    return target;
}
function $ccfb9497d8ef598f$var$sliceText(text, from, to) {
    return $ccfb9497d8ef598f$var$appendText(text, [
        ""
    ], from, to);
}
class $ccfb9497d8ef598f$var$RawTextCursor {
    constructor(text, dir = 1){
        this.dir = dir;
        this.done = false;
        this.lineBreak = false;
        this.value = "";
        this.nodes = [
            text
        ];
        this.offsets = [
            dir > 0 ? 1 : (text instanceof $ccfb9497d8ef598f$var$TextLeaf ? text.text.length : text.children.length) << 1
        ];
    }
    nextInner(skip, dir) {
        this.done = this.lineBreak = false;
        for(;;){
            let last = this.nodes.length - 1;
            let top = this.nodes[last], offsetValue = this.offsets[last], offset = offsetValue >> 1;
            let size = top instanceof $ccfb9497d8ef598f$var$TextLeaf ? top.text.length : top.children.length;
            if (offset == (dir > 0 ? size : 0)) {
                if (last == 0) {
                    this.done = true;
                    this.value = "";
                    return this;
                }
                if (dir > 0) this.offsets[last - 1]++;
                this.nodes.pop();
                this.offsets.pop();
            } else if ((offsetValue & 1) == (dir > 0 ? 0 : 1)) {
                this.offsets[last] += dir;
                if (skip == 0) {
                    this.lineBreak = true;
                    this.value = "\n";
                    return this;
                }
                skip--;
            } else if (top instanceof $ccfb9497d8ef598f$var$TextLeaf) {
                // Move to the next string
                let next = top.text[offset + (dir < 0 ? -1 : 0)];
                this.offsets[last] += dir;
                if (next.length > Math.max(0, skip)) {
                    this.value = skip == 0 ? next : dir > 0 ? next.slice(skip) : next.slice(0, next.length - skip);
                    return this;
                }
                skip -= next.length;
            } else {
                let next = top.children[offset + (dir < 0 ? -1 : 0)];
                if (skip > next.length) {
                    skip -= next.length;
                    this.offsets[last] += dir;
                } else {
                    if (dir < 0) this.offsets[last]--;
                    this.nodes.push(next);
                    this.offsets.push(dir > 0 ? 1 : (next instanceof $ccfb9497d8ef598f$var$TextLeaf ? next.text.length : next.children.length) << 1);
                }
            }
        }
    }
    next(skip = 0) {
        if (skip < 0) {
            this.nextInner(-skip, -this.dir);
            skip = this.value.length;
        }
        return this.nextInner(skip, this.dir);
    }
}
class $ccfb9497d8ef598f$var$PartialTextCursor {
    constructor(text, start, end){
        this.value = "";
        this.done = false;
        this.cursor = new $ccfb9497d8ef598f$var$RawTextCursor(text, start > end ? -1 : 1);
        this.pos = start > end ? text.length : 0;
        this.from = Math.min(start, end);
        this.to = Math.max(start, end);
    }
    nextInner(skip, dir) {
        if (dir < 0 ? this.pos <= this.from : this.pos >= this.to) {
            this.value = "";
            this.done = true;
            return this;
        }
        skip += Math.max(0, dir < 0 ? this.pos - this.to : this.from - this.pos);
        let limit = dir < 0 ? this.pos - this.from : this.to - this.pos;
        if (skip > limit) skip = limit;
        limit -= skip;
        let { value: value } = this.cursor.next(skip);
        this.pos += (value.length + skip) * dir;
        this.value = value.length <= limit ? value : dir < 0 ? value.slice(value.length - limit) : value.slice(0, limit);
        this.done = !this.value;
        return this;
    }
    next(skip = 0) {
        if (skip < 0) skip = Math.max(skip, this.from - this.pos);
        else if (skip > 0) skip = Math.min(skip, this.to - this.pos);
        return this.nextInner(skip, this.cursor.dir);
    }
    get lineBreak() {
        return this.cursor.lineBreak && this.value != "";
    }
}
class $ccfb9497d8ef598f$var$LineCursor {
    constructor(inner){
        this.inner = inner;
        this.afterBreak = true;
        this.value = "";
        this.done = false;
    }
    next(skip = 0) {
        let { done: done, lineBreak: lineBreak, value: value } = this.inner.next(skip);
        if (done) {
            this.done = true;
            this.value = "";
        } else if (lineBreak) {
            if (this.afterBreak) this.value = "";
            else {
                this.afterBreak = true;
                this.next();
            }
        } else {
            this.value = value;
            this.afterBreak = false;
        }
        return this;
    }
    get lineBreak() {
        return false;
    }
}
if (typeof Symbol != "undefined") {
    $ccfb9497d8ef598f$export$5f1af8db9871e1d6.prototype[Symbol.iterator] = function() {
        return this.iter();
    };
    $ccfb9497d8ef598f$var$RawTextCursor.prototype[Symbol.iterator] = $ccfb9497d8ef598f$var$PartialTextCursor.prototype[Symbol.iterator] = $ccfb9497d8ef598f$var$LineCursor.prototype[Symbol.iterator] = function() {
        return this;
    };
}
/**
This type describes a line in the document. It is created
on-demand when lines are [queried](https://codemirror.net/6/docs/ref/#state.Text.lineAt).
*/ class $ccfb9497d8ef598f$export$17d680238e50603e {
    /**
    @internal
    */ constructor(/**
    The position of the start of the line.
    */ from, /**
    The position at the end of the line (_before_ the line break,
    or at the end of document for the last line).
    */ to, /**
    This line's line number (1-based).
    */ number, /**
    The line's content.
    */ text){
        this.from = from;
        this.to = to;
        this.number = number;
        this.text = text;
    }
    /**
    The length of the line (not including any line break after it).
    */ get length() {
        return this.to - this.from;
    }
}
// Compressed representation of the Grapheme_Cluster_Break=Extend
// information from
// http://www.unicode.org/Public/13.0.0/ucd/auxiliary/GraphemeBreakProperty.txt.
// Each pair of elements represents a range, as an offet from the
// previous range and a length. Numbers are in base-36, with the empty
// string being a shorthand for 1.
let $ccfb9497d8ef598f$var$extend = /*@__PURE__*/ "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((s)=>s ? parseInt(s, 36) : 1);
// Convert offsets into absolute values
for(let i = 1; i < $ccfb9497d8ef598f$var$extend.length; i++)$ccfb9497d8ef598f$var$extend[i] += $ccfb9497d8ef598f$var$extend[i - 1];
function $ccfb9497d8ef598f$var$isExtendingChar(code) {
    for(let i = 1; i < $ccfb9497d8ef598f$var$extend.length; i += 2)if ($ccfb9497d8ef598f$var$extend[i] > code) return $ccfb9497d8ef598f$var$extend[i - 1] <= code;
    return false;
}
function $ccfb9497d8ef598f$var$isRegionalIndicator(code) {
    return code >= 0x1F1E6 && code <= 0x1F1FF;
}
const $ccfb9497d8ef598f$var$ZWJ = 0x200d;
/**
Returns a next grapheme cluster break _after_ (not equal to)
`pos`, if `forward` is true, or before otherwise. Returns `pos`
itself if no further cluster break is available in the string.
Moves across surrogate pairs, extending characters (when
`includeExtending` is true), characters joined with zero-width
joiners, and flag emoji.
*/ function $ccfb9497d8ef598f$export$a0fa439fd515e1ed(str, pos, forward = true, includeExtending = true) {
    return (forward ? $ccfb9497d8ef598f$var$nextClusterBreak : $ccfb9497d8ef598f$var$prevClusterBreak)(str, pos, includeExtending);
}
function $ccfb9497d8ef598f$var$nextClusterBreak(str, pos, includeExtending) {
    if (pos == str.length) return pos;
    // If pos is in the middle of a surrogate pair, move to its start
    if (pos && $ccfb9497d8ef598f$var$surrogateLow(str.charCodeAt(pos)) && $ccfb9497d8ef598f$var$surrogateHigh(str.charCodeAt(pos - 1))) pos--;
    let prev = $ccfb9497d8ef598f$export$42977f40461e1360(str, pos);
    pos += $ccfb9497d8ef598f$export$a870abf234f6353c(prev);
    while(pos < str.length){
        let next = $ccfb9497d8ef598f$export$42977f40461e1360(str, pos);
        if (prev == $ccfb9497d8ef598f$var$ZWJ || next == $ccfb9497d8ef598f$var$ZWJ || includeExtending && $ccfb9497d8ef598f$var$isExtendingChar(next)) {
            pos += $ccfb9497d8ef598f$export$a870abf234f6353c(next);
            prev = next;
        } else if ($ccfb9497d8ef598f$var$isRegionalIndicator(next)) {
            let countBefore = 0, i = pos - 2;
            while(i >= 0 && $ccfb9497d8ef598f$var$isRegionalIndicator($ccfb9497d8ef598f$export$42977f40461e1360(str, i))){
                countBefore++;
                i -= 2;
            }
            if (countBefore % 2 == 0) break;
            else pos += 2;
        } else break;
    }
    return pos;
}
function $ccfb9497d8ef598f$var$prevClusterBreak(str, pos, includeExtending) {
    while(pos > 0){
        let found = $ccfb9497d8ef598f$var$nextClusterBreak(str, pos - 2, includeExtending);
        if (found < pos) return found;
        pos--;
    }
    return 0;
}
function $ccfb9497d8ef598f$var$surrogateLow(ch) {
    return ch >= 0xDC00 && ch < 0xE000;
}
function $ccfb9497d8ef598f$var$surrogateHigh(ch) {
    return ch >= 0xD800 && ch < 0xDC00;
}
/**
Find the code point at the given position in a string (like the
[`codePointAt`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/codePointAt)
string method).
*/ function $ccfb9497d8ef598f$export$42977f40461e1360(str, pos) {
    let code0 = str.charCodeAt(pos);
    if (!$ccfb9497d8ef598f$var$surrogateHigh(code0) || pos + 1 == str.length) return code0;
    let code1 = str.charCodeAt(pos + 1);
    if (!$ccfb9497d8ef598f$var$surrogateLow(code1)) return code0;
    return (code0 - 0xd800 << 10) + (code1 - 0xdc00) + 0x10000;
}
/**
Given a Unicode codepoint, return the JavaScript string that
respresents it (like
[`String.fromCodePoint`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/fromCodePoint)).
*/ function $ccfb9497d8ef598f$export$73bfc63873071f74(code) {
    if (code <= 0xffff) return String.fromCharCode(code);
    code -= 0x10000;
    return String.fromCharCode((code >> 10) + 0xd800, (code & 1023) + 0xdc00);
}
/**
The amount of positions a character takes up a JavaScript string.
*/ function $ccfb9497d8ef598f$export$a870abf234f6353c(code) {
    return code < 0x10000 ? 1 : 2;
}
const $ccfb9497d8ef598f$var$DefaultSplit = /\r\n?|\n/;
/**
Distinguishes different ways in which positions can be mapped.
*/ var $ccfb9497d8ef598f$export$39cf3280165f92aa = /*@__PURE__*/ function(MapMode) {
    /**
    Map a position to a valid new position, even when its context
    was deleted.
    */ MapMode[MapMode["Simple"] = 0] = "Simple";
    /**
    Return null if deletion happens across the position.
    */ MapMode[MapMode["TrackDel"] = 1] = "TrackDel";
    /**
    Return null if the character _before_ the position is deleted.
    */ MapMode[MapMode["TrackBefore"] = 2] = "TrackBefore";
    /**
    Return null if the character _after_ the position is deleted.
    */ MapMode[MapMode["TrackAfter"] = 3] = "TrackAfter";
    return MapMode;
}($ccfb9497d8ef598f$export$39cf3280165f92aa || ($ccfb9497d8ef598f$export$39cf3280165f92aa = {}));
/**
A change description is a variant of [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet)
that doesn't store the inserted text. As such, it can't be
applied, but is cheaper to store and manipulate.
*/ class $ccfb9497d8ef598f$export$34b6a936f2bb06a2 {
    // Sections are encoded as pairs of integers. The first is the
    // length in the current document, and the second is -1 for
    // unaffected sections, and the length of the replacement content
    // otherwise. So an insertion would be (0, n>0), a deletion (n>0,
    // 0), and a replacement two positive numbers.
    /**
    @internal
    */ constructor(/**
    @internal
    */ sections){
        this.sections = sections;
    }
    /**
    The length of the document before the change.
    */ get length() {
        let result = 0;
        for(let i = 0; i < this.sections.length; i += 2)result += this.sections[i];
        return result;
    }
    /**
    The length of the document after the change.
    */ get newLength() {
        let result = 0;
        for(let i = 0; i < this.sections.length; i += 2){
            let ins = this.sections[i + 1];
            result += ins < 0 ? this.sections[i] : ins;
        }
        return result;
    }
    /**
    False when there are actual changes in this set.
    */ get empty() {
        return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
    }
    /**
    Iterate over the unchanged parts left by these changes. `posA`
    provides the position of the range in the old document, `posB`
    the new position in the changed document.
    */ iterGaps(f) {
        for(let i = 0, posA = 0, posB = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            if (ins < 0) {
                f(posA, posB, len);
                posB += len;
            } else posB += ins;
            posA += len;
        }
    }
    /**
    Iterate over the ranges changed by these changes. (See
    [`ChangeSet.iterChanges`](https://codemirror.net/6/docs/ref/#state.ChangeSet.iterChanges) for a
    variant that also provides you with the inserted text.)
    `fromA`/`toA` provides the extent of the change in the starting
    document, `fromB`/`toB` the extent of the replacement in the
    changed document.
    
    When `individual` is true, adjacent changes (which are kept
    separate for [position mapping](https://codemirror.net/6/docs/ref/#state.ChangeDesc.mapPos)) are
    reported separately.
    */ iterChangedRanges(f, individual = false) {
        $ccfb9497d8ef598f$var$iterChanges(this, f, individual);
    }
    /**
    Get a description of the inverted form of these changes.
    */ get invertedDesc() {
        let sections = [];
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            if (ins < 0) sections.push(len, ins);
            else sections.push(ins, len);
        }
        return new $ccfb9497d8ef598f$export$34b6a936f2bb06a2(sections);
    }
    /**
    Compute the combined effect of applying another set of changes
    after this one. The length of the document after this set should
    match the length before `other`.
    */ composeDesc(other) {
        return this.empty ? other : other.empty ? this : $ccfb9497d8ef598f$var$composeSets(this, other);
    }
    /**
    Map this description, which should start with the same document
    as `other`, over another set of changes, so that it can be
    applied after it. When `before` is true, map as if the changes
    in `other` happened before the ones in `this`.
    */ mapDesc(other, before = false) {
        return other.empty ? this : $ccfb9497d8ef598f$var$mapSet(this, other, before);
    }
    mapPos(pos, assoc = -1, mode = $ccfb9497d8ef598f$export$39cf3280165f92aa.Simple) {
        let posA = 0, posB = 0;
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++], endA = posA + len;
            if (ins < 0) {
                if (endA > pos) return posB + (pos - posA);
                posB += len;
            } else {
                if (mode != $ccfb9497d8ef598f$export$39cf3280165f92aa.Simple && endA >= pos && (mode == $ccfb9497d8ef598f$export$39cf3280165f92aa.TrackDel && posA < pos && endA > pos || mode == $ccfb9497d8ef598f$export$39cf3280165f92aa.TrackBefore && posA < pos || mode == $ccfb9497d8ef598f$export$39cf3280165f92aa.TrackAfter && endA > pos)) return null;
                if (endA > pos || endA == pos && assoc < 0 && !len) return pos == posA || assoc < 0 ? posB : posB + ins;
                posB += ins;
            }
            posA = endA;
        }
        if (pos > posA) throw new RangeError(`Position ${pos} is out of range for changeset of length ${posA}`);
        return posB;
    }
    /**
    Check whether these changes touch a given range. When one of the
    changes entirely covers the range, the string `"cover"` is
    returned.
    */ touchesRange(from, to = from) {
        for(let i = 0, pos = 0; i < this.sections.length && pos <= to;){
            let len = this.sections[i++], ins = this.sections[i++], end = pos + len;
            if (ins >= 0 && pos <= to && end >= from) return pos < from && end > to ? "cover" : true;
            pos = end;
        }
        return false;
    }
    /**
    @internal
    */ toString() {
        let result = "";
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            result += (result ? " " : "") + len + (ins >= 0 ? ":" + ins : "");
        }
        return result;
    }
    /**
    Serialize this change desc to a JSON-representable value.
    */ toJSON() {
        return this.sections;
    }
    /**
    Create a change desc from its JSON representation (as produced
    by [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeDesc.toJSON).
    */ static fromJSON(json) {
        if (!Array.isArray(json) || json.length % 2 || json.some((a)=>typeof a != "number")) throw new RangeError("Invalid JSON representation of ChangeDesc");
        return new $ccfb9497d8ef598f$export$34b6a936f2bb06a2(json);
    }
    /**
    @internal
    */ static create(sections) {
        return new $ccfb9497d8ef598f$export$34b6a936f2bb06a2(sections);
    }
}
/**
A change set represents a group of modifications to a document. It
stores the document length, and can only be applied to documents
with exactly that length.
*/ class $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c extends $ccfb9497d8ef598f$export$34b6a936f2bb06a2 {
    constructor(sections, /**
    @internal
    */ inserted){
        super(sections);
        this.inserted = inserted;
    }
    /**
    Apply the changes to a document, returning the modified
    document.
    */ apply(doc) {
        if (this.length != doc.length) throw new RangeError("Applying change set to a document with the wrong length");
        $ccfb9497d8ef598f$var$iterChanges(this, (fromA, toA, fromB, _toB, text)=>doc = doc.replace(fromB, fromB + (toA - fromA), text), false);
        return doc;
    }
    mapDesc(other, before = false) {
        return $ccfb9497d8ef598f$var$mapSet(this, other, before, true);
    }
    /**
    Given the document as it existed _before_ the changes, return a
    change set that represents the inverse of this set, which could
    be used to go from the document created by the changes back to
    the document as it existed before the changes.
    */ invert(doc) {
        let sections = this.sections.slice(), inserted = [];
        for(let i = 0, pos = 0; i < sections.length; i += 2){
            let len = sections[i], ins = sections[i + 1];
            if (ins >= 0) {
                sections[i] = ins;
                sections[i + 1] = len;
                let index = i >> 1;
                while(inserted.length < index)inserted.push($ccfb9497d8ef598f$export$5f1af8db9871e1d6.empty);
                inserted.push(len ? doc.slice(pos, pos + len) : $ccfb9497d8ef598f$export$5f1af8db9871e1d6.empty);
            }
            pos += len;
        }
        return new $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c(sections, inserted);
    }
    /**
    Combine two subsequent change sets into a single set. `other`
    must start in the document produced by `this`. If `this` goes
    `docA` → `docB` and `other` represents `docB` → `docC`, the
    returned value will represent the change `docA` → `docC`.
    */ compose(other) {
        return this.empty ? other : other.empty ? this : $ccfb9497d8ef598f$var$composeSets(this, other, true);
    }
    /**
    Given another change set starting in the same document, maps this
    change set over the other, producing a new change set that can be
    applied to the document produced by applying `other`. When
    `before` is `true`, order changes as if `this` comes before
    `other`, otherwise (the default) treat `other` as coming first.
    
    Given two changes `A` and `B`, `A.compose(B.map(A))` and
    `B.compose(A.map(B, true))` will produce the same document. This
    provides a basic form of [operational
    transformation](https://en.wikipedia.org/wiki/Operational_transformation),
    and can be used for collaborative editing.
    */ map(other, before = false) {
        return other.empty ? this : $ccfb9497d8ef598f$var$mapSet(this, other, before, true);
    }
    /**
    Iterate over the changed ranges in the document, calling `f` for
    each, with the range in the original document (`fromA`-`toA`)
    and the range that replaces it in the new document
    (`fromB`-`toB`).
    
    When `individual` is true, adjacent changes are reported
    separately.
    */ iterChanges(f, individual = false) {
        $ccfb9497d8ef598f$var$iterChanges(this, f, individual);
    }
    /**
    Get a [change description](https://codemirror.net/6/docs/ref/#state.ChangeDesc) for this change
    set.
    */ get desc() {
        return $ccfb9497d8ef598f$export$34b6a936f2bb06a2.create(this.sections);
    }
    /**
    @internal
    */ filter(ranges) {
        let resultSections = [], resultInserted = [], filteredSections = [];
        let iter = new $ccfb9497d8ef598f$var$SectionIter(this);
        done: for(let i = 0, pos = 0;;){
            let next = i == ranges.length ? 1e9 : ranges[i++];
            while(pos < next || pos == next && iter.len == 0){
                if (iter.done) break done;
                let len = Math.min(iter.len, next - pos);
                $ccfb9497d8ef598f$var$addSection(filteredSections, len, -1);
                let ins = iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0;
                $ccfb9497d8ef598f$var$addSection(resultSections, len, ins);
                if (ins > 0) $ccfb9497d8ef598f$var$addInsert(resultInserted, resultSections, iter.text);
                iter.forward(len);
                pos += len;
            }
            let end = ranges[i++];
            while(pos < end){
                if (iter.done) break done;
                let len = Math.min(iter.len, end - pos);
                $ccfb9497d8ef598f$var$addSection(resultSections, len, -1);
                $ccfb9497d8ef598f$var$addSection(filteredSections, len, iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0);
                iter.forward(len);
                pos += len;
            }
        }
        return {
            changes: new $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c(resultSections, resultInserted),
            filtered: $ccfb9497d8ef598f$export$34b6a936f2bb06a2.create(filteredSections)
        };
    }
    /**
    Serialize this change set to a JSON-representable value.
    */ toJSON() {
        let parts = [];
        for(let i = 0; i < this.sections.length; i += 2){
            let len = this.sections[i], ins = this.sections[i + 1];
            if (ins < 0) parts.push(len);
            else if (ins == 0) parts.push([
                len
            ]);
            else parts.push([
                len
            ].concat(this.inserted[i >> 1].toJSON()));
        }
        return parts;
    }
    /**
    Create a change set for the given changes, for a document of the
    given length, using `lineSep` as line separator.
    */ static of(changes, length, lineSep) {
        let sections = [], inserted = [], pos = 0;
        let total = null;
        function flush(force = false) {
            if (!force && !sections.length) return;
            if (pos < length) $ccfb9497d8ef598f$var$addSection(sections, length - pos, -1);
            let set = new $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c(sections, inserted);
            total = total ? total.compose(set.map(total)) : set;
            sections = [];
            inserted = [];
            pos = 0;
        }
        function process(spec) {
            if (Array.isArray(spec)) for (let sub of spec)process(sub);
            else if (spec instanceof $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c) {
                if (spec.length != length) throw new RangeError(`Mismatched change set length (got ${spec.length}, expected ${length})`);
                flush();
                total = total ? total.compose(spec.map(total)) : spec;
            } else {
                let { from: from, to: to = from, insert: insert } = spec;
                if (from > to || from < 0 || to > length) throw new RangeError(`Invalid change range ${from} to ${to} (in doc of length ${length})`);
                let insText = !insert ? $ccfb9497d8ef598f$export$5f1af8db9871e1d6.empty : typeof insert == "string" ? $ccfb9497d8ef598f$export$5f1af8db9871e1d6.of(insert.split(lineSep || $ccfb9497d8ef598f$var$DefaultSplit)) : insert;
                let insLen = insText.length;
                if (from == to && insLen == 0) return;
                if (from < pos) flush();
                if (from > pos) $ccfb9497d8ef598f$var$addSection(sections, from - pos, -1);
                $ccfb9497d8ef598f$var$addSection(sections, to - from, insLen);
                $ccfb9497d8ef598f$var$addInsert(inserted, sections, insText);
                pos = to;
            }
        }
        process(changes);
        flush(!total);
        return total;
    }
    /**
    Create an empty changeset of the given length.
    */ static empty(length) {
        return new $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c(length ? [
            length,
            -1
        ] : [], []);
    }
    /**
    Create a changeset from its JSON representation (as produced by
    [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeSet.toJSON).
    */ static fromJSON(json) {
        if (!Array.isArray(json)) throw new RangeError("Invalid JSON representation of ChangeSet");
        let sections = [], inserted = [];
        for(let i = 0; i < json.length; i++){
            let part = json[i];
            if (typeof part == "number") sections.push(part, -1);
            else if (!Array.isArray(part) || typeof part[0] != "number" || part.some((e, i)=>i && typeof e != "string")) throw new RangeError("Invalid JSON representation of ChangeSet");
            else if (part.length == 1) sections.push(part[0], 0);
            else {
                while(inserted.length < i)inserted.push($ccfb9497d8ef598f$export$5f1af8db9871e1d6.empty);
                inserted[i] = $ccfb9497d8ef598f$export$5f1af8db9871e1d6.of(part.slice(1));
                sections.push(part[0], inserted[i].length);
            }
        }
        return new $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c(sections, inserted);
    }
    /**
    @internal
    */ static createSet(sections, inserted) {
        return new $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c(sections, inserted);
    }
}
function $ccfb9497d8ef598f$var$addSection(sections, len, ins, forceJoin = false) {
    if (len == 0 && ins <= 0) return;
    let last = sections.length - 2;
    if (last >= 0 && ins <= 0 && ins == sections[last + 1]) sections[last] += len;
    else if (len == 0 && sections[last] == 0) sections[last + 1] += ins;
    else if (forceJoin) {
        sections[last] += len;
        sections[last + 1] += ins;
    } else sections.push(len, ins);
}
function $ccfb9497d8ef598f$var$addInsert(values, sections, value) {
    if (value.length == 0) return;
    let index = sections.length - 2 >> 1;
    if (index < values.length) values[values.length - 1] = values[values.length - 1].append(value);
    else {
        while(values.length < index)values.push($ccfb9497d8ef598f$export$5f1af8db9871e1d6.empty);
        values.push(value);
    }
}
function $ccfb9497d8ef598f$var$iterChanges(desc, f, individual) {
    let inserted = desc.inserted;
    for(let posA = 0, posB = 0, i = 0; i < desc.sections.length;){
        let len = desc.sections[i++], ins = desc.sections[i++];
        if (ins < 0) {
            posA += len;
            posB += len;
        } else {
            let endA = posA, endB = posB, text = $ccfb9497d8ef598f$export$5f1af8db9871e1d6.empty;
            for(;;){
                endA += len;
                endB += ins;
                if (ins && inserted) text = text.append(inserted[i - 2 >> 1]);
                if (individual || i == desc.sections.length || desc.sections[i + 1] < 0) break;
                len = desc.sections[i++];
                ins = desc.sections[i++];
            }
            f(posA, endA, posB, endB, text);
            posA = endA;
            posB = endB;
        }
    }
}
function $ccfb9497d8ef598f$var$mapSet(setA, setB, before, mkSet = false) {
    // Produce a copy of setA that applies to the document after setB
    // has been applied (assuming both start at the same document).
    let sections = [], insert = mkSet ? [] : null;
    let a = new $ccfb9497d8ef598f$var$SectionIter(setA), b = new $ccfb9497d8ef598f$var$SectionIter(setB);
    // Iterate over both sets in parallel. inserted tracks, for changes
    // in A that have to be processed piece-by-piece, whether their
    // content has been inserted already, and refers to the section
    // index.
    for(let inserted = -1;;){
        if (a.ins == -1 && b.ins == -1) {
            // Move across ranges skipped by both sets.
            let len = Math.min(a.len, b.len);
            $ccfb9497d8ef598f$var$addSection(sections, len, -1);
            a.forward(len);
            b.forward(len);
        } else if (b.ins >= 0 && (a.ins < 0 || inserted == a.i || a.off == 0 && (b.len < a.len || b.len == a.len && !before))) {
            // If there's a change in B that comes before the next change in
            // A (ordered by start pos, then len, then before flag), skip
            // that (and process any changes in A it covers).
            let len = b.len;
            $ccfb9497d8ef598f$var$addSection(sections, b.ins, -1);
            while(len){
                let piece = Math.min(a.len, len);
                if (a.ins >= 0 && inserted < a.i && a.len <= piece) {
                    $ccfb9497d8ef598f$var$addSection(sections, 0, a.ins);
                    if (insert) $ccfb9497d8ef598f$var$addInsert(insert, sections, a.text);
                    inserted = a.i;
                }
                a.forward(piece);
                len -= piece;
            }
            b.next();
        } else if (a.ins >= 0) {
            // Process the part of a change in A up to the start of the next
            // non-deletion change in B (if overlapping).
            let len = 0, left = a.len;
            while(left){
                if (b.ins == -1) {
                    let piece = Math.min(left, b.len);
                    len += piece;
                    left -= piece;
                    b.forward(piece);
                } else if (b.ins == 0 && b.len < left) {
                    left -= b.len;
                    b.next();
                } else break;
            }
            $ccfb9497d8ef598f$var$addSection(sections, len, inserted < a.i ? a.ins : 0);
            if (insert && inserted < a.i) $ccfb9497d8ef598f$var$addInsert(insert, sections, a.text);
            inserted = a.i;
            a.forward(a.len - left);
        } else if (a.done && b.done) return insert ? $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c.createSet(sections, insert) : $ccfb9497d8ef598f$export$34b6a936f2bb06a2.create(sections);
        else throw new Error("Mismatched change set lengths");
    }
}
function $ccfb9497d8ef598f$var$composeSets(setA, setB, mkSet = false) {
    let sections = [];
    let insert = mkSet ? [] : null;
    let a = new $ccfb9497d8ef598f$var$SectionIter(setA), b = new $ccfb9497d8ef598f$var$SectionIter(setB);
    for(let open = false;;){
        if (a.done && b.done) return insert ? $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c.createSet(sections, insert) : $ccfb9497d8ef598f$export$34b6a936f2bb06a2.create(sections);
        else if (a.ins == 0) {
            $ccfb9497d8ef598f$var$addSection(sections, a.len, 0, open);
            a.next();
        } else if (b.len == 0 && !b.done) {
            $ccfb9497d8ef598f$var$addSection(sections, 0, b.ins, open);
            if (insert) $ccfb9497d8ef598f$var$addInsert(insert, sections, b.text);
            b.next();
        } else if (a.done || b.done) throw new Error("Mismatched change set lengths");
        else {
            let len = Math.min(a.len2, b.len), sectionLen = sections.length;
            if (a.ins == -1) {
                let insB = b.ins == -1 ? -1 : b.off ? 0 : b.ins;
                $ccfb9497d8ef598f$var$addSection(sections, len, insB, open);
                if (insert && insB) $ccfb9497d8ef598f$var$addInsert(insert, sections, b.text);
            } else if (b.ins == -1) {
                $ccfb9497d8ef598f$var$addSection(sections, a.off ? 0 : a.len, len, open);
                if (insert) $ccfb9497d8ef598f$var$addInsert(insert, sections, a.textBit(len));
            } else {
                $ccfb9497d8ef598f$var$addSection(sections, a.off ? 0 : a.len, b.off ? 0 : b.ins, open);
                if (insert && !b.off) $ccfb9497d8ef598f$var$addInsert(insert, sections, b.text);
            }
            open = (a.ins > len || b.ins >= 0 && b.len > len) && (open || sections.length > sectionLen);
            a.forward2(len);
            b.forward(len);
        }
    }
}
class $ccfb9497d8ef598f$var$SectionIter {
    constructor(set){
        this.set = set;
        this.i = 0;
        this.next();
    }
    next() {
        let { sections: sections } = this.set;
        if (this.i < sections.length) {
            this.len = sections[this.i++];
            this.ins = sections[this.i++];
        } else {
            this.len = 0;
            this.ins = -2;
        }
        this.off = 0;
    }
    get done() {
        return this.ins == -2;
    }
    get len2() {
        return this.ins < 0 ? this.len : this.ins;
    }
    get text() {
        let { inserted: inserted } = this.set, index = this.i - 2 >> 1;
        return index >= inserted.length ? $ccfb9497d8ef598f$export$5f1af8db9871e1d6.empty : inserted[index];
    }
    textBit(len) {
        let { inserted: inserted } = this.set, index = this.i - 2 >> 1;
        return index >= inserted.length && !len ? $ccfb9497d8ef598f$export$5f1af8db9871e1d6.empty : inserted[index].slice(this.off, len == null ? undefined : this.off + len);
    }
    forward(len) {
        if (len == this.len) this.next();
        else {
            this.len -= len;
            this.off += len;
        }
    }
    forward2(len) {
        if (this.ins == -1) this.forward(len);
        else if (len == this.ins) this.next();
        else {
            this.ins -= len;
            this.off += len;
        }
    }
}
/**
A single selection range. When
[`allowMultipleSelections`](https://codemirror.net/6/docs/ref/#state.EditorState^allowMultipleSelections)
is enabled, a [selection](https://codemirror.net/6/docs/ref/#state.EditorSelection) may hold
multiple ranges. By default, selections hold exactly one range.
*/ class $ccfb9497d8ef598f$export$7bd1839c3c5d5bd4 {
    constructor(/**
    The lower boundary of the range.
    */ from, /**
    The upper boundary of the range.
    */ to, flags){
        this.from = from;
        this.to = to;
        this.flags = flags;
    }
    /**
    The anchor of the range—the side that doesn't move when you
    extend it.
    */ get anchor() {
        return this.flags & 16 /* RangeFlag.Inverted */  ? this.to : this.from;
    }
    /**
    The head of the range, which is moved when the range is
    [extended](https://codemirror.net/6/docs/ref/#state.SelectionRange.extend).
    */ get head() {
        return this.flags & 16 /* RangeFlag.Inverted */  ? this.from : this.to;
    }
    /**
    True when `anchor` and `head` are at the same position.
    */ get empty() {
        return this.from == this.to;
    }
    /**
    If this is a cursor that is explicitly associated with the
    character on one of its sides, this returns the side. -1 means
    the character before its position, 1 the character after, and 0
    means no association.
    */ get assoc() {
        return this.flags & 4 /* RangeFlag.AssocBefore */  ? -1 : this.flags & 8 /* RangeFlag.AssocAfter */  ? 1 : 0;
    }
    /**
    The bidirectional text level associated with this cursor, if
    any.
    */ get bidiLevel() {
        let level = this.flags & 3 /* RangeFlag.BidiLevelMask */ ;
        return level == 3 ? null : level;
    }
    /**
    The goal column (stored vertical offset) associated with a
    cursor. This is used to preserve the vertical position when
    [moving](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) across
    lines of different length.
    */ get goalColumn() {
        let value = this.flags >> 5 /* RangeFlag.GoalColumnOffset */ ;
        return value == 33554431 /* RangeFlag.NoGoalColumn */  ? undefined : value;
    }
    /**
    Map this range through a change, producing a valid range in the
    updated document.
    */ map(change, assoc = -1) {
        let from, to;
        if (this.empty) from = to = change.mapPos(this.from, assoc);
        else {
            from = change.mapPos(this.from, 1);
            to = change.mapPos(this.to, -1);
        }
        return from == this.from && to == this.to ? this : new $ccfb9497d8ef598f$export$7bd1839c3c5d5bd4(from, to, this.flags);
    }
    /**
    Extend this range to cover at least `from` to `to`.
    */ extend(from, to = from) {
        if (from <= this.anchor && to >= this.anchor) return $ccfb9497d8ef598f$export$3bb1bd44aee62999.range(from, to);
        let head = Math.abs(from - this.anchor) > Math.abs(to - this.anchor) ? from : to;
        return $ccfb9497d8ef598f$export$3bb1bd44aee62999.range(this.anchor, head);
    }
    /**
    Compare this range to another range.
    */ eq(other) {
        return this.anchor == other.anchor && this.head == other.head;
    }
    /**
    Return a JSON-serializable object representing the range.
    */ toJSON() {
        return {
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    Convert a JSON representation of a range to a `SelectionRange`
    instance.
    */ static fromJSON(json) {
        if (!json || typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid JSON representation for SelectionRange");
        return $ccfb9497d8ef598f$export$3bb1bd44aee62999.range(json.anchor, json.head);
    }
    /**
    @internal
    */ static create(from, to, flags) {
        return new $ccfb9497d8ef598f$export$7bd1839c3c5d5bd4(from, to, flags);
    }
}
/**
An editor selection holds one or more selection ranges.
*/ class $ccfb9497d8ef598f$export$3bb1bd44aee62999 {
    constructor(/**
    The ranges in the selection, sorted by position. Ranges cannot
    overlap (but they may touch, if they aren't empty).
    */ ranges, /**
    The index of the _main_ range in the selection (which is
    usually the range that was added last).
    */ mainIndex){
        this.ranges = ranges;
        this.mainIndex = mainIndex;
    }
    /**
    Map a selection through a change. Used to adjust the selection
    position for changes.
    */ map(change, assoc = -1) {
        if (change.empty) return this;
        return $ccfb9497d8ef598f$export$3bb1bd44aee62999.create(this.ranges.map((r)=>r.map(change, assoc)), this.mainIndex);
    }
    /**
    Compare this selection to another selection.
    */ eq(other) {
        if (this.ranges.length != other.ranges.length || this.mainIndex != other.mainIndex) return false;
        for(let i = 0; i < this.ranges.length; i++)if (!this.ranges[i].eq(other.ranges[i])) return false;
        return true;
    }
    /**
    Get the primary selection range. Usually, you should make sure
    your code applies to _all_ ranges, by using methods like
    [`changeByRange`](https://codemirror.net/6/docs/ref/#state.EditorState.changeByRange).
    */ get main() {
        return this.ranges[this.mainIndex];
    }
    /**
    Make sure the selection only has one range. Returns a selection
    holding only the main range from this selection.
    */ asSingle() {
        return this.ranges.length == 1 ? this : new $ccfb9497d8ef598f$export$3bb1bd44aee62999([
            this.main
        ], 0);
    }
    /**
    Extend this selection with an extra range.
    */ addRange(range, main = true) {
        return $ccfb9497d8ef598f$export$3bb1bd44aee62999.create([
            range
        ].concat(this.ranges), main ? 0 : this.mainIndex + 1);
    }
    /**
    Replace a given range with another range, and then normalize the
    selection to merge and sort ranges if necessary.
    */ replaceRange(range, which = this.mainIndex) {
        let ranges = this.ranges.slice();
        ranges[which] = range;
        return $ccfb9497d8ef598f$export$3bb1bd44aee62999.create(ranges, this.mainIndex);
    }
    /**
    Convert this selection to an object that can be serialized to
    JSON.
    */ toJSON() {
        return {
            ranges: this.ranges.map((r)=>r.toJSON()),
            main: this.mainIndex
        };
    }
    /**
    Create a selection from a JSON representation.
    */ static fromJSON(json) {
        if (!json || !Array.isArray(json.ranges) || typeof json.main != "number" || json.main >= json.ranges.length) throw new RangeError("Invalid JSON representation for EditorSelection");
        return new $ccfb9497d8ef598f$export$3bb1bd44aee62999(json.ranges.map((r)=>$ccfb9497d8ef598f$export$7bd1839c3c5d5bd4.fromJSON(r)), json.main);
    }
    /**
    Create a selection holding a single range.
    */ static single(anchor, head = anchor) {
        return new $ccfb9497d8ef598f$export$3bb1bd44aee62999([
            $ccfb9497d8ef598f$export$3bb1bd44aee62999.range(anchor, head)
        ], 0);
    }
    /**
    Sort and merge the given set of ranges, creating a valid
    selection.
    */ static create(ranges, mainIndex = 0) {
        if (ranges.length == 0) throw new RangeError("A selection needs at least one range");
        for(let pos = 0, i = 0; i < ranges.length; i++){
            let range = ranges[i];
            if (range.empty ? range.from <= pos : range.from < pos) return $ccfb9497d8ef598f$export$3bb1bd44aee62999.normalized(ranges.slice(), mainIndex);
            pos = range.to;
        }
        return new $ccfb9497d8ef598f$export$3bb1bd44aee62999(ranges, mainIndex);
    }
    /**
    Create a cursor selection range at the given position. You can
    safely ignore the optional arguments in most situations.
    */ static cursor(pos, assoc = 0, bidiLevel, goalColumn) {
        return $ccfb9497d8ef598f$export$7bd1839c3c5d5bd4.create(pos, pos, (assoc == 0 ? 0 : assoc < 0 ? 4 /* RangeFlag.AssocBefore */  : 8 /* RangeFlag.AssocAfter */ ) | (bidiLevel == null ? 3 : Math.min(2, bidiLevel)) | (goalColumn !== null && goalColumn !== void 0 ? goalColumn : 33554431 /* RangeFlag.NoGoalColumn */ ) << 5 /* RangeFlag.GoalColumnOffset */ );
    }
    /**
    Create a selection range.
    */ static range(anchor, head, goalColumn, bidiLevel) {
        let flags = (goalColumn !== null && goalColumn !== void 0 ? goalColumn : 33554431 /* RangeFlag.NoGoalColumn */ ) << 5 /* RangeFlag.GoalColumnOffset */  | (bidiLevel == null ? 3 : Math.min(2, bidiLevel));
        return head < anchor ? $ccfb9497d8ef598f$export$7bd1839c3c5d5bd4.create(head, anchor, 24 /* RangeFlag.AssocAfter */  | flags) : $ccfb9497d8ef598f$export$7bd1839c3c5d5bd4.create(anchor, head, (head > anchor ? 4 /* RangeFlag.AssocBefore */  : 0) | flags);
    }
    /**
    @internal
    */ static normalized(ranges, mainIndex = 0) {
        let main = ranges[mainIndex];
        ranges.sort((a, b)=>a.from - b.from);
        mainIndex = ranges.indexOf(main);
        for(let i = 1; i < ranges.length; i++){
            let range = ranges[i], prev = ranges[i - 1];
            if (range.empty ? range.from <= prev.to : range.from < prev.to) {
                let from = prev.from, to = Math.max(range.to, prev.to);
                if (i <= mainIndex) mainIndex--;
                ranges.splice(--i, 2, range.anchor > range.head ? $ccfb9497d8ef598f$export$3bb1bd44aee62999.range(to, from) : $ccfb9497d8ef598f$export$3bb1bd44aee62999.range(from, to));
            }
        }
        return new $ccfb9497d8ef598f$export$3bb1bd44aee62999(ranges, mainIndex);
    }
}
function $ccfb9497d8ef598f$var$checkSelection(selection, docLength) {
    for (let range of selection.ranges)if (range.to > docLength) throw new RangeError("Selection points outside of document");
}
let $ccfb9497d8ef598f$var$nextID = 0;
/**
A facet is a labeled value that is associated with an editor
state. It takes inputs from any number of extensions, and combines
those into a single output value.

Examples of uses of facets are the [tab
size](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize), [editor
attributes](https://codemirror.net/6/docs/ref/#view.EditorView^editorAttributes), and [update
listeners](https://codemirror.net/6/docs/ref/#view.EditorView^updateListener).
*/ class $ccfb9497d8ef598f$export$ef7d5e9b79fa1504 {
    constructor(/**
    @internal
    */ combine, /**
    @internal
    */ compareInput, /**
    @internal
    */ compare, isStatic, enables){
        this.combine = combine;
        this.compareInput = compareInput;
        this.compare = compare;
        this.isStatic = isStatic;
        /**
        @internal
        */ this.id = $ccfb9497d8ef598f$var$nextID++;
        this.default = combine([]);
        this.extensions = typeof enables == "function" ? enables(this) : enables;
    }
    /**
    Define a new facet.
    */ static define(config = {}) {
        return new $ccfb9497d8ef598f$export$ef7d5e9b79fa1504(config.combine || ((a)=>a), config.compareInput || ((a, b)=>a === b), config.compare || (!config.combine ? $ccfb9497d8ef598f$var$sameArray : (a, b)=>a === b), !!config.static, config.enables);
    }
    /**
    Returns an extension that adds the given value to this facet.
    */ of(value) {
        return new $ccfb9497d8ef598f$var$FacetProvider([], this, 0 /* Provider.Static */ , value);
    }
    /**
    Create an extension that computes a value for the facet from a
    state. You must take care to declare the parts of the state that
    this value depends on, since your function is only called again
    for a new state when one of those parts changed.
    
    In cases where your value depends only on a single field, you'll
    want to use the [`from`](https://codemirror.net/6/docs/ref/#state.Facet.from) method instead.
    */ compute(deps, get) {
        if (this.isStatic) throw new Error("Can't compute a static facet");
        return new $ccfb9497d8ef598f$var$FacetProvider(deps, this, 1 /* Provider.Single */ , get);
    }
    /**
    Create an extension that computes zero or more values for this
    facet from a state.
    */ computeN(deps, get) {
        if (this.isStatic) throw new Error("Can't compute a static facet");
        return new $ccfb9497d8ef598f$var$FacetProvider(deps, this, 2 /* Provider.Multi */ , get);
    }
    from(field, get) {
        if (!get) get = (x)=>x;
        return this.compute([
            field
        ], (state)=>get(state.field(field)));
    }
}
function $ccfb9497d8ef598f$var$sameArray(a, b) {
    return a == b || a.length == b.length && a.every((e, i)=>e === b[i]);
}
class $ccfb9497d8ef598f$var$FacetProvider {
    constructor(dependencies, facet, type, value){
        this.dependencies = dependencies;
        this.facet = facet;
        this.type = type;
        this.value = value;
        this.id = $ccfb9497d8ef598f$var$nextID++;
    }
    dynamicSlot(addresses) {
        var _a;
        let getter = this.value;
        let compare = this.facet.compareInput;
        let id = this.id, idx = addresses[id] >> 1, multi = this.type == 2 /* Provider.Multi */ ;
        let depDoc = false, depSel = false, depAddrs = [];
        for (let dep of this.dependencies){
            if (dep == "doc") depDoc = true;
            else if (dep == "selection") depSel = true;
            else if ((((_a = addresses[dep.id]) !== null && _a !== void 0 ? _a : 1) & 1) == 0) depAddrs.push(addresses[dep.id]);
        }
        return {
            create (state) {
                state.values[idx] = getter(state);
                return 1 /* SlotStatus.Changed */ ;
            },
            update (state, tr) {
                if (depDoc && tr.docChanged || depSel && (tr.docChanged || tr.selection) || $ccfb9497d8ef598f$var$ensureAll(state, depAddrs)) {
                    let newVal = getter(state);
                    if (multi ? !$ccfb9497d8ef598f$var$compareArray(newVal, state.values[idx], compare) : !compare(newVal, state.values[idx])) {
                        state.values[idx] = newVal;
                        return 1 /* SlotStatus.Changed */ ;
                    }
                }
                return 0;
            },
            reconfigure: (state, oldState)=>{
                let newVal, oldAddr = oldState.config.address[id];
                if (oldAddr != null) {
                    let oldVal = $ccfb9497d8ef598f$var$getAddr(oldState, oldAddr);
                    if (this.dependencies.every((dep)=>{
                        return dep instanceof $ccfb9497d8ef598f$export$ef7d5e9b79fa1504 ? oldState.facet(dep) === state.facet(dep) : dep instanceof $ccfb9497d8ef598f$export$34381b1ce2130245 ? oldState.field(dep, false) == state.field(dep, false) : true;
                    }) || (multi ? $ccfb9497d8ef598f$var$compareArray(newVal = getter(state), oldVal, compare) : compare(newVal = getter(state), oldVal))) {
                        state.values[idx] = oldVal;
                        return 0;
                    }
                } else newVal = getter(state);
                state.values[idx] = newVal;
                return 1 /* SlotStatus.Changed */ ;
            }
        };
    }
}
function $ccfb9497d8ef598f$var$compareArray(a, b, compare) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!compare(a[i], b[i])) return false;
    return true;
}
function $ccfb9497d8ef598f$var$ensureAll(state, addrs) {
    let changed = false;
    for (let addr of addrs)if ($ccfb9497d8ef598f$var$ensureAddr(state, addr) & 1 /* SlotStatus.Changed */ ) changed = true;
    return changed;
}
function $ccfb9497d8ef598f$var$dynamicFacetSlot(addresses, facet, providers) {
    let providerAddrs = providers.map((p)=>addresses[p.id]);
    let providerTypes = providers.map((p)=>p.type);
    let dynamic = providerAddrs.filter((p)=>!(p & 1));
    let idx = addresses[facet.id] >> 1;
    function get(state) {
        let values = [];
        for(let i = 0; i < providerAddrs.length; i++){
            let value = $ccfb9497d8ef598f$var$getAddr(state, providerAddrs[i]);
            if (providerTypes[i] == 2 /* Provider.Multi */ ) for (let val of value)values.push(val);
            else values.push(value);
        }
        return facet.combine(values);
    }
    return {
        create (state) {
            for (let addr of providerAddrs)$ccfb9497d8ef598f$var$ensureAddr(state, addr);
            state.values[idx] = get(state);
            return 1 /* SlotStatus.Changed */ ;
        },
        update (state, tr) {
            if (!$ccfb9497d8ef598f$var$ensureAll(state, dynamic)) return 0;
            let value = get(state);
            if (facet.compare(value, state.values[idx])) return 0;
            state.values[idx] = value;
            return 1 /* SlotStatus.Changed */ ;
        },
        reconfigure (state, oldState) {
            let depChanged = $ccfb9497d8ef598f$var$ensureAll(state, providerAddrs);
            let oldProviders = oldState.config.facets[facet.id], oldValue = oldState.facet(facet);
            if (oldProviders && !depChanged && $ccfb9497d8ef598f$var$sameArray(providers, oldProviders)) {
                state.values[idx] = oldValue;
                return 0;
            }
            let value = get(state);
            if (facet.compare(value, oldValue)) {
                state.values[idx] = oldValue;
                return 0;
            }
            state.values[idx] = value;
            return 1 /* SlotStatus.Changed */ ;
        }
    };
}
const $ccfb9497d8ef598f$var$initField = /*@__PURE__*/ $ccfb9497d8ef598f$export$ef7d5e9b79fa1504.define({
    static: true
});
/**
Fields can store additional information in an editor state, and
keep it in sync with the rest of the state.
*/ class $ccfb9497d8ef598f$export$34381b1ce2130245 {
    constructor(/**
    @internal
    */ id, createF, updateF, compareF, /**
    @internal
    */ spec){
        this.id = id;
        this.createF = createF;
        this.updateF = updateF;
        this.compareF = compareF;
        this.spec = spec;
        /**
        @internal
        */ this.provides = undefined;
    }
    /**
    Define a state field.
    */ static define(config) {
        let field = new $ccfb9497d8ef598f$export$34381b1ce2130245($ccfb9497d8ef598f$var$nextID++, config.create, config.update, config.compare || ((a, b)=>a === b), config);
        if (config.provide) field.provides = config.provide(field);
        return field;
    }
    create(state) {
        let init = state.facet($ccfb9497d8ef598f$var$initField).find((i)=>i.field == this);
        return ((init === null || init === void 0 ? void 0 : init.create) || this.createF)(state);
    }
    /**
    @internal
    */ slot(addresses) {
        let idx = addresses[this.id] >> 1;
        return {
            create: (state)=>{
                state.values[idx] = this.create(state);
                return 1 /* SlotStatus.Changed */ ;
            },
            update: (state, tr)=>{
                let oldVal = state.values[idx];
                let value = this.updateF(oldVal, tr);
                if (this.compareF(oldVal, value)) return 0;
                state.values[idx] = value;
                return 1 /* SlotStatus.Changed */ ;
            },
            reconfigure: (state, oldState)=>{
                if (oldState.config.address[this.id] != null) {
                    state.values[idx] = oldState.field(this);
                    return 0;
                }
                state.values[idx] = this.create(state);
                return 1 /* SlotStatus.Changed */ ;
            }
        };
    }
    /**
    Returns an extension that enables this field and overrides the
    way it is initialized. Can be useful when you need to provide a
    non-default starting value for the field.
    */ init(create) {
        return [
            this,
            $ccfb9497d8ef598f$var$initField.of({
                field: this,
                create: create
            })
        ];
    }
    /**
    State field instances can be used as
    [`Extension`](https://codemirror.net/6/docs/ref/#state.Extension) values to enable the field in a
    given state.
    */ get extension() {
        return this;
    }
}
const $ccfb9497d8ef598f$var$Prec_ = {
    lowest: 4,
    low: 3,
    default: 2,
    high: 1,
    highest: 0
};
function $ccfb9497d8ef598f$var$prec(value) {
    return (ext)=>new $ccfb9497d8ef598f$var$PrecExtension(ext, value);
}
/**
By default extensions are registered in the order they are found
in the flattened form of nested array that was provided.
Individual extension values can be assigned a precedence to
override this. Extensions that do not have a precedence set get
the precedence of the nearest parent with a precedence, or
[`default`](https://codemirror.net/6/docs/ref/#state.Prec.default) if there is no such parent. The
final ordering of extensions is determined by first sorting by
precedence and then by order within each precedence.
*/ const $ccfb9497d8ef598f$export$b92464a736444411 = {
    /**
    The highest precedence level, for extensions that should end up
    near the start of the precedence ordering.
    */ highest: /*@__PURE__*/ $ccfb9497d8ef598f$var$prec($ccfb9497d8ef598f$var$Prec_.highest),
    /**
    A higher-than-default precedence, for extensions that should
    come before those with default precedence.
    */ high: /*@__PURE__*/ $ccfb9497d8ef598f$var$prec($ccfb9497d8ef598f$var$Prec_.high),
    /**
    The default precedence, which is also used for extensions
    without an explicit precedence.
    */ default: /*@__PURE__*/ $ccfb9497d8ef598f$var$prec($ccfb9497d8ef598f$var$Prec_.default),
    /**
    A lower-than-default precedence.
    */ low: /*@__PURE__*/ $ccfb9497d8ef598f$var$prec($ccfb9497d8ef598f$var$Prec_.low),
    /**
    The lowest precedence level. Meant for things that should end up
    near the end of the extension order.
    */ lowest: /*@__PURE__*/ $ccfb9497d8ef598f$var$prec($ccfb9497d8ef598f$var$Prec_.lowest)
};
class $ccfb9497d8ef598f$var$PrecExtension {
    constructor(inner, prec){
        this.inner = inner;
        this.prec = prec;
    }
}
/**
Extension compartments can be used to make a configuration
dynamic. By [wrapping](https://codemirror.net/6/docs/ref/#state.Compartment.of) part of your
configuration in a compartment, you can later
[replace](https://codemirror.net/6/docs/ref/#state.Compartment.reconfigure) that part through a
transaction.
*/ class $ccfb9497d8ef598f$export$d51c0172eb2c2431 {
    /**
    Create an instance of this compartment to add to your [state
    configuration](https://codemirror.net/6/docs/ref/#state.EditorStateConfig.extensions).
    */ of(ext) {
        return new $ccfb9497d8ef598f$var$CompartmentInstance(this, ext);
    }
    /**
    Create an [effect](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) that
    reconfigures this compartment.
    */ reconfigure(content) {
        return $ccfb9497d8ef598f$export$d51c0172eb2c2431.reconfigure.of({
            compartment: this,
            extension: content
        });
    }
    /**
    Get the current content of the compartment in the state, or
    `undefined` if it isn't present.
    */ get(state) {
        return state.config.compartments.get(this);
    }
}
class $ccfb9497d8ef598f$var$CompartmentInstance {
    constructor(compartment, inner){
        this.compartment = compartment;
        this.inner = inner;
    }
}
class $ccfb9497d8ef598f$var$Configuration {
    constructor(base, compartments, dynamicSlots, address, staticValues, facets){
        this.base = base;
        this.compartments = compartments;
        this.dynamicSlots = dynamicSlots;
        this.address = address;
        this.staticValues = staticValues;
        this.facets = facets;
        this.statusTemplate = [];
        while(this.statusTemplate.length < dynamicSlots.length)this.statusTemplate.push(0 /* SlotStatus.Unresolved */ );
    }
    staticFacet(facet) {
        let addr = this.address[facet.id];
        return addr == null ? facet.default : this.staticValues[addr >> 1];
    }
    static resolve(base, compartments, oldState) {
        let fields = [];
        let facets = Object.create(null);
        let newCompartments = new Map();
        for (let ext of $ccfb9497d8ef598f$var$flatten(base, compartments, newCompartments))if (ext instanceof $ccfb9497d8ef598f$export$34381b1ce2130245) fields.push(ext);
        else (facets[ext.facet.id] || (facets[ext.facet.id] = [])).push(ext);
        let address = Object.create(null);
        let staticValues = [];
        let dynamicSlots = [];
        for (let field of fields){
            address[field.id] = dynamicSlots.length << 1;
            dynamicSlots.push((a)=>field.slot(a));
        }
        let oldFacets = oldState === null || oldState === void 0 ? void 0 : oldState.config.facets;
        for(let id in facets){
            let providers = facets[id], facet = providers[0].facet;
            let oldProviders = oldFacets && oldFacets[id] || [];
            if (providers.every((p)=>p.type == 0 /* Provider.Static */ )) {
                address[facet.id] = staticValues.length << 1 | 1;
                if ($ccfb9497d8ef598f$var$sameArray(oldProviders, providers)) staticValues.push(oldState.facet(facet));
                else {
                    let value = facet.combine(providers.map((p)=>p.value));
                    staticValues.push(oldState && facet.compare(value, oldState.facet(facet)) ? oldState.facet(facet) : value);
                }
            } else {
                for (let p of providers)if (p.type == 0 /* Provider.Static */ ) {
                    address[p.id] = staticValues.length << 1 | 1;
                    staticValues.push(p.value);
                } else {
                    address[p.id] = dynamicSlots.length << 1;
                    dynamicSlots.push((a)=>p.dynamicSlot(a));
                }
                address[facet.id] = dynamicSlots.length << 1;
                dynamicSlots.push((a)=>$ccfb9497d8ef598f$var$dynamicFacetSlot(a, facet, providers));
            }
        }
        let dynamic = dynamicSlots.map((f)=>f(address));
        return new $ccfb9497d8ef598f$var$Configuration(base, newCompartments, dynamic, address, staticValues, facets);
    }
}
function $ccfb9497d8ef598f$var$flatten(extension, compartments, newCompartments) {
    let result = [
        [],
        [],
        [],
        [],
        []
    ];
    let seen = new Map();
    function inner(ext, prec) {
        let known = seen.get(ext);
        if (known != null) {
            if (known <= prec) return;
            let found = result[known].indexOf(ext);
            if (found > -1) result[known].splice(found, 1);
            if (ext instanceof $ccfb9497d8ef598f$var$CompartmentInstance) newCompartments.delete(ext.compartment);
        }
        seen.set(ext, prec);
        if (Array.isArray(ext)) for (let e of ext)inner(e, prec);
        else if (ext instanceof $ccfb9497d8ef598f$var$CompartmentInstance) {
            if (newCompartments.has(ext.compartment)) throw new RangeError(`Duplicate use of compartment in extensions`);
            let content = compartments.get(ext.compartment) || ext.inner;
            newCompartments.set(ext.compartment, content);
            inner(content, prec);
        } else if (ext instanceof $ccfb9497d8ef598f$var$PrecExtension) inner(ext.inner, ext.prec);
        else if (ext instanceof $ccfb9497d8ef598f$export$34381b1ce2130245) {
            result[prec].push(ext);
            if (ext.provides) inner(ext.provides, prec);
        } else if (ext instanceof $ccfb9497d8ef598f$var$FacetProvider) {
            result[prec].push(ext);
            if (ext.facet.extensions) inner(ext.facet.extensions, $ccfb9497d8ef598f$var$Prec_.default);
        } else {
            let content = ext.extension;
            if (!content) throw new Error(`Unrecognized extension value in extension set (${ext}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
            inner(content, prec);
        }
    }
    inner(extension, $ccfb9497d8ef598f$var$Prec_.default);
    return result.reduce((a, b)=>a.concat(b));
}
function $ccfb9497d8ef598f$var$ensureAddr(state, addr) {
    if (addr & 1) return 2 /* SlotStatus.Computed */ ;
    let idx = addr >> 1;
    let status = state.status[idx];
    if (status == 4 /* SlotStatus.Computing */ ) throw new Error("Cyclic dependency between fields and/or facets");
    if (status & 2 /* SlotStatus.Computed */ ) return status;
    state.status[idx] = 4 /* SlotStatus.Computing */ ;
    let changed = state.computeSlot(state, state.config.dynamicSlots[idx]);
    return state.status[idx] = 2 /* SlotStatus.Computed */  | changed;
}
function $ccfb9497d8ef598f$var$getAddr(state, addr) {
    return addr & 1 ? state.config.staticValues[addr >> 1] : state.values[addr >> 1];
}
const $ccfb9497d8ef598f$var$languageData = /*@__PURE__*/ $ccfb9497d8ef598f$export$ef7d5e9b79fa1504.define();
const $ccfb9497d8ef598f$var$allowMultipleSelections = /*@__PURE__*/ $ccfb9497d8ef598f$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.some((v)=>v),
    static: true
});
const $ccfb9497d8ef598f$var$lineSeparator = /*@__PURE__*/ $ccfb9497d8ef598f$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : undefined,
    static: true
});
const $ccfb9497d8ef598f$var$changeFilter = /*@__PURE__*/ $ccfb9497d8ef598f$export$ef7d5e9b79fa1504.define();
const $ccfb9497d8ef598f$var$transactionFilter = /*@__PURE__*/ $ccfb9497d8ef598f$export$ef7d5e9b79fa1504.define();
const $ccfb9497d8ef598f$var$transactionExtender = /*@__PURE__*/ $ccfb9497d8ef598f$export$ef7d5e9b79fa1504.define();
const $ccfb9497d8ef598f$var$readOnly = /*@__PURE__*/ $ccfb9497d8ef598f$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : false
});
/**
Annotations are tagged values that are used to add metadata to
transactions in an extensible way. They should be used to model
things that effect the entire transaction (such as its [time
stamp](https://codemirror.net/6/docs/ref/#state.Transaction^time) or information about its
[origin](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent)). For effects that happen
_alongside_ the other changes made by the transaction, [state
effects](https://codemirror.net/6/docs/ref/#state.StateEffect) are more appropriate.
*/ class $ccfb9497d8ef598f$export$9279461326b8700a {
    /**
    @internal
    */ constructor(/**
    The annotation type.
    */ type, /**
    The value of this annotation.
    */ value){
        this.type = type;
        this.value = value;
    }
    /**
    Define a new type of annotation.
    */ static define() {
        return new $ccfb9497d8ef598f$export$f50c3066a53a6f2c();
    }
}
/**
Marker that identifies a type of [annotation](https://codemirror.net/6/docs/ref/#state.Annotation).
*/ class $ccfb9497d8ef598f$export$f50c3066a53a6f2c {
    /**
    Create an instance of this annotation.
    */ of(value) {
        return new $ccfb9497d8ef598f$export$9279461326b8700a(this, value);
    }
}
/**
Representation of a type of state effect. Defined with
[`StateEffect.define`](https://codemirror.net/6/docs/ref/#state.StateEffect^define).
*/ class $ccfb9497d8ef598f$export$e41ff6bd17cc4417 {
    /**
    @internal
    */ constructor(// The `any` types in these function types are there to work
    // around TypeScript issue #37631, where the type guard on
    // `StateEffect.is` mysteriously stops working when these properly
    // have type `Value`.
    /**
    @internal
    */ map){
        this.map = map;
    }
    /**
    Create a [state effect](https://codemirror.net/6/docs/ref/#state.StateEffect) instance of this
    type.
    */ of(value) {
        return new $ccfb9497d8ef598f$export$95000d4efaa4321f(this, value);
    }
}
/**
State effects can be used to represent additional effects
associated with a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction.effects). They
are often useful to model changes to custom [state
fields](https://codemirror.net/6/docs/ref/#state.StateField), when those changes aren't implicit in
document or selection changes.
*/ class $ccfb9497d8ef598f$export$95000d4efaa4321f {
    /**
    @internal
    */ constructor(/**
    @internal
    */ type, /**
    The value of this effect.
    */ value){
        this.type = type;
        this.value = value;
    }
    /**
    Map this effect through a position mapping. Will return
    `undefined` when that ends up deleting the effect.
    */ map(mapping) {
        let mapped = this.type.map(this.value, mapping);
        return mapped === undefined ? undefined : mapped == this.value ? this : new $ccfb9497d8ef598f$export$95000d4efaa4321f(this.type, mapped);
    }
    /**
    Tells you whether this effect object is of a given
    [type](https://codemirror.net/6/docs/ref/#state.StateEffectType).
    */ is(type) {
        return this.type == type;
    }
    /**
    Define a new effect type. The type parameter indicates the type
    of values that his effect holds. It should be a type that
    doesn't include `undefined`, since that is used in
    [mapping](https://codemirror.net/6/docs/ref/#state.StateEffect.map) to indicate that an effect is
    removed.
    */ static define(spec = {}) {
        return new $ccfb9497d8ef598f$export$e41ff6bd17cc4417(spec.map || ((v)=>v));
    }
    /**
    Map an array of effects through a change set.
    */ static mapEffects(effects, mapping) {
        if (!effects.length) return effects;
        let result = [];
        for (let effect of effects){
            let mapped = effect.map(mapping);
            if (mapped) result.push(mapped);
        }
        return result;
    }
}
/**
This effect can be used to reconfigure the root extensions of
the editor. Doing this will discard any extensions
[appended](https://codemirror.net/6/docs/ref/#state.StateEffect^appendConfig), but does not reset
the content of [reconfigured](https://codemirror.net/6/docs/ref/#state.Compartment.reconfigure)
compartments.
*/ $ccfb9497d8ef598f$export$95000d4efaa4321f.reconfigure = /*@__PURE__*/ $ccfb9497d8ef598f$export$95000d4efaa4321f.define();
/**
Append extensions to the top-level configuration of the editor.
*/ $ccfb9497d8ef598f$export$95000d4efaa4321f.appendConfig = /*@__PURE__*/ $ccfb9497d8ef598f$export$95000d4efaa4321f.define();
/**
Changes to the editor state are grouped into transactions.
Typically, a user action creates a single transaction, which may
contain any number of document changes, may change the selection,
or have other effects. Create a transaction by calling
[`EditorState.update`](https://codemirror.net/6/docs/ref/#state.EditorState.update), or immediately
dispatch one by calling
[`EditorView.dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch).
*/ class $ccfb9497d8ef598f$export$febc5573c75cefb0 {
    constructor(/**
    The state from which the transaction starts.
    */ startState, /**
    The document changes made by this transaction.
    */ changes, /**
    The selection set by this transaction, or undefined if it
    doesn't explicitly set a selection.
    */ selection, /**
    The effects added to the transaction.
    */ effects, /**
    @internal
    */ annotations, /**
    Whether the selection should be scrolled into view after this
    transaction is dispatched.
    */ scrollIntoView){
        this.startState = startState;
        this.changes = changes;
        this.selection = selection;
        this.effects = effects;
        this.annotations = annotations;
        this.scrollIntoView = scrollIntoView;
        /**
        @internal
        */ this._doc = null;
        /**
        @internal
        */ this._state = null;
        if (selection) $ccfb9497d8ef598f$var$checkSelection(selection, changes.newLength);
        if (!annotations.some((a)=>a.type == $ccfb9497d8ef598f$export$febc5573c75cefb0.time)) this.annotations = annotations.concat($ccfb9497d8ef598f$export$febc5573c75cefb0.time.of(Date.now()));
    }
    /**
    @internal
    */ static create(startState, changes, selection, effects, annotations, scrollIntoView) {
        return new $ccfb9497d8ef598f$export$febc5573c75cefb0(startState, changes, selection, effects, annotations, scrollIntoView);
    }
    /**
    The new document produced by the transaction. Contrary to
    [`.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state)`.doc`, accessing this won't
    force the entire new state to be computed right away, so it is
    recommended that [transaction
    filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) use this getter
    when they need to look at the new document.
    */ get newDoc() {
        return this._doc || (this._doc = this.changes.apply(this.startState.doc));
    }
    /**
    The new selection produced by the transaction. If
    [`this.selection`](https://codemirror.net/6/docs/ref/#state.Transaction.selection) is undefined,
    this will [map](https://codemirror.net/6/docs/ref/#state.EditorSelection.map) the start state's
    current selection through the changes made by the transaction.
    */ get newSelection() {
        return this.selection || this.startState.selection.map(this.changes);
    }
    /**
    The new state created by the transaction. Computed on demand
    (but retained for subsequent access), so it is recommended not to
    access it in [transaction
    filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) when possible.
    */ get state() {
        if (!this._state) this.startState.applyTransaction(this);
        return this._state;
    }
    /**
    Get the value of the given annotation type, if any.
    */ annotation(type) {
        for (let ann of this.annotations)if (ann.type == type) return ann.value;
        return undefined;
    }
    /**
    Indicates whether the transaction changed the document.
    */ get docChanged() {
        return !this.changes.empty;
    }
    /**
    Indicates whether this transaction reconfigures the state
    (through a [configuration compartment](https://codemirror.net/6/docs/ref/#state.Compartment) or
    with a top-level configuration
    [effect](https://codemirror.net/6/docs/ref/#state.StateEffect^reconfigure).
    */ get reconfigured() {
        return this.startState.config != this.state.config;
    }
    /**
    Returns true if the transaction has a [user
    event](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent) annotation that is equal to
    or more specific than `event`. For example, if the transaction
    has `"select.pointer"` as user event, `"select"` and
    `"select.pointer"` will match it.
    */ isUserEvent(event) {
        let e = this.annotation($ccfb9497d8ef598f$export$febc5573c75cefb0.userEvent);
        return !!(e && (e == event || e.length > event.length && e.slice(0, event.length) == event && e[event.length] == "."));
    }
}
/**
Annotation used to store transaction timestamps. Automatically
added to every transaction, holding `Date.now()`.
*/ $ccfb9497d8ef598f$export$febc5573c75cefb0.time = /*@__PURE__*/ $ccfb9497d8ef598f$export$9279461326b8700a.define();
/**
Annotation used to associate a transaction with a user interface
event. Holds a string identifying the event, using a
dot-separated format to support attaching more specific
information. The events used by the core libraries are:

 - `"input"` when content is entered
   - `"input.type"` for typed input
     - `"input.type.compose"` for composition
   - `"input.paste"` for pasted input
   - `"input.drop"` when adding content with drag-and-drop
   - `"input.complete"` when autocompleting
 - `"delete"` when the user deletes content
   - `"delete.selection"` when deleting the selection
   - `"delete.forward"` when deleting forward from the selection
   - `"delete.backward"` when deleting backward from the selection
   - `"delete.cut"` when cutting to the clipboard
 - `"move"` when content is moved
   - `"move.drop"` when content is moved within the editor through drag-and-drop
 - `"select"` when explicitly changing the selection
   - `"select.pointer"` when selecting with a mouse or other pointing device
 - `"undo"` and `"redo"` for history actions

Use [`isUserEvent`](https://codemirror.net/6/docs/ref/#state.Transaction.isUserEvent) to check
whether the annotation matches a given event.
*/ $ccfb9497d8ef598f$export$febc5573c75cefb0.userEvent = /*@__PURE__*/ $ccfb9497d8ef598f$export$9279461326b8700a.define();
/**
Annotation indicating whether a transaction should be added to
the undo history or not.
*/ $ccfb9497d8ef598f$export$febc5573c75cefb0.addToHistory = /*@__PURE__*/ $ccfb9497d8ef598f$export$9279461326b8700a.define();
/**
Annotation indicating (when present and true) that a transaction
represents a change made by some other actor, not the user. This
is used, for example, to tag other people's changes in
collaborative editing.
*/ $ccfb9497d8ef598f$export$febc5573c75cefb0.remote = /*@__PURE__*/ $ccfb9497d8ef598f$export$9279461326b8700a.define();
function $ccfb9497d8ef598f$var$joinRanges(a, b) {
    let result = [];
    for(let iA = 0, iB = 0;;){
        let from, to;
        if (iA < a.length && (iB == b.length || b[iB] >= a[iA])) {
            from = a[iA++];
            to = a[iA++];
        } else if (iB < b.length) {
            from = b[iB++];
            to = b[iB++];
        } else return result;
        if (!result.length || result[result.length - 1] < from) result.push(from, to);
        else if (result[result.length - 1] < to) result[result.length - 1] = to;
    }
}
function $ccfb9497d8ef598f$var$mergeTransaction(a, b, sequential) {
    var _a;
    let mapForA, mapForB, changes;
    if (sequential) {
        mapForA = b.changes;
        mapForB = $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c.empty(b.changes.length);
        changes = a.changes.compose(b.changes);
    } else {
        mapForA = b.changes.map(a.changes);
        mapForB = a.changes.mapDesc(b.changes, true);
        changes = a.changes.compose(mapForA);
    }
    return {
        changes: changes,
        selection: b.selection ? b.selection.map(mapForB) : (_a = a.selection) === null || _a === void 0 ? void 0 : _a.map(mapForA),
        effects: $ccfb9497d8ef598f$export$95000d4efaa4321f.mapEffects(a.effects, mapForA).concat($ccfb9497d8ef598f$export$95000d4efaa4321f.mapEffects(b.effects, mapForB)),
        annotations: a.annotations.length ? a.annotations.concat(b.annotations) : b.annotations,
        scrollIntoView: a.scrollIntoView || b.scrollIntoView
    };
}
function $ccfb9497d8ef598f$var$resolveTransactionInner(state, spec, docSize) {
    let sel = spec.selection, annotations = $ccfb9497d8ef598f$var$asArray(spec.annotations);
    if (spec.userEvent) annotations = annotations.concat($ccfb9497d8ef598f$export$febc5573c75cefb0.userEvent.of(spec.userEvent));
    return {
        changes: spec.changes instanceof $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c ? spec.changes : $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c.of(spec.changes || [], docSize, state.facet($ccfb9497d8ef598f$var$lineSeparator)),
        selection: sel && (sel instanceof $ccfb9497d8ef598f$export$3bb1bd44aee62999 ? sel : $ccfb9497d8ef598f$export$3bb1bd44aee62999.single(sel.anchor, sel.head)),
        effects: $ccfb9497d8ef598f$var$asArray(spec.effects),
        annotations: annotations,
        scrollIntoView: !!spec.scrollIntoView
    };
}
function $ccfb9497d8ef598f$var$resolveTransaction(state, specs, filter) {
    let s = $ccfb9497d8ef598f$var$resolveTransactionInner(state, specs.length ? specs[0] : {}, state.doc.length);
    if (specs.length && specs[0].filter === false) filter = false;
    for(let i = 1; i < specs.length; i++){
        if (specs[i].filter === false) filter = false;
        let seq = !!specs[i].sequential;
        s = $ccfb9497d8ef598f$var$mergeTransaction(s, $ccfb9497d8ef598f$var$resolveTransactionInner(state, specs[i], seq ? s.changes.newLength : state.doc.length), seq);
    }
    let tr = $ccfb9497d8ef598f$export$febc5573c75cefb0.create(state, s.changes, s.selection, s.effects, s.annotations, s.scrollIntoView);
    return $ccfb9497d8ef598f$var$extendTransaction(filter ? $ccfb9497d8ef598f$var$filterTransaction(tr) : tr);
}
// Finish a transaction by applying filters if necessary.
function $ccfb9497d8ef598f$var$filterTransaction(tr) {
    let state = tr.startState;
    // Change filters
    let result = true;
    for (let filter of state.facet($ccfb9497d8ef598f$var$changeFilter)){
        let value = filter(tr);
        if (value === false) {
            result = false;
            break;
        }
        if (Array.isArray(value)) result = result === true ? value : $ccfb9497d8ef598f$var$joinRanges(result, value);
    }
    if (result !== true) {
        let changes, back;
        if (result === false) {
            back = tr.changes.invertedDesc;
            changes = $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c.empty(state.doc.length);
        } else {
            let filtered = tr.changes.filter(result);
            changes = filtered.changes;
            back = filtered.filtered.mapDesc(filtered.changes).invertedDesc;
        }
        tr = $ccfb9497d8ef598f$export$febc5573c75cefb0.create(state, changes, tr.selection && tr.selection.map(back), $ccfb9497d8ef598f$export$95000d4efaa4321f.mapEffects(tr.effects, back), tr.annotations, tr.scrollIntoView);
    }
    // Transaction filters
    let filters = state.facet($ccfb9497d8ef598f$var$transactionFilter);
    for(let i = filters.length - 1; i >= 0; i--){
        let filtered = filters[i](tr);
        if (filtered instanceof $ccfb9497d8ef598f$export$febc5573c75cefb0) tr = filtered;
        else if (Array.isArray(filtered) && filtered.length == 1 && filtered[0] instanceof $ccfb9497d8ef598f$export$febc5573c75cefb0) tr = filtered[0];
        else tr = $ccfb9497d8ef598f$var$resolveTransaction(state, $ccfb9497d8ef598f$var$asArray(filtered), false);
    }
    return tr;
}
function $ccfb9497d8ef598f$var$extendTransaction(tr) {
    let state = tr.startState, extenders = state.facet($ccfb9497d8ef598f$var$transactionExtender), spec = tr;
    for(let i = extenders.length - 1; i >= 0; i--){
        let extension = extenders[i](tr);
        if (extension && Object.keys(extension).length) spec = $ccfb9497d8ef598f$var$mergeTransaction(spec, $ccfb9497d8ef598f$var$resolveTransactionInner(state, extension, tr.changes.newLength), true);
    }
    return spec == tr ? tr : $ccfb9497d8ef598f$export$febc5573c75cefb0.create(state, tr.changes, tr.selection, spec.effects, spec.annotations, spec.scrollIntoView);
}
const $ccfb9497d8ef598f$var$none = [];
function $ccfb9497d8ef598f$var$asArray(value) {
    return value == null ? $ccfb9497d8ef598f$var$none : Array.isArray(value) ? value : [
        value
    ];
}
/**
The categories produced by a [character
categorizer](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer). These are used
do things like selecting by word.
*/ var $ccfb9497d8ef598f$export$239a3d59567c1401 = /*@__PURE__*/ function(CharCategory) {
    /**
    Word characters.
    */ CharCategory[CharCategory["Word"] = 0] = "Word";
    /**
    Whitespace.
    */ CharCategory[CharCategory["Space"] = 1] = "Space";
    /**
    Anything else.
    */ CharCategory[CharCategory["Other"] = 2] = "Other";
    return CharCategory;
}($ccfb9497d8ef598f$export$239a3d59567c1401 || ($ccfb9497d8ef598f$export$239a3d59567c1401 = {}));
const $ccfb9497d8ef598f$var$nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let $ccfb9497d8ef598f$var$wordChar;
try {
    $ccfb9497d8ef598f$var$wordChar = /*@__PURE__*/ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch (_) {}
function $ccfb9497d8ef598f$var$hasWordChar(str) {
    if ($ccfb9497d8ef598f$var$wordChar) return $ccfb9497d8ef598f$var$wordChar.test(str);
    for(let i = 0; i < str.length; i++){
        let ch = str[i];
        if (/\w/.test(ch) || ch > "\x80" && (ch.toUpperCase() != ch.toLowerCase() || $ccfb9497d8ef598f$var$nonASCIISingleCaseWordChar.test(ch))) return true;
    }
    return false;
}
function $ccfb9497d8ef598f$var$makeCategorizer(wordChars) {
    return (char)=>{
        if (!/\S/.test(char)) return $ccfb9497d8ef598f$export$239a3d59567c1401.Space;
        if ($ccfb9497d8ef598f$var$hasWordChar(char)) return $ccfb9497d8ef598f$export$239a3d59567c1401.Word;
        for(let i = 0; i < wordChars.length; i++)if (char.indexOf(wordChars[i]) > -1) return $ccfb9497d8ef598f$export$239a3d59567c1401.Word;
        return $ccfb9497d8ef598f$export$239a3d59567c1401.Other;
    };
}
/**
The editor state class is a persistent (immutable) data structure.
To update a state, you [create](https://codemirror.net/6/docs/ref/#state.EditorState.update) a
[transaction](https://codemirror.net/6/docs/ref/#state.Transaction), which produces a _new_ state
instance, without modifying the original object.

As such, _never_ mutate properties of a state directly. That'll
just break things.
*/ class $ccfb9497d8ef598f$export$afa855cbfaff27f2 {
    constructor(/**
    @internal
    */ config, /**
    The current document.
    */ doc, /**
    The current selection.
    */ selection, /**
    @internal
    */ values, computeSlot, tr){
        this.config = config;
        this.doc = doc;
        this.selection = selection;
        this.values = values;
        this.status = config.statusTemplate.slice();
        this.computeSlot = computeSlot;
        // Fill in the computed state immediately, so that further queries
        // for it made during the update return this state
        if (tr) tr._state = this;
        for(let i = 0; i < this.config.dynamicSlots.length; i++)$ccfb9497d8ef598f$var$ensureAddr(this, i << 1);
        this.computeSlot = null;
    }
    field(field, require = true) {
        let addr = this.config.address[field.id];
        if (addr == null) {
            if (require) throw new RangeError("Field is not present in this state");
            return undefined;
        }
        $ccfb9497d8ef598f$var$ensureAddr(this, addr);
        return $ccfb9497d8ef598f$var$getAddr(this, addr);
    }
    /**
    Create a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction) that updates this
    state. Any number of [transaction specs](https://codemirror.net/6/docs/ref/#state.TransactionSpec)
    can be passed. Unless
    [`sequential`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.sequential) is set, the
    [changes](https://codemirror.net/6/docs/ref/#state.TransactionSpec.changes) (if any) of each spec
    are assumed to start in the _current_ document (not the document
    produced by previous specs), and its
    [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) and
    [effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) are assumed to refer
    to the document created by its _own_ changes. The resulting
    transaction contains the combined effect of all the different
    specs. For [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection), later
    specs take precedence over earlier ones.
    */ update(...specs) {
        return $ccfb9497d8ef598f$var$resolveTransaction(this, specs, true);
    }
    /**
    @internal
    */ applyTransaction(tr) {
        let conf = this.config, { base: base, compartments: compartments } = conf;
        for (let effect of tr.effects){
            if (effect.is($ccfb9497d8ef598f$export$d51c0172eb2c2431.reconfigure)) {
                if (conf) {
                    compartments = new Map;
                    conf.compartments.forEach((val, key)=>compartments.set(key, val));
                    conf = null;
                }
                compartments.set(effect.value.compartment, effect.value.extension);
            } else if (effect.is($ccfb9497d8ef598f$export$95000d4efaa4321f.reconfigure)) {
                conf = null;
                base = effect.value;
            } else if (effect.is($ccfb9497d8ef598f$export$95000d4efaa4321f.appendConfig)) {
                conf = null;
                base = $ccfb9497d8ef598f$var$asArray(base).concat(effect.value);
            }
        }
        let startValues;
        if (!conf) {
            conf = $ccfb9497d8ef598f$var$Configuration.resolve(base, compartments, this);
            let intermediateState = new $ccfb9497d8ef598f$export$afa855cbfaff27f2(conf, this.doc, this.selection, conf.dynamicSlots.map(()=>null), (state, slot)=>slot.reconfigure(state, this), null);
            startValues = intermediateState.values;
        } else startValues = tr.startState.values.slice();
        new $ccfb9497d8ef598f$export$afa855cbfaff27f2(conf, tr.newDoc, tr.newSelection, startValues, (state, slot)=>slot.update(state, tr), tr);
    }
    /**
    Create a [transaction spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec) that
    replaces every selection range with the given content.
    */ replaceSelection(text) {
        if (typeof text == "string") text = this.toText(text);
        return this.changeByRange((range)=>({
                changes: {
                    from: range.from,
                    to: range.to,
                    insert: text
                },
                range: $ccfb9497d8ef598f$export$3bb1bd44aee62999.cursor(range.from + text.length)
            }));
    }
    /**
    Create a set of changes and a new selection by running the given
    function for each range in the active selection. The function
    can return an optional set of changes (in the coordinate space
    of the start document), plus an updated range (in the coordinate
    space of the document produced by the call's own changes). This
    method will merge all the changes and ranges into a single
    changeset and selection, and return it as a [transaction
    spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec), which can be passed to
    [`update`](https://codemirror.net/6/docs/ref/#state.EditorState.update).
    */ changeByRange(f) {
        let sel = this.selection;
        let result1 = f(sel.ranges[0]);
        let changes = this.changes(result1.changes), ranges = [
            result1.range
        ];
        let effects = $ccfb9497d8ef598f$var$asArray(result1.effects);
        for(let i = 1; i < sel.ranges.length; i++){
            let result = f(sel.ranges[i]);
            let newChanges = this.changes(result.changes), newMapped = newChanges.map(changes);
            for(let j = 0; j < i; j++)ranges[j] = ranges[j].map(newMapped);
            let mapBy = changes.mapDesc(newChanges, true);
            ranges.push(result.range.map(mapBy));
            changes = changes.compose(newMapped);
            effects = $ccfb9497d8ef598f$export$95000d4efaa4321f.mapEffects(effects, newMapped).concat($ccfb9497d8ef598f$export$95000d4efaa4321f.mapEffects($ccfb9497d8ef598f$var$asArray(result.effects), mapBy));
        }
        return {
            changes: changes,
            selection: $ccfb9497d8ef598f$export$3bb1bd44aee62999.create(ranges, sel.mainIndex),
            effects: effects
        };
    }
    /**
    Create a [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet) from the given change
    description, taking the state's document length and line
    separator into account.
    */ changes(spec = []) {
        if (spec instanceof $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c) return spec;
        return $ccfb9497d8ef598f$export$29d7fbdcb1f8b71c.of(spec, this.doc.length, this.facet($ccfb9497d8ef598f$export$afa855cbfaff27f2.lineSeparator));
    }
    /**
    Using the state's [line
    separator](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator), create a
    [`Text`](https://codemirror.net/6/docs/ref/#state.Text) instance from the given string.
    */ toText(string) {
        return $ccfb9497d8ef598f$export$5f1af8db9871e1d6.of(string.split(this.facet($ccfb9497d8ef598f$export$afa855cbfaff27f2.lineSeparator) || $ccfb9497d8ef598f$var$DefaultSplit));
    }
    /**
    Return the given range of the document as a string.
    */ sliceDoc(from = 0, to = this.doc.length) {
        return this.doc.sliceString(from, to, this.lineBreak);
    }
    /**
    Get the value of a state [facet](https://codemirror.net/6/docs/ref/#state.Facet).
    */ facet(facet) {
        let addr = this.config.address[facet.id];
        if (addr == null) return facet.default;
        $ccfb9497d8ef598f$var$ensureAddr(this, addr);
        return $ccfb9497d8ef598f$var$getAddr(this, addr);
    }
    /**
    Convert this state to a JSON-serializable object. When custom
    fields should be serialized, you can pass them in as an object
    mapping property names (in the resulting object, which should
    not use `doc` or `selection`) to fields.
    */ toJSON(fields) {
        let result = {
            doc: this.sliceDoc(),
            selection: this.selection.toJSON()
        };
        if (fields) for(let prop in fields){
            let value = fields[prop];
            if (value instanceof $ccfb9497d8ef598f$export$34381b1ce2130245 && this.config.address[value.id] != null) result[prop] = value.spec.toJSON(this.field(fields[prop]), this);
        }
        return result;
    }
    /**
    Deserialize a state from its JSON representation. When custom
    fields should be deserialized, pass the same object you passed
    to [`toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) when serializing as
    third argument.
    */ static fromJSON(json, config = {}, fields) {
        if (!json || typeof json.doc != "string") throw new RangeError("Invalid JSON representation for EditorState");
        let fieldInit = [];
        if (fields) {
            for(let prop in fields)if (Object.prototype.hasOwnProperty.call(json, prop)) {
                let field = fields[prop], value = json[prop];
                fieldInit.push(field.init((state)=>field.spec.fromJSON(value, state)));
            }
        }
        return $ccfb9497d8ef598f$export$afa855cbfaff27f2.create({
            doc: json.doc,
            selection: $ccfb9497d8ef598f$export$3bb1bd44aee62999.fromJSON(json.selection),
            extensions: config.extensions ? fieldInit.concat([
                config.extensions
            ]) : fieldInit
        });
    }
    /**
    Create a new state. You'll usually only need this when
    initializing an editor—updated states are created by applying
    transactions.
    */ static create(config = {}) {
        let configuration = $ccfb9497d8ef598f$var$Configuration.resolve(config.extensions || [], new Map);
        let doc = config.doc instanceof $ccfb9497d8ef598f$export$5f1af8db9871e1d6 ? config.doc : $ccfb9497d8ef598f$export$5f1af8db9871e1d6.of((config.doc || "").split(configuration.staticFacet($ccfb9497d8ef598f$export$afa855cbfaff27f2.lineSeparator) || $ccfb9497d8ef598f$var$DefaultSplit));
        let selection = !config.selection ? $ccfb9497d8ef598f$export$3bb1bd44aee62999.single(0) : config.selection instanceof $ccfb9497d8ef598f$export$3bb1bd44aee62999 ? config.selection : $ccfb9497d8ef598f$export$3bb1bd44aee62999.single(config.selection.anchor, config.selection.head);
        $ccfb9497d8ef598f$var$checkSelection(selection, doc.length);
        if (!configuration.staticFacet($ccfb9497d8ef598f$var$allowMultipleSelections)) selection = selection.asSingle();
        return new $ccfb9497d8ef598f$export$afa855cbfaff27f2(configuration, doc, selection, configuration.dynamicSlots.map(()=>null), (state, slot)=>slot.create(state), null);
    }
    /**
    The size (in columns) of a tab in the document, determined by
    the [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) facet.
    */ get tabSize() {
        return this.facet($ccfb9497d8ef598f$export$afa855cbfaff27f2.tabSize);
    }
    /**
    Get the proper [line-break](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator)
    string for this state.
    */ get lineBreak() {
        return this.facet($ccfb9497d8ef598f$export$afa855cbfaff27f2.lineSeparator) || "\n";
    }
    /**
    Returns true when the editor is
    [configured](https://codemirror.net/6/docs/ref/#state.EditorState^readOnly) to be read-only.
    */ get readOnly() {
        return this.facet($ccfb9497d8ef598f$var$readOnly);
    }
    /**
    Look up a translation for the given phrase (via the
    [`phrases`](https://codemirror.net/6/docs/ref/#state.EditorState^phrases) facet), or return the
    original string if no translation is found.
    
    If additional arguments are passed, they will be inserted in
    place of markers like `$1` (for the first value) and `$2`, etc.
    A single `$` is equivalent to `$1`, and `$$` will produce a
    literal dollar sign.
    */ phrase(phrase, ...insert) {
        for (let map of this.facet($ccfb9497d8ef598f$export$afa855cbfaff27f2.phrases))if (Object.prototype.hasOwnProperty.call(map, phrase)) {
            phrase = map[phrase];
            break;
        }
        if (insert.length) phrase = phrase.replace(/\$(\$|\d*)/g, (m, i)=>{
            if (i == "$") return "$";
            let n = +(i || 1);
            return !n || n > insert.length ? m : insert[n - 1];
        });
        return phrase;
    }
    /**
    Find the values for a given language data field, provided by the
    the [`languageData`](https://codemirror.net/6/docs/ref/#state.EditorState^languageData) facet.
    
    Examples of language data fields are...
    
    - [`"commentTokens"`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) for specifying
      comment syntax.
    - [`"autocomplete"`](https://codemirror.net/6/docs/ref/#autocomplete.autocompletion^config.override)
      for providing language-specific completion sources.
    - [`"wordChars"`](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) for adding
      characters that should be considered part of words in this
      language.
    - [`"closeBrackets"`](https://codemirror.net/6/docs/ref/#autocomplete.CloseBracketConfig) controls
      bracket closing behavior.
    */ languageDataAt(name, pos, side = -1) {
        let values = [];
        for (let provider of this.facet($ccfb9497d8ef598f$var$languageData)){
            for (let result of provider(this, pos, side))if (Object.prototype.hasOwnProperty.call(result, name)) values.push(result[name]);
        }
        return values;
    }
    /**
    Return a function that can categorize strings (expected to
    represent a single [grapheme cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak))
    into one of:
    
     - Word (contains an alphanumeric character or a character
       explicitly listed in the local language's `"wordChars"`
       language data, which should be a string)
     - Space (contains only whitespace)
     - Other (anything else)
    */ charCategorizer(at) {
        return $ccfb9497d8ef598f$var$makeCategorizer(this.languageDataAt("wordChars", at).join(""));
    }
    /**
    Find the word at the given position, meaning the range
    containing all [word](https://codemirror.net/6/docs/ref/#state.CharCategory.Word) characters
    around it. If no word characters are adjacent to the position,
    this returns null.
    */ wordAt(pos) {
        let { text: text, from: from, length: length } = this.doc.lineAt(pos);
        let cat = this.charCategorizer(pos);
        let start = pos - from, end = pos - from;
        while(start > 0){
            let prev = $ccfb9497d8ef598f$export$a0fa439fd515e1ed(text, start, false);
            if (cat(text.slice(prev, start)) != $ccfb9497d8ef598f$export$239a3d59567c1401.Word) break;
            start = prev;
        }
        while(end < length){
            let next = $ccfb9497d8ef598f$export$a0fa439fd515e1ed(text, end);
            if (cat(text.slice(end, next)) != $ccfb9497d8ef598f$export$239a3d59567c1401.Word) break;
            end = next;
        }
        return start == end ? null : $ccfb9497d8ef598f$export$3bb1bd44aee62999.range(start + from, end + from);
    }
}
/**
A facet that, when enabled, causes the editor to allow multiple
ranges to be selected. Be careful though, because by default the
editor relies on the native DOM selection, which cannot handle
multiple selections. An extension like
[`drawSelection`](https://codemirror.net/6/docs/ref/#view.drawSelection) can be used to make
secondary selections visible to the user.
*/ $ccfb9497d8ef598f$export$afa855cbfaff27f2.allowMultipleSelections = $ccfb9497d8ef598f$var$allowMultipleSelections;
/**
Configures the tab size to use in this state. The first
(highest-precedence) value of the facet is used. If no value is
given, this defaults to 4.
*/ $ccfb9497d8ef598f$export$afa855cbfaff27f2.tabSize = /*@__PURE__*/ $ccfb9497d8ef598f$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : 4
});
/**
The line separator to use. By default, any of `"\n"`, `"\r\n"`
and `"\r"` is treated as a separator when splitting lines, and
lines are joined with `"\n"`.

When you configure a value here, only that precise separator
will be used, allowing you to round-trip documents through the
editor without normalizing line separators.
*/ $ccfb9497d8ef598f$export$afa855cbfaff27f2.lineSeparator = $ccfb9497d8ef598f$var$lineSeparator;
/**
This facet controls the value of the
[`readOnly`](https://codemirror.net/6/docs/ref/#state.EditorState.readOnly) getter, which is
consulted by commands and extensions that implement editing
functionality to determine whether they should apply. It
defaults to false, but when its highest-precedence value is
`true`, such functionality disables itself.

Not to be confused with
[`EditorView.editable`](https://codemirror.net/6/docs/ref/#view.EditorView^editable), which
controls whether the editor's DOM is set to be editable (and
thus focusable).
*/ $ccfb9497d8ef598f$export$afa855cbfaff27f2.readOnly = $ccfb9497d8ef598f$var$readOnly;
/**
Registers translation phrases. The
[`phrase`](https://codemirror.net/6/docs/ref/#state.EditorState.phrase) method will look through
all objects registered with this facet to find translations for
its argument.
*/ $ccfb9497d8ef598f$export$afa855cbfaff27f2.phrases = /*@__PURE__*/ $ccfb9497d8ef598f$export$ef7d5e9b79fa1504.define({
    compare (a, b) {
        let kA = Object.keys(a), kB = Object.keys(b);
        return kA.length == kB.length && kA.every((k)=>a[k] == b[k]);
    }
});
/**
A facet used to register [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt) providers.
*/ $ccfb9497d8ef598f$export$afa855cbfaff27f2.languageData = $ccfb9497d8ef598f$var$languageData;
/**
Facet used to register change filters, which are called for each
transaction (unless explicitly
[disabled](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter)), and can suppress
part of the transaction's changes.

Such a function can return `true` to indicate that it doesn't
want to do anything, `false` to completely stop the changes in
the transaction, or a set of ranges in which changes should be
suppressed. Such ranges are represented as an array of numbers,
with each pair of two numbers indicating the start and end of a
range. So for example `[10, 20, 100, 110]` suppresses changes
between 10 and 20, and between 100 and 110.
*/ $ccfb9497d8ef598f$export$afa855cbfaff27f2.changeFilter = $ccfb9497d8ef598f$var$changeFilter;
/**
Facet used to register a hook that gets a chance to update or
replace transaction specs before they are applied. This will
only be applied for transactions that don't have
[`filter`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter) set to `false`. You
can either return a single transaction spec (possibly the input
transaction), or an array of specs (which will be combined in
the same way as the arguments to
[`EditorState.update`](https://codemirror.net/6/docs/ref/#state.EditorState.update)).

When possible, it is recommended to avoid accessing
[`Transaction.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state) in a filter,
since it will force creation of a state that will then be
discarded again, if the transaction is actually filtered.

(This functionality should be used with care. Indiscriminately
modifying transaction is likely to break something or degrade
the user experience.)
*/ $ccfb9497d8ef598f$export$afa855cbfaff27f2.transactionFilter = $ccfb9497d8ef598f$var$transactionFilter;
/**
This is a more limited form of
[`transactionFilter`](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter),
which can only add
[annotations](https://codemirror.net/6/docs/ref/#state.TransactionSpec.annotations) and
[effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects). _But_, this type
of filter runs even if the transaction has disabled regular
[filtering](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter), making it suitable
for effects that don't need to touch the changes or selection,
but do want to process every transaction.

Extenders run _after_ filters, when both are present.
*/ $ccfb9497d8ef598f$export$afa855cbfaff27f2.transactionExtender = $ccfb9497d8ef598f$var$transactionExtender;
$ccfb9497d8ef598f$export$d51c0172eb2c2431.reconfigure = /*@__PURE__*/ $ccfb9497d8ef598f$export$95000d4efaa4321f.define();
/**
Utility function for combining behaviors to fill in a config
object from an array of provided configs. `defaults` should hold
default values for all optional fields in `Config`.

The function will, by default, error
when a field gets two values that aren't `===`-equal, but you can
provide combine functions per field to do something else.
*/ function $ccfb9497d8ef598f$export$4e19c0b693794a7e(configs, defaults, combine = {}) {
    let result = {};
    for (let config of configs)for (let key of Object.keys(config)){
        let value = config[key], current = result[key];
        if (current === undefined) result[key] = value;
        else if (current === value || value === undefined) ; // No conflict
        else if (Object.hasOwnProperty.call(combine, key)) result[key] = combine[key](current, value);
        else throw new Error("Config merge conflict for field " + key);
    }
    for(let key in defaults)if (result[key] === undefined) result[key] = defaults[key];
    return result;
}
/**
Each range is associated with a value, which must inherit from
this class.
*/ class $ccfb9497d8ef598f$export$d60f08ed93a48611 {
    /**
    Compare this value with another value. Used when comparing
    rangesets. The default implementation compares by identity.
    Unless you are only creating a fixed number of unique instances
    of your value type, it is a good idea to implement this
    properly.
    */ eq(other) {
        return this == other;
    }
    /**
    Create a [range](https://codemirror.net/6/docs/ref/#state.Range) with this value.
    */ range(from, to = from) {
        return $ccfb9497d8ef598f$export$9a58ef0d7ad3278c.create(from, to, this);
    }
}
$ccfb9497d8ef598f$export$d60f08ed93a48611.prototype.startSide = $ccfb9497d8ef598f$export$d60f08ed93a48611.prototype.endSide = 0;
$ccfb9497d8ef598f$export$d60f08ed93a48611.prototype.point = false;
$ccfb9497d8ef598f$export$d60f08ed93a48611.prototype.mapMode = $ccfb9497d8ef598f$export$39cf3280165f92aa.TrackDel;
/**
A range associates a value with a range of positions.
*/ class $ccfb9497d8ef598f$export$9a58ef0d7ad3278c {
    constructor(/**
    The range's start position.
    */ from, /**
    Its end position.
    */ to, /**
    The value associated with this range.
    */ value){
        this.from = from;
        this.to = to;
        this.value = value;
    }
    /**
    @internal
    */ static create(from, to, value) {
        return new $ccfb9497d8ef598f$export$9a58ef0d7ad3278c(from, to, value);
    }
}
function $ccfb9497d8ef598f$var$cmpRange(a, b) {
    return a.from - b.from || a.value.startSide - b.value.startSide;
}
class $ccfb9497d8ef598f$var$Chunk {
    constructor(from, to, value, // Chunks are marked with the largest point that occurs
    // in them (or -1 for no points), so that scans that are
    // only interested in points (such as the
    // heightmap-related logic) can skip range-only chunks.
    maxPoint){
        this.from = from;
        this.to = to;
        this.value = value;
        this.maxPoint = maxPoint;
    }
    get length() {
        return this.to[this.to.length - 1];
    }
    // Find the index of the given position and side. Use the ranges'
    // `from` pos when `end == false`, `to` when `end == true`.
    findIndex(pos, side, end, startAt = 0) {
        let arr = end ? this.to : this.from;
        for(let lo = startAt, hi = arr.length;;){
            if (lo == hi) return lo;
            let mid = lo + hi >> 1;
            let diff = arr[mid] - pos || (end ? this.value[mid].endSide : this.value[mid].startSide) - side;
            if (mid == lo) return diff >= 0 ? lo : hi;
            if (diff >= 0) hi = mid;
            else lo = mid + 1;
        }
    }
    between(offset, from, to, f) {
        for(let i = this.findIndex(from, -1000000000 /* C.Far */ , true), e = this.findIndex(to, 1000000000 /* C.Far */ , false, i); i < e; i++)if (f(this.from[i] + offset, this.to[i] + offset, this.value[i]) === false) return false;
    }
    map(offset, changes) {
        let value = [], from = [], to = [], newPos = -1, maxPoint = -1;
        for(let i = 0; i < this.value.length; i++){
            let val = this.value[i], curFrom = this.from[i] + offset, curTo = this.to[i] + offset, newFrom, newTo;
            if (curFrom == curTo) {
                let mapped = changes.mapPos(curFrom, val.startSide, val.mapMode);
                if (mapped == null) continue;
                newFrom = newTo = mapped;
                if (val.startSide != val.endSide) {
                    newTo = changes.mapPos(curFrom, val.endSide);
                    if (newTo < newFrom) continue;
                }
            } else {
                newFrom = changes.mapPos(curFrom, val.startSide);
                newTo = changes.mapPos(curTo, val.endSide);
                if (newFrom > newTo || newFrom == newTo && val.startSide > 0 && val.endSide <= 0) continue;
            }
            if ((newTo - newFrom || val.endSide - val.startSide) < 0) continue;
            if (newPos < 0) newPos = newFrom;
            if (val.point) maxPoint = Math.max(maxPoint, newTo - newFrom);
            value.push(val);
            from.push(newFrom - newPos);
            to.push(newTo - newPos);
        }
        return {
            mapped: value.length ? new $ccfb9497d8ef598f$var$Chunk(from, to, value, maxPoint) : null,
            pos: newPos
        };
    }
}
/**
A range set stores a collection of [ranges](https://codemirror.net/6/docs/ref/#state.Range) in a
way that makes them efficient to [map](https://codemirror.net/6/docs/ref/#state.RangeSet.map) and
[update](https://codemirror.net/6/docs/ref/#state.RangeSet.update). This is an immutable data
structure.
*/ class $ccfb9497d8ef598f$export$34cb5241245008dd {
    constructor(/**
    @internal
    */ chunkPos, /**
    @internal
    */ chunk, /**
    @internal
    */ nextLayer, /**
    @internal
    */ maxPoint){
        this.chunkPos = chunkPos;
        this.chunk = chunk;
        this.nextLayer = nextLayer;
        this.maxPoint = maxPoint;
    }
    /**
    @internal
    */ static create(chunkPos, chunk, nextLayer, maxPoint) {
        return new $ccfb9497d8ef598f$export$34cb5241245008dd(chunkPos, chunk, nextLayer, maxPoint);
    }
    /**
    @internal
    */ get length() {
        let last = this.chunk.length - 1;
        return last < 0 ? 0 : Math.max(this.chunkEnd(last), this.nextLayer.length);
    }
    /**
    The number of ranges in the set.
    */ get size() {
        if (this.isEmpty) return 0;
        let size = this.nextLayer.size;
        for (let chunk of this.chunk)size += chunk.value.length;
        return size;
    }
    /**
    @internal
    */ chunkEnd(index) {
        return this.chunkPos[index] + this.chunk[index].length;
    }
    /**
    Update the range set, optionally adding new ranges or filtering
    out existing ones.
    
    (Note: The type parameter is just there as a kludge to work
    around TypeScript variance issues that prevented `RangeSet<X>`
    from being a subtype of `RangeSet<Y>` when `X` is a subtype of
    `Y`.)
    */ update(updateSpec) {
        let { add: add = [], sort: sort = false, filterFrom: filterFrom = 0, filterTo: filterTo = this.length } = updateSpec;
        let filter = updateSpec.filter;
        if (add.length == 0 && !filter) return this;
        if (sort) add = add.slice().sort($ccfb9497d8ef598f$var$cmpRange);
        if (this.isEmpty) return add.length ? $ccfb9497d8ef598f$export$34cb5241245008dd.of(add) : this;
        let cur = new $ccfb9497d8ef598f$var$LayerCursor(this, null, -1).goto(0), i = 0, spill = [];
        let builder = new $ccfb9497d8ef598f$export$89e09ce03c7e8594();
        while(cur.value || i < add.length){
            if (i < add.length && (cur.from - add[i].from || cur.startSide - add[i].value.startSide) >= 0) {
                let range = add[i++];
                if (!builder.addInner(range.from, range.to, range.value)) spill.push(range);
            } else if (cur.rangeIndex == 1 && cur.chunkIndex < this.chunk.length && (i == add.length || this.chunkEnd(cur.chunkIndex) < add[i].from) && (!filter || filterFrom > this.chunkEnd(cur.chunkIndex) || filterTo < this.chunkPos[cur.chunkIndex]) && builder.addChunk(this.chunkPos[cur.chunkIndex], this.chunk[cur.chunkIndex])) cur.nextChunk();
            else {
                if (!filter || filterFrom > cur.to || filterTo < cur.from || filter(cur.from, cur.to, cur.value)) {
                    if (!builder.addInner(cur.from, cur.to, cur.value)) spill.push($ccfb9497d8ef598f$export$9a58ef0d7ad3278c.create(cur.from, cur.to, cur.value));
                }
                cur.next();
            }
        }
        return builder.finishInner(this.nextLayer.isEmpty && !spill.length ? $ccfb9497d8ef598f$export$34cb5241245008dd.empty : this.nextLayer.update({
            add: spill,
            filter: filter,
            filterFrom: filterFrom,
            filterTo: filterTo
        }));
    }
    /**
    Map this range set through a set of changes, return the new set.
    */ map(changes) {
        if (changes.empty || this.isEmpty) return this;
        let chunks = [], chunkPos = [], maxPoint = -1;
        for(let i = 0; i < this.chunk.length; i++){
            let start = this.chunkPos[i], chunk = this.chunk[i];
            let touch = changes.touchesRange(start, start + chunk.length);
            if (touch === false) {
                maxPoint = Math.max(maxPoint, chunk.maxPoint);
                chunks.push(chunk);
                chunkPos.push(changes.mapPos(start));
            } else if (touch === true) {
                let { mapped: mapped, pos: pos } = chunk.map(start, changes);
                if (mapped) {
                    maxPoint = Math.max(maxPoint, mapped.maxPoint);
                    chunks.push(mapped);
                    chunkPos.push(pos);
                }
            }
        }
        let next = this.nextLayer.map(changes);
        return chunks.length == 0 ? next : new $ccfb9497d8ef598f$export$34cb5241245008dd(chunkPos, chunks, next || $ccfb9497d8ef598f$export$34cb5241245008dd.empty, maxPoint);
    }
    /**
    Iterate over the ranges that touch the region `from` to `to`,
    calling `f` for each. There is no guarantee that the ranges will
    be reported in any specific order. When the callback returns
    `false`, iteration stops.
    */ between(from, to, f) {
        if (this.isEmpty) return;
        for(let i = 0; i < this.chunk.length; i++){
            let start = this.chunkPos[i], chunk = this.chunk[i];
            if (to >= start && from <= start + chunk.length && chunk.between(start, from - start, to - start, f) === false) return;
        }
        this.nextLayer.between(from, to, f);
    }
    /**
    Iterate over the ranges in this set, in order, including all
    ranges that end at or after `from`.
    */ iter(from = 0) {
        return $ccfb9497d8ef598f$var$HeapCursor.from([
            this
        ]).goto(from);
    }
    /**
    @internal
    */ get isEmpty() {
        return this.nextLayer == this;
    }
    /**
    Iterate over the ranges in a collection of sets, in order,
    starting from `from`.
    */ static iter(sets, from = 0) {
        return $ccfb9497d8ef598f$var$HeapCursor.from(sets).goto(from);
    }
    /**
    Iterate over two groups of sets, calling methods on `comparator`
    to notify it of possible differences.
    */ static compare(oldSets, newSets, /**
    This indicates how the underlying data changed between these
    ranges, and is needed to synchronize the iteration.
    */ textDiff, comparator, /**
    Can be used to ignore all non-point ranges, and points below
    the given size. When -1, all ranges are compared.
    */ minPointSize = -1) {
        let a = oldSets.filter((set)=>set.maxPoint > 0 || !set.isEmpty && set.maxPoint >= minPointSize);
        let b = newSets.filter((set)=>set.maxPoint > 0 || !set.isEmpty && set.maxPoint >= minPointSize);
        let sharedChunks = $ccfb9497d8ef598f$var$findSharedChunks(a, b, textDiff);
        let sideA = new $ccfb9497d8ef598f$var$SpanCursor(a, sharedChunks, minPointSize);
        let sideB = new $ccfb9497d8ef598f$var$SpanCursor(b, sharedChunks, minPointSize);
        textDiff.iterGaps((fromA, fromB, length)=>$ccfb9497d8ef598f$var$compare(sideA, fromA, sideB, fromB, length, comparator));
        if (textDiff.empty && textDiff.length == 0) $ccfb9497d8ef598f$var$compare(sideA, 0, sideB, 0, 0, comparator);
    }
    /**
    Compare the contents of two groups of range sets, returning true
    if they are equivalent in the given range.
    */ static eq(oldSets, newSets, from = 0, to) {
        if (to == null) to = 999999999;
        let a = oldSets.filter((set)=>!set.isEmpty && newSets.indexOf(set) < 0);
        let b = newSets.filter((set)=>!set.isEmpty && oldSets.indexOf(set) < 0);
        if (a.length != b.length) return false;
        if (!a.length) return true;
        let sharedChunks = $ccfb9497d8ef598f$var$findSharedChunks(a, b);
        let sideA = new $ccfb9497d8ef598f$var$SpanCursor(a, sharedChunks, 0).goto(from), sideB = new $ccfb9497d8ef598f$var$SpanCursor(b, sharedChunks, 0).goto(from);
        for(;;){
            if (sideA.to != sideB.to || !$ccfb9497d8ef598f$var$sameValues(sideA.active, sideB.active) || sideA.point && (!sideB.point || !sideA.point.eq(sideB.point))) return false;
            if (sideA.to > to) return true;
            sideA.next();
            sideB.next();
        }
    }
    /**
    Iterate over a group of range sets at the same time, notifying
    the iterator about the ranges covering every given piece of
    content. Returns the open count (see
    [`SpanIterator.span`](https://codemirror.net/6/docs/ref/#state.SpanIterator.span)) at the end
    of the iteration.
    */ static spans(sets, from, to, iterator, /**
    When given and greater than -1, only points of at least this
    size are taken into account.
    */ minPointSize = -1) {
        let cursor = new $ccfb9497d8ef598f$var$SpanCursor(sets, null, minPointSize).goto(from), pos = from;
        let openRanges = cursor.openStart;
        for(;;){
            let curTo = Math.min(cursor.to, to);
            if (cursor.point) {
                let active = cursor.activeForPoint(cursor.to);
                let openCount = cursor.pointFrom < from ? active.length + 1 : Math.min(active.length, openRanges);
                iterator.point(pos, curTo, cursor.point, active, openCount, cursor.pointRank);
                openRanges = Math.min(cursor.openEnd(curTo), active.length);
            } else if (curTo > pos) {
                iterator.span(pos, curTo, cursor.active, openRanges);
                openRanges = cursor.openEnd(curTo);
            }
            if (cursor.to > to) return openRanges + (cursor.point && cursor.to > to ? 1 : 0);
            pos = cursor.to;
            cursor.next();
        }
    }
    /**
    Create a range set for the given range or array of ranges. By
    default, this expects the ranges to be _sorted_ (by start
    position and, if two start at the same position,
    `value.startSide`). You can pass `true` as second argument to
    cause the method to sort them.
    */ static of(ranges, sort = false) {
        let build = new $ccfb9497d8ef598f$export$89e09ce03c7e8594();
        for (let range of ranges instanceof $ccfb9497d8ef598f$export$9a58ef0d7ad3278c ? [
            ranges
        ] : sort ? $ccfb9497d8ef598f$var$lazySort(ranges) : ranges)build.add(range.from, range.to, range.value);
        return build.finish();
    }
}
/**
The empty set of ranges.
*/ $ccfb9497d8ef598f$export$34cb5241245008dd.empty = /*@__PURE__*/ new $ccfb9497d8ef598f$export$34cb5241245008dd([], [], null, -1);
function $ccfb9497d8ef598f$var$lazySort(ranges) {
    if (ranges.length > 1) for(let prev = ranges[0], i = 1; i < ranges.length; i++){
        let cur = ranges[i];
        if ($ccfb9497d8ef598f$var$cmpRange(prev, cur) > 0) return ranges.slice().sort($ccfb9497d8ef598f$var$cmpRange);
        prev = cur;
    }
    return ranges;
}
$ccfb9497d8ef598f$export$34cb5241245008dd.empty.nextLayer = $ccfb9497d8ef598f$export$34cb5241245008dd.empty;
/**
A range set builder is a data structure that helps build up a
[range set](https://codemirror.net/6/docs/ref/#state.RangeSet) directly, without first allocating
an array of [`Range`](https://codemirror.net/6/docs/ref/#state.Range) objects.
*/ class $ccfb9497d8ef598f$export$89e09ce03c7e8594 {
    finishChunk(newArrays) {
        this.chunks.push(new $ccfb9497d8ef598f$var$Chunk(this.from, this.to, this.value, this.maxPoint));
        this.chunkPos.push(this.chunkStart);
        this.chunkStart = -1;
        this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint);
        this.maxPoint = -1;
        if (newArrays) {
            this.from = [];
            this.to = [];
            this.value = [];
        }
    }
    /**
    Create an empty builder.
    */ constructor(){
        this.chunks = [];
        this.chunkPos = [];
        this.chunkStart = -1;
        this.last = null;
        this.lastFrom = -1000000000 /* C.Far */ ;
        this.lastTo = -1000000000 /* C.Far */ ;
        this.from = [];
        this.to = [];
        this.value = [];
        this.maxPoint = -1;
        this.setMaxPoint = -1;
        this.nextLayer = null;
    }
    /**
    Add a range. Ranges should be added in sorted (by `from` and
    `value.startSide`) order.
    */ add(from, to, value) {
        if (!this.addInner(from, to, value)) (this.nextLayer || (this.nextLayer = new $ccfb9497d8ef598f$export$89e09ce03c7e8594)).add(from, to, value);
    }
    /**
    @internal
    */ addInner(from, to, value) {
        let diff = from - this.lastTo || value.startSide - this.last.endSide;
        if (diff <= 0 && (from - this.lastFrom || value.startSide - this.last.startSide) < 0) throw new Error("Ranges must be added sorted by `from` position and `startSide`");
        if (diff < 0) return false;
        if (this.from.length == 250 /* C.ChunkSize */ ) this.finishChunk(true);
        if (this.chunkStart < 0) this.chunkStart = from;
        this.from.push(from - this.chunkStart);
        this.to.push(to - this.chunkStart);
        this.last = value;
        this.lastFrom = from;
        this.lastTo = to;
        this.value.push(value);
        if (value.point) this.maxPoint = Math.max(this.maxPoint, to - from);
        return true;
    }
    /**
    @internal
    */ addChunk(from, chunk) {
        if ((from - this.lastTo || chunk.value[0].startSide - this.last.endSide) < 0) return false;
        if (this.from.length) this.finishChunk(true);
        this.setMaxPoint = Math.max(this.setMaxPoint, chunk.maxPoint);
        this.chunks.push(chunk);
        this.chunkPos.push(from);
        let last = chunk.value.length - 1;
        this.last = chunk.value[last];
        this.lastFrom = chunk.from[last] + from;
        this.lastTo = chunk.to[last] + from;
        return true;
    }
    /**
    Finish the range set. Returns the new set. The builder can't be
    used anymore after this has been called.
    */ finish() {
        return this.finishInner($ccfb9497d8ef598f$export$34cb5241245008dd.empty);
    }
    /**
    @internal
    */ finishInner(next) {
        if (this.from.length) this.finishChunk(false);
        if (this.chunks.length == 0) return next;
        let result = $ccfb9497d8ef598f$export$34cb5241245008dd.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(next) : next, this.setMaxPoint);
        this.from = null; // Make sure further `add` calls produce errors
        return result;
    }
}
function $ccfb9497d8ef598f$var$findSharedChunks(a, b, textDiff) {
    let inA = new Map();
    for (let set of a)for(let i = 0; i < set.chunk.length; i++)if (set.chunk[i].maxPoint <= 0) inA.set(set.chunk[i], set.chunkPos[i]);
    let shared = new Set();
    for (let set of b)for(let i = 0; i < set.chunk.length; i++){
        let known = inA.get(set.chunk[i]);
        if (known != null && (textDiff ? textDiff.mapPos(known) : known) == set.chunkPos[i] && !(textDiff === null || textDiff === void 0 ? void 0 : textDiff.touchesRange(known, known + set.chunk[i].length))) shared.add(set.chunk[i]);
    }
    return shared;
}
class $ccfb9497d8ef598f$var$LayerCursor {
    constructor(layer, skip, minPoint, rank = 0){
        this.layer = layer;
        this.skip = skip;
        this.minPoint = minPoint;
        this.rank = rank;
    }
    get startSide() {
        return this.value ? this.value.startSide : 0;
    }
    get endSide() {
        return this.value ? this.value.endSide : 0;
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        this.chunkIndex = this.rangeIndex = 0;
        this.gotoInner(pos, side, false);
        return this;
    }
    gotoInner(pos, side, forward) {
        while(this.chunkIndex < this.layer.chunk.length){
            let next = this.layer.chunk[this.chunkIndex];
            if (!(this.skip && this.skip.has(next) || this.layer.chunkEnd(this.chunkIndex) < pos || next.maxPoint < this.minPoint)) break;
            this.chunkIndex++;
            forward = false;
        }
        if (this.chunkIndex < this.layer.chunk.length) {
            let rangeIndex = this.layer.chunk[this.chunkIndex].findIndex(pos - this.layer.chunkPos[this.chunkIndex], side, true);
            if (!forward || this.rangeIndex < rangeIndex) this.setRangeIndex(rangeIndex);
        }
        this.next();
    }
    forward(pos, side) {
        if ((this.to - pos || this.endSide - side) < 0) this.gotoInner(pos, side, true);
    }
    next() {
        for(;;)if (this.chunkIndex == this.layer.chunk.length) {
            this.from = this.to = 1000000000 /* C.Far */ ;
            this.value = null;
            break;
        } else {
            let chunkPos = this.layer.chunkPos[this.chunkIndex], chunk = this.layer.chunk[this.chunkIndex];
            let from = chunkPos + chunk.from[this.rangeIndex];
            this.from = from;
            this.to = chunkPos + chunk.to[this.rangeIndex];
            this.value = chunk.value[this.rangeIndex];
            this.setRangeIndex(this.rangeIndex + 1);
            if (this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint) break;
        }
    }
    setRangeIndex(index) {
        if (index == this.layer.chunk[this.chunkIndex].value.length) {
            this.chunkIndex++;
            if (this.skip) while(this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]))this.chunkIndex++;
            this.rangeIndex = 0;
        } else this.rangeIndex = index;
    }
    nextChunk() {
        this.chunkIndex++;
        this.rangeIndex = 0;
        this.next();
    }
    compare(other) {
        return this.from - other.from || this.startSide - other.startSide || this.rank - other.rank || this.to - other.to || this.endSide - other.endSide;
    }
}
class $ccfb9497d8ef598f$var$HeapCursor {
    constructor(heap){
        this.heap = heap;
    }
    static from(sets, skip = null, minPoint = -1) {
        let heap = [];
        for(let i = 0; i < sets.length; i++){
            for(let cur = sets[i]; !cur.isEmpty; cur = cur.nextLayer)if (cur.maxPoint >= minPoint) heap.push(new $ccfb9497d8ef598f$var$LayerCursor(cur, skip, minPoint, i));
        }
        return heap.length == 1 ? heap[0] : new $ccfb9497d8ef598f$var$HeapCursor(heap);
    }
    get startSide() {
        return this.value ? this.value.startSide : 0;
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        for (let cur of this.heap)cur.goto(pos, side);
        for(let i = this.heap.length >> 1; i >= 0; i--)$ccfb9497d8ef598f$var$heapBubble(this.heap, i);
        this.next();
        return this;
    }
    forward(pos, side) {
        for (let cur of this.heap)cur.forward(pos, side);
        for(let i = this.heap.length >> 1; i >= 0; i--)$ccfb9497d8ef598f$var$heapBubble(this.heap, i);
        if ((this.to - pos || this.value.endSide - side) < 0) this.next();
    }
    next() {
        if (this.heap.length == 0) {
            this.from = this.to = 1000000000 /* C.Far */ ;
            this.value = null;
            this.rank = -1;
        } else {
            let top = this.heap[0];
            this.from = top.from;
            this.to = top.to;
            this.value = top.value;
            this.rank = top.rank;
            if (top.value) top.next();
            $ccfb9497d8ef598f$var$heapBubble(this.heap, 0);
        }
    }
}
function $ccfb9497d8ef598f$var$heapBubble(heap, index) {
    for(let cur = heap[index];;){
        let childIndex = (index << 1) + 1;
        if (childIndex >= heap.length) break;
        let child = heap[childIndex];
        if (childIndex + 1 < heap.length && child.compare(heap[childIndex + 1]) >= 0) {
            child = heap[childIndex + 1];
            childIndex++;
        }
        if (cur.compare(child) < 0) break;
        heap[childIndex] = cur;
        heap[index] = child;
        index = childIndex;
    }
}
class $ccfb9497d8ef598f$var$SpanCursor {
    constructor(sets, skip, minPoint){
        this.minPoint = minPoint;
        this.active = [];
        this.activeTo = [];
        this.activeRank = [];
        this.minActive = -1;
        // A currently active point range, if any
        this.point = null;
        this.pointFrom = 0;
        this.pointRank = 0;
        this.to = -1000000000 /* C.Far */ ;
        this.endSide = 0;
        // The amount of open active ranges at the start of the iterator.
        // Not including points.
        this.openStart = -1;
        this.cursor = $ccfb9497d8ef598f$var$HeapCursor.from(sets, skip, minPoint);
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        this.cursor.goto(pos, side);
        this.active.length = this.activeTo.length = this.activeRank.length = 0;
        this.minActive = -1;
        this.to = pos;
        this.endSide = side;
        this.openStart = -1;
        this.next();
        return this;
    }
    forward(pos, side) {
        while(this.minActive > -1 && (this.activeTo[this.minActive] - pos || this.active[this.minActive].endSide - side) < 0)this.removeActive(this.minActive);
        this.cursor.forward(pos, side);
    }
    removeActive(index) {
        $ccfb9497d8ef598f$var$remove(this.active, index);
        $ccfb9497d8ef598f$var$remove(this.activeTo, index);
        $ccfb9497d8ef598f$var$remove(this.activeRank, index);
        this.minActive = $ccfb9497d8ef598f$var$findMinIndex(this.active, this.activeTo);
    }
    addActive(trackOpen) {
        let i = 0, { value: value, to: to, rank: rank } = this.cursor;
        while(i < this.activeRank.length && this.activeRank[i] <= rank)i++;
        $ccfb9497d8ef598f$var$insert(this.active, i, value);
        $ccfb9497d8ef598f$var$insert(this.activeTo, i, to);
        $ccfb9497d8ef598f$var$insert(this.activeRank, i, rank);
        if (trackOpen) $ccfb9497d8ef598f$var$insert(trackOpen, i, this.cursor.from);
        this.minActive = $ccfb9497d8ef598f$var$findMinIndex(this.active, this.activeTo);
    }
    // After calling this, if `this.point` != null, the next range is a
    // point. Otherwise, it's a regular range, covered by `this.active`.
    next() {
        let from = this.to, wasPoint = this.point;
        this.point = null;
        let trackOpen = this.openStart < 0 ? [] : null;
        for(;;){
            let a = this.minActive;
            if (a > -1 && (this.activeTo[a] - this.cursor.from || this.active[a].endSide - this.cursor.startSide) < 0) {
                if (this.activeTo[a] > from) {
                    this.to = this.activeTo[a];
                    this.endSide = this.active[a].endSide;
                    break;
                }
                this.removeActive(a);
                if (trackOpen) $ccfb9497d8ef598f$var$remove(trackOpen, a);
            } else if (!this.cursor.value) {
                this.to = this.endSide = 1000000000 /* C.Far */ ;
                break;
            } else if (this.cursor.from > from) {
                this.to = this.cursor.from;
                this.endSide = this.cursor.startSide;
                break;
            } else {
                let nextVal = this.cursor.value;
                if (!nextVal.point) {
                    this.addActive(trackOpen);
                    this.cursor.next();
                } else if (wasPoint && this.cursor.to == this.to && this.cursor.from < this.cursor.to) // Ignore any non-empty points that end precisely at the end of the prev point
                this.cursor.next();
                else {
                    this.point = nextVal;
                    this.pointFrom = this.cursor.from;
                    this.pointRank = this.cursor.rank;
                    this.to = this.cursor.to;
                    this.endSide = nextVal.endSide;
                    this.cursor.next();
                    this.forward(this.to, this.endSide);
                    break;
                }
            }
        }
        if (trackOpen) {
            this.openStart = 0;
            for(let i = trackOpen.length - 1; i >= 0 && trackOpen[i] < from; i--)this.openStart++;
        }
    }
    activeForPoint(to) {
        if (!this.active.length) return this.active;
        let active = [];
        for(let i = this.active.length - 1; i >= 0; i--){
            if (this.activeRank[i] < this.pointRank) break;
            if (this.activeTo[i] > to || this.activeTo[i] == to && this.active[i].endSide >= this.point.endSide) active.push(this.active[i]);
        }
        return active.reverse();
    }
    openEnd(to) {
        let open = 0;
        for(let i = this.activeTo.length - 1; i >= 0 && this.activeTo[i] > to; i--)open++;
        return open;
    }
}
function $ccfb9497d8ef598f$var$compare(a, startA, b, startB, length, comparator) {
    a.goto(startA);
    b.goto(startB);
    let endB = startB + length;
    let pos = startB, dPos = startB - startA;
    for(;;){
        let diff = a.to + dPos - b.to || a.endSide - b.endSide;
        let end = diff < 0 ? a.to + dPos : b.to, clipEnd = Math.min(end, endB);
        if (a.point || b.point) {
            if (!(a.point && b.point && (a.point == b.point || a.point.eq(b.point)) && $ccfb9497d8ef598f$var$sameValues(a.activeForPoint(a.to), b.activeForPoint(b.to)))) comparator.comparePoint(pos, clipEnd, a.point, b.point);
        } else if (clipEnd > pos && !$ccfb9497d8ef598f$var$sameValues(a.active, b.active)) comparator.compareRange(pos, clipEnd, a.active, b.active);
        if (end > endB) break;
        pos = end;
        if (diff <= 0) a.next();
        if (diff >= 0) b.next();
    }
}
function $ccfb9497d8ef598f$var$sameValues(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (a[i] != b[i] && !a[i].eq(b[i])) return false;
    return true;
}
function $ccfb9497d8ef598f$var$remove(array, index) {
    for(let i = index, e = array.length - 1; i < e; i++)array[i] = array[i + 1];
    array.pop();
}
function $ccfb9497d8ef598f$var$insert(array, index, value) {
    for(let i = array.length - 1; i >= index; i--)array[i + 1] = array[i];
    array[index] = value;
}
function $ccfb9497d8ef598f$var$findMinIndex(value, array) {
    let found = -1, foundPos = 1000000000 /* C.Far */ ;
    for(let i = 0; i < array.length; i++)if ((array[i] - foundPos || value[i].endSide - value[found].endSide) < 0) {
        found = i;
        foundPos = array[i];
    }
    return found;
}
/**
Count the column position at the given offset into the string,
taking extending characters and tab size into account.
*/ function $ccfb9497d8ef598f$export$20b4ab289374d0ac(string, tabSize, to = string.length) {
    let n = 0;
    for(let i = 0; i < to;)if (string.charCodeAt(i) == 9) {
        n += tabSize - n % tabSize;
        i++;
    } else {
        n++;
        i = $ccfb9497d8ef598f$export$a0fa439fd515e1ed(string, i);
    }
    return n;
}
/**
Find the offset that corresponds to the given column position in a
string, taking extending characters and tab size into account. By
default, the string length is returned when it is too short to
reach the column. Pass `strict` true to make it return -1 in that
situation.
*/ function $ccfb9497d8ef598f$export$718b3d71c384ca05(string, col, tabSize, strict) {
    for(let i = 0, n = 0;;){
        if (n >= col) return i;
        if (i == string.length) break;
        n += string.charCodeAt(i) == 9 ? tabSize - n % tabSize : 1;
        i = $ccfb9497d8ef598f$export$a0fa439fd515e1ed(string, i);
    }
    return strict === true ? -1 : string.length;
}

});

parcelRequire.register("jQ4bL", function(module, exports) {

$parcel$export(module.exports, "WidgetType", () => $e7161f778706e663$export$95cdd842edb044c5);
$parcel$export(module.exports, "Decoration", () => $e7161f778706e663$export$10e30b733df217ea);
$parcel$export(module.exports, "logException", () => $e7161f778706e663$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "ViewPlugin", () => $e7161f778706e663$export$44d5eccfd62adda7);
$parcel$export(module.exports, "Direction", () => $e7161f778706e663$export$cacd6541cfeeb6c1);
$parcel$export(module.exports, "EditorView", () => $e7161f778706e663$export$eece2fccabbb77c5);
$parcel$export(module.exports, "keymap", () => $e7161f778706e663$export$5043418e2ef368d5);
$parcel$export(module.exports, "showTooltip", () => $e7161f778706e663$export$dba11b50e1aa3c12);
$parcel$export(module.exports, "getTooltip", () => $e7161f778706e663$export$46455b4476d4b8e1);
$parcel$export(module.exports, "GutterMarker", () => $e7161f778706e663$export$591ab4c909549043);
$parcel$export(module.exports, "gutter", () => $e7161f778706e663$export$f2b922cb4a245974);

var $hB7kI = parcelRequire("hB7kI");

var $luNHI = parcelRequire("luNHI");

var $lNHdE = parcelRequire("lNHdE");
function $e7161f778706e663$var$getSelection(root) {
    let target;
    // Browsers differ on whether shadow roots have a getSelection
    // method. If it exists, use that, otherwise, call it on the
    // document.
    if (root.nodeType == 11) target = root.getSelection ? root : root.ownerDocument;
    else target = root;
    return target.getSelection();
}
function $e7161f778706e663$var$contains(dom, node) {
    return node ? dom == node || dom.contains(node.nodeType != 1 ? node.parentNode : node) : false;
}
function $e7161f778706e663$var$deepActiveElement(doc) {
    let elt = doc.activeElement;
    while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
    return elt;
}
function $e7161f778706e663$var$hasSelection(dom, selection) {
    if (!selection.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return $e7161f778706e663$var$contains(dom, selection.anchorNode);
    } catch (_) {
        return false;
    }
}
function $e7161f778706e663$var$clientRectsFor(dom) {
    if (dom.nodeType == 3) return $e7161f778706e663$var$textRange(dom, 0, dom.nodeValue.length).getClientRects();
    else if (dom.nodeType == 1) return dom.getClientRects();
    else return [];
}
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
function $e7161f778706e663$var$isEquivalentPosition(node, off, targetNode, targetOff) {
    return targetNode ? $e7161f778706e663$var$scanFor(node, off, targetNode, targetOff, -1) || $e7161f778706e663$var$scanFor(node, off, targetNode, targetOff, 1) : false;
}
function $e7161f778706e663$var$domIndex(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
}
function $e7161f778706e663$var$scanFor(node, off, targetNode, targetOff, dir) {
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $e7161f778706e663$var$maxOffset(node))) {
            if (node.nodeName == "DIV") return false;
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1) return false;
            off = $e7161f778706e663$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.nodeType == 1 && node.contentEditable == "false") return false;
            off = dir < 0 ? $e7161f778706e663$var$maxOffset(node) : 0;
        } else return false;
    }
}
function $e7161f778706e663$var$maxOffset(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $e7161f778706e663$var$flattenRect(rect, left) {
    let x = left ? rect.left : rect.right;
    return {
        left: x,
        right: x,
        top: rect.top,
        bottom: rect.bottom
    };
}
function $e7161f778706e663$var$windowRect(win) {
    return {
        left: 0,
        right: win.innerWidth,
        top: 0,
        bottom: win.innerHeight
    };
}
function $e7161f778706e663$var$scrollRectIntoView(dom, rect, side, x, y, xMargin, yMargin, ltr) {
    let doc = dom.ownerDocument, win = doc.defaultView || window;
    for(let cur = dom; cur;){
        if (cur.nodeType == 1) {
            let bounding, top = cur == doc.body;
            if (top) bounding = $e7161f778706e663$var$windowRect(win);
            else {
                if (cur.scrollHeight <= cur.clientHeight && cur.scrollWidth <= cur.clientWidth) {
                    cur = cur.assignedSlot || cur.parentNode;
                    continue;
                }
                let rect = cur.getBoundingClientRect();
                // Make sure scrollbar width isn't included in the rectangle
                bounding = {
                    left: rect.left,
                    right: rect.left + cur.clientWidth,
                    top: rect.top,
                    bottom: rect.top + cur.clientHeight
                };
            }
            let moveX = 0, moveY = 0;
            if (y == "nearest") {
                if (rect.top < bounding.top) {
                    moveY = -(bounding.top - rect.top + yMargin);
                    if (side > 0 && rect.bottom > bounding.bottom + moveY) moveY = rect.bottom - bounding.bottom + moveY + yMargin;
                } else if (rect.bottom > bounding.bottom) {
                    moveY = rect.bottom - bounding.bottom + yMargin;
                    if (side < 0 && rect.top - moveY < bounding.top) moveY = -(bounding.top + moveY - rect.top + yMargin);
                }
            } else {
                let rectHeight = rect.bottom - rect.top, boundingHeight = bounding.bottom - bounding.top;
                let targetTop = y == "center" && rectHeight <= boundingHeight ? rect.top + rectHeight / 2 - boundingHeight / 2 : y == "start" || y == "center" && side < 0 ? rect.top - yMargin : rect.bottom - boundingHeight + yMargin;
                moveY = targetTop - bounding.top;
            }
            if (x == "nearest") {
                if (rect.left < bounding.left) {
                    moveX = -(bounding.left - rect.left + xMargin);
                    if (side > 0 && rect.right > bounding.right + moveX) moveX = rect.right - bounding.right + moveX + xMargin;
                } else if (rect.right > bounding.right) {
                    moveX = rect.right - bounding.right + xMargin;
                    if (side < 0 && rect.left < bounding.left + moveX) moveX = -(bounding.left + moveX - rect.left + xMargin);
                }
            } else {
                let targetLeft = x == "center" ? rect.left + (rect.right - rect.left) / 2 - (bounding.right - bounding.left) / 2 : x == "start" == ltr ? rect.left - xMargin : rect.right - (bounding.right - bounding.left) + xMargin;
                moveX = targetLeft - bounding.left;
            }
            if (moveX || moveY) {
                if (top) win.scrollBy(moveX, moveY);
                else {
                    let movedX = 0, movedY = 0;
                    if (moveY) {
                        let start = cur.scrollTop;
                        cur.scrollTop += moveY;
                        movedY = cur.scrollTop - start;
                    }
                    if (moveX) {
                        let start = cur.scrollLeft;
                        cur.scrollLeft += moveX;
                        movedX = cur.scrollLeft - start;
                    }
                    rect = {
                        left: rect.left - movedX,
                        top: rect.top - movedY,
                        right: rect.right - movedX,
                        bottom: rect.bottom - movedY
                    };
                    if (movedX && Math.abs(movedX - moveX) < 1) x = "nearest";
                    if (movedY && Math.abs(movedY - moveY) < 1) y = "nearest";
                }
            }
            if (top) break;
            cur = cur.assignedSlot || cur.parentNode;
        } else if (cur.nodeType == 11) cur = cur.host;
        else break;
    }
}
function $e7161f778706e663$var$scrollableParent(dom) {
    let doc = dom.ownerDocument;
    for(let cur = dom.parentNode; cur;){
        if (cur == doc.body) break;
        else if (cur.nodeType == 1) {
            if (cur.scrollHeight > cur.clientHeight || cur.scrollWidth > cur.clientWidth) return cur;
            cur = cur.assignedSlot || cur.parentNode;
        } else if (cur.nodeType == 11) cur = cur.host;
        else break;
    }
    return null;
}
class $e7161f778706e663$var$DOMSelectionState {
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    eq(domSel) {
        return this.anchorNode == domSel.anchorNode && this.anchorOffset == domSel.anchorOffset && this.focusNode == domSel.focusNode && this.focusOffset == domSel.focusOffset;
    }
    setRange(range) {
        let { anchorNode: anchorNode, focusNode: focusNode } = range;
        // Clip offsets to node size to avoid crashes when Safari reports bogus offsets (#1152)
        this.set(anchorNode, Math.min(range.anchorOffset, anchorNode ? $e7161f778706e663$var$maxOffset(anchorNode) : 0), focusNode, Math.min(range.focusOffset, focusNode ? $e7161f778706e663$var$maxOffset(focusNode) : 0));
    }
    set(anchorNode, anchorOffset, focusNode, focusOffset) {
        this.anchorNode = anchorNode;
        this.anchorOffset = anchorOffset;
        this.focusNode = focusNode;
        this.focusOffset = focusOffset;
    }
}
let $e7161f778706e663$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $e7161f778706e663$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($e7161f778706e663$var$preventScrollSupported) return dom.focus($e7161f778706e663$var$preventScrollSupported);
    let stack = [];
    for(let cur = dom; cur; cur = cur.parentNode){
        stack.push(cur, cur.scrollTop, cur.scrollLeft);
        if (cur == cur.ownerDocument) break;
    }
    dom.focus($e7161f778706e663$var$preventScrollSupported == null ? {
        get preventScroll () {
            $e7161f778706e663$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$e7161f778706e663$var$preventScrollSupported) {
        $e7161f778706e663$var$preventScrollSupported = false;
        for(let i = 0; i < stack.length;){
            let elt = stack[i++], top = stack[i++], left = stack[i++];
            if (elt.scrollTop != top) elt.scrollTop = top;
            if (elt.scrollLeft != left) elt.scrollLeft = left;
        }
    }
}
let $e7161f778706e663$var$scratchRange;
function $e7161f778706e663$var$textRange(node, from, to = from) {
    let range = $e7161f778706e663$var$scratchRange || ($e7161f778706e663$var$scratchRange = document.createRange());
    range.setEnd(node, to);
    range.setStart(node, from);
    return range;
}
function $e7161f778706e663$var$dispatchKey(elt, name, code) {
    let options = {
        key: name,
        code: name,
        keyCode: code,
        which: code,
        cancelable: true
    };
    let down = new KeyboardEvent("keydown", options);
    down.synthetic = true;
    elt.dispatchEvent(down);
    let up = new KeyboardEvent("keyup", options);
    up.synthetic = true;
    elt.dispatchEvent(up);
    return down.defaultPrevented || up.defaultPrevented;
}
function $e7161f778706e663$var$getRoot(node) {
    while(node){
        if (node && (node.nodeType == 9 || node.nodeType == 11 && node.host)) return node;
        node = node.assignedSlot || node.parentNode;
    }
    return null;
}
function $e7161f778706e663$var$clearAttributes(node) {
    while(node.attributes.length)node.removeAttributeNode(node.attributes[0]);
}
function $e7161f778706e663$var$atElementStart(doc, selection) {
    let node = selection.focusNode, offset = selection.focusOffset;
    if (!node || selection.anchorNode != node || selection.anchorOffset != offset) return false;
    // Safari can report bogus offsets (#1152)
    offset = Math.min(offset, $e7161f778706e663$var$maxOffset(node));
    for(;;){
        if (offset) {
            if (node.nodeType != 1) return false;
            let prev = node.childNodes[offset - 1];
            if (prev.contentEditable == "false") offset--;
            else {
                node = prev;
                offset = $e7161f778706e663$var$maxOffset(node);
            }
        } else if (node == doc) return true;
        else {
            offset = $e7161f778706e663$var$domIndex(node);
            node = node.parentNode;
        }
    }
}
class $e7161f778706e663$var$DOMPos {
    constructor(node, offset, precise = true){
        this.node = node;
        this.offset = offset;
        this.precise = precise;
    }
    static before(dom, precise) {
        return new $e7161f778706e663$var$DOMPos(dom.parentNode, $e7161f778706e663$var$domIndex(dom), precise);
    }
    static after(dom, precise) {
        return new $e7161f778706e663$var$DOMPos(dom.parentNode, $e7161f778706e663$var$domIndex(dom) + 1, precise);
    }
}
const $e7161f778706e663$var$noChildren = [];
class $e7161f778706e663$var$ContentView {
    constructor(){
        this.parent = null;
        this.dom = null;
        this.dirty = 2 /* Node */ ;
    }
    get overrideDOMText() {
        return null;
    }
    get posAtStart() {
        return this.parent ? this.parent.posBefore(this) : 0;
    }
    get posAtEnd() {
        return this.posAtStart + this.length;
    }
    posBefore(view) {
        let pos = this.posAtStart;
        for (let child of this.children){
            if (child == view) return pos;
            pos += child.length + child.breakAfter;
        }
        throw new RangeError("Invalid child in posBefore");
    }
    posAfter(view) {
        return this.posBefore(view) + view.length;
    }
    sync(view, track) {
        if (this.dirty & 2 /* Node */ ) {
            let parent = this.dom;
            let prev = null, next;
            for (let child of this.children){
                if (child.dirty) {
                    if (!child.dom && (next = prev ? prev.nextSibling : parent.firstChild)) {
                        let contentView = $e7161f778706e663$var$ContentView.get(next);
                        if (!contentView || !contentView.parent && contentView.canReuseDOM(child)) child.reuseDOM(next);
                    }
                    child.sync(view, track);
                    child.dirty = 0 /* Not */ ;
                }
                next = prev ? prev.nextSibling : parent.firstChild;
                if (track && !track.written && track.node == parent && next != child.dom) track.written = true;
                if (child.dom.parentNode == parent) while(next && next != child.dom)next = $e7161f778706e663$var$rm$1(next);
                else parent.insertBefore(child.dom, next);
                prev = child.dom;
            }
            next = prev ? prev.nextSibling : parent.firstChild;
            if (next && track && track.node == parent) track.written = true;
            while(next)next = $e7161f778706e663$var$rm$1(next);
        } else if (this.dirty & 1 /* Child */ ) {
            for (let child of this.children)if (child.dirty) {
                child.sync(view, track);
                child.dirty = 0 /* Not */ ;
            }
        }
    }
    reuseDOM(_dom) {}
    localPosFromDOM(node, offset) {
        let after;
        if (node == this.dom) after = this.dom.childNodes[offset];
        else {
            let bias = $e7161f778706e663$var$maxOffset(node) == 0 ? 0 : offset == 0 ? -1 : 1;
            for(;;){
                let parent = node.parentNode;
                if (parent == this.dom) break;
                if (bias == 0 && parent.firstChild != parent.lastChild) {
                    if (node == parent.firstChild) bias = -1;
                    else bias = 1;
                }
                node = parent;
            }
            if (bias < 0) after = node;
            else after = node.nextSibling;
        }
        if (after == this.dom.firstChild) return 0;
        while(after && !$e7161f778706e663$var$ContentView.get(after))after = after.nextSibling;
        if (!after) return this.length;
        for(let i = 0, pos = 0;; i++){
            let child = this.children[i];
            if (child.dom == after) return pos;
            pos += child.length + child.breakAfter;
        }
    }
    domBoundsAround(from, to, offset = 0) {
        let fromI = -1, fromStart = -1, toI = -1, toEnd = -1;
        for(let i = 0, pos = offset, prevEnd = offset; i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            if (pos < from && end > to) return child.domBoundsAround(from, to, pos);
            if (end >= from && fromI == -1) {
                fromI = i;
                fromStart = pos;
            }
            if (pos > to && child.dom.parentNode == this.dom) {
                toI = i;
                toEnd = prevEnd;
                break;
            }
            prevEnd = end;
            pos = end + child.breakAfter;
        }
        return {
            from: fromStart,
            to: toEnd < 0 ? offset + this.length : toEnd,
            startDOM: (fromI ? this.children[fromI - 1].dom.nextSibling : null) || this.dom.firstChild,
            endDOM: toI < this.children.length && toI >= 0 ? this.children[toI].dom : null
        };
    }
    markDirty(andParent = false) {
        this.dirty |= 2 /* Node */ ;
        this.markParentsDirty(andParent);
    }
    markParentsDirty(childList) {
        for(let parent = this.parent; parent; parent = parent.parent){
            if (childList) parent.dirty |= 2 /* Node */ ;
            if (parent.dirty & 1 /* Child */ ) return;
            parent.dirty |= 1 /* Child */ ;
            childList = false;
        }
    }
    setParent(parent) {
        if (this.parent != parent) {
            this.parent = parent;
            if (this.dirty) this.markParentsDirty(true);
        }
    }
    setDOM(dom) {
        if (this.dom) this.dom.cmView = null;
        this.dom = dom;
        dom.cmView = this;
    }
    get rootView() {
        for(let v = this;;){
            let parent = v.parent;
            if (!parent) return v;
            v = parent;
        }
    }
    replaceChildren(from, to, children = $e7161f778706e663$var$noChildren) {
        this.markDirty();
        for(let i = from; i < to; i++){
            let child = this.children[i];
            if (child.parent == this) child.destroy();
        }
        this.children.splice(from, to - from, ...children);
        for(let i = 0; i < children.length; i++)children[i].setParent(this);
    }
    ignoreMutation(_rec) {
        return false;
    }
    ignoreEvent(_event) {
        return false;
    }
    childCursor(pos = this.length) {
        return new $e7161f778706e663$var$ChildCursor(this.children, pos, this.children.length);
    }
    childPos(pos, bias = 1) {
        return this.childCursor().findPos(pos, bias);
    }
    toString() {
        let name = this.constructor.name.replace("View", "");
        return name + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (name == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
    }
    static get(node) {
        return node.cmView;
    }
    get isEditable() {
        return true;
    }
    get isWidget() {
        return false;
    }
    get isHidden() {
        return false;
    }
    merge(from, to, source, hasStart, openStart, openEnd) {
        return false;
    }
    become(other) {
        return false;
    }
    canReuseDOM(other) {
        return other.constructor == this.constructor;
    }
    // When this is a zero-length view with a side, this should return a
    // number <= 0 to indicate it is before its position, or a
    // number > 0 when after its position.
    getSide() {
        return 0;
    }
    destroy() {
        this.parent = null;
    }
}
$e7161f778706e663$var$ContentView.prototype.breakAfter = 0;
// Remove a DOM node and return its next sibling.
function $e7161f778706e663$var$rm$1(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
class $e7161f778706e663$var$ChildCursor {
    constructor(children, pos, i){
        this.children = children;
        this.pos = pos;
        this.i = i;
        this.off = 0;
    }
    findPos(pos, bias = 1) {
        for(;;){
            if (pos > this.pos || pos == this.pos && (bias > 0 || this.i == 0 || this.children[this.i - 1].breakAfter)) {
                this.off = pos - this.pos;
                return this;
            }
            let next = this.children[--this.i];
            this.pos -= next.length + next.breakAfter;
        }
    }
}
function $e7161f778706e663$var$replaceRange(parent, fromI, fromOff, toI, toOff, insert, breakAtStart, openStart, openEnd) {
    let { children: children } = parent;
    let before = children.length ? children[fromI] : null;
    let last = insert.length ? insert[insert.length - 1] : null;
    let breakAtEnd = last ? last.breakAfter : breakAtStart;
    // Change within a single child
    if (fromI == toI && before && !breakAtStart && !breakAtEnd && insert.length < 2 && before.merge(fromOff, toOff, insert.length ? last : null, fromOff == 0, openStart, openEnd)) return;
    if (toI < children.length) {
        let after = children[toI];
        // Make sure the end of the child after the update is preserved in `after`
        if (after && toOff < after.length) {
            // If we're splitting a child, separate part of it to avoid that
            // being mangled when updating the child before the update.
            if (fromI == toI) {
                after = after.split(toOff);
                toOff = 0;
            }
            // If the element after the replacement should be merged with
            // the last replacing element, update `content`
            if (!breakAtEnd && last && after.merge(0, toOff, last, true, 0, openEnd)) insert[insert.length - 1] = after;
            else {
                // Remove the start of the after element, if necessary, and
                // add it to `content`.
                if (toOff) after.merge(0, toOff, null, false, 0, openEnd);
                insert.push(after);
            }
        } else if (after === null || after === void 0 ? void 0 : after.breakAfter) {
            // The element at `toI` is entirely covered by this range.
            // Preserve its line break, if any.
            if (last) last.breakAfter = 1;
            else breakAtStart = 1;
        }
        // Since we've handled the next element from the current elements
        // now, make sure `toI` points after that.
        toI++;
    }
    if (before) {
        before.breakAfter = breakAtStart;
        if (fromOff > 0) {
            if (!breakAtStart && insert.length && before.merge(fromOff, before.length, insert[0], false, openStart, 0)) before.breakAfter = insert.shift().breakAfter;
            else if (fromOff < before.length || before.children.length && before.children[before.children.length - 1].length == 0) before.merge(fromOff, before.length, null, false, openStart, 0);
            fromI++;
        }
    }
    // Try to merge widgets on the boundaries of the replacement
    while(fromI < toI && insert.length){
        if (children[toI - 1].become(insert[insert.length - 1])) {
            toI--;
            insert.pop();
            openEnd = insert.length ? 0 : openStart;
        } else if (children[fromI].become(insert[0])) {
            fromI++;
            insert.shift();
            openStart = insert.length ? 0 : openEnd;
        } else break;
    }
    if (!insert.length && fromI && toI < children.length && !children[fromI - 1].breakAfter && children[toI].merge(0, 0, children[fromI - 1], false, openStart, openEnd)) fromI--;
    if (fromI < toI || insert.length) parent.replaceChildren(fromI, toI, insert);
}
function $e7161f778706e663$var$mergeChildrenInto(parent, from, to, insert, openStart, openEnd) {
    let cur = parent.childCursor();
    let { i: toI, off: toOff } = cur.findPos(to, 1);
    let { i: fromI, off: fromOff } = cur.findPos(from, -1);
    let dLen = from - to;
    for (let view of insert)dLen += view.length;
    parent.length += dLen;
    $e7161f778706e663$var$replaceRange(parent, fromI, fromOff, toI, toOff, insert, 0, openStart, openEnd);
}
let $e7161f778706e663$var$nav = typeof navigator != "undefined" ? navigator : {
    userAgent: "",
    vendor: "",
    platform: ""
};
let $e7161f778706e663$var$doc = typeof document != "undefined" ? document : {
    documentElement: {
        style: {}
    }
};
const $e7161f778706e663$var$ie_edge = /*@__PURE__*/ /Edge\/(\d+)/.exec($e7161f778706e663$var$nav.userAgent);
const $e7161f778706e663$var$ie_upto10 = /*@__PURE__*/ /MSIE \d/.test($e7161f778706e663$var$nav.userAgent);
const $e7161f778706e663$var$ie_11up = /*@__PURE__*/ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($e7161f778706e663$var$nav.userAgent);
const $e7161f778706e663$var$ie = !!($e7161f778706e663$var$ie_upto10 || $e7161f778706e663$var$ie_11up || $e7161f778706e663$var$ie_edge);
const $e7161f778706e663$var$gecko = !$e7161f778706e663$var$ie && /*@__PURE__*/ /gecko\/(\d+)/i.test($e7161f778706e663$var$nav.userAgent);
const $e7161f778706e663$var$chrome = !$e7161f778706e663$var$ie && /*@__PURE__*/ /Chrome\/(\d+)/.exec($e7161f778706e663$var$nav.userAgent);
const $e7161f778706e663$var$webkit = "webkitFontSmoothing" in $e7161f778706e663$var$doc.documentElement.style;
const $e7161f778706e663$var$safari = !$e7161f778706e663$var$ie && /*@__PURE__*/ /Apple Computer/.test($e7161f778706e663$var$nav.vendor);
const $e7161f778706e663$var$ios = $e7161f778706e663$var$safari && /*@__PURE__*/ (/Mobile\/\w+/.test($e7161f778706e663$var$nav.userAgent) || $e7161f778706e663$var$nav.maxTouchPoints > 2);
var $e7161f778706e663$var$browser = {
    mac: $e7161f778706e663$var$ios || /*@__PURE__*/ /Mac/.test($e7161f778706e663$var$nav.platform),
    windows: /*@__PURE__*/ /Win/.test($e7161f778706e663$var$nav.platform),
    linux: /*@__PURE__*/ /Linux|X11/.test($e7161f778706e663$var$nav.platform),
    ie: $e7161f778706e663$var$ie,
    ie_version: $e7161f778706e663$var$ie_upto10 ? $e7161f778706e663$var$doc.documentMode || 6 : $e7161f778706e663$var$ie_11up ? +$e7161f778706e663$var$ie_11up[1] : $e7161f778706e663$var$ie_edge ? +$e7161f778706e663$var$ie_edge[1] : 0,
    gecko: $e7161f778706e663$var$gecko,
    gecko_version: $e7161f778706e663$var$gecko ? +/*@__PURE__*/ (/Firefox\/(\d+)/.exec($e7161f778706e663$var$nav.userAgent) || [
        0,
        0
    ])[1] : 0,
    chrome: !!$e7161f778706e663$var$chrome,
    chrome_version: $e7161f778706e663$var$chrome ? +$e7161f778706e663$var$chrome[1] : 0,
    ios: $e7161f778706e663$var$ios,
    android: /*@__PURE__*/ /Android\b/.test($e7161f778706e663$var$nav.userAgent),
    webkit: $e7161f778706e663$var$webkit,
    safari: $e7161f778706e663$var$safari,
    webkit_version: $e7161f778706e663$var$webkit ? +/*@__PURE__*/ (/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
        0,
        0
    ])[1] : 0,
    tabSize: $e7161f778706e663$var$doc.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
const $e7161f778706e663$var$MaxJoinLen = 256;
class $e7161f778706e663$var$TextView extends $e7161f778706e663$var$ContentView {
    constructor(text){
        super();
        this.text = text;
    }
    get length() {
        return this.text.length;
    }
    createDOM(textDOM) {
        this.setDOM(textDOM || document.createTextNode(this.text));
    }
    sync(view, track) {
        if (!this.dom) this.createDOM();
        if (this.dom.nodeValue != this.text) {
            if (track && track.node == this.dom) track.written = true;
            this.dom.nodeValue = this.text;
        }
    }
    reuseDOM(dom) {
        if (dom.nodeType == 3) this.createDOM(dom);
    }
    merge(from, to, source) {
        if (source && (!(source instanceof $e7161f778706e663$var$TextView) || this.length - (to - from) + source.length > $e7161f778706e663$var$MaxJoinLen)) return false;
        this.text = this.text.slice(0, from) + (source ? source.text : "") + this.text.slice(to);
        this.markDirty();
        return true;
    }
    split(from) {
        let result = new $e7161f778706e663$var$TextView(this.text.slice(from));
        this.text = this.text.slice(0, from);
        this.markDirty();
        return result;
    }
    localPosFromDOM(node, offset) {
        return node == this.dom ? offset : offset ? this.text.length : 0;
    }
    domAtPos(pos) {
        return new $e7161f778706e663$var$DOMPos(this.dom, pos);
    }
    domBoundsAround(_from, _to, offset) {
        return {
            from: offset,
            to: offset + this.length,
            startDOM: this.dom,
            endDOM: this.dom.nextSibling
        };
    }
    coordsAt(pos, side) {
        return $e7161f778706e663$var$textCoords(this.dom, pos, side);
    }
}
class $e7161f778706e663$var$MarkView extends $e7161f778706e663$var$ContentView {
    constructor(mark, children = [], length = 0){
        super();
        this.mark = mark;
        this.children = children;
        this.length = length;
        for (let ch of children)ch.setParent(this);
    }
    setAttrs(dom) {
        $e7161f778706e663$var$clearAttributes(dom);
        if (this.mark.class) dom.className = this.mark.class;
        if (this.mark.attrs) for(let name in this.mark.attrs)dom.setAttribute(name, this.mark.attrs[name]);
        return dom;
    }
    reuseDOM(node) {
        if (node.nodeName == this.mark.tagName.toUpperCase()) {
            this.setDOM(node);
            this.dirty |= 6 /* Node */ ;
        }
    }
    sync(view, track) {
        if (!this.dom) this.setDOM(this.setAttrs(document.createElement(this.mark.tagName)));
        else if (this.dirty & 4 /* Attrs */ ) this.setAttrs(this.dom);
        super.sync(view, track);
    }
    merge(from, to, source, _hasStart, openStart, openEnd) {
        if (source && (!(source instanceof $e7161f778706e663$var$MarkView && source.mark.eq(this.mark)) || from && openStart <= 0 || to < this.length && openEnd <= 0)) return false;
        $e7161f778706e663$var$mergeChildrenInto(this, from, to, source ? source.children : [], openStart - 1, openEnd - 1);
        this.markDirty();
        return true;
    }
    split(from) {
        let result = [], off = 0, detachFrom = -1, i = 0;
        for (let elt of this.children){
            let end = off + elt.length;
            if (end > from) result.push(off < from ? elt.split(from - off) : elt);
            if (detachFrom < 0 && off >= from) detachFrom = i;
            off = end;
            i++;
        }
        let length = this.length - from;
        this.length = from;
        if (detachFrom > -1) {
            this.children.length = detachFrom;
            this.markDirty();
        }
        return new $e7161f778706e663$var$MarkView(this.mark, result, length);
    }
    domAtPos(pos) {
        return $e7161f778706e663$var$inlineDOMAtPos(this, pos);
    }
    coordsAt(pos, side) {
        return $e7161f778706e663$var$coordsInChildren(this, pos, side);
    }
}
function $e7161f778706e663$var$textCoords(text, pos, side) {
    let length = text.nodeValue.length;
    if (pos > length) pos = length;
    let from = pos, to = pos, flatten = 0;
    if (pos == 0 && side < 0 || pos == length && side >= 0) {
        if (!($e7161f778706e663$var$browser.chrome || $e7161f778706e663$var$browser.gecko)) {
            if (pos) {
                from--;
                flatten = 1;
            } else if (to < length) {
                to++;
                flatten = -1;
            }
        }
    } else {
        if (side < 0) from--;
        else if (to < length) to++;
    }
    let rects = $e7161f778706e663$var$textRange(text, from, to).getClientRects();
    if (!rects.length) return null;
    let rect = rects[(flatten ? flatten < 0 : side >= 0) ? 0 : rects.length - 1];
    if ($e7161f778706e663$var$browser.safari && !flatten && rect.width == 0) rect = Array.prototype.find.call(rects, (r)=>r.width) || rect;
    return flatten ? $e7161f778706e663$var$flattenRect(rect, flatten < 0) : rect || null;
}
// Also used for collapsed ranges that don't have a placeholder widget!
class $e7161f778706e663$var$WidgetView extends $e7161f778706e663$var$ContentView {
    constructor(widget, length, side){
        super();
        this.widget = widget;
        this.length = length;
        this.side = side;
        this.prevWidget = null;
    }
    static create(widget, length, side) {
        return new (widget.customView || $e7161f778706e663$var$WidgetView)(widget, length, side);
    }
    split(from) {
        let result = $e7161f778706e663$var$WidgetView.create(this.widget, this.length - from, this.side);
        this.length -= from;
        return result;
    }
    sync(view) {
        if (!this.dom || !this.widget.updateDOM(this.dom, view)) {
            if (this.dom && this.prevWidget) this.prevWidget.destroy(this.dom);
            this.prevWidget = null;
            this.setDOM(this.widget.toDOM(view));
            this.dom.contentEditable = "false";
        }
    }
    getSide() {
        return this.side;
    }
    merge(from, to, source, hasStart, openStart, openEnd) {
        if (source && (!(source instanceof $e7161f778706e663$var$WidgetView) || !this.widget.compare(source.widget) || from > 0 && openStart <= 0 || to < this.length && openEnd <= 0)) return false;
        this.length = from + (source ? source.length : 0) + (this.length - to);
        return true;
    }
    become(other) {
        if (other instanceof $e7161f778706e663$var$WidgetView && other.side == this.side && this.widget.constructor == other.widget.constructor) {
            if (!this.widget.compare(other.widget)) this.markDirty(true);
            if (this.dom && !this.prevWidget) this.prevWidget = this.widget;
            this.widget = other.widget;
            this.length = other.length;
            return true;
        }
        return false;
    }
    ignoreMutation() {
        return true;
    }
    ignoreEvent(event) {
        return this.widget.ignoreEvent(event);
    }
    get overrideDOMText() {
        if (this.length == 0) return (0, $hB7kI.Text).empty;
        let top = this;
        while(top.parent)top = top.parent;
        let { view: view } = top, text = view && view.state.doc, start = this.posAtStart;
        return text ? text.slice(start, start + this.length) : (0, $hB7kI.Text).empty;
    }
    domAtPos(pos) {
        return (this.length ? pos == 0 : this.side > 0) ? $e7161f778706e663$var$DOMPos.before(this.dom) : $e7161f778706e663$var$DOMPos.after(this.dom, pos == this.length);
    }
    domBoundsAround() {
        return null;
    }
    coordsAt(pos, side) {
        let custom = this.widget.coordsAt(this.dom, pos, side);
        if (custom) return custom;
        let rects = this.dom.getClientRects(), rect = null;
        if (!rects.length) return null;
        let fromBack = this.side ? this.side < 0 : pos > 0;
        for(let i = fromBack ? rects.length - 1 : 0;; i += fromBack ? -1 : 1){
            rect = rects[i];
            if (pos > 0 ? i == 0 : i == rects.length - 1 || rect.top < rect.bottom) break;
        }
        return $e7161f778706e663$var$flattenRect(rect, !fromBack);
    }
    get isEditable() {
        return false;
    }
    get isWidget() {
        return true;
    }
    get isHidden() {
        return this.widget.isHidden;
    }
    destroy() {
        super.destroy();
        if (this.dom) this.widget.destroy(this.dom);
    }
}
class $e7161f778706e663$var$CompositionView extends $e7161f778706e663$var$WidgetView {
    domAtPos(pos) {
        let { topView: topView, text: text } = this.widget;
        if (!topView) return new $e7161f778706e663$var$DOMPos(text, Math.min(pos, text.nodeValue.length));
        return $e7161f778706e663$var$scanCompositionTree(pos, 0, topView, text, this.length - topView.length, (v, p)=>v.domAtPos(p), (text, p)=>new $e7161f778706e663$var$DOMPos(text, Math.min(p, text.nodeValue.length)));
    }
    sync() {
        this.setDOM(this.widget.toDOM());
    }
    localPosFromDOM(node, offset) {
        let { topView: topView, text: text } = this.widget;
        if (!topView) return Math.min(offset, this.length);
        return $e7161f778706e663$var$posFromDOMInCompositionTree(node, offset, topView, text, this.length - topView.length);
    }
    ignoreMutation() {
        return false;
    }
    get overrideDOMText() {
        return null;
    }
    coordsAt(pos, side) {
        let { topView: topView, text: text } = this.widget;
        if (!topView) return $e7161f778706e663$var$textCoords(text, pos, side);
        return $e7161f778706e663$var$scanCompositionTree(pos, side, topView, text, this.length - topView.length, (v, pos, side)=>v.coordsAt(pos, side), (text, pos, side)=>$e7161f778706e663$var$textCoords(text, pos, side));
    }
    destroy() {
        var _a;
        super.destroy();
        (_a = this.widget.topView) === null || _a === void 0 || _a.destroy();
    }
    get isEditable() {
        return true;
    }
    canReuseDOM() {
        return true;
    }
}
// Uses the old structure of a chunk of content view frozen for
// composition to try and find a reasonable DOM location for the given
// offset.
function $e7161f778706e663$var$scanCompositionTree(pos, side, view, text, dLen, enterView, fromText) {
    if (view instanceof $e7161f778706e663$var$MarkView) {
        for(let child = view.dom.firstChild; child; child = child.nextSibling){
            let desc = $e7161f778706e663$var$ContentView.get(child);
            if (!desc) {
                let inner = $e7161f778706e663$var$scanCompositionNode(pos, side, child, fromText);
                if (typeof inner != "number") return inner;
                pos = inner;
            } else {
                let hasComp = $e7161f778706e663$var$contains(child, text);
                let len = desc.length + (hasComp ? dLen : 0);
                if (pos < len || pos == len && desc.getSide() <= 0) return hasComp ? $e7161f778706e663$var$scanCompositionTree(pos, side, desc, text, dLen, enterView, fromText) : enterView(desc, pos, side);
                pos -= len;
            }
        }
        return enterView(view, view.length, -1);
    } else if (view.dom == text) return fromText(text, pos, side);
    else return enterView(view, pos, side);
}
function $e7161f778706e663$var$scanCompositionNode(pos, side, node, fromText) {
    if (node.nodeType == 3) {
        let len = node.nodeValue.length;
        if (pos <= len) return fromText(node, pos, side);
        pos -= len;
    } else if (node.nodeType == 1 && node.contentEditable != "false") for(let child = node.firstChild; child; child = child.nextSibling){
        let inner = $e7161f778706e663$var$scanCompositionNode(pos, side, child, fromText);
        if (typeof inner != "number") return inner;
        pos = inner;
    }
    return pos;
}
function $e7161f778706e663$var$posFromDOMInCompositionTree(node, offset, view, text, dLen) {
    if (view instanceof $e7161f778706e663$var$MarkView) {
        let pos = 0;
        for(let child = view.dom.firstChild; child; child = child.nextSibling){
            let childView = $e7161f778706e663$var$ContentView.get(child);
            if (childView) {
                let hasComp = $e7161f778706e663$var$contains(child, text);
                if ($e7161f778706e663$var$contains(child, node)) return pos + (hasComp ? $e7161f778706e663$var$posFromDOMInCompositionTree(node, offset, childView, text, dLen) : childView.localPosFromDOM(node, offset));
                pos += childView.length + (hasComp ? dLen : 0);
            } else {
                let inner = $e7161f778706e663$var$posFromDOMInOpaqueNode(node, offset, child);
                if (inner.result != null) return pos + inner.result;
                pos += inner.size;
            }
        }
    } else if (view.dom == text) return Math.min(offset, text.nodeValue.length);
    return view.localPosFromDOM(node, offset);
}
function $e7161f778706e663$var$posFromDOMInOpaqueNode(node, offset, target) {
    if (target.nodeType == 3) return node == target ? {
        result: offset
    } : {
        size: target.nodeValue.length
    };
    else if (target.nodeType == 1 && target.contentEditable != "false") {
        let pos = 0;
        for(let child = target.firstChild, i = 0;; child = child.nextSibling, i++){
            if (node == target && i == offset) return {
                result: pos
            };
            if (!child) return {
                size: pos
            };
            let inner = $e7161f778706e663$var$posFromDOMInOpaqueNode(node, offset, child);
            if (inner.result != null) return {
                result: offset + inner.result
            };
            pos += inner.size;
        }
    } else return target.contains(node) ? {
        result: 0
    } : {
        size: 0
    };
}
// These are drawn around uneditable widgets to avoid a number of
// browser bugs that show up when the cursor is directly next to
// uneditable inline content.
class $e7161f778706e663$var$WidgetBufferView extends $e7161f778706e663$var$ContentView {
    constructor(side){
        super();
        this.side = side;
    }
    get length() {
        return 0;
    }
    merge() {
        return false;
    }
    become(other) {
        return other instanceof $e7161f778706e663$var$WidgetBufferView && other.side == this.side;
    }
    split() {
        return new $e7161f778706e663$var$WidgetBufferView(this.side);
    }
    sync() {
        if (!this.dom) {
            let dom = document.createElement("img");
            dom.className = "cm-widgetBuffer";
            dom.setAttribute("aria-hidden", "true");
            this.setDOM(dom);
        }
    }
    getSide() {
        return this.side;
    }
    domAtPos(pos) {
        return this.side > 0 ? $e7161f778706e663$var$DOMPos.before(this.dom) : $e7161f778706e663$var$DOMPos.after(this.dom);
    }
    localPosFromDOM() {
        return 0;
    }
    domBoundsAround() {
        return null;
    }
    coordsAt(pos) {
        return this.dom.getBoundingClientRect();
    }
    get overrideDOMText() {
        return (0, $hB7kI.Text).empty;
    }
    get isHidden() {
        return true;
    }
}
$e7161f778706e663$var$TextView.prototype.children = $e7161f778706e663$var$WidgetView.prototype.children = $e7161f778706e663$var$WidgetBufferView.prototype.children = $e7161f778706e663$var$noChildren;
function $e7161f778706e663$var$inlineDOMAtPos(parent, pos) {
    let dom = parent.dom, { children: children } = parent, i = 0;
    for(let off = 0; i < children.length; i++){
        let child = children[i], end = off + child.length;
        if (end == off && child.getSide() <= 0) continue;
        if (pos > off && pos < end && child.dom.parentNode == dom) return child.domAtPos(pos - off);
        if (pos <= off) break;
        off = end;
    }
    for(let j = i; j > 0; j--){
        let prev = children[j - 1];
        if (prev.dom.parentNode == dom) return prev.domAtPos(prev.length);
    }
    for(let j = i; j < children.length; j++){
        let next = children[j];
        if (next.dom.parentNode == dom) return next.domAtPos(0);
    }
    return new $e7161f778706e663$var$DOMPos(dom, 0);
}
// Assumes `view`, if a mark view, has precisely 1 child.
function $e7161f778706e663$var$joinInlineInto(parent, view, open) {
    let last, { children: children } = parent;
    if (open > 0 && view instanceof $e7161f778706e663$var$MarkView && children.length && (last = children[children.length - 1]) instanceof $e7161f778706e663$var$MarkView && last.mark.eq(view.mark)) $e7161f778706e663$var$joinInlineInto(last, view.children[0], open - 1);
    else {
        children.push(view);
        view.setParent(parent);
    }
    parent.length += view.length;
}
function $e7161f778706e663$var$coordsInChildren(view, pos, side) {
    let before = null, beforePos = -1, after = null, afterPos = -1;
    function scan(view, pos) {
        for(let i = 0, off = 0; i < view.children.length && off <= pos; i++){
            let child = view.children[i], end = off + child.length;
            if (end >= pos) {
                if (child.children.length) scan(child, pos - off);
                else if ((!after || after.isHidden && side > 0) && (end > pos || off == end && child.getSide() > 0)) {
                    after = child;
                    afterPos = pos - off;
                } else if (off < pos || off == end && child.getSide() < 0 && !child.isHidden) {
                    before = child;
                    beforePos = pos - off;
                }
            }
            off = end;
        }
    }
    scan(view, pos);
    let target = (side < 0 ? before : after) || before || after;
    if (target) return target.coordsAt(Math.max(0, target == before ? beforePos : afterPos), side);
    return $e7161f778706e663$var$fallbackRect(view);
}
function $e7161f778706e663$var$fallbackRect(view) {
    let last = view.dom.lastChild;
    if (!last) return view.dom.getBoundingClientRect();
    let rects = $e7161f778706e663$var$clientRectsFor(last);
    return rects[rects.length - 1] || null;
}
function $e7161f778706e663$var$combineAttrs(source, target) {
    for(let name in source){
        if (name == "class" && target.class) target.class += " " + source.class;
        else if (name == "style" && target.style) target.style += ";" + source.style;
        else target[name] = source[name];
    }
    return target;
}
function $e7161f778706e663$var$attrsEq(a, b) {
    if (a == b) return true;
    if (!a || !b) return false;
    let keysA = Object.keys(a), keysB = Object.keys(b);
    if (keysA.length != keysB.length) return false;
    for (let key of keysA){
        if (keysB.indexOf(key) == -1 || a[key] !== b[key]) return false;
    }
    return true;
}
function $e7161f778706e663$var$updateAttrs(dom, prev, attrs) {
    let changed = null;
    if (prev) {
        for(let name in prev)if (!(attrs && name in attrs)) dom.removeAttribute(changed = name);
    }
    if (attrs) {
        for(let name in attrs)if (!(prev && prev[name] == attrs[name])) dom.setAttribute(changed = name, attrs[name]);
    }
    return !!changed;
}
/**
Widgets added to the content are described by subclasses of this
class. Using a description object like that makes it possible to
delay creating of the DOM structure for a widget until it is
needed, and to avoid redrawing widgets even if the decorations
that define them are recreated.
*/ class $e7161f778706e663$export$95cdd842edb044c5 {
    /**
    Compare this instance to another instance of the same type.
    (TypeScript can't express this, but only instances of the same
    specific class will be passed to this method.) This is used to
    avoid redrawing widgets when they are replaced by a new
    decoration of the same type. The default implementation just
    returns `false`, which will cause new instances of the widget to
    always be redrawn.
    */ eq(widget) {
        return false;
    }
    /**
    Update a DOM element created by a widget of the same type (but
    different, non-`eq` content) to reflect this widget. May return
    true to indicate that it could update, false to indicate it
    couldn't (in which case the widget will be redrawn). The default
    implementation just returns false.
    */ updateDOM(dom, view) {
        return false;
    }
    /**
    @internal
    */ compare(other) {
        return this == other || this.constructor == other.constructor && this.eq(other);
    }
    /**
    The estimated height this widget will have, to be used when
    estimating the height of content that hasn't been drawn. May
    return -1 to indicate you don't know. The default implementation
    returns -1.
    */ get estimatedHeight() {
        return -1;
    }
    /**
    For inline widgets that are displayed inline (as opposed to
    `inline-block`) and introduce line breaks (through `<br>` tags
    or textual newlines), this must indicate the amount of line
    breaks they introduce. Defaults to 0.
    */ get lineBreaks() {
        return 0;
    }
    /**
    Can be used to configure which kinds of events inside the widget
    should be ignored by the editor. The default is to ignore all
    events.
    */ ignoreEvent(event) {
        return true;
    }
    /**
    Override the way screen coordinates for positions at/in the
    widget are found. `pos` will be the offset into the widget, and
    `side` the side of the position that is being queried—less than
    zero for before, greater than zero for after, and zero for
    directly at that position.
    */ coordsAt(dom, pos, side) {
        return null;
    }
    /**
    @internal
    */ get customView() {
        return null;
    }
    /**
    @internal
    */ get isHidden() {
        return false;
    }
    /**
    This is called when the an instance of the widget is removed
    from the editor view.
    */ destroy(dom) {}
}
/**
The different types of blocks that can occur in an editor view.
*/ var $e7161f778706e663$export$48808c686fe495c4 = /*@__PURE__*/ function(BlockType) {
    /**
    A line of text.
    */ BlockType[BlockType["Text"] = 0] = "Text";
    /**
    A block widget associated with the position after it.
    */ BlockType[BlockType["WidgetBefore"] = 1] = "WidgetBefore";
    /**
    A block widget associated with the position before it.
    */ BlockType[BlockType["WidgetAfter"] = 2] = "WidgetAfter";
    /**
    A block widget [replacing](https://codemirror.net/6/docs/ref/#view.Decoration^replace) a range of content.
    */ BlockType[BlockType["WidgetRange"] = 3] = "WidgetRange";
    return BlockType;
}($e7161f778706e663$export$48808c686fe495c4 || ($e7161f778706e663$export$48808c686fe495c4 = {}));
/**
A decoration provides information on how to draw or style a piece
of content. You'll usually use it wrapped in a
[`Range`](https://codemirror.net/6/docs/ref/#state.Range), which adds a start and end position.
@nonabstract
*/ class $e7161f778706e663$export$10e30b733df217ea extends (0, $hB7kI.RangeValue) {
    constructor(/**
    @internal
    */ startSide, /**
    @internal
    */ endSide, /**
    @internal
    */ widget, /**
    The config object used to create this decoration. You can
    include additional properties in there to store metadata about
    your decoration.
    */ spec){
        super();
        this.startSide = startSide;
        this.endSide = endSide;
        this.widget = widget;
        this.spec = spec;
    }
    /**
    @internal
    */ get heightRelevant() {
        return false;
    }
    /**
    Create a mark decoration, which influences the styling of the
    content in its range. Nested mark decorations will cause nested
    DOM elements to be created. Nesting order is determined by
    precedence of the [facet](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), with
    the higher-precedence decorations creating the inner DOM nodes.
    Such elements are split on line boundaries and on the boundaries
    of lower-precedence decorations.
    */ static mark(spec) {
        return new $e7161f778706e663$var$MarkDecoration(spec);
    }
    /**
    Create a widget decoration, which displays a DOM element at the
    given position.
    */ static widget(spec) {
        let side = Math.max(-10000, Math.min(10000, spec.side || 0)), block = !!spec.block;
        side += block && !spec.inlineOrder ? side > 0 ? 300000000 /* BlockAfter */  : -400000000 /* BlockBefore */  : side > 0 ? 100000000 /* InlineAfter */  : -100000000 /* InlineBefore */ ;
        return new $e7161f778706e663$var$PointDecoration(spec, side, side, block, spec.widget || null, false);
    }
    /**
    Create a replace decoration which replaces the given range with
    a widget, or simply hides it.
    */ static replace(spec) {
        let block = !!spec.block, startSide, endSide;
        if (spec.isBlockGap) {
            startSide = -500000000 /* GapStart */ ;
            endSide = 400000000 /* GapEnd */ ;
        } else {
            let { start: start, end: end } = $e7161f778706e663$var$getInclusive(spec, block);
            startSide = (start ? block ? -300000000 /* BlockIncStart */  : -1 /* InlineIncStart */  : 500000000 /* NonIncStart */ ) - 1;
            endSide = (end ? block ? 200000000 /* BlockIncEnd */  : 1 /* InlineIncEnd */  : -600000000 /* NonIncEnd */ ) + 1;
        }
        return new $e7161f778706e663$var$PointDecoration(spec, startSide, endSide, block, spec.widget || null, true);
    }
    /**
    Create a line decoration, which can add DOM attributes to the
    line starting at the given position.
    */ static line(spec) {
        return new $e7161f778706e663$var$LineDecoration(spec);
    }
    /**
    Build a [`DecorationSet`](https://codemirror.net/6/docs/ref/#view.DecorationSet) from the given
    decorated range or ranges. If the ranges aren't already sorted,
    pass `true` for `sort` to make the library sort them for you.
    */ static set(of, sort = false) {
        return (0, $hB7kI.RangeSet).of(of, sort);
    }
    /**
    @internal
    */ hasHeight() {
        return this.widget ? this.widget.estimatedHeight > -1 : false;
    }
}
/**
The empty set of decorations.
*/ $e7161f778706e663$export$10e30b733df217ea.none = (0, $hB7kI.RangeSet).empty;
class $e7161f778706e663$var$MarkDecoration extends $e7161f778706e663$export$10e30b733df217ea {
    constructor(spec){
        let { start: start, end: end } = $e7161f778706e663$var$getInclusive(spec);
        super(start ? -1 /* InlineIncStart */  : 500000000 /* NonIncStart */ , end ? 1 /* InlineIncEnd */  : -600000000 /* NonIncEnd */ , null, spec);
        this.tagName = spec.tagName || "span";
        this.class = spec.class || "";
        this.attrs = spec.attributes || null;
    }
    eq(other) {
        return this == other || other instanceof $e7161f778706e663$var$MarkDecoration && this.tagName == other.tagName && this.class == other.class && $e7161f778706e663$var$attrsEq(this.attrs, other.attrs);
    }
    range(from, to = from) {
        if (from >= to) throw new RangeError("Mark decorations may not be empty");
        return super.range(from, to);
    }
}
$e7161f778706e663$var$MarkDecoration.prototype.point = false;
class $e7161f778706e663$var$LineDecoration extends $e7161f778706e663$export$10e30b733df217ea {
    constructor(spec){
        super(-200000000 /* Line */ , -200000000 /* Line */ , null, spec);
    }
    eq(other) {
        return other instanceof $e7161f778706e663$var$LineDecoration && this.spec.class == other.spec.class && $e7161f778706e663$var$attrsEq(this.spec.attributes, other.spec.attributes);
    }
    range(from, to = from) {
        if (to != from) throw new RangeError("Line decoration ranges must be zero-length");
        return super.range(from, to);
    }
}
$e7161f778706e663$var$LineDecoration.prototype.mapMode = (0, $hB7kI.MapMode).TrackBefore;
$e7161f778706e663$var$LineDecoration.prototype.point = true;
class $e7161f778706e663$var$PointDecoration extends $e7161f778706e663$export$10e30b733df217ea {
    constructor(spec, startSide, endSide, block, widget, isReplace){
        super(startSide, endSide, widget, spec);
        this.block = block;
        this.isReplace = isReplace;
        this.mapMode = !block ? (0, $hB7kI.MapMode).TrackDel : startSide <= 0 ? (0, $hB7kI.MapMode).TrackBefore : (0, $hB7kI.MapMode).TrackAfter;
    }
    // Only relevant when this.block == true
    get type() {
        return this.startSide < this.endSide ? $e7161f778706e663$export$48808c686fe495c4.WidgetRange : this.startSide <= 0 ? $e7161f778706e663$export$48808c686fe495c4.WidgetBefore : $e7161f778706e663$export$48808c686fe495c4.WidgetAfter;
    }
    get heightRelevant() {
        return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
    }
    eq(other) {
        return other instanceof $e7161f778706e663$var$PointDecoration && $e7161f778706e663$var$widgetsEq(this.widget, other.widget) && this.block == other.block && this.startSide == other.startSide && this.endSide == other.endSide;
    }
    range(from, to = from) {
        if (this.isReplace && (from > to || from == to && this.startSide > 0 && this.endSide <= 0)) throw new RangeError("Invalid range for replacement decoration");
        if (!this.isReplace && to != from) throw new RangeError("Widget decorations can only have zero-length ranges");
        return super.range(from, to);
    }
}
$e7161f778706e663$var$PointDecoration.prototype.point = true;
function $e7161f778706e663$var$getInclusive(spec, block = false) {
    let { inclusiveStart: start, inclusiveEnd: end } = spec;
    if (start == null) start = spec.inclusive;
    if (end == null) end = spec.inclusive;
    return {
        start: start !== null && start !== void 0 ? start : block,
        end: end !== null && end !== void 0 ? end : block
    };
}
function $e7161f778706e663$var$widgetsEq(a, b) {
    return a == b || !!(a && b && a.compare(b));
}
function $e7161f778706e663$var$addRange(from, to, ranges, margin = 0) {
    let last = ranges.length - 1;
    if (last >= 0 && ranges[last] + margin >= from) ranges[last] = Math.max(ranges[last], to);
    else ranges.push(from, to);
}
class $e7161f778706e663$var$LineView extends $e7161f778706e663$var$ContentView {
    constructor(){
        super(...arguments);
        this.children = [];
        this.length = 0;
        this.prevAttrs = undefined;
        this.attrs = null;
        this.breakAfter = 0;
    }
    // Consumes source
    merge(from, to, source, hasStart, openStart, openEnd) {
        if (source) {
            if (!(source instanceof $e7161f778706e663$var$LineView)) return false;
            if (!this.dom) source.transferDOM(this); // Reuse source.dom when appropriate
        }
        if (hasStart) this.setDeco(source ? source.attrs : null);
        $e7161f778706e663$var$mergeChildrenInto(this, from, to, source ? source.children : [], openStart, openEnd);
        return true;
    }
    split(at) {
        let end = new $e7161f778706e663$var$LineView;
        end.breakAfter = this.breakAfter;
        if (this.length == 0) return end;
        let { i: i, off: off } = this.childPos(at);
        if (off) {
            end.append(this.children[i].split(off), 0);
            this.children[i].merge(off, this.children[i].length, null, false, 0, 0);
            i++;
        }
        for(let j = i; j < this.children.length; j++)end.append(this.children[j], 0);
        while(i > 0 && this.children[i - 1].length == 0)this.children[--i].destroy();
        this.children.length = i;
        this.markDirty();
        this.length = at;
        return end;
    }
    transferDOM(other) {
        if (!this.dom) return;
        this.markDirty();
        other.setDOM(this.dom);
        other.prevAttrs = this.prevAttrs === undefined ? this.attrs : this.prevAttrs;
        this.prevAttrs = undefined;
        this.dom = null;
    }
    setDeco(attrs) {
        if (!$e7161f778706e663$var$attrsEq(this.attrs, attrs)) {
            if (this.dom) {
                this.prevAttrs = this.attrs;
                this.markDirty();
            }
            this.attrs = attrs;
        }
    }
    append(child, openStart) {
        $e7161f778706e663$var$joinInlineInto(this, child, openStart);
    }
    // Only called when building a line view in ContentBuilder
    addLineDeco(deco) {
        let attrs = deco.spec.attributes, cls = deco.spec.class;
        if (attrs) this.attrs = $e7161f778706e663$var$combineAttrs(attrs, this.attrs || {});
        if (cls) this.attrs = $e7161f778706e663$var$combineAttrs({
            class: cls
        }, this.attrs || {});
    }
    domAtPos(pos) {
        return $e7161f778706e663$var$inlineDOMAtPos(this, pos);
    }
    reuseDOM(node) {
        if (node.nodeName == "DIV") {
            this.setDOM(node);
            this.dirty |= 6 /* Node */ ;
        }
    }
    sync(view, track) {
        var _a;
        if (!this.dom) {
            this.setDOM(document.createElement("div"));
            this.dom.className = "cm-line";
            this.prevAttrs = this.attrs ? null : undefined;
        } else if (this.dirty & 4 /* Attrs */ ) {
            $e7161f778706e663$var$clearAttributes(this.dom);
            this.dom.className = "cm-line";
            this.prevAttrs = this.attrs ? null : undefined;
        }
        if (this.prevAttrs !== undefined) {
            $e7161f778706e663$var$updateAttrs(this.dom, this.prevAttrs, this.attrs);
            this.dom.classList.add("cm-line");
            this.prevAttrs = undefined;
        }
        super.sync(view, track);
        let last = this.dom.lastChild;
        while(last && $e7161f778706e663$var$ContentView.get(last) instanceof $e7161f778706e663$var$MarkView)last = last.lastChild;
        if (!last || !this.length || last.nodeName != "BR" && ((_a = $e7161f778706e663$var$ContentView.get(last)) === null || _a === void 0 ? void 0 : _a.isEditable) == false && (!$e7161f778706e663$var$browser.ios || !this.children.some((ch)=>ch instanceof $e7161f778706e663$var$TextView))) {
            let hack = document.createElement("BR");
            hack.cmIgnore = true;
            this.dom.appendChild(hack);
        }
    }
    measureTextSize() {
        if (this.children.length == 0 || this.length > 20) return null;
        let totalWidth = 0, textHeight;
        for (let child of this.children){
            if (!(child instanceof $e7161f778706e663$var$TextView) || /[^ -~]/.test(child.text)) return null;
            let rects = $e7161f778706e663$var$clientRectsFor(child.dom);
            if (rects.length != 1) return null;
            totalWidth += rects[0].width;
            textHeight = rects[0].height;
        }
        return !totalWidth ? null : {
            lineHeight: this.dom.getBoundingClientRect().height,
            charWidth: totalWidth / this.length,
            textHeight: textHeight
        };
    }
    coordsAt(pos, side) {
        let rect = $e7161f778706e663$var$coordsInChildren(this, pos, side);
        // Correct rectangle height for empty lines when the returned
        // height is larger than the text height.
        if (!this.children.length && rect && this.parent) {
            let { heightOracle: heightOracle } = this.parent.view.viewState, height = rect.bottom - rect.top;
            if (Math.abs(height - heightOracle.lineHeight) < 2 && heightOracle.textHeight < height) {
                let dist = (height - heightOracle.textHeight) / 2;
                return {
                    top: rect.top + dist,
                    bottom: rect.bottom - dist,
                    left: rect.left,
                    right: rect.left
                };
            }
        }
        return rect;
    }
    become(_other) {
        return false;
    }
    get type() {
        return $e7161f778706e663$export$48808c686fe495c4.Text;
    }
    static find(docView, pos) {
        for(let i = 0, off = 0; i < docView.children.length; i++){
            let block = docView.children[i], end = off + block.length;
            if (end >= pos) {
                if (block instanceof $e7161f778706e663$var$LineView) return block;
                if (end > pos) break;
            }
            off = end + block.breakAfter;
        }
        return null;
    }
}
class $e7161f778706e663$var$BlockWidgetView extends $e7161f778706e663$var$ContentView {
    constructor(widget, length, type){
        super();
        this.widget = widget;
        this.length = length;
        this.type = type;
        this.breakAfter = 0;
        this.prevWidget = null;
    }
    merge(from, to, source, _takeDeco, openStart, openEnd) {
        if (source && (!(source instanceof $e7161f778706e663$var$BlockWidgetView) || !this.widget.compare(source.widget) || from > 0 && openStart <= 0 || to < this.length && openEnd <= 0)) return false;
        this.length = from + (source ? source.length : 0) + (this.length - to);
        return true;
    }
    domAtPos(pos) {
        return pos == 0 ? $e7161f778706e663$var$DOMPos.before(this.dom) : $e7161f778706e663$var$DOMPos.after(this.dom, pos == this.length);
    }
    split(at) {
        let len = this.length - at;
        this.length = at;
        let end = new $e7161f778706e663$var$BlockWidgetView(this.widget, len, this.type);
        end.breakAfter = this.breakAfter;
        return end;
    }
    get children() {
        return $e7161f778706e663$var$noChildren;
    }
    sync(view) {
        if (!this.dom || !this.widget.updateDOM(this.dom, view)) {
            if (this.dom && this.prevWidget) this.prevWidget.destroy(this.dom);
            this.prevWidget = null;
            this.setDOM(this.widget.toDOM(view));
            this.dom.contentEditable = "false";
        }
    }
    get overrideDOMText() {
        return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : (0, $hB7kI.Text).empty;
    }
    domBoundsAround() {
        return null;
    }
    become(other) {
        if (other instanceof $e7161f778706e663$var$BlockWidgetView && other.widget.constructor == this.widget.constructor) {
            if (!other.widget.compare(this.widget)) this.markDirty(true);
            if (this.dom && !this.prevWidget) this.prevWidget = this.widget;
            this.widget = other.widget;
            this.length = other.length;
            this.type = other.type;
            this.breakAfter = other.breakAfter;
            return true;
        }
        return false;
    }
    ignoreMutation() {
        return true;
    }
    ignoreEvent(event) {
        return this.widget.ignoreEvent(event);
    }
    get isEditable() {
        return false;
    }
    get isWidget() {
        return true;
    }
    coordsAt(pos, side) {
        return this.widget.coordsAt(this.dom, pos, side);
    }
    destroy() {
        super.destroy();
        if (this.dom) this.widget.destroy(this.dom);
    }
}
class $e7161f778706e663$var$ContentBuilder {
    constructor(doc, pos, end, disallowBlockEffectsFor){
        this.doc = doc;
        this.pos = pos;
        this.end = end;
        this.disallowBlockEffectsFor = disallowBlockEffectsFor;
        this.content = [];
        this.curLine = null;
        this.breakAtStart = 0;
        this.pendingBuffer = 0 /* No */ ;
        this.bufferMarks = [];
        // Set to false directly after a widget that covers the position after it
        this.atCursorPos = true;
        this.openStart = -1;
        this.openEnd = -1;
        this.text = "";
        this.textOff = 0;
        this.cursor = doc.iter();
        this.skip = pos;
    }
    posCovered() {
        if (this.content.length == 0) return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
        let last = this.content[this.content.length - 1];
        return !last.breakAfter && !(last instanceof $e7161f778706e663$var$BlockWidgetView && last.type == $e7161f778706e663$export$48808c686fe495c4.WidgetBefore);
    }
    getLine() {
        if (!this.curLine) {
            this.content.push(this.curLine = new $e7161f778706e663$var$LineView);
            this.atCursorPos = true;
        }
        return this.curLine;
    }
    flushBuffer(active = this.bufferMarks) {
        if (this.pendingBuffer) {
            this.curLine.append($e7161f778706e663$var$wrapMarks(new $e7161f778706e663$var$WidgetBufferView(-1), active), active.length);
            this.pendingBuffer = 0 /* No */ ;
        }
    }
    addBlockWidget(view) {
        this.flushBuffer();
        this.curLine = null;
        this.content.push(view);
    }
    finish(openEnd) {
        if (this.pendingBuffer && openEnd <= this.bufferMarks.length) this.flushBuffer();
        else this.pendingBuffer = 0 /* No */ ;
        if (!this.posCovered()) this.getLine();
    }
    buildText(length, active, openStart) {
        while(length > 0){
            if (this.textOff == this.text.length) {
                let { value: value, lineBreak: lineBreak, done: done } = this.cursor.next(this.skip);
                this.skip = 0;
                if (done) throw new Error("Ran out of text content when drawing inline views");
                if (lineBreak) {
                    if (!this.posCovered()) this.getLine();
                    if (this.content.length) this.content[this.content.length - 1].breakAfter = 1;
                    else this.breakAtStart = 1;
                    this.flushBuffer();
                    this.curLine = null;
                    this.atCursorPos = true;
                    length--;
                    continue;
                } else {
                    this.text = value;
                    this.textOff = 0;
                }
            }
            let take = Math.min(this.text.length - this.textOff, length, 512 /* Chunk */ );
            this.flushBuffer(active.slice(active.length - openStart));
            this.getLine().append($e7161f778706e663$var$wrapMarks(new $e7161f778706e663$var$TextView(this.text.slice(this.textOff, this.textOff + take)), active), openStart);
            this.atCursorPos = true;
            this.textOff += take;
            length -= take;
            openStart = 0;
        }
    }
    span(from, to, active, openStart) {
        this.buildText(to - from, active, openStart);
        this.pos = to;
        if (this.openStart < 0) this.openStart = openStart;
    }
    point(from, to, deco, active, openStart, index) {
        if (this.disallowBlockEffectsFor[index] && deco instanceof $e7161f778706e663$var$PointDecoration) {
            if (deco.block) throw new RangeError("Block decorations may not be specified via plugins");
            if (to > this.doc.lineAt(this.pos).to) throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
        }
        let len = to - from;
        if (deco instanceof $e7161f778706e663$var$PointDecoration) {
            if (deco.block) {
                let { type: type } = deco;
                if (type == $e7161f778706e663$export$48808c686fe495c4.WidgetAfter && !this.posCovered()) this.getLine();
                this.addBlockWidget(new $e7161f778706e663$var$BlockWidgetView(deco.widget || new $e7161f778706e663$var$NullWidget("div"), len, type));
            } else {
                let view = $e7161f778706e663$var$WidgetView.create(deco.widget || new $e7161f778706e663$var$NullWidget("span"), len, len ? 0 : deco.startSide);
                let cursorBefore = this.atCursorPos && !view.isEditable && openStart <= active.length && (from < to || deco.startSide > 0);
                let cursorAfter = !view.isEditable && (from < to || openStart > active.length || deco.startSide <= 0);
                let line = this.getLine();
                if (this.pendingBuffer == 2 /* IfCursor */  && !cursorBefore && !view.isEditable) this.pendingBuffer = 0 /* No */ ;
                this.flushBuffer(active);
                if (cursorBefore) {
                    line.append($e7161f778706e663$var$wrapMarks(new $e7161f778706e663$var$WidgetBufferView(1), active), openStart);
                    openStart = active.length + Math.max(0, openStart - active.length);
                }
                line.append($e7161f778706e663$var$wrapMarks(view, active), openStart);
                this.atCursorPos = cursorAfter;
                this.pendingBuffer = !cursorAfter ? 0 /* No */  : from < to || openStart > active.length ? 1 /* Yes */  : 2 /* IfCursor */ ;
                if (this.pendingBuffer) this.bufferMarks = active.slice();
            }
        } else if (this.doc.lineAt(this.pos).from == this.pos) this.getLine().addLineDeco(deco);
        if (len) {
            // Advance the iterator past the replaced content
            if (this.textOff + len <= this.text.length) this.textOff += len;
            else {
                this.skip += len - (this.text.length - this.textOff);
                this.text = "";
                this.textOff = 0;
            }
            this.pos = to;
        }
        if (this.openStart < 0) this.openStart = openStart;
    }
    static build(text, from, to, decorations, dynamicDecorationMap) {
        let builder = new $e7161f778706e663$var$ContentBuilder(text, from, to, dynamicDecorationMap);
        builder.openEnd = (0, $hB7kI.RangeSet).spans(decorations, from, to, builder);
        if (builder.openStart < 0) builder.openStart = builder.openEnd;
        builder.finish(builder.openEnd);
        return builder;
    }
}
function $e7161f778706e663$var$wrapMarks(view, active) {
    for (let mark of active)view = new $e7161f778706e663$var$MarkView(mark, [
        view
    ], view.length);
    return view;
}
class $e7161f778706e663$var$NullWidget extends $e7161f778706e663$export$95cdd842edb044c5 {
    constructor(tag){
        super();
        this.tag = tag;
    }
    eq(other) {
        return other.tag == this.tag;
    }
    toDOM() {
        return document.createElement(this.tag);
    }
    updateDOM(elt) {
        return elt.nodeName.toLowerCase() == this.tag;
    }
    get isHidden() {
        return true;
    }
}
const $e7161f778706e663$var$clickAddsSelectionRange = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $e7161f778706e663$var$dragMovesSelection$1 = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $e7161f778706e663$var$mouseSelectionStyle = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $e7161f778706e663$var$exceptionSink = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $e7161f778706e663$var$updateListener = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $e7161f778706e663$var$inputHandler = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $e7161f778706e663$var$focusChangeEffect = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $e7161f778706e663$var$perLineTextDirection = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine: (values)=>values.some((x)=>x)
});
const $e7161f778706e663$var$nativeSelectionHidden = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine: (values)=>values.some((x)=>x)
});
class $e7161f778706e663$var$ScrollTarget {
    constructor(range, y = "nearest", x = "nearest", yMargin = 5, xMargin = 5){
        this.range = range;
        this.y = y;
        this.x = x;
        this.yMargin = yMargin;
        this.xMargin = xMargin;
    }
    map(changes) {
        return changes.empty ? this : new $e7161f778706e663$var$ScrollTarget(this.range.map(changes), this.y, this.x, this.yMargin, this.xMargin);
    }
}
const $e7161f778706e663$var$scrollIntoView = /*@__PURE__*/ (0, $hB7kI.StateEffect).define({
    map: (t, ch)=>t.map(ch)
});
/**
Log or report an unhandled exception in client code. Should
probably only be used by extension code that allows client code to
provide functions, and calls those functions in a context where an
exception can't be propagated to calling code in a reasonable way
(for example when in an event handler).

Either calls a handler registered with
[`EditorView.exceptionSink`](https://codemirror.net/6/docs/ref/#view.EditorView^exceptionSink),
`window.onerror`, if defined, or `console.error` (in which case
it'll pass `context`, when given, as first argument).
*/ function $e7161f778706e663$export$f86b2a1a2ce291b3(state, exception, context) {
    let handler = state.facet($e7161f778706e663$var$exceptionSink);
    if (handler.length) handler[0](exception);
    else if (window.onerror) window.onerror(String(exception), context, undefined, undefined, exception);
    else if (context) console.error(context + ":", exception);
    else console.error(exception);
}
const $e7161f778706e663$var$editable = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine: (values)=>values.length ? values[0] : true
});
let $e7161f778706e663$var$nextPluginID = 0;
const $e7161f778706e663$var$viewPlugin = /*@__PURE__*/ (0, $hB7kI.Facet).define();
/**
View plugins associate stateful values with a view. They can
influence the way the content is drawn, and are notified of things
that happen in the view.
*/ class $e7161f778706e663$export$44d5eccfd62adda7 {
    constructor(/**
    @internal
    */ id, /**
    @internal
    */ create, /**
    @internal
    */ domEventHandlers, buildExtensions){
        this.id = id;
        this.create = create;
        this.domEventHandlers = domEventHandlers;
        this.extension = buildExtensions(this);
    }
    /**
    Define a plugin from a constructor function that creates the
    plugin's value, given an editor view.
    */ static define(create, spec) {
        const { eventHandlers: eventHandlers, provide: provide, decorations: deco } = spec || {};
        return new $e7161f778706e663$export$44d5eccfd62adda7($e7161f778706e663$var$nextPluginID++, create, eventHandlers, (plugin)=>{
            let ext = [
                $e7161f778706e663$var$viewPlugin.of(plugin)
            ];
            if (deco) ext.push($e7161f778706e663$var$decorations.of((view)=>{
                let pluginInst = view.plugin(plugin);
                return pluginInst ? deco(pluginInst) : $e7161f778706e663$export$10e30b733df217ea.none;
            }));
            if (provide) ext.push(provide(plugin));
            return ext;
        });
    }
    /**
    Create a plugin for a class whose constructor takes a single
    editor view as argument.
    */ static fromClass(cls, spec) {
        return $e7161f778706e663$export$44d5eccfd62adda7.define((view)=>new cls(view), spec);
    }
}
class $e7161f778706e663$var$PluginInstance {
    constructor(spec){
        this.spec = spec;
        // When starting an update, all plugins have this field set to the
        // update object, indicating they need to be updated. When finished
        // updating, it is set to `false`. Retrieving a plugin that needs to
        // be updated with `view.plugin` forces an eager update.
        this.mustUpdate = null;
        // This is null when the plugin is initially created, but
        // initialized on the first update.
        this.value = null;
    }
    update(view) {
        if (!this.value) {
            if (this.spec) try {
                this.value = this.spec.create(view);
            } catch (e) {
                $e7161f778706e663$export$f86b2a1a2ce291b3(view.state, e, "CodeMirror plugin crashed");
                this.deactivate();
            }
        } else if (this.mustUpdate) {
            let update = this.mustUpdate;
            this.mustUpdate = null;
            if (this.value.update) try {
                this.value.update(update);
            } catch (e) {
                $e7161f778706e663$export$f86b2a1a2ce291b3(update.state, e, "CodeMirror plugin crashed");
                if (this.value.destroy) try {
                    this.value.destroy();
                } catch (_) {}
                this.deactivate();
            }
        }
        return this;
    }
    destroy(view) {
        var _a;
        if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.destroy) try {
            this.value.destroy();
        } catch (e) {
            $e7161f778706e663$export$f86b2a1a2ce291b3(view.state, e, "CodeMirror plugin crashed");
        }
    }
    deactivate() {
        this.spec = this.value = null;
    }
}
const $e7161f778706e663$var$editorAttributes = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $e7161f778706e663$var$contentAttributes = /*@__PURE__*/ (0, $hB7kI.Facet).define();
// Provide decorations
const $e7161f778706e663$var$decorations = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $e7161f778706e663$var$atomicRanges = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $e7161f778706e663$var$scrollMargins = /*@__PURE__*/ (0, $hB7kI.Facet).define();
function $e7161f778706e663$var$getScrollMargins(view) {
    let left = 0, right = 0, top = 0, bottom = 0;
    for (let source of view.state.facet($e7161f778706e663$var$scrollMargins)){
        let m = source(view);
        if (m) {
            if (m.left != null) left = Math.max(left, m.left);
            if (m.right != null) right = Math.max(right, m.right);
            if (m.top != null) top = Math.max(top, m.top);
            if (m.bottom != null) bottom = Math.max(bottom, m.bottom);
        }
    }
    return {
        left: left,
        right: right,
        top: top,
        bottom: bottom
    };
}
const $e7161f778706e663$var$styleModule = /*@__PURE__*/ (0, $hB7kI.Facet).define();
class $e7161f778706e663$var$ChangedRange {
    constructor(fromA, toA, fromB, toB){
        this.fromA = fromA;
        this.toA = toA;
        this.fromB = fromB;
        this.toB = toB;
    }
    join(other) {
        return new $e7161f778706e663$var$ChangedRange(Math.min(this.fromA, other.fromA), Math.max(this.toA, other.toA), Math.min(this.fromB, other.fromB), Math.max(this.toB, other.toB));
    }
    addToSet(set) {
        let i = set.length, me = this;
        for(; i > 0; i--){
            let range = set[i - 1];
            if (range.fromA > me.toA) continue;
            if (range.toA < me.fromA) break;
            me = me.join(range);
            set.splice(i - 1, 1);
        }
        set.splice(i, 0, me);
        return set;
    }
    static extendWithRanges(diff, ranges) {
        if (ranges.length == 0) return diff;
        let result = [];
        for(let dI = 0, rI = 0, posA = 0, posB = 0;; dI++){
            let next = dI == diff.length ? null : diff[dI], off = posA - posB;
            let end = next ? next.fromB : 1e9;
            while(rI < ranges.length && ranges[rI] < end){
                let from = ranges[rI], to = ranges[rI + 1];
                let fromB = Math.max(posB, from), toB = Math.min(end, to);
                if (fromB <= toB) new $e7161f778706e663$var$ChangedRange(fromB + off, toB + off, fromB, toB).addToSet(result);
                if (to > end) break;
                else rI += 2;
            }
            if (!next) return result;
            new $e7161f778706e663$var$ChangedRange(next.fromA, next.toA, next.fromB, next.toB).addToSet(result);
            posA = next.toA;
            posB = next.toB;
        }
    }
}
/**
View [plugins](https://codemirror.net/6/docs/ref/#view.ViewPlugin) are given instances of this
class, which describe what happened, whenever the view is updated.
*/ class $e7161f778706e663$export$b5b084f95c87edf7 {
    constructor(/**
    The editor view that the update is associated with.
    */ view, /**
    The new editor state.
    */ state, /**
    The transactions involved in the update. May be empty.
    */ transactions){
        this.view = view;
        this.state = state;
        this.transactions = transactions;
        /**
        @internal
        */ this.flags = 0;
        this.startState = view.state;
        this.changes = (0, $hB7kI.ChangeSet).empty(this.startState.doc.length);
        for (let tr of transactions)this.changes = this.changes.compose(tr.changes);
        let changedRanges = [];
        this.changes.iterChangedRanges((fromA, toA, fromB, toB)=>changedRanges.push(new $e7161f778706e663$var$ChangedRange(fromA, toA, fromB, toB)));
        this.changedRanges = changedRanges;
    }
    /**
    @internal
    */ static create(view, state, transactions) {
        return new $e7161f778706e663$export$b5b084f95c87edf7(view, state, transactions);
    }
    /**
    Tells you whether the [viewport](https://codemirror.net/6/docs/ref/#view.EditorView.viewport) or
    [visible ranges](https://codemirror.net/6/docs/ref/#view.EditorView.visibleRanges) changed in this
    update.
    */ get viewportChanged() {
        return (this.flags & 4 /* Viewport */ ) > 0;
    }
    /**
    Indicates whether the height of a block element in the editor
    changed in this update.
    */ get heightChanged() {
        return (this.flags & 2 /* Height */ ) > 0;
    }
    /**
    Returns true when the document was modified or the size of the
    editor, or elements within the editor, changed.
    */ get geometryChanged() {
        return this.docChanged || (this.flags & 10 /* Height */ ) > 0;
    }
    /**
    True when this update indicates a focus change.
    */ get focusChanged() {
        return (this.flags & 1 /* Focus */ ) > 0;
    }
    /**
    Whether the document changed in this update.
    */ get docChanged() {
        return !this.changes.empty;
    }
    /**
    Whether the selection was explicitly set in this update.
    */ get selectionSet() {
        return this.transactions.some((tr)=>tr.selection);
    }
    /**
    @internal
    */ get empty() {
        return this.flags == 0 && this.transactions.length == 0;
    }
}
/**
Used to indicate [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
*/ var $e7161f778706e663$export$cacd6541cfeeb6c1 = /*@__PURE__*/ function(Direction) {
    // (These are chosen to match the base levels, in bidi algorithm
    // terms, of spans in that direction.)
    /**
    Left-to-right.
    */ Direction[Direction["LTR"] = 0] = "LTR";
    /**
    Right-to-left.
    */ Direction[Direction["RTL"] = 1] = "RTL";
    return Direction;
}($e7161f778706e663$export$cacd6541cfeeb6c1 || ($e7161f778706e663$export$cacd6541cfeeb6c1 = {}));
const $e7161f778706e663$var$LTR = $e7161f778706e663$export$cacd6541cfeeb6c1.LTR, $e7161f778706e663$var$RTL = $e7161f778706e663$export$cacd6541cfeeb6c1.RTL;
// Decode a string with each type encoded as log2(type)
function $e7161f778706e663$var$dec(str) {
    let result = [];
    for(let i = 0; i < str.length; i++)result.push(1 << +str[i]);
    return result;
}
// Character types for codepoints 0 to 0xf8
const $e7161f778706e663$var$LowTypes = /*@__PURE__*/ $e7161f778706e663$var$dec("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008");
// Character types for codepoints 0x600 to 0x6f9
const $e7161f778706e663$var$ArabicTypes = /*@__PURE__*/ $e7161f778706e663$var$dec("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333");
const $e7161f778706e663$var$Brackets = /*@__PURE__*/ Object.create(null), $e7161f778706e663$var$BracketStack = [];
// There's a lot more in
// https://www.unicode.org/Public/UCD/latest/ucd/BidiBrackets.txt,
// which are left out to keep code size down.
for (let p of [
    "()",
    "[]",
    "{}"
]){
    let l = /*@__PURE__*/ p.charCodeAt(0), r = /*@__PURE__*/ p.charCodeAt(1);
    $e7161f778706e663$var$Brackets[l] = r;
    $e7161f778706e663$var$Brackets[r] = -l;
}
function $e7161f778706e663$var$charType(ch) {
    return ch <= 0xf7 ? $e7161f778706e663$var$LowTypes[ch] : 0x590 <= ch && ch <= 0x5f4 ? 2 /* R */  : 0x600 <= ch && ch <= 0x6f9 ? $e7161f778706e663$var$ArabicTypes[ch - 0x600] : 0x6ee <= ch && ch <= 0x8ac ? 4 /* AL */  : 0x2000 <= ch && ch <= 0x200b ? 256 /* NI */  : 0xfb50 <= ch && ch <= 0xfdff ? 4 /* AL */  : ch == 0x200c ? 256 /* NI */  : 1 /* L */ ;
}
const $e7161f778706e663$var$BidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
/**
Represents a contiguous range of text that has a single direction
(as in left-to-right or right-to-left).
*/ class $e7161f778706e663$export$e1ed96b746bb516a {
    /**
    @internal
    */ constructor(/**
    The start of the span (relative to the start of the line).
    */ from, /**
    The end of the span.
    */ to, /**
    The ["bidi
    level"](https://unicode.org/reports/tr9/#Basic_Display_Algorithm)
    of the span (in this context, 0 means
    left-to-right, 1 means right-to-left, 2 means left-to-right
    number inside right-to-left text).
    */ level){
        this.from = from;
        this.to = to;
        this.level = level;
    }
    /**
    The direction of this span.
    */ get dir() {
        return this.level % 2 ? $e7161f778706e663$var$RTL : $e7161f778706e663$var$LTR;
    }
    /**
    @internal
    */ side(end, dir) {
        return this.dir == dir == end ? this.to : this.from;
    }
    /**
    @internal
    */ static find(order, index, level, assoc) {
        let maybe = -1;
        for(let i = 0; i < order.length; i++){
            let span = order[i];
            if (span.from <= index && span.to >= index) {
                if (span.level == level) return i;
                // When multiple spans match, if assoc != 0, take the one that
                // covers that side, otherwise take the one with the minimum
                // level.
                if (maybe < 0 || (assoc != 0 ? assoc < 0 ? span.from < index : span.to > index : order[maybe].level > span.level)) maybe = i;
            }
        }
        if (maybe < 0) throw new RangeError("Index out of range");
        return maybe;
    }
}
// Reused array of character types
const $e7161f778706e663$var$types = [];
function $e7161f778706e663$var$computeOrder(line, direction) {
    let len = line.length, outerType = direction == $e7161f778706e663$var$LTR ? 1 /* L */  : 2 /* R */ , oppositeType = direction == $e7161f778706e663$var$LTR ? 2 /* R */  : 1 /* L */ ;
    if (!line || outerType == 1 /* L */  && !$e7161f778706e663$var$BidiRE.test(line)) return $e7161f778706e663$var$trivialOrder(len);
    // W1. Examine each non-spacing mark (NSM) in the level run, and
    // change the type of the NSM to the type of the previous
    // character. If the NSM is at the start of the level run, it will
    // get the type of sor.
    // W2. Search backwards from each instance of a European number
    // until the first strong type (R, L, AL, or sor) is found. If an
    // AL is found, change the type of the European number to Arabic
    // number.
    // W3. Change all ALs to R.
    // (Left after this: L, R, EN, AN, ET, CS, NI)
    for(let i = 0, prev = outerType, prevStrong = outerType; i < len; i++){
        let type = $e7161f778706e663$var$charType(line.charCodeAt(i));
        if (type == 512 /* NSM */ ) type = prev;
        else if (type == 8 /* EN */  && prevStrong == 4 /* AL */ ) type = 16 /* AN */ ;
        $e7161f778706e663$var$types[i] = type == 4 /* AL */  ? 2 /* R */  : type;
        if (type & 7 /* Strong */ ) prevStrong = type;
        prev = type;
    }
    // W5. A sequence of European terminators adjacent to European
    // numbers changes to all European numbers.
    // W6. Otherwise, separators and terminators change to Other
    // Neutral.
    // W7. Search backwards from each instance of a European number
    // until the first strong type (R, L, or sor) is found. If an L is
    // found, then change the type of the European number to L.
    // (Left after this: L, R, EN+AN, NI)
    for(let i = 0, prev = outerType, prevStrong = outerType; i < len; i++){
        let type = $e7161f778706e663$var$types[i];
        if (type == 128 /* CS */ ) {
            if (i < len - 1 && prev == $e7161f778706e663$var$types[i + 1] && prev & 24 /* Num */ ) type = $e7161f778706e663$var$types[i] = prev;
            else $e7161f778706e663$var$types[i] = 256 /* NI */ ;
        } else if (type == 64 /* ET */ ) {
            let end = i + 1;
            while(end < len && $e7161f778706e663$var$types[end] == 64 /* ET */ )end++;
            let replace = i && prev == 8 /* EN */  || end < len && $e7161f778706e663$var$types[end] == 8 /* EN */  ? prevStrong == 1 /* L */  ? 1 /* L */  : 8 /* EN */  : 256 /* NI */ ;
            for(let j = i; j < end; j++)$e7161f778706e663$var$types[j] = replace;
            i = end - 1;
        } else if (type == 8 /* EN */  && prevStrong == 1 /* L */ ) $e7161f778706e663$var$types[i] = 1 /* L */ ;
        prev = type;
        if (type & 7 /* Strong */ ) prevStrong = type;
    }
    // N0. Process bracket pairs in an isolating run sequence
    // sequentially in the logical order of the text positions of the
    // opening paired brackets using the logic given below. Within this
    // scope, bidirectional types EN and AN are treated as R.
    for(let i = 0, sI = 0, context = 0, ch, br, type; i < len; i++){
        // Keeps [startIndex, type, strongSeen] triples for each open
        // bracket on BracketStack.
        if (br = $e7161f778706e663$var$Brackets[ch = line.charCodeAt(i)]) {
            if (br < 0) {
                for(let sJ = sI - 3; sJ >= 0; sJ -= 3)if ($e7161f778706e663$var$BracketStack[sJ + 1] == -br) {
                    let flags = $e7161f778706e663$var$BracketStack[sJ + 2];
                    let type = flags & 2 /* EmbedInside */  ? outerType : !(flags & 4 /* OppositeInside */ ) ? 0 : flags & 1 /* OppositeBefore */  ? oppositeType : outerType;
                    if (type) $e7161f778706e663$var$types[i] = $e7161f778706e663$var$types[$e7161f778706e663$var$BracketStack[sJ]] = type;
                    sI = sJ;
                    break;
                }
            } else if ($e7161f778706e663$var$BracketStack.length == 189 /* MaxDepth */ ) break;
            else {
                $e7161f778706e663$var$BracketStack[sI++] = i;
                $e7161f778706e663$var$BracketStack[sI++] = ch;
                $e7161f778706e663$var$BracketStack[sI++] = context;
            }
        } else if ((type = $e7161f778706e663$var$types[i]) == 2 /* R */  || type == 1 /* L */ ) {
            let embed = type == outerType;
            context = embed ? 0 : 1 /* OppositeBefore */ ;
            for(let sJ = sI - 3; sJ >= 0; sJ -= 3){
                let cur = $e7161f778706e663$var$BracketStack[sJ + 2];
                if (cur & 2 /* EmbedInside */ ) break;
                if (embed) $e7161f778706e663$var$BracketStack[sJ + 2] |= 2 /* EmbedInside */ ;
                else {
                    if (cur & 4 /* OppositeInside */ ) break;
                    $e7161f778706e663$var$BracketStack[sJ + 2] |= 4 /* OppositeInside */ ;
                }
            }
        }
    }
    // N1. A sequence of neutrals takes the direction of the
    // surrounding strong text if the text on both sides has the same
    // direction. European and Arabic numbers act as if they were R in
    // terms of their influence on neutrals. Start-of-level-run (sor)
    // and end-of-level-run (eor) are used at level run boundaries.
    // N2. Any remaining neutrals take the embedding direction.
    // (Left after this: L, R, EN+AN)
    for(let i = 0; i < len; i++)if ($e7161f778706e663$var$types[i] == 256 /* NI */ ) {
        let end = i + 1;
        while(end < len && $e7161f778706e663$var$types[end] == 256 /* NI */ )end++;
        let beforeL = (i ? $e7161f778706e663$var$types[i - 1] : outerType) == 1 /* L */ ;
        let afterL = (end < len ? $e7161f778706e663$var$types[end] : outerType) == 1 /* L */ ;
        let replace = beforeL == afterL ? beforeL ? 1 /* L */  : 2 /* R */  : outerType;
        for(let j = i; j < end; j++)$e7161f778706e663$var$types[j] = replace;
        i = end - 1;
    }
    // Here we depart from the documented algorithm, in order to avoid
    // building up an actual levels array. Since there are only three
    // levels (0, 1, 2) in an implementation that doesn't take
    // explicit embedding into account, we can build up the order on
    // the fly, without following the level-based algorithm.
    let order = [];
    if (outerType == 1 /* L */ ) for(let i = 0; i < len;){
        let start = i, rtl = $e7161f778706e663$var$types[i++] != 1 /* L */ ;
        while(i < len && rtl == ($e7161f778706e663$var$types[i] != 1 /* L */ ))i++;
        if (rtl) for(let j = i; j > start;){
            let end = j, l = $e7161f778706e663$var$types[--j] != 2 /* R */ ;
            while(j > start && l == ($e7161f778706e663$var$types[j - 1] != 2 /* R */ ))j--;
            order.push(new $e7161f778706e663$export$e1ed96b746bb516a(j, end, l ? 2 : 1));
        }
        else order.push(new $e7161f778706e663$export$e1ed96b746bb516a(start, i, 0));
    }
    else for(let i = 0; i < len;){
        let start = i, rtl = $e7161f778706e663$var$types[i++] == 2 /* R */ ;
        while(i < len && rtl == ($e7161f778706e663$var$types[i] == 2 /* R */ ))i++;
        order.push(new $e7161f778706e663$export$e1ed96b746bb516a(start, i, rtl ? 1 : 2));
    }
    return order;
}
function $e7161f778706e663$var$trivialOrder(length) {
    return [
        new $e7161f778706e663$export$e1ed96b746bb516a(0, length, 0)
    ];
}
let $e7161f778706e663$var$movedOver = "";
function $e7161f778706e663$var$moveVisually(line, order, dir, start, forward) {
    var _a;
    let startIndex = start.head - line.from, spanI = -1;
    if (startIndex == 0) {
        if (!forward || !line.length) return null;
        if (order[0].level != dir) {
            startIndex = order[0].side(false, dir);
            spanI = 0;
        }
    } else if (startIndex == line.length) {
        if (forward) return null;
        let last = order[order.length - 1];
        if (last.level != dir) {
            startIndex = last.side(true, dir);
            spanI = order.length - 1;
        }
    }
    if (spanI < 0) spanI = $e7161f778706e663$export$e1ed96b746bb516a.find(order, startIndex, (_a = start.bidiLevel) !== null && _a !== void 0 ? _a : -1, start.assoc);
    let span = order[spanI];
    // End of span. (But not end of line--that was checked for above.)
    if (startIndex == span.side(forward, dir)) {
        span = order[spanI += forward ? 1 : -1];
        startIndex = span.side(!forward, dir);
    }
    let indexForward = forward == (span.dir == dir);
    let nextIndex = (0, $hB7kI.findClusterBreak)(line.text, startIndex, indexForward);
    $e7161f778706e663$var$movedOver = line.text.slice(Math.min(startIndex, nextIndex), Math.max(startIndex, nextIndex));
    if (nextIndex != span.side(forward, dir)) return (0, $hB7kI.EditorSelection).cursor(nextIndex + line.from, indexForward ? -1 : 1, span.level);
    let nextSpan = spanI == (forward ? order.length - 1 : 0) ? null : order[spanI + (forward ? 1 : -1)];
    if (!nextSpan && span.level != dir) return (0, $hB7kI.EditorSelection).cursor(forward ? line.to : line.from, forward ? -1 : 1, dir);
    if (nextSpan && nextSpan.level < span.level) return (0, $hB7kI.EditorSelection).cursor(nextSpan.side(!forward, dir) + line.from, forward ? 1 : -1, nextSpan.level);
    return (0, $hB7kI.EditorSelection).cursor(nextIndex + line.from, forward ? -1 : 1, span.level);
}
const $e7161f778706e663$var$LineBreakPlaceholder = "￿";
class $e7161f778706e663$var$DOMReader {
    constructor(points, state){
        this.points = points;
        this.text = "";
        this.lineSeparator = state.facet((0, $hB7kI.EditorState).lineSeparator);
    }
    append(text) {
        this.text += text;
    }
    lineBreak() {
        this.text += $e7161f778706e663$var$LineBreakPlaceholder;
    }
    readRange(start, end) {
        if (!start) return this;
        let parent = start.parentNode;
        for(let cur = start;;){
            this.findPointBefore(parent, cur);
            let oldLen = this.text.length;
            this.readNode(cur);
            let next = cur.nextSibling;
            if (next == end) break;
            let view = $e7161f778706e663$var$ContentView.get(cur), nextView = $e7161f778706e663$var$ContentView.get(next);
            if (view && nextView ? view.breakAfter : (view ? view.breakAfter : $e7161f778706e663$var$isBlockElement(cur)) || $e7161f778706e663$var$isBlockElement(next) && (cur.nodeName != "BR" || cur.cmIgnore) && this.text.length > oldLen) this.lineBreak();
            cur = next;
        }
        this.findPointBefore(parent, end);
        return this;
    }
    readTextNode(node) {
        let text = node.nodeValue;
        for (let point of this.points)if (point.node == node) point.pos = this.text.length + Math.min(point.offset, text.length);
        for(let off = 0, re = this.lineSeparator ? null : /\r\n?|\n/g;;){
            let nextBreak = -1, breakSize = 1, m;
            if (this.lineSeparator) {
                nextBreak = text.indexOf(this.lineSeparator, off);
                breakSize = this.lineSeparator.length;
            } else if (m = re.exec(text)) {
                nextBreak = m.index;
                breakSize = m[0].length;
            }
            this.append(text.slice(off, nextBreak < 0 ? text.length : nextBreak));
            if (nextBreak < 0) break;
            this.lineBreak();
            if (breakSize > 1) {
                for (let point of this.points)if (point.node == node && point.pos > this.text.length) point.pos -= breakSize - 1;
            }
            off = nextBreak + breakSize;
        }
    }
    readNode(node) {
        if (node.cmIgnore) return;
        let view = $e7161f778706e663$var$ContentView.get(node);
        let fromView = view && view.overrideDOMText;
        if (fromView != null) {
            this.findPointInside(node, fromView.length);
            for(let i = fromView.iter(); !i.next().done;)if (i.lineBreak) this.lineBreak();
            else this.append(i.value);
        } else if (node.nodeType == 3) this.readTextNode(node);
        else if (node.nodeName == "BR") {
            if (node.nextSibling) this.lineBreak();
        } else if (node.nodeType == 1) this.readRange(node.firstChild, null);
    }
    findPointBefore(node, next) {
        for (let point of this.points)if (point.node == node && node.childNodes[point.offset] == next) point.pos = this.text.length;
    }
    findPointInside(node, maxLen) {
        for (let point of this.points)if (node.nodeType == 3 ? point.node == node : node.contains(point.node)) point.pos = this.text.length + Math.min(maxLen, point.offset);
    }
}
function $e7161f778706e663$var$isBlockElement(node) {
    return node.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(node.nodeName);
}
class $e7161f778706e663$var$DOMPoint {
    constructor(node, offset){
        this.node = node;
        this.offset = offset;
        this.pos = -1;
    }
}
class $e7161f778706e663$var$DocView extends $e7161f778706e663$var$ContentView {
    constructor(view){
        super();
        this.view = view;
        this.compositionDeco = $e7161f778706e663$export$10e30b733df217ea.none;
        this.decorations = [];
        this.dynamicDecorationMap = [];
        // Track a minimum width for the editor. When measuring sizes in
        // measureVisibleLineHeights, this is updated to point at the width
        // of a given element and its extent in the document. When a change
        // happens in that range, these are reset. That way, once we've seen
        // a line/element of a given length, we keep the editor wide enough
        // to fit at least that element, until it is changed, at which point
        // we forget it again.
        this.minWidth = 0;
        this.minWidthFrom = 0;
        this.minWidthTo = 0;
        // Track whether the DOM selection was set in a lossy way, so that
        // we don't mess it up when reading it back it
        this.impreciseAnchor = null;
        this.impreciseHead = null;
        this.forceSelection = false;
        // Used by the resize observer to ignore resizes that we caused
        // ourselves
        this.lastUpdate = Date.now();
        this.setDOM(view.contentDOM);
        this.children = [
            new $e7161f778706e663$var$LineView
        ];
        this.children[0].setParent(this);
        this.updateDeco();
        this.updateInner([
            new $e7161f778706e663$var$ChangedRange(0, 0, 0, view.state.doc.length)
        ], 0);
    }
    get length() {
        return this.view.state.doc.length;
    }
    // Update the document view to a given state.
    update(update) {
        let changedRanges = update.changedRanges;
        if (this.minWidth > 0 && changedRanges.length) {
            if (!changedRanges.every(({ fromA: fromA, toA: toA })=>toA < this.minWidthFrom || fromA > this.minWidthTo)) this.minWidth = this.minWidthFrom = this.minWidthTo = 0;
            else {
                this.minWidthFrom = update.changes.mapPos(this.minWidthFrom, 1);
                this.minWidthTo = update.changes.mapPos(this.minWidthTo, 1);
            }
        }
        if (this.view.inputState.composing < 0) this.compositionDeco = $e7161f778706e663$export$10e30b733df217ea.none;
        else if (update.transactions.length || this.dirty) this.compositionDeco = $e7161f778706e663$var$computeCompositionDeco(this.view, update.changes);
        // When the DOM nodes around the selection are moved to another
        // parent, Chrome sometimes reports a different selection through
        // getSelection than the one that it actually shows to the user.
        // This forces a selection update when lines are joined to work
        // around that. Issue #54
        if (($e7161f778706e663$var$browser.ie || $e7161f778706e663$var$browser.chrome) && !this.compositionDeco.size && update && update.state.doc.lines != update.startState.doc.lines) this.forceSelection = true;
        let prevDeco = this.decorations, deco = this.updateDeco();
        let decoDiff = $e7161f778706e663$var$findChangedDeco(prevDeco, deco, update.changes);
        changedRanges = $e7161f778706e663$var$ChangedRange.extendWithRanges(changedRanges, decoDiff);
        if (this.dirty == 0 /* Not */  && changedRanges.length == 0) return false;
        else {
            this.updateInner(changedRanges, update.startState.doc.length);
            if (update.transactions.length) this.lastUpdate = Date.now();
            return true;
        }
    }
    // Used by update and the constructor do perform the actual DOM
    // update
    updateInner(changes, oldLength) {
        this.view.viewState.mustMeasureContent = true;
        this.updateChildren(changes, oldLength);
        let { observer: observer } = this.view;
        observer.ignore(()=>{
            // Lock the height during redrawing, since Chrome sometimes
            // messes with the scroll position during DOM mutation (though
            // no relayout is triggered and I cannot imagine how it can
            // recompute the scroll position without a layout)
            this.dom.style.height = this.view.viewState.contentHeight + "px";
            this.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
            // Chrome will sometimes, when DOM mutations occur directly
            // around the selection, get confused and report a different
            // selection from the one it displays (issue #218). This tries
            // to detect that situation.
            let track = $e7161f778706e663$var$browser.chrome || $e7161f778706e663$var$browser.ios ? {
                node: observer.selectionRange.focusNode,
                written: false
            } : undefined;
            this.sync(this.view, track);
            this.dirty = 0 /* Not */ ;
            if (track && (track.written || observer.selectionRange.focusNode != track.node)) this.forceSelection = true;
            this.dom.style.height = "";
        });
        let gaps = [];
        if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length) {
            for (let child of this.children)if (child instanceof $e7161f778706e663$var$BlockWidgetView && child.widget instanceof $e7161f778706e663$var$BlockGapWidget) gaps.push(child.dom);
        }
        observer.updateGaps(gaps);
    }
    updateChildren(changes, oldLength) {
        let cursor = this.childCursor(oldLength);
        for(let i = changes.length - 1;; i--){
            let next = i >= 0 ? changes[i] : null;
            if (!next) break;
            let { fromA: fromA, toA: toA, fromB: fromB, toB: toB } = next;
            let { content: content, breakAtStart: breakAtStart, openStart: openStart, openEnd: openEnd } = $e7161f778706e663$var$ContentBuilder.build(this.view.state.doc, fromB, toB, this.decorations, this.dynamicDecorationMap);
            let { i: toI, off: toOff } = cursor.findPos(toA, 1);
            let { i: fromI, off: fromOff } = cursor.findPos(fromA, -1);
            $e7161f778706e663$var$replaceRange(this, fromI, fromOff, toI, toOff, content, breakAtStart, openStart, openEnd);
        }
    }
    // Sync the DOM selection to this.state.selection
    updateSelection(mustRead = false, fromPointer = false) {
        if (mustRead || !this.view.observer.selectionRange.focusNode) this.view.observer.readSelectionRange();
        let activeElt = this.view.root.activeElement, focused = activeElt == this.dom;
        let selectionNotFocus = !focused && $e7161f778706e663$var$hasSelection(this.dom, this.view.observer.selectionRange) && !(activeElt && this.dom.contains(activeElt));
        if (!(focused || fromPointer || selectionNotFocus)) return;
        let force = this.forceSelection;
        this.forceSelection = false;
        let main = this.view.state.selection.main;
        // FIXME need to handle the case where the selection falls inside a block range
        let anchor = this.domAtPos(main.anchor);
        let head = main.empty ? anchor : this.domAtPos(main.head);
        // Always reset on Firefox when next to an uneditable node to
        // avoid invisible cursor bugs (#111)
        if ($e7161f778706e663$var$browser.gecko && main.empty && !this.compositionDeco.size && $e7161f778706e663$var$betweenUneditable(anchor)) {
            let dummy = document.createTextNode("");
            this.view.observer.ignore(()=>anchor.node.insertBefore(dummy, anchor.node.childNodes[anchor.offset] || null));
            anchor = head = new $e7161f778706e663$var$DOMPos(dummy, 0);
            force = true;
        }
        let domSel = this.view.observer.selectionRange;
        // If the selection is already here, or in an equivalent position, don't touch it
        if (force || !domSel.focusNode || !$e7161f778706e663$var$isEquivalentPosition(anchor.node, anchor.offset, domSel.anchorNode, domSel.anchorOffset) || !$e7161f778706e663$var$isEquivalentPosition(head.node, head.offset, domSel.focusNode, domSel.focusOffset)) {
            this.view.observer.ignore(()=>{
                // Chrome Android will hide the virtual keyboard when tapping
                // inside an uneditable node, and not bring it back when we
                // move the cursor to its proper position. This tries to
                // restore the keyboard by cycling focus.
                if ($e7161f778706e663$var$browser.android && $e7161f778706e663$var$browser.chrome && this.dom.contains(domSel.focusNode) && $e7161f778706e663$var$inUneditable(domSel.focusNode, this.dom)) {
                    this.dom.blur();
                    this.dom.focus({
                        preventScroll: true
                    });
                }
                let rawSel = $e7161f778706e663$var$getSelection(this.view.root);
                if (!rawSel) ;
                else if (main.empty) {
                    // Work around https://bugzilla.mozilla.org/show_bug.cgi?id=1612076
                    if ($e7161f778706e663$var$browser.gecko) {
                        let nextTo = $e7161f778706e663$var$nextToUneditable(anchor.node, anchor.offset);
                        if (nextTo && nextTo != 3 /* After */ ) {
                            let text = $e7161f778706e663$var$nearbyTextNode(anchor.node, anchor.offset, nextTo == 1 /* Before */  ? 1 : -1);
                            if (text) anchor = new $e7161f778706e663$var$DOMPos(text, nextTo == 1 /* Before */  ? 0 : text.nodeValue.length);
                        }
                    }
                    rawSel.collapse(anchor.node, anchor.offset);
                    if (main.bidiLevel != null && domSel.cursorBidiLevel != null) domSel.cursorBidiLevel = main.bidiLevel;
                } else if (rawSel.extend) {
                    // Selection.extend can be used to create an 'inverted' selection
                    // (one where the focus is before the anchor), but not all
                    // browsers support it yet.
                    rawSel.collapse(anchor.node, anchor.offset);
                    // Safari will ignore the call above when the editor is
                    // hidden, and then raise an error on the call to extend
                    // (#940).
                    try {
                        rawSel.extend(head.node, head.offset);
                    } catch (_) {}
                } else {
                    // Primitive (IE) way
                    let range = document.createRange();
                    if (main.anchor > main.head) [anchor, head] = [
                        head,
                        anchor
                    ];
                    range.setEnd(head.node, head.offset);
                    range.setStart(anchor.node, anchor.offset);
                    rawSel.removeAllRanges();
                    rawSel.addRange(range);
                }
                if (selectionNotFocus && this.view.root.activeElement == this.dom) {
                    this.dom.blur();
                    if (activeElt) activeElt.focus();
                }
            });
            this.view.observer.setSelectionRange(anchor, head);
        }
        this.impreciseAnchor = anchor.precise ? null : new $e7161f778706e663$var$DOMPos(domSel.anchorNode, domSel.anchorOffset);
        this.impreciseHead = head.precise ? null : new $e7161f778706e663$var$DOMPos(domSel.focusNode, domSel.focusOffset);
    }
    enforceCursorAssoc() {
        if (this.compositionDeco.size) return;
        let { view: view } = this, cursor = view.state.selection.main;
        let sel = $e7161f778706e663$var$getSelection(view.root);
        let { anchorNode: anchorNode, anchorOffset: anchorOffset } = view.observer.selectionRange;
        if (!sel || !cursor.empty || !cursor.assoc || !sel.modify) return;
        let line = $e7161f778706e663$var$LineView.find(this, cursor.head);
        if (!line) return;
        let lineStart = line.posAtStart;
        if (cursor.head == lineStart || cursor.head == lineStart + line.length) return;
        let before = this.coordsAt(cursor.head, -1), after = this.coordsAt(cursor.head, 1);
        if (!before || !after || before.bottom > after.top) return;
        let dom = this.domAtPos(cursor.head + cursor.assoc);
        sel.collapse(dom.node, dom.offset);
        sel.modify("move", cursor.assoc < 0 ? "forward" : "backward", "lineboundary");
        // This can go wrong in corner cases like single-character lines,
        // so check and reset if necessary.
        view.observer.readSelectionRange();
        let newRange = view.observer.selectionRange;
        if (view.docView.posFromDOM(newRange.anchorNode, newRange.anchorOffset) != cursor.from) sel.collapse(anchorNode, anchorOffset);
    }
    nearest(dom) {
        for(let cur = dom; cur;){
            let domView = $e7161f778706e663$var$ContentView.get(cur);
            if (domView && domView.rootView == this) return domView;
            cur = cur.parentNode;
        }
        return null;
    }
    posFromDOM(node, offset) {
        let view = this.nearest(node);
        if (!view) throw new RangeError("Trying to find position for a DOM position outside of the document");
        return view.localPosFromDOM(node, offset) + view.posAtStart;
    }
    domAtPos(pos) {
        let { i: i, off: off } = this.childCursor().findPos(pos, -1);
        for(; i < this.children.length - 1;){
            let child = this.children[i];
            if (off < child.length || child instanceof $e7161f778706e663$var$LineView) break;
            i++;
            off = 0;
        }
        return this.children[i].domAtPos(off);
    }
    coordsAt(pos, side) {
        for(let off = this.length, i = this.children.length - 1;; i--){
            let child = this.children[i], start = off - child.breakAfter - child.length;
            if (pos > start || pos == start && child.type != $e7161f778706e663$export$48808c686fe495c4.WidgetBefore && child.type != $e7161f778706e663$export$48808c686fe495c4.WidgetAfter && (!i || side == 2 || this.children[i - 1].breakAfter || this.children[i - 1].type == $e7161f778706e663$export$48808c686fe495c4.WidgetBefore && side > -2)) return child.coordsAt(pos - start, side);
            off = start;
        }
    }
    measureVisibleLineHeights(viewport) {
        let result = [], { from: from, to: to } = viewport;
        let contentWidth = this.view.contentDOM.clientWidth;
        let isWider = contentWidth > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1;
        let widest = -1, ltr = this.view.textDirection == $e7161f778706e663$export$cacd6541cfeeb6c1.LTR;
        for(let pos = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            if (end > to) break;
            if (pos >= from) {
                let childRect = child.dom.getBoundingClientRect();
                result.push(childRect.height);
                if (isWider) {
                    let last = child.dom.lastChild;
                    let rects = last ? $e7161f778706e663$var$clientRectsFor(last) : [];
                    if (rects.length) {
                        let rect = rects[rects.length - 1];
                        let width = ltr ? rect.right - childRect.left : childRect.right - rect.left;
                        if (width > widest) {
                            widest = width;
                            this.minWidth = contentWidth;
                            this.minWidthFrom = pos;
                            this.minWidthTo = end;
                        }
                    }
                }
            }
            pos = end + child.breakAfter;
        }
        return result;
    }
    textDirectionAt(pos) {
        let { i: i } = this.childPos(pos, 1);
        return getComputedStyle(this.children[i].dom).direction == "rtl" ? $e7161f778706e663$export$cacd6541cfeeb6c1.RTL : $e7161f778706e663$export$cacd6541cfeeb6c1.LTR;
    }
    measureTextSize() {
        for (let child of this.children)if (child instanceof $e7161f778706e663$var$LineView) {
            let measure = child.measureTextSize();
            if (measure) return measure;
        }
        // If no workable line exists, force a layout of a measurable element
        let dummy = document.createElement("div"), lineHeight, charWidth, textHeight;
        dummy.className = "cm-line";
        dummy.style.width = "99999px";
        dummy.textContent = "abc def ghi jkl mno pqr stu";
        this.view.observer.ignore(()=>{
            this.dom.appendChild(dummy);
            let rect = $e7161f778706e663$var$clientRectsFor(dummy.firstChild)[0];
            lineHeight = dummy.getBoundingClientRect().height;
            charWidth = rect ? rect.width / 27 : 7;
            textHeight = rect ? rect.height : lineHeight;
            dummy.remove();
        });
        return {
            lineHeight: lineHeight,
            charWidth: charWidth,
            textHeight: textHeight
        };
    }
    childCursor(pos = this.length) {
        // Move back to start of last element when possible, so that
        // `ChildCursor.findPos` doesn't have to deal with the edge case
        // of being after the last element.
        let i = this.children.length;
        if (i) pos -= this.children[--i].length;
        return new $e7161f778706e663$var$ChildCursor(this.children, pos, i);
    }
    computeBlockGapDeco() {
        let deco = [], vs = this.view.viewState;
        for(let pos = 0, i = 0;; i++){
            let next = i == vs.viewports.length ? null : vs.viewports[i];
            let end = next ? next.from - 1 : this.length;
            if (end > pos) {
                let height = vs.lineBlockAt(end).bottom - vs.lineBlockAt(pos).top;
                deco.push($e7161f778706e663$export$10e30b733df217ea.replace({
                    widget: new $e7161f778706e663$var$BlockGapWidget(height),
                    block: true,
                    inclusive: true,
                    isBlockGap: true
                }).range(pos, end));
            }
            if (!next) break;
            pos = next.to + 1;
        }
        return $e7161f778706e663$export$10e30b733df217ea.set(deco);
    }
    updateDeco() {
        let allDeco = this.view.state.facet($e7161f778706e663$var$decorations).map((d, i)=>{
            let dynamic = this.dynamicDecorationMap[i] = typeof d == "function";
            return dynamic ? d(this.view) : d;
        });
        for(let i = allDeco.length; i < allDeco.length + 3; i++)this.dynamicDecorationMap[i] = false;
        return this.decorations = [
            ...allDeco,
            this.compositionDeco,
            this.computeBlockGapDeco(),
            this.view.viewState.lineGapDeco
        ];
    }
    scrollIntoView(target) {
        let { range: range } = target;
        let rect = this.coordsAt(range.head, range.empty ? range.assoc : range.head > range.anchor ? -1 : 1), other;
        if (!rect) return;
        if (!range.empty && (other = this.coordsAt(range.anchor, range.anchor > range.head ? -1 : 1))) rect = {
            left: Math.min(rect.left, other.left),
            top: Math.min(rect.top, other.top),
            right: Math.max(rect.right, other.right),
            bottom: Math.max(rect.bottom, other.bottom)
        };
        let margins = $e7161f778706e663$var$getScrollMargins(this.view);
        let targetRect = {
            left: rect.left - margins.left,
            top: rect.top - margins.top,
            right: rect.right + margins.right,
            bottom: rect.bottom + margins.bottom
        };
        $e7161f778706e663$var$scrollRectIntoView(this.view.scrollDOM, targetRect, range.head < range.anchor ? -1 : 1, target.x, target.y, target.xMargin, target.yMargin, this.view.textDirection == $e7161f778706e663$export$cacd6541cfeeb6c1.LTR);
    }
}
function $e7161f778706e663$var$betweenUneditable(pos) {
    return pos.node.nodeType == 1 && pos.node.firstChild && (pos.offset == 0 || pos.node.childNodes[pos.offset - 1].contentEditable == "false") && (pos.offset == pos.node.childNodes.length || pos.node.childNodes[pos.offset].contentEditable == "false");
}
class $e7161f778706e663$var$BlockGapWidget extends $e7161f778706e663$export$95cdd842edb044c5 {
    constructor(height){
        super();
        this.height = height;
    }
    toDOM() {
        let elt = document.createElement("div");
        this.updateDOM(elt);
        return elt;
    }
    eq(other) {
        return other.height == this.height;
    }
    updateDOM(elt) {
        elt.style.height = this.height + "px";
        return true;
    }
    get estimatedHeight() {
        return this.height;
    }
}
function $e7161f778706e663$var$compositionSurroundingNode(view) {
    let sel = view.observer.selectionRange;
    let textNode = sel.focusNode && $e7161f778706e663$var$nearbyTextNode(sel.focusNode, sel.focusOffset, 0);
    if (!textNode) return null;
    let cView = view.docView.nearest(textNode);
    if (!cView) return null;
    if (cView instanceof $e7161f778706e663$var$LineView) {
        let topNode = textNode;
        while(topNode.parentNode != cView.dom)topNode = topNode.parentNode;
        let prev = topNode.previousSibling;
        while(prev && !$e7161f778706e663$var$ContentView.get(prev))prev = prev.previousSibling;
        let pos = prev ? $e7161f778706e663$var$ContentView.get(prev).posAtEnd : cView.posAtStart;
        return {
            from: pos,
            to: pos,
            node: topNode,
            text: textNode
        };
    } else {
        for(;;){
            let { parent: parent } = cView;
            if (!parent) return null;
            if (parent instanceof $e7161f778706e663$var$LineView) break;
            cView = parent;
        }
        let from = cView.posAtStart;
        return {
            from: from,
            to: from + cView.length,
            node: cView.dom,
            text: textNode
        };
    }
}
function $e7161f778706e663$var$computeCompositionDeco(view, changes) {
    let surrounding = $e7161f778706e663$var$compositionSurroundingNode(view);
    if (!surrounding) return $e7161f778706e663$export$10e30b733df217ea.none;
    let { from: from, to: to, node: node, text: textNode } = surrounding;
    let newFrom = changes.mapPos(from, 1), newTo = Math.max(newFrom, changes.mapPos(to, -1));
    let { state: state } = view, reader = new $e7161f778706e663$var$DOMReader([], state);
    if (node.nodeType == 3) reader.readTextNode(node);
    else reader.readRange(node.firstChild, null);
    let { text: text } = reader;
    if (text.indexOf($e7161f778706e663$var$LineBreakPlaceholder) > -1) return $e7161f778706e663$export$10e30b733df217ea.none; // Don't try to preserve multi-line compositions
    if (newTo - newFrom < text.length) {
        if (state.doc.sliceString(newFrom, Math.min(state.doc.length, newFrom + text.length)) == text) newTo = newFrom + text.length;
        else if (state.doc.sliceString(Math.max(0, newTo - text.length), newTo) == text) newFrom = newTo - text.length;
        else return $e7161f778706e663$export$10e30b733df217ea.none;
    } else if (state.doc.sliceString(newFrom, newTo) != text) return $e7161f778706e663$export$10e30b733df217ea.none;
    let topView = $e7161f778706e663$var$ContentView.get(node);
    if (topView instanceof $e7161f778706e663$var$CompositionView) topView = topView.widget.topView;
    else if (topView) topView.parent = null;
    return $e7161f778706e663$export$10e30b733df217ea.set($e7161f778706e663$export$10e30b733df217ea.replace({
        widget: new $e7161f778706e663$var$CompositionWidget(node, textNode, topView),
        inclusive: true
    }).range(newFrom, newTo));
}
class $e7161f778706e663$var$CompositionWidget extends $e7161f778706e663$export$95cdd842edb044c5 {
    constructor(top, text, topView){
        super();
        this.top = top;
        this.text = text;
        this.topView = topView;
    }
    eq(other) {
        return this.top == other.top && this.text == other.text;
    }
    toDOM() {
        return this.top;
    }
    ignoreEvent() {
        return false;
    }
    get customView() {
        return $e7161f778706e663$var$CompositionView;
    }
}
function $e7161f778706e663$var$nearbyTextNode(startNode, startOffset, side) {
    if (side <= 0) for(let node = startNode, offset = startOffset;;){
        if (node.nodeType == 3) return node;
        if (node.nodeType == 1 && offset > 0) {
            node = node.childNodes[offset - 1];
            offset = $e7161f778706e663$var$maxOffset(node);
        } else break;
    }
    if (side >= 0) for(let node = startNode, offset = startOffset;;){
        if (node.nodeType == 3) return node;
        if (node.nodeType == 1 && offset < node.childNodes.length && side >= 0) {
            node = node.childNodes[offset];
            offset = 0;
        } else break;
    }
    return null;
}
function $e7161f778706e663$var$nextToUneditable(node, offset) {
    if (node.nodeType != 1) return 0;
    return (offset && node.childNodes[offset - 1].contentEditable == "false" ? 1 /* Before */  : 0) | (offset < node.childNodes.length && node.childNodes[offset].contentEditable == "false" ? 2 /* After */  : 0);
}
class $e7161f778706e663$var$DecorationComparator$1 {
    constructor(){
        this.changes = [];
    }
    compareRange(from, to) {
        $e7161f778706e663$var$addRange(from, to, this.changes);
    }
    comparePoint(from, to) {
        $e7161f778706e663$var$addRange(from, to, this.changes);
    }
}
function $e7161f778706e663$var$findChangedDeco(a, b, diff) {
    let comp = new $e7161f778706e663$var$DecorationComparator$1;
    (0, $hB7kI.RangeSet).compare(a, b, diff, comp);
    return comp.changes;
}
function $e7161f778706e663$var$inUneditable(node, inside) {
    for(let cur = node; cur && cur != inside; cur = cur.assignedSlot || cur.parentNode){
        if (cur.nodeType == 1 && cur.contentEditable == "false") return true;
    }
    return false;
}
function $e7161f778706e663$var$groupAt(state, pos, bias = 1) {
    let categorize = state.charCategorizer(pos);
    let line = state.doc.lineAt(pos), linePos = pos - line.from;
    if (line.length == 0) return (0, $hB7kI.EditorSelection).cursor(pos);
    if (linePos == 0) bias = 1;
    else if (linePos == line.length) bias = -1;
    let from = linePos, to = linePos;
    if (bias < 0) from = (0, $hB7kI.findClusterBreak)(line.text, linePos, false);
    else to = (0, $hB7kI.findClusterBreak)(line.text, linePos);
    let cat = categorize(line.text.slice(from, to));
    while(from > 0){
        let prev = (0, $hB7kI.findClusterBreak)(line.text, from, false);
        if (categorize(line.text.slice(prev, from)) != cat) break;
        from = prev;
    }
    while(to < line.length){
        let next = (0, $hB7kI.findClusterBreak)(line.text, to);
        if (categorize(line.text.slice(to, next)) != cat) break;
        to = next;
    }
    return (0, $hB7kI.EditorSelection).range(from + line.from, to + line.from);
}
// Search the DOM for the {node, offset} position closest to the given
// coordinates. Very inefficient and crude, but can usually be avoided
// by calling caret(Position|Range)FromPoint instead.
function $e7161f778706e663$var$getdx(x, rect) {
    return rect.left > x ? rect.left - x : Math.max(0, x - rect.right);
}
function $e7161f778706e663$var$getdy(y, rect) {
    return rect.top > y ? rect.top - y : Math.max(0, y - rect.bottom);
}
function $e7161f778706e663$var$yOverlap(a, b) {
    return a.top < b.bottom - 1 && a.bottom > b.top + 1;
}
function $e7161f778706e663$var$upTop(rect, top) {
    return top < rect.top ? {
        top: top,
        left: rect.left,
        right: rect.right,
        bottom: rect.bottom
    } : rect;
}
function $e7161f778706e663$var$upBot(rect, bottom) {
    return bottom > rect.bottom ? {
        top: rect.top,
        left: rect.left,
        right: rect.right,
        bottom: bottom
    } : rect;
}
function $e7161f778706e663$var$domPosAtCoords(parent, x, y) {
    let closest, closestRect, closestX, closestY, closestOverlap = false;
    let above, below, aboveRect, belowRect;
    for(let child = parent.firstChild; child; child = child.nextSibling){
        let rects = $e7161f778706e663$var$clientRectsFor(child);
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (closestRect && $e7161f778706e663$var$yOverlap(closestRect, rect)) rect = $e7161f778706e663$var$upTop($e7161f778706e663$var$upBot(rect, closestRect.bottom), closestRect.top);
            let dx = $e7161f778706e663$var$getdx(x, rect), dy = $e7161f778706e663$var$getdy(y, rect);
            if (dx == 0 && dy == 0) return child.nodeType == 3 ? $e7161f778706e663$var$domPosInText(child, x, y) : $e7161f778706e663$var$domPosAtCoords(child, x, y);
            if (!closest || closestY > dy || closestY == dy && closestX > dx) {
                closest = child;
                closestRect = rect;
                closestX = dx;
                closestY = dy;
                let side = dy ? y < rect.top ? -1 : 1 : dx ? x < rect.left ? -1 : 1 : 0;
                closestOverlap = !side || (side > 0 ? i < rects.length - 1 : i > 0);
            }
            if (dx == 0) {
                if (y > rect.bottom && (!aboveRect || aboveRect.bottom < rect.bottom)) {
                    above = child;
                    aboveRect = rect;
                } else if (y < rect.top && (!belowRect || belowRect.top > rect.top)) {
                    below = child;
                    belowRect = rect;
                }
            } else if (aboveRect && $e7161f778706e663$var$yOverlap(aboveRect, rect)) aboveRect = $e7161f778706e663$var$upBot(aboveRect, rect.bottom);
            else if (belowRect && $e7161f778706e663$var$yOverlap(belowRect, rect)) belowRect = $e7161f778706e663$var$upTop(belowRect, rect.top);
        }
    }
    if (aboveRect && aboveRect.bottom >= y) {
        closest = above;
        closestRect = aboveRect;
    } else if (belowRect && belowRect.top <= y) {
        closest = below;
        closestRect = belowRect;
    }
    if (!closest) return {
        node: parent,
        offset: 0
    };
    let clipX = Math.max(closestRect.left, Math.min(closestRect.right, x));
    if (closest.nodeType == 3) return $e7161f778706e663$var$domPosInText(closest, clipX, y);
    if (closestOverlap && closest.contentEditable != "false") return $e7161f778706e663$var$domPosAtCoords(closest, clipX, y);
    let offset = Array.prototype.indexOf.call(parent.childNodes, closest) + (x >= (closestRect.left + closestRect.right) / 2 ? 1 : 0);
    return {
        node: parent,
        offset: offset
    };
}
function $e7161f778706e663$var$domPosInText(node, x, y) {
    let len = node.nodeValue.length;
    let closestOffset = -1, closestDY = 1e9, generalSide = 0;
    for(let i = 0; i < len; i++){
        let rects = $e7161f778706e663$var$textRange(node, i, i + 1).getClientRects();
        for(let j = 0; j < rects.length; j++){
            let rect = rects[j];
            if (rect.top == rect.bottom) continue;
            if (!generalSide) generalSide = x - rect.left;
            let dy = (rect.top > y ? rect.top - y : y - rect.bottom) - 1;
            if (rect.left - 1 <= x && rect.right + 1 >= x && dy < closestDY) {
                let right = x >= (rect.left + rect.right) / 2, after = right;
                if ($e7161f778706e663$var$browser.chrome || $e7161f778706e663$var$browser.gecko) {
                    // Check for RTL on browsers that support getting client
                    // rects for empty ranges.
                    let rectBefore = $e7161f778706e663$var$textRange(node, i).getBoundingClientRect();
                    if (rectBefore.left == rect.right) after = !right;
                }
                if (dy <= 0) return {
                    node: node,
                    offset: i + (after ? 1 : 0)
                };
                closestOffset = i + (after ? 1 : 0);
                closestDY = dy;
            }
        }
    }
    return {
        node: node,
        offset: closestOffset > -1 ? closestOffset : generalSide > 0 ? node.nodeValue.length : 0
    };
}
function $e7161f778706e663$var$posAtCoords(view, coords, precise, bias = -1) {
    var _a, _b;
    let content = view.contentDOM.getBoundingClientRect(), docTop = content.top + view.viewState.paddingTop;
    let block, { docHeight: docHeight } = view.viewState;
    let { x: x, y: y } = coords, yOffset = y - docTop;
    if (yOffset < 0) return 0;
    if (yOffset > docHeight) return view.state.doc.length;
    // Scan for a text block near the queried y position
    for(let halfLine = view.viewState.heightOracle.textHeight / 2, bounced = false;;){
        block = view.elementAtHeight(yOffset);
        if (block.type == $e7161f778706e663$export$48808c686fe495c4.Text) break;
        for(;;){
            // Move the y position out of this block
            yOffset = bias > 0 ? block.bottom + halfLine : block.top - halfLine;
            if (yOffset >= 0 && yOffset <= docHeight) break;
            // If the document consists entirely of replaced widgets, we
            // won't find a text block, so return 0
            if (bounced) return precise ? null : 0;
            bounced = true;
            bias = -bias;
        }
    }
    y = docTop + yOffset;
    let lineStart = block.from;
    // If this is outside of the rendered viewport, we can't determine a position
    if (lineStart < view.viewport.from) return view.viewport.from == 0 ? 0 : precise ? null : $e7161f778706e663$var$posAtCoordsImprecise(view, content, block, x, y);
    if (lineStart > view.viewport.to) return view.viewport.to == view.state.doc.length ? view.state.doc.length : precise ? null : $e7161f778706e663$var$posAtCoordsImprecise(view, content, block, x, y);
    // Prefer ShadowRootOrDocument.elementFromPoint if present, fall back to document if not
    let doc = view.dom.ownerDocument;
    let root = view.root.elementFromPoint ? view.root : doc;
    let element = root.elementFromPoint(x, y);
    if (element && !view.contentDOM.contains(element)) element = null;
    // If the element is unexpected, clip x at the sides of the content area and try again
    if (!element) {
        x = Math.max(content.left + 1, Math.min(content.right - 1, x));
        element = root.elementFromPoint(x, y);
        if (element && !view.contentDOM.contains(element)) element = null;
    }
    // There's visible editor content under the point, so we can try
    // using caret(Position|Range)FromPoint as a shortcut
    let node, offset = -1;
    if (element && ((_a = view.docView.nearest(element)) === null || _a === void 0 ? void 0 : _a.isEditable) != false) {
        if (doc.caretPositionFromPoint) {
            let pos = doc.caretPositionFromPoint(x, y);
            if (pos) ({ offsetNode: node, offset: offset } = pos);
        } else if (doc.caretRangeFromPoint) {
            let range = doc.caretRangeFromPoint(x, y);
            if (range) {
                ({ startContainer: node, startOffset: offset } = range);
                if (!view.contentDOM.contains(node) || $e7161f778706e663$var$browser.safari && $e7161f778706e663$var$isSuspiciousSafariCaretResult(node, offset, x) || $e7161f778706e663$var$browser.chrome && $e7161f778706e663$var$isSuspiciousChromeCaretResult(node, offset, x)) node = undefined;
            }
        }
    }
    // No luck, do our own (potentially expensive) search
    if (!node || !view.docView.dom.contains(node)) {
        let line = $e7161f778706e663$var$LineView.find(view.docView, lineStart);
        if (!line) return yOffset > block.top + block.height / 2 ? block.to : block.from;
        ({ node: node, offset: offset } = $e7161f778706e663$var$domPosAtCoords(line.dom, x, y));
    }
    let nearest = view.docView.nearest(node);
    if (!nearest) return null;
    if (nearest.isWidget && ((_b = nearest.dom) === null || _b === void 0 ? void 0 : _b.nodeType) == 1) {
        let rect = nearest.dom.getBoundingClientRect();
        return coords.y < rect.top || coords.y <= rect.bottom && coords.x <= (rect.left + rect.right) / 2 ? nearest.posAtStart : nearest.posAtEnd;
    } else return nearest.localPosFromDOM(node, offset) + nearest.posAtStart;
}
function $e7161f778706e663$var$posAtCoordsImprecise(view, contentRect, block, x, y) {
    let into = Math.round((x - contentRect.left) * view.defaultCharacterWidth);
    if (view.lineWrapping && block.height > view.defaultLineHeight * 1.5) {
        let textHeight = view.viewState.heightOracle.textHeight;
        let line = Math.floor((y - block.top - (view.defaultLineHeight - textHeight) * 0.5) / textHeight);
        into += line * view.viewState.heightOracle.lineLength;
    }
    let content = view.state.sliceDoc(block.from, block.to);
    return block.from + (0, $hB7kI.findColumn)(content, into, view.state.tabSize);
}
// In case of a high line height, Safari's caretRangeFromPoint treats
// the space between lines as belonging to the last character of the
// line before. This is used to detect such a result so that it can be
// ignored (issue #401).
function $e7161f778706e663$var$isSuspiciousSafariCaretResult(node, offset, x) {
    let len;
    if (node.nodeType != 3 || offset != (len = node.nodeValue.length)) return false;
    for(let next = node.nextSibling; next; next = next.nextSibling)if (next.nodeType != 1 || next.nodeName != "BR") return false;
    return $e7161f778706e663$var$textRange(node, len - 1, len).getBoundingClientRect().left > x;
}
// Chrome will move positions between lines to the start of the next line
function $e7161f778706e663$var$isSuspiciousChromeCaretResult(node, offset, x) {
    if (offset != 0) return false;
    for(let cur = node;;){
        let parent = cur.parentNode;
        if (!parent || parent.nodeType != 1 || parent.firstChild != cur) return false;
        if (parent.classList.contains("cm-line")) break;
        cur = parent;
    }
    let rect = node.nodeType == 1 ? node.getBoundingClientRect() : $e7161f778706e663$var$textRange(node, 0, Math.max(node.nodeValue.length, 1)).getBoundingClientRect();
    return x - rect.left > 5;
}
function $e7161f778706e663$var$blockAt(view, pos) {
    let line = view.lineBlockAt(pos);
    if (Array.isArray(line.type)) for (let l of line.type){
        if (l.to > pos || l.to == pos && (l.to == line.to || l.type == $e7161f778706e663$export$48808c686fe495c4.Text)) return l;
    }
    return line;
}
function $e7161f778706e663$var$moveToLineBoundary(view, start, forward, includeWrap) {
    let line = $e7161f778706e663$var$blockAt(view, start.head);
    let coords = !includeWrap || line.type != $e7161f778706e663$export$48808c686fe495c4.Text || !(view.lineWrapping || line.widgetLineBreaks) ? null : view.coordsAtPos(start.assoc < 0 && start.head > line.from ? start.head - 1 : start.head);
    if (coords) {
        let editorRect = view.dom.getBoundingClientRect();
        let direction = view.textDirectionAt(line.from);
        let pos = view.posAtCoords({
            x: forward == (direction == $e7161f778706e663$export$cacd6541cfeeb6c1.LTR) ? editorRect.right - 1 : editorRect.left + 1,
            y: (coords.top + coords.bottom) / 2
        });
        if (pos != null) return (0, $hB7kI.EditorSelection).cursor(pos, forward ? -1 : 1);
    }
    return (0, $hB7kI.EditorSelection).cursor(forward ? line.to : line.from, forward ? -1 : 1);
}
function $e7161f778706e663$var$moveByChar(view, start, forward, by) {
    let line = view.state.doc.lineAt(start.head), spans = view.bidiSpans(line);
    let direction = view.textDirectionAt(line.from);
    for(let cur = start, check = null;;){
        let next = $e7161f778706e663$var$moveVisually(line, spans, direction, cur, forward), char = $e7161f778706e663$var$movedOver;
        if (!next) {
            if (line.number == (forward ? view.state.doc.lines : 1)) return cur;
            char = "\n";
            line = view.state.doc.line(line.number + (forward ? 1 : -1));
            spans = view.bidiSpans(line);
            next = (0, $hB7kI.EditorSelection).cursor(forward ? line.from : line.to);
        }
        if (!check) {
            if (!by) return next;
            check = by(char);
        } else if (!check(char)) return cur;
        cur = next;
    }
}
function $e7161f778706e663$var$byGroup(view, pos, start) {
    let categorize = view.state.charCategorizer(pos);
    let cat = categorize(start);
    return (next)=>{
        let nextCat = categorize(next);
        if (cat == (0, $hB7kI.CharCategory).Space) cat = nextCat;
        return cat == nextCat;
    };
}
function $e7161f778706e663$var$moveVertically(view, start, forward, distance) {
    let startPos = start.head, dir = forward ? 1 : -1;
    if (startPos == (forward ? view.state.doc.length : 0)) return (0, $hB7kI.EditorSelection).cursor(startPos, start.assoc);
    let goal = start.goalColumn, startY;
    let rect = view.contentDOM.getBoundingClientRect();
    let startCoords = view.coordsAtPos(startPos), docTop = view.documentTop;
    if (startCoords) {
        if (goal == null) goal = startCoords.left - rect.left;
        startY = dir < 0 ? startCoords.top : startCoords.bottom;
    } else {
        let line = view.viewState.lineBlockAt(startPos);
        if (goal == null) goal = Math.min(rect.right - rect.left, view.defaultCharacterWidth * (startPos - line.from));
        startY = (dir < 0 ? line.top : line.bottom) + docTop;
    }
    let resolvedGoal = rect.left + goal;
    let dist = distance !== null && distance !== void 0 ? distance : view.viewState.heightOracle.textHeight >> 1;
    for(let extra = 0;; extra += 10){
        let curY = startY + (dist + extra) * dir;
        let pos = $e7161f778706e663$var$posAtCoords(view, {
            x: resolvedGoal,
            y: curY
        }, false, dir);
        if (curY < rect.top || curY > rect.bottom || (dir < 0 ? pos < startPos : pos > startPos)) return (0, $hB7kI.EditorSelection).cursor(pos, start.assoc, undefined, goal);
    }
}
function $e7161f778706e663$var$skipAtomicRanges(atoms, pos, bias) {
    for(;;){
        let moved = 0;
        for (let set of atoms)set.between(pos - 1, pos + 1, (from, to, value)=>{
            if (pos > from && pos < to) {
                let side = moved || bias || (pos - from < to - pos ? -1 : 1);
                pos = side < 0 ? from : to;
                moved = side;
            }
        });
        if (!moved) return pos;
    }
}
function $e7161f778706e663$var$skipAtoms(view, oldPos, pos) {
    let newPos = $e7161f778706e663$var$skipAtomicRanges(view.state.facet($e7161f778706e663$var$atomicRanges).map((f)=>f(view)), pos.from, oldPos.head > pos.from ? -1 : 1);
    return newPos == pos.from ? pos : (0, $hB7kI.EditorSelection).cursor(newPos, newPos < pos.from ? 1 : -1);
}
// This will also be where dragging info and such goes
class $e7161f778706e663$var$InputState {
    constructor(view){
        this.lastKeyCode = 0;
        this.lastKeyTime = 0;
        this.lastTouchTime = 0;
        this.lastFocusTime = 0;
        this.lastScrollTop = 0;
        this.lastScrollLeft = 0;
        this.chromeScrollHack = -1;
        // On iOS, some keys need to have their default behavior happen
        // (after which we retroactively handle them and reset the DOM) to
        // avoid messing up the virtual keyboard state.
        this.pendingIOSKey = undefined;
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastEscPress = 0;
        this.lastContextMenu = 0;
        this.scrollHandlers = [];
        this.registeredEvents = [];
        this.customHandlers = [];
        // -1 means not in a composition. Otherwise, this counts the number
        // of changes made during the composition. The count is used to
        // avoid treating the start state of the composition, before any
        // changes have been made, as part of the composition.
        this.composing = -1;
        // Tracks whether the next change should be marked as starting the
        // composition (null means no composition, true means next is the
        // first, false means first has already been marked for this
        // composition)
        this.compositionFirstChange = null;
        // End time of the previous composition
        this.compositionEndedAt = 0;
        // Used in a kludge to detect when an Enter keypress should be
        // considered part of the composition on Safari, which fires events
        // in the wrong order
        this.compositionPendingKey = false;
        // Used to categorize changes as part of a composition, even when
        // the mutation events fire shortly after the compositionend event
        this.compositionPendingChange = false;
        this.mouseSelection = null;
        let handleEvent = (handler, event)=>{
            if (this.ignoreDuringComposition(event)) return;
            if (event.type == "keydown" && this.keydown(view, event)) return;
            if (this.mustFlushObserver(event)) view.observer.forceFlush();
            if (this.runCustomHandlers(event.type, view, event)) event.preventDefault();
            else handler(view, event);
        };
        for(let type in $e7161f778706e663$var$handlers){
            let handler = $e7161f778706e663$var$handlers[type];
            view.contentDOM.addEventListener(type, (event)=>{
                if ($e7161f778706e663$var$eventBelongsToEditor(view, event)) handleEvent(handler, event);
            }, $e7161f778706e663$var$handlerOptions[type]);
            this.registeredEvents.push(type);
        }
        view.scrollDOM.addEventListener("mousedown", (event)=>{
            if (event.target == view.scrollDOM && event.clientY > view.contentDOM.getBoundingClientRect().bottom) {
                handleEvent($e7161f778706e663$var$handlers.mousedown, event);
                if (!event.defaultPrevented && event.button == 2) {
                    // Make sure the content covers the entire scroller height, in order
                    // to catch a native context menu click below it
                    let start = view.contentDOM.style.minHeight;
                    view.contentDOM.style.minHeight = "100%";
                    setTimeout(()=>view.contentDOM.style.minHeight = start, 200);
                }
            }
        });
        view.scrollDOM.addEventListener("drop", (event)=>{
            if (event.target == view.scrollDOM && event.clientY > view.contentDOM.getBoundingClientRect().bottom) handleEvent($e7161f778706e663$var$handlers.drop, event);
        });
        if ($e7161f778706e663$var$browser.chrome && $e7161f778706e663$var$browser.chrome_version == 102) // On Chrome 102, viewport updates somehow stop wheel-based
        // scrolling. Turning off pointer events during the scroll seems
        // to avoid the issue.
        view.scrollDOM.addEventListener("wheel", ()=>{
            if (this.chromeScrollHack < 0) view.contentDOM.style.pointerEvents = "none";
            else window.clearTimeout(this.chromeScrollHack);
            this.chromeScrollHack = setTimeout(()=>{
                this.chromeScrollHack = -1;
                view.contentDOM.style.pointerEvents = "";
            }, 100);
        }, {
            passive: true
        });
        this.notifiedFocused = view.hasFocus;
        // On Safari adding an input event handler somehow prevents an
        // issue where the composition vanishes when you press enter.
        if ($e7161f778706e663$var$browser.safari) view.contentDOM.addEventListener("input", ()=>null);
    }
    setSelectionOrigin(origin) {
        this.lastSelectionOrigin = origin;
        this.lastSelectionTime = Date.now();
    }
    ensureHandlers(view, plugins) {
        var _a;
        let handlers;
        this.customHandlers = [];
        for (let plugin of plugins)if (handlers = (_a = plugin.update(view).spec) === null || _a === void 0 ? void 0 : _a.domEventHandlers) {
            this.customHandlers.push({
                plugin: plugin.value,
                handlers: handlers
            });
            for(let type in handlers)if (this.registeredEvents.indexOf(type) < 0 && type != "scroll") {
                this.registeredEvents.push(type);
                view.contentDOM.addEventListener(type, (event)=>{
                    if (!$e7161f778706e663$var$eventBelongsToEditor(view, event)) return;
                    if (this.runCustomHandlers(type, view, event)) event.preventDefault();
                });
            }
        }
    }
    runCustomHandlers(type, view, event) {
        for (let set of this.customHandlers){
            let handler = set.handlers[type];
            if (handler) try {
                if (handler.call(set.plugin, event, view) || event.defaultPrevented) return true;
            } catch (e) {
                $e7161f778706e663$export$f86b2a1a2ce291b3(view.state, e);
            }
        }
        return false;
    }
    runScrollHandlers(view, event) {
        this.lastScrollTop = view.scrollDOM.scrollTop;
        this.lastScrollLeft = view.scrollDOM.scrollLeft;
        for (let set of this.customHandlers){
            let handler = set.handlers.scroll;
            if (handler) try {
                handler.call(set.plugin, event, view);
            } catch (e) {
                $e7161f778706e663$export$f86b2a1a2ce291b3(view.state, e);
            }
        }
    }
    keydown(view, event) {
        // Must always run, even if a custom handler handled the event
        this.lastKeyCode = event.keyCode;
        this.lastKeyTime = Date.now();
        if (event.keyCode == 9 && Date.now() < this.lastEscPress + 2000) return true;
        if (event.keyCode != 27 && $e7161f778706e663$var$modifierCodes.indexOf(event.keyCode) < 0) view.inputState.lastEscPress = 0;
        // Chrome for Android usually doesn't fire proper key events, but
        // occasionally does, usually surrounded by a bunch of complicated
        // composition changes. When an enter or backspace key event is
        // seen, hold off on handling DOM events for a bit, and then
        // dispatch it.
        if ($e7161f778706e663$var$browser.android && $e7161f778706e663$var$browser.chrome && !event.synthetic && (event.keyCode == 13 || event.keyCode == 8)) {
            view.observer.delayAndroidKey(event.key, event.keyCode);
            return true;
        }
        // Prevent the default behavior of Enter on iOS makes the
        // virtual keyboard get stuck in the wrong (lowercase)
        // state. So we let it go through, and then, in
        // applyDOMChange, notify key handlers of it and reset to
        // the state they produce.
        let pending;
        if ($e7161f778706e663$var$browser.ios && !event.synthetic && !event.altKey && !event.metaKey && ((pending = $e7161f778706e663$var$PendingKeys.find((key)=>key.keyCode == event.keyCode)) && !event.ctrlKey || $e7161f778706e663$var$EmacsyPendingKeys.indexOf(event.key) > -1 && event.ctrlKey && !event.shiftKey)) {
            this.pendingIOSKey = pending || event;
            setTimeout(()=>this.flushIOSKey(view), 250);
            return true;
        }
        return false;
    }
    flushIOSKey(view) {
        let key = this.pendingIOSKey;
        if (!key) return false;
        this.pendingIOSKey = undefined;
        return $e7161f778706e663$var$dispatchKey(view.contentDOM, key.key, key.keyCode);
    }
    ignoreDuringComposition(event) {
        if (!/^key/.test(event.type)) return false;
        if (this.composing > 0) return true;
        // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
        // On some input method editors (IMEs), the Enter key is used to
        // confirm character selection. On Safari, when Enter is pressed,
        // compositionend and keydown events are sometimes emitted in the
        // wrong order. The key event should still be ignored, even when
        // it happens after the compositionend event.
        if ($e7161f778706e663$var$browser.safari && !$e7161f778706e663$var$browser.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100) {
            this.compositionPendingKey = false;
            return true;
        }
        return false;
    }
    mustFlushObserver(event) {
        return event.type == "keydown" && event.keyCode != 229;
    }
    startMouseSelection(mouseSelection) {
        if (this.mouseSelection) this.mouseSelection.destroy();
        this.mouseSelection = mouseSelection;
    }
    update(update) {
        if (this.mouseSelection) this.mouseSelection.update(update);
        if (update.transactions.length) this.lastKeyCode = this.lastSelectionTime = 0;
    }
    destroy() {
        if (this.mouseSelection) this.mouseSelection.destroy();
    }
}
const $e7161f778706e663$var$PendingKeys = [
    {
        key: "Backspace",
        keyCode: 8,
        inputType: "deleteContentBackward"
    },
    {
        key: "Enter",
        keyCode: 13,
        inputType: "insertParagraph"
    },
    {
        key: "Delete",
        keyCode: 46,
        inputType: "deleteContentForward"
    }
];
const $e7161f778706e663$var$EmacsyPendingKeys = "dthko";
// Key codes for modifier keys
const $e7161f778706e663$var$modifierCodes = [
    16,
    17,
    18,
    20,
    91,
    92,
    224,
    225
];
const $e7161f778706e663$var$dragScrollMargin = 6;
function $e7161f778706e663$var$dragScrollSpeed(dist) {
    return Math.max(0, dist) * 0.7 + 8;
}
class $e7161f778706e663$var$MouseSelection {
    constructor(view, startEvent, style, mustSelect){
        this.view = view;
        this.style = style;
        this.mustSelect = mustSelect;
        this.scrollSpeed = {
            x: 0,
            y: 0
        };
        this.scrolling = -1;
        this.lastEvent = startEvent;
        this.scrollParent = $e7161f778706e663$var$scrollableParent(view.contentDOM);
        this.atoms = view.state.facet($e7161f778706e663$var$atomicRanges).map((f)=>f(view));
        let doc = view.contentDOM.ownerDocument;
        doc.addEventListener("mousemove", this.move = this.move.bind(this));
        doc.addEventListener("mouseup", this.up = this.up.bind(this));
        this.extend = startEvent.shiftKey;
        this.multiple = view.state.facet((0, $hB7kI.EditorState).allowMultipleSelections) && $e7161f778706e663$var$addsSelectionRange(view, startEvent);
        this.dragging = $e7161f778706e663$var$isInPrimarySelection(view, startEvent) && $e7161f778706e663$var$getClickType(startEvent) == 1 ? null : false;
    }
    start(event) {
        // When clicking outside of the selection, immediately apply the
        // effect of starting the selection
        if (this.dragging === false) {
            event.preventDefault();
            this.select(event);
        }
    }
    move(event) {
        var _a;
        if (event.buttons == 0) return this.destroy();
        if (this.dragging !== false) return;
        this.select(this.lastEvent = event);
        let sx = 0, sy = 0;
        let rect = ((_a = this.scrollParent) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) || {
            left: 0,
            top: 0,
            right: this.view.win.innerWidth,
            bottom: this.view.win.innerHeight
        };
        let margins = $e7161f778706e663$var$getScrollMargins(this.view);
        if (event.clientX - margins.left <= rect.left + $e7161f778706e663$var$dragScrollMargin) sx = -$e7161f778706e663$var$dragScrollSpeed(rect.left - event.clientX);
        else if (event.clientX + margins.right >= rect.right - $e7161f778706e663$var$dragScrollMargin) sx = $e7161f778706e663$var$dragScrollSpeed(event.clientX - rect.right);
        if (event.clientY - margins.top <= rect.top + $e7161f778706e663$var$dragScrollMargin) sy = -$e7161f778706e663$var$dragScrollSpeed(rect.top - event.clientY);
        else if (event.clientY + margins.bottom >= rect.bottom - $e7161f778706e663$var$dragScrollMargin) sy = $e7161f778706e663$var$dragScrollSpeed(event.clientY - rect.bottom);
        this.setScrollSpeed(sx, sy);
    }
    up(event) {
        if (this.dragging == null) this.select(this.lastEvent);
        if (!this.dragging) event.preventDefault();
        this.destroy();
    }
    destroy() {
        this.setScrollSpeed(0, 0);
        let doc = this.view.contentDOM.ownerDocument;
        doc.removeEventListener("mousemove", this.move);
        doc.removeEventListener("mouseup", this.up);
        this.view.inputState.mouseSelection = null;
    }
    setScrollSpeed(sx, sy) {
        this.scrollSpeed = {
            x: sx,
            y: sy
        };
        if (sx || sy) {
            if (this.scrolling < 0) this.scrolling = setInterval(()=>this.scroll(), 50);
        } else if (this.scrolling > -1) {
            clearInterval(this.scrolling);
            this.scrolling = -1;
        }
    }
    scroll() {
        if (this.scrollParent) {
            this.scrollParent.scrollLeft += this.scrollSpeed.x;
            this.scrollParent.scrollTop += this.scrollSpeed.y;
        } else this.view.win.scrollBy(this.scrollSpeed.x, this.scrollSpeed.y);
        if (this.dragging === false) this.select(this.lastEvent);
    }
    skipAtoms(sel) {
        let ranges = null;
        for(let i = 0; i < sel.ranges.length; i++){
            let range = sel.ranges[i], updated = null;
            if (range.empty) {
                let pos = $e7161f778706e663$var$skipAtomicRanges(this.atoms, range.from, 0);
                if (pos != range.from) updated = (0, $hB7kI.EditorSelection).cursor(pos, -1);
            } else {
                let from = $e7161f778706e663$var$skipAtomicRanges(this.atoms, range.from, -1);
                let to = $e7161f778706e663$var$skipAtomicRanges(this.atoms, range.to, 1);
                if (from != range.from || to != range.to) updated = (0, $hB7kI.EditorSelection).range(range.from == range.anchor ? from : to, range.from == range.head ? from : to);
            }
            if (updated) {
                if (!ranges) ranges = sel.ranges.slice();
                ranges[i] = updated;
            }
        }
        return ranges ? (0, $hB7kI.EditorSelection).create(ranges, sel.mainIndex) : sel;
    }
    select(event) {
        let { view: view } = this, selection = this.skipAtoms(this.style.get(event, this.extend, this.multiple));
        if (this.mustSelect || !selection.eq(view.state.selection) || selection.main.assoc != view.state.selection.main.assoc) this.view.dispatch({
            selection: selection,
            userEvent: "select.pointer"
        });
        this.mustSelect = false;
    }
    update(update) {
        if (update.docChanged && this.dragging) this.dragging = this.dragging.map(update.changes);
        if (this.style.update(update)) setTimeout(()=>this.select(this.lastEvent), 20);
    }
}
function $e7161f778706e663$var$addsSelectionRange(view, event) {
    let facet = view.state.facet($e7161f778706e663$var$clickAddsSelectionRange);
    return facet.length ? facet[0](event) : $e7161f778706e663$var$browser.mac ? event.metaKey : event.ctrlKey;
}
function $e7161f778706e663$var$dragMovesSelection(view, event) {
    let facet = view.state.facet($e7161f778706e663$var$dragMovesSelection$1);
    return facet.length ? facet[0](event) : $e7161f778706e663$var$browser.mac ? !event.altKey : !event.ctrlKey;
}
function $e7161f778706e663$var$isInPrimarySelection(view, event) {
    let { main: main } = view.state.selection;
    if (main.empty) return false;
    // On boundary clicks, check whether the coordinates are inside the
    // selection's client rectangles
    let sel = $e7161f778706e663$var$getSelection(view.root);
    if (!sel || sel.rangeCount == 0) return true;
    let rects = sel.getRangeAt(0).getClientRects();
    for(let i = 0; i < rects.length; i++){
        let rect = rects[i];
        if (rect.left <= event.clientX && rect.right >= event.clientX && rect.top <= event.clientY && rect.bottom >= event.clientY) return true;
    }
    return false;
}
function $e7161f778706e663$var$eventBelongsToEditor(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target, cView; node != view.contentDOM; node = node.parentNode)if (!node || node.nodeType == 11 || (cView = $e7161f778706e663$var$ContentView.get(node)) && cView.ignoreEvent(event)) return false;
    return true;
}
const $e7161f778706e663$var$handlers = /*@__PURE__*/ Object.create(null);
const $e7161f778706e663$var$handlerOptions = /*@__PURE__*/ Object.create(null);
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $e7161f778706e663$var$brokenClipboardAPI = $e7161f778706e663$var$browser.ie && $e7161f778706e663$var$browser.ie_version < 15 || $e7161f778706e663$var$browser.ios && $e7161f778706e663$var$browser.webkit_version < 604;
function $e7161f778706e663$var$capturePaste(view) {
    let parent = view.dom.parentNode;
    if (!parent) return;
    let target = parent.appendChild(document.createElement("textarea"));
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    setTimeout(()=>{
        view.focus();
        target.remove();
        $e7161f778706e663$var$doPaste(view, target.value);
    }, 50);
}
function $e7161f778706e663$var$doPaste(view, input) {
    let { state: state } = view, changes, i = 1, text = state.toText(input);
    let byLine = text.lines == state.selection.ranges.length;
    let linewise = $e7161f778706e663$var$lastLinewiseCopy != null && state.selection.ranges.every((r)=>r.empty) && $e7161f778706e663$var$lastLinewiseCopy == text.toString();
    if (linewise) {
        let lastLine = -1;
        changes = state.changeByRange((range)=>{
            let line = state.doc.lineAt(range.from);
            if (line.from == lastLine) return {
                range: range
            };
            lastLine = line.from;
            let insert = state.toText((byLine ? text.line(i++).text : input) + state.lineBreak);
            return {
                changes: {
                    from: line.from,
                    insert: insert
                },
                range: (0, $hB7kI.EditorSelection).cursor(range.from + insert.length)
            };
        });
    } else if (byLine) changes = state.changeByRange((range)=>{
        let line = text.line(i++);
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: line.text
            },
            range: (0, $hB7kI.EditorSelection).cursor(range.from + line.length)
        };
    });
    else changes = state.replaceSelection(text);
    view.dispatch(changes, {
        userEvent: "input.paste",
        scrollIntoView: true
    });
}
$e7161f778706e663$var$handlers.keydown = (view, event)=>{
    view.inputState.setSelectionOrigin("select");
    if (event.keyCode == 27) view.inputState.lastEscPress = Date.now();
};
$e7161f778706e663$var$handlers.touchstart = (view, e)=>{
    view.inputState.lastTouchTime = Date.now();
    view.inputState.setSelectionOrigin("select.pointer");
};
$e7161f778706e663$var$handlers.touchmove = (view)=>{
    view.inputState.setSelectionOrigin("select.pointer");
};
$e7161f778706e663$var$handlerOptions.touchstart = $e7161f778706e663$var$handlerOptions.touchmove = {
    passive: true
};
$e7161f778706e663$var$handlers.mousedown = (view, event)=>{
    view.observer.flush();
    if (view.inputState.lastTouchTime > Date.now() - 2000) return; // Ignore touch interaction
    let style = null;
    for (let makeStyle of view.state.facet($e7161f778706e663$var$mouseSelectionStyle)){
        style = makeStyle(view, event);
        if (style) break;
    }
    if (!style && event.button == 0) style = $e7161f778706e663$var$basicMouseSelection(view, event);
    if (style) {
        let mustFocus = view.root.activeElement != view.contentDOM;
        view.inputState.startMouseSelection(new $e7161f778706e663$var$MouseSelection(view, event, style, mustFocus));
        if (mustFocus) view.observer.ignore(()=>$e7161f778706e663$var$focusPreventScroll(view.contentDOM));
        if (view.inputState.mouseSelection) view.inputState.mouseSelection.start(event);
    }
};
function $e7161f778706e663$var$rangeForClick(view, pos, bias, type) {
    if (type == 1) return (0, $hB7kI.EditorSelection).cursor(pos, bias);
    else if (type == 2) return $e7161f778706e663$var$groupAt(view.state, pos, bias);
    else {
        let visual = $e7161f778706e663$var$LineView.find(view.docView, pos), line = view.state.doc.lineAt(visual ? visual.posAtEnd : pos);
        let from = visual ? visual.posAtStart : line.from, to = visual ? visual.posAtEnd : line.to;
        if (to < view.state.doc.length && to == line.to) to++;
        return (0, $hB7kI.EditorSelection).range(from, to);
    }
}
let $e7161f778706e663$var$insideY = (y, rect)=>y >= rect.top && y <= rect.bottom;
let $e7161f778706e663$var$inside = (x, y, rect)=>$e7161f778706e663$var$insideY(y, rect) && x >= rect.left && x <= rect.right;
// Try to determine, for the given coordinates, associated with the
// given position, whether they are related to the element before or
// the element after the position.
function $e7161f778706e663$var$findPositionSide(view, pos, x, y) {
    let line = $e7161f778706e663$var$LineView.find(view.docView, pos);
    if (!line) return 1;
    let off = pos - line.posAtStart;
    // Line boundaries point into the line
    if (off == 0) return 1;
    if (off == line.length) return -1;
    // Positions on top of an element point at that element
    let before = line.coordsAt(off, -1);
    if (before && $e7161f778706e663$var$inside(x, y, before)) return -1;
    let after = line.coordsAt(off, 1);
    if (after && $e7161f778706e663$var$inside(x, y, after)) return 1;
    // This is probably a line wrap point. Pick before if the point is
    // beside it.
    return before && $e7161f778706e663$var$insideY(y, before) ? -1 : 1;
}
function $e7161f778706e663$var$queryPos(view, event) {
    let pos = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    return {
        pos: pos,
        bias: $e7161f778706e663$var$findPositionSide(view, pos, event.clientX, event.clientY)
    };
}
const $e7161f778706e663$var$BadMouseDetail = $e7161f778706e663$var$browser.ie && $e7161f778706e663$var$browser.ie_version <= 11;
let $e7161f778706e663$var$lastMouseDown = null, $e7161f778706e663$var$lastMouseDownCount = 0, $e7161f778706e663$var$lastMouseDownTime = 0;
function $e7161f778706e663$var$getClickType(event) {
    if (!$e7161f778706e663$var$BadMouseDetail) return event.detail;
    let last = $e7161f778706e663$var$lastMouseDown, lastTime = $e7161f778706e663$var$lastMouseDownTime;
    $e7161f778706e663$var$lastMouseDown = event;
    $e7161f778706e663$var$lastMouseDownTime = Date.now();
    return $e7161f778706e663$var$lastMouseDownCount = !last || lastTime > Date.now() - 400 && Math.abs(last.clientX - event.clientX) < 2 && Math.abs(last.clientY - event.clientY) < 2 ? ($e7161f778706e663$var$lastMouseDownCount + 1) % 3 : 1;
}
function $e7161f778706e663$var$basicMouseSelection(view, event) {
    let start = $e7161f778706e663$var$queryPos(view, event), type = $e7161f778706e663$var$getClickType(event);
    let startSel = view.state.selection;
    return {
        update (update) {
            if (update.docChanged) {
                start.pos = update.changes.mapPos(start.pos);
                startSel = startSel.map(update.changes);
            }
        },
        get (event, extend, multiple) {
            let cur = $e7161f778706e663$var$queryPos(view, event), removed;
            let range = $e7161f778706e663$var$rangeForClick(view, cur.pos, cur.bias, type);
            if (start.pos != cur.pos && !extend) {
                let startRange = $e7161f778706e663$var$rangeForClick(view, start.pos, start.bias, type);
                let from = Math.min(startRange.from, range.from), to = Math.max(startRange.to, range.to);
                range = from < range.from ? (0, $hB7kI.EditorSelection).range(from, to) : (0, $hB7kI.EditorSelection).range(to, from);
            }
            if (extend) return startSel.replaceRange(startSel.main.extend(range.from, range.to));
            else if (multiple && type == 1 && startSel.ranges.length > 1 && (removed = $e7161f778706e663$var$removeRangeAround(startSel, cur.pos))) return removed;
            else if (multiple) return startSel.addRange(range);
            else return (0, $hB7kI.EditorSelection).create([
                range
            ]);
        }
    };
}
function $e7161f778706e663$var$removeRangeAround(sel, pos) {
    for(let i = 0; i < sel.ranges.length; i++){
        let { from: from, to: to } = sel.ranges[i];
        if (from <= pos && to >= pos) return (0, $hB7kI.EditorSelection).create(sel.ranges.slice(0, i).concat(sel.ranges.slice(i + 1)), sel.mainIndex == i ? 0 : sel.mainIndex - (sel.mainIndex > i ? 1 : 0));
    }
    return null;
}
$e7161f778706e663$var$handlers.dragstart = (view, event)=>{
    let { selection: { main: main } } = view.state;
    let { mouseSelection: mouseSelection } = view.inputState;
    if (mouseSelection) mouseSelection.dragging = main;
    if (event.dataTransfer) {
        event.dataTransfer.setData("Text", view.state.sliceDoc(main.from, main.to));
        event.dataTransfer.effectAllowed = "copyMove";
    }
};
function $e7161f778706e663$var$dropText(view, event, text, direct) {
    if (!text) return;
    let dropPos = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    event.preventDefault();
    let { mouseSelection: mouseSelection } = view.inputState;
    let del = direct && mouseSelection && mouseSelection.dragging && $e7161f778706e663$var$dragMovesSelection(view, event) ? {
        from: mouseSelection.dragging.from,
        to: mouseSelection.dragging.to
    } : null;
    let ins = {
        from: dropPos,
        insert: text
    };
    let changes = view.state.changes(del ? [
        del,
        ins
    ] : ins);
    view.focus();
    view.dispatch({
        changes: changes,
        selection: {
            anchor: changes.mapPos(dropPos, -1),
            head: changes.mapPos(dropPos, 1)
        },
        userEvent: del ? "move.drop" : "input.drop"
    });
}
$e7161f778706e663$var$handlers.drop = (view, event)=>{
    if (!event.dataTransfer) return;
    if (view.state.readOnly) return event.preventDefault();
    let files = event.dataTransfer.files;
    if (files && files.length) {
        event.preventDefault();
        let text = Array(files.length), read = 0;
        let finishFile = ()=>{
            if (++read == files.length) $e7161f778706e663$var$dropText(view, event, text.filter((s)=>s != null).join(view.state.lineBreak), false);
        };
        for(let i = 0; i < files.length; i++){
            let reader = new FileReader;
            reader.onerror = finishFile;
            reader.onload = ()=>{
                if (!/[\x00-\x08\x0e-\x1f]{2}/.test(reader.result)) text[i] = reader.result;
                finishFile();
            };
            reader.readAsText(files[i]);
        }
    } else $e7161f778706e663$var$dropText(view, event, event.dataTransfer.getData("Text"), true);
};
$e7161f778706e663$var$handlers.paste = (view, event)=>{
    if (view.state.readOnly) return event.preventDefault();
    view.observer.flush();
    let data = $e7161f778706e663$var$brokenClipboardAPI ? null : event.clipboardData;
    if (data) {
        $e7161f778706e663$var$doPaste(view, data.getData("text/plain") || data.getData("text/uri-text"));
        event.preventDefault();
    } else $e7161f778706e663$var$capturePaste(view);
};
function $e7161f778706e663$var$captureCopy(view, text) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    let parent = view.dom.parentNode;
    if (!parent) return;
    let target = parent.appendChild(document.createElement("textarea"));
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.value = text;
    target.focus();
    target.selectionEnd = text.length;
    target.selectionStart = 0;
    setTimeout(()=>{
        target.remove();
        view.focus();
    }, 50);
}
function $e7161f778706e663$var$copiedRange(state) {
    let content = [], ranges = [], linewise = false;
    for (let range of state.selection.ranges)if (!range.empty) {
        content.push(state.sliceDoc(range.from, range.to));
        ranges.push(range);
    }
    if (!content.length) {
        // Nothing selected, do a line-wise copy
        let upto = -1;
        for (let { from: from } of state.selection.ranges){
            let line = state.doc.lineAt(from);
            if (line.number > upto) {
                content.push(line.text);
                ranges.push({
                    from: line.from,
                    to: Math.min(state.doc.length, line.to + 1)
                });
            }
            upto = line.number;
        }
        linewise = true;
    }
    return {
        text: content.join(state.lineBreak),
        ranges: ranges,
        linewise: linewise
    };
}
let $e7161f778706e663$var$lastLinewiseCopy = null;
$e7161f778706e663$var$handlers.copy = $e7161f778706e663$var$handlers.cut = (view, event)=>{
    let { text: text, ranges: ranges, linewise: linewise } = $e7161f778706e663$var$copiedRange(view.state);
    if (!text && !linewise) return;
    $e7161f778706e663$var$lastLinewiseCopy = linewise ? text : null;
    let data = $e7161f778706e663$var$brokenClipboardAPI ? null : event.clipboardData;
    if (data) {
        event.preventDefault();
        data.clearData();
        data.setData("text/plain", text);
    } else $e7161f778706e663$var$captureCopy(view, text);
    if (event.type == "cut" && !view.state.readOnly) view.dispatch({
        changes: ranges,
        scrollIntoView: true,
        userEvent: "delete.cut"
    });
};
const $e7161f778706e663$var$isFocusChange = /*@__PURE__*/ (0, $hB7kI.Annotation).define();
function $e7161f778706e663$var$focusChangeTransaction(state, focus) {
    let effects = [];
    for (let getEffect of state.facet($e7161f778706e663$var$focusChangeEffect)){
        let effect = getEffect(state, focus);
        if (effect) effects.push(effect);
    }
    return effects ? state.update({
        effects: effects,
        annotations: $e7161f778706e663$var$isFocusChange.of(true)
    }) : null;
}
function $e7161f778706e663$var$updateForFocusChange(view) {
    setTimeout(()=>{
        let focus = view.hasFocus;
        if (focus != view.inputState.notifiedFocused) {
            let tr = $e7161f778706e663$var$focusChangeTransaction(view.state, focus);
            if (tr) view.dispatch(tr);
            else view.update([]);
        }
    }, 10);
}
$e7161f778706e663$var$handlers.focus = (view)=>{
    view.inputState.lastFocusTime = Date.now();
    // When focusing reset the scroll position, move it back to where it was
    if (!view.scrollDOM.scrollTop && (view.inputState.lastScrollTop || view.inputState.lastScrollLeft)) {
        view.scrollDOM.scrollTop = view.inputState.lastScrollTop;
        view.scrollDOM.scrollLeft = view.inputState.lastScrollLeft;
    }
    $e7161f778706e663$var$updateForFocusChange(view);
};
$e7161f778706e663$var$handlers.blur = (view)=>{
    view.observer.clearSelectionRange();
    $e7161f778706e663$var$updateForFocusChange(view);
};
$e7161f778706e663$var$handlers.compositionstart = $e7161f778706e663$var$handlers.compositionupdate = (view)=>{
    if (view.inputState.compositionFirstChange == null) view.inputState.compositionFirstChange = true;
    if (view.inputState.composing < 0) // FIXME possibly set a timeout to clear it again on Android
    view.inputState.composing = 0;
};
$e7161f778706e663$var$handlers.compositionend = (view)=>{
    view.inputState.composing = -1;
    view.inputState.compositionEndedAt = Date.now();
    view.inputState.compositionPendingKey = true;
    view.inputState.compositionPendingChange = view.observer.pendingRecords().length > 0;
    view.inputState.compositionFirstChange = null;
    if ($e7161f778706e663$var$browser.chrome && $e7161f778706e663$var$browser.android) // Delay flushing for a bit on Android because it'll often fire a
    // bunch of contradictory changes in a row at end of compositon
    view.observer.flushSoon();
    else if (view.inputState.compositionPendingChange) // If we found pending records, schedule a flush.
    Promise.resolve().then(()=>view.observer.flush());
    else // Otherwise, make sure that, if no changes come in soon, the
    // composition view is cleared.
    setTimeout(()=>{
        if (view.inputState.composing < 0 && view.docView.compositionDeco.size) view.update([]);
    }, 50);
};
$e7161f778706e663$var$handlers.contextmenu = (view)=>{
    view.inputState.lastContextMenu = Date.now();
};
$e7161f778706e663$var$handlers.beforeinput = (view, event)=>{
    var _a;
    // Because Chrome Android doesn't fire useful key events, use
    // beforeinput to detect backspace (and possibly enter and delete,
    // but those usually don't even seem to fire beforeinput events at
    // the moment) and fake a key event for it.
    //
    // (preventDefault on beforeinput, though supported in the spec,
    // seems to do nothing at all on Chrome).
    let pending;
    if ($e7161f778706e663$var$browser.chrome && $e7161f778706e663$var$browser.android && (pending = $e7161f778706e663$var$PendingKeys.find((key)=>key.inputType == event.inputType))) {
        view.observer.delayAndroidKey(pending.key, pending.keyCode);
        if (pending.key == "Backspace" || pending.key == "Delete") {
            let startViewHeight = ((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.height) || 0;
            setTimeout(()=>{
                var _a;
                // Backspacing near uneditable nodes on Chrome Android sometimes
                // closes the virtual keyboard. This tries to crudely detect
                // that and refocus to get it back.
                if ((((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.height) || 0) > startViewHeight + 10 && view.hasFocus) {
                    view.contentDOM.blur();
                    view.focus();
                }
            }, 100);
        }
    }
};
const $e7161f778706e663$var$wrappingWhiteSpace = [
    "pre-wrap",
    "normal",
    "pre-line",
    "break-spaces"
];
class $e7161f778706e663$var$HeightOracle {
    constructor(lineWrapping){
        this.lineWrapping = lineWrapping;
        this.doc = (0, $hB7kI.Text).empty;
        this.heightSamples = {};
        this.lineHeight = 14; // The height of an entire line (line-height)
        this.charWidth = 7;
        this.textHeight = 14; // The height of the actual font (font-size)
        this.lineLength = 30;
        // Used to track, during updateHeight, if any actual heights changed
        this.heightChanged = false;
    }
    heightForGap(from, to) {
        let lines = this.doc.lineAt(to).number - this.doc.lineAt(from).number + 1;
        if (this.lineWrapping) lines += Math.max(0, Math.ceil((to - from - lines * this.lineLength * 0.5) / this.lineLength));
        return this.lineHeight * lines;
    }
    heightForLine(length) {
        if (!this.lineWrapping) return this.lineHeight;
        let lines = 1 + Math.max(0, Math.ceil((length - this.lineLength) / (this.lineLength - 5)));
        return lines * this.lineHeight;
    }
    setDoc(doc) {
        this.doc = doc;
        return this;
    }
    mustRefreshForWrapping(whiteSpace) {
        return $e7161f778706e663$var$wrappingWhiteSpace.indexOf(whiteSpace) > -1 != this.lineWrapping;
    }
    mustRefreshForHeights(lineHeights) {
        let newHeight = false;
        for(let i = 0; i < lineHeights.length; i++){
            let h = lineHeights[i];
            if (h < 0) i++;
            else if (!this.heightSamples[Math.floor(h * 10)]) {
                newHeight = true;
                this.heightSamples[Math.floor(h * 10)] = true;
            }
        }
        return newHeight;
    }
    refresh(whiteSpace, lineHeight, charWidth, textHeight, lineLength, knownHeights) {
        let lineWrapping = $e7161f778706e663$var$wrappingWhiteSpace.indexOf(whiteSpace) > -1;
        let changed = Math.round(lineHeight) != Math.round(this.lineHeight) || this.lineWrapping != lineWrapping;
        this.lineWrapping = lineWrapping;
        this.lineHeight = lineHeight;
        this.charWidth = charWidth;
        this.textHeight = textHeight;
        this.lineLength = lineLength;
        if (changed) {
            this.heightSamples = {};
            for(let i = 0; i < knownHeights.length; i++){
                let h = knownHeights[i];
                if (h < 0) i++;
                else this.heightSamples[Math.floor(h * 10)] = true;
            }
        }
        return changed;
    }
}
// This object is used by `updateHeight` to make DOM measurements
// arrive at the right nides. The `heights` array is a sequence of
// block heights, starting from position `from`.
class $e7161f778706e663$var$MeasuredHeights {
    constructor(from, heights){
        this.from = from;
        this.heights = heights;
        this.index = 0;
    }
    get more() {
        return this.index < this.heights.length;
    }
}
/**
Record used to represent information about a block-level element
in the editor view.
*/ class $e7161f778706e663$export$ddfdc4ccfe9512bd {
    /**
    @internal
    */ constructor(/**
    The start of the element in the document.
    */ from, /**
    The length of the element.
    */ length, /**
    The top position of the element (relative to the top of the
    document).
    */ top, /**
    Its height.
    */ height, /**
    @internal Weird packed field that holds an array of children
    for composite blocks, a decoration for block widgets, and a
    number indicating the amount of widget-create line breaks for
    text blocks.
    */ _content){
        this.from = from;
        this.length = length;
        this.top = top;
        this.height = height;
        this._content = _content;
    }
    /**
    The type of element this is. When querying lines, this may be
    an array of all the blocks that make up the line.
    */ get type() {
        return typeof this._content == "number" ? $e7161f778706e663$export$48808c686fe495c4.Text : Array.isArray(this._content) ? this._content : this._content.type;
    }
    /**
    The end of the element as a document position.
    */ get to() {
        return this.from + this.length;
    }
    /**
    The bottom position of the element.
    */ get bottom() {
        return this.top + this.height;
    }
    /**
    If this is a widget block, this will return the widget
    associated with it.
    */ get widget() {
        return this._content instanceof $e7161f778706e663$var$PointDecoration ? this._content.widget : null;
    }
    /**
    If this is a textblock, this holds the number of line breaks
    that appear in widgets inside the block.
    */ get widgetLineBreaks() {
        return typeof this._content == "number" ? this._content : 0;
    }
    /**
    @internal
    */ join(other) {
        let content = (Array.isArray(this._content) ? this._content : [
            this
        ]).concat(Array.isArray(other._content) ? other._content : [
            other
        ]);
        return new $e7161f778706e663$export$ddfdc4ccfe9512bd(this.from, this.length + other.length, this.top, this.height + other.height, content);
    }
}
var $e7161f778706e663$var$QueryType = /*@__PURE__*/ function(QueryType) {
    QueryType[QueryType["ByPos"] = 0] = "ByPos";
    QueryType[QueryType["ByHeight"] = 1] = "ByHeight";
    QueryType[QueryType["ByPosNoHeight"] = 2] = "ByPosNoHeight";
    return QueryType;
}($e7161f778706e663$var$QueryType || ($e7161f778706e663$var$QueryType = {}));
const $e7161f778706e663$var$Epsilon = 1e-3;
class $e7161f778706e663$var$HeightMap {
    constructor(length, height, flags = 2 /* Outdated */ ){
        this.length = length;
        this.height = height;
        this.flags = flags;
    }
    get outdated() {
        return (this.flags & 2 /* Outdated */ ) > 0;
    }
    set outdated(value) {
        this.flags = (value ? 2 /* Outdated */  : 0) | this.flags & -3 /* Outdated */ ;
    }
    setHeight(oracle, height) {
        if (this.height != height) {
            if (Math.abs(this.height - height) > $e7161f778706e663$var$Epsilon) oracle.heightChanged = true;
            this.height = height;
        }
    }
    // Base case is to replace a leaf node, which simply builds a tree
    // from the new nodes and returns that (HeightMapBranch and
    // HeightMapGap override this to actually use from/to)
    replace(_from, _to, nodes) {
        return $e7161f778706e663$var$HeightMap.of(nodes);
    }
    // Again, these are base cases, and are overridden for branch and gap nodes.
    decomposeLeft(_to, result) {
        result.push(this);
    }
    decomposeRight(_from, result) {
        result.push(this);
    }
    applyChanges(decorations, oldDoc, oracle, changes) {
        let me = this, doc = oracle.doc;
        for(let i = changes.length - 1; i >= 0; i--){
            let { fromA: fromA, toA: toA, fromB: fromB, toB: toB } = changes[i];
            let start = me.lineAt(fromA, $e7161f778706e663$var$QueryType.ByPosNoHeight, oracle.setDoc(oldDoc), 0, 0);
            let end = start.to >= toA ? start : me.lineAt(toA, $e7161f778706e663$var$QueryType.ByPosNoHeight, oracle, 0, 0);
            toB += end.to - toA;
            toA = end.to;
            while(i > 0 && start.from <= changes[i - 1].toA){
                fromA = changes[i - 1].fromA;
                fromB = changes[i - 1].fromB;
                i--;
                if (fromA < start.from) start = me.lineAt(fromA, $e7161f778706e663$var$QueryType.ByPosNoHeight, oracle, 0, 0);
            }
            fromB += start.from - fromA;
            fromA = start.from;
            let nodes = $e7161f778706e663$var$NodeBuilder.build(oracle.setDoc(doc), decorations, fromB, toB);
            me = me.replace(fromA, toA, nodes);
        }
        return me.updateHeight(oracle, 0);
    }
    static empty() {
        return new $e7161f778706e663$var$HeightMapText(0, 0);
    }
    // nodes uses null values to indicate the position of line breaks.
    // There are never line breaks at the start or end of the array, or
    // two line breaks next to each other, and the array isn't allowed
    // to be empty (same restrictions as return value from the builder).
    static of(nodes) {
        if (nodes.length == 1) return nodes[0];
        let i = 0, j = nodes.length, before = 0, after = 0;
        for(;;){
            if (i == j) {
                if (before > after * 2) {
                    let split = nodes[i - 1];
                    if (split.break) nodes.splice(--i, 1, split.left, null, split.right);
                    else nodes.splice(--i, 1, split.left, split.right);
                    j += 1 + split.break;
                    before -= split.size;
                } else if (after > before * 2) {
                    let split = nodes[j];
                    if (split.break) nodes.splice(j, 1, split.left, null, split.right);
                    else nodes.splice(j, 1, split.left, split.right);
                    j += 2 + split.break;
                    after -= split.size;
                } else break;
            } else if (before < after) {
                let next = nodes[i++];
                if (next) before += next.size;
            } else {
                let next = nodes[--j];
                if (next) after += next.size;
            }
        }
        let brk = 0;
        if (nodes[i - 1] == null) {
            brk = 1;
            i--;
        } else if (nodes[i] == null) {
            brk = 1;
            j++;
        }
        return new $e7161f778706e663$var$HeightMapBranch($e7161f778706e663$var$HeightMap.of(nodes.slice(0, i)), brk, $e7161f778706e663$var$HeightMap.of(nodes.slice(j)));
    }
}
$e7161f778706e663$var$HeightMap.prototype.size = 1;
class $e7161f778706e663$var$HeightMapBlock extends $e7161f778706e663$var$HeightMap {
    constructor(length, height, deco){
        super(length, height);
        this.deco = deco;
    }
    blockAt(_height, _oracle, top, offset) {
        return new $e7161f778706e663$export$ddfdc4ccfe9512bd(offset, this.length, top, this.height, this.deco || 0);
    }
    lineAt(_value, _type, oracle, top, offset) {
        return this.blockAt(0, oracle, top, offset);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        if (from <= offset + this.length && to >= offset) f(this.blockAt(0, oracle, top, offset));
    }
    updateHeight(oracle, offset = 0, _force = false, measured) {
        if (measured && measured.from <= offset && measured.more) this.setHeight(oracle, measured.heights[measured.index++]);
        this.outdated = false;
        return this;
    }
    toString() {
        return `block(${this.length})`;
    }
}
class $e7161f778706e663$var$HeightMapText extends $e7161f778706e663$var$HeightMapBlock {
    constructor(length, height){
        super(length, height, null);
        this.collapsed = 0; // Amount of collapsed content in the line
        this.widgetHeight = 0; // Maximum inline widget height
        this.breaks = 0; // Number of widget-introduced line breaks on the line
    }
    blockAt(_height, _oracle, top, offset) {
        return new $e7161f778706e663$export$ddfdc4ccfe9512bd(offset, this.length, top, this.height, this.breaks);
    }
    replace(_from, _to, nodes) {
        let node = nodes[0];
        if (nodes.length == 1 && (node instanceof $e7161f778706e663$var$HeightMapText || node instanceof $e7161f778706e663$var$HeightMapGap && node.flags & 4 /* SingleLine */ ) && Math.abs(this.length - node.length) < 10) {
            if (node instanceof $e7161f778706e663$var$HeightMapGap) node = new $e7161f778706e663$var$HeightMapText(node.length, this.height);
            else node.height = this.height;
            if (!this.outdated) node.outdated = false;
            return node;
        } else return $e7161f778706e663$var$HeightMap.of(nodes);
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        if (measured && measured.from <= offset && measured.more) this.setHeight(oracle, measured.heights[measured.index++]);
        else if (force || this.outdated) this.setHeight(oracle, Math.max(this.widgetHeight, oracle.heightForLine(this.length - this.collapsed)) + this.breaks * oracle.lineHeight);
        this.outdated = false;
        return this;
    }
    toString() {
        return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
    }
}
class $e7161f778706e663$var$HeightMapGap extends $e7161f778706e663$var$HeightMap {
    constructor(length){
        super(length, 0);
    }
    heightMetrics(oracle, offset) {
        let firstLine = oracle.doc.lineAt(offset).number, lastLine = oracle.doc.lineAt(offset + this.length).number;
        let lines = lastLine - firstLine + 1;
        let perLine, perChar = 0;
        if (oracle.lineWrapping) {
            let totalPerLine = Math.min(this.height, oracle.lineHeight * lines);
            perLine = totalPerLine / lines;
            if (this.length > lines + 1) perChar = (this.height - totalPerLine) / (this.length - lines - 1);
        } else perLine = this.height / lines;
        return {
            firstLine: firstLine,
            lastLine: lastLine,
            perLine: perLine,
            perChar: perChar
        };
    }
    blockAt(height, oracle, top, offset) {
        let { firstLine: firstLine, lastLine: lastLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        if (oracle.lineWrapping) {
            let guess = offset + Math.round(Math.max(0, Math.min(1, (height - top) / this.height)) * this.length);
            let line = oracle.doc.lineAt(guess), lineHeight = perLine + line.length * perChar;
            let lineTop = Math.max(top, height - lineHeight / 2);
            return new $e7161f778706e663$export$ddfdc4ccfe9512bd(line.from, line.length, lineTop, lineHeight, 0);
        } else {
            let line = Math.max(0, Math.min(lastLine - firstLine, Math.floor((height - top) / perLine)));
            let { from: from, length: length } = oracle.doc.line(firstLine + line);
            return new $e7161f778706e663$export$ddfdc4ccfe9512bd(from, length, top + perLine * line, perLine, 0);
        }
    }
    lineAt(value, type, oracle, top, offset) {
        if (type == $e7161f778706e663$var$QueryType.ByHeight) return this.blockAt(value, oracle, top, offset);
        if (type == $e7161f778706e663$var$QueryType.ByPosNoHeight) {
            let { from: from, to: to } = oracle.doc.lineAt(value);
            return new $e7161f778706e663$export$ddfdc4ccfe9512bd(from, to - from, 0, 0, 0);
        }
        let { firstLine: firstLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        let line = oracle.doc.lineAt(value), lineHeight = perLine + line.length * perChar;
        let linesAbove = line.number - firstLine;
        let lineTop = top + perLine * linesAbove + perChar * (line.from - offset - linesAbove);
        return new $e7161f778706e663$export$ddfdc4ccfe9512bd(line.from, line.length, Math.max(top, Math.min(lineTop, top + this.height - lineHeight)), lineHeight, 0);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        from = Math.max(from, offset);
        to = Math.min(to, offset + this.length);
        let { firstLine: firstLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        for(let pos = from, lineTop = top; pos <= to;){
            let line = oracle.doc.lineAt(pos);
            if (pos == from) {
                let linesAbove = line.number - firstLine;
                lineTop += perLine * linesAbove + perChar * (from - offset - linesAbove);
            }
            let lineHeight = perLine + perChar * line.length;
            f(new $e7161f778706e663$export$ddfdc4ccfe9512bd(line.from, line.length, lineTop, lineHeight, 0));
            lineTop += lineHeight;
            pos = line.to + 1;
        }
    }
    replace(from, to, nodes) {
        let after = this.length - to;
        if (after > 0) {
            let last = nodes[nodes.length - 1];
            if (last instanceof $e7161f778706e663$var$HeightMapGap) nodes[nodes.length - 1] = new $e7161f778706e663$var$HeightMapGap(last.length + after);
            else nodes.push(null, new $e7161f778706e663$var$HeightMapGap(after - 1));
        }
        if (from > 0) {
            let first = nodes[0];
            if (first instanceof $e7161f778706e663$var$HeightMapGap) nodes[0] = new $e7161f778706e663$var$HeightMapGap(from + first.length);
            else nodes.unshift(new $e7161f778706e663$var$HeightMapGap(from - 1), null);
        }
        return $e7161f778706e663$var$HeightMap.of(nodes);
    }
    decomposeLeft(to, result) {
        result.push(new $e7161f778706e663$var$HeightMapGap(to - 1), null);
    }
    decomposeRight(from, result) {
        result.push(null, new $e7161f778706e663$var$HeightMapGap(this.length - from - 1));
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        let end = offset + this.length;
        if (measured && measured.from <= offset + this.length && measured.more) {
            // Fill in part of this gap with measured lines. We know there
            // can't be widgets or collapsed ranges in those lines, because
            // they would already have been added to the heightmap (gaps
            // only contain plain text).
            let nodes = [], pos = Math.max(offset, measured.from), singleHeight = -1;
            if (measured.from > offset) nodes.push(new $e7161f778706e663$var$HeightMapGap(measured.from - offset - 1).updateHeight(oracle, offset));
            while(pos <= end && measured.more){
                let len = oracle.doc.lineAt(pos).length;
                if (nodes.length) nodes.push(null);
                let height = measured.heights[measured.index++];
                if (singleHeight == -1) singleHeight = height;
                else if (Math.abs(height - singleHeight) >= $e7161f778706e663$var$Epsilon) singleHeight = -2;
                let line = new $e7161f778706e663$var$HeightMapText(len, height);
                line.outdated = false;
                nodes.push(line);
                pos += len + 1;
            }
            if (pos <= end) nodes.push(null, new $e7161f778706e663$var$HeightMapGap(end - pos).updateHeight(oracle, pos));
            let result = $e7161f778706e663$var$HeightMap.of(nodes);
            if (singleHeight < 0 || Math.abs(result.height - this.height) >= $e7161f778706e663$var$Epsilon || Math.abs(singleHeight - this.heightMetrics(oracle, offset).perLine) >= $e7161f778706e663$var$Epsilon) oracle.heightChanged = true;
            return result;
        } else if (force || this.outdated) {
            this.setHeight(oracle, oracle.heightForGap(offset, offset + this.length));
            this.outdated = false;
        }
        return this;
    }
    toString() {
        return `gap(${this.length})`;
    }
}
class $e7161f778706e663$var$HeightMapBranch extends $e7161f778706e663$var$HeightMap {
    constructor(left, brk, right){
        super(left.length + brk + right.length, left.height + right.height, brk | (left.outdated || right.outdated ? 2 /* Outdated */  : 0));
        this.left = left;
        this.right = right;
        this.size = left.size + right.size;
    }
    get break() {
        return this.flags & 1 /* Break */ ;
    }
    blockAt(height, oracle, top, offset) {
        let mid = top + this.left.height;
        return height < mid ? this.left.blockAt(height, oracle, top, offset) : this.right.blockAt(height, oracle, mid, offset + this.left.length + this.break);
    }
    lineAt(value, type, oracle, top, offset) {
        let rightTop = top + this.left.height, rightOffset = offset + this.left.length + this.break;
        let left = type == $e7161f778706e663$var$QueryType.ByHeight ? value < rightTop : value < rightOffset;
        let base = left ? this.left.lineAt(value, type, oracle, top, offset) : this.right.lineAt(value, type, oracle, rightTop, rightOffset);
        if (this.break || (left ? base.to < rightOffset : base.from > rightOffset)) return base;
        let subQuery = type == $e7161f778706e663$var$QueryType.ByPosNoHeight ? $e7161f778706e663$var$QueryType.ByPosNoHeight : $e7161f778706e663$var$QueryType.ByPos;
        if (left) return base.join(this.right.lineAt(rightOffset, subQuery, oracle, rightTop, rightOffset));
        else return this.left.lineAt(rightOffset, subQuery, oracle, top, offset).join(base);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        let rightTop = top + this.left.height, rightOffset = offset + this.left.length + this.break;
        if (this.break) {
            if (from < rightOffset) this.left.forEachLine(from, to, oracle, top, offset, f);
            if (to >= rightOffset) this.right.forEachLine(from, to, oracle, rightTop, rightOffset, f);
        } else {
            let mid = this.lineAt(rightOffset, $e7161f778706e663$var$QueryType.ByPos, oracle, top, offset);
            if (from < mid.from) this.left.forEachLine(from, mid.from - 1, oracle, top, offset, f);
            if (mid.to >= from && mid.from <= to) f(mid);
            if (to > mid.to) this.right.forEachLine(mid.to + 1, to, oracle, rightTop, rightOffset, f);
        }
    }
    replace(from, to, nodes) {
        let rightStart = this.left.length + this.break;
        if (to < rightStart) return this.balanced(this.left.replace(from, to, nodes), this.right);
        if (from > this.left.length) return this.balanced(this.left, this.right.replace(from - rightStart, to - rightStart, nodes));
        let result = [];
        if (from > 0) this.decomposeLeft(from, result);
        let left = result.length;
        for (let node of nodes)result.push(node);
        if (from > 0) $e7161f778706e663$var$mergeGaps(result, left - 1);
        if (to < this.length) {
            let right = result.length;
            this.decomposeRight(to, result);
            $e7161f778706e663$var$mergeGaps(result, right);
        }
        return $e7161f778706e663$var$HeightMap.of(result);
    }
    decomposeLeft(to, result) {
        let left = this.left.length;
        if (to <= left) return this.left.decomposeLeft(to, result);
        result.push(this.left);
        if (this.break) {
            left++;
            if (to >= left) result.push(null);
        }
        if (to > left) this.right.decomposeLeft(to - left, result);
    }
    decomposeRight(from, result) {
        let left = this.left.length, right = left + this.break;
        if (from >= right) return this.right.decomposeRight(from - right, result);
        if (from < left) this.left.decomposeRight(from, result);
        if (this.break && from < right) result.push(null);
        result.push(this.right);
    }
    balanced(left, right) {
        if (left.size > 2 * right.size || right.size > 2 * left.size) return $e7161f778706e663$var$HeightMap.of(this.break ? [
            left,
            null,
            right
        ] : [
            left,
            right
        ]);
        this.left = left;
        this.right = right;
        this.height = left.height + right.height;
        this.outdated = left.outdated || right.outdated;
        this.size = left.size + right.size;
        this.length = left.length + this.break + right.length;
        return this;
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        let { left: left, right: right } = this, rightStart = offset + left.length + this.break, rebalance = null;
        if (measured && measured.from <= offset + left.length && measured.more) rebalance = left = left.updateHeight(oracle, offset, force, measured);
        else left.updateHeight(oracle, offset, force);
        if (measured && measured.from <= rightStart + right.length && measured.more) rebalance = right = right.updateHeight(oracle, rightStart, force, measured);
        else right.updateHeight(oracle, rightStart, force);
        if (rebalance) return this.balanced(left, right);
        this.height = this.left.height + this.right.height;
        this.outdated = false;
        return this;
    }
    toString() {
        return this.left + (this.break ? " " : "-") + this.right;
    }
}
function $e7161f778706e663$var$mergeGaps(nodes, around) {
    let before, after;
    if (nodes[around] == null && (before = nodes[around - 1]) instanceof $e7161f778706e663$var$HeightMapGap && (after = nodes[around + 1]) instanceof $e7161f778706e663$var$HeightMapGap) nodes.splice(around - 1, 3, new $e7161f778706e663$var$HeightMapGap(before.length + 1 + after.length));
}
const $e7161f778706e663$var$relevantWidgetHeight = 5;
class $e7161f778706e663$var$NodeBuilder {
    constructor(pos, oracle){
        this.pos = pos;
        this.oracle = oracle;
        this.nodes = [];
        this.lineStart = -1;
        this.lineEnd = -1;
        this.covering = null;
        this.writtenTo = pos;
    }
    get isCovered() {
        return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
    }
    span(_from, to) {
        if (this.lineStart > -1) {
            let end = Math.min(to, this.lineEnd), last = this.nodes[this.nodes.length - 1];
            if (last instanceof $e7161f778706e663$var$HeightMapText) last.length += end - this.pos;
            else if (end > this.pos || !this.isCovered) this.nodes.push(new $e7161f778706e663$var$HeightMapText(end - this.pos, -1));
            this.writtenTo = end;
            if (to > end) {
                this.nodes.push(null);
                this.writtenTo++;
                this.lineStart = -1;
            }
        }
        this.pos = to;
    }
    point(from, to, deco) {
        if (from < to || deco.heightRelevant) {
            let height = deco.widget ? deco.widget.estimatedHeight : 0;
            let breaks = deco.widget ? deco.widget.lineBreaks : 0;
            if (height < 0) height = this.oracle.lineHeight;
            let len = to - from;
            if (deco.block) this.addBlock(new $e7161f778706e663$var$HeightMapBlock(len, height, deco));
            else if (len || breaks || height >= $e7161f778706e663$var$relevantWidgetHeight) this.addLineDeco(height, breaks, len);
        } else if (to > from) this.span(from, to);
        if (this.lineEnd > -1 && this.lineEnd < this.pos) this.lineEnd = this.oracle.doc.lineAt(this.pos).to;
    }
    enterLine() {
        if (this.lineStart > -1) return;
        let { from: from, to: to } = this.oracle.doc.lineAt(this.pos);
        this.lineStart = from;
        this.lineEnd = to;
        if (this.writtenTo < from) {
            if (this.writtenTo < from - 1 || this.nodes[this.nodes.length - 1] == null) this.nodes.push(this.blankContent(this.writtenTo, from - 1));
            this.nodes.push(null);
        }
        if (this.pos > from) this.nodes.push(new $e7161f778706e663$var$HeightMapText(this.pos - from, -1));
        this.writtenTo = this.pos;
    }
    blankContent(from, to) {
        let gap = new $e7161f778706e663$var$HeightMapGap(to - from);
        if (this.oracle.doc.lineAt(from).to == to) gap.flags |= 4 /* SingleLine */ ;
        return gap;
    }
    ensureLine() {
        this.enterLine();
        let last = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
        if (last instanceof $e7161f778706e663$var$HeightMapText) return last;
        let line = new $e7161f778706e663$var$HeightMapText(0, -1);
        this.nodes.push(line);
        return line;
    }
    addBlock(block) {
        var _a;
        this.enterLine();
        let type = (_a = block.deco) === null || _a === void 0 ? void 0 : _a.type;
        if (type == $e7161f778706e663$export$48808c686fe495c4.WidgetAfter && !this.isCovered) this.ensureLine();
        this.nodes.push(block);
        this.writtenTo = this.pos = this.pos + block.length;
        if (type != $e7161f778706e663$export$48808c686fe495c4.WidgetBefore) this.covering = block;
    }
    addLineDeco(height, breaks, length) {
        let line = this.ensureLine();
        line.length += length;
        line.collapsed += length;
        line.widgetHeight = Math.max(line.widgetHeight, height);
        line.breaks += breaks;
        this.writtenTo = this.pos = this.pos + length;
    }
    finish(from) {
        let last = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
        if (this.lineStart > -1 && !(last instanceof $e7161f778706e663$var$HeightMapText) && !this.isCovered) this.nodes.push(new $e7161f778706e663$var$HeightMapText(0, -1));
        else if (this.writtenTo < this.pos || last == null) this.nodes.push(this.blankContent(this.writtenTo, this.pos));
        let pos = from;
        for (let node of this.nodes){
            if (node instanceof $e7161f778706e663$var$HeightMapText) node.updateHeight(this.oracle, pos);
            pos += node ? node.length : 1;
        }
        return this.nodes;
    }
    // Always called with a region that on both sides either stretches
    // to a line break or the end of the document.
    // The returned array uses null to indicate line breaks, but never
    // starts or ends in a line break, or has multiple line breaks next
    // to each other.
    static build(oracle, decorations, from, to) {
        let builder = new $e7161f778706e663$var$NodeBuilder(from, oracle);
        (0, $hB7kI.RangeSet).spans(decorations, from, to, builder, 0);
        return builder.finish(from);
    }
}
function $e7161f778706e663$var$heightRelevantDecoChanges(a, b, diff) {
    let comp = new $e7161f778706e663$var$DecorationComparator;
    (0, $hB7kI.RangeSet).compare(a, b, diff, comp, 0);
    return comp.changes;
}
class $e7161f778706e663$var$DecorationComparator {
    constructor(){
        this.changes = [];
    }
    compareRange() {}
    comparePoint(from, to, a, b) {
        if (from < to || a && a.heightRelevant || b && b.heightRelevant) $e7161f778706e663$var$addRange(from, to, this.changes, 5);
    }
}
function $e7161f778706e663$var$visiblePixelRange(dom, paddingTop) {
    let rect = dom.getBoundingClientRect();
    let doc = dom.ownerDocument, win = doc.defaultView || window;
    let left = Math.max(0, rect.left), right = Math.min(win.innerWidth, rect.right);
    let top = Math.max(0, rect.top), bottom = Math.min(win.innerHeight, rect.bottom);
    for(let parent = dom.parentNode; parent && parent != doc.body;){
        if (parent.nodeType == 1) {
            let elt = parent;
            let style = window.getComputedStyle(elt);
            if ((elt.scrollHeight > elt.clientHeight || elt.scrollWidth > elt.clientWidth) && style.overflow != "visible") {
                let parentRect = elt.getBoundingClientRect();
                left = Math.max(left, parentRect.left);
                right = Math.min(right, parentRect.right);
                top = Math.max(top, parentRect.top);
                bottom = parent == dom.parentNode ? parentRect.bottom : Math.min(bottom, parentRect.bottom);
            }
            parent = style.position == "absolute" || style.position == "fixed" ? elt.offsetParent : elt.parentNode;
        } else if (parent.nodeType == 11) parent = parent.host;
        else break;
    }
    return {
        left: left - rect.left,
        right: Math.max(left, right) - rect.left,
        top: top - (rect.top + paddingTop),
        bottom: Math.max(top, bottom) - (rect.top + paddingTop)
    };
}
function $e7161f778706e663$var$fullPixelRange(dom, paddingTop) {
    let rect = dom.getBoundingClientRect();
    return {
        left: 0,
        right: rect.right - rect.left,
        top: paddingTop,
        bottom: rect.bottom - (rect.top + paddingTop)
    };
}
// Line gaps are placeholder widgets used to hide pieces of overlong
// lines within the viewport, as a kludge to keep the editor
// responsive when a ridiculously long line is loaded into it.
class $e7161f778706e663$var$LineGap {
    constructor(from, to, size){
        this.from = from;
        this.to = to;
        this.size = size;
    }
    static same(a, b) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++){
            let gA = a[i], gB = b[i];
            if (gA.from != gB.from || gA.to != gB.to || gA.size != gB.size) return false;
        }
        return true;
    }
    draw(wrapping) {
        return $e7161f778706e663$export$10e30b733df217ea.replace({
            widget: new $e7161f778706e663$var$LineGapWidget(this.size, wrapping)
        }).range(this.from, this.to);
    }
}
class $e7161f778706e663$var$LineGapWidget extends $e7161f778706e663$export$95cdd842edb044c5 {
    constructor(size, vertical){
        super();
        this.size = size;
        this.vertical = vertical;
    }
    eq(other) {
        return other.size == this.size && other.vertical == this.vertical;
    }
    toDOM() {
        let elt = document.createElement("div");
        if (this.vertical) elt.style.height = this.size + "px";
        else {
            elt.style.width = this.size + "px";
            elt.style.height = "2px";
            elt.style.display = "inline-block";
        }
        return elt;
    }
    get estimatedHeight() {
        return this.vertical ? this.size : -1;
    }
}
class $e7161f778706e663$var$ViewState {
    constructor(state){
        this.state = state;
        // These are contentDOM-local coordinates
        this.pixelViewport = {
            left: 0,
            right: window.innerWidth,
            top: 0,
            bottom: 0
        };
        this.inView = true;
        this.paddingTop = 0;
        this.paddingBottom = 0;
        this.contentDOMWidth = 0;
        this.contentDOMHeight = 0;
        this.editorHeight = 0;
        this.editorWidth = 0;
        this.scrollTop = 0;
        this.scrolledToBottom = true;
        // The vertical position (document-relative) to which to anchor the
        // scroll position. -1 means anchor to the end of the document.
        this.scrollAnchorPos = 0;
        // The height at the anchor position. Set by the DOM update phase.
        // -1 means no height available.
        this.scrollAnchorHeight = -1;
        // See VP.MaxDOMHeight
        this.scaler = $e7161f778706e663$var$IdScaler;
        this.scrollTarget = null;
        // Briefly set to true when printing, to disable viewport limiting
        this.printing = false;
        // Flag set when editor content was redrawn, so that the next
        // measure stage knows it must read DOM layout
        this.mustMeasureContent = true;
        this.defaultTextDirection = $e7161f778706e663$export$cacd6541cfeeb6c1.LTR;
        this.visibleRanges = [];
        // Cursor 'assoc' is only significant when the cursor is on a line
        // wrap point, where it must stick to the character that it is
        // associated with. Since browsers don't provide a reasonable
        // interface to set or query this, when a selection is set that
        // might cause this to be significant, this flag is set. The next
        // measure phase will check whether the cursor is on a line-wrapping
        // boundary and, if so, reset it to make sure it is positioned in
        // the right place.
        this.mustEnforceCursorAssoc = false;
        let guessWrapping = state.facet($e7161f778706e663$var$contentAttributes).some((v)=>typeof v != "function" && v.class == "cm-lineWrapping");
        this.heightOracle = new $e7161f778706e663$var$HeightOracle(guessWrapping);
        this.stateDeco = state.facet($e7161f778706e663$var$decorations).filter((d)=>typeof d != "function");
        this.heightMap = $e7161f778706e663$var$HeightMap.empty().applyChanges(this.stateDeco, (0, $hB7kI.Text).empty, this.heightOracle.setDoc(state.doc), [
            new $e7161f778706e663$var$ChangedRange(0, 0, 0, state.doc.length)
        ]);
        this.viewport = this.getViewport(0, null);
        this.updateViewportLines();
        this.updateForViewport();
        this.lineGaps = this.ensureLineGaps([]);
        this.lineGapDeco = $e7161f778706e663$export$10e30b733df217ea.set(this.lineGaps.map((gap)=>gap.draw(false)));
        this.computeVisibleRanges();
    }
    updateForViewport() {
        let viewports = [
            this.viewport
        ], { main: main } = this.state.selection;
        for(let i = 0; i <= 1; i++){
            let pos = i ? main.head : main.anchor;
            if (!viewports.some(({ from: from, to: to })=>pos >= from && pos <= to)) {
                let { from: from, to: to } = this.lineBlockAt(pos);
                viewports.push(new $e7161f778706e663$var$Viewport(from, to));
            }
        }
        this.viewports = viewports.sort((a, b)=>a.from - b.from);
        this.scaler = this.heightMap.height <= 7000000 /* MaxDOMHeight */  ? $e7161f778706e663$var$IdScaler : new $e7161f778706e663$var$BigScaler(this.heightOracle, this.heightMap, this.viewports);
    }
    updateViewportLines() {
        this.viewportLines = [];
        this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (block)=>{
            this.viewportLines.push(this.scaler.scale == 1 ? block : $e7161f778706e663$var$scaleBlock(block, this.scaler));
        });
    }
    update(update, scrollTarget = null) {
        this.state = update.state;
        let prevDeco = this.stateDeco;
        this.stateDeco = this.state.facet($e7161f778706e663$var$decorations).filter((d)=>typeof d != "function");
        let contentChanges = update.changedRanges;
        let heightChanges = $e7161f778706e663$var$ChangedRange.extendWithRanges(contentChanges, $e7161f778706e663$var$heightRelevantDecoChanges(prevDeco, this.stateDeco, update ? update.changes : (0, $hB7kI.ChangeSet).empty(this.state.doc.length)));
        let prevHeight = this.heightMap.height;
        let scrollAnchor = this.scrolledToBottom ? null : this.lineBlockAtHeight(this.scrollTop);
        this.heightMap = this.heightMap.applyChanges(this.stateDeco, update.startState.doc, this.heightOracle.setDoc(this.state.doc), heightChanges);
        if (this.heightMap.height != prevHeight) update.flags |= 2 /* Height */ ;
        if (scrollAnchor) {
            this.scrollAnchorPos = update.changes.mapPos(scrollAnchor.from, -1);
            this.scrollAnchorHeight = scrollAnchor.top;
        } else {
            this.scrollAnchorPos = -1;
            this.scrollAnchorHeight = this.heightMap.height;
        }
        let viewport = heightChanges.length ? this.mapViewport(this.viewport, update.changes) : this.viewport;
        if (scrollTarget && (scrollTarget.range.head < viewport.from || scrollTarget.range.head > viewport.to) || !this.viewportIsAppropriate(viewport)) viewport = this.getViewport(0, scrollTarget);
        let updateLines = !update.changes.empty || update.flags & 2 /* Height */  || viewport.from != this.viewport.from || viewport.to != this.viewport.to;
        this.viewport = viewport;
        this.updateForViewport();
        if (updateLines) this.updateViewportLines();
        if (this.lineGaps.length || this.viewport.to - this.viewport.from > 4000) this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, update.changes)));
        update.flags |= this.computeVisibleRanges();
        if (scrollTarget) this.scrollTarget = scrollTarget;
        if (!this.mustEnforceCursorAssoc && update.selectionSet && update.view.lineWrapping && update.state.selection.main.empty && update.state.selection.main.assoc && !update.state.facet($e7161f778706e663$var$nativeSelectionHidden)) this.mustEnforceCursorAssoc = true;
    }
    measure(view) {
        let dom = view.contentDOM, style = window.getComputedStyle(dom);
        let oracle = this.heightOracle;
        let whiteSpace = style.whiteSpace;
        this.defaultTextDirection = style.direction == "rtl" ? $e7161f778706e663$export$cacd6541cfeeb6c1.RTL : $e7161f778706e663$export$cacd6541cfeeb6c1.LTR;
        let refresh = this.heightOracle.mustRefreshForWrapping(whiteSpace);
        let domRect = dom.getBoundingClientRect();
        let measureContent = refresh || this.mustMeasureContent || this.contentDOMHeight != domRect.height;
        this.contentDOMHeight = domRect.height;
        this.mustMeasureContent = false;
        let result = 0, bias = 0;
        // Vertical padding
        let paddingTop = parseInt(style.paddingTop) || 0, paddingBottom = parseInt(style.paddingBottom) || 0;
        if (this.paddingTop != paddingTop || this.paddingBottom != paddingBottom) {
            this.paddingTop = paddingTop;
            this.paddingBottom = paddingBottom;
            result |= 10 /* Height */ ;
        }
        if (this.editorWidth != view.scrollDOM.clientWidth) {
            if (oracle.lineWrapping) measureContent = true;
            this.editorWidth = view.scrollDOM.clientWidth;
            result |= 8 /* Geometry */ ;
        }
        if (this.scrollTop != view.scrollDOM.scrollTop) {
            this.scrollAnchorHeight = -1;
            this.scrollTop = view.scrollDOM.scrollTop;
        }
        this.scrolledToBottom = this.scrollTop > view.scrollDOM.scrollHeight - view.scrollDOM.clientHeight - 4;
        // Pixel viewport
        let pixelViewport = (this.printing ? $e7161f778706e663$var$fullPixelRange : $e7161f778706e663$var$visiblePixelRange)(dom, this.paddingTop);
        let dTop = pixelViewport.top - this.pixelViewport.top, dBottom = pixelViewport.bottom - this.pixelViewport.bottom;
        this.pixelViewport = pixelViewport;
        let inView = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
        if (inView != this.inView) {
            this.inView = inView;
            if (inView) measureContent = true;
        }
        if (!this.inView && !this.scrollTarget) return 0;
        let contentWidth = domRect.width;
        if (this.contentDOMWidth != contentWidth || this.editorHeight != view.scrollDOM.clientHeight) {
            this.contentDOMWidth = domRect.width;
            this.editorHeight = view.scrollDOM.clientHeight;
            result |= 8 /* Geometry */ ;
        }
        if (measureContent) {
            let lineHeights = view.docView.measureVisibleLineHeights(this.viewport);
            if (oracle.mustRefreshForHeights(lineHeights)) refresh = true;
            if (refresh || oracle.lineWrapping && Math.abs(contentWidth - this.contentDOMWidth) > oracle.charWidth) {
                let { lineHeight: lineHeight, charWidth: charWidth, textHeight: textHeight } = view.docView.measureTextSize();
                refresh = lineHeight > 0 && oracle.refresh(whiteSpace, lineHeight, charWidth, textHeight, contentWidth / charWidth, lineHeights);
                if (refresh) {
                    view.docView.minWidth = 0;
                    result |= 8 /* Geometry */ ;
                }
            }
            if (dTop > 0 && dBottom > 0) bias = Math.max(dTop, dBottom);
            else if (dTop < 0 && dBottom < 0) bias = Math.min(dTop, dBottom);
            oracle.heightChanged = false;
            for (let vp of this.viewports){
                let heights = vp.from == this.viewport.from ? lineHeights : view.docView.measureVisibleLineHeights(vp);
                this.heightMap = (refresh ? $e7161f778706e663$var$HeightMap.empty().applyChanges(this.stateDeco, (0, $hB7kI.Text).empty, this.heightOracle, [
                    new $e7161f778706e663$var$ChangedRange(0, 0, 0, view.state.doc.length)
                ]) : this.heightMap).updateHeight(oracle, 0, refresh, new $e7161f778706e663$var$MeasuredHeights(vp.from, heights));
            }
            if (oracle.heightChanged) result |= 2 /* Height */ ;
        }
        let viewportChange = !this.viewportIsAppropriate(this.viewport, bias) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
        if (viewportChange) this.viewport = this.getViewport(bias, this.scrollTarget);
        this.updateForViewport();
        if (result & 2 /* Height */  || viewportChange) this.updateViewportLines();
        if (this.lineGaps.length || this.viewport.to - this.viewport.from > 4000) this.updateLineGaps(this.ensureLineGaps(refresh ? [] : this.lineGaps, view));
        result |= this.computeVisibleRanges();
        if (this.mustEnforceCursorAssoc) {
            this.mustEnforceCursorAssoc = false;
            // This is done in the read stage, because moving the selection
            // to a line end is going to trigger a layout anyway, so it
            // can't be a pure write. It should be rare that it does any
            // writing.
            view.docView.enforceCursorAssoc();
        }
        return result;
    }
    get visibleTop() {
        return this.scaler.fromDOM(this.pixelViewport.top);
    }
    get visibleBottom() {
        return this.scaler.fromDOM(this.pixelViewport.bottom);
    }
    getViewport(bias, scrollTarget) {
        // This will divide VP.Margin between the top and the
        // bottom, depending on the bias (the change in viewport position
        // since the last update). It'll hold a number between 0 and 1
        let marginTop = 0.5 - Math.max(-0.5, Math.min(0.5, bias / 1000 /* Margin */  / 2));
        let map = this.heightMap, oracle = this.heightOracle;
        let { visibleTop: visibleTop, visibleBottom: visibleBottom } = this;
        let viewport = new $e7161f778706e663$var$Viewport(map.lineAt(visibleTop - marginTop * 1000 /* Margin */ , $e7161f778706e663$var$QueryType.ByHeight, oracle, 0, 0).from, map.lineAt(visibleBottom + (1 - marginTop) * 1000 /* Margin */ , $e7161f778706e663$var$QueryType.ByHeight, oracle, 0, 0).to);
        // If scrollTarget is given, make sure the viewport includes that position
        if (scrollTarget) {
            let { head: head } = scrollTarget.range;
            if (head < viewport.from || head > viewport.to) {
                let viewHeight = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top);
                let block = map.lineAt(head, $e7161f778706e663$var$QueryType.ByPos, oracle, 0, 0), topPos;
                if (scrollTarget.y == "center") topPos = (block.top + block.bottom) / 2 - viewHeight / 2;
                else if (scrollTarget.y == "start" || scrollTarget.y == "nearest" && head < viewport.from) topPos = block.top;
                else topPos = block.bottom - viewHeight;
                viewport = new $e7161f778706e663$var$Viewport(map.lineAt(topPos - 500, $e7161f778706e663$var$QueryType.ByHeight, oracle, 0, 0).from, map.lineAt(topPos + viewHeight + 500, $e7161f778706e663$var$QueryType.ByHeight, oracle, 0, 0).to);
            }
        }
        return viewport;
    }
    mapViewport(viewport, changes) {
        let from = changes.mapPos(viewport.from, -1), to = changes.mapPos(viewport.to, 1);
        return new $e7161f778706e663$var$Viewport(this.heightMap.lineAt(from, $e7161f778706e663$var$QueryType.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(to, $e7161f778706e663$var$QueryType.ByPos, this.heightOracle, 0, 0).to);
    }
    // Checks if a given viewport covers the visible part of the
    // document and not too much beyond that.
    viewportIsAppropriate({ from: from, to: to }, bias = 0) {
        if (!this.inView) return true;
        let { top: top } = this.heightMap.lineAt(from, $e7161f778706e663$var$QueryType.ByPos, this.heightOracle, 0, 0);
        let { bottom: bottom } = this.heightMap.lineAt(to, $e7161f778706e663$var$QueryType.ByPos, this.heightOracle, 0, 0);
        let { visibleTop: visibleTop, visibleBottom: visibleBottom } = this;
        return (from == 0 || top <= visibleTop - Math.max(10 /* MinCoverMargin */ , Math.min(-bias, 250 /* MaxCoverMargin */ ))) && (to == this.state.doc.length || bottom >= visibleBottom + Math.max(10 /* MinCoverMargin */ , Math.min(bias, 250 /* MaxCoverMargin */ ))) && top > visibleTop - 2000 /* Margin */  && bottom < visibleBottom + 2000 /* Margin */ ;
    }
    mapLineGaps(gaps, changes) {
        if (!gaps.length || changes.empty) return gaps;
        let mapped = [];
        for (let gap of gaps)if (!changes.touchesRange(gap.from, gap.to)) mapped.push(new $e7161f778706e663$var$LineGap(changes.mapPos(gap.from), changes.mapPos(gap.to), gap.size));
        return mapped;
    }
    // Computes positions in the viewport where the start or end of a
    // line should be hidden, trying to reuse existing line gaps when
    // appropriate to avoid unneccesary redraws.
    // Uses crude character-counting for the positioning and sizing,
    // since actual DOM coordinates aren't always available and
    // predictable. Relies on generous margins (see LG.Margin) to hide
    // the artifacts this might produce from the user.
    ensureLineGaps(current, mayMeasure) {
        let wrapping = this.heightOracle.lineWrapping;
        let margin = wrapping ? 10000 /* MarginWrap */  : 2000 /* Margin */ , halfMargin = margin >> 1, doubleMargin = margin << 1;
        // The non-wrapping logic won't work at all in predominantly right-to-left text.
        if (this.defaultTextDirection != $e7161f778706e663$export$cacd6541cfeeb6c1.LTR && !wrapping) return [];
        let gaps = [];
        let addGap = (from, to, line, structure)=>{
            if (to - from < halfMargin) return;
            let sel = this.state.selection.main, avoid = [
                sel.from
            ];
            if (!sel.empty) avoid.push(sel.to);
            for (let pos of avoid)if (pos > from && pos < to) {
                addGap(from, pos - 10 /* SelectionMargin */ , line, structure);
                addGap(pos + 10 /* SelectionMargin */ , to, line, structure);
                return;
            }
            let gap = $e7161f778706e663$var$find(current, (gap)=>gap.from >= line.from && gap.to <= line.to && Math.abs(gap.from - from) < halfMargin && Math.abs(gap.to - to) < halfMargin && !avoid.some((pos)=>gap.from < pos && gap.to > pos));
            if (!gap) {
                // When scrolling down, snap gap ends to line starts to avoid shifts in wrapping
                if (to < line.to && mayMeasure && wrapping && mayMeasure.visibleRanges.some((r)=>r.from <= to && r.to >= to)) {
                    let lineStart = mayMeasure.moveToLineBoundary((0, $hB7kI.EditorSelection).cursor(to), false, true).head;
                    if (lineStart > from) to = lineStart;
                }
                gap = new $e7161f778706e663$var$LineGap(from, to, this.gapSize(line, from, to, structure));
            }
            gaps.push(gap);
        };
        for (let line of this.viewportLines){
            if (line.length < doubleMargin) continue;
            let structure = $e7161f778706e663$var$lineStructure(line.from, line.to, this.stateDeco);
            if (structure.total < doubleMargin) continue;
            let target = this.scrollTarget ? this.scrollTarget.range.head : null;
            let viewFrom, viewTo;
            if (wrapping) {
                let marginHeight = margin / this.heightOracle.lineLength * this.heightOracle.lineHeight;
                let top, bot;
                if (target != null) {
                    let targetFrac = $e7161f778706e663$var$findFraction(structure, target);
                    let spaceFrac = ((this.visibleBottom - this.visibleTop) / 2 + marginHeight) / line.height;
                    top = targetFrac - spaceFrac;
                    bot = targetFrac + spaceFrac;
                } else {
                    top = (this.visibleTop - line.top - marginHeight) / line.height;
                    bot = (this.visibleBottom - line.top + marginHeight) / line.height;
                }
                viewFrom = $e7161f778706e663$var$findPosition(structure, top);
                viewTo = $e7161f778706e663$var$findPosition(structure, bot);
            } else {
                let totalWidth = structure.total * this.heightOracle.charWidth;
                let marginWidth = margin * this.heightOracle.charWidth;
                let left, right;
                if (target != null) {
                    let targetFrac = $e7161f778706e663$var$findFraction(structure, target);
                    let spaceFrac = ((this.pixelViewport.right - this.pixelViewport.left) / 2 + marginWidth) / totalWidth;
                    left = targetFrac - spaceFrac;
                    right = targetFrac + spaceFrac;
                } else {
                    left = (this.pixelViewport.left - marginWidth) / totalWidth;
                    right = (this.pixelViewport.right + marginWidth) / totalWidth;
                }
                viewFrom = $e7161f778706e663$var$findPosition(structure, left);
                viewTo = $e7161f778706e663$var$findPosition(structure, right);
            }
            if (viewFrom > line.from) addGap(line.from, viewFrom, line, structure);
            if (viewTo < line.to) addGap(viewTo, line.to, line, structure);
        }
        return gaps;
    }
    gapSize(line, from, to, structure) {
        let fraction = $e7161f778706e663$var$findFraction(structure, to) - $e7161f778706e663$var$findFraction(structure, from);
        if (this.heightOracle.lineWrapping) return line.height * fraction;
        else return structure.total * this.heightOracle.charWidth * fraction;
    }
    updateLineGaps(gaps) {
        if (!$e7161f778706e663$var$LineGap.same(gaps, this.lineGaps)) {
            this.lineGaps = gaps;
            this.lineGapDeco = $e7161f778706e663$export$10e30b733df217ea.set(gaps.map((gap)=>gap.draw(this.heightOracle.lineWrapping)));
        }
    }
    computeVisibleRanges() {
        let deco = this.stateDeco;
        if (this.lineGaps.length) deco = deco.concat(this.lineGapDeco);
        let ranges = [];
        (0, $hB7kI.RangeSet).spans(deco, this.viewport.from, this.viewport.to, {
            span (from, to) {
                ranges.push({
                    from: from,
                    to: to
                });
            },
            point () {}
        }, 20);
        let changed = ranges.length != this.visibleRanges.length || this.visibleRanges.some((r, i)=>r.from != ranges[i].from || r.to != ranges[i].to);
        this.visibleRanges = ranges;
        return changed ? 4 /* Viewport */  : 0;
    }
    lineBlockAt(pos) {
        return pos >= this.viewport.from && pos <= this.viewport.to && this.viewportLines.find((b)=>b.from <= pos && b.to >= pos) || $e7161f778706e663$var$scaleBlock(this.heightMap.lineAt(pos, $e7161f778706e663$var$QueryType.ByPos, this.heightOracle, 0, 0), this.scaler);
    }
    lineBlockAtHeight(height) {
        return $e7161f778706e663$var$scaleBlock(this.heightMap.lineAt(this.scaler.fromDOM(height), $e7161f778706e663$var$QueryType.ByHeight, this.heightOracle, 0, 0), this.scaler);
    }
    elementAtHeight(height) {
        return $e7161f778706e663$var$scaleBlock(this.heightMap.blockAt(this.scaler.fromDOM(height), this.heightOracle, 0, 0), this.scaler);
    }
    get docHeight() {
        return this.scaler.toDOM(this.heightMap.height);
    }
    get contentHeight() {
        return this.docHeight + this.paddingTop + this.paddingBottom;
    }
}
class $e7161f778706e663$var$Viewport {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
}
function $e7161f778706e663$var$lineStructure(from, to, stateDeco) {
    let ranges = [], pos = from, total = 0;
    (0, $hB7kI.RangeSet).spans(stateDeco, from, to, {
        span () {},
        point (from, to) {
            if (from > pos) {
                ranges.push({
                    from: pos,
                    to: from
                });
                total += from - pos;
            }
            pos = to;
        }
    }, 20); // We're only interested in collapsed ranges of a significant size
    if (pos < to) {
        ranges.push({
            from: pos,
            to: to
        });
        total += to - pos;
    }
    return {
        total: total,
        ranges: ranges
    };
}
function $e7161f778706e663$var$findPosition({ total: total, ranges: ranges }, ratio) {
    if (ratio <= 0) return ranges[0].from;
    if (ratio >= 1) return ranges[ranges.length - 1].to;
    let dist = Math.floor(total * ratio);
    for(let i = 0;; i++){
        let { from: from, to: to } = ranges[i], size = to - from;
        if (dist <= size) return from + dist;
        dist -= size;
    }
}
function $e7161f778706e663$var$findFraction(structure, pos) {
    let counted = 0;
    for (let { from: from, to: to } of structure.ranges){
        if (pos <= to) {
            counted += pos - from;
            break;
        }
        counted += to - from;
    }
    return counted / structure.total;
}
function $e7161f778706e663$var$find(array, f) {
    for (let val of array)if (f(val)) return val;
    return undefined;
}
// Don't scale when the document height is within the range of what
// the DOM can handle.
const $e7161f778706e663$var$IdScaler = {
    toDOM (n) {
        return n;
    },
    fromDOM (n) {
        return n;
    },
    scale: 1
};
// When the height is too big (> VP.MaxDOMHeight), scale down the
// regions outside the viewports so that the total height is
// VP.MaxDOMHeight.
class $e7161f778706e663$var$BigScaler {
    constructor(oracle, heightMap, viewports){
        let vpHeight = 0, base = 0, domBase = 0;
        this.viewports = viewports.map(({ from: from, to: to })=>{
            let top = heightMap.lineAt(from, $e7161f778706e663$var$QueryType.ByPos, oracle, 0, 0).top;
            let bottom = heightMap.lineAt(to, $e7161f778706e663$var$QueryType.ByPos, oracle, 0, 0).bottom;
            vpHeight += bottom - top;
            return {
                from: from,
                to: to,
                top: top,
                bottom: bottom,
                domTop: 0,
                domBottom: 0
            };
        });
        this.scale = (7000000 /* MaxDOMHeight */  - vpHeight) / (heightMap.height - vpHeight);
        for (let obj of this.viewports){
            obj.domTop = domBase + (obj.top - base) * this.scale;
            domBase = obj.domBottom = obj.domTop + (obj.bottom - obj.top);
            base = obj.bottom;
        }
    }
    toDOM(n) {
        for(let i = 0, base = 0, domBase = 0;; i++){
            let vp = i < this.viewports.length ? this.viewports[i] : null;
            if (!vp || n < vp.top) return domBase + (n - base) * this.scale;
            if (n <= vp.bottom) return vp.domTop + (n - vp.top);
            base = vp.bottom;
            domBase = vp.domBottom;
        }
    }
    fromDOM(n) {
        for(let i = 0, base = 0, domBase = 0;; i++){
            let vp = i < this.viewports.length ? this.viewports[i] : null;
            if (!vp || n < vp.domTop) return base + (n - domBase) / this.scale;
            if (n <= vp.domBottom) return vp.top + (n - vp.domTop);
            base = vp.bottom;
            domBase = vp.domBottom;
        }
    }
}
function $e7161f778706e663$var$scaleBlock(block, scaler) {
    if (scaler.scale == 1) return block;
    let bTop = scaler.toDOM(block.top), bBottom = scaler.toDOM(block.bottom);
    return new $e7161f778706e663$export$ddfdc4ccfe9512bd(block.from, block.length, bTop, bBottom - bTop, Array.isArray(block._content) ? block._content.map((b)=>$e7161f778706e663$var$scaleBlock(b, scaler)) : block._content);
}
const $e7161f778706e663$var$theme = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine: (strs)=>strs.join(" ")
});
const $e7161f778706e663$var$darkTheme = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine: (values)=>values.indexOf(true) > -1
});
const $e7161f778706e663$var$baseThemeID = /*@__PURE__*/ (0, $luNHI.StyleModule).newName(), $e7161f778706e663$var$baseLightID = /*@__PURE__*/ (0, $luNHI.StyleModule).newName(), $e7161f778706e663$var$baseDarkID = /*@__PURE__*/ (0, $luNHI.StyleModule).newName();
const $e7161f778706e663$var$lightDarkIDs = {
    "&light": "." + $e7161f778706e663$var$baseLightID,
    "&dark": "." + $e7161f778706e663$var$baseDarkID
};
function $e7161f778706e663$var$buildTheme(main, spec, scopes) {
    return new (0, $luNHI.StyleModule)(spec, {
        finish (sel) {
            return /&/.test(sel) ? sel.replace(/&\w*/, (m)=>{
                if (m == "&") return main;
                if (!scopes || !scopes[m]) throw new RangeError(`Unsupported selector: ${m}`);
                return scopes[m];
            }) : main + " " + sel;
        }
    });
}
const $e7161f778706e663$var$baseTheme$1 = /*@__PURE__*/ $e7161f778706e663$var$buildTheme("." + $e7161f778706e663$var$baseThemeID, {
    "&": {
        position: "relative !important",
        boxSizing: "border-box",
        "&.cm-focused": {
            // Provide a simple default outline to make sure a focused
            // editor is visually distinct. Can't leave the default behavior
            // because that will apply to the content element, which is
            // inside the scrollable container and doesn't include the
            // gutters. We also can't use an 'auto' outline, since those
            // are, for some reason, drawn behind the element content, which
            // will cause things like the active line background to cover
            // the outline (#297).
            outline: "1px dotted #212121"
        },
        display: "flex !important",
        flexDirection: "column"
    },
    ".cm-scroller": {
        display: "flex !important",
        alignItems: "flex-start !important",
        fontFamily: "monospace",
        lineHeight: 1.4,
        height: "100%",
        overflowX: "auto",
        position: "relative",
        zIndex: 0
    },
    ".cm-content": {
        margin: 0,
        flexGrow: 2,
        flexShrink: 0,
        display: "block",
        whiteSpace: "pre",
        wordWrap: "normal",
        boxSizing: "border-box",
        padding: "4px 0",
        outline: "none",
        "&[contenteditable=true]": {
            WebkitUserModify: "read-write-plaintext-only"
        }
    },
    ".cm-lineWrapping": {
        whiteSpace_fallback: "pre-wrap",
        whiteSpace: "break-spaces",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        flexShrink: 1
    },
    "&light .cm-content": {
        caretColor: "black"
    },
    "&dark .cm-content": {
        caretColor: "white"
    },
    ".cm-line": {
        display: "block",
        padding: "0 2px 0 6px"
    },
    ".cm-layer": {
        position: "absolute",
        left: 0,
        top: 0,
        contain: "size style",
        "& > *": {
            position: "absolute"
        }
    },
    "&light .cm-selectionBackground": {
        background: "#d9d9d9"
    },
    "&dark .cm-selectionBackground": {
        background: "#222"
    },
    "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
        background: "#d7d4f0"
    },
    "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
        background: "#233"
    },
    ".cm-cursorLayer": {
        pointerEvents: "none"
    },
    "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
        animation: "steps(1) cm-blink 1.2s infinite"
    },
    // Two animations defined so that we can switch between them to
    // restart the animation without forcing another style
    // recomputation.
    "@keyframes cm-blink": {
        "0%": {},
        "50%": {
            opacity: 0
        },
        "100%": {}
    },
    "@keyframes cm-blink2": {
        "0%": {},
        "50%": {
            opacity: 0
        },
        "100%": {}
    },
    ".cm-cursor, .cm-dropCursor": {
        borderLeft: "1.2px solid black",
        marginLeft: "-0.6px",
        pointerEvents: "none"
    },
    ".cm-cursor": {
        display: "none"
    },
    "&dark .cm-cursor": {
        borderLeftColor: "#444"
    },
    ".cm-dropCursor": {
        position: "absolute"
    },
    "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
        display: "block"
    },
    "&light .cm-activeLine": {
        backgroundColor: "#cceeff44"
    },
    "&dark .cm-activeLine": {
        backgroundColor: "#99eeff33"
    },
    "&light .cm-specialChar": {
        color: "red"
    },
    "&dark .cm-specialChar": {
        color: "#f78"
    },
    ".cm-gutters": {
        flexShrink: 0,
        display: "flex",
        height: "100%",
        boxSizing: "border-box",
        left: 0,
        zIndex: 200
    },
    "&light .cm-gutters": {
        backgroundColor: "#f5f5f5",
        color: "#6c6c6c",
        borderRight: "1px solid #ddd"
    },
    "&dark .cm-gutters": {
        backgroundColor: "#333338",
        color: "#ccc"
    },
    ".cm-gutter": {
        display: "flex !important",
        flexDirection: "column",
        flexShrink: 0,
        boxSizing: "border-box",
        minHeight: "100%",
        overflow: "hidden"
    },
    ".cm-gutterElement": {
        boxSizing: "border-box"
    },
    ".cm-lineNumbers .cm-gutterElement": {
        padding: "0 3px 0 5px",
        minWidth: "20px",
        textAlign: "right",
        whiteSpace: "nowrap"
    },
    "&light .cm-activeLineGutter": {
        backgroundColor: "#e2f2ff"
    },
    "&dark .cm-activeLineGutter": {
        backgroundColor: "#222227"
    },
    ".cm-panels": {
        boxSizing: "border-box",
        position: "sticky",
        left: 0,
        right: 0
    },
    "&light .cm-panels": {
        backgroundColor: "#f5f5f5",
        color: "black"
    },
    "&light .cm-panels-top": {
        borderBottom: "1px solid #ddd"
    },
    "&light .cm-panels-bottom": {
        borderTop: "1px solid #ddd"
    },
    "&dark .cm-panels": {
        backgroundColor: "#333338",
        color: "white"
    },
    ".cm-tab": {
        display: "inline-block",
        overflow: "hidden",
        verticalAlign: "bottom"
    },
    ".cm-widgetBuffer": {
        verticalAlign: "text-top",
        height: "1em",
        width: 0,
        display: "inline"
    },
    ".cm-placeholder": {
        color: "#888",
        display: "inline-block",
        verticalAlign: "top"
    },
    ".cm-highlightSpace:before": {
        content: "attr(data-display)",
        position: "absolute",
        pointerEvents: "none",
        color: "#888"
    },
    ".cm-highlightTab": {
        backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
        backgroundSize: "auto 100%",
        backgroundPosition: "right 90%",
        backgroundRepeat: "no-repeat"
    },
    ".cm-trailingSpace": {
        backgroundColor: "#ff332255"
    },
    ".cm-button": {
        verticalAlign: "middle",
        color: "inherit",
        fontSize: "70%",
        padding: ".2em 1em",
        borderRadius: "1px"
    },
    "&light .cm-button": {
        backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
        border: "1px solid #888",
        "&:active": {
            backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
        }
    },
    "&dark .cm-button": {
        backgroundImage: "linear-gradient(#393939, #111)",
        border: "1px solid #888",
        "&:active": {
            backgroundImage: "linear-gradient(#111, #333)"
        }
    },
    ".cm-textfield": {
        verticalAlign: "middle",
        color: "inherit",
        fontSize: "70%",
        border: "1px solid silver",
        padding: ".2em .5em"
    },
    "&light .cm-textfield": {
        backgroundColor: "white"
    },
    "&dark .cm-textfield": {
        border: "1px solid #555",
        backgroundColor: "inherit"
    }
}, $e7161f778706e663$var$lightDarkIDs);
class $e7161f778706e663$var$DOMChange {
    constructor(view, start, end, typeOver){
        this.typeOver = typeOver;
        this.bounds = null;
        this.text = "";
        let { impreciseHead: iHead, impreciseAnchor: iAnchor } = view.docView;
        if (view.state.readOnly && start > -1) // Ignore changes when the editor is read-only
        this.newSel = null;
        else if (start > -1 && (this.bounds = view.docView.domBoundsAround(start, end, 0))) {
            let selPoints = iHead || iAnchor ? [] : $e7161f778706e663$var$selectionPoints(view);
            let reader = new $e7161f778706e663$var$DOMReader(selPoints, view.state);
            reader.readRange(this.bounds.startDOM, this.bounds.endDOM);
            this.text = reader.text;
            this.newSel = $e7161f778706e663$var$selectionFromPoints(selPoints, this.bounds.from);
        } else {
            let domSel = view.observer.selectionRange;
            let head = iHead && iHead.node == domSel.focusNode && iHead.offset == domSel.focusOffset || !$e7161f778706e663$var$contains(view.contentDOM, domSel.focusNode) ? view.state.selection.main.head : view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset);
            let anchor = iAnchor && iAnchor.node == domSel.anchorNode && iAnchor.offset == domSel.anchorOffset || !$e7161f778706e663$var$contains(view.contentDOM, domSel.anchorNode) ? view.state.selection.main.anchor : view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset);
            this.newSel = (0, $hB7kI.EditorSelection).single(anchor, head);
        }
    }
}
function $e7161f778706e663$var$applyDOMChange(view, domChange) {
    let change;
    let { newSel: newSel } = domChange, sel = view.state.selection.main;
    let lastKey = view.inputState.lastKeyTime > Date.now() - 100 ? view.inputState.lastKeyCode : -1;
    if (domChange.bounds) {
        let { from: from, to: to } = domChange.bounds;
        let preferredPos = sel.from, preferredSide = null;
        // Prefer anchoring to end when Backspace is pressed (or, on
        // Android, when something was deleted)
        if (lastKey === 8 || $e7161f778706e663$var$browser.android && domChange.text.length < to - from) {
            preferredPos = sel.to;
            preferredSide = "end";
        }
        let diff = $e7161f778706e663$var$findDiff(view.state.doc.sliceString(from, to, $e7161f778706e663$var$LineBreakPlaceholder), domChange.text, preferredPos - from, preferredSide);
        if (diff) {
            // Chrome inserts two newlines when pressing shift-enter at the
            // end of a line. DomChange drops one of those.
            if ($e7161f778706e663$var$browser.chrome && lastKey == 13 && diff.toB == diff.from + 2 && domChange.text.slice(diff.from, diff.toB) == $e7161f778706e663$var$LineBreakPlaceholder + $e7161f778706e663$var$LineBreakPlaceholder) diff.toB--;
            change = {
                from: from + diff.from,
                to: from + diff.toA,
                insert: (0, $hB7kI.Text).of(domChange.text.slice(diff.from, diff.toB).split($e7161f778706e663$var$LineBreakPlaceholder))
            };
        }
    } else if (newSel && (!view.hasFocus && view.state.facet($e7161f778706e663$var$editable) || newSel.main.eq(sel))) newSel = null;
    if (!change && !newSel) return false;
    if (!change && domChange.typeOver && !sel.empty && newSel && newSel.main.empty) // Heuristic to notice typing over a selected character
    change = {
        from: sel.from,
        to: sel.to,
        insert: view.state.doc.slice(sel.from, sel.to)
    };
    else if (change && change.from >= sel.from && change.to <= sel.to && (change.from != sel.from || change.to != sel.to) && sel.to - sel.from - (change.to - change.from) <= 4) // If the change is inside the selection and covers most of it,
    // assume it is a selection replace (with identical characters at
    // the start/end not included in the diff)
    change = {
        from: sel.from,
        to: sel.to,
        insert: view.state.doc.slice(sel.from, change.from).append(change.insert).append(view.state.doc.slice(change.to, sel.to))
    };
    else if (($e7161f778706e663$var$browser.mac || $e7161f778706e663$var$browser.android) && change && change.from == change.to && change.from == sel.head - 1 && /^\. ?$/.test(change.insert.toString()) && view.contentDOM.getAttribute("autocorrect") == "off") {
        // Detect insert-period-on-double-space Mac and Android behavior,
        // and transform it into a regular space insert.
        if (newSel && change.insert.length == 2) newSel = (0, $hB7kI.EditorSelection).single(newSel.main.anchor - 1, newSel.main.head - 1);
        change = {
            from: sel.from,
            to: sel.to,
            insert: (0, $hB7kI.Text).of([
                " "
            ])
        };
    } else if ($e7161f778706e663$var$browser.chrome && change && change.from == change.to && change.from == sel.head && change.insert.toString() == "\n " && view.lineWrapping) {
        // In Chrome, if you insert a space at the start of a wrapped
        // line, it will actually insert a newline and a space, causing a
        // bogus new line to be created in CodeMirror (#968)
        if (newSel) newSel = (0, $hB7kI.EditorSelection).single(newSel.main.anchor - 1, newSel.main.head - 1);
        change = {
            from: sel.from,
            to: sel.to,
            insert: (0, $hB7kI.Text).of([
                " "
            ])
        };
    }
    if (change) {
        let startState = view.state;
        if ($e7161f778706e663$var$browser.ios && view.inputState.flushIOSKey(view)) return true;
        // Android browsers don't fire reasonable key events for enter,
        // backspace, or delete. So this detects changes that look like
        // they're caused by those keys, and reinterprets them as key
        // events. (Some of these keys are also handled by beforeinput
        // events and the pendingAndroidKey mechanism, but that's not
        // reliable in all situations.)
        if ($e7161f778706e663$var$browser.android && (change.from == sel.from && change.to == sel.to && change.insert.length == 1 && change.insert.lines == 2 && $e7161f778706e663$var$dispatchKey(view.contentDOM, "Enter", 13) || (change.from == sel.from - 1 && change.to == sel.to && change.insert.length == 0 || lastKey == 8 && change.insert.length < change.to - change.from) && $e7161f778706e663$var$dispatchKey(view.contentDOM, "Backspace", 8) || change.from == sel.from && change.to == sel.to + 1 && change.insert.length == 0 && $e7161f778706e663$var$dispatchKey(view.contentDOM, "Delete", 46))) return true;
        let text = change.insert.toString();
        if (view.state.facet($e7161f778706e663$var$inputHandler).some((h)=>h(view, change.from, change.to, text))) return true;
        if (view.inputState.composing >= 0) view.inputState.composing++;
        let tr;
        if (change.from >= sel.from && change.to <= sel.to && change.to - change.from >= (sel.to - sel.from) / 3 && (!newSel || newSel.main.empty && newSel.main.from == change.from + change.insert.length) && view.inputState.composing < 0) {
            let before = sel.from < change.from ? startState.sliceDoc(sel.from, change.from) : "";
            let after = sel.to > change.to ? startState.sliceDoc(change.to, sel.to) : "";
            tr = startState.replaceSelection(view.state.toText(before + change.insert.sliceString(0, undefined, view.state.lineBreak) + after));
        } else {
            let changes = startState.changes(change);
            let mainSel = newSel && newSel.main.to <= changes.newLength ? newSel.main : undefined;
            // Try to apply a composition change to all cursors
            if (startState.selection.ranges.length > 1 && view.inputState.composing >= 0 && change.to <= sel.to && change.to >= sel.to - 10) {
                let replaced = view.state.sliceDoc(change.from, change.to);
                let compositionRange = $e7161f778706e663$var$compositionSurroundingNode(view) || view.state.doc.lineAt(sel.head);
                let offset = sel.to - change.to, size = sel.to - sel.from;
                tr = startState.changeByRange((range)=>{
                    if (range.from == sel.from && range.to == sel.to) return {
                        changes: changes,
                        range: mainSel || range.map(changes)
                    };
                    let to = range.to - offset, from = to - replaced.length;
                    if (range.to - range.from != size || view.state.sliceDoc(from, to) != replaced || // Unfortunately, there's no way to make multiple
                    // changes in the same node work without aborting
                    // composition, so cursors in the composition range are
                    // ignored.
                    compositionRange && range.to >= compositionRange.from && range.from <= compositionRange.to) return {
                        range: range
                    };
                    let rangeChanges = startState.changes({
                        from: from,
                        to: to,
                        insert: change.insert
                    }), selOff = range.to - sel.to;
                    return {
                        changes: rangeChanges,
                        range: !mainSel ? range.map(rangeChanges) : (0, $hB7kI.EditorSelection).range(Math.max(0, mainSel.anchor + selOff), Math.max(0, mainSel.head + selOff))
                    };
                });
            } else tr = {
                changes: changes,
                selection: mainSel && startState.selection.replaceRange(mainSel)
            };
        }
        let userEvent = "input.type";
        if (view.composing || view.inputState.compositionPendingChange && view.inputState.compositionEndedAt > Date.now() - 50) {
            view.inputState.compositionPendingChange = false;
            userEvent += ".compose";
            if (view.inputState.compositionFirstChange) {
                userEvent += ".start";
                view.inputState.compositionFirstChange = false;
            }
        }
        view.dispatch(tr, {
            scrollIntoView: true,
            userEvent: userEvent
        });
        return true;
    } else if (newSel && !newSel.main.eq(sel)) {
        let scrollIntoView = false, userEvent = "select";
        if (view.inputState.lastSelectionTime > Date.now() - 50) {
            if (view.inputState.lastSelectionOrigin == "select") scrollIntoView = true;
            userEvent = view.inputState.lastSelectionOrigin;
        }
        view.dispatch({
            selection: newSel,
            scrollIntoView: scrollIntoView,
            userEvent: userEvent
        });
        return true;
    } else return false;
}
function $e7161f778706e663$var$findDiff(a, b, preferredPos, preferredSide) {
    let minLen = Math.min(a.length, b.length);
    let from = 0;
    while(from < minLen && a.charCodeAt(from) == b.charCodeAt(from))from++;
    if (from == minLen && a.length == b.length) return null;
    let toA = a.length, toB = b.length;
    while(toA > 0 && toB > 0 && a.charCodeAt(toA - 1) == b.charCodeAt(toB - 1)){
        toA--;
        toB--;
    }
    if (preferredSide == "end") {
        let adjust = Math.max(0, from - Math.min(toA, toB));
        preferredPos -= toA + adjust - from;
    }
    if (toA < from && a.length < b.length) {
        let move = preferredPos <= from && preferredPos >= toA ? from - preferredPos : 0;
        from -= move;
        toB = from + (toB - toA);
        toA = from;
    } else if (toB < from) {
        let move = preferredPos <= from && preferredPos >= toB ? from - preferredPos : 0;
        from -= move;
        toA = from + (toA - toB);
        toB = from;
    }
    return {
        from: from,
        toA: toA,
        toB: toB
    };
}
function $e7161f778706e663$var$selectionPoints(view) {
    let result = [];
    if (view.root.activeElement != view.contentDOM) return result;
    let { anchorNode: anchorNode, anchorOffset: anchorOffset, focusNode: focusNode, focusOffset: focusOffset } = view.observer.selectionRange;
    if (anchorNode) {
        result.push(new $e7161f778706e663$var$DOMPoint(anchorNode, anchorOffset));
        if (focusNode != anchorNode || focusOffset != anchorOffset) result.push(new $e7161f778706e663$var$DOMPoint(focusNode, focusOffset));
    }
    return result;
}
function $e7161f778706e663$var$selectionFromPoints(points, base) {
    if (points.length == 0) return null;
    let anchor = points[0].pos, head = points.length == 2 ? points[1].pos : anchor;
    return anchor > -1 && head > -1 ? (0, $hB7kI.EditorSelection).single(anchor + base, head + base) : null;
}
const $e7161f778706e663$var$observeOptions = {
    childList: true,
    characterData: true,
    subtree: true,
    attributes: true,
    characterDataOldValue: true
};
// IE11 has very broken mutation observers, so we also listen to
// DOMCharacterDataModified there
const $e7161f778706e663$var$useCharData = $e7161f778706e663$var$browser.ie && $e7161f778706e663$var$browser.ie_version <= 11;
class $e7161f778706e663$var$DOMObserver {
    constructor(view){
        this.view = view;
        this.active = false;
        // The known selection. Kept in our own object, as opposed to just
        // directly accessing the selection because:
        //  - Safari doesn't report the right selection in shadow DOM
        //  - Reading from the selection forces a DOM layout
        //  - This way, we can ignore selectionchange events if we have
        //    already seen the 'new' selection
        this.selectionRange = new $e7161f778706e663$var$DOMSelectionState;
        // Set when a selection change is detected, cleared on flush
        this.selectionChanged = false;
        this.delayedFlush = -1;
        this.resizeTimeout = -1;
        this.queue = [];
        this.delayedAndroidKey = null;
        this.flushingAndroidKey = -1;
        this.lastChange = 0;
        this.scrollTargets = [];
        this.intersection = null;
        this.resizeScroll = null;
        this.resizeContent = null;
        this.intersecting = false;
        this.gapIntersection = null;
        this.gaps = [];
        // Timeout for scheduling check of the parents that need scroll handlers
        this.parentCheck = -1;
        this.dom = view.contentDOM;
        this.observer = new MutationObserver((mutations)=>{
            for (let mut of mutations)this.queue.push(mut);
            // IE11 will sometimes (on typing over a selection or
            // backspacing out a single character text node) call the
            // observer callback before actually updating the DOM.
            //
            // Unrelatedly, iOS Safari will, when ending a composition,
            // sometimes first clear it, deliver the mutations, and then
            // reinsert the finished text. CodeMirror's handling of the
            // deletion will prevent the reinsertion from happening,
            // breaking composition.
            if (($e7161f778706e663$var$browser.ie && $e7161f778706e663$var$browser.ie_version <= 11 || $e7161f778706e663$var$browser.ios && view.composing) && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if ($e7161f778706e663$var$useCharData) this.onCharData = (event)=>{
            this.queue.push({
                target: event.target,
                type: "characterData",
                oldValue: event.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onPrint = this.onPrint.bind(this);
        this.onScroll = this.onScroll.bind(this);
        if (typeof ResizeObserver == "function") {
            this.resizeScroll = new ResizeObserver(()=>{
                var _a;
                if (((_a = this.view.docView) === null || _a === void 0 ? void 0 : _a.lastUpdate) < Date.now() - 75) this.onResize();
            });
            this.resizeScroll.observe(view.scrollDOM);
            this.resizeContent = new ResizeObserver(()=>this.view.requestMeasure());
            this.resizeContent.observe(view.contentDOM);
        }
        this.addWindowListeners(this.win = view.win);
        this.start();
        if (typeof IntersectionObserver == "function") {
            this.intersection = new IntersectionObserver((entries)=>{
                if (this.parentCheck < 0) this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1000);
                if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0 != this.intersecting) {
                    this.intersecting = !this.intersecting;
                    if (this.intersecting != this.view.inView) this.onScrollChanged(document.createEvent("Event"));
                }
            }, {
                threshold: [
                    0,
                    .001
                ]
            });
            this.intersection.observe(this.dom);
            this.gapIntersection = new IntersectionObserver((entries)=>{
                if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0) this.onScrollChanged(document.createEvent("Event"));
            }, {});
        }
        this.listenForScroll();
        this.readSelectionRange();
    }
    onScrollChanged(e) {
        this.view.inputState.runScrollHandlers(this.view, e);
        if (this.intersecting) this.view.measure();
    }
    onScroll(e) {
        if (this.intersecting) this.flush(false);
        this.onScrollChanged(e);
    }
    onResize() {
        if (this.resizeTimeout < 0) this.resizeTimeout = setTimeout(()=>{
            this.resizeTimeout = -1;
            this.view.requestMeasure();
        }, 50);
    }
    onPrint() {
        this.view.viewState.printing = true;
        this.view.measure();
        setTimeout(()=>{
            this.view.viewState.printing = false;
            this.view.requestMeasure();
        }, 500);
    }
    updateGaps(gaps) {
        if (this.gapIntersection && (gaps.length != this.gaps.length || this.gaps.some((g, i)=>g != gaps[i]))) {
            this.gapIntersection.disconnect();
            for (let gap of gaps)this.gapIntersection.observe(gap);
            this.gaps = gaps;
        }
    }
    onSelectionChange(event) {
        let wasChanged = this.selectionChanged;
        if (!this.readSelectionRange() || this.delayedAndroidKey) return;
        let { view: view } = this, sel = this.selectionRange;
        if (view.state.facet($e7161f778706e663$var$editable) ? view.root.activeElement != this.dom : !$e7161f778706e663$var$hasSelection(view.dom, sel)) return;
        let context = sel.anchorNode && view.docView.nearest(sel.anchorNode);
        if (context && context.ignoreEvent(event)) {
            if (!wasChanged) this.selectionChanged = false;
            return;
        }
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        // Chrome Android has a similar issue when backspacing out a
        // selection (#645).
        if (($e7161f778706e663$var$browser.ie && $e7161f778706e663$var$browser.ie_version <= 11 || $e7161f778706e663$var$browser.android && $e7161f778706e663$var$browser.chrome) && !view.state.selection.main.empty && // (Selection.isCollapsed isn't reliable on IE)
        sel.focusNode && $e7161f778706e663$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) this.flushSoon();
        else this.flush(false);
    }
    readSelectionRange() {
        let { view: view } = this;
        // The Selection object is broken in shadow roots in Safari. See
        // https://github.com/codemirror/dev/issues/414
        let range = $e7161f778706e663$var$browser.safari && view.root.nodeType == 11 && $e7161f778706e663$var$deepActiveElement(this.dom.ownerDocument) == this.dom && $e7161f778706e663$var$safariSelectionRangeHack(this.view) || $e7161f778706e663$var$getSelection(view.root);
        if (!range || this.selectionRange.eq(range)) return false;
        let local = $e7161f778706e663$var$hasSelection(this.dom, range);
        // Detect the situation where the browser has, on focus, moved the
        // selection to the start of the content element. Reset it to the
        // position from the editor state.
        if (local && !this.selectionChanged && view.inputState.lastFocusTime > Date.now() - 200 && view.inputState.lastTouchTime < Date.now() - 300 && $e7161f778706e663$var$atElementStart(this.dom, range)) {
            this.view.inputState.lastFocusTime = 0;
            view.docView.updateSelection();
            return false;
        }
        this.selectionRange.setRange(range);
        if (local) this.selectionChanged = true;
        return true;
    }
    setSelectionRange(anchor, head) {
        this.selectionRange.set(anchor.node, anchor.offset, head.node, head.offset);
        this.selectionChanged = false;
    }
    clearSelectionRange() {
        this.selectionRange.set(null, 0, null, 0);
    }
    listenForScroll() {
        this.parentCheck = -1;
        let i = 0, changed = null;
        for(let dom = this.dom; dom;){
            if (dom.nodeType == 1) {
                if (!changed && i < this.scrollTargets.length && this.scrollTargets[i] == dom) i++;
                else if (!changed) changed = this.scrollTargets.slice(0, i);
                if (changed) changed.push(dom);
                dom = dom.assignedSlot || dom.parentNode;
            } else if (dom.nodeType == 11) dom = dom.host;
            else break;
        }
        if (i < this.scrollTargets.length && !changed) changed = this.scrollTargets.slice(0, i);
        if (changed) {
            for (let dom of this.scrollTargets)dom.removeEventListener("scroll", this.onScroll);
            for (let dom of this.scrollTargets = changed)dom.addEventListener("scroll", this.onScroll);
        }
    }
    ignore(f) {
        if (!this.active) return f();
        try {
            this.stop();
            return f();
        } finally{
            this.start();
            this.clear();
        }
    }
    start() {
        if (this.active) return;
        this.observer.observe(this.dom, $e7161f778706e663$var$observeOptions);
        if ($e7161f778706e663$var$useCharData) this.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.active = true;
    }
    stop() {
        if (!this.active) return;
        this.active = false;
        this.observer.disconnect();
        if ($e7161f778706e663$var$useCharData) this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
    }
    // Throw away any pending changes
    clear() {
        this.processRecords();
        this.queue.length = 0;
        this.selectionChanged = false;
    }
    // Chrome Android, especially in combination with GBoard, not only
    // doesn't reliably fire regular key events, but also often
    // surrounds the effect of enter or backspace with a bunch of
    // composition events that, when interrupted, cause text duplication
    // or other kinds of corruption. This hack makes the editor back off
    // from handling DOM changes for a moment when such a key is
    // detected (via beforeinput or keydown), and then tries to flush
    // them or, if that has no effect, dispatches the given key.
    delayAndroidKey(key, keyCode) {
        var _a;
        if (!this.delayedAndroidKey) {
            let flush = ()=>{
                let key = this.delayedAndroidKey;
                if (key) {
                    this.clearDelayedAndroidKey();
                    this.view.inputState.lastKeyCode = key.keyCode;
                    this.view.inputState.lastKeyTime = Date.now();
                    let flushed = this.flush();
                    if (!flushed && key.force) $e7161f778706e663$var$dispatchKey(this.dom, key.key, key.keyCode);
                }
            };
            this.flushingAndroidKey = this.view.win.requestAnimationFrame(flush);
        }
        // Since backspace beforeinput is sometimes signalled spuriously,
        // Enter always takes precedence.
        if (!this.delayedAndroidKey || key == "Enter") this.delayedAndroidKey = {
            key: key,
            keyCode: keyCode,
            // Only run the key handler when no changes are detected if
            // this isn't coming right after another change, in which case
            // it is probably part of a weird chain of updates, and should
            // be ignored if it returns the DOM to its previous state.
            force: this.lastChange < Date.now() - 50 || !!((_a = this.delayedAndroidKey) === null || _a === void 0 ? void 0 : _a.force)
        };
    }
    clearDelayedAndroidKey() {
        this.win.cancelAnimationFrame(this.flushingAndroidKey);
        this.delayedAndroidKey = null;
        this.flushingAndroidKey = -1;
    }
    flushSoon() {
        if (this.delayedFlush < 0) this.delayedFlush = this.view.win.requestAnimationFrame(()=>{
            this.delayedFlush = -1;
            this.flush();
        });
    }
    forceFlush() {
        if (this.delayedFlush >= 0) {
            this.view.win.cancelAnimationFrame(this.delayedFlush);
            this.delayedFlush = -1;
        }
        this.flush();
    }
    pendingRecords() {
        for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    processRecords() {
        let records = this.pendingRecords();
        if (records.length) this.queue = [];
        let from = -1, to = -1, typeOver = false;
        for (let record of records){
            let range = this.readMutation(record);
            if (!range) continue;
            if (range.typeOver) typeOver = true;
            if (from == -1) ({ from: from, to: to } = range);
            else {
                from = Math.min(range.from, from);
                to = Math.max(range.to, to);
            }
        }
        return {
            from: from,
            to: to,
            typeOver: typeOver
        };
    }
    readChange() {
        let { from: from, to: to, typeOver: typeOver } = this.processRecords();
        let newSel = this.selectionChanged && $e7161f778706e663$var$hasSelection(this.dom, this.selectionRange);
        if (from < 0 && !newSel) return null;
        if (from > -1) this.lastChange = Date.now();
        this.view.inputState.lastFocusTime = 0;
        this.selectionChanged = false;
        return new $e7161f778706e663$var$DOMChange(this.view, from, to, typeOver);
    }
    // Apply pending changes, if any
    flush(readSelection = true) {
        // Completely hold off flushing when pending keys are set—the code
        // managing those will make sure processRecords is called and the
        // view is resynchronized after
        if (this.delayedFlush >= 0 || this.delayedAndroidKey) return false;
        if (readSelection) this.readSelectionRange();
        let domChange = this.readChange();
        if (!domChange) return false;
        let startState = this.view.state;
        let handled = $e7161f778706e663$var$applyDOMChange(this.view, domChange);
        // The view wasn't updated
        if (this.view.state == startState) this.view.update([]);
        return handled;
    }
    readMutation(rec) {
        let cView = this.view.docView.nearest(rec.target);
        if (!cView || cView.ignoreMutation(rec)) return null;
        cView.markDirty(rec.type == "attributes");
        if (rec.type == "attributes") cView.dirty |= 4 /* Attrs */ ;
        if (rec.type == "childList") {
            let childBefore = $e7161f778706e663$var$findChild(cView, rec.previousSibling || rec.target.previousSibling, -1);
            let childAfter = $e7161f778706e663$var$findChild(cView, rec.nextSibling || rec.target.nextSibling, 1);
            return {
                from: childBefore ? cView.posAfter(childBefore) : cView.posAtStart,
                to: childAfter ? cView.posBefore(childAfter) : cView.posAtEnd,
                typeOver: false
            };
        } else if (rec.type == "characterData") return {
            from: cView.posAtStart,
            to: cView.posAtEnd,
            typeOver: rec.target.nodeValue == rec.oldValue
        };
        else return null;
    }
    setWindow(win) {
        if (win != this.win) {
            this.removeWindowListeners(this.win);
            this.win = win;
            this.addWindowListeners(this.win);
        }
    }
    addWindowListeners(win) {
        win.addEventListener("resize", this.onResize);
        win.addEventListener("beforeprint", this.onPrint);
        win.addEventListener("scroll", this.onScroll);
        win.document.addEventListener("selectionchange", this.onSelectionChange);
    }
    removeWindowListeners(win) {
        win.removeEventListener("scroll", this.onScroll);
        win.removeEventListener("resize", this.onResize);
        win.removeEventListener("beforeprint", this.onPrint);
        win.document.removeEventListener("selectionchange", this.onSelectionChange);
    }
    destroy() {
        var _a, _b, _c, _d;
        this.stop();
        (_a = this.intersection) === null || _a === void 0 || _a.disconnect();
        (_b = this.gapIntersection) === null || _b === void 0 || _b.disconnect();
        (_c = this.resizeScroll) === null || _c === void 0 || _c.disconnect();
        (_d = this.resizeContent) === null || _d === void 0 || _d.disconnect();
        for (let dom of this.scrollTargets)dom.removeEventListener("scroll", this.onScroll);
        this.removeWindowListeners(this.win);
        clearTimeout(this.parentCheck);
        clearTimeout(this.resizeTimeout);
        this.win.cancelAnimationFrame(this.delayedFlush);
        this.win.cancelAnimationFrame(this.flushingAndroidKey);
    }
}
function $e7161f778706e663$var$findChild(cView, dom, dir) {
    while(dom){
        let curView = $e7161f778706e663$var$ContentView.get(dom);
        if (curView && curView.parent == cView) return curView;
        let parent = dom.parentNode;
        dom = parent != cView.dom ? parent : dir > 0 ? dom.nextSibling : dom.previousSibling;
    }
    return null;
}
// Used to work around a Safari Selection/shadow DOM bug (#414)
function $e7161f778706e663$var$safariSelectionRangeHack(view) {
    let found = null;
    // Because Safari (at least in 2018-2021) doesn't provide regular
    // access to the selection inside a shadowroot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    view.contentDOM.addEventListener("beforeinput", read, true);
    view.dom.ownerDocument.execCommand("indent");
    view.contentDOM.removeEventListener("beforeinput", read, true);
    if (!found) return null;
    let anchorNode = found.startContainer, anchorOffset = found.startOffset;
    let focusNode = found.endContainer, focusOffset = found.endOffset;
    let curAnchor = view.docView.domAtPos(view.state.selection.main.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($e7161f778706e663$var$isEquivalentPosition(curAnchor.node, curAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// The editor's update state machine looks something like this:
//
//     Idle → Updating ⇆ Idle (unchecked) → Measuring → Idle
//                                         ↑      ↓
//                                         Updating (measure)
//
// The difference between 'Idle' and 'Idle (unchecked)' lies in
// whether a layout check has been scheduled. A regular update through
// the `update` method updates the DOM in a write-only fashion, and
// relies on a check (scheduled with `requestAnimationFrame`) to make
// sure everything is where it should be and the viewport covers the
// visible code. That check continues to measure and then optionally
// update until it reaches a coherent state.
/**
An editor view represents the editor's user interface. It holds
the editable DOM surface, and possibly other elements such as the
line number gutter. It handles events and dispatches state
transactions for editing actions.
*/ class $e7161f778706e663$export$eece2fccabbb77c5 {
    /**
    Construct a new view. You'll want to either provide a `parent`
    option, or put `view.dom` into your document after creating a
    view, so that the user can see the editor.
    */ constructor(config = {}){
        this.plugins = [];
        this.pluginMap = new Map;
        this.editorAttrs = {};
        this.contentAttrs = {};
        this.bidiCache = [];
        this.destroyed = false;
        /**
        @internal
        */ this.updateState = 2 /* Updating */ ;
        /**
        @internal
        */ this.measureScheduled = -1;
        /**
        @internal
        */ this.measureRequests = [];
        this.contentDOM = document.createElement("div");
        this.scrollDOM = document.createElement("div");
        this.scrollDOM.tabIndex = -1;
        this.scrollDOM.className = "cm-scroller";
        this.scrollDOM.appendChild(this.contentDOM);
        this.announceDOM = document.createElement("div");
        this.announceDOM.style.cssText = "position: fixed; top: -10000px";
        this.announceDOM.setAttribute("aria-live", "polite");
        this.dom = document.createElement("div");
        this.dom.appendChild(this.announceDOM);
        this.dom.appendChild(this.scrollDOM);
        this._dispatch = config.dispatch || ((tr)=>this.update([
                tr
            ]));
        this.dispatch = this.dispatch.bind(this);
        this._root = config.root || $e7161f778706e663$var$getRoot(config.parent) || document;
        this.viewState = new $e7161f778706e663$var$ViewState(config.state || (0, $hB7kI.EditorState).create(config));
        this.plugins = this.state.facet($e7161f778706e663$var$viewPlugin).map((spec)=>new $e7161f778706e663$var$PluginInstance(spec));
        for (let plugin of this.plugins)plugin.update(this);
        this.observer = new $e7161f778706e663$var$DOMObserver(this);
        this.inputState = new $e7161f778706e663$var$InputState(this);
        this.inputState.ensureHandlers(this, this.plugins);
        this.docView = new $e7161f778706e663$var$DocView(this);
        this.mountStyles();
        this.updateAttrs();
        this.updateState = 0 /* Idle */ ;
        this.requestMeasure();
        if (config.parent) config.parent.appendChild(this.dom);
    }
    /**
    The current editor state.
    */ get state() {
        return this.viewState.state;
    }
    /**
    To be able to display large documents without consuming too much
    memory or overloading the browser, CodeMirror only draws the
    code that is visible (plus a margin around it) to the DOM. This
    property tells you the extent of the current drawn viewport, in
    document positions.
    */ get viewport() {
        return this.viewState.viewport;
    }
    /**
    When there are, for example, large collapsed ranges in the
    viewport, its size can be a lot bigger than the actual visible
    content. Thus, if you are doing something like styling the
    content in the viewport, it is preferable to only do so for
    these ranges, which are the subset of the viewport that is
    actually drawn.
    */ get visibleRanges() {
        return this.viewState.visibleRanges;
    }
    /**
    Returns false when the editor is entirely scrolled out of view
    or otherwise hidden.
    */ get inView() {
        return this.viewState.inView;
    }
    /**
    Indicates whether the user is currently composing text via
    [IME](https://en.wikipedia.org/wiki/Input_method), and at least
    one change has been made in the current composition.
    */ get composing() {
        return this.inputState.composing > 0;
    }
    /**
    Indicates whether the user is currently in composing state. Note
    that on some platforms, like Android, this will be the case a
    lot, since just putting the cursor on a word starts a
    composition there.
    */ get compositionStarted() {
        return this.inputState.composing >= 0;
    }
    /**
    The document or shadow root that the view lives in.
    */ get root() {
        return this._root;
    }
    /**
    @internal
    */ get win() {
        return this.dom.ownerDocument.defaultView || window;
    }
    dispatch(...input) {
        let tr = input.length == 1 && input[0] instanceof (0, $hB7kI.Transaction) ? input[0] : this.state.update(...input);
        this._dispatch(tr, this);
    }
    /**
    Update the view for the given array of transactions. This will
    update the visible document and selection to match the state
    produced by the transactions, and notify view plugins of the
    change. You should usually call
    [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead, which uses this
    as a primitive.
    */ update(transactions) {
        if (this.updateState != 0 /* Idle */ ) throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
        let redrawn = false, attrsChanged = false, update;
        let state = this.state;
        for (let tr of transactions){
            if (tr.startState != state) throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
            state = tr.state;
        }
        if (this.destroyed) {
            this.viewState.state = state;
            return;
        }
        let focus = this.hasFocus, focusFlag = 0, dispatchFocus = null;
        if (transactions.some((tr)=>tr.annotation($e7161f778706e663$var$isFocusChange))) {
            this.inputState.notifiedFocused = focus;
            // If a focus-change transaction is being dispatched, set this update flag.
            focusFlag = 1 /* Focus */ ;
        } else if (focus != this.inputState.notifiedFocused) {
            this.inputState.notifiedFocused = focus;
            // Schedule a separate focus transaction if necessary, otherwise
            // add a flag to this update
            dispatchFocus = $e7161f778706e663$var$focusChangeTransaction(state, focus);
            if (!dispatchFocus) focusFlag = 1 /* Focus */ ;
        }
        // If there was a pending DOM change, eagerly read it and try to
        // apply it after the given transactions.
        let pendingKey = this.observer.delayedAndroidKey, domChange = null;
        if (pendingKey) {
            this.observer.clearDelayedAndroidKey();
            domChange = this.observer.readChange();
            // Only try to apply DOM changes if the transactions didn't
            // change the doc or selection.
            if (domChange && !this.state.doc.eq(state.doc) || !this.state.selection.eq(state.selection)) domChange = null;
        } else this.observer.clear();
        // When the phrases change, redraw the editor
        if (state.facet((0, $hB7kI.EditorState).phrases) != this.state.facet((0, $hB7kI.EditorState).phrases)) return this.setState(state);
        update = $e7161f778706e663$export$b5b084f95c87edf7.create(this, state, transactions);
        update.flags |= focusFlag;
        let scrollTarget = this.viewState.scrollTarget;
        try {
            this.updateState = 2 /* Updating */ ;
            for (let tr of transactions){
                if (scrollTarget) scrollTarget = scrollTarget.map(tr.changes);
                if (tr.scrollIntoView) {
                    let { main: main } = tr.state.selection;
                    scrollTarget = new $e7161f778706e663$var$ScrollTarget(main.empty ? main : (0, $hB7kI.EditorSelection).cursor(main.head, main.head > main.anchor ? -1 : 1));
                }
                for (let e of tr.effects)if (e.is($e7161f778706e663$var$scrollIntoView)) scrollTarget = e.value;
            }
            this.viewState.update(update, scrollTarget);
            this.bidiCache = $e7161f778706e663$var$CachedOrder.update(this.bidiCache, update.changes);
            if (!update.empty) {
                this.updatePlugins(update);
                this.inputState.update(update);
            }
            redrawn = this.docView.update(update);
            if (this.state.facet($e7161f778706e663$var$styleModule) != this.styleModules) this.mountStyles();
            attrsChanged = this.updateAttrs();
            this.showAnnouncements(transactions);
            this.docView.updateSelection(redrawn, transactions.some((tr)=>tr.isUserEvent("select.pointer")));
        } finally{
            this.updateState = 0 /* Idle */ ;
        }
        if (update.startState.facet($e7161f778706e663$var$theme) != update.state.facet($e7161f778706e663$var$theme)) this.viewState.mustMeasureContent = true;
        if (redrawn || attrsChanged || scrollTarget || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) this.requestMeasure();
        if (!update.empty) for (let listener of this.state.facet($e7161f778706e663$var$updateListener))listener(update);
        if (dispatchFocus || domChange) Promise.resolve().then(()=>{
            if (dispatchFocus && this.state == dispatchFocus.startState) this.dispatch(dispatchFocus);
            if (domChange) {
                if (!$e7161f778706e663$var$applyDOMChange(this, domChange) && pendingKey.force) $e7161f778706e663$var$dispatchKey(this.contentDOM, pendingKey.key, pendingKey.keyCode);
            }
        });
    }
    /**
    Reset the view to the given state. (This will cause the entire
    document to be redrawn and all view plugins to be reinitialized,
    so you should probably only use it when the new state isn't
    derived from the old state. Otherwise, use
    [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead.)
    */ setState(newState) {
        if (this.updateState != 0 /* Idle */ ) throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
        if (this.destroyed) {
            this.viewState.state = newState;
            return;
        }
        this.updateState = 2 /* Updating */ ;
        let hadFocus = this.hasFocus;
        try {
            for (let plugin of this.plugins)plugin.destroy(this);
            this.viewState = new $e7161f778706e663$var$ViewState(newState);
            this.plugins = newState.facet($e7161f778706e663$var$viewPlugin).map((spec)=>new $e7161f778706e663$var$PluginInstance(spec));
            this.pluginMap.clear();
            for (let plugin of this.plugins)plugin.update(this);
            this.docView = new $e7161f778706e663$var$DocView(this);
            this.inputState.ensureHandlers(this, this.plugins);
            this.mountStyles();
            this.updateAttrs();
            this.bidiCache = [];
        } finally{
            this.updateState = 0 /* Idle */ ;
        }
        if (hadFocus) this.focus();
        this.requestMeasure();
    }
    updatePlugins(update) {
        let prevSpecs = update.startState.facet($e7161f778706e663$var$viewPlugin), specs = update.state.facet($e7161f778706e663$var$viewPlugin);
        if (prevSpecs != specs) {
            let newPlugins = [];
            for (let spec of specs){
                let found = prevSpecs.indexOf(spec);
                if (found < 0) newPlugins.push(new $e7161f778706e663$var$PluginInstance(spec));
                else {
                    let plugin = this.plugins[found];
                    plugin.mustUpdate = update;
                    newPlugins.push(plugin);
                }
            }
            for (let plugin of this.plugins)if (plugin.mustUpdate != update) plugin.destroy(this);
            this.plugins = newPlugins;
            this.pluginMap.clear();
            this.inputState.ensureHandlers(this, this.plugins);
        } else for (let p of this.plugins)p.mustUpdate = update;
        for(let i = 0; i < this.plugins.length; i++)this.plugins[i].update(this);
    }
    /**
    @internal
    */ measure(flush = true) {
        if (this.destroyed) return;
        if (this.measureScheduled > -1) this.win.cancelAnimationFrame(this.measureScheduled);
        this.measureScheduled = 0; // Prevent requestMeasure calls from scheduling another animation frame
        if (flush) this.observer.forceFlush();
        let updated = null;
        let sDOM = this.scrollDOM, { scrollTop: scrollTop } = sDOM;
        let { scrollAnchorPos: scrollAnchorPos, scrollAnchorHeight: scrollAnchorHeight } = this.viewState;
        this.viewState.scrollAnchorHeight = -1;
        if (scrollAnchorHeight < 0 || scrollTop != this.viewState.scrollTop) {
            if (scrollTop > sDOM.scrollHeight - sDOM.clientHeight - 4) {
                scrollAnchorPos = -1;
                scrollAnchorHeight = this.viewState.heightMap.height;
            } else {
                let block = this.viewState.lineBlockAtHeight(scrollTop);
                scrollAnchorPos = block.from;
                scrollAnchorHeight = block.top;
            }
        }
        try {
            for(let i = 0;; i++){
                this.updateState = 1 /* Measuring */ ;
                let oldViewport = this.viewport;
                let changed = this.viewState.measure(this);
                if (!changed && !this.measureRequests.length && this.viewState.scrollTarget == null) break;
                if (i > 5) {
                    console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
                    break;
                }
                let measuring = [];
                // Only run measure requests in this cycle when the viewport didn't change
                if (!(changed & 4 /* Viewport */ )) [this.measureRequests, measuring] = [
                    measuring,
                    this.measureRequests
                ];
                let measured = measuring.map((m)=>{
                    try {
                        return m.read(this);
                    } catch (e) {
                        $e7161f778706e663$export$f86b2a1a2ce291b3(this.state, e);
                        return $e7161f778706e663$var$BadMeasure;
                    }
                });
                let update = $e7161f778706e663$export$b5b084f95c87edf7.create(this, this.state, []), redrawn = false, scrolled = false;
                update.flags |= changed;
                if (!updated) updated = update;
                else updated.flags |= changed;
                this.updateState = 2 /* Updating */ ;
                if (!update.empty) {
                    this.updatePlugins(update);
                    this.inputState.update(update);
                    this.updateAttrs();
                    redrawn = this.docView.update(update);
                }
                for(let i = 0; i < measuring.length; i++)if (measured[i] != $e7161f778706e663$var$BadMeasure) try {
                    let m = measuring[i];
                    if (m.write) m.write(measured[i], this);
                } catch (e) {
                    $e7161f778706e663$export$f86b2a1a2ce291b3(this.state, e);
                }
                if (this.viewState.editorHeight) {
                    if (this.viewState.scrollTarget) {
                        this.docView.scrollIntoView(this.viewState.scrollTarget);
                        this.viewState.scrollTarget = null;
                        scrolled = true;
                    } else if (scrollAnchorHeight > -1) {
                        let newAnchorHeight = scrollAnchorPos < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(scrollAnchorPos).top;
                        let diff = newAnchorHeight - scrollAnchorHeight;
                        if (diff > 1 || diff < -1) {
                            sDOM.scrollTop = scrollTop + diff;
                            scrolled = true;
                        }
                    }
                }
                if (redrawn) this.docView.updateSelection(true);
                if (this.viewport.from == oldViewport.from && this.viewport.to == oldViewport.to && !scrolled && this.measureRequests.length == 0) break;
                scrollAnchorHeight = -1;
            }
        } finally{
            this.updateState = 0 /* Idle */ ;
            this.measureScheduled = -1;
        }
        if (updated && !updated.empty) for (let listener of this.state.facet($e7161f778706e663$var$updateListener))listener(updated);
    }
    /**
    Get the CSS classes for the currently active editor themes.
    */ get themeClasses() {
        return $e7161f778706e663$var$baseThemeID + " " + (this.state.facet($e7161f778706e663$var$darkTheme) ? $e7161f778706e663$var$baseDarkID : $e7161f778706e663$var$baseLightID) + " " + this.state.facet($e7161f778706e663$var$theme);
    }
    updateAttrs() {
        let editorAttrs = $e7161f778706e663$var$attrsFromFacet(this, $e7161f778706e663$var$editorAttributes, {
            class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
        });
        let contentAttrs = {
            spellcheck: "false",
            autocorrect: "off",
            autocapitalize: "off",
            translate: "no",
            contenteditable: !this.state.facet($e7161f778706e663$var$editable) ? "false" : "true",
            class: "cm-content",
            style: `${$e7161f778706e663$var$browser.tabSize}: ${this.state.tabSize}`,
            role: "textbox",
            "aria-multiline": "true"
        };
        if (this.state.readOnly) contentAttrs["aria-readonly"] = "true";
        $e7161f778706e663$var$attrsFromFacet(this, $e7161f778706e663$var$contentAttributes, contentAttrs);
        let changed = this.observer.ignore(()=>{
            let changedContent = $e7161f778706e663$var$updateAttrs(this.contentDOM, this.contentAttrs, contentAttrs);
            let changedEditor = $e7161f778706e663$var$updateAttrs(this.dom, this.editorAttrs, editorAttrs);
            return changedContent || changedEditor;
        });
        this.editorAttrs = editorAttrs;
        this.contentAttrs = contentAttrs;
        return changed;
    }
    showAnnouncements(trs) {
        let first = true;
        for (let tr of trs)for (let effect of tr.effects)if (effect.is($e7161f778706e663$export$eece2fccabbb77c5.announce)) {
            if (first) this.announceDOM.textContent = "";
            first = false;
            let div = this.announceDOM.appendChild(document.createElement("div"));
            div.textContent = effect.value;
        }
    }
    mountStyles() {
        this.styleModules = this.state.facet($e7161f778706e663$var$styleModule);
        (0, $luNHI.StyleModule).mount(this.root, this.styleModules.concat($e7161f778706e663$var$baseTheme$1).reverse());
    }
    readMeasured() {
        if (this.updateState == 2 /* Updating */ ) throw new Error("Reading the editor layout isn't allowed during an update");
        if (this.updateState == 0 /* Idle */  && this.measureScheduled > -1) this.measure(false);
    }
    /**
    Schedule a layout measurement, optionally providing callbacks to
    do custom DOM measuring followed by a DOM write phase. Using
    this is preferable reading DOM layout directly from, for
    example, an event handler, because it'll make sure measuring and
    drawing done by other components is synchronized, avoiding
    unnecessary DOM layout computations.
    */ requestMeasure(request) {
        if (this.measureScheduled < 0) this.measureScheduled = this.win.requestAnimationFrame(()=>this.measure());
        if (request) {
            if (this.measureRequests.indexOf(request) > -1) return;
            if (request.key != null) {
                for(let i = 0; i < this.measureRequests.length; i++)if (this.measureRequests[i].key === request.key) {
                    this.measureRequests[i] = request;
                    return;
                }
            }
            this.measureRequests.push(request);
        }
    }
    /**
    Get the value of a specific plugin, if present. Note that
    plugins that crash can be dropped from a view, so even when you
    know you registered a given plugin, it is recommended to check
    the return value of this method.
    */ plugin(plugin) {
        let known = this.pluginMap.get(plugin);
        if (known === undefined || known && known.spec != plugin) this.pluginMap.set(plugin, known = this.plugins.find((p)=>p.spec == plugin) || null);
        return known && known.update(this).value;
    }
    /**
    The top position of the document, in screen coordinates. This
    may be negative when the editor is scrolled down. Points
    directly to the top of the first line, not above the padding.
    */ get documentTop() {
        return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
    }
    /**
    Reports the padding above and below the document.
    */ get documentPadding() {
        return {
            top: this.viewState.paddingTop,
            bottom: this.viewState.paddingBottom
        };
    }
    /**
    Find the text line or block widget at the given vertical
    position (which is interpreted as relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop)).
    */ elementAtHeight(height) {
        this.readMeasured();
        return this.viewState.elementAtHeight(height);
    }
    /**
    Find the line block (see
    [`lineBlockAt`](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) at the given
    height, again interpreted relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop).
    */ lineBlockAtHeight(height) {
        this.readMeasured();
        return this.viewState.lineBlockAtHeight(height);
    }
    /**
    Get the extent and vertical position of all [line
    blocks](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) in the viewport. Positions
    are relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop);
    */ get viewportLineBlocks() {
        return this.viewState.viewportLines;
    }
    /**
    Find the line block around the given document position. A line
    block is a range delimited on both sides by either a
    non-[hidden](https://codemirror.net/6/docs/ref/#view.Decoration^replace) line breaks, or the
    start/end of the document. It will usually just hold a line of
    text, but may be broken into multiple textblocks by block
    widgets.
    */ lineBlockAt(pos) {
        return this.viewState.lineBlockAt(pos);
    }
    /**
    The editor's total content height.
    */ get contentHeight() {
        return this.viewState.contentHeight;
    }
    /**
    Move a cursor position by [grapheme
    cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak). `forward` determines whether
    the motion is away from the line start, or towards it. In
    bidirectional text, the line is traversed in visual order, using
    the editor's [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
    When the start position was the last one on the line, the
    returned position will be across the line break. If there is no
    further line, the original position is returned.
    
    By default, this method moves over a single cluster. The
    optional `by` argument can be used to move across more. It will
    be called with the first cluster as argument, and should return
    a predicate that determines, for each subsequent cluster,
    whether it should also be moved over.
    */ moveByChar(start, forward, by) {
        return $e7161f778706e663$var$skipAtoms(this, start, $e7161f778706e663$var$moveByChar(this, start, forward, by));
    }
    /**
    Move a cursor position across the next group of either
    [letters](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) or non-letter
    non-whitespace characters.
    */ moveByGroup(start, forward) {
        return $e7161f778706e663$var$skipAtoms(this, start, $e7161f778706e663$var$moveByChar(this, start, forward, (initial)=>$e7161f778706e663$var$byGroup(this, start.head, initial)));
    }
    /**
    Move to the next line boundary in the given direction. If
    `includeWrap` is true, line wrapping is on, and there is a
    further wrap point on the current line, the wrap point will be
    returned. Otherwise this function will return the start or end
    of the line.
    */ moveToLineBoundary(start, forward, includeWrap = true) {
        return $e7161f778706e663$var$moveToLineBoundary(this, start, forward, includeWrap);
    }
    /**
    Move a cursor position vertically. When `distance` isn't given,
    it defaults to moving to the next line (including wrapped
    lines). Otherwise, `distance` should provide a positive distance
    in pixels.
    
    When `start` has a
    [`goalColumn`](https://codemirror.net/6/docs/ref/#state.SelectionRange.goalColumn), the vertical
    motion will use that as a target horizontal position. Otherwise,
    the cursor's own horizontal position is used. The returned
    cursor will have its goal column set to whichever column was
    used.
    */ moveVertically(start, forward, distance) {
        return $e7161f778706e663$var$skipAtoms(this, start, $e7161f778706e663$var$moveVertically(this, start, forward, distance));
    }
    /**
    Find the DOM parent node and offset (child offset if `node` is
    an element, character offset when it is a text node) at the
    given document position.
    
    Note that for positions that aren't currently in
    `visibleRanges`, the resulting DOM position isn't necessarily
    meaningful (it may just point before or after a placeholder
    element).
    */ domAtPos(pos) {
        return this.docView.domAtPos(pos);
    }
    /**
    Find the document position at the given DOM node. Can be useful
    for associating positions with DOM events. Will raise an error
    when `node` isn't part of the editor content.
    */ posAtDOM(node, offset = 0) {
        return this.docView.posFromDOM(node, offset);
    }
    posAtCoords(coords, precise = true) {
        this.readMeasured();
        return $e7161f778706e663$var$posAtCoords(this, coords, precise);
    }
    /**
    Get the screen coordinates at the given document position.
    `side` determines whether the coordinates are based on the
    element before (-1) or after (1) the position (if no element is
    available on the given side, the method will transparently use
    another strategy to get reasonable coordinates).
    */ coordsAtPos(pos, side = 1) {
        this.readMeasured();
        let rect = this.docView.coordsAt(pos, side);
        if (!rect || rect.left == rect.right) return rect;
        let line = this.state.doc.lineAt(pos), order = this.bidiSpans(line);
        let span = order[$e7161f778706e663$export$e1ed96b746bb516a.find(order, pos - line.from, -1, side)];
        return $e7161f778706e663$var$flattenRect(rect, span.dir == $e7161f778706e663$export$cacd6541cfeeb6c1.LTR == side > 0);
    }
    /**
    The default width of a character in the editor. May not
    accurately reflect the width of all characters (given variable
    width fonts or styling of invididual ranges).
    */ get defaultCharacterWidth() {
        return this.viewState.heightOracle.charWidth;
    }
    /**
    The default height of a line in the editor. May not be accurate
    for all lines.
    */ get defaultLineHeight() {
        return this.viewState.heightOracle.lineHeight;
    }
    /**
    The text direction
    ([`direction`](https://developer.mozilla.org/en-US/docs/Web/CSS/direction)
    CSS property) of the editor's content element.
    */ get textDirection() {
        return this.viewState.defaultTextDirection;
    }
    /**
    Find the text direction of the block at the given position, as
    assigned by CSS. If
    [`perLineTextDirection`](https://codemirror.net/6/docs/ref/#view.EditorView^perLineTextDirection)
    isn't enabled, or the given position is outside of the viewport,
    this will always return the same as
    [`textDirection`](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection). Note that
    this may trigger a DOM layout.
    */ textDirectionAt(pos) {
        let perLine = this.state.facet($e7161f778706e663$var$perLineTextDirection);
        if (!perLine || pos < this.viewport.from || pos > this.viewport.to) return this.textDirection;
        this.readMeasured();
        return this.docView.textDirectionAt(pos);
    }
    /**
    Whether this editor [wraps lines](https://codemirror.net/6/docs/ref/#view.EditorView.lineWrapping)
    (as determined by the
    [`white-space`](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space)
    CSS property of its content element).
    */ get lineWrapping() {
        return this.viewState.heightOracle.lineWrapping;
    }
    /**
    Returns the bidirectional text structure of the given line
    (which should be in the current document) as an array of span
    objects. The order of these spans matches the [text
    direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection)—if that is
    left-to-right, the leftmost spans come first, otherwise the
    rightmost spans come first.
    */ bidiSpans(line) {
        if (line.length > $e7161f778706e663$var$MaxBidiLine) return $e7161f778706e663$var$trivialOrder(line.length);
        let dir = this.textDirectionAt(line.from);
        for (let entry of this.bidiCache)if (entry.from == line.from && entry.dir == dir) return entry.order;
        let order = $e7161f778706e663$var$computeOrder(line.text, dir);
        this.bidiCache.push(new $e7161f778706e663$var$CachedOrder(line.from, line.to, dir, order));
        return order;
    }
    /**
    Check whether the editor has focus.
    */ get hasFocus() {
        var _a;
        // Safari return false for hasFocus when the context menu is open
        // or closing, which leads us to ignore selection changes from the
        // context menu because it looks like the editor isn't focused.
        // This kludges around that.
        return (this.dom.ownerDocument.hasFocus() || $e7161f778706e663$var$browser.safari && ((_a = this.inputState) === null || _a === void 0 ? void 0 : _a.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
    }
    /**
    Put focus on the editor.
    */ focus() {
        this.observer.ignore(()=>{
            $e7161f778706e663$var$focusPreventScroll(this.contentDOM);
            this.docView.updateSelection();
        });
    }
    /**
    Update the [root](https://codemirror.net/6/docs/ref/##view.EditorViewConfig.root) in which the editor lives. This is only
    necessary when moving the editor's existing DOM to a new window or shadow root.
    */ setRoot(root) {
        if (this._root != root) {
            this._root = root;
            this.observer.setWindow((root.nodeType == 9 ? root : root.ownerDocument).defaultView || window);
            this.mountStyles();
        }
    }
    /**
    Clean up this editor view, removing its element from the
    document, unregistering event handlers, and notifying
    plugins. The view instance can no longer be used after
    calling this.
    */ destroy() {
        for (let plugin of this.plugins)plugin.destroy(this);
        this.plugins = [];
        this.inputState.destroy();
        this.dom.remove();
        this.observer.destroy();
        if (this.measureScheduled > -1) this.win.cancelAnimationFrame(this.measureScheduled);
        this.destroyed = true;
    }
    /**
    Returns an effect that can be
    [added](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) to a transaction to
    cause it to scroll the given position or range into view.
    */ static scrollIntoView(pos, options = {}) {
        return $e7161f778706e663$var$scrollIntoView.of(new $e7161f778706e663$var$ScrollTarget(typeof pos == "number" ? (0, $hB7kI.EditorSelection).cursor(pos) : pos, options.y, options.x, options.yMargin, options.xMargin));
    }
    /**
    Returns an extension that can be used to add DOM event handlers.
    The value should be an object mapping event names to handler
    functions. For any given event, such functions are ordered by
    extension precedence, and the first handler to return true will
    be assumed to have handled that event, and no other handlers or
    built-in behavior will be activated for it. These are registered
    on the [content element](https://codemirror.net/6/docs/ref/#view.EditorView.contentDOM), except
    for `scroll` handlers, which will be called any time the
    editor's [scroll element](https://codemirror.net/6/docs/ref/#view.EditorView.scrollDOM) or one of
    its parent nodes is scrolled.
    */ static domEventHandlers(handlers) {
        return $e7161f778706e663$export$44d5eccfd62adda7.define(()=>({}), {
            eventHandlers: handlers
        });
    }
    /**
    Create a theme extension. The first argument can be a
    [`style-mod`](https://github.com/marijnh/style-mod#documentation)
    style spec providing the styles for the theme. These will be
    prefixed with a generated class for the style.
    
    Because the selectors will be prefixed with a scope class, rule
    that directly match the editor's [wrapper
    element](https://codemirror.net/6/docs/ref/#view.EditorView.dom)—to which the scope class will be
    added—need to be explicitly differentiated by adding an `&` to
    the selector for that element—for example
    `&.cm-focused`.
    
    When `dark` is set to true, the theme will be marked as dark,
    which will cause the `&dark` rules from [base
    themes](https://codemirror.net/6/docs/ref/#view.EditorView^baseTheme) to be used (as opposed to
    `&light` when a light theme is active).
    */ static theme(spec, options) {
        let prefix = (0, $luNHI.StyleModule).newName();
        let result = [
            $e7161f778706e663$var$theme.of(prefix),
            $e7161f778706e663$var$styleModule.of($e7161f778706e663$var$buildTheme(`.${prefix}`, spec))
        ];
        if (options && options.dark) result.push($e7161f778706e663$var$darkTheme.of(true));
        return result;
    }
    /**
    Create an extension that adds styles to the base theme. Like
    with [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme), use `&` to indicate the
    place of the editor wrapper element when directly targeting
    that. You can also use `&dark` or `&light` instead to only
    target editors with a dark or light theme.
    */ static baseTheme(spec) {
        return (0, $hB7kI.Prec).lowest($e7161f778706e663$var$styleModule.of($e7161f778706e663$var$buildTheme("." + $e7161f778706e663$var$baseThemeID, spec, $e7161f778706e663$var$lightDarkIDs)));
    }
    /**
    Retrieve an editor view instance from the view's DOM
    representation.
    */ static findFromDOM(dom) {
        var _a;
        let content = dom.querySelector(".cm-content");
        let cView = content && $e7161f778706e663$var$ContentView.get(content) || $e7161f778706e663$var$ContentView.get(dom);
        return ((_a = cView === null || cView === void 0 ? void 0 : cView.rootView) === null || _a === void 0 ? void 0 : _a.view) || null;
    }
}
/**
Facet to add a [style
module](https://github.com/marijnh/style-mod#documentation) to
an editor view. The view will ensure that the module is
mounted in its [document
root](https://codemirror.net/6/docs/ref/#view.EditorView.constructor^config.root).
*/ $e7161f778706e663$export$eece2fccabbb77c5.styleModule = $e7161f778706e663$var$styleModule;
/**
An input handler can override the way changes to the editable
DOM content are handled. Handlers are passed the document
positions between which the change was found, and the new
content. When one returns true, no further input handlers are
called and the default behavior is prevented.
*/ $e7161f778706e663$export$eece2fccabbb77c5.inputHandler = $e7161f778706e663$var$inputHandler;
/**
This facet can be used to provide functions that create effects
to be dispatched when the editor's focus state changes.
*/ $e7161f778706e663$export$eece2fccabbb77c5.focusChangeEffect = $e7161f778706e663$var$focusChangeEffect;
/**
By default, the editor assumes all its content has the same
[text direction](https://codemirror.net/6/docs/ref/#view.Direction). Configure this with a `true`
value to make it read the text direction of every (rendered)
line separately.
*/ $e7161f778706e663$export$eece2fccabbb77c5.perLineTextDirection = $e7161f778706e663$var$perLineTextDirection;
/**
Allows you to provide a function that should be called when the
library catches an exception from an extension (mostly from view
plugins, but may be used by other extensions to route exceptions
from user-code-provided callbacks). This is mostly useful for
debugging and logging. See [`logException`](https://codemirror.net/6/docs/ref/#view.logException).
*/ $e7161f778706e663$export$eece2fccabbb77c5.exceptionSink = $e7161f778706e663$var$exceptionSink;
/**
A facet that can be used to register a function to be called
every time the view updates.
*/ $e7161f778706e663$export$eece2fccabbb77c5.updateListener = $e7161f778706e663$var$updateListener;
/**
Facet that controls whether the editor content DOM is editable.
When its highest-precedence value is `false`, the element will
not have its `contenteditable` attribute set. (Note that this
doesn't affect API calls that change the editor content, even
when those are bound to keys or buttons. See the
[`readOnly`](https://codemirror.net/6/docs/ref/#state.EditorState.readOnly) facet for that.)
*/ $e7161f778706e663$export$eece2fccabbb77c5.editable = $e7161f778706e663$var$editable;
/**
Allows you to influence the way mouse selection happens. The
functions in this facet will be called for a `mousedown` event
on the editor, and can return an object that overrides the way a
selection is computed from that mouse click or drag.
*/ $e7161f778706e663$export$eece2fccabbb77c5.mouseSelectionStyle = $e7161f778706e663$var$mouseSelectionStyle;
/**
Facet used to configure whether a given selection drag event
should move or copy the selection. The given predicate will be
called with the `mousedown` event, and can return `true` when
the drag should move the content.
*/ $e7161f778706e663$export$eece2fccabbb77c5.dragMovesSelection = $e7161f778706e663$var$dragMovesSelection$1;
/**
Facet used to configure whether a given selecting click adds a
new range to the existing selection or replaces it entirely. The
default behavior is to check `event.metaKey` on macOS, and
`event.ctrlKey` elsewhere.
*/ $e7161f778706e663$export$eece2fccabbb77c5.clickAddsSelectionRange = $e7161f778706e663$var$clickAddsSelectionRange;
/**
A facet that determines which [decorations](https://codemirror.net/6/docs/ref/#view.Decoration)
are shown in the view. Decorations can be provided in two
ways—directly, or via a function that takes an editor view.

Only decoration sets provided directly are allowed to influence
the editor's vertical layout structure. The ones provided as
functions are called _after_ the new viewport has been computed,
and thus **must not** introduce block widgets or replacing
decorations that cover line breaks.

If you want decorated ranges to behave like atomic units for
cursor motion and deletion purposes, also provide the range set
containing the decorations to
[`EditorView.atomicRanges`](https://codemirror.net/6/docs/ref/#view.EditorView^atomicRanges).
*/ $e7161f778706e663$export$eece2fccabbb77c5.decorations = $e7161f778706e663$var$decorations;
/**
Used to provide ranges that should be treated as atoms as far as
cursor motion is concerned. This causes methods like
[`moveByChar`](https://codemirror.net/6/docs/ref/#view.EditorView.moveByChar) and
[`moveVertically`](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) (and the
commands built on top of them) to skip across such regions when
a selection endpoint would enter them. This does _not_ prevent
direct programmatic [selection
updates](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) from moving into such
regions.
*/ $e7161f778706e663$export$eece2fccabbb77c5.atomicRanges = $e7161f778706e663$var$atomicRanges;
/**
Facet that allows extensions to provide additional scroll
margins (space around the sides of the scrolling element that
should be considered invisible). This can be useful when the
plugin introduces elements that cover part of that element (for
example a horizontally fixed gutter).
*/ $e7161f778706e663$export$eece2fccabbb77c5.scrollMargins = $e7161f778706e663$var$scrollMargins;
/**
This facet records whether a dark theme is active. The extension
returned by [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme) automatically
includes an instance of this when the `dark` option is set to
true.
*/ $e7161f778706e663$export$eece2fccabbb77c5.darkTheme = $e7161f778706e663$var$darkTheme;
/**
Facet that provides additional DOM attributes for the editor's
editable DOM element.
*/ $e7161f778706e663$export$eece2fccabbb77c5.contentAttributes = $e7161f778706e663$var$contentAttributes;
/**
Facet that provides DOM attributes for the editor's outer
element.
*/ $e7161f778706e663$export$eece2fccabbb77c5.editorAttributes = $e7161f778706e663$var$editorAttributes;
/**
An extension that enables line wrapping in the editor (by
setting CSS `white-space` to `pre-wrap` in the content).
*/ $e7161f778706e663$export$eece2fccabbb77c5.lineWrapping = /*@__PURE__*/ $e7161f778706e663$export$eece2fccabbb77c5.contentAttributes.of({
    "class": "cm-lineWrapping"
});
/**
State effect used to include screen reader announcements in a
transaction. These will be added to the DOM in a visually hidden
element with `aria-live="polite"` set, and should be used to
describe effects that are visually obvious but may not be
noticed by screen reader users (such as moving to the next
search match).
*/ $e7161f778706e663$export$eece2fccabbb77c5.announce = /*@__PURE__*/ (0, $hB7kI.StateEffect).define();
// Maximum line length for which we compute accurate bidi info
const $e7161f778706e663$var$MaxBidiLine = 4096;
const $e7161f778706e663$var$BadMeasure = {};
class $e7161f778706e663$var$CachedOrder {
    constructor(from, to, dir, order){
        this.from = from;
        this.to = to;
        this.dir = dir;
        this.order = order;
    }
    static update(cache, changes) {
        if (changes.empty) return cache;
        let result = [], lastDir = cache.length ? cache[cache.length - 1].dir : $e7161f778706e663$export$cacd6541cfeeb6c1.LTR;
        for(let i = Math.max(0, cache.length - 10); i < cache.length; i++){
            let entry = cache[i];
            if (entry.dir == lastDir && !changes.touchesRange(entry.from, entry.to)) result.push(new $e7161f778706e663$var$CachedOrder(changes.mapPos(entry.from, 1), changes.mapPos(entry.to, -1), entry.dir, entry.order));
        }
        return result;
    }
}
function $e7161f778706e663$var$attrsFromFacet(view, facet, base) {
    for(let sources = view.state.facet(facet), i = sources.length - 1; i >= 0; i--){
        let source = sources[i], value = typeof source == "function" ? source(view) : source;
        if (value) $e7161f778706e663$var$combineAttrs(value, base);
    }
    return base;
}
const $e7161f778706e663$var$currentPlatform = $e7161f778706e663$var$browser.mac ? "mac" : $e7161f778706e663$var$browser.windows ? "win" : $e7161f778706e663$var$browser.linux ? "linux" : "key";
function $e7161f778706e663$var$normalizeKeyName(name, platform) {
    const parts = name.split(/-(?!$)/);
    let result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; ++i){
        const mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if (platform == "mac") meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $e7161f778706e663$var$modifiers(name, event, shift) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift !== false && event.shiftKey) name = "Shift-" + name;
    return name;
}
const $e7161f778706e663$var$handleKeyEvents = /*@__PURE__*/ (0, $hB7kI.Prec).default(/*@__PURE__*/ $e7161f778706e663$export$eece2fccabbb77c5.domEventHandlers({
    keydown (event, view) {
        return $e7161f778706e663$var$runHandlers($e7161f778706e663$var$getKeymap(view.state), event, view, "editor");
    }
}));
/**
Facet used for registering keymaps.

You can add multiple keymaps to an editor. Their priorities
determine their precedence (the ones specified early or with high
priority get checked first). When a handler has returned `true`
for a given key, no further handlers are called.
*/ const $e7161f778706e663$export$5043418e2ef368d5 = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    enables: $e7161f778706e663$var$handleKeyEvents
});
const $e7161f778706e663$var$Keymaps = /*@__PURE__*/ new WeakMap();
// This is hidden behind an indirection, rather than directly computed
// by the facet, to keep internal types out of the facet's type.
function $e7161f778706e663$var$getKeymap(state) {
    let bindings = state.facet($e7161f778706e663$export$5043418e2ef368d5);
    let map = $e7161f778706e663$var$Keymaps.get(bindings);
    if (!map) $e7161f778706e663$var$Keymaps.set(bindings, map = $e7161f778706e663$var$buildKeymap(bindings.reduce((a, b)=>a.concat(b), [])));
    return map;
}
/**
Run the key handlers registered for a given scope. The event
object should be a `"keydown"` event. Returns true if any of the
handlers handled it.
*/ function $e7161f778706e663$export$bce154f45536286e(view, event, scope) {
    return $e7161f778706e663$var$runHandlers($e7161f778706e663$var$getKeymap(view.state), event, view, scope);
}
let $e7161f778706e663$var$storedPrefix = null;
const $e7161f778706e663$var$PrefixTimeout = 4000;
function $e7161f778706e663$var$buildKeymap(bindings, platform = $e7161f778706e663$var$currentPlatform) {
    let bound = Object.create(null);
    let isPrefix = Object.create(null);
    let checkPrefix = (name, is)=>{
        let current = isPrefix[name];
        if (current == null) isPrefix[name] = is;
        else if (current != is) throw new Error("Key binding " + name + " is used both as a regular binding and as a multi-stroke prefix");
    };
    let add = (scope, key, command, preventDefault)=>{
        var _a, _b;
        let scopeObj = bound[scope] || (bound[scope] = Object.create(null));
        let parts = key.split(/ (?!$)/).map((k)=>$e7161f778706e663$var$normalizeKeyName(k, platform));
        for(let i = 1; i < parts.length; i++){
            let prefix = parts.slice(0, i).join(" ");
            checkPrefix(prefix, true);
            if (!scopeObj[prefix]) scopeObj[prefix] = {
                preventDefault: true,
                run: [
                    (view)=>{
                        let ourObj = $e7161f778706e663$var$storedPrefix = {
                            view: view,
                            prefix: prefix,
                            scope: scope
                        };
                        setTimeout(()=>{
                            if ($e7161f778706e663$var$storedPrefix == ourObj) $e7161f778706e663$var$storedPrefix = null;
                        }, $e7161f778706e663$var$PrefixTimeout);
                        return true;
                    }
                ]
            };
        }
        let full = parts.join(" ");
        checkPrefix(full, false);
        let binding = scopeObj[full] || (scopeObj[full] = {
            preventDefault: false,
            run: ((_b = (_a = scopeObj._any) === null || _a === void 0 ? void 0 : _a.run) === null || _b === void 0 ? void 0 : _b.slice()) || []
        });
        if (command) binding.run.push(command);
        if (preventDefault) binding.preventDefault = true;
    };
    for (let b of bindings){
        let scopes = b.scope ? b.scope.split(" ") : [
            "editor"
        ];
        if (b.any) for (let scope of scopes){
            let scopeObj = bound[scope] || (bound[scope] = Object.create(null));
            if (!scopeObj._any) scopeObj._any = {
                preventDefault: false,
                run: []
            };
            for(let key in scopeObj)scopeObj[key].run.push(b.any);
        }
        let name = b[platform] || b.key;
        if (!name) continue;
        for (let scope of scopes){
            add(scope, name, b.run, b.preventDefault);
            if (b.shift) add(scope, "Shift-" + name, b.shift, b.preventDefault);
        }
    }
    return bound;
}
function $e7161f778706e663$var$runHandlers(map, event, view, scope) {
    let name = (0, $lNHdE.keyName)(event);
    let charCode = (0, $hB7kI.codePointAt)(name, 0), isChar = (0, $hB7kI.codePointSize)(charCode) == name.length && name != " ";
    let prefix = "", fallthrough = false;
    if ($e7161f778706e663$var$storedPrefix && $e7161f778706e663$var$storedPrefix.view == view && $e7161f778706e663$var$storedPrefix.scope == scope) {
        prefix = $e7161f778706e663$var$storedPrefix.prefix + " ";
        if (fallthrough = $e7161f778706e663$var$modifierCodes.indexOf(event.keyCode) < 0) $e7161f778706e663$var$storedPrefix = null;
    }
    let ran = new Set;
    let runFor = (binding)=>{
        if (binding) {
            for (let cmd of binding.run)if (!ran.has(cmd)) {
                ran.add(cmd);
                if (cmd(view, event)) return true;
            }
            if (binding.preventDefault) fallthrough = true;
        }
        return false;
    };
    let scopeObj = map[scope], baseName, shiftName;
    if (scopeObj) {
        if (runFor(scopeObj[prefix + $e7161f778706e663$var$modifiers(name, event, !isChar)])) return true;
        if (isChar && (event.altKey || event.metaKey || event.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
        !($e7161f778706e663$var$browser.windows && event.ctrlKey && event.altKey) && (baseName = (0, $lNHdE.base)[event.keyCode]) && baseName != name) {
            if (runFor(scopeObj[prefix + $e7161f778706e663$var$modifiers(baseName, event, true)])) return true;
            else if (event.shiftKey && (shiftName = (0, $lNHdE.shift)[event.keyCode]) != name && shiftName != baseName && runFor(scopeObj[prefix + $e7161f778706e663$var$modifiers(shiftName, event, false)])) return true;
        } else if (isChar && event.shiftKey) {
            if (runFor(scopeObj[prefix + $e7161f778706e663$var$modifiers(name, event, true)])) return true;
        }
        if (runFor(scopeObj._any)) return true;
    }
    return fallthrough;
}
/**
Implementation of [`LayerMarker`](https://codemirror.net/6/docs/ref/#view.LayerMarker) that creates
a rectangle at a given set of coordinates.
*/ class $e7161f778706e663$export$9ddce7bd14f42a78 {
    /**
    Create a marker with the given class and dimensions. If `width`
    is null, the DOM element will get no width style.
    */ constructor(className, left, top, width, height){
        this.className = className;
        this.left = left;
        this.top = top;
        this.width = width;
        this.height = height;
    }
    draw() {
        let elt = document.createElement("div");
        elt.className = this.className;
        this.adjust(elt);
        return elt;
    }
    update(elt, prev) {
        if (prev.className != this.className) return false;
        this.adjust(elt);
        return true;
    }
    adjust(elt) {
        elt.style.left = this.left + "px";
        elt.style.top = this.top + "px";
        if (this.width != null) elt.style.width = this.width + "px";
        elt.style.height = this.height + "px";
    }
    eq(p) {
        return this.left == p.left && this.top == p.top && this.width == p.width && this.height == p.height && this.className == p.className;
    }
    /**
    Create a set of rectangles for the given selection range,
    assigning them theclass`className`. Will create a single
    rectangle for empty ranges, and a set of selection-style
    rectangles covering the range's content (in a bidi-aware
    way) for non-empty ones.
    */ static forRange(view, className, range) {
        if (range.empty) {
            let pos = view.coordsAtPos(range.head, range.assoc || 1);
            if (!pos) return [];
            let base = $e7161f778706e663$var$getBase(view);
            return [
                new $e7161f778706e663$export$9ddce7bd14f42a78(className, pos.left - base.left, pos.top - base.top, null, pos.bottom - pos.top)
            ];
        } else return $e7161f778706e663$var$rectanglesForRange(view, className, range);
    }
}
function $e7161f778706e663$var$getBase(view) {
    let rect = view.scrollDOM.getBoundingClientRect();
    let left = view.textDirection == $e7161f778706e663$export$cacd6541cfeeb6c1.LTR ? rect.left : rect.right - view.scrollDOM.clientWidth;
    return {
        left: left - view.scrollDOM.scrollLeft,
        top: rect.top - view.scrollDOM.scrollTop
    };
}
function $e7161f778706e663$var$wrappedLine(view, pos, inside) {
    let range = (0, $hB7kI.EditorSelection).cursor(pos);
    return {
        from: Math.max(inside.from, view.moveToLineBoundary(range, false, true).from),
        to: Math.min(inside.to, view.moveToLineBoundary(range, true, true).from),
        type: $e7161f778706e663$export$48808c686fe495c4.Text
    };
}
function $e7161f778706e663$var$rectanglesForRange(view, className, range) {
    if (range.to <= view.viewport.from || range.from >= view.viewport.to) return [];
    let from = Math.max(range.from, view.viewport.from), to = Math.min(range.to, view.viewport.to);
    let ltr = view.textDirection == $e7161f778706e663$export$cacd6541cfeeb6c1.LTR;
    let content = view.contentDOM, contentRect = content.getBoundingClientRect(), base = $e7161f778706e663$var$getBase(view);
    let lineElt = content.querySelector(".cm-line"), lineStyle = lineElt && window.getComputedStyle(lineElt);
    let leftSide = contentRect.left + (lineStyle ? parseInt(lineStyle.paddingLeft) + Math.min(0, parseInt(lineStyle.textIndent)) : 0);
    let rightSide = contentRect.right - (lineStyle ? parseInt(lineStyle.paddingRight) : 0);
    let startBlock = $e7161f778706e663$var$blockAt(view, from), endBlock = $e7161f778706e663$var$blockAt(view, to);
    let visualStart = startBlock.type == $e7161f778706e663$export$48808c686fe495c4.Text ? startBlock : null;
    let visualEnd = endBlock.type == $e7161f778706e663$export$48808c686fe495c4.Text ? endBlock : null;
    if (visualStart && (view.lineWrapping || startBlock.widgetLineBreaks)) visualStart = $e7161f778706e663$var$wrappedLine(view, from, visualStart);
    if (visualEnd && (view.lineWrapping || endBlock.widgetLineBreaks)) visualEnd = $e7161f778706e663$var$wrappedLine(view, to, visualEnd);
    if (visualStart && visualEnd && visualStart.from == visualEnd.from) return pieces(drawForLine(range.from, range.to, visualStart));
    else {
        let top = visualStart ? drawForLine(range.from, null, visualStart) : drawForWidget(startBlock, false);
        let bottom = visualEnd ? drawForLine(null, range.to, visualEnd) : drawForWidget(endBlock, true);
        let between = [];
        if ((visualStart || startBlock).to < (visualEnd || endBlock).from - (visualStart && visualEnd ? 1 : 0) || startBlock.widgetLineBreaks > 1 && top.bottom + view.defaultLineHeight / 2 < bottom.top) between.push(piece(leftSide, top.bottom, rightSide, bottom.top));
        else if (top.bottom < bottom.top && view.elementAtHeight((top.bottom + bottom.top) / 2).type == $e7161f778706e663$export$48808c686fe495c4.Text) top.bottom = bottom.top = (top.bottom + bottom.top) / 2;
        return pieces(top).concat(between).concat(pieces(bottom));
    }
    function piece(left, top, right, bottom) {
        return new $e7161f778706e663$export$9ddce7bd14f42a78(className, left - base.left, top - base.top - 0.01 /* Epsilon */ , right - left, bottom - top + 0.01 /* Epsilon */ );
    }
    function pieces({ top: top, bottom: bottom, horizontal: horizontal }) {
        let pieces = [];
        for(let i = 0; i < horizontal.length; i += 2)pieces.push(piece(horizontal[i], top, horizontal[i + 1], bottom));
        return pieces;
    }
    // Gets passed from/to in line-local positions
    function drawForLine(from, to, line) {
        let top = 1e9, bottom = -1000000000, horizontal = [];
        function addSpan(from, fromOpen, to, toOpen, dir) {
            // Passing 2/-2 is a kludge to force the view to return
            // coordinates on the proper side of block widgets, since
            // normalizing the side there, though appropriate for most
            // coordsAtPos queries, would break selection drawing.
            let fromCoords = view.coordsAtPos(from, from == line.to ? -2 : 2);
            let toCoords = view.coordsAtPos(to, to == line.from ? 2 : -2);
            if (!fromCoords || !toCoords) return;
            top = Math.min(fromCoords.top, toCoords.top, top);
            bottom = Math.max(fromCoords.bottom, toCoords.bottom, bottom);
            if (dir == $e7161f778706e663$export$cacd6541cfeeb6c1.LTR) horizontal.push(ltr && fromOpen ? leftSide : fromCoords.left, ltr && toOpen ? rightSide : toCoords.right);
            else horizontal.push(!ltr && toOpen ? leftSide : toCoords.left, !ltr && fromOpen ? rightSide : fromCoords.right);
        }
        let start = from !== null && from !== void 0 ? from : line.from, end = to !== null && to !== void 0 ? to : line.to;
        // Split the range by visible range and document line
        for (let r of view.visibleRanges)if (r.to > start && r.from < end) for(let pos = Math.max(r.from, start), endPos = Math.min(r.to, end);;){
            let docLine = view.state.doc.lineAt(pos);
            for (let span of view.bidiSpans(docLine)){
                let spanFrom = span.from + docLine.from, spanTo = span.to + docLine.from;
                if (spanFrom >= endPos) break;
                if (spanTo > pos) addSpan(Math.max(spanFrom, pos), from == null && spanFrom <= start, Math.min(spanTo, endPos), to == null && spanTo >= end, span.dir);
            }
            pos = docLine.to + 1;
            if (pos >= endPos) break;
        }
        if (horizontal.length == 0) addSpan(start, from == null, end, to == null, view.textDirection);
        return {
            top: top,
            bottom: bottom,
            horizontal: horizontal
        };
    }
    function drawForWidget(block, top) {
        let y = contentRect.top + (top ? block.top : block.bottom);
        return {
            top: y,
            bottom: y,
            horizontal: []
        };
    }
}
function $e7161f778706e663$var$sameMarker(a, b) {
    return a.constructor == b.constructor && a.eq(b);
}
class $e7161f778706e663$var$LayerView {
    constructor(view, layer){
        this.view = view;
        this.layer = layer;
        this.drawn = [];
        this.measureReq = {
            read: this.measure.bind(this),
            write: this.draw.bind(this)
        };
        this.dom = view.scrollDOM.appendChild(document.createElement("div"));
        this.dom.classList.add("cm-layer");
        if (layer.above) this.dom.classList.add("cm-layer-above");
        if (layer.class) this.dom.classList.add(layer.class);
        this.dom.setAttribute("aria-hidden", "true");
        this.setOrder(view.state);
        view.requestMeasure(this.measureReq);
        if (layer.mount) layer.mount(this.dom, view);
    }
    update(update) {
        if (update.startState.facet($e7161f778706e663$var$layerOrder) != update.state.facet($e7161f778706e663$var$layerOrder)) this.setOrder(update.state);
        if (this.layer.update(update, this.dom) || update.geometryChanged) update.view.requestMeasure(this.measureReq);
    }
    setOrder(state) {
        let pos = 0, order = state.facet($e7161f778706e663$var$layerOrder);
        while(pos < order.length && order[pos] != this.layer)pos++;
        this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - pos);
    }
    measure() {
        return this.layer.markers(this.view);
    }
    draw(markers) {
        if (markers.length != this.drawn.length || markers.some((p, i)=>!$e7161f778706e663$var$sameMarker(p, this.drawn[i]))) {
            let old = this.dom.firstChild, oldI = 0;
            for (let marker of markers)if (marker.update && old && marker.constructor && this.drawn[oldI].constructor && marker.update(old, this.drawn[oldI])) {
                old = old.nextSibling;
                oldI++;
            } else this.dom.insertBefore(marker.draw(), old);
            while(old){
                let next = old.nextSibling;
                old.remove();
                old = next;
            }
            this.drawn = markers;
        }
    }
    destroy() {
        if (this.layer.destroy) this.layer.destroy(this.dom, this.view);
        this.dom.remove();
    }
}
const $e7161f778706e663$var$layerOrder = /*@__PURE__*/ (0, $hB7kI.Facet).define();
/**
Define a layer.
*/ function $e7161f778706e663$export$50a222d9023da98b(config) {
    return [
        $e7161f778706e663$export$44d5eccfd62adda7.define((v)=>new $e7161f778706e663$var$LayerView(v, config)),
        $e7161f778706e663$var$layerOrder.of(config)
    ];
}
const $e7161f778706e663$var$CanHidePrimary = !$e7161f778706e663$var$browser.ios; // FIXME test IE
const $e7161f778706e663$var$selectionConfig = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine (configs) {
        return (0, $hB7kI.combineConfig)(configs, {
            cursorBlinkRate: 1200,
            drawRangeCursor: true
        }, {
            cursorBlinkRate: (a, b)=>Math.min(a, b),
            drawRangeCursor: (a, b)=>a || b
        });
    }
});
/**
Returns an extension that hides the browser's native selection and
cursor, replacing the selection with a background behind the text
(with the `cm-selectionBackground` class), and the
cursors with elements overlaid over the code (using
`cm-cursor-primary` and `cm-cursor-secondary`).

This allows the editor to display secondary selection ranges, and
tends to produce a type of selection more in line with that users
expect in a text editor (the native selection styling will often
leave gaps between lines and won't fill the horizontal space after
a line when the selection continues past it).

It does have a performance cost, in that it requires an extra DOM
layout cycle for many updates (the selection is drawn based on DOM
layout information that's only available after laying out the
content).
*/ function $e7161f778706e663$export$17a3d0ab3687347d(config = {}) {
    return [
        $e7161f778706e663$var$selectionConfig.of(config),
        $e7161f778706e663$var$cursorLayer,
        $e7161f778706e663$var$selectionLayer,
        $e7161f778706e663$var$hideNativeSelection,
        $e7161f778706e663$var$nativeSelectionHidden.of(true)
    ];
}
function $e7161f778706e663$var$configChanged(update) {
    return update.startState.facet($e7161f778706e663$var$selectionConfig) != update.state.facet($e7161f778706e663$var$selectionConfig);
}
const $e7161f778706e663$var$cursorLayer = /*@__PURE__*/ $e7161f778706e663$export$50a222d9023da98b({
    above: true,
    markers (view) {
        let { state: state } = view, conf = state.facet($e7161f778706e663$var$selectionConfig);
        let cursors = [];
        for (let r of state.selection.ranges){
            let prim = r == state.selection.main;
            if (r.empty ? !prim || $e7161f778706e663$var$CanHidePrimary : conf.drawRangeCursor) {
                let className = prim ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary";
                let cursor = r.empty ? r : (0, $hB7kI.EditorSelection).cursor(r.head, r.head > r.anchor ? -1 : 1);
                for (let piece of $e7161f778706e663$export$9ddce7bd14f42a78.forRange(view, className, cursor))cursors.push(piece);
            }
        }
        return cursors;
    },
    update (update, dom) {
        if (update.transactions.some((tr)=>tr.selection)) dom.style.animationName = dom.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink";
        let confChange = $e7161f778706e663$var$configChanged(update);
        if (confChange) $e7161f778706e663$var$setBlinkRate(update.state, dom);
        return update.docChanged || update.selectionSet || confChange;
    },
    mount (dom, view) {
        $e7161f778706e663$var$setBlinkRate(view.state, dom);
    },
    class: "cm-cursorLayer"
});
function $e7161f778706e663$var$setBlinkRate(state, dom) {
    dom.style.animationDuration = state.facet($e7161f778706e663$var$selectionConfig).cursorBlinkRate + "ms";
}
const $e7161f778706e663$var$selectionLayer = /*@__PURE__*/ $e7161f778706e663$export$50a222d9023da98b({
    above: false,
    markers (view) {
        return view.state.selection.ranges.map((r)=>r.empty ? [] : $e7161f778706e663$export$9ddce7bd14f42a78.forRange(view, "cm-selectionBackground", r)).reduce((a, b)=>a.concat(b));
    },
    update (update, dom) {
        return update.docChanged || update.selectionSet || update.viewportChanged || $e7161f778706e663$var$configChanged(update);
    },
    class: "cm-selectionLayer"
});
const $e7161f778706e663$var$themeSpec = {
    ".cm-line": {
        "& ::selection": {
            backgroundColor: "transparent !important"
        },
        "&::selection": {
            backgroundColor: "transparent !important"
        }
    }
};
if ($e7161f778706e663$var$CanHidePrimary) $e7161f778706e663$var$themeSpec[".cm-line"].caretColor = "transparent !important";
const $e7161f778706e663$var$hideNativeSelection = /*@__PURE__*/ (0, $hB7kI.Prec).highest(/*@__PURE__*/ $e7161f778706e663$export$eece2fccabbb77c5.theme($e7161f778706e663$var$themeSpec));
const $e7161f778706e663$var$setDropCursorPos = /*@__PURE__*/ (0, $hB7kI.StateEffect).define({
    map (pos, mapping) {
        return pos == null ? null : mapping.mapPos(pos);
    }
});
const $e7161f778706e663$var$dropCursorPos = /*@__PURE__*/ (0, $hB7kI.StateField).define({
    create () {
        return null;
    },
    update (pos, tr) {
        if (pos != null) pos = tr.changes.mapPos(pos);
        return tr.effects.reduce((pos, e)=>e.is($e7161f778706e663$var$setDropCursorPos) ? e.value : pos, pos);
    }
});
const $e7161f778706e663$var$drawDropCursor = /*@__PURE__*/ $e7161f778706e663$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.cursor = null;
        this.measureReq = {
            read: this.readPos.bind(this),
            write: this.drawCursor.bind(this)
        };
    }
    update(update) {
        var _a;
        let cursorPos = update.state.field($e7161f778706e663$var$dropCursorPos);
        if (cursorPos == null) {
            if (this.cursor != null) {
                (_a = this.cursor) === null || _a === void 0 || _a.remove();
                this.cursor = null;
            }
        } else {
            if (!this.cursor) {
                this.cursor = this.view.scrollDOM.appendChild(document.createElement("div"));
                this.cursor.className = "cm-dropCursor";
            }
            if (update.startState.field($e7161f778706e663$var$dropCursorPos) != cursorPos || update.docChanged || update.geometryChanged) this.view.requestMeasure(this.measureReq);
        }
    }
    readPos() {
        let pos = this.view.state.field($e7161f778706e663$var$dropCursorPos);
        let rect = pos != null && this.view.coordsAtPos(pos);
        if (!rect) return null;
        let outer = this.view.scrollDOM.getBoundingClientRect();
        return {
            left: rect.left - outer.left + this.view.scrollDOM.scrollLeft,
            top: rect.top - outer.top + this.view.scrollDOM.scrollTop,
            height: rect.bottom - rect.top
        };
    }
    drawCursor(pos) {
        if (this.cursor) {
            if (pos) {
                this.cursor.style.left = pos.left + "px";
                this.cursor.style.top = pos.top + "px";
                this.cursor.style.height = pos.height + "px";
            } else this.cursor.style.left = "-100000px";
        }
    }
    destroy() {
        if (this.cursor) this.cursor.remove();
    }
    setDropPos(pos) {
        if (this.view.state.field($e7161f778706e663$var$dropCursorPos) != pos) this.view.dispatch({
            effects: $e7161f778706e663$var$setDropCursorPos.of(pos)
        });
    }
}, {
    eventHandlers: {
        dragover (event) {
            this.setDropPos(this.view.posAtCoords({
                x: event.clientX,
                y: event.clientY
            }));
        },
        dragleave (event) {
            if (event.target == this.view.contentDOM || !this.view.contentDOM.contains(event.relatedTarget)) this.setDropPos(null);
        },
        dragend () {
            this.setDropPos(null);
        },
        drop () {
            this.setDropPos(null);
        }
    }
});
/**
Draws a cursor at the current drop position when something is
dragged over the editor.
*/ function $e7161f778706e663$export$b8e3092a3bfa2062() {
    return [
        $e7161f778706e663$var$dropCursorPos,
        $e7161f778706e663$var$drawDropCursor
    ];
}
function $e7161f778706e663$var$iterMatches(doc, re, from, to, f) {
    re.lastIndex = 0;
    for(let cursor = doc.iterRange(from, to), pos = from, m; !cursor.next().done; pos += cursor.value.length){
        if (!cursor.lineBreak) while(m = re.exec(cursor.value))f(pos + m.index, m);
    }
}
function $e7161f778706e663$var$matchRanges(view, maxLength) {
    let visible = view.visibleRanges;
    if (visible.length == 1 && visible[0].from == view.viewport.from && visible[0].to == view.viewport.to) return visible;
    let result = [];
    for (let { from: from, to: to } of visible){
        from = Math.max(view.state.doc.lineAt(from).from, from - maxLength);
        to = Math.min(view.state.doc.lineAt(to).to, to + maxLength);
        if (result.length && result[result.length - 1].to >= from) result[result.length - 1].to = to;
        else result.push({
            from: from,
            to: to
        });
    }
    return result;
}
/**
Helper class used to make it easier to maintain decorations on
visible code that matches a given regular expression. To be used
in a [view plugin](https://codemirror.net/6/docs/ref/#view.ViewPlugin). Instances of this object
represent a matching configuration.
*/ class $e7161f778706e663$export$9b928b0ca20b25cb {
    /**
    Create a decorator.
    */ constructor(config){
        const { regexp: regexp, decoration: decoration, decorate: decorate, boundary: boundary, maxLength: maxLength = 1000 } = config;
        if (!regexp.global) throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
        this.regexp = regexp;
        if (decorate) this.addMatch = (match, view, from, add)=>decorate(add, from, from + match[0].length, match, view);
        else if (typeof decoration == "function") this.addMatch = (match, view, from, add)=>{
            let deco = decoration(match, view, from);
            if (deco) add(from, from + match[0].length, deco);
        };
        else if (decoration) this.addMatch = (match, _view, from, add)=>add(from, from + match[0].length, decoration);
        else throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
        this.boundary = boundary;
        this.maxLength = maxLength;
    }
    /**
    Compute the full set of decorations for matches in the given
    view's viewport. You'll want to call this when initializing your
    plugin.
    */ createDeco(view) {
        let build = new (0, $hB7kI.RangeSetBuilder)(), add = build.add.bind(build);
        for (let { from: from, to: to } of $e7161f778706e663$var$matchRanges(view, this.maxLength))$e7161f778706e663$var$iterMatches(view.state.doc, this.regexp, from, to, (from, m)=>this.addMatch(m, view, from, add));
        return build.finish();
    }
    /**
    Update a set of decorations for a view update. `deco` _must_ be
    the set of decorations produced by _this_ `MatchDecorator` for
    the view state before the update.
    */ updateDeco(update, deco) {
        let changeFrom = 1e9, changeTo = -1;
        if (update.docChanged) update.changes.iterChanges((_f, _t, from, to)=>{
            if (to > update.view.viewport.from && from < update.view.viewport.to) {
                changeFrom = Math.min(from, changeFrom);
                changeTo = Math.max(to, changeTo);
            }
        });
        if (update.viewportChanged || changeTo - changeFrom > 1000) return this.createDeco(update.view);
        if (changeTo > -1) return this.updateRange(update.view, deco.map(update.changes), changeFrom, changeTo);
        return deco;
    }
    updateRange(view, deco, updateFrom, updateTo) {
        for (let r of view.visibleRanges){
            let from = Math.max(r.from, updateFrom), to = Math.min(r.to, updateTo);
            if (to > from) {
                let fromLine = view.state.doc.lineAt(from), toLine = fromLine.to < to ? view.state.doc.lineAt(to) : fromLine;
                let start = Math.max(r.from, fromLine.from), end = Math.min(r.to, toLine.to);
                if (this.boundary) {
                    for(; from > fromLine.from; from--)if (this.boundary.test(fromLine.text[from - 1 - fromLine.from])) {
                        start = from;
                        break;
                    }
                    for(; to < toLine.to; to++)if (this.boundary.test(toLine.text[to - toLine.from])) {
                        end = to;
                        break;
                    }
                }
                let ranges = [], m;
                let add = (from, to, deco)=>ranges.push(deco.range(from, to));
                if (fromLine == toLine) {
                    this.regexp.lastIndex = start - fromLine.from;
                    while((m = this.regexp.exec(fromLine.text)) && m.index < end - fromLine.from)this.addMatch(m, view, m.index + fromLine.from, add);
                } else $e7161f778706e663$var$iterMatches(view.state.doc, this.regexp, start, end, (from, m)=>this.addMatch(m, view, from, add));
                deco = deco.update({
                    filterFrom: start,
                    filterTo: end,
                    filter: (from, to)=>from < start || to > end,
                    add: ranges
                });
            }
        }
        return deco;
    }
}
const $e7161f778706e663$var$UnicodeRegexpSupport = /x/.unicode != null ? "gu" : "g";
const $e7161f778706e663$var$Specials = /*@__PURE__*/ new RegExp("[\x00-\b\n-\x1f\x7f-\x9f\xad؜​‎‏\u2028\u2029‭‮⁦⁧⁩\uFEFF￹-￼]", $e7161f778706e663$var$UnicodeRegexpSupport);
const $e7161f778706e663$var$Names = {
    0: "null",
    7: "bell",
    8: "backspace",
    10: "newline",
    11: "vertical tab",
    13: "carriage return",
    27: "escape",
    8203: "zero width space",
    8204: "zero width non-joiner",
    8205: "zero width joiner",
    8206: "left-to-right mark",
    8207: "right-to-left mark",
    8232: "line separator",
    8237: "left-to-right override",
    8238: "right-to-left override",
    8294: "left-to-right isolate",
    8295: "right-to-left isolate",
    8297: "pop directional isolate",
    8233: "paragraph separator",
    65279: "zero width no-break space",
    65532: "object replacement"
};
let $e7161f778706e663$var$_supportsTabSize = null;
function $e7161f778706e663$var$supportsTabSize() {
    var _a;
    if ($e7161f778706e663$var$_supportsTabSize == null && typeof document != "undefined" && document.body) {
        let styles = document.body.style;
        $e7161f778706e663$var$_supportsTabSize = ((_a = styles.tabSize) !== null && _a !== void 0 ? _a : styles.MozTabSize) != null;
    }
    return $e7161f778706e663$var$_supportsTabSize || false;
}
const $e7161f778706e663$var$specialCharConfig = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine (configs) {
        let config = (0, $hB7kI.combineConfig)(configs, {
            render: null,
            specialChars: $e7161f778706e663$var$Specials,
            addSpecialChars: null
        });
        if (config.replaceTabs = !$e7161f778706e663$var$supportsTabSize()) config.specialChars = new RegExp("	|" + config.specialChars.source, $e7161f778706e663$var$UnicodeRegexpSupport);
        if (config.addSpecialChars) config.specialChars = new RegExp(config.specialChars.source + "|" + config.addSpecialChars.source, $e7161f778706e663$var$UnicodeRegexpSupport);
        return config;
    }
});
/**
Returns an extension that installs highlighting of special
characters.
*/ function $e7161f778706e663$export$76dc0899547f659c(/**
Configuration options.
*/ config = {}) {
    return [
        $e7161f778706e663$var$specialCharConfig.of(config),
        $e7161f778706e663$var$specialCharPlugin()
    ];
}
let $e7161f778706e663$var$_plugin = null;
function $e7161f778706e663$var$specialCharPlugin() {
    return $e7161f778706e663$var$_plugin || ($e7161f778706e663$var$_plugin = $e7161f778706e663$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.decorations = $e7161f778706e663$export$10e30b733df217ea.none;
            this.decorationCache = Object.create(null);
            this.decorator = this.makeDecorator(view.state.facet($e7161f778706e663$var$specialCharConfig));
            this.decorations = this.decorator.createDeco(view);
        }
        makeDecorator(conf) {
            return new $e7161f778706e663$export$9b928b0ca20b25cb({
                regexp: conf.specialChars,
                decoration: (m, view, pos)=>{
                    let { doc: doc } = view.state;
                    let code = (0, $hB7kI.codePointAt)(m[0], 0);
                    if (code == 9) {
                        let line = doc.lineAt(pos);
                        let size = view.state.tabSize, col = (0, $hB7kI.countColumn)(line.text, size, pos - line.from);
                        return $e7161f778706e663$export$10e30b733df217ea.replace({
                            widget: new $e7161f778706e663$var$TabWidget((size - col % size) * this.view.defaultCharacterWidth)
                        });
                    }
                    return this.decorationCache[code] || (this.decorationCache[code] = $e7161f778706e663$export$10e30b733df217ea.replace({
                        widget: new $e7161f778706e663$var$SpecialCharWidget(conf, code)
                    }));
                },
                boundary: conf.replaceTabs ? undefined : /[^]/
            });
        }
        update(update) {
            let conf = update.state.facet($e7161f778706e663$var$specialCharConfig);
            if (update.startState.facet($e7161f778706e663$var$specialCharConfig) != conf) {
                this.decorator = this.makeDecorator(conf);
                this.decorations = this.decorator.createDeco(update.view);
            } else this.decorations = this.decorator.updateDeco(update, this.decorations);
        }
    }, {
        decorations: (v)=>v.decorations
    }));
}
const $e7161f778706e663$var$DefaultPlaceholder = "•";
// Assigns placeholder characters from the Control Pictures block to
// ASCII control characters
function $e7161f778706e663$var$placeholder$1(code) {
    if (code >= 32) return $e7161f778706e663$var$DefaultPlaceholder;
    if (code == 10) return "␤";
    return String.fromCharCode(9216 + code);
}
class $e7161f778706e663$var$SpecialCharWidget extends $e7161f778706e663$export$95cdd842edb044c5 {
    constructor(options, code){
        super();
        this.options = options;
        this.code = code;
    }
    eq(other) {
        return other.code == this.code;
    }
    toDOM(view) {
        let ph = $e7161f778706e663$var$placeholder$1(this.code);
        let desc = view.state.phrase("Control character") + " " + ($e7161f778706e663$var$Names[this.code] || "0x" + this.code.toString(16));
        let custom = this.options.render && this.options.render(this.code, desc, ph);
        if (custom) return custom;
        let span = document.createElement("span");
        span.textContent = ph;
        span.title = desc;
        span.setAttribute("aria-label", desc);
        span.className = "cm-specialChar";
        return span;
    }
    ignoreEvent() {
        return false;
    }
}
class $e7161f778706e663$var$TabWidget extends $e7161f778706e663$export$95cdd842edb044c5 {
    constructor(width){
        super();
        this.width = width;
    }
    eq(other) {
        return other.width == this.width;
    }
    toDOM() {
        let span = document.createElement("span");
        span.textContent = "	";
        span.className = "cm-tab";
        span.style.width = this.width + "px";
        return span;
    }
    ignoreEvent() {
        return false;
    }
}
const $e7161f778706e663$var$plugin = /*@__PURE__*/ $e7161f778706e663$export$44d5eccfd62adda7.fromClass(class {
    constructor(){
        this.height = 1000;
        this.attrs = {
            style: "padding-bottom: 1000px"
        };
    }
    update(update) {
        let { view: view } = update;
        let height = view.viewState.editorHeight - view.defaultLineHeight - view.documentPadding.top - 0.5;
        if (height >= 0 && height != this.height) {
            this.height = height;
            this.attrs = {
                style: `padding-bottom: ${height}px`
            };
        }
    }
});
/**
Returns an extension that makes sure the content has a bottom
margin equivalent to the height of the editor, minus one line
height, so that every line in the document can be scrolled to the
top of the editor.

This is only meaningful when the editor is scrollable, and should
not be enabled in editors that take the size of their content.
*/ function $e7161f778706e663$export$1f905ef5d6deb4f() {
    return [
        $e7161f778706e663$var$plugin,
        $e7161f778706e663$var$contentAttributes.of((view)=>{
            var _a;
            return ((_a = view.plugin($e7161f778706e663$var$plugin)) === null || _a === void 0 ? void 0 : _a.attrs) || null;
        })
    ];
}
/**
Mark lines that have a cursor on them with the `"cm-activeLine"`
DOM class.
*/ function $e7161f778706e663$export$1a7e096bee9035c() {
    return $e7161f778706e663$var$activeLineHighlighter;
}
const $e7161f778706e663$var$lineDeco = /*@__PURE__*/ $e7161f778706e663$export$10e30b733df217ea.line({
    class: "cm-activeLine"
});
const $e7161f778706e663$var$activeLineHighlighter = /*@__PURE__*/ $e7161f778706e663$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.decorations = this.getDeco(view);
    }
    update(update) {
        if (update.docChanged || update.selectionSet) this.decorations = this.getDeco(update.view);
    }
    getDeco(view) {
        let lastLineStart = -1, deco = [];
        for (let r of view.state.selection.ranges){
            let line = view.lineBlockAt(r.head);
            if (line.from > lastLineStart) {
                deco.push($e7161f778706e663$var$lineDeco.range(line.from));
                lastLineStart = line.from;
            }
        }
        return $e7161f778706e663$export$10e30b733df217ea.set(deco);
    }
}, {
    decorations: (v)=>v.decorations
});
class $e7161f778706e663$var$Placeholder extends $e7161f778706e663$export$95cdd842edb044c5 {
    constructor(content){
        super();
        this.content = content;
    }
    toDOM() {
        let wrap = document.createElement("span");
        wrap.className = "cm-placeholder";
        wrap.style.pointerEvents = "none";
        wrap.appendChild(typeof this.content == "string" ? document.createTextNode(this.content) : this.content);
        if (typeof this.content == "string") wrap.setAttribute("aria-label", "placeholder " + this.content);
        else wrap.setAttribute("aria-hidden", "true");
        return wrap;
    }
    coordsAt(dom) {
        let rects = dom.firstChild ? $e7161f778706e663$var$clientRectsFor(dom.firstChild) : [];
        if (!rects.length) return null;
        let style = window.getComputedStyle(dom.parentNode);
        let rect = $e7161f778706e663$var$flattenRect(rects[0], style.direction != "rtl");
        let lineHeight = parseInt(style.lineHeight);
        if (rect.bottom - rect.top > lineHeight * 1.5) return {
            left: rect.left,
            right: rect.right,
            top: rect.top,
            bottom: rect.top + lineHeight
        };
        return rect;
    }
    ignoreEvent() {
        return false;
    }
}
/**
Extension that enables a placeholder—a piece of example content
to show when the editor is empty.
*/ function $e7161f778706e663$export$c7187bbd1a7a9244(content) {
    return $e7161f778706e663$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.placeholder = $e7161f778706e663$export$10e30b733df217ea.set([
                $e7161f778706e663$export$10e30b733df217ea.widget({
                    widget: new $e7161f778706e663$var$Placeholder(content),
                    side: 1
                }).range(0)
            ]);
        }
        get decorations() {
            return this.view.state.doc.length ? $e7161f778706e663$export$10e30b733df217ea.none : this.placeholder;
        }
    }, {
        decorations: (v)=>v.decorations
    });
}
// Don't compute precise column positions for line offsets above this
// (since it could get expensive). Assume offset==column for them.
const $e7161f778706e663$var$MaxOff = 2000;
function $e7161f778706e663$var$rectangleFor(state, a, b) {
    let startLine = Math.min(a.line, b.line), endLine = Math.max(a.line, b.line);
    let ranges = [];
    if (a.off > $e7161f778706e663$var$MaxOff || b.off > $e7161f778706e663$var$MaxOff || a.col < 0 || b.col < 0) {
        let startOff = Math.min(a.off, b.off), endOff = Math.max(a.off, b.off);
        for(let i = startLine; i <= endLine; i++){
            let line = state.doc.line(i);
            if (line.length <= endOff) ranges.push((0, $hB7kI.EditorSelection).range(line.from + startOff, line.to + endOff));
        }
    } else {
        let startCol = Math.min(a.col, b.col), endCol = Math.max(a.col, b.col);
        for(let i = startLine; i <= endLine; i++){
            let line = state.doc.line(i);
            let start = (0, $hB7kI.findColumn)(line.text, startCol, state.tabSize, true);
            if (start < 0) ranges.push((0, $hB7kI.EditorSelection).cursor(line.to));
            else {
                let end = (0, $hB7kI.findColumn)(line.text, endCol, state.tabSize);
                ranges.push((0, $hB7kI.EditorSelection).range(line.from + start, line.from + end));
            }
        }
    }
    return ranges;
}
function $e7161f778706e663$var$absoluteColumn(view, x) {
    let ref = view.coordsAtPos(view.viewport.from);
    return ref ? Math.round(Math.abs((ref.left - x) / view.defaultCharacterWidth)) : -1;
}
function $e7161f778706e663$var$getPos(view, event) {
    let offset = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    let line = view.state.doc.lineAt(offset), off = offset - line.from;
    let col = off > $e7161f778706e663$var$MaxOff ? -1 : off == line.length ? $e7161f778706e663$var$absoluteColumn(view, event.clientX) : (0, $hB7kI.countColumn)(line.text, view.state.tabSize, offset - line.from);
    return {
        line: line.number,
        col: col,
        off: off
    };
}
function $e7161f778706e663$var$rectangleSelectionStyle(view, event) {
    let start = $e7161f778706e663$var$getPos(view, event), startSel = view.state.selection;
    if (!start) return null;
    return {
        update (update) {
            if (update.docChanged) {
                let newStart = update.changes.mapPos(update.startState.doc.line(start.line).from);
                let newLine = update.state.doc.lineAt(newStart);
                start = {
                    line: newLine.number,
                    col: start.col,
                    off: Math.min(start.off, newLine.length)
                };
                startSel = startSel.map(update.changes);
            }
        },
        get (event, _extend, multiple) {
            let cur = $e7161f778706e663$var$getPos(view, event);
            if (!cur) return startSel;
            let ranges = $e7161f778706e663$var$rectangleFor(view.state, start, cur);
            if (!ranges.length) return startSel;
            if (multiple) return (0, $hB7kI.EditorSelection).create(ranges.concat(startSel.ranges));
            else return (0, $hB7kI.EditorSelection).create(ranges);
        }
    };
}
/**
Create an extension that enables rectangular selections. By
default, it will react to left mouse drag with the Alt key held
down. When such a selection occurs, the text within the rectangle
that was dragged over will be selected, as one selection
[range](https://codemirror.net/6/docs/ref/#state.SelectionRange) per line.
*/ function $e7161f778706e663$export$dd482925db1aabd3(options) {
    let filter = (options === null || options === void 0 ? void 0 : options.eventFilter) || ((e)=>e.altKey && e.button == 0);
    return $e7161f778706e663$export$eece2fccabbb77c5.mouseSelectionStyle.of((view, event)=>filter(event) ? $e7161f778706e663$var$rectangleSelectionStyle(view, event) : null);
}
const $e7161f778706e663$var$keys = {
    Alt: [
        18,
        (e)=>!!e.altKey
    ],
    Control: [
        17,
        (e)=>!!e.ctrlKey
    ],
    Shift: [
        16,
        (e)=>!!e.shiftKey
    ],
    Meta: [
        91,
        (e)=>!!e.metaKey
    ]
};
const $e7161f778706e663$var$showCrosshair = {
    style: "cursor: crosshair"
};
/**
Returns an extension that turns the pointer cursor into a
crosshair when a given modifier key, defaulting to Alt, is held
down. Can serve as a visual hint that rectangular selection is
going to happen when paired with
[`rectangularSelection`](https://codemirror.net/6/docs/ref/#view.rectangularSelection).
*/ function $e7161f778706e663$export$9b6525222ac3b7fb(options = {}) {
    let [code, getter] = $e7161f778706e663$var$keys[options.key || "Alt"];
    let plugin = $e7161f778706e663$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.isDown = false;
        }
        set(isDown) {
            if (this.isDown != isDown) {
                this.isDown = isDown;
                this.view.update([]);
            }
        }
    }, {
        eventHandlers: {
            keydown (e) {
                this.set(e.keyCode == code || getter(e));
            },
            keyup (e) {
                if (e.keyCode == code || !getter(e)) this.set(false);
            },
            mousemove (e) {
                this.set(getter(e));
            }
        }
    });
    return [
        plugin,
        $e7161f778706e663$export$eece2fccabbb77c5.contentAttributes.of((view)=>{
            var _a;
            return ((_a = view.plugin(plugin)) === null || _a === void 0 ? void 0 : _a.isDown) ? $e7161f778706e663$var$showCrosshair : null;
        })
    ];
}
const $e7161f778706e663$var$Outside = "-10000px";
class $e7161f778706e663$var$TooltipViewManager {
    constructor(view, facet, createTooltipView){
        this.facet = facet;
        this.createTooltipView = createTooltipView;
        this.input = view.state.facet(facet);
        this.tooltips = this.input.filter((t)=>t);
        this.tooltipViews = this.tooltips.map(createTooltipView);
    }
    update(update) {
        var _a;
        let input = update.state.facet(this.facet);
        let tooltips = input.filter((x)=>x);
        if (input === this.input) {
            for (let t of this.tooltipViews)if (t.update) t.update(update);
            return false;
        }
        let tooltipViews = [];
        for(let i = 0; i < tooltips.length; i++){
            let tip = tooltips[i], known = -1;
            if (!tip) continue;
            for(let i = 0; i < this.tooltips.length; i++){
                let other = this.tooltips[i];
                if (other && other.create == tip.create) known = i;
            }
            if (known < 0) tooltipViews[i] = this.createTooltipView(tip);
            else {
                let tooltipView = tooltipViews[i] = this.tooltipViews[known];
                if (tooltipView.update) tooltipView.update(update);
            }
        }
        for (let t of this.tooltipViews)if (tooltipViews.indexOf(t) < 0) {
            t.dom.remove();
            (_a = t.destroy) === null || _a === void 0 || _a.call(t);
        }
        this.input = input;
        this.tooltips = tooltips;
        this.tooltipViews = tooltipViews;
        return true;
    }
}
/**
Creates an extension that configures tooltip behavior.
*/ function $e7161f778706e663$export$1fc29293196e3bc(config = {}) {
    return $e7161f778706e663$var$tooltipConfig.of(config);
}
function $e7161f778706e663$var$windowSpace(view) {
    let { win: win } = view;
    return {
        top: 0,
        left: 0,
        bottom: win.innerHeight,
        right: win.innerWidth
    };
}
const $e7161f778706e663$var$tooltipConfig = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine: (values)=>{
        var _a, _b, _c;
        return {
            position: $e7161f778706e663$var$browser.ios ? "absolute" : ((_a = values.find((conf)=>conf.position)) === null || _a === void 0 ? void 0 : _a.position) || "fixed",
            parent: ((_b = values.find((conf)=>conf.parent)) === null || _b === void 0 ? void 0 : _b.parent) || null,
            tooltipSpace: ((_c = values.find((conf)=>conf.tooltipSpace)) === null || _c === void 0 ? void 0 : _c.tooltipSpace) || $e7161f778706e663$var$windowSpace
        };
    }
});
const $e7161f778706e663$var$knownHeight = /*@__PURE__*/ new WeakMap();
const $e7161f778706e663$var$tooltipPlugin = /*@__PURE__*/ $e7161f778706e663$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.inView = true;
        this.lastTransaction = 0;
        this.measureTimeout = -1;
        let config = view.state.facet($e7161f778706e663$var$tooltipConfig);
        this.position = config.position;
        this.parent = config.parent;
        this.classes = view.themeClasses;
        this.createContainer();
        this.measureReq = {
            read: this.readMeasure.bind(this),
            write: this.writeMeasure.bind(this),
            key: this
        };
        this.manager = new $e7161f778706e663$var$TooltipViewManager(view, $e7161f778706e663$export$dba11b50e1aa3c12, (t)=>this.createTooltip(t));
        this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((entries)=>{
            if (Date.now() > this.lastTransaction - 50 && entries.length > 0 && entries[entries.length - 1].intersectionRatio < 1) this.measureSoon();
        }, {
            threshold: [
                1
            ]
        }) : null;
        this.observeIntersection();
        view.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this));
        this.maybeMeasure();
    }
    createContainer() {
        if (this.parent) {
            this.container = document.createElement("div");
            this.container.style.position = "relative";
            this.container.className = this.view.themeClasses;
            this.parent.appendChild(this.container);
        } else this.container = this.view.dom;
    }
    observeIntersection() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            for (let tooltip of this.manager.tooltipViews)this.intersectionObserver.observe(tooltip.dom);
        }
    }
    measureSoon() {
        if (this.measureTimeout < 0) this.measureTimeout = setTimeout(()=>{
            this.measureTimeout = -1;
            this.maybeMeasure();
        }, 50);
    }
    update(update) {
        if (update.transactions.length) this.lastTransaction = Date.now();
        let updated = this.manager.update(update);
        if (updated) this.observeIntersection();
        let shouldMeasure = updated || update.geometryChanged;
        let newConfig = update.state.facet($e7161f778706e663$var$tooltipConfig);
        if (newConfig.position != this.position) {
            this.position = newConfig.position;
            for (let t of this.manager.tooltipViews)t.dom.style.position = this.position;
            shouldMeasure = true;
        }
        if (newConfig.parent != this.parent) {
            if (this.parent) this.container.remove();
            this.parent = newConfig.parent;
            this.createContainer();
            for (let t of this.manager.tooltipViews)this.container.appendChild(t.dom);
            shouldMeasure = true;
        } else if (this.parent && this.view.themeClasses != this.classes) this.classes = this.container.className = this.view.themeClasses;
        if (shouldMeasure) this.maybeMeasure();
    }
    createTooltip(tooltip) {
        let tooltipView = tooltip.create(this.view);
        tooltipView.dom.classList.add("cm-tooltip");
        if (tooltip.arrow && !tooltipView.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
            let arrow = document.createElement("div");
            arrow.className = "cm-tooltip-arrow";
            tooltipView.dom.appendChild(arrow);
        }
        tooltipView.dom.style.position = this.position;
        tooltipView.dom.style.top = $e7161f778706e663$var$Outside;
        this.container.appendChild(tooltipView.dom);
        if (tooltipView.mount) tooltipView.mount(this.view);
        return tooltipView;
    }
    destroy() {
        var _a, _b;
        this.view.win.removeEventListener("resize", this.measureSoon);
        for (let tooltipView of this.manager.tooltipViews){
            tooltipView.dom.remove();
            (_a = tooltipView.destroy) === null || _a === void 0 || _a.call(tooltipView);
        }
        (_b = this.intersectionObserver) === null || _b === void 0 || _b.disconnect();
        clearTimeout(this.measureTimeout);
    }
    readMeasure() {
        let editor = this.view.dom.getBoundingClientRect();
        return {
            editor: editor,
            parent: this.parent ? this.container.getBoundingClientRect() : editor,
            pos: this.manager.tooltips.map((t, i)=>{
                let tv = this.manager.tooltipViews[i];
                return tv.getCoords ? tv.getCoords(t.pos) : this.view.coordsAtPos(t.pos);
            }),
            size: this.manager.tooltipViews.map(({ dom: dom })=>dom.getBoundingClientRect()),
            space: this.view.state.facet($e7161f778706e663$var$tooltipConfig).tooltipSpace(this.view)
        };
    }
    writeMeasure(measured) {
        var _a;
        let { editor: editor, space: space } = measured;
        let others = [];
        for(let i = 0; i < this.manager.tooltips.length; i++){
            let tooltip = this.manager.tooltips[i], tView = this.manager.tooltipViews[i], { dom: dom } = tView;
            let pos = measured.pos[i], size = measured.size[i];
            // Hide tooltips that are outside of the editor.
            if (!pos || pos.bottom <= Math.max(editor.top, space.top) || pos.top >= Math.min(editor.bottom, space.bottom) || pos.right < Math.max(editor.left, space.left) - .1 || pos.left > Math.min(editor.right, space.right) + .1) {
                dom.style.top = $e7161f778706e663$var$Outside;
                continue;
            }
            let arrow = tooltip.arrow ? tView.dom.querySelector(".cm-tooltip-arrow") : null;
            let arrowHeight = arrow ? 7 /* Size */  : 0;
            let width = size.right - size.left, height = (_a = $e7161f778706e663$var$knownHeight.get(tView)) !== null && _a !== void 0 ? _a : size.bottom - size.top;
            let offset = tView.offset || $e7161f778706e663$var$noOffset, ltr = this.view.textDirection == $e7161f778706e663$export$cacd6541cfeeb6c1.LTR;
            let left = size.width > space.right - space.left ? ltr ? space.left : space.right - size.width : ltr ? Math.min(pos.left - (arrow ? 14 /* Offset */  : 0) + offset.x, space.right - width) : Math.max(space.left, pos.left - width + (arrow ? 14 /* Offset */  : 0) - offset.x);
            let above = !!tooltip.above;
            if (!tooltip.strictSide && (above ? pos.top - (size.bottom - size.top) - offset.y < space.top : pos.bottom + (size.bottom - size.top) + offset.y > space.bottom) && above == space.bottom - pos.bottom > pos.top - space.top) above = !above;
            let spaceVert = (above ? pos.top - space.top : space.bottom - pos.bottom) - arrowHeight;
            if (spaceVert < height && tView.resize !== false) {
                if (spaceVert < this.view.defaultLineHeight) {
                    dom.style.top = $e7161f778706e663$var$Outside;
                    continue;
                }
                $e7161f778706e663$var$knownHeight.set(tView, height);
                dom.style.height = (height = spaceVert) + "px";
            } else if (dom.style.height) dom.style.height = "";
            let top = above ? pos.top - height - arrowHeight - offset.y : pos.bottom + arrowHeight + offset.y;
            let right = left + width;
            if (tView.overlap !== true) {
                for (let r of others)if (r.left < right && r.right > left && r.top < top + height && r.bottom > top) top = above ? r.top - height - 2 - arrowHeight : r.bottom + arrowHeight + 2;
            }
            if (this.position == "absolute") {
                dom.style.top = top - measured.parent.top + "px";
                dom.style.left = left - measured.parent.left + "px";
            } else {
                dom.style.top = top + "px";
                dom.style.left = left + "px";
            }
            if (arrow) arrow.style.left = `${pos.left + (ltr ? offset.x : -offset.x) - (left + 14 /* Offset */  - 7 /* Size */ )}px`;
            if (tView.overlap !== true) others.push({
                left: left,
                top: top,
                right: right,
                bottom: top + height
            });
            dom.classList.toggle("cm-tooltip-above", above);
            dom.classList.toggle("cm-tooltip-below", !above);
            if (tView.positioned) tView.positioned(measured.space);
        }
    }
    maybeMeasure() {
        if (this.manager.tooltips.length) {
            if (this.view.inView) this.view.requestMeasure(this.measureReq);
            if (this.inView != this.view.inView) {
                this.inView = this.view.inView;
                if (!this.inView) for (let tv of this.manager.tooltipViews)tv.dom.style.top = $e7161f778706e663$var$Outside;
            }
        }
    }
}, {
    eventHandlers: {
        scroll () {
            this.maybeMeasure();
        }
    }
});
const $e7161f778706e663$var$baseTheme = /*@__PURE__*/ $e7161f778706e663$export$eece2fccabbb77c5.baseTheme({
    ".cm-tooltip": {
        zIndex: 100,
        boxSizing: "border-box"
    },
    "&light .cm-tooltip": {
        border: "1px solid #bbb",
        backgroundColor: "#f5f5f5"
    },
    "&light .cm-tooltip-section:not(:first-child)": {
        borderTop: "1px solid #bbb"
    },
    "&dark .cm-tooltip": {
        backgroundColor: "#333338",
        color: "white"
    },
    ".cm-tooltip-arrow": {
        height: `${7 /* Size */ }px`,
        width: `${14}px`,
        position: "absolute",
        zIndex: -1,
        overflow: "hidden",
        "&:before, &:after": {
            content: "''",
            position: "absolute",
            width: 0,
            height: 0,
            borderLeft: `${7 /* Size */ }px solid transparent`,
            borderRight: `${7 /* Size */ }px solid transparent`
        },
        ".cm-tooltip-above &": {
            bottom: `-${7 /* Size */ }px`,
            "&:before": {
                borderTop: `${7 /* Size */ }px solid #bbb`
            },
            "&:after": {
                borderTop: `${7 /* Size */ }px solid #f5f5f5`,
                bottom: "1px"
            }
        },
        ".cm-tooltip-below &": {
            top: `-${7 /* Size */ }px`,
            "&:before": {
                borderBottom: `${7 /* Size */ }px solid #bbb`
            },
            "&:after": {
                borderBottom: `${7 /* Size */ }px solid #f5f5f5`,
                top: "1px"
            }
        }
    },
    "&dark .cm-tooltip .cm-tooltip-arrow": {
        "&:before": {
            borderTopColor: "#333338",
            borderBottomColor: "#333338"
        },
        "&:after": {
            borderTopColor: "transparent",
            borderBottomColor: "transparent"
        }
    }
});
const $e7161f778706e663$var$noOffset = {
    x: 0,
    y: 0
};
/**
Facet to which an extension can add a value to show a tooltip.
*/ const $e7161f778706e663$export$dba11b50e1aa3c12 = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    enables: [
        $e7161f778706e663$var$tooltipPlugin,
        $e7161f778706e663$var$baseTheme
    ]
});
const $e7161f778706e663$var$showHoverTooltip = /*@__PURE__*/ (0, $hB7kI.Facet).define();
class $e7161f778706e663$var$HoverTooltipHost {
    constructor(view){
        this.view = view;
        this.mounted = false;
        this.dom = document.createElement("div");
        this.dom.classList.add("cm-tooltip-hover");
        this.manager = new $e7161f778706e663$var$TooltipViewManager(view, $e7161f778706e663$var$showHoverTooltip, (t)=>this.createHostedView(t));
    }
    // Needs to be static so that host tooltip instances always match
    static create(view) {
        return new $e7161f778706e663$var$HoverTooltipHost(view);
    }
    createHostedView(tooltip) {
        let hostedView = tooltip.create(this.view);
        hostedView.dom.classList.add("cm-tooltip-section");
        this.dom.appendChild(hostedView.dom);
        if (this.mounted && hostedView.mount) hostedView.mount(this.view);
        return hostedView;
    }
    mount(view) {
        for (let hostedView of this.manager.tooltipViews)if (hostedView.mount) hostedView.mount(view);
        this.mounted = true;
    }
    positioned(space) {
        for (let hostedView of this.manager.tooltipViews)if (hostedView.positioned) hostedView.positioned(space);
    }
    update(update) {
        this.manager.update(update);
    }
    destroy() {
        var _a;
        for (let t of this.manager.tooltipViews)(_a = t.destroy) === null || _a === void 0 || _a.call(t);
    }
}
const $e7161f778706e663$var$showHoverTooltipHost = /*@__PURE__*/ $e7161f778706e663$export$dba11b50e1aa3c12.compute([
    $e7161f778706e663$var$showHoverTooltip
], (state)=>{
    let tooltips = state.facet($e7161f778706e663$var$showHoverTooltip).filter((t)=>t);
    if (tooltips.length === 0) return null;
    return {
        pos: Math.min(...tooltips.map((t)=>t.pos)),
        end: Math.max(...tooltips.filter((t)=>t.end != null).map((t)=>t.end)),
        create: $e7161f778706e663$var$HoverTooltipHost.create,
        above: tooltips[0].above,
        arrow: tooltips.some((t)=>t.arrow)
    };
});
class $e7161f778706e663$var$HoverPlugin {
    constructor(view, source, field, setHover, hoverTime){
        this.view = view;
        this.source = source;
        this.field = field;
        this.setHover = setHover;
        this.hoverTime = hoverTime;
        this.hoverTimeout = -1;
        this.restartTimeout = -1;
        this.pending = null;
        this.lastMove = {
            x: 0,
            y: 0,
            target: view.dom,
            time: 0
        };
        this.checkHover = this.checkHover.bind(this);
        view.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this));
        view.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
    }
    update() {
        if (this.pending) {
            this.pending = null;
            clearTimeout(this.restartTimeout);
            this.restartTimeout = setTimeout(()=>this.startHover(), 20);
        }
    }
    get active() {
        return this.view.state.field(this.field);
    }
    checkHover() {
        this.hoverTimeout = -1;
        if (this.active) return;
        let hovered = Date.now() - this.lastMove.time;
        if (hovered < this.hoverTime) this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - hovered);
        else this.startHover();
    }
    startHover() {
        clearTimeout(this.restartTimeout);
        let { lastMove: lastMove } = this;
        let pos = this.view.contentDOM.contains(lastMove.target) ? this.view.posAtCoords(lastMove) : null;
        if (pos == null) return;
        let posCoords = this.view.coordsAtPos(pos);
        if (posCoords == null || lastMove.y < posCoords.top || lastMove.y > posCoords.bottom || lastMove.x < posCoords.left - this.view.defaultCharacterWidth || lastMove.x > posCoords.right + this.view.defaultCharacterWidth) return;
        let bidi = this.view.bidiSpans(this.view.state.doc.lineAt(pos)).find((s)=>s.from <= pos && s.to >= pos);
        let rtl = bidi && bidi.dir == $e7161f778706e663$export$cacd6541cfeeb6c1.RTL ? -1 : 1;
        let open = this.source(this.view, pos, lastMove.x < posCoords.left ? -rtl : rtl);
        if (open === null || open === void 0 ? void 0 : open.then) {
            let pending = this.pending = {
                pos: pos
            };
            open.then((result)=>{
                if (this.pending == pending) {
                    this.pending = null;
                    if (result) this.view.dispatch({
                        effects: this.setHover.of(result)
                    });
                }
            }, (e)=>$e7161f778706e663$export$f86b2a1a2ce291b3(this.view.state, e, "hover tooltip"));
        } else if (open) this.view.dispatch({
            effects: this.setHover.of(open)
        });
    }
    mousemove(event) {
        var _a;
        this.lastMove = {
            x: event.clientX,
            y: event.clientY,
            target: event.target,
            time: Date.now()
        };
        if (this.hoverTimeout < 0) this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime);
        let tooltip = this.active;
        if (tooltip && !$e7161f778706e663$var$isInTooltip(this.lastMove.target) || this.pending) {
            let { pos: pos } = tooltip || this.pending, end = (_a = tooltip === null || tooltip === void 0 ? void 0 : tooltip.end) !== null && _a !== void 0 ? _a : pos;
            if (pos == end ? this.view.posAtCoords(this.lastMove) != pos : !$e7161f778706e663$var$isOverRange(this.view, pos, end, event.clientX, event.clientY, 6 /* MaxDist */ )) {
                this.view.dispatch({
                    effects: this.setHover.of(null)
                });
                this.pending = null;
            }
        }
    }
    mouseleave(e) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = -1;
        if (this.active && !$e7161f778706e663$var$isInTooltip(e.relatedTarget)) this.view.dispatch({
            effects: this.setHover.of(null)
        });
    }
    destroy() {
        clearTimeout(this.hoverTimeout);
        this.view.dom.removeEventListener("mouseleave", this.mouseleave);
        this.view.dom.removeEventListener("mousemove", this.mousemove);
    }
}
function $e7161f778706e663$var$isInTooltip(elt) {
    for(let cur = elt; cur; cur = cur.parentNode)if (cur.nodeType == 1 && cur.classList.contains("cm-tooltip")) return true;
    return false;
}
function $e7161f778706e663$var$isOverRange(view, from, to, x, y, margin) {
    let range = document.createRange();
    let fromDOM = view.domAtPos(from), toDOM = view.domAtPos(to);
    range.setEnd(toDOM.node, toDOM.offset);
    range.setStart(fromDOM.node, fromDOM.offset);
    let rects = range.getClientRects();
    range.detach();
    for(let i = 0; i < rects.length; i++){
        let rect = rects[i];
        let dist = Math.max(rect.top - y, y - rect.bottom, rect.left - x, x - rect.right);
        if (dist <= margin) return true;
    }
    return false;
}
/**
Set up a hover tooltip, which shows up when the pointer hovers
over ranges of text. The callback is called when the mouse hovers
over the document text. It should, if there is a tooltip
associated with position `pos`, return the tooltip description
(either directly or in a promise). The `side` argument indicates
on which side of the position the pointer is—it will be -1 if the
pointer is before the position, 1 if after the position.

Note that all hover tooltips are hosted within a single tooltip
container element. This allows multiple tooltips over the same
range to be "merged" together without overlapping.
*/ function $e7161f778706e663$export$69f8d9e63c4aa884(source, options = {}) {
    let setHover = (0, $hB7kI.StateEffect).define();
    let hoverState = (0, $hB7kI.StateField).define({
        create () {
            return null;
        },
        update (value, tr) {
            if (value && (options.hideOnChange && (tr.docChanged || tr.selection) || options.hideOn && options.hideOn(tr, value))) return null;
            if (value && tr.docChanged) {
                let newPos = tr.changes.mapPos(value.pos, -1, (0, $hB7kI.MapMode).TrackDel);
                if (newPos == null) return null;
                let copy = Object.assign(Object.create(null), value);
                copy.pos = newPos;
                if (value.end != null) copy.end = tr.changes.mapPos(value.end);
                value = copy;
            }
            for (let effect of tr.effects){
                if (effect.is(setHover)) value = effect.value;
                if (effect.is($e7161f778706e663$var$closeHoverTooltipEffect)) value = null;
            }
            return value;
        },
        provide: (f)=>$e7161f778706e663$var$showHoverTooltip.from(f)
    });
    return [
        hoverState,
        $e7161f778706e663$export$44d5eccfd62adda7.define((view)=>new $e7161f778706e663$var$HoverPlugin(view, source, hoverState, setHover, options.hoverTime || 300 /* Time */ )),
        $e7161f778706e663$var$showHoverTooltipHost
    ];
}
/**
Get the active tooltip view for a given tooltip, if available.
*/ function $e7161f778706e663$export$46455b4476d4b8e1(view, tooltip) {
    let plugin = view.plugin($e7161f778706e663$var$tooltipPlugin);
    if (!plugin) return null;
    let found = plugin.manager.tooltips.indexOf(tooltip);
    return found < 0 ? null : plugin.manager.tooltipViews[found];
}
/**
Returns true if any hover tooltips are currently active.
*/ function $e7161f778706e663$export$7864d875805bc1b0(state) {
    return state.facet($e7161f778706e663$var$showHoverTooltip).some((x)=>x);
}
const $e7161f778706e663$var$closeHoverTooltipEffect = /*@__PURE__*/ (0, $hB7kI.StateEffect).define();
/**
Transaction effect that closes all hover tooltips.
*/ const $e7161f778706e663$export$f6974094db6525a = /*@__PURE__*/ $e7161f778706e663$var$closeHoverTooltipEffect.of(null);
/**
Tell the tooltip extension to recompute the position of the active
tooltips. This can be useful when something happens (such as a
re-positioning or CSS change affecting the editor) that could
invalidate the existing tooltip positions.
*/ function $e7161f778706e663$export$912859096d593b90(view) {
    var _a;
    (_a = view.plugin($e7161f778706e663$var$tooltipPlugin)) === null || _a === void 0 || _a.maybeMeasure();
}
const $e7161f778706e663$var$panelConfig = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine (configs) {
        let topContainer, bottomContainer;
        for (let c of configs){
            topContainer = topContainer || c.topContainer;
            bottomContainer = bottomContainer || c.bottomContainer;
        }
        return {
            topContainer: topContainer,
            bottomContainer: bottomContainer
        };
    }
});
/**
Configures the panel-managing extension.
*/ function $e7161f778706e663$export$8128819a2322681a(config) {
    return config ? [
        $e7161f778706e663$var$panelConfig.of(config)
    ] : [];
}
/**
Get the active panel created by the given constructor, if any.
This can be useful when you need access to your panels' DOM
structure.
*/ function $e7161f778706e663$export$7361ed18ff57179e(view, panel) {
    let plugin = view.plugin($e7161f778706e663$var$panelPlugin);
    let index = plugin ? plugin.specs.indexOf(panel) : -1;
    return index > -1 ? plugin.panels[index] : null;
}
const $e7161f778706e663$var$panelPlugin = /*@__PURE__*/ $e7161f778706e663$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.input = view.state.facet($e7161f778706e663$export$e89c3c9af31c1e3b);
        this.specs = this.input.filter((s)=>s);
        this.panels = this.specs.map((spec)=>spec(view));
        let conf = view.state.facet($e7161f778706e663$var$panelConfig);
        this.top = new $e7161f778706e663$var$PanelGroup(view, true, conf.topContainer);
        this.bottom = new $e7161f778706e663$var$PanelGroup(view, false, conf.bottomContainer);
        this.top.sync(this.panels.filter((p)=>p.top));
        this.bottom.sync(this.panels.filter((p)=>!p.top));
        for (let p of this.panels){
            p.dom.classList.add("cm-panel");
            if (p.mount) p.mount();
        }
    }
    update(update) {
        let conf = update.state.facet($e7161f778706e663$var$panelConfig);
        if (this.top.container != conf.topContainer) {
            this.top.sync([]);
            this.top = new $e7161f778706e663$var$PanelGroup(update.view, true, conf.topContainer);
        }
        if (this.bottom.container != conf.bottomContainer) {
            this.bottom.sync([]);
            this.bottom = new $e7161f778706e663$var$PanelGroup(update.view, false, conf.bottomContainer);
        }
        this.top.syncClasses();
        this.bottom.syncClasses();
        let input = update.state.facet($e7161f778706e663$export$e89c3c9af31c1e3b);
        if (input != this.input) {
            let specs = input.filter((x)=>x);
            let panels = [], top = [], bottom = [], mount = [];
            for (let spec of specs){
                let known = this.specs.indexOf(spec), panel;
                if (known < 0) {
                    panel = spec(update.view);
                    mount.push(panel);
                } else {
                    panel = this.panels[known];
                    if (panel.update) panel.update(update);
                }
                panels.push(panel);
                (panel.top ? top : bottom).push(panel);
            }
            this.specs = specs;
            this.panels = panels;
            this.top.sync(top);
            this.bottom.sync(bottom);
            for (let p of mount){
                p.dom.classList.add("cm-panel");
                if (p.mount) p.mount();
            }
        } else {
            for (let p of this.panels)if (p.update) p.update(update);
        }
    }
    destroy() {
        this.top.sync([]);
        this.bottom.sync([]);
    }
}, {
    provide: (plugin)=>$e7161f778706e663$export$eece2fccabbb77c5.scrollMargins.of((view)=>{
            let value = view.plugin(plugin);
            return value && {
                top: value.top.scrollMargin(),
                bottom: value.bottom.scrollMargin()
            };
        })
});
class $e7161f778706e663$var$PanelGroup {
    constructor(view, top, container){
        this.view = view;
        this.top = top;
        this.container = container;
        this.dom = undefined;
        this.classes = "";
        this.panels = [];
        this.syncClasses();
    }
    sync(panels) {
        for (let p of this.panels)if (p.destroy && panels.indexOf(p) < 0) p.destroy();
        this.panels = panels;
        this.syncDOM();
    }
    syncDOM() {
        if (this.panels.length == 0) {
            if (this.dom) {
                this.dom.remove();
                this.dom = undefined;
            }
            return;
        }
        if (!this.dom) {
            this.dom = document.createElement("div");
            this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom";
            this.dom.style[this.top ? "top" : "bottom"] = "0";
            let parent = this.container || this.view.dom;
            parent.insertBefore(this.dom, this.top ? parent.firstChild : null);
        }
        let curDOM = this.dom.firstChild;
        for (let panel of this.panels)if (panel.dom.parentNode == this.dom) {
            while(curDOM != panel.dom)curDOM = $e7161f778706e663$var$rm(curDOM);
            curDOM = curDOM.nextSibling;
        } else this.dom.insertBefore(panel.dom, curDOM);
        while(curDOM)curDOM = $e7161f778706e663$var$rm(curDOM);
    }
    scrollMargin() {
        return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
    }
    syncClasses() {
        if (!this.container || this.classes == this.view.themeClasses) return;
        for (let cls of this.classes.split(" "))if (cls) this.container.classList.remove(cls);
        for (let cls of (this.classes = this.view.themeClasses).split(" "))if (cls) this.container.classList.add(cls);
    }
}
function $e7161f778706e663$var$rm(node) {
    let next = node.nextSibling;
    node.remove();
    return next;
}
/**
Opening a panel is done by providing a constructor function for
the panel through this facet. (The panel is closed again when its
constructor is no longer provided.) Values of `null` are ignored.
*/ const $e7161f778706e663$export$e89c3c9af31c1e3b = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    enables: $e7161f778706e663$var$panelPlugin
});
/**
A gutter marker represents a bit of information attached to a line
in a specific gutter. Your own custom markers have to extend this
class.
*/ class $e7161f778706e663$export$591ab4c909549043 extends (0, $hB7kI.RangeValue) {
    /**
    @internal
    */ compare(other) {
        return this == other || this.constructor == other.constructor && this.eq(other);
    }
    /**
    Compare this marker to another marker of the same type.
    */ eq(other) {
        return false;
    }
    /**
    Called if the marker has a `toDOM` method and its representation
    was removed from a gutter.
    */ destroy(dom) {}
}
$e7161f778706e663$export$591ab4c909549043.prototype.elementClass = "";
$e7161f778706e663$export$591ab4c909549043.prototype.toDOM = undefined;
$e7161f778706e663$export$591ab4c909549043.prototype.mapMode = (0, $hB7kI.MapMode).TrackBefore;
$e7161f778706e663$export$591ab4c909549043.prototype.startSide = $e7161f778706e663$export$591ab4c909549043.prototype.endSide = -1;
$e7161f778706e663$export$591ab4c909549043.prototype.point = true;
/**
Facet used to add a class to all gutter elements for a given line.
Markers given to this facet should _only_ define an
[`elementclass`](https://codemirror.net/6/docs/ref/#view.GutterMarker.elementClass), not a
[`toDOM`](https://codemirror.net/6/docs/ref/#view.GutterMarker.toDOM) (or the marker will appear
in all gutters for the line).
*/ const $e7161f778706e663$export$113bd64f27ac1172 = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $e7161f778706e663$var$defaults = {
    class: "",
    renderEmptyElements: false,
    elementStyle: "",
    markers: ()=>(0, $hB7kI.RangeSet).empty,
    lineMarker: ()=>null,
    widgetMarker: ()=>null,
    lineMarkerChange: null,
    initialSpacer: null,
    updateSpacer: null,
    domEventHandlers: {}
};
const $e7161f778706e663$var$activeGutters = /*@__PURE__*/ (0, $hB7kI.Facet).define();
/**
Define an editor gutter. The order in which the gutters appear is
determined by their extension priority.
*/ function $e7161f778706e663$export$f2b922cb4a245974(config) {
    return [
        $e7161f778706e663$export$ec15ef01b8fbae61(),
        $e7161f778706e663$var$activeGutters.of(Object.assign(Object.assign({}, $e7161f778706e663$var$defaults), config))
    ];
}
const $e7161f778706e663$var$unfixGutters = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine: (values)=>values.some((x)=>x)
});
/**
The gutter-drawing plugin is automatically enabled when you add a
gutter, but you can use this function to explicitly configure it.

Unless `fixed` is explicitly set to `false`, the gutters are
fixed, meaning they don't scroll along with the content
horizontally (except on Internet Explorer, which doesn't support
CSS [`position:
sticky`](https://developer.mozilla.org/en-US/docs/Web/CSS/position#sticky)).
*/ function $e7161f778706e663$export$ec15ef01b8fbae61(config) {
    let result = [
        $e7161f778706e663$var$gutterView
    ];
    if (config && config.fixed === false) result.push($e7161f778706e663$var$unfixGutters.of(true));
    return result;
}
const $e7161f778706e663$var$gutterView = /*@__PURE__*/ $e7161f778706e663$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.prevViewport = view.viewport;
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutters";
        this.dom.setAttribute("aria-hidden", "true");
        this.dom.style.minHeight = this.view.contentHeight + "px";
        this.gutters = view.state.facet($e7161f778706e663$var$activeGutters).map((conf)=>new $e7161f778706e663$var$SingleGutterView(view, conf));
        for (let gutter of this.gutters)this.dom.appendChild(gutter.dom);
        this.fixed = !view.state.facet($e7161f778706e663$var$unfixGutters);
        if (this.fixed) // FIXME IE11 fallback, which doesn't support position: sticky,
        // by using position: relative + event handlers that realign the
        // gutter (or just force fixed=false on IE11?)
        this.dom.style.position = "sticky";
        this.syncGutters(false);
        view.scrollDOM.insertBefore(this.dom, view.contentDOM);
    }
    update(update) {
        if (this.updateGutters(update)) {
            // Detach during sync when the viewport changed significantly
            // (such as during scrolling), since for large updates that is
            // faster.
            let vpA = this.prevViewport, vpB = update.view.viewport;
            let vpOverlap = Math.min(vpA.to, vpB.to) - Math.max(vpA.from, vpB.from);
            this.syncGutters(vpOverlap < (vpB.to - vpB.from) * 0.8);
        }
        if (update.geometryChanged) this.dom.style.minHeight = this.view.contentHeight + "px";
        if (this.view.state.facet($e7161f778706e663$var$unfixGutters) != !this.fixed) {
            this.fixed = !this.fixed;
            this.dom.style.position = this.fixed ? "sticky" : "";
        }
        this.prevViewport = update.view.viewport;
    }
    syncGutters(detach) {
        let after = this.dom.nextSibling;
        if (detach) this.dom.remove();
        let lineClasses = (0, $hB7kI.RangeSet).iter(this.view.state.facet($e7161f778706e663$export$113bd64f27ac1172), this.view.viewport.from);
        let classSet = [];
        let contexts = this.gutters.map((gutter)=>new $e7161f778706e663$var$UpdateContext(gutter, this.view.viewport, -this.view.documentPadding.top));
        for (let line of this.view.viewportLineBlocks){
            if (classSet.length) classSet = [];
            if (Array.isArray(line.type)) {
                let first = true;
                for (let b of line.type){
                    if (b.type == $e7161f778706e663$export$48808c686fe495c4.Text && first) {
                        $e7161f778706e663$var$advanceCursor(lineClasses, classSet, b.from);
                        for (let cx of contexts)cx.line(this.view, b, classSet);
                        first = false;
                    } else if (b.widget) for (let cx of contexts)cx.widget(this.view, b);
                }
            } else if (line.type == $e7161f778706e663$export$48808c686fe495c4.Text) {
                $e7161f778706e663$var$advanceCursor(lineClasses, classSet, line.from);
                for (let cx of contexts)cx.line(this.view, line, classSet);
            }
        }
        for (let cx of contexts)cx.finish();
        if (detach) this.view.scrollDOM.insertBefore(this.dom, after);
    }
    updateGutters(update) {
        let prev = update.startState.facet($e7161f778706e663$var$activeGutters), cur = update.state.facet($e7161f778706e663$var$activeGutters);
        let change = update.docChanged || update.heightChanged || update.viewportChanged || !(0, $hB7kI.RangeSet).eq(update.startState.facet($e7161f778706e663$export$113bd64f27ac1172), update.state.facet($e7161f778706e663$export$113bd64f27ac1172), update.view.viewport.from, update.view.viewport.to);
        if (prev == cur) {
            for (let gutter of this.gutters)if (gutter.update(update)) change = true;
        } else {
            change = true;
            let gutters = [];
            for (let conf of cur){
                let known = prev.indexOf(conf);
                if (known < 0) gutters.push(new $e7161f778706e663$var$SingleGutterView(this.view, conf));
                else {
                    this.gutters[known].update(update);
                    gutters.push(this.gutters[known]);
                }
            }
            for (let g of this.gutters){
                g.dom.remove();
                if (gutters.indexOf(g) < 0) g.destroy();
            }
            for (let g of gutters)this.dom.appendChild(g.dom);
            this.gutters = gutters;
        }
        return change;
    }
    destroy() {
        for (let view of this.gutters)view.destroy();
        this.dom.remove();
    }
}, {
    provide: (plugin)=>$e7161f778706e663$export$eece2fccabbb77c5.scrollMargins.of((view)=>{
            let value = view.plugin(plugin);
            if (!value || value.gutters.length == 0 || !value.fixed) return null;
            return view.textDirection == $e7161f778706e663$export$cacd6541cfeeb6c1.LTR ? {
                left: value.dom.offsetWidth
            } : {
                right: value.dom.offsetWidth
            };
        })
});
function $e7161f778706e663$var$asArray(val) {
    return Array.isArray(val) ? val : [
        val
    ];
}
function $e7161f778706e663$var$advanceCursor(cursor, collect, pos) {
    while(cursor.value && cursor.from <= pos){
        if (cursor.from == pos) collect.push(cursor.value);
        cursor.next();
    }
}
class $e7161f778706e663$var$UpdateContext {
    constructor(gutter, viewport, height){
        this.gutter = gutter;
        this.height = height;
        this.i = 0;
        this.cursor = (0, $hB7kI.RangeSet).iter(gutter.markers, viewport.from);
    }
    addElement(view, block, markers) {
        let { gutter: gutter } = this, above = block.top - this.height;
        if (this.i == gutter.elements.length) {
            let newElt = new $e7161f778706e663$var$GutterElement(view, block.height, above, markers);
            gutter.elements.push(newElt);
            gutter.dom.appendChild(newElt.dom);
        } else gutter.elements[this.i].update(view, block.height, above, markers);
        this.height = block.bottom;
        this.i++;
    }
    line(view, line, extraMarkers) {
        let localMarkers = [];
        $e7161f778706e663$var$advanceCursor(this.cursor, localMarkers, line.from);
        if (extraMarkers.length) localMarkers = localMarkers.concat(extraMarkers);
        let forLine = this.gutter.config.lineMarker(view, line, localMarkers);
        if (forLine) localMarkers.unshift(forLine);
        let gutter = this.gutter;
        if (localMarkers.length == 0 && !gutter.config.renderEmptyElements) return;
        this.addElement(view, line, localMarkers);
    }
    widget(view, block) {
        let marker = this.gutter.config.widgetMarker(view, block.widget, block);
        if (marker) this.addElement(view, block, [
            marker
        ]);
    }
    finish() {
        let gutter = this.gutter;
        while(gutter.elements.length > this.i){
            let last = gutter.elements.pop();
            gutter.dom.removeChild(last.dom);
            last.destroy();
        }
    }
}
class $e7161f778706e663$var$SingleGutterView {
    constructor(view, config){
        this.view = view;
        this.config = config;
        this.elements = [];
        this.spacer = null;
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
        for(let prop in config.domEventHandlers)this.dom.addEventListener(prop, (event)=>{
            let target = event.target, y;
            if (target != this.dom && this.dom.contains(target)) {
                while(target.parentNode != this.dom)target = target.parentNode;
                let rect = target.getBoundingClientRect();
                y = (rect.top + rect.bottom) / 2;
            } else y = event.clientY;
            let line = view.lineBlockAtHeight(y - view.documentTop);
            if (config.domEventHandlers[prop](view, line, event)) event.preventDefault();
        });
        this.markers = $e7161f778706e663$var$asArray(config.markers(view));
        if (config.initialSpacer) {
            this.spacer = new $e7161f778706e663$var$GutterElement(view, 0, 0, [
                config.initialSpacer(view)
            ]);
            this.dom.appendChild(this.spacer.dom);
            this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none";
        }
    }
    update(update) {
        let prevMarkers = this.markers;
        this.markers = $e7161f778706e663$var$asArray(this.config.markers(update.view));
        if (this.spacer && this.config.updateSpacer) {
            let updated = this.config.updateSpacer(this.spacer.markers[0], update);
            if (updated != this.spacer.markers[0]) this.spacer.update(update.view, 0, 0, [
                updated
            ]);
        }
        let vp = update.view.viewport;
        return !(0, $hB7kI.RangeSet).eq(this.markers, prevMarkers, vp.from, vp.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(update) : false);
    }
    destroy() {
        for (let elt of this.elements)elt.destroy();
    }
}
class $e7161f778706e663$var$GutterElement {
    constructor(view, height, above, markers){
        this.height = -1;
        this.above = 0;
        this.markers = [];
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutterElement";
        this.update(view, height, above, markers);
    }
    update(view, height, above, markers) {
        if (this.height != height) this.dom.style.height = (this.height = height) + "px";
        if (this.above != above) this.dom.style.marginTop = (this.above = above) ? above + "px" : "";
        if (!$e7161f778706e663$var$sameMarkers(this.markers, markers)) this.setMarkers(view, markers);
    }
    setMarkers(view, markers) {
        let cls = "cm-gutterElement", domPos = this.dom.firstChild;
        for(let iNew = 0, iOld = 0;;){
            let skipTo = iOld, marker = iNew < markers.length ? markers[iNew++] : null, matched = false;
            if (marker) {
                let c = marker.elementClass;
                if (c) cls += " " + c;
                for(let i = iOld; i < this.markers.length; i++)if (this.markers[i].compare(marker)) {
                    skipTo = i;
                    matched = true;
                    break;
                }
            } else skipTo = this.markers.length;
            while(iOld < skipTo){
                let next = this.markers[iOld++];
                if (next.toDOM) {
                    next.destroy(domPos);
                    let after = domPos.nextSibling;
                    domPos.remove();
                    domPos = after;
                }
            }
            if (!marker) break;
            if (marker.toDOM) {
                if (matched) domPos = domPos.nextSibling;
                else this.dom.insertBefore(marker.toDOM(view), domPos);
            }
            if (matched) iOld++;
        }
        this.dom.className = cls;
        this.markers = markers;
    }
    destroy() {
        this.setMarkers(null, []); // First argument not used unless creating markers
    }
}
function $e7161f778706e663$var$sameMarkers(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].compare(b[i])) return false;
    return true;
}
/**
Facet used to provide markers to the line number gutter.
*/ const $e7161f778706e663$export$dd0c91e0a7121f5f = /*@__PURE__*/ (0, $hB7kI.Facet).define();
const $e7161f778706e663$var$lineNumberConfig = /*@__PURE__*/ (0, $hB7kI.Facet).define({
    combine (values) {
        return (0, $hB7kI.combineConfig)(values, {
            formatNumber: String,
            domEventHandlers: {}
        }, {
            domEventHandlers (a, b) {
                let result = Object.assign({}, a);
                for(let event in b){
                    let exists = result[event], add = b[event];
                    result[event] = exists ? (view, line, event)=>exists(view, line, event) || add(view, line, event) : add;
                }
                return result;
            }
        });
    }
});
class $e7161f778706e663$var$NumberMarker extends $e7161f778706e663$export$591ab4c909549043 {
    constructor(number){
        super();
        this.number = number;
    }
    eq(other) {
        return this.number == other.number;
    }
    toDOM() {
        return document.createTextNode(this.number);
    }
}
function $e7161f778706e663$var$formatNumber(view, number) {
    return view.state.facet($e7161f778706e663$var$lineNumberConfig).formatNumber(number, view.state);
}
const $e7161f778706e663$var$lineNumberGutter = /*@__PURE__*/ $e7161f778706e663$var$activeGutters.compute([
    $e7161f778706e663$var$lineNumberConfig
], (state)=>({
        class: "cm-lineNumbers",
        renderEmptyElements: false,
        markers (view) {
            return view.state.facet($e7161f778706e663$export$dd0c91e0a7121f5f);
        },
        lineMarker (view, line, others) {
            if (others.some((m)=>m.toDOM)) return null;
            return new $e7161f778706e663$var$NumberMarker($e7161f778706e663$var$formatNumber(view, view.state.doc.lineAt(line.from).number));
        },
        widgetMarker: ()=>null,
        lineMarkerChange: (update)=>update.startState.facet($e7161f778706e663$var$lineNumberConfig) != update.state.facet($e7161f778706e663$var$lineNumberConfig),
        initialSpacer (view) {
            return new $e7161f778706e663$var$NumberMarker($e7161f778706e663$var$formatNumber(view, $e7161f778706e663$var$maxLineNumber(view.state.doc.lines)));
        },
        updateSpacer (spacer, update) {
            let max = $e7161f778706e663$var$formatNumber(update.view, $e7161f778706e663$var$maxLineNumber(update.view.state.doc.lines));
            return max == spacer.number ? spacer : new $e7161f778706e663$var$NumberMarker(max);
        },
        domEventHandlers: state.facet($e7161f778706e663$var$lineNumberConfig).domEventHandlers
    }));
/**
Create a line number gutter extension.
*/ function $e7161f778706e663$export$1a8cf111682eaa7d(config = {}) {
    return [
        $e7161f778706e663$var$lineNumberConfig.of(config),
        $e7161f778706e663$export$ec15ef01b8fbae61(),
        $e7161f778706e663$var$lineNumberGutter
    ];
}
function $e7161f778706e663$var$maxLineNumber(lines) {
    let last = 9;
    while(last < lines)last = last * 10 + 9;
    return last;
}
const $e7161f778706e663$var$activeLineGutterMarker = /*@__PURE__*/ new class extends $e7161f778706e663$export$591ab4c909549043 {
    constructor(){
        super(...arguments);
        this.elementClass = "cm-activeLineGutter";
    }
};
const $e7161f778706e663$var$activeLineGutterHighlighter = /*@__PURE__*/ $e7161f778706e663$export$113bd64f27ac1172.compute([
    "selection"
], (state)=>{
    let marks = [], last = -1;
    for (let range of state.selection.ranges){
        let linePos = state.doc.lineAt(range.head).from;
        if (linePos > last) {
            last = linePos;
            marks.push($e7161f778706e663$var$activeLineGutterMarker.range(linePos));
        }
    }
    return (0, $hB7kI.RangeSet).of(marks);
});
/**
Returns an extension that adds a `cm-activeLineGutter` class to
all gutter elements on the [active
line](https://codemirror.net/6/docs/ref/#view.highlightActiveLine).
*/ function $e7161f778706e663$export$93b52f08bb2c759c() {
    return $e7161f778706e663$var$activeLineGutterHighlighter;
}
const $e7161f778706e663$var$WhitespaceDeco = /*@__PURE__*/ new Map();
function $e7161f778706e663$var$getWhitespaceDeco(space) {
    let deco = $e7161f778706e663$var$WhitespaceDeco.get(space);
    if (!deco) $e7161f778706e663$var$WhitespaceDeco.set(space, deco = $e7161f778706e663$export$10e30b733df217ea.mark({
        attributes: space === "	" ? {
            class: "cm-highlightTab"
        } : {
            class: "cm-highlightSpace",
            "data-display": space.replace(/ /g, "\xb7")
        }
    }));
    return deco;
}
function $e7161f778706e663$var$matcher(decorator) {
    return $e7161f778706e663$export$44d5eccfd62adda7.define((view)=>({
            decorations: decorator.createDeco(view),
            update (u) {
                this.decorations = decorator.updateDeco(u, this.decorations);
            }
        }), {
        decorations: (v)=>v.decorations
    });
}
const $e7161f778706e663$var$whitespaceHighlighter = /*@__PURE__*/ $e7161f778706e663$var$matcher(/*@__PURE__*/ new $e7161f778706e663$export$9b928b0ca20b25cb({
    regexp: /\t| +/g,
    decoration: (match)=>$e7161f778706e663$var$getWhitespaceDeco(match[0]),
    boundary: /\S/
}));
/**
Returns an extension that highlights whitespace, adding a
`cm-highlightSpace` class to stretches of spaces, and a
`cm-highlightTab` class to individual tab characters. By default,
the former are shown as faint dots, and the latter as arrows.
*/ function $e7161f778706e663$export$beeff585f23bdb79() {
    return $e7161f778706e663$var$whitespaceHighlighter;
}
const $e7161f778706e663$var$trailingHighlighter = /*@__PURE__*/ $e7161f778706e663$var$matcher(/*@__PURE__*/ new $e7161f778706e663$export$9b928b0ca20b25cb({
    regexp: /\s+$/g,
    decoration: /*@__PURE__*/ $e7161f778706e663$export$10e30b733df217ea.mark({
        class: "cm-trailingSpace"
    }),
    boundary: /\S/
}));
/**
Returns an extension that adds a `cm-trailingSpace` class to all
trailing whitespace.
*/ function $e7161f778706e663$export$6e66b0e142f44c26() {
    return $e7161f778706e663$var$trailingHighlighter;
}
/**
@internal
*/ const $e7161f778706e663$export$91afc2cf83e15b44 = {
    HeightMap: $e7161f778706e663$var$HeightMap,
    HeightOracle: $e7161f778706e663$var$HeightOracle,
    MeasuredHeights: $e7161f778706e663$var$MeasuredHeights,
    QueryType: $e7161f778706e663$var$QueryType,
    ChangedRange: $e7161f778706e663$var$ChangedRange,
    computeOrder: $e7161f778706e663$var$computeOrder,
    moveVisually: $e7161f778706e663$var$moveVisually
};

});
parcelRequire.register("luNHI", function(module, exports) {

$parcel$export(module.exports, "StyleModule", () => $fa62f485c41d169a$export$b920c662d2efee20);
const $fa62f485c41d169a$var$C = "ͼ";
const $fa62f485c41d169a$var$COUNT = typeof Symbol == "undefined" ? "__" + $fa62f485c41d169a$var$C : Symbol.for($fa62f485c41d169a$var$C);
const $fa62f485c41d169a$var$SET = typeof Symbol == "undefined" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet");
const $fa62f485c41d169a$var$top = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : {};
class $fa62f485c41d169a$export$b920c662d2efee20 {
    // :: (Object<Style>, ?{finish: ?(string) → string})
    // Create a style module from the given spec.
    //
    // When `finish` is given, it is called on regular (non-`@`)
    // selectors (after `&` expansion) to compute the final selector.
    constructor(spec, options){
        this.rules = [];
        let { finish: finish } = options || {};
        function splitSelector(selector) {
            return /^@/.test(selector) ? [
                selector
            ] : selector.split(/,\s*/);
        }
        function render(selectors, spec, target, isKeyframes) {
            let local = [], isAt = /^@(\w+)\b/.exec(selectors[0]), keyframes = isAt && isAt[1] == "keyframes";
            if (isAt && spec == null) return target.push(selectors[0] + ";");
            for(let prop in spec){
                let value = spec[prop];
                if (/&/.test(prop)) render(prop.split(/,\s*/).map((part)=>selectors.map((sel)=>part.replace(/&/, sel))).reduce((a, b)=>a.concat(b)), value, target);
                else if (value && typeof value == "object") {
                    if (!isAt) throw new RangeError("The value of a property (" + prop + ") should be a primitive value.");
                    render(splitSelector(prop), value, local, keyframes);
                } else if (value != null) local.push(prop.replace(/_.*/, "").replace(/[A-Z]/g, (l)=>"-" + l.toLowerCase()) + ": " + value + ";");
            }
            if (local.length || keyframes) target.push((finish && !isAt && !isKeyframes ? selectors.map(finish) : selectors).join(", ") + " {" + local.join(" ") + "}");
        }
        for(let prop in spec)render(splitSelector(prop), spec[prop], this.rules);
    }
    // :: () → string
    // Returns a string containing the module's CSS rules.
    getRules() {
        return this.rules.join("\n");
    }
    // :: () → string
    // Generate a new unique CSS class name.
    static newName() {
        let id = $fa62f485c41d169a$var$top[$fa62f485c41d169a$var$COUNT] || 1;
        $fa62f485c41d169a$var$top[$fa62f485c41d169a$var$COUNT] = id + 1;
        return $fa62f485c41d169a$var$C + id.toString(36);
    }
    // :: (union<Document, ShadowRoot>, union<[StyleModule], StyleModule>)
    //
    // Mount the given set of modules in the given DOM root, which ensures
    // that the CSS rules defined by the module are available in that
    // context.
    //
    // Rules are only added to the document once per root.
    //
    // Rule order will follow the order of the modules, so that rules from
    // modules later in the array take precedence of those from earlier
    // modules. If you call this function multiple times for the same root
    // in a way that changes the order of already mounted modules, the old
    // order will be changed.
    static mount(root, modules) {
        (root[$fa62f485c41d169a$var$SET] || new $fa62f485c41d169a$var$StyleSet(root)).mount(Array.isArray(modules) ? modules : [
            modules
        ]);
    }
}
let $fa62f485c41d169a$var$adoptedSet = new Map //<Document, StyleSet>
;
class $fa62f485c41d169a$var$StyleSet {
    constructor(root){
        let doc = root.ownerDocument || root, win = doc.defaultView;
        if (!root.head && root.adoptedStyleSheets && win.CSSStyleSheet) {
            let adopted = $fa62f485c41d169a$var$adoptedSet.get(doc);
            if (adopted) {
                root.adoptedStyleSheets = [
                    adopted.sheet,
                    ...root.adoptedStyleSheets
                ];
                return root[$fa62f485c41d169a$var$SET] = adopted;
            }
            this.sheet = new win.CSSStyleSheet;
            root.adoptedStyleSheets = [
                this.sheet,
                ...root.adoptedStyleSheets
            ];
            $fa62f485c41d169a$var$adoptedSet.set(doc, this);
        } else {
            this.styleTag = doc.createElement("style");
            let target = root.head || root;
            target.insertBefore(this.styleTag, target.firstChild);
        }
        this.modules = [];
        root[$fa62f485c41d169a$var$SET] = this;
    }
    mount(modules) {
        let sheet = this.sheet;
        let pos = 0 /* Current rule offset */ , j = 0 /* Index into this.modules */ ;
        for(let i = 0; i < modules.length; i++){
            let mod = modules[i], index = this.modules.indexOf(mod);
            if (index < j && index > -1) {
                this.modules.splice(index, 1);
                j--;
                index = -1;
            }
            if (index == -1) {
                this.modules.splice(j++, 0, mod);
                if (sheet) for(let k = 0; k < mod.rules.length; k++)sheet.insertRule(mod.rules[k], pos++);
            } else {
                while(j < index)pos += this.modules[j++].rules.length;
                pos += mod.rules.length;
                j++;
            }
        }
        if (!sheet) {
            let text = "";
            for(let i = 0; i < this.modules.length; i++)text += this.modules[i].getRules() + "\n";
            this.styleTag.textContent = text;
        }
    }
} // Style::Object<union<Style,string>>
 //
 // A style is an object that, in the simple case, maps CSS property
 // names to strings holding their values, as in `{color: "red",
 // fontWeight: "bold"}`. The property names can be given in
 // camel-case—the library will insert a dash before capital letters
 // when converting them to CSS.
 //
 // If you include an underscore in a property name, it and everything
 // after it will be removed from the output, which can be useful when
 // providing a property multiple times, for browser compatibility
 // reasons.
 //
 // A property in a style object can also be a sub-selector, which
 // extends the current context to add a pseudo-selector or a child
 // selector. Such a property should contain a `&` character, which
 // will be replaced by the current selector. For example `{"&:before":
 // {content: '"hi"'}}`. Sub-selectors and regular properties can
 // freely be mixed in a given object. Any property containing a `&` is
 // assumed to be a sub-selector.
 //
 // Finally, a property can specify an @-block to be wrapped around the
 // styles defined inside the object that's the property's value. For
 // example to create a media query you can do `{"@media screen and
 // (min-width: 400px)": {...}}`.

});

parcelRequire.register("lNHdE", function(module, exports) {

$parcel$export(module.exports, "base", () => $fdefb3038aa23227$export$e2253033e6e1df16);
$parcel$export(module.exports, "shift", () => $fdefb3038aa23227$export$fba63a578e423eb);
$parcel$export(module.exports, "keyName", () => $fdefb3038aa23227$export$fb33aafd75404f4c);
var $fdefb3038aa23227$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $fdefb3038aa23227$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: '"'
};
var $fdefb3038aa23227$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $fdefb3038aa23227$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $fdefb3038aa23227$var$i = 0; $fdefb3038aa23227$var$i < 10; $fdefb3038aa23227$var$i++)$fdefb3038aa23227$export$e2253033e6e1df16[48 + $fdefb3038aa23227$var$i] = $fdefb3038aa23227$export$e2253033e6e1df16[96 + $fdefb3038aa23227$var$i] = String($fdefb3038aa23227$var$i);
// The function keys
for(var $fdefb3038aa23227$var$i = 1; $fdefb3038aa23227$var$i <= 24; $fdefb3038aa23227$var$i++)$fdefb3038aa23227$export$e2253033e6e1df16[$fdefb3038aa23227$var$i + 111] = "F" + $fdefb3038aa23227$var$i;
// And the alphabetic keys
for(var $fdefb3038aa23227$var$i = 65; $fdefb3038aa23227$var$i <= 90; $fdefb3038aa23227$var$i++){
    $fdefb3038aa23227$export$e2253033e6e1df16[$fdefb3038aa23227$var$i] = String.fromCharCode($fdefb3038aa23227$var$i + 32);
    $fdefb3038aa23227$export$fba63a578e423eb[$fdefb3038aa23227$var$i] = String.fromCharCode($fdefb3038aa23227$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $fdefb3038aa23227$var$code in $fdefb3038aa23227$export$e2253033e6e1df16)if (!$fdefb3038aa23227$export$fba63a578e423eb.hasOwnProperty($fdefb3038aa23227$var$code)) $fdefb3038aa23227$export$fba63a578e423eb[$fdefb3038aa23227$var$code] = $fdefb3038aa23227$export$e2253033e6e1df16[$fdefb3038aa23227$var$code];
function $fdefb3038aa23227$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $fdefb3038aa23227$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $fdefb3038aa23227$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $fdefb3038aa23227$export$fba63a578e423eb : $fdefb3038aa23227$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}

});


parcelRequire.register("6yW7d", function(module, exports) {

$parcel$export(module.exports, "Tag", () => $4c72ff8c9e8a407a$export$3288d34c523a1192);
$parcel$export(module.exports, "styleTags", () => $4c72ff8c9e8a407a$export$c537e79bb7b94295);
$parcel$export(module.exports, "tagHighlighter", () => $4c72ff8c9e8a407a$export$b7f6332ce20f80fb);
$parcel$export(module.exports, "highlightTree", () => $4c72ff8c9e8a407a$export$af82b3d076119fad);
$parcel$export(module.exports, "tags", () => $4c72ff8c9e8a407a$export$8b7a896ae75accbf);
$parcel$export(module.exports, "classHighlighter", () => $4c72ff8c9e8a407a$export$bf3ffb24fb17216c);

var $6DlXS = parcelRequire("6DlXS");
let $4c72ff8c9e8a407a$var$nextTagID = 0;
/**
Highlighting tags are markers that denote a highlighting category.
They are [associated](#highlight.styleTags) with parts of a syntax
tree by a language mode, and then mapped to an actual CSS style by
a [highlighter](#highlight.Highlighter).

Because syntax tree node types and highlight styles have to be
able to talk the same language, CodeMirror uses a mostly _closed_
[vocabulary](#highlight.tags) of syntax tags (as opposed to
traditional open string-based systems, which make it hard for
highlighting themes to cover all the tokens produced by the
various languages).

It _is_ possible to [define](#highlight.Tag^define) your own
highlighting tags for system-internal use (where you control both
the language package and the highlighter), but such tags will not
be picked up by regular highlighters (though you can derive them
from standard tags to allow highlighters to fall back to those).
*/ class $4c72ff8c9e8a407a$export$3288d34c523a1192 {
    /**
    @internal
    */ constructor(/**
    The set of this tag and all its parent tags, starting with
    this one itself and sorted in order of decreasing specificity.
    */ set, /**
    The base unmodified tag that this one is based on, if it's
    modified @internal
    */ base, /**
    The modifiers applied to this.base @internal
    */ modified){
        this.set = set;
        this.base = base;
        this.modified = modified;
        /**
        @internal
        */ this.id = $4c72ff8c9e8a407a$var$nextTagID++;
    }
    /**
    Define a new tag. If `parent` is given, the tag is treated as a
    sub-tag of that parent, and
    [highlighters](#highlight.tagHighlighter) that don't mention
    this tag will try to fall back to the parent tag (or grandparent
    tag, etc).
    */ static define(parent) {
        if (parent === null || parent === void 0 ? void 0 : parent.base) throw new Error("Can not derive from a modified tag");
        let tag = new $4c72ff8c9e8a407a$export$3288d34c523a1192([], null, []);
        tag.set.push(tag);
        if (parent) for (let t of parent.set)tag.set.push(t);
        return tag;
    }
    /**
    Define a tag _modifier_, which is a function that, given a tag,
    will return a tag that is a subtag of the original. Applying the
    same modifier to a twice tag will return the same value (`m1(t1)
    == m1(t1)`) and applying multiple modifiers will, regardless or
    order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
    
    When multiple modifiers are applied to a given base tag, each
    smaller set of modifiers is registered as a parent, so that for
    example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
    `m1(m3(t1)`, and so on.
    */ static defineModifier() {
        let mod = new $4c72ff8c9e8a407a$var$Modifier;
        return (tag)=>{
            if (tag.modified.indexOf(mod) > -1) return tag;
            return $4c72ff8c9e8a407a$var$Modifier.get(tag.base || tag, tag.modified.concat(mod).sort((a, b)=>a.id - b.id));
        };
    }
}
let $4c72ff8c9e8a407a$var$nextModifierID = 0;
class $4c72ff8c9e8a407a$var$Modifier {
    constructor(){
        this.instances = [];
        this.id = $4c72ff8c9e8a407a$var$nextModifierID++;
    }
    static get(base, mods) {
        if (!mods.length) return base;
        let exists = mods[0].instances.find((t)=>t.base == base && $4c72ff8c9e8a407a$var$sameArray(mods, t.modified));
        if (exists) return exists;
        let set = [], tag = new $4c72ff8c9e8a407a$export$3288d34c523a1192(set, base, mods);
        for (let m of mods)m.instances.push(tag);
        let configs = $4c72ff8c9e8a407a$var$powerSet(mods);
        for (let parent of base.set)if (!parent.modified.length) for (let config of configs)set.push($4c72ff8c9e8a407a$var$Modifier.get(parent, config));
        return tag;
    }
}
function $4c72ff8c9e8a407a$var$sameArray(a, b) {
    return a.length == b.length && a.every((x, i)=>x == b[i]);
}
function $4c72ff8c9e8a407a$var$powerSet(array) {
    let sets = [
        []
    ];
    for(let i = 0; i < array.length; i++)for(let j = 0, e = sets.length; j < e; j++)sets.push(sets[j].concat(array[i]));
    return sets.sort((a, b)=>b.length - a.length);
}
/**
This function is used to add a set of tags to a language syntax
via [`NodeSet.extend`](#common.NodeSet.extend) or
[`LRParser.configure`](#lr.LRParser.configure).

The argument object maps node selectors to [highlighting
tags](#highlight.Tag) or arrays of tags.

Node selectors may hold one or more (space-separated) node paths.
Such a path can be a [node name](#common.NodeType.name), or
multiple node names (or `*` wildcards) separated by slash
characters, as in `"Block/Declaration/VariableName"`. Such a path
matches the final node but only if its direct parent nodes are the
other nodes mentioned. A `*` in such a path matches any parent,
but only a single level—wildcards that match multiple parents
aren't supported, both for efficiency reasons and because Lezer
trees make it rather hard to reason about what they would match.)

A path can be ended with `/...` to indicate that the tag assigned
to the node should also apply to all child nodes, even if they
match their own style (by default, only the innermost style is
used).

When a path ends in `!`, as in `Attribute!`, no further matching
happens for the node's child nodes, and the entire node gets the
given style.

In this notation, node names that contain `/`, `!`, `*`, or `...`
must be quoted as JSON strings.

For example:

```javascript
parser.withProps(
  styleTags({
    // Style Number and BigNumber nodes
    "Number BigNumber": tags.number,
    // Style Escape nodes whose parent is String
    "String/Escape": tags.escape,
    // Style anything inside Attributes nodes
    "Attributes!": tags.meta,
    // Add a style to all content inside Italic nodes
    "Italic/...": tags.emphasis,
    // Style InvalidString nodes as both `string` and `invalid`
    "InvalidString": [tags.string, tags.invalid],
    // Style the node named "/" as punctuation
    '"/"': tags.punctuation
  })
)
```
*/ function $4c72ff8c9e8a407a$export$c537e79bb7b94295(spec) {
    let byName = Object.create(null);
    for(let prop in spec){
        let tags = spec[prop];
        if (!Array.isArray(tags)) tags = [
            tags
        ];
        for (let part of prop.split(" "))if (part) {
            let pieces = [], mode = 2 /* Normal */ , rest = part;
            for(let pos = 0;;){
                if (rest == "..." && pos > 0 && pos + 3 == part.length) {
                    mode = 1 /* Inherit */ ;
                    break;
                }
                let m = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(rest);
                if (!m) throw new RangeError("Invalid path: " + part);
                pieces.push(m[0] == "*" ? "" : m[0][0] == '"' ? JSON.parse(m[0]) : m[0]);
                pos += m[0].length;
                if (pos == part.length) break;
                let next = part[pos++];
                if (pos == part.length && next == "!") {
                    mode = 0 /* Opaque */ ;
                    break;
                }
                if (next != "/") throw new RangeError("Invalid path: " + part);
                rest = part.slice(pos);
            }
            let last = pieces.length - 1, inner = pieces[last];
            if (!inner) throw new RangeError("Invalid path: " + part);
            let rule = new $4c72ff8c9e8a407a$var$Rule(tags, mode, last > 0 ? pieces.slice(0, last) : null);
            byName[inner] = rule.sort(byName[inner]);
        }
    }
    return $4c72ff8c9e8a407a$var$ruleNodeProp.add(byName);
}
const $4c72ff8c9e8a407a$var$ruleNodeProp = new (0, $6DlXS.NodeProp)();
class $4c72ff8c9e8a407a$var$Rule {
    constructor(tags, mode, context, next){
        this.tags = tags;
        this.mode = mode;
        this.context = context;
        this.next = next;
    }
    get opaque() {
        return this.mode == 0 /* Opaque */ ;
    }
    get inherit() {
        return this.mode == 1 /* Inherit */ ;
    }
    sort(other) {
        if (!other || other.depth < this.depth) {
            this.next = other;
            return this;
        }
        other.next = this.sort(other.next);
        return other;
    }
    get depth() {
        return this.context ? this.context.length : 0;
    }
}
$4c72ff8c9e8a407a$var$Rule.empty = new $4c72ff8c9e8a407a$var$Rule([], 2 /* Normal */ , null);
/**
Define a [highlighter](#highlight.Highlighter) from an array of
tag/class pairs. Classes associated with more specific tags will
take precedence.
*/ function $4c72ff8c9e8a407a$export$b7f6332ce20f80fb(tags, options) {
    let map = Object.create(null);
    for (let style of tags){
        if (!Array.isArray(style.tag)) map[style.tag.id] = style.class;
        else for (let tag of style.tag)map[tag.id] = style.class;
    }
    let { scope: scope, all: all = null } = options || {};
    return {
        style: (tags)=>{
            let cls = all;
            for (let tag of tags)for (let sub of tag.set){
                let tagClass = map[sub.id];
                if (tagClass) {
                    cls = cls ? cls + " " + tagClass : tagClass;
                    break;
                }
            }
            return cls;
        },
        scope: scope
    };
}
function $4c72ff8c9e8a407a$var$highlightTags(highlighters, tags) {
    let result = null;
    for (let highlighter of highlighters){
        let value = highlighter.style(tags);
        if (value) result = result ? result + " " + value : value;
    }
    return result;
}
/**
Highlight the given [tree](#common.Tree) with the given
[highlighter](#highlight.Highlighter).
*/ function $4c72ff8c9e8a407a$export$af82b3d076119fad(tree, highlighter, /**
Assign styling to a region of the text. Will be called, in order
of position, for any ranges where more than zero classes apply.
`classes` is a space separated string of CSS classes.
*/ putStyle, /**
The start of the range to highlight.
*/ from = 0, /**
The end of the range.
*/ to = tree.length) {
    let builder = new $4c72ff8c9e8a407a$var$HighlightBuilder(from, Array.isArray(highlighter) ? highlighter : [
        highlighter
    ], putStyle);
    builder.highlightRange(tree.cursor(), from, to, "", builder.highlighters);
    builder.flush(to);
}
class $4c72ff8c9e8a407a$var$HighlightBuilder {
    constructor(at, highlighters, span){
        this.at = at;
        this.highlighters = highlighters;
        this.span = span;
        this.class = "";
    }
    startSpan(at, cls) {
        if (cls != this.class) {
            this.flush(at);
            if (at > this.at) this.at = at;
            this.class = cls;
        }
    }
    flush(to) {
        if (to > this.at && this.class) this.span(this.at, to, this.class);
    }
    highlightRange(cursor, from, to, inheritedClass, highlighters) {
        let { type: type, from: start, to: end } = cursor;
        if (start >= to || end <= from) return;
        if (type.isTop) highlighters = this.highlighters.filter((h)=>!h.scope || h.scope(type));
        let cls = inheritedClass;
        let rule = $4c72ff8c9e8a407a$export$1519d79cc79711ec(cursor) || $4c72ff8c9e8a407a$var$Rule.empty;
        let tagCls = $4c72ff8c9e8a407a$var$highlightTags(highlighters, rule.tags);
        if (tagCls) {
            if (cls) cls += " ";
            cls += tagCls;
            if (rule.mode == 1 /* Inherit */ ) inheritedClass += (inheritedClass ? " " : "") + tagCls;
        }
        this.startSpan(Math.max(from, start), cls);
        if (rule.opaque) return;
        let mounted = cursor.tree && cursor.tree.prop((0, $6DlXS.NodeProp).mounted);
        if (mounted && mounted.overlay) {
            let inner = cursor.node.enter(mounted.overlay[0].from + start, 1);
            let innerHighlighters = this.highlighters.filter((h)=>!h.scope || h.scope(mounted.tree.type));
            let hasChild = cursor.firstChild();
            for(let i = 0, pos = start;; i++){
                let next = i < mounted.overlay.length ? mounted.overlay[i] : null;
                let nextPos = next ? next.from + start : end;
                let rangeFrom = Math.max(from, pos), rangeTo = Math.min(to, nextPos);
                if (rangeFrom < rangeTo && hasChild) while(cursor.from < rangeTo){
                    this.highlightRange(cursor, rangeFrom, rangeTo, inheritedClass, highlighters);
                    this.startSpan(Math.min(rangeTo, cursor.to), cls);
                    if (cursor.to >= nextPos || !cursor.nextSibling()) break;
                }
                if (!next || nextPos > to) break;
                pos = next.to + start;
                if (pos > from) {
                    this.highlightRange(inner.cursor(), Math.max(from, next.from + start), Math.min(to, pos), "", innerHighlighters);
                    this.startSpan(Math.min(to, pos), cls);
                }
            }
            if (hasChild) cursor.parent();
        } else if (cursor.firstChild()) {
            if (mounted) inheritedClass = "";
            do {
                if (cursor.to <= from) continue;
                if (cursor.from >= to) break;
                this.highlightRange(cursor, from, to, inheritedClass, highlighters);
                this.startSpan(Math.min(to, cursor.to), cls);
            }while (cursor.nextSibling());
            cursor.parent();
        }
    }
}
/**
Match a syntax node's [highlight rules](#highlight.styleTags). If
there's a match, return its set of tags, and whether it is
opaque (uses a `!`) or applies to all child nodes (`/...`).
*/ function $4c72ff8c9e8a407a$export$1519d79cc79711ec(node) {
    let rule = node.type.prop($4c72ff8c9e8a407a$var$ruleNodeProp);
    while(rule && rule.context && !node.matchContext(rule.context))rule = rule.next;
    return rule || null;
}
const $4c72ff8c9e8a407a$var$t = $4c72ff8c9e8a407a$export$3288d34c523a1192.define;
const $4c72ff8c9e8a407a$var$comment = $4c72ff8c9e8a407a$var$t(), $4c72ff8c9e8a407a$var$name = $4c72ff8c9e8a407a$var$t(), $4c72ff8c9e8a407a$var$typeName = $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$name), $4c72ff8c9e8a407a$var$propertyName = $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$name), $4c72ff8c9e8a407a$var$literal = $4c72ff8c9e8a407a$var$t(), $4c72ff8c9e8a407a$var$string = $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$literal), $4c72ff8c9e8a407a$var$number = $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$literal), $4c72ff8c9e8a407a$var$content = $4c72ff8c9e8a407a$var$t(), $4c72ff8c9e8a407a$var$heading = $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$content), $4c72ff8c9e8a407a$var$keyword = $4c72ff8c9e8a407a$var$t(), $4c72ff8c9e8a407a$var$operator = $4c72ff8c9e8a407a$var$t(), $4c72ff8c9e8a407a$var$punctuation = $4c72ff8c9e8a407a$var$t(), $4c72ff8c9e8a407a$var$bracket = $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$punctuation), $4c72ff8c9e8a407a$var$meta = $4c72ff8c9e8a407a$var$t();
/**
The default set of highlighting [tags](#highlight.Tag).

This collection is heavily biased towards programming languages,
and necessarily incomplete. A full ontology of syntactic
constructs would fill a stack of books, and be impractical to
write themes for. So try to make do with this set. If all else
fails, [open an
issue](https://github.com/codemirror/codemirror.next) to propose a
new tag, or [define](#highlight.Tag^define) a local custom tag for
your use case.

Note that it is not obligatory to always attach the most specific
tag possible to an element—if your grammar can't easily
distinguish a certain type of element (such as a local variable),
it is okay to style it as its more general variant (a variable).

For tags that extend some parent tag, the documentation links to
the parent.
*/ const $4c72ff8c9e8a407a$export$8b7a896ae75accbf = {
    comment: /**
    A comment.
    */ $4c72ff8c9e8a407a$var$comment,
    /**
    A line [comment](#highlight.tags.comment).
    */ lineComment: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$comment),
    /**
    A block [comment](#highlight.tags.comment).
    */ blockComment: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$comment),
    /**
    A documentation [comment](#highlight.tags.comment).
    */ docComment: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$comment),
    name: /**
    Any kind of identifier.
    */ $4c72ff8c9e8a407a$var$name,
    /**
    The [name](#highlight.tags.name) of a variable.
    */ variableName: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$name),
    /**
    A type [name](#highlight.tags.name).
    */ typeName: $4c72ff8c9e8a407a$var$typeName,
    /**
    A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
    */ tagName: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$typeName),
    /**
    A property or field [name](#highlight.tags.name).
    */ propertyName: $4c72ff8c9e8a407a$var$propertyName,
    /**
    An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
    */ attributeName: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$propertyName),
    /**
    The [name](#highlight.tags.name) of a class.
    */ className: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$name),
    /**
    A label [name](#highlight.tags.name).
    */ labelName: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$name),
    /**
    A namespace [name](#highlight.tags.name).
    */ namespace: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$name),
    /**
    The [name](#highlight.tags.name) of a macro.
    */ macroName: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$name),
    literal: /**
    A literal value.
    */ $4c72ff8c9e8a407a$var$literal,
    string: /**
    A string [literal](#highlight.tags.literal).
    */ $4c72ff8c9e8a407a$var$string,
    /**
    A documentation [string](#highlight.tags.string).
    */ docString: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$string),
    /**
    A character literal (subtag of [string](#highlight.tags.string)).
    */ character: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$string),
    /**
    An attribute value (subtag of [string](#highlight.tags.string)).
    */ attributeValue: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$string),
    number: /**
    A number [literal](#highlight.tags.literal).
    */ $4c72ff8c9e8a407a$var$number,
    /**
    An integer [number](#highlight.tags.number) literal.
    */ integer: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$number),
    /**
    A floating-point [number](#highlight.tags.number) literal.
    */ float: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$number),
    /**
    A boolean [literal](#highlight.tags.literal).
    */ bool: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$literal),
    /**
    Regular expression [literal](#highlight.tags.literal).
    */ regexp: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$literal),
    /**
    An escape [literal](#highlight.tags.literal), for example a
    backslash escape in a string.
    */ escape: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$literal),
    /**
    A color [literal](#highlight.tags.literal).
    */ color: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$literal),
    /**
    A URL [literal](#highlight.tags.literal).
    */ url: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$literal),
    keyword: /**
    A language keyword.
    */ $4c72ff8c9e8a407a$var$keyword,
    /**
    The [keyword](#highlight.tags.keyword) for the self or this
    object.
    */ self: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$keyword),
    /**
    The [keyword](#highlight.tags.keyword) for null.
    */ null: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) denoting some atomic value.
    */ atom: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that represents a unit.
    */ unit: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$keyword),
    /**
    A modifier [keyword](#highlight.tags.keyword).
    */ modifier: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that acts as an operator.
    */ operatorKeyword: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$keyword),
    /**
    A control-flow related [keyword](#highlight.tags.keyword).
    */ controlKeyword: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that defines something.
    */ definitionKeyword: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) related to defining or
    interfacing with modules.
    */ moduleKeyword: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$keyword),
    operator: /**
    An operator.
    */ $4c72ff8c9e8a407a$var$operator,
    /**
    An [operator](#highlight.tags.operator) that dereferences something.
    */ derefOperator: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$operator),
    /**
    Arithmetic-related [operator](#highlight.tags.operator).
    */ arithmeticOperator: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$operator),
    /**
    Logical [operator](#highlight.tags.operator).
    */ logicOperator: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$operator),
    /**
    Bit [operator](#highlight.tags.operator).
    */ bitwiseOperator: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$operator),
    /**
    Comparison [operator](#highlight.tags.operator).
    */ compareOperator: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$operator),
    /**
    [Operator](#highlight.tags.operator) that updates its operand.
    */ updateOperator: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$operator),
    /**
    [Operator](#highlight.tags.operator) that defines something.
    */ definitionOperator: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$operator),
    /**
    Type-related [operator](#highlight.tags.operator).
    */ typeOperator: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$operator),
    /**
    Control-flow [operator](#highlight.tags.operator).
    */ controlOperator: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$operator),
    punctuation: /**
    Program or markup punctuation.
    */ $4c72ff8c9e8a407a$var$punctuation,
    /**
    [Punctuation](#highlight.tags.punctuation) that separates
    things.
    */ separator: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$punctuation),
    bracket: /**
    Bracket-style [punctuation](#highlight.tags.punctuation).
    */ $4c72ff8c9e8a407a$var$bracket,
    /**
    Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
    tokens).
    */ angleBracket: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$bracket),
    /**
    Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
    tokens).
    */ squareBracket: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$bracket),
    /**
    Parentheses (usually `(` and `)` tokens). Subtag of
    [bracket](#highlight.tags.bracket).
    */ paren: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$bracket),
    /**
    Braces (usually `{` and `}` tokens). Subtag of
    [bracket](#highlight.tags.bracket).
    */ brace: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$bracket),
    content: /**
    Content, for example plain text in XML or markup documents.
    */ $4c72ff8c9e8a407a$var$content,
    heading: /**
    [Content](#highlight.tags.content) that represents a heading.
    */ $4c72ff8c9e8a407a$var$heading,
    /**
    A level 1 [heading](#highlight.tags.heading).
    */ heading1: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$heading),
    /**
    A level 2 [heading](#highlight.tags.heading).
    */ heading2: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$heading),
    /**
    A level 3 [heading](#highlight.tags.heading).
    */ heading3: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$heading),
    /**
    A level 4 [heading](#highlight.tags.heading).
    */ heading4: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$heading),
    /**
    A level 5 [heading](#highlight.tags.heading).
    */ heading5: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$heading),
    /**
    A level 6 [heading](#highlight.tags.heading).
    */ heading6: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$heading),
    /**
    A prose separator (such as a horizontal rule).
    */ contentSeparator: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$content),
    /**
    [Content](#highlight.tags.content) that represents a list.
    */ list: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$content),
    /**
    [Content](#highlight.tags.content) that represents a quote.
    */ quote: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$content),
    /**
    [Content](#highlight.tags.content) that is emphasized.
    */ emphasis: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$content),
    /**
    [Content](#highlight.tags.content) that is styled strong.
    */ strong: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$content),
    /**
    [Content](#highlight.tags.content) that is part of a link.
    */ link: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$content),
    /**
    [Content](#highlight.tags.content) that is styled as code or
    monospace.
    */ monospace: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$content),
    /**
    [Content](#highlight.tags.content) that has a strike-through
    style.
    */ strikethrough: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$content),
    /**
    Inserted text in a change-tracking format.
    */ inserted: $4c72ff8c9e8a407a$var$t(),
    /**
    Deleted text.
    */ deleted: $4c72ff8c9e8a407a$var$t(),
    /**
    Changed text.
    */ changed: $4c72ff8c9e8a407a$var$t(),
    /**
    An invalid or unsyntactic element.
    */ invalid: $4c72ff8c9e8a407a$var$t(),
    meta: /**
    Metadata or meta-instruction.
    */ $4c72ff8c9e8a407a$var$meta,
    /**
    [Metadata](#highlight.tags.meta) that applies to the entire
    document.
    */ documentMeta: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$meta),
    /**
    [Metadata](#highlight.tags.meta) that annotates or adds
    attributes to a given syntactic element.
    */ annotation: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$meta),
    /**
    Processing instruction or preprocessor directive. Subtag of
    [meta](#highlight.tags.meta).
    */ processingInstruction: $4c72ff8c9e8a407a$var$t($4c72ff8c9e8a407a$var$meta),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates that a
    given element is being defined. Expected to be used with the
    various [name](#highlight.tags.name) tags.
    */ definition: $4c72ff8c9e8a407a$export$3288d34c523a1192.defineModifier(),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates that
    something is constant. Mostly expected to be used with
    [variable names](#highlight.tags.variableName).
    */ constant: $4c72ff8c9e8a407a$export$3288d34c523a1192.defineModifier(),
    /**
    [Modifier](#highlight.Tag^defineModifier) used to indicate that
    a [variable](#highlight.tags.variableName) or [property
    name](#highlight.tags.propertyName) is being called or defined
    as a function.
    */ function: $4c72ff8c9e8a407a$export$3288d34c523a1192.defineModifier(),
    /**
    [Modifier](#highlight.Tag^defineModifier) that can be applied to
    [names](#highlight.tags.name) to indicate that they belong to
    the language's standard environment.
    */ standard: $4c72ff8c9e8a407a$export$3288d34c523a1192.defineModifier(),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates a given
    [names](#highlight.tags.name) is local to some scope.
    */ local: $4c72ff8c9e8a407a$export$3288d34c523a1192.defineModifier(),
    /**
    A generic variant [modifier](#highlight.Tag^defineModifier) that
    can be used to tag language-specific alternative variants of
    some common tag. It is recommended for themes to define special
    forms of at least the [string](#highlight.tags.string) and
    [variable name](#highlight.tags.variableName) tags, since those
    come up a lot.
    */ special: $4c72ff8c9e8a407a$export$3288d34c523a1192.defineModifier()
};
/**
This is a highlighter that adds stable, predictable classes to
tokens, for styling with external CSS.

The following tags are mapped to their name prefixed with `"tok-"`
(for example `"tok-comment"`):

* [`link`](#highlight.tags.link)
* [`heading`](#highlight.tags.heading)
* [`emphasis`](#highlight.tags.emphasis)
* [`strong`](#highlight.tags.strong)
* [`keyword`](#highlight.tags.keyword)
* [`atom`](#highlight.tags.atom)
* [`bool`](#highlight.tags.bool)
* [`url`](#highlight.tags.url)
* [`labelName`](#highlight.tags.labelName)
* [`inserted`](#highlight.tags.inserted)
* [`deleted`](#highlight.tags.deleted)
* [`literal`](#highlight.tags.literal)
* [`string`](#highlight.tags.string)
* [`number`](#highlight.tags.number)
* [`variableName`](#highlight.tags.variableName)
* [`typeName`](#highlight.tags.typeName)
* [`namespace`](#highlight.tags.namespace)
* [`className`](#highlight.tags.className)
* [`macroName`](#highlight.tags.macroName)
* [`propertyName`](#highlight.tags.propertyName)
* [`operator`](#highlight.tags.operator)
* [`comment`](#highlight.tags.comment)
* [`meta`](#highlight.tags.meta)
* [`punctuation`](#highlight.tags.punctuation)
* [`invalid`](#highlight.tags.invalid)

In addition, these mappings are provided:

* [`regexp`](#highlight.tags.regexp),
  [`escape`](#highlight.tags.escape), and
  [`special`](#highlight.tags.special)[`(string)`](#highlight.tags.string)
  are mapped to `"tok-string2"`
* [`special`](#highlight.tags.special)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName2"`
* [`local`](#highlight.tags.local)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName tok-local"`
* [`definition`](#highlight.tags.definition)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName tok-definition"`
* [`definition`](#highlight.tags.definition)[`(propertyName)`](#highlight.tags.propertyName)
  to `"tok-propertyName tok-definition"`
*/ const $4c72ff8c9e8a407a$export$bf3ffb24fb17216c = $4c72ff8c9e8a407a$export$b7f6332ce20f80fb([
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.link,
        class: "tok-link"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.heading,
        class: "tok-heading"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.emphasis,
        class: "tok-emphasis"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.strong,
        class: "tok-strong"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.keyword,
        class: "tok-keyword"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.atom,
        class: "tok-atom"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.bool,
        class: "tok-bool"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.url,
        class: "tok-url"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.labelName,
        class: "tok-labelName"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.inserted,
        class: "tok-inserted"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.deleted,
        class: "tok-deleted"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.literal,
        class: "tok-literal"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.string,
        class: "tok-string"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.number,
        class: "tok-number"
    },
    {
        tag: [
            $4c72ff8c9e8a407a$export$8b7a896ae75accbf.regexp,
            $4c72ff8c9e8a407a$export$8b7a896ae75accbf.escape,
            $4c72ff8c9e8a407a$export$8b7a896ae75accbf.special($4c72ff8c9e8a407a$export$8b7a896ae75accbf.string)
        ],
        class: "tok-string2"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.variableName,
        class: "tok-variableName"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.local($4c72ff8c9e8a407a$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName tok-local"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.definition($4c72ff8c9e8a407a$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName tok-definition"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.special($4c72ff8c9e8a407a$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName2"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.definition($4c72ff8c9e8a407a$export$8b7a896ae75accbf.propertyName),
        class: "tok-propertyName tok-definition"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.typeName,
        class: "tok-typeName"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.namespace,
        class: "tok-namespace"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.className,
        class: "tok-className"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.macroName,
        class: "tok-macroName"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.propertyName,
        class: "tok-propertyName"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.operator,
        class: "tok-operator"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.comment,
        class: "tok-comment"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.meta,
        class: "tok-meta"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.invalid,
        class: "tok-invalid"
    },
    {
        tag: $4c72ff8c9e8a407a$export$8b7a896ae75accbf.punctuation,
        class: "tok-punctuation"
    }
]);

});


parcelRequire.register("5IH7g", function(module, exports) {
"use strict";
var $42a281cde968d9bd$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $42a281cde968d9bd$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $42a281cde968d9bd$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRequire.register("4XBEa", function(module, exports) {
"use strict";
var $39c9e00506b0cbf9$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $39c9e00506b0cbf9$var$has = Object.prototype.hasOwnProperty;
    var $39c9e00506b0cbf9$var$toStr = Object.prototype.toString;
    var $39c9e00506b0cbf9$var$isArgs = (parcelRequire("5IH7g")); // eslint-disable-line global-require
    var $39c9e00506b0cbf9$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $39c9e00506b0cbf9$var$hasDontEnumBug = !$39c9e00506b0cbf9$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $39c9e00506b0cbf9$var$hasProtoEnumBug = $39c9e00506b0cbf9$var$isEnumerable.call(function() {}, "prototype");
    var $39c9e00506b0cbf9$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $39c9e00506b0cbf9$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $39c9e00506b0cbf9$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $39c9e00506b0cbf9$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$39c9e00506b0cbf9$var$excludedKeys["$" + k] && $39c9e00506b0cbf9$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $39c9e00506b0cbf9$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $39c9e00506b0cbf9$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !$39c9e00506b0cbf9$var$hasAutomationEqualityBug) return $39c9e00506b0cbf9$var$equalsConstructorPrototype(o);
        try {
            return $39c9e00506b0cbf9$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $39c9e00506b0cbf9$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $39c9e00506b0cbf9$var$toStr.call(object) === "[object Function]";
        var isArguments = $39c9e00506b0cbf9$var$isArgs(object);
        var isString = isObject && $39c9e00506b0cbf9$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $39c9e00506b0cbf9$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$39c9e00506b0cbf9$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $39c9e00506b0cbf9$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($39c9e00506b0cbf9$var$hasDontEnumBug) {
            var skipConstructor = $39c9e00506b0cbf9$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $39c9e00506b0cbf9$var$dontEnums.length; ++k)if (!(skipConstructor && $39c9e00506b0cbf9$var$dontEnums[k] === "constructor") && $39c9e00506b0cbf9$var$has.call(object, $39c9e00506b0cbf9$var$dontEnums[k])) theKeys.push($39c9e00506b0cbf9$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $39c9e00506b0cbf9$var$keysShim;

});

parcelRequire.register("9ft5k", function(module, exports) {
"use strict";

var $gXypp = parcelRequire("gXypp");
var $6bbc137079526b2d$var$$defineProperty = $gXypp("%Object.defineProperty%", true);
var $6bbc137079526b2d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    if ($6bbc137079526b2d$var$$defineProperty) try {
        $6bbc137079526b2d$var$$defineProperty({}, "a", {
            value: 1
        });
        return true;
    } catch (e) {
        // IE 8 has a broken defineProperty
        return false;
    }
    return false;
};
$6bbc137079526b2d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$6bbc137079526b2d$var$hasPropertyDescriptors()) return null;
    try {
        return $6bbc137079526b2d$var$$defineProperty([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $6bbc137079526b2d$var$hasPropertyDescriptors;

});
parcelRequire.register("gXypp", function(module, exports) {
"use strict";
var $c58cd8edc8aa2201$var$undefined;
var $c58cd8edc8aa2201$var$$SyntaxError = SyntaxError;
var $c58cd8edc8aa2201$var$$Function = Function;
var $c58cd8edc8aa2201$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $c58cd8edc8aa2201$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $c58cd8edc8aa2201$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $c58cd8edc8aa2201$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($c58cd8edc8aa2201$var$$gOPD) try {
    $c58cd8edc8aa2201$var$$gOPD({}, "");
} catch (e) {
    $c58cd8edc8aa2201$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $c58cd8edc8aa2201$var$throwTypeError = function() {
    throw new $c58cd8edc8aa2201$var$$TypeError();
};
var $c58cd8edc8aa2201$var$ThrowTypeError = $c58cd8edc8aa2201$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $c58cd8edc8aa2201$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $c58cd8edc8aa2201$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $c58cd8edc8aa2201$var$throwTypeError;
        }
    }
}() : $c58cd8edc8aa2201$var$throwTypeError;

var $c58cd8edc8aa2201$var$hasSymbols = (parcelRequire("eke6n"))();

var $c58cd8edc8aa2201$var$hasProto = (parcelRequire("6E1kU"))();
var $c58cd8edc8aa2201$var$getProto = Object.getPrototypeOf || ($c58cd8edc8aa2201$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $c58cd8edc8aa2201$var$needsEval = {};
var $c58cd8edc8aa2201$var$TypedArray = typeof Uint8Array === "undefined" || !$c58cd8edc8aa2201$var$getProto ? $c58cd8edc8aa2201$var$undefined : $c58cd8edc8aa2201$var$getProto(Uint8Array);
var $c58cd8edc8aa2201$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? $c58cd8edc8aa2201$var$undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? $c58cd8edc8aa2201$var$undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $c58cd8edc8aa2201$var$hasSymbols && $c58cd8edc8aa2201$var$getProto ? $c58cd8edc8aa2201$var$getProto([][Symbol.iterator]()) : $c58cd8edc8aa2201$var$undefined,
    "%AsyncFromSyncIteratorPrototype%": $c58cd8edc8aa2201$var$undefined,
    "%AsyncFunction%": $c58cd8edc8aa2201$var$needsEval,
    "%AsyncGenerator%": $c58cd8edc8aa2201$var$needsEval,
    "%AsyncGeneratorFunction%": $c58cd8edc8aa2201$var$needsEval,
    "%AsyncIteratorPrototype%": $c58cd8edc8aa2201$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? $c58cd8edc8aa2201$var$undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? $c58cd8edc8aa2201$var$undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? $c58cd8edc8aa2201$var$undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? $c58cd8edc8aa2201$var$undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? $c58cd8edc8aa2201$var$undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? $c58cd8edc8aa2201$var$undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? $c58cd8edc8aa2201$var$undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? $c58cd8edc8aa2201$var$undefined : FinalizationRegistry,
    "%Function%": $c58cd8edc8aa2201$var$$Function,
    "%GeneratorFunction%": $c58cd8edc8aa2201$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? $c58cd8edc8aa2201$var$undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? $c58cd8edc8aa2201$var$undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? $c58cd8edc8aa2201$var$undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $c58cd8edc8aa2201$var$hasSymbols && $c58cd8edc8aa2201$var$getProto ? $c58cd8edc8aa2201$var$getProto($c58cd8edc8aa2201$var$getProto([][Symbol.iterator]())) : $c58cd8edc8aa2201$var$undefined,
    "%JSON%": typeof JSON === "object" ? JSON : $c58cd8edc8aa2201$var$undefined,
    "%Map%": typeof Map === "undefined" ? $c58cd8edc8aa2201$var$undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$c58cd8edc8aa2201$var$hasSymbols || !$c58cd8edc8aa2201$var$getProto ? $c58cd8edc8aa2201$var$undefined : $c58cd8edc8aa2201$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? $c58cd8edc8aa2201$var$undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? $c58cd8edc8aa2201$var$undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? $c58cd8edc8aa2201$var$undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? $c58cd8edc8aa2201$var$undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$c58cd8edc8aa2201$var$hasSymbols || !$c58cd8edc8aa2201$var$getProto ? $c58cd8edc8aa2201$var$undefined : $c58cd8edc8aa2201$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? $c58cd8edc8aa2201$var$undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $c58cd8edc8aa2201$var$hasSymbols && $c58cd8edc8aa2201$var$getProto ? $c58cd8edc8aa2201$var$getProto(""[Symbol.iterator]()) : $c58cd8edc8aa2201$var$undefined,
    "%Symbol%": $c58cd8edc8aa2201$var$hasSymbols ? Symbol : $c58cd8edc8aa2201$var$undefined,
    "%SyntaxError%": $c58cd8edc8aa2201$var$$SyntaxError,
    "%ThrowTypeError%": $c58cd8edc8aa2201$var$ThrowTypeError,
    "%TypedArray%": $c58cd8edc8aa2201$var$TypedArray,
    "%TypeError%": $c58cd8edc8aa2201$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? $c58cd8edc8aa2201$var$undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? $c58cd8edc8aa2201$var$undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? $c58cd8edc8aa2201$var$undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? $c58cd8edc8aa2201$var$undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? $c58cd8edc8aa2201$var$undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? $c58cd8edc8aa2201$var$undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? $c58cd8edc8aa2201$var$undefined : WeakSet
};
if ($c58cd8edc8aa2201$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $c58cd8edc8aa2201$var$errorProto = $c58cd8edc8aa2201$var$getProto($c58cd8edc8aa2201$var$getProto(e));
    $c58cd8edc8aa2201$var$INTRINSICS["%Error.prototype%"] = $c58cd8edc8aa2201$var$errorProto;
}
var $c58cd8edc8aa2201$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $c58cd8edc8aa2201$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $c58cd8edc8aa2201$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $c58cd8edc8aa2201$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $c58cd8edc8aa2201$var$getProto) value = $c58cd8edc8aa2201$var$getProto(gen.prototype);
    }
    $c58cd8edc8aa2201$var$INTRINSICS[name] = value;
    return value;
};
var $c58cd8edc8aa2201$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $4QGjd = parcelRequire("4QGjd");

var $lkSdN = parcelRequire("lkSdN");
var $c58cd8edc8aa2201$var$$concat = $4QGjd.call(Function.call, Array.prototype.concat);
var $c58cd8edc8aa2201$var$$spliceApply = $4QGjd.call(Function.apply, Array.prototype.splice);
var $c58cd8edc8aa2201$var$$replace = $4QGjd.call(Function.call, String.prototype.replace);
var $c58cd8edc8aa2201$var$$strSlice = $4QGjd.call(Function.call, String.prototype.slice);
var $c58cd8edc8aa2201$var$$exec = $4QGjd.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $c58cd8edc8aa2201$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $c58cd8edc8aa2201$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $c58cd8edc8aa2201$var$stringToPath = function stringToPath(string) {
    var first = $c58cd8edc8aa2201$var$$strSlice(string, 0, 1);
    var last = $c58cd8edc8aa2201$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $c58cd8edc8aa2201$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $c58cd8edc8aa2201$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $c58cd8edc8aa2201$var$$replace(string, $c58cd8edc8aa2201$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $c58cd8edc8aa2201$var$$replace(subString, $c58cd8edc8aa2201$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $c58cd8edc8aa2201$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($lkSdN($c58cd8edc8aa2201$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $c58cd8edc8aa2201$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($lkSdN($c58cd8edc8aa2201$var$INTRINSICS, intrinsicName)) {
        var value = $c58cd8edc8aa2201$var$INTRINSICS[intrinsicName];
        if (value === $c58cd8edc8aa2201$var$needsEval) value = $c58cd8edc8aa2201$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $c58cd8edc8aa2201$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $c58cd8edc8aa2201$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $c58cd8edc8aa2201$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $c58cd8edc8aa2201$var$$TypeError('"allowMissing" argument must be a boolean');
    if ($c58cd8edc8aa2201$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $c58cd8edc8aa2201$var$$SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $c58cd8edc8aa2201$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $c58cd8edc8aa2201$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $c58cd8edc8aa2201$var$$spliceApply(parts, $c58cd8edc8aa2201$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $c58cd8edc8aa2201$var$$strSlice(part, 0, 1);
        var last = $c58cd8edc8aa2201$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $c58cd8edc8aa2201$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($lkSdN($c58cd8edc8aa2201$var$INTRINSICS, intrinsicRealName)) value = $c58cd8edc8aa2201$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $c58cd8edc8aa2201$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($c58cd8edc8aa2201$var$$gOPD && i + 1 >= parts.length) {
                var desc = $c58cd8edc8aa2201$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $lkSdN(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $c58cd8edc8aa2201$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRequire.register("eke6n", function(module, exports) {
"use strict";
var $a6dddf46cbc60e99$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $i50ZI = parcelRequire("i50ZI");
module.exports = function hasNativeSymbols() {
    if (typeof $a6dddf46cbc60e99$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $a6dddf46cbc60e99$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $i50ZI();
};

});
parcelRequire.register("i50ZI", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRequire.register("6E1kU", function(module, exports) {
"use strict";
var $4d6783db61916e66$var$test = {
    foo: {}
};
var $4d6783db61916e66$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $4d6783db61916e66$var$test
    }).foo === $4d6783db61916e66$var$test.foo && !(({
        __proto__: null
    }) instanceof $4d6783db61916e66$var$$Object);
};

});

parcelRequire.register("4QGjd", function(module, exports) {
"use strict";

var $diGNy = parcelRequire("diGNy");
module.exports = Function.prototype.bind || $diGNy;

});
parcelRequire.register("diGNy", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $9aee27a6038f9165$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $9aee27a6038f9165$var$slice = Array.prototype.slice;
var $9aee27a6038f9165$var$toStr = Object.prototype.toString;
var $9aee27a6038f9165$var$funcType = "[object Function]";
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $9aee27a6038f9165$var$toStr.call(target) !== $9aee27a6038f9165$var$funcType) throw new TypeError($9aee27a6038f9165$var$ERROR_MESSAGE + target);
    var args = $9aee27a6038f9165$var$slice.call(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat($9aee27a6038f9165$var$slice.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat($9aee27a6038f9165$var$slice.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push("$" + i);
    bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRequire.register("lkSdN", function(module, exports) {
"use strict";

var $4QGjd = parcelRequire("4QGjd");
module.exports = $4QGjd.call(Function.call, Object.prototype.hasOwnProperty);

});



parcelRequire.register("f5Ljh", function(module, exports) {
"use strict";

var $gXypp = parcelRequire("gXypp");

var $j2lnW = parcelRequire("j2lnW");
var $afcc05650747cbf7$var$$indexOf = $j2lnW($gXypp("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $gXypp(name, !!allowMissing);
    if (typeof intrinsic === "function" && $afcc05650747cbf7$var$$indexOf(name, ".prototype.") > -1) return $j2lnW(intrinsic);
    return intrinsic;
};

});
parcelRequire.register("j2lnW", function(module, exports) {
"use strict";

var $4QGjd = parcelRequire("4QGjd");

var $gXypp = parcelRequire("gXypp");
var $ddbecae150c6484a$var$$apply = $gXypp("%Function.prototype.apply%");
var $ddbecae150c6484a$var$$call = $gXypp("%Function.prototype.call%");
var $ddbecae150c6484a$var$$reflectApply = $gXypp("%Reflect.apply%", true) || $4QGjd.call($ddbecae150c6484a$var$$call, $ddbecae150c6484a$var$$apply);
var $ddbecae150c6484a$var$$gOPD = $gXypp("%Object.getOwnPropertyDescriptor%", true);
var $ddbecae150c6484a$var$$defineProperty = $gXypp("%Object.defineProperty%", true);
var $ddbecae150c6484a$var$$max = $gXypp("%Math.max%");
if ($ddbecae150c6484a$var$$defineProperty) try {
    $ddbecae150c6484a$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $ddbecae150c6484a$var$$defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    var func = $ddbecae150c6484a$var$$reflectApply($4QGjd, $ddbecae150c6484a$var$$call, arguments);
    if ($ddbecae150c6484a$var$$gOPD && $ddbecae150c6484a$var$$defineProperty) {
        var desc = $ddbecae150c6484a$var$$gOPD(func, "length");
        if (desc.configurable) // original length, plus the receiver, minus any additional arguments (after the receiver)
        $ddbecae150c6484a$var$$defineProperty(func, "length", {
            value: 1 + $ddbecae150c6484a$var$$max(0, originalFunction.length - (arguments.length - 1))
        });
    }
    return func;
};
var $ddbecae150c6484a$var$applyBind = function applyBind() {
    return $ddbecae150c6484a$var$$reflectApply($4QGjd, $ddbecae150c6484a$var$$apply, arguments);
};
if ($ddbecae150c6484a$var$$defineProperty) $ddbecae150c6484a$var$$defineProperty(module.exports, "apply", {
    value: $ddbecae150c6484a$var$applyBind
});
else module.exports.apply = $ddbecae150c6484a$var$applyBind;

});


parcelRequire.register("66x4O", function(module, exports) {
"use strict";
var $471cf5f4965c3b81$var$functionsHaveNames = function functionsHaveNames() {
    return typeof (function f() {}).name === "string";
};
var $471cf5f4965c3b81$var$gOPD = Object.getOwnPropertyDescriptor;
if ($471cf5f4965c3b81$var$gOPD) try {
    $471cf5f4965c3b81$var$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $471cf5f4965c3b81$var$gOPD = null;
}
$471cf5f4965c3b81$var$functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
    if (!$471cf5f4965c3b81$var$functionsHaveNames() || !$471cf5f4965c3b81$var$gOPD) return false;
    var desc = $471cf5f4965c3b81$var$gOPD(function() {}, "name");
    return !!desc && !!desc.configurable;
};
var $471cf5f4965c3b81$var$$bind = Function.prototype.bind;
$471cf5f4965c3b81$var$functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
    return $471cf5f4965c3b81$var$functionsHaveNames() && typeof $471cf5f4965c3b81$var$$bind === "function" && (function f() {}).bind().name !== "";
};
module.exports = $471cf5f4965c3b81$var$functionsHaveNames;

});

parcelRequire.register("4Jj9n", function(module, exports) {
// shim for using process in browser
var $371a3837fd81d701$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $371a3837fd81d701$var$cachedSetTimeout;
var $371a3837fd81d701$var$cachedClearTimeout;
function $371a3837fd81d701$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $371a3837fd81d701$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        else $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    } catch (e) {
        $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        else $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    } catch (e) {
        $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    }
})();
function $371a3837fd81d701$var$runTimeout(fun) {
    if ($371a3837fd81d701$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedSetTimeout === $371a3837fd81d701$var$defaultSetTimout || !$371a3837fd81d701$var$cachedSetTimeout) && setTimeout) {
        $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $371a3837fd81d701$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $371a3837fd81d701$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $371a3837fd81d701$var$runClearTimeout(marker) {
    if ($371a3837fd81d701$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedClearTimeout === $371a3837fd81d701$var$defaultClearTimeout || !$371a3837fd81d701$var$cachedClearTimeout) && clearTimeout) {
        $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $371a3837fd81d701$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $371a3837fd81d701$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $371a3837fd81d701$var$queue = [];
var $371a3837fd81d701$var$draining = false;
var $371a3837fd81d701$var$currentQueue;
var $371a3837fd81d701$var$queueIndex = -1;
function $371a3837fd81d701$var$cleanUpNextTick() {
    if (!$371a3837fd81d701$var$draining || !$371a3837fd81d701$var$currentQueue) return;
    $371a3837fd81d701$var$draining = false;
    if ($371a3837fd81d701$var$currentQueue.length) $371a3837fd81d701$var$queue = $371a3837fd81d701$var$currentQueue.concat($371a3837fd81d701$var$queue);
    else $371a3837fd81d701$var$queueIndex = -1;
    if ($371a3837fd81d701$var$queue.length) $371a3837fd81d701$var$drainQueue();
}
function $371a3837fd81d701$var$drainQueue() {
    if ($371a3837fd81d701$var$draining) return;
    var timeout = $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$cleanUpNextTick);
    $371a3837fd81d701$var$draining = true;
    var len = $371a3837fd81d701$var$queue.length;
    while(len){
        $371a3837fd81d701$var$currentQueue = $371a3837fd81d701$var$queue;
        $371a3837fd81d701$var$queue = [];
        while(++$371a3837fd81d701$var$queueIndex < len)if ($371a3837fd81d701$var$currentQueue) $371a3837fd81d701$var$currentQueue[$371a3837fd81d701$var$queueIndex].run();
        $371a3837fd81d701$var$queueIndex = -1;
        len = $371a3837fd81d701$var$queue.length;
    }
    $371a3837fd81d701$var$currentQueue = null;
    $371a3837fd81d701$var$draining = false;
    $371a3837fd81d701$var$runClearTimeout(timeout);
}
$371a3837fd81d701$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $371a3837fd81d701$var$queue.push(new $371a3837fd81d701$var$Item(fun, args));
    if ($371a3837fd81d701$var$queue.length === 1 && !$371a3837fd81d701$var$draining) $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$drainQueue);
};
// v8 likes predictible objects
function $371a3837fd81d701$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$371a3837fd81d701$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$371a3837fd81d701$var$process.title = "browser";
$371a3837fd81d701$var$process.browser = true;
$371a3837fd81d701$var$process.env = {};
$371a3837fd81d701$var$process.argv = [];
$371a3837fd81d701$var$process.version = ""; // empty string to avoid regexp issues
$371a3837fd81d701$var$process.versions = {};
function $371a3837fd81d701$var$noop() {}
$371a3837fd81d701$var$process.on = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.addListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.once = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.off = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeAllListeners = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.emit = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependOnceListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.listeners = function(name) {
    return [];
};
$371a3837fd81d701$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$371a3837fd81d701$var$process.cwd = function() {
    return "/";
};
$371a3837fd81d701$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$371a3837fd81d701$var$process.umask = function() {
    return 0;
};

});

parcelRequire.register("61Tck", function(module, exports) {
"use strict";

var $i50ZI = parcelRequire("i50ZI");
module.exports = function hasToStringTagShams() {
    return $i50ZI() && !!Symbol.toStringTag;
};

});

parcelRequire.register("40Tvb", function(module, exports) {
"use strict";

var $gXypp = parcelRequire("gXypp");

var $f5Ljh = parcelRequire("f5Ljh");

var $fENB6 = parcelRequire("fENB6");
var $2ec23708f8df4af8$var$$TypeError = $gXypp("%TypeError%");
var $2ec23708f8df4af8$var$$WeakMap = $gXypp("%WeakMap%", true);
var $2ec23708f8df4af8$var$$Map = $gXypp("%Map%", true);
var $2ec23708f8df4af8$var$$weakMapGet = $f5Ljh("WeakMap.prototype.get", true);
var $2ec23708f8df4af8$var$$weakMapSet = $f5Ljh("WeakMap.prototype.set", true);
var $2ec23708f8df4af8$var$$weakMapHas = $f5Ljh("WeakMap.prototype.has", true);
var $2ec23708f8df4af8$var$$mapGet = $f5Ljh("Map.prototype.get", true);
var $2ec23708f8df4af8$var$$mapSet = $f5Ljh("Map.prototype.set", true);
var $2ec23708f8df4af8$var$$mapHas = $f5Ljh("Map.prototype.has", true);
/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */ var $2ec23708f8df4af8$var$listGetNode = function(list, key) {
    for(var prev = list, curr; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        curr.next = list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
var $2ec23708f8df4af8$var$listGet = function(objects, key) {
    var node = $2ec23708f8df4af8$var$listGetNode(objects, key);
    return node && node.value;
};
var $2ec23708f8df4af8$var$listSet = function(objects, key, value) {
    var node = $2ec23708f8df4af8$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = {
        key: key,
        next: objects.next,
        value: value
    };
};
var $2ec23708f8df4af8$var$listHas = function(objects, key) {
    return !!$2ec23708f8df4af8$var$listGetNode(objects, key);
};
module.exports = function getSideChannel() {
    var $wm;
    var $m;
    var $o;
    var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $2ec23708f8df4af8$var$$TypeError("Side channel does not contain " + $fENB6(key));
        },
        get: function(key) {
            if ($2ec23708f8df4af8$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $2ec23708f8df4af8$var$$weakMapGet($wm, key);
            } else if ($2ec23708f8df4af8$var$$Map) {
                if ($m) return $2ec23708f8df4af8$var$$mapGet($m, key);
            } else {
                if ($o) return $2ec23708f8df4af8$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($2ec23708f8df4af8$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $2ec23708f8df4af8$var$$weakMapHas($wm, key);
            } else if ($2ec23708f8df4af8$var$$Map) {
                if ($m) return $2ec23708f8df4af8$var$$mapHas($m, key);
            } else {
                if ($o) return $2ec23708f8df4af8$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($2ec23708f8df4af8$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $2ec23708f8df4af8$var$$WeakMap();
                $2ec23708f8df4af8$var$$weakMapSet($wm, key, value);
            } else if ($2ec23708f8df4af8$var$$Map) {
                if (!$m) $m = new $2ec23708f8df4af8$var$$Map();
                $2ec23708f8df4af8$var$$mapSet($m, key, value);
            } else {
                if (!$o) /*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */ $o = {
                    key: {},
                    next: null
                };
                $2ec23708f8df4af8$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRequire.register("fENB6", function(module, exports) {
var $b661106fb308b99c$var$hasMap = typeof Map === "function" && Map.prototype;
var $b661106fb308b99c$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $b661106fb308b99c$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $b661106fb308b99c$var$mapSize = $b661106fb308b99c$var$hasMap && $b661106fb308b99c$var$mapSizeDescriptor && typeof $b661106fb308b99c$var$mapSizeDescriptor.get === "function" ? $b661106fb308b99c$var$mapSizeDescriptor.get : null;
var $b661106fb308b99c$var$mapForEach = $b661106fb308b99c$var$hasMap && Map.prototype.forEach;
var $b661106fb308b99c$var$hasSet = typeof Set === "function" && Set.prototype;
var $b661106fb308b99c$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $b661106fb308b99c$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $b661106fb308b99c$var$setSize = $b661106fb308b99c$var$hasSet && $b661106fb308b99c$var$setSizeDescriptor && typeof $b661106fb308b99c$var$setSizeDescriptor.get === "function" ? $b661106fb308b99c$var$setSizeDescriptor.get : null;
var $b661106fb308b99c$var$setForEach = $b661106fb308b99c$var$hasSet && Set.prototype.forEach;
var $b661106fb308b99c$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $b661106fb308b99c$var$weakMapHas = $b661106fb308b99c$var$hasWeakMap ? WeakMap.prototype.has : null;
var $b661106fb308b99c$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $b661106fb308b99c$var$weakSetHas = $b661106fb308b99c$var$hasWeakSet ? WeakSet.prototype.has : null;
var $b661106fb308b99c$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $b661106fb308b99c$var$weakRefDeref = $b661106fb308b99c$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $b661106fb308b99c$var$booleanValueOf = Boolean.prototype.valueOf;
var $b661106fb308b99c$var$objectToString = Object.prototype.toString;
var $b661106fb308b99c$var$functionToString = Function.prototype.toString;
var $b661106fb308b99c$var$$match = String.prototype.match;
var $b661106fb308b99c$var$$slice = String.prototype.slice;
var $b661106fb308b99c$var$$replace = String.prototype.replace;
var $b661106fb308b99c$var$$toUpperCase = String.prototype.toUpperCase;
var $b661106fb308b99c$var$$toLowerCase = String.prototype.toLowerCase;
var $b661106fb308b99c$var$$test = RegExp.prototype.test;
var $b661106fb308b99c$var$$concat = Array.prototype.concat;
var $b661106fb308b99c$var$$join = Array.prototype.join;
var $b661106fb308b99c$var$$arrSlice = Array.prototype.slice;
var $b661106fb308b99c$var$$floor = Math.floor;
var $b661106fb308b99c$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $b661106fb308b99c$var$gOPS = Object.getOwnPropertySymbols;
var $b661106fb308b99c$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $b661106fb308b99c$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $b661106fb308b99c$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $b661106fb308b99c$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $b661106fb308b99c$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $b661106fb308b99c$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $b661106fb308b99c$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $b661106fb308b99c$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$b661106fb308b99c$var$$floor(-num) : $b661106fb308b99c$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $b661106fb308b99c$var$$slice.call(str, intStr.length + 1);
            return $b661106fb308b99c$var$$replace.call(intStr, sepRegex, "$&_") + "." + $b661106fb308b99c$var$$replace.call($b661106fb308b99c$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $b661106fb308b99c$var$$replace.call(str, sepRegex, "$&_");
}

var $7SsmL = parcelRequire("7SsmL");
var $b661106fb308b99c$var$inspectCustom = $7SsmL.custom;
var $b661106fb308b99c$var$inspectSymbol = $b661106fb308b99c$var$isSymbol($b661106fb308b99c$var$inspectCustom) ? $b661106fb308b99c$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($b661106fb308b99c$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($b661106fb308b99c$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $b661106fb308b99c$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($b661106fb308b99c$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($b661106fb308b99c$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $b661106fb308b99c$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $b661106fb308b99c$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $b661106fb308b99c$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $b661106fb308b99c$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $b661106fb308b99c$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($b661106fb308b99c$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $b661106fb308b99c$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($b661106fb308b99c$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$b661106fb308b99c$var$isRegExp(obj)) {
        var name = $b661106fb308b99c$var$nameOf(obj);
        var keys = $b661106fb308b99c$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $b661106fb308b99c$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($b661106fb308b99c$var$isSymbol(obj)) {
        var symString = $b661106fb308b99c$var$hasShammedSymbols ? $b661106fb308b99c$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $b661106fb308b99c$var$symToString.call(obj);
        return typeof obj === "object" && !$b661106fb308b99c$var$hasShammedSymbols ? $b661106fb308b99c$var$markBoxed(symString) : symString;
    }
    if ($b661106fb308b99c$var$isElement(obj)) {
        var s = "<" + $b661106fb308b99c$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $b661106fb308b99c$var$wrapQuotes($b661106fb308b99c$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $b661106fb308b99c$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($b661106fb308b99c$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $b661106fb308b99c$var$arrObjKeys(obj, inspect);
        if (indent && !$b661106fb308b99c$var$singleLineValues(xs)) return "[" + $b661106fb308b99c$var$indentedJoin(xs, indent) + "]";
        return "[ " + $b661106fb308b99c$var$$join.call(xs, ", ") + " ]";
    }
    if ($b661106fb308b99c$var$isError(obj)) {
        var parts = $b661106fb308b99c$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$b661106fb308b99c$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $b661106fb308b99c$var$$join.call($b661106fb308b99c$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $b661106fb308b99c$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($b661106fb308b99c$var$inspectSymbol && typeof obj[$b661106fb308b99c$var$inspectSymbol] === "function" && $7SsmL) return $7SsmL(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($b661106fb308b99c$var$isMap(obj)) {
        var mapParts = [];
        if ($b661106fb308b99c$var$mapForEach) $b661106fb308b99c$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $b661106fb308b99c$var$collectionOf("Map", $b661106fb308b99c$var$mapSize.call(obj), mapParts, indent);
    }
    if ($b661106fb308b99c$var$isSet(obj)) {
        var setParts = [];
        if ($b661106fb308b99c$var$setForEach) $b661106fb308b99c$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $b661106fb308b99c$var$collectionOf("Set", $b661106fb308b99c$var$setSize.call(obj), setParts, indent);
    }
    if ($b661106fb308b99c$var$isWeakMap(obj)) return $b661106fb308b99c$var$weakCollectionOf("WeakMap");
    if ($b661106fb308b99c$var$isWeakSet(obj)) return $b661106fb308b99c$var$weakCollectionOf("WeakSet");
    if ($b661106fb308b99c$var$isWeakRef(obj)) return $b661106fb308b99c$var$weakCollectionOf("WeakRef");
    if ($b661106fb308b99c$var$isNumber(obj)) return $b661106fb308b99c$var$markBoxed(inspect(Number(obj)));
    if ($b661106fb308b99c$var$isBigInt(obj)) return $b661106fb308b99c$var$markBoxed(inspect($b661106fb308b99c$var$bigIntValueOf.call(obj)));
    if ($b661106fb308b99c$var$isBoolean(obj)) return $b661106fb308b99c$var$markBoxed($b661106fb308b99c$var$booleanValueOf.call(obj));
    if ($b661106fb308b99c$var$isString(obj)) return $b661106fb308b99c$var$markBoxed(inspect(String(obj)));
    if (!$b661106fb308b99c$var$isDate(obj) && !$b661106fb308b99c$var$isRegExp(obj)) {
        var ys = $b661106fb308b99c$var$arrObjKeys(obj, inspect);
        var isPlainObject = $b661106fb308b99c$var$gPO ? $b661106fb308b99c$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $b661106fb308b99c$var$toStringTag && Object(obj) === obj && $b661106fb308b99c$var$toStringTag in obj ? $b661106fb308b99c$var$$slice.call($b661106fb308b99c$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $b661106fb308b99c$var$$join.call($b661106fb308b99c$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $b661106fb308b99c$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $b661106fb308b99c$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $b661106fb308b99c$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $b661106fb308b99c$var$quote(s) {
    return $b661106fb308b99c$var$$replace.call(String(s), /"/g, "&quot;");
}
function $b661106fb308b99c$var$isArray(obj) {
    return $b661106fb308b99c$var$toStr(obj) === "[object Array]" && (!$b661106fb308b99c$var$toStringTag || !(typeof obj === "object" && $b661106fb308b99c$var$toStringTag in obj));
}
function $b661106fb308b99c$var$isDate(obj) {
    return $b661106fb308b99c$var$toStr(obj) === "[object Date]" && (!$b661106fb308b99c$var$toStringTag || !(typeof obj === "object" && $b661106fb308b99c$var$toStringTag in obj));
}
function $b661106fb308b99c$var$isRegExp(obj) {
    return $b661106fb308b99c$var$toStr(obj) === "[object RegExp]" && (!$b661106fb308b99c$var$toStringTag || !(typeof obj === "object" && $b661106fb308b99c$var$toStringTag in obj));
}
function $b661106fb308b99c$var$isError(obj) {
    return $b661106fb308b99c$var$toStr(obj) === "[object Error]" && (!$b661106fb308b99c$var$toStringTag || !(typeof obj === "object" && $b661106fb308b99c$var$toStringTag in obj));
}
function $b661106fb308b99c$var$isString(obj) {
    return $b661106fb308b99c$var$toStr(obj) === "[object String]" && (!$b661106fb308b99c$var$toStringTag || !(typeof obj === "object" && $b661106fb308b99c$var$toStringTag in obj));
}
function $b661106fb308b99c$var$isNumber(obj) {
    return $b661106fb308b99c$var$toStr(obj) === "[object Number]" && (!$b661106fb308b99c$var$toStringTag || !(typeof obj === "object" && $b661106fb308b99c$var$toStringTag in obj));
}
function $b661106fb308b99c$var$isBoolean(obj) {
    return $b661106fb308b99c$var$toStr(obj) === "[object Boolean]" && (!$b661106fb308b99c$var$toStringTag || !(typeof obj === "object" && $b661106fb308b99c$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $b661106fb308b99c$var$isSymbol(obj) {
    if ($b661106fb308b99c$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$b661106fb308b99c$var$symToString) return false;
    try {
        $b661106fb308b99c$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $b661106fb308b99c$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$b661106fb308b99c$var$bigIntValueOf) return false;
    try {
        $b661106fb308b99c$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $b661106fb308b99c$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $b661106fb308b99c$var$has(obj, key) {
    return $b661106fb308b99c$var$hasOwn.call(obj, key);
}
function $b661106fb308b99c$var$toStr(obj) {
    return $b661106fb308b99c$var$objectToString.call(obj);
}
function $b661106fb308b99c$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $b661106fb308b99c$var$$match.call($b661106fb308b99c$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $b661106fb308b99c$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $b661106fb308b99c$var$isMap(x) {
    if (!$b661106fb308b99c$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $b661106fb308b99c$var$mapSize.call(x);
        try {
            $b661106fb308b99c$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $b661106fb308b99c$var$isWeakMap(x) {
    if (!$b661106fb308b99c$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $b661106fb308b99c$var$weakMapHas.call(x, $b661106fb308b99c$var$weakMapHas);
        try {
            $b661106fb308b99c$var$weakSetHas.call(x, $b661106fb308b99c$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $b661106fb308b99c$var$isWeakRef(x) {
    if (!$b661106fb308b99c$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $b661106fb308b99c$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $b661106fb308b99c$var$isSet(x) {
    if (!$b661106fb308b99c$var$setSize || !x || typeof x !== "object") return false;
    try {
        $b661106fb308b99c$var$setSize.call(x);
        try {
            $b661106fb308b99c$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $b661106fb308b99c$var$isWeakSet(x) {
    if (!$b661106fb308b99c$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $b661106fb308b99c$var$weakSetHas.call(x, $b661106fb308b99c$var$weakSetHas);
        try {
            $b661106fb308b99c$var$weakMapHas.call(x, $b661106fb308b99c$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $b661106fb308b99c$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $b661106fb308b99c$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $b661106fb308b99c$var$inspectString($b661106fb308b99c$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $b661106fb308b99c$var$$replace.call($b661106fb308b99c$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $b661106fb308b99c$var$lowbyte);
    return $b661106fb308b99c$var$wrapQuotes(s, "single", opts);
}
function $b661106fb308b99c$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $b661106fb308b99c$var$$toUpperCase.call(n.toString(16));
}
function $b661106fb308b99c$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $b661106fb308b99c$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $b661106fb308b99c$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $b661106fb308b99c$var$indentedJoin(entries, indent) : $b661106fb308b99c$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $b661106fb308b99c$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($b661106fb308b99c$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $b661106fb308b99c$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $b661106fb308b99c$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $b661106fb308b99c$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $b661106fb308b99c$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $b661106fb308b99c$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $b661106fb308b99c$var$arrObjKeys(obj, inspect) {
    var isArr = $b661106fb308b99c$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $b661106fb308b99c$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $b661106fb308b99c$var$gOPS === "function" ? $b661106fb308b99c$var$gOPS(obj) : [];
    var symMap;
    if ($b661106fb308b99c$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$b661106fb308b99c$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($b661106fb308b99c$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($b661106fb308b99c$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $b661106fb308b99c$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($b661106fb308b99c$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRequire.register("7SsmL", function(module, exports) {
"use strict";

});



parcelRequire.register("5JxkD", function(module, exports) {
var $42cb02b8d969841b$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $42cb02b8d969841b$var$toString.call(arr) == "[object Array]";
};

});

parcelRequire.register("3jOv9", function(module, exports) {
"use strict";
var $26aa51fb98ba1969$var$strValue = String.prototype.valueOf;
var $26aa51fb98ba1969$var$tryStringObject = function tryStringObject(value) {
    try {
        $26aa51fb98ba1969$var$strValue.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $26aa51fb98ba1969$var$toStr = Object.prototype.toString;
var $26aa51fb98ba1969$var$strClass = "[object String]";

var $26aa51fb98ba1969$var$hasToStringTag = (parcelRequire("61Tck"))();
module.exports = function isString(value) {
    if (typeof value === "string") return true;
    if (typeof value !== "object") return false;
    return $26aa51fb98ba1969$var$hasToStringTag ? $26aa51fb98ba1969$var$tryStringObject(value) : $26aa51fb98ba1969$var$toStr.call(value) === $26aa51fb98ba1969$var$strClass;
};

});

parcelRequire.register("3GgX7", function(module, exports) {
"use strict";
var $2ae271bf79e16507$var$$Map = typeof Map === "function" && Map.prototype ? Map : null;
var $2ae271bf79e16507$var$$Set = typeof Set === "function" && Set.prototype ? Set : null;
var $2ae271bf79e16507$var$exported;
if (!$2ae271bf79e16507$var$$Map) // eslint-disable-next-line no-unused-vars
$2ae271bf79e16507$var$exported = function isMap(x) {
    // `Map` is not present in this environment.
    return false;
};
var $2ae271bf79e16507$var$$mapHas = $2ae271bf79e16507$var$$Map ? Map.prototype.has : null;
var $2ae271bf79e16507$var$$setHas = $2ae271bf79e16507$var$$Set ? Set.prototype.has : null;
if (!$2ae271bf79e16507$var$exported && !$2ae271bf79e16507$var$$mapHas) // eslint-disable-next-line no-unused-vars
$2ae271bf79e16507$var$exported = function isMap(x) {
    // `Map` does not have a `has` method
    return false;
};
module.exports = $2ae271bf79e16507$var$exported || function isMap(x) {
    if (!x || typeof x !== "object") return false;
    try {
        $2ae271bf79e16507$var$$mapHas.call(x);
        if ($2ae271bf79e16507$var$$setHas) try {
            $2ae271bf79e16507$var$$setHas.call(x);
        } catch (e) {
            return true;
        }
        return x instanceof $2ae271bf79e16507$var$$Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
};

});

parcelRequire.register("c2Ook", function(module, exports) {
"use strict";
var $8c4cc29f733aab33$var$$Map = typeof Map === "function" && Map.prototype ? Map : null;
var $8c4cc29f733aab33$var$$Set = typeof Set === "function" && Set.prototype ? Set : null;
var $8c4cc29f733aab33$var$exported;
if (!$8c4cc29f733aab33$var$$Set) // eslint-disable-next-line no-unused-vars
$8c4cc29f733aab33$var$exported = function isSet(x) {
    // `Set` is not present in this environment.
    return false;
};
var $8c4cc29f733aab33$var$$mapHas = $8c4cc29f733aab33$var$$Map ? Map.prototype.has : null;
var $8c4cc29f733aab33$var$$setHas = $8c4cc29f733aab33$var$$Set ? Set.prototype.has : null;
if (!$8c4cc29f733aab33$var$exported && !$8c4cc29f733aab33$var$$setHas) // eslint-disable-next-line no-unused-vars
$8c4cc29f733aab33$var$exported = function isSet(x) {
    // `Set` does not have a `has` method
    return false;
};
module.exports = $8c4cc29f733aab33$var$exported || function isSet(x) {
    if (!x || typeof x !== "object") return false;
    try {
        $8c4cc29f733aab33$var$$setHas.call(x);
        if ($8c4cc29f733aab33$var$$mapHas) try {
            $8c4cc29f733aab33$var$$mapHas.call(x);
        } catch (e) {
            return true;
        }
        return x instanceof $8c4cc29f733aab33$var$$Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
};

});

parcelRequire.register("h6a0S", function(module, exports) {
"use strict";
var $c72ac39ae62a3d11$var$$BigInt = typeof BigInt !== "undefined" && BigInt;
module.exports = function hasNativeBigInts() {
    return typeof $c72ac39ae62a3d11$var$$BigInt === "function" && typeof BigInt === "function" && typeof $c72ac39ae62a3d11$var$$BigInt(42) === "bigint" // eslint-disable-line no-magic-numbers
     && typeof BigInt(42) === "bigint"; // eslint-disable-line no-magic-numbers
};

});

parcelRequire.register("f9x8D", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("1Zafa")).resolve("gBuiE")),
    import("./" + (parcelRequire("1Zafa")).resolve("hTTPc"))
]).then(()=>parcelRequire("jHANW"));

});

parcelRequire.register("6Gk4g", function(module, exports) {




module.exports = Promise.all([
    import("./" + (parcelRequire("1Zafa")).resolve("8xDPs")),
    import("./" + (parcelRequire("1Zafa")).resolve("gBuiE")),
    import("./" + (parcelRequire("1Zafa")).resolve("hTTPc")),
    import("./" + (parcelRequire("1Zafa")).resolve("96pOy"))
]).then(()=>parcelRequire("8e2sZ"));

});

parcelRequire.register("32IhZ", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("1Zafa")).resolve("gBuiE")),
    import("./" + (parcelRequire("1Zafa")).resolve("8xDPs"))
]).then(()=>parcelRequire("bveFi"));

});

parcelRequire.register("l2fOX", function(module, exports) {





module.exports = Promise.all([
    import("./" + (parcelRequire("1Zafa")).resolve("8xDPs")),
    import("./" + (parcelRequire("1Zafa")).resolve("96pOy")),
    import("./" + (parcelRequire("1Zafa")).resolve("gBuiE")),
    import("./" + (parcelRequire("1Zafa")).resolve("hTTPc")),
    import("./" + (parcelRequire("1Zafa")).resolve("7Ayic"))
]).then(()=>parcelRequire("47LfZ"));

});

var $110956e5e1cd1426$exports = {};
"use strict";

$110956e5e1cd1426$exports = (parcelRequire("4Bxju"));



var $k116o = parcelRequire("k116o");
var $76965258e0e6e98a$export$882461b6382ed46c;
var $76965258e0e6e98a$export$757ceba2d55c277e;
"use strict";
var $24f93cb6581801da$exports = {};
"use strict";
function $24f93cb6581801da$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($24f93cb6581801da$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$24f93cb6581801da$var$checkDCE();

$24f93cb6581801da$exports = (parcelRequire("11Y1g"));


var $76965258e0e6e98a$var$i;
$76965258e0e6e98a$export$882461b6382ed46c = $24f93cb6581801da$exports.createRoot;
$76965258e0e6e98a$export$757ceba2d55c277e = $24f93cb6581801da$exports.hydrateRoot;


/**
 * React Router DOM v6.14.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $k116o = parcelRequire("k116o");
/**
 * @remix-run/router v1.7.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $d64590e8ac5fce5b$var$_extends() {
    $d64590e8ac5fce5b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d64590e8ac5fce5b$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $d64590e8ac5fce5b$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($d64590e8ac5fce5b$export$e19cd5f9376f8cee || ($d64590e8ac5fce5b$export$e19cd5f9376f8cee = {}));
const $d64590e8ac5fce5b$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $d64590e8ac5fce5b$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $d64590e8ac5fce5b$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $d64590e8ac5fce5b$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $d64590e8ac5fce5b$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $d64590e8ac5fce5b$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $d64590e8ac5fce5b$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $d64590e8ac5fce5b$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $d64590e8ac5fce5b$export$fe53371bee54353d(to);
    }
    return $d64590e8ac5fce5b$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $d64590e8ac5fce5b$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $d64590e8ac5fce5b$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $d64590e8ac5fce5b$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $d64590e8ac5fce5b$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $d64590e8ac5fce5b$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $d64590e8ac5fce5b$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $d64590e8ac5fce5b$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $d64590e8ac5fce5b$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $d64590e8ac5fce5b$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $d64590e8ac5fce5b$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $d64590e8ac5fce5b$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $d64590e8ac5fce5b$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $d64590e8ac5fce5b$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $d64590e8ac5fce5b$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $d64590e8ac5fce5b$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $d64590e8ac5fce5b$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $d64590e8ac5fce5b$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($d64590e8ac5fce5b$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Push;
        let location = $d64590e8ac5fce5b$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $d64590e8ac5fce5b$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Replace;
        let location = $d64590e8ac5fce5b$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $d64590e8ac5fce5b$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $d64590e8ac5fce5b$export$fe53371bee54353d(to);
        $d64590e8ac5fce5b$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($d64590e8ac5fce5b$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($d64590e8ac5fce5b$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $d64590e8ac5fce5b$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($d64590e8ac5fce5b$var$ResultType || ($d64590e8ac5fce5b$var$ResultType = {}));
const $d64590e8ac5fce5b$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $d64590e8ac5fce5b$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $d64590e8ac5fce5b$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $d64590e8ac5fce5b$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $d64590e8ac5fce5b$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($d64590e8ac5fce5b$var$isIndexRoute(route)) {
            let indexRoute = $d64590e8ac5fce5b$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $d64590e8ac5fce5b$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $d64590e8ac5fce5b$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $d64590e8ac5fce5b$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $d64590e8ac5fce5b$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $d64590e8ac5fce5b$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $d64590e8ac5fce5b$var$flattenRoutes(routes);
    $d64590e8ac5fce5b$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $d64590e8ac5fce5b$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $d64590e8ac5fce5b$var$safelyDecodeURI(pathname));
    return matches;
}
function $d64590e8ac5fce5b$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $d64590e8ac5fce5b$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $d64590e8ac5fce5b$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $d64590e8ac5fce5b$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $d64590e8ac5fce5b$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $d64590e8ac5fce5b$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $d64590e8ac5fce5b$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $d64590e8ac5fce5b$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $d64590e8ac5fce5b$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $d64590e8ac5fce5b$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $d64590e8ac5fce5b$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $d64590e8ac5fce5b$var$paramRe = /^:\w+$/;
const $d64590e8ac5fce5b$var$dynamicSegmentValue = 3;
const $d64590e8ac5fce5b$var$indexRouteValue = 2;
const $d64590e8ac5fce5b$var$emptySegmentValue = 1;
const $d64590e8ac5fce5b$var$staticSegmentValue = 10;
const $d64590e8ac5fce5b$var$splatPenalty = -2;
const $d64590e8ac5fce5b$var$isSplat = (s)=>s === "*";
function $d64590e8ac5fce5b$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($d64590e8ac5fce5b$var$isSplat)) initialScore += $d64590e8ac5fce5b$var$splatPenalty;
    if (index) initialScore += $d64590e8ac5fce5b$var$indexRouteValue;
    return segments.filter((s)=>!$d64590e8ac5fce5b$var$isSplat(s)).reduce((score, segment)=>score + ($d64590e8ac5fce5b$var$paramRe.test(segment) ? $d64590e8ac5fce5b$var$dynamicSegmentValue : segment === "" ? $d64590e8ac5fce5b$var$emptySegmentValue : $d64590e8ac5fce5b$var$staticSegmentValue), initialScore);
}
function $d64590e8ac5fce5b$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $d64590e8ac5fce5b$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $d64590e8ac5fce5b$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $d64590e8ac5fce5b$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $d64590e8ac5fce5b$export$a5c6d149b50c1d86($d64590e8ac5fce5b$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $d64590e8ac5fce5b$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $d64590e8ac5fce5b$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $d64590e8ac5fce5b$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $d64590e8ac5fce5b$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $d64590e8ac5fce5b$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $d64590e8ac5fce5b$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $d64590e8ac5fce5b$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $d64590e8ac5fce5b$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $d64590e8ac5fce5b$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $d64590e8ac5fce5b$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $d64590e8ac5fce5b$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $d64590e8ac5fce5b$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $d64590e8ac5fce5b$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $d64590e8ac5fce5b$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $d64590e8ac5fce5b$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $d64590e8ac5fce5b$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $d64590e8ac5fce5b$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $d64590e8ac5fce5b$var$normalizeSearch(search),
        hash: $d64590e8ac5fce5b$var$normalizeHash(hash)
    };
}
function $d64590e8ac5fce5b$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $d64590e8ac5fce5b$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $d64590e8ac5fce5b$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $d64590e8ac5fce5b$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $d64590e8ac5fce5b$export$8ccf933b0513f8d0(toArg);
    else {
        to = $d64590e8ac5fce5b$var$_extends({}, toArg);
        $d64590e8ac5fce5b$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $d64590e8ac5fce5b$var$getInvalidPathError("?", "pathname", "search", to));
        $d64590e8ac5fce5b$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $d64590e8ac5fce5b$var$getInvalidPathError("#", "pathname", "hash", to));
        $d64590e8ac5fce5b$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $d64590e8ac5fce5b$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $d64590e8ac5fce5b$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $d64590e8ac5fce5b$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $d64590e8ac5fce5b$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $d64590e8ac5fce5b$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $d64590e8ac5fce5b$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $d64590e8ac5fce5b$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $d64590e8ac5fce5b$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $d64590e8ac5fce5b$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $d64590e8ac5fce5b$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $d64590e8ac5fce5b$export$42a99a7a4bc0e76a extends Error {
}
class $d64590e8ac5fce5b$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $d64590e8ac5fce5b$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $d64590e8ac5fce5b$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $d64590e8ac5fce5b$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $d64590e8ac5fce5b$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $d64590e8ac5fce5b$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $d64590e8ac5fce5b$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $d64590e8ac5fce5b$var$unwrapTrackedPromise(value) {
    if (!$d64590e8ac5fce5b$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $d64590e8ac5fce5b$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $d64590e8ac5fce5b$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $d64590e8ac5fce5b$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $d64590e8ac5fce5b$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $d64590e8ac5fce5b$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $d64590e8ac5fce5b$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $d64590e8ac5fce5b$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $d64590e8ac5fce5b$var$validMutationMethods = new Set($d64590e8ac5fce5b$var$validMutationMethodsArr);
const $d64590e8ac5fce5b$var$validRequestMethodsArr = [
    "get",
    ...$d64590e8ac5fce5b$var$validMutationMethodsArr
];
const $d64590e8ac5fce5b$var$validRequestMethods = new Set($d64590e8ac5fce5b$var$validRequestMethodsArr);
const $d64590e8ac5fce5b$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $d64590e8ac5fce5b$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $d64590e8ac5fce5b$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $d64590e8ac5fce5b$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $d64590e8ac5fce5b$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $d64590e8ac5fce5b$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $d64590e8ac5fce5b$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $d64590e8ac5fce5b$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $d64590e8ac5fce5b$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $d64590e8ac5fce5b$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $d64590e8ac5fce5b$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $d64590e8ac5fce5b$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $d64590e8ac5fce5b$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $d64590e8ac5fce5b$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $d64590e8ac5fce5b$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $d64590e8ac5fce5b$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $d64590e8ac5fce5b$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $d64590e8ac5fce5b$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($d64590e8ac5fce5b$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $d64590e8ac5fce5b$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $d64590e8ac5fce5b$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $d64590e8ac5fce5b$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $d64590e8ac5fce5b$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $d64590e8ac5fce5b$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        updateState($d64590e8ac5fce5b$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $d64590e8ac5fce5b$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }));
        // Reset stateful navigation vars
        pendingAction = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $d64590e8ac5fce5b$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $d64590e8ac5fce5b$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $d64590e8ac5fce5b$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $d64590e8ac5fce5b$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $d64590e8ac5fce5b$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $d64590e8ac5fce5b$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $d64590e8ac5fce5b$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $d64590e8ac5fce5b$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $d64590e8ac5fce5b$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $d64590e8ac5fce5b$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $d64590e8ac5fce5b$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $d64590e8ac5fce5b$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$d64590e8ac5fce5b$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $d64590e8ac5fce5b$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $d64590e8ac5fce5b$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $d64590e8ac5fce5b$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $d64590e8ac5fce5b$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $d64590e8ac5fce5b$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $d64590e8ac5fce5b$var$ResultType.error,
            error: $d64590e8ac5fce5b$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $d64590e8ac5fce5b$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($d64590e8ac5fce5b$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($d64590e8ac5fce5b$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $d64590e8ac5fce5b$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($d64590e8ac5fce5b$var$isDeferredResult(result)) throw $d64590e8ac5fce5b$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $d64590e8ac5fce5b$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $d64590e8ac5fce5b$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $d64590e8ac5fce5b$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $d64590e8ac5fce5b$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $d64590e8ac5fce5b$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($d64590e8ac5fce5b$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $d64590e8ac5fce5b$var$findRedirect(results);
        if (redirect) {
            await startRedirectNavigation(state, redirect, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $d64590e8ac5fce5b$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $d64590e8ac5fce5b$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $d64590e8ac5fce5b$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $d64590e8ac5fce5b$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $d64590e8ac5fce5b$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $d64590e8ac5fce5b$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $d64590e8ac5fce5b$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $d64590e8ac5fce5b$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $d64590e8ac5fce5b$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $d64590e8ac5fce5b$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $d64590e8ac5fce5b$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $d64590e8ac5fce5b$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await $d64590e8ac5fce5b$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($d64590e8ac5fce5b$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = $d64590e8ac5fce5b$var$getLoadingFetcher(submission);
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return startRedirectNavigation(state, actionResult, {
                submission: submission,
                isFetchActionRedirect: true
            });
        }
        // Process any non-redirect errors thrown
        if ($d64590e8ac5fce5b$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($d64590e8ac5fce5b$var$isDeferredResult(actionResult)) throw $d64590e8ac5fce5b$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $d64590e8ac5fce5b$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $d64590e8ac5fce5b$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $d64590e8ac5fce5b$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $d64590e8ac5fce5b$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $d64590e8ac5fce5b$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $d64590e8ac5fce5b$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $d64590e8ac5fce5b$var$findRedirect(results);
        if (redirect) return startRedirectNavigation(state, redirect);
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $d64590e8ac5fce5b$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $d64590e8ac5fce5b$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $d64590e8ac5fce5b$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($d64590e8ac5fce5b$var$_extends({
                errors: errors,
                loaderData: $d64590e8ac5fce5b$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $d64590e8ac5fce5b$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $d64590e8ac5fce5b$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await $d64590e8ac5fce5b$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($d64590e8ac5fce5b$var$isDeferredResult(result)) result = await $d64590e8ac5fce5b$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($d64590e8ac5fce5b$var$isRedirectResult(result)) {
            fetchRedirectIds.add(key);
            await startRedirectNavigation(state, result);
            return;
        }
        // Process any non-redirect errors thrown
        if ($d64590e8ac5fce5b$var$isErrorResult(result)) {
            let boundaryMatch = $d64590e8ac5fce5b$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $d64590e8ac5fce5b$export$3e9cee6b33872309(!$d64590e8ac5fce5b$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $d64590e8ac5fce5b$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, replace: replace, isFetchActionRedirect: isFetchActionRedirect } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $d64590e8ac5fce5b$var$createLocation(state.location, redirect.location, $d64590e8ac5fce5b$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $d64590e8ac5fce5b$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        // Check if this an absolute external redirect that goes to a new origin
        if ($d64590e8ac5fce5b$var$ABSOLUTE_URL_REGEX.test(redirect.location) && isBrowser) {
            let url = init.history.createURL(redirect.location);
            let isDifferentBasename = $d64590e8ac5fce5b$export$b69e3301ce081aa3(url.pathname, basename) == null;
            if (routerWindow.location.origin !== url.origin || isDifferentBasename) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Replace : $d64590e8ac5fce5b$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let activeSubmission = submission || $d64590e8ac5fce5b$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($d64590e8ac5fce5b$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $d64590e8ac5fce5b$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $d64590e8ac5fce5b$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else if (isFetchActionRedirect) // For a fetch action redirect, we kick off a new loading navigation
        // without the fetcher submission, but we send it along for shouldRevalidate
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: $d64590e8ac5fce5b$var$getLoadingNavigation(redirectLocation),
            fetcherSubmission: activeSubmission,
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a submission, we will preserve it through the redirect navigation
            let overrideNavigation = $d64590e8ac5fce5b$var$getLoadingNavigation(redirectLocation, activeSubmission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$d64590e8ac5fce5b$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $d64590e8ac5fce5b$var$callLoaderOrAction("loader", $d64590e8ac5fce5b$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $d64590e8ac5fce5b$var$ResultType.error,
                        error: $d64590e8ac5fce5b$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $d64590e8ac5fce5b$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $d64590e8ac5fce5b$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $d64590e8ac5fce5b$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $d64590e8ac5fce5b$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $d64590e8ac5fce5b$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $d64590e8ac5fce5b$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $d64590e8ac5fce5b$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $d64590e8ac5fce5b$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $d64590e8ac5fce5b$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $d64590e8ac5fce5b$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $d64590e8ac5fce5b$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $d64590e8ac5fce5b$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$d64590e8ac5fce5b$var$createUseMatchesMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $d64590e8ac5fce5b$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $d64590e8ac5fce5b$export$4d0306f8f6a4585b = Symbol("deferred");
function $d64590e8ac5fce5b$export$3336b097a6fbc59a(routes, opts) {
    $d64590e8ac5fce5b$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $d64590e8ac5fce5b$var$defaultMapRouteProperties;
    let dataRoutes = $d64590e8ac5fce5b$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $d64590e8ac5fce5b$var$createLocation("", $d64590e8ac5fce5b$export$fe53371bee54353d(url), null, "default");
        let matches = $d64590e8ac5fce5b$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$d64590e8ac5fce5b$var$isValidMethod(method) && method !== "HEAD") {
            let error = $d64590e8ac5fce5b$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $d64590e8ac5fce5b$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $d64590e8ac5fce5b$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $d64590e8ac5fce5b$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($d64590e8ac5fce5b$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $d64590e8ac5fce5b$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $d64590e8ac5fce5b$var$createLocation("", $d64590e8ac5fce5b$export$fe53371bee54353d(url), null, "default");
        let matches = $d64590e8ac5fce5b$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$d64590e8ac5fce5b$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $d64590e8ac5fce5b$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $d64590e8ac5fce5b$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $d64590e8ac5fce5b$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $d64590e8ac5fce5b$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $d64590e8ac5fce5b$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($d64590e8ac5fce5b$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$d64590e8ac5fce5b$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $d64590e8ac5fce5b$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($d64590e8ac5fce5b$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $d64590e8ac5fce5b$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $d64590e8ac5fce5b$var$isResponse(result) ? result : $d64590e8ac5fce5b$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($d64590e8ac5fce5b$var$isQueryRouteResponse(e)) {
                if (e.type === $d64590e8ac5fce5b$var$ResultType.error && !$d64590e8ac5fce5b$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($d64590e8ac5fce5b$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $d64590e8ac5fce5b$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $d64590e8ac5fce5b$var$ResultType.error,
                error: error
            };
        } else {
            result = await $d64590e8ac5fce5b$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($d64590e8ac5fce5b$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($d64590e8ac5fce5b$var$isDeferredResult(result)) {
            let error = $d64590e8ac5fce5b$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $d64590e8ac5fce5b$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($d64590e8ac5fce5b$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($d64590e8ac5fce5b$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $d64590e8ac5fce5b$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $d64590e8ac5fce5b$var$_extends({}, context, {
                statusCode: $d64590e8ac5fce5b$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $d64590e8ac5fce5b$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $d64590e8ac5fce5b$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $d64590e8ac5fce5b$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $d64590e8ac5fce5b$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $d64590e8ac5fce5b$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$d64590e8ac5fce5b$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $d64590e8ac5fce5b$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $d64590e8ac5fce5b$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $d64590e8ac5fce5b$export$fec11da027c70692(routes, context, error) {
    let newContext = $d64590e8ac5fce5b$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $d64590e8ac5fce5b$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $d64590e8ac5fce5b$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $d64590e8ac5fce5b$export$cae722b0cc860f13(to ? to : ".", $d64590e8ac5fce5b$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $d64590e8ac5fce5b$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$d64590e8ac5fce5b$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $d64590e8ac5fce5b$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $d64590e8ac5fce5b$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $d64590e8ac5fce5b$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$d64590e8ac5fce5b$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$d64590e8ac5fce5b$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $d64590e8ac5fce5b$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $d64590e8ac5fce5b$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $d64590e8ac5fce5b$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$d64590e8ac5fce5b$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$d64590e8ac5fce5b$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $d64590e8ac5fce5b$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $d64590e8ac5fce5b$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $d64590e8ac5fce5b$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $d64590e8ac5fce5b$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $d64590e8ac5fce5b$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($d64590e8ac5fce5b$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $d64590e8ac5fce5b$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $d64590e8ac5fce5b$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $d64590e8ac5fce5b$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $d64590e8ac5fce5b$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $d64590e8ac5fce5b$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $d64590e8ac5fce5b$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($d64590e8ac5fce5b$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $d64590e8ac5fce5b$var$shouldRevalidateLoader(match, $d64590e8ac5fce5b$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $d64590e8ac5fce5b$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $d64590e8ac5fce5b$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They only set `defaultShouldRevalidate` on
        // explicit revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        //
        // They automatically revalidate without even calling shouldRevalidate if:
        // - They were cancelled
        // - They're in the middle of their first load and therefore this is still
        //   an initial load and not a revalidation
        //
        // If neither of those is true, then they _always_ check shouldRevalidate
        let fetcher = state.fetchers.get(key);
        let isPerformingInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === undefined && // If a fetcher.load redirected then it'll be "loading" without any data
        // so ensure we're not processing the redirect from this fetcher
        !fetchRedirectIds.has(key);
        let fetcherMatch = $d64590e8ac5fce5b$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = cancelledFetcherLoads.includes(key) || isPerformingInitialLoad || $d64590e8ac5fce5b$var$shouldRevalidateLoader(fetcherMatch, $d64590e8ac5fce5b$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $d64590e8ac5fce5b$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $d64590e8ac5fce5b$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $d64590e8ac5fce5b$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $d64590e8ac5fce5b$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $d64590e8ac5fce5b$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $d64590e8ac5fce5b$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$d64590e8ac5fce5b$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $d64590e8ac5fce5b$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $d64590e8ac5fce5b$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let values = await Promise.all([
                    runHandler(handler),
                    $d64590e8ac5fce5b$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $d64590e8ac5fce5b$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $d64590e8ac5fce5b$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $d64590e8ac5fce5b$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $d64590e8ac5fce5b$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $d64590e8ac5fce5b$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $d64590e8ac5fce5b$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($d64590e8ac5fce5b$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($d64590e8ac5fce5b$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $d64590e8ac5fce5b$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$d64590e8ac5fce5b$var$ABSOLUTE_URL_REGEX.test(location)) location = $d64590e8ac5fce5b$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $d64590e8ac5fce5b$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $d64590e8ac5fce5b$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $d64590e8ac5fce5b$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $d64590e8ac5fce5b$var$ResultType.error) return {
            type: resultType,
            error: new $d64590e8ac5fce5b$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $d64590e8ac5fce5b$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $d64590e8ac5fce5b$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($d64590e8ac5fce5b$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $d64590e8ac5fce5b$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $d64590e8ac5fce5b$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $d64590e8ac5fce5b$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($d64590e8ac5fce5b$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $d64590e8ac5fce5b$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $d64590e8ac5fce5b$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $d64590e8ac5fce5b$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $d64590e8ac5fce5b$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $d64590e8ac5fce5b$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $d64590e8ac5fce5b$export$3e9cee6b33872309(!$d64590e8ac5fce5b$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($d64590e8ac5fce5b$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $d64590e8ac5fce5b$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $d64590e8ac5fce5b$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($d64590e8ac5fce5b$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $d64590e8ac5fce5b$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $d64590e8ac5fce5b$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $d64590e8ac5fce5b$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($d64590e8ac5fce5b$var$isErrorResult(result)) {
            let boundaryMatch = $d64590e8ac5fce5b$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $d64590e8ac5fce5b$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($d64590e8ac5fce5b$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $d64590e8ac5fce5b$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($d64590e8ac5fce5b$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $d64590e8ac5fce5b$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $d64590e8ac5fce5b$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $d64590e8ac5fce5b$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $d64590e8ac5fce5b$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $d64590e8ac5fce5b$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $d64590e8ac5fce5b$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $d64590e8ac5fce5b$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $d64590e8ac5fce5b$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $d64590e8ac5fce5b$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($d64590e8ac5fce5b$var$isRedirectResult(result)) return result;
    }
}
function $d64590e8ac5fce5b$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $d64590e8ac5fce5b$export$8ccf933b0513f8d0(path) : path;
    return $d64590e8ac5fce5b$export$fe53371bee54353d($d64590e8ac5fce5b$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $d64590e8ac5fce5b$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $d64590e8ac5fce5b$var$isDeferredResult(result) {
    return result.type === $d64590e8ac5fce5b$var$ResultType.deferred;
}
function $d64590e8ac5fce5b$var$isErrorResult(result) {
    return result.type === $d64590e8ac5fce5b$var$ResultType.error;
}
function $d64590e8ac5fce5b$var$isRedirectResult(result) {
    return (result && result.type) === $d64590e8ac5fce5b$var$ResultType.redirect;
}
function $d64590e8ac5fce5b$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $d64590e8ac5fce5b$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $d64590e8ac5fce5b$var$isRedirectResponse(result) {
    if (!$d64590e8ac5fce5b$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $d64590e8ac5fce5b$var$isQueryRouteResponse(obj) {
    return obj && $d64590e8ac5fce5b$var$isResponse(obj.response) && (obj.type === $d64590e8ac5fce5b$var$ResultType.data || $d64590e8ac5fce5b$var$ResultType.error);
}
function $d64590e8ac5fce5b$var$isValidMethod(method) {
    return $d64590e8ac5fce5b$var$validRequestMethods.has(method.toLowerCase());
}
function $d64590e8ac5fce5b$var$isMutationMethod(method) {
    return $d64590e8ac5fce5b$var$validMutationMethods.has(method.toLowerCase());
}
async function $d64590e8ac5fce5b$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$d64590e8ac5fce5b$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($d64590e8ac5fce5b$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $d64590e8ac5fce5b$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $d64590e8ac5fce5b$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $d64590e8ac5fce5b$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $d64590e8ac5fce5b$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $d64590e8ac5fce5b$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $d64590e8ac5fce5b$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $d64590e8ac5fce5b$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
// Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $d64590e8ac5fce5b$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $d64590e8ac5fce5b$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $d64590e8ac5fce5b$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $d64590e8ac5fce5b$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $d64590e8ac5fce5b$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $d64590e8ac5fce5b$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $d64590e8ac5fce5b$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $d64590e8ac5fce5b$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $d64590e8ac5fce5b$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher;
    }
}
function $d64590e8ac5fce5b$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}
function $d64590e8ac5fce5b$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}

/**
 * React Router v6.14.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $k116o = parcelRequire("k116o");

function $f6bd5ad5dd65be62$var$_extends() {
    $f6bd5ad5dd65be62$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f6bd5ad5dd65be62$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $f6bd5ad5dd65be62$export$3add0d5dce533e2e = /*#__PURE__*/ $k116o.createContext(null);
const $f6bd5ad5dd65be62$export$145dfa71566a64dc = /*#__PURE__*/ $k116o.createContext(null);
const $f6bd5ad5dd65be62$var$AwaitContext = /*#__PURE__*/ $k116o.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $f6bd5ad5dd65be62$export$26749e8557646306 = /*#__PURE__*/ $k116o.createContext(null);
const $f6bd5ad5dd65be62$export$c7914228fb69b0f5 = /*#__PURE__*/ $k116o.createContext(null);
const $f6bd5ad5dd65be62$export$9072aa6dd1f93057 = /*#__PURE__*/ $k116o.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $f6bd5ad5dd65be62$var$RouteErrorContext = /*#__PURE__*/ $k116o.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $f6bd5ad5dd65be62$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$f6bd5ad5dd65be62$export$9c954a9d03d32f4a() && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $k116o.useContext($f6bd5ad5dd65be62$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $f6bd5ad5dd65be62$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $d64590e8ac5fce5b$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $f6bd5ad5dd65be62$export$9c954a9d03d32f4a() {
    return $k116o.useContext($f6bd5ad5dd65be62$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $f6bd5ad5dd65be62$export$45d76561a5302f2b() {
    !$f6bd5ad5dd65be62$export$9c954a9d03d32f4a() && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    return $k116o.useContext($f6bd5ad5dd65be62$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $f6bd5ad5dd65be62$export$1b3f31771c5d07c() {
    return $k116o.useContext($f6bd5ad5dd65be62$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $f6bd5ad5dd65be62$export$6c330e8992e8a295(pattern) {
    !$f6bd5ad5dd65be62$export$9c954a9d03d32f4a() && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $f6bd5ad5dd65be62$export$45d76561a5302f2b();
    return $k116o.useMemo(()=>(0, $d64590e8ac5fce5b$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $f6bd5ad5dd65be62$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $f6bd5ad5dd65be62$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $k116o.useContext($f6bd5ad5dd65be62$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $k116o.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $f6bd5ad5dd65be62$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $k116o.useContext($f6bd5ad5dd65be62$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $f6bd5ad5dd65be62$var$useNavigateStable() : $f6bd5ad5dd65be62$var$useNavigateUnstable();
}
function $f6bd5ad5dd65be62$var$useNavigateUnstable() {
    !$f6bd5ad5dd65be62$export$9c954a9d03d32f4a() && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    let dataRouterContext = $k116o.useContext($f6bd5ad5dd65be62$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $k116o.useContext($f6bd5ad5dd65be62$export$26749e8557646306);
    let { matches: matches } = $k116o.useContext($f6bd5ad5dd65be62$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $f6bd5ad5dd65be62$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $d64590e8ac5fce5b$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $k116o.useRef(false);
    $f6bd5ad5dd65be62$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $k116o.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $d64590e8ac5fce5b$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $d64590e8ac5fce5b$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $f6bd5ad5dd65be62$var$OutletContext = /*#__PURE__*/ $k116o.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $f6bd5ad5dd65be62$export$4138103a3ae699cc() {
    return $k116o.useContext($f6bd5ad5dd65be62$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $f6bd5ad5dd65be62$export$a3be3530d8e40d0b(context) {
    let outlet = $k116o.useContext($f6bd5ad5dd65be62$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $k116o.createElement($f6bd5ad5dd65be62$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $f6bd5ad5dd65be62$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $k116o.useContext($f6bd5ad5dd65be62$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $f6bd5ad5dd65be62$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $k116o.useContext($f6bd5ad5dd65be62$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $f6bd5ad5dd65be62$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $d64590e8ac5fce5b$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $k116o.useMemo(()=>(0, $d64590e8ac5fce5b$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $f6bd5ad5dd65be62$export$5d3fca4a98652595(routes, locationArg) {
    return $f6bd5ad5dd65be62$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $f6bd5ad5dd65be62$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$f6bd5ad5dd65be62$export$9c954a9d03d32f4a() && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $k116o.useContext($f6bd5ad5dd65be62$export$26749e8557646306);
    let { matches: parentMatches } = $k116o.useContext($f6bd5ad5dd65be62$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $f6bd5ad5dd65be62$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $d64590e8ac5fce5b$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $d64590e8ac5fce5b$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $f6bd5ad5dd65be62$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $d64590e8ac5fce5b$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $d64590e8ac5fce5b$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $k116o.createElement($f6bd5ad5dd65be62$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $f6bd5ad5dd65be62$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $d64590e8ac5fce5b$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $f6bd5ad5dd65be62$var$DefaultErrorComponent() {
    let error = $f6bd5ad5dd65be62$export$ed527bf60f6e05f2();
    let message = (0, $d64590e8ac5fce5b$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $k116o.createElement($k116o.Fragment, null, /*#__PURE__*/ $k116o.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $k116o.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $k116o.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $f6bd5ad5dd65be62$var$defaultErrorElement = /*#__PURE__*/ $k116o.createElement($f6bd5ad5dd65be62$var$DefaultErrorComponent, null);
class $f6bd5ad5dd65be62$var$RenderErrorBoundary extends $k116o.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $k116o.createElement($f6bd5ad5dd65be62$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $k116o.createElement($f6bd5ad5dd65be62$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $f6bd5ad5dd65be62$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $k116o.useContext($f6bd5ad5dd65be62$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $k116o.createElement($f6bd5ad5dd65be62$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $f6bd5ad5dd65be62$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $f6bd5ad5dd65be62$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $k116o.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $k116o.createElement($f6bd5ad5dd65be62$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $k116o.createElement($f6bd5ad5dd65be62$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $f6bd5ad5dd65be62$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
})($f6bd5ad5dd65be62$var$DataRouterHook || ($f6bd5ad5dd65be62$var$DataRouterHook = {}));
var $f6bd5ad5dd65be62$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
})($f6bd5ad5dd65be62$var$DataRouterStateHook || ($f6bd5ad5dd65be62$var$DataRouterStateHook = {}));
function $f6bd5ad5dd65be62$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $f6bd5ad5dd65be62$var$useDataRouterContext(hookName) {
    let ctx = $k116o.useContext($f6bd5ad5dd65be62$export$3add0d5dce533e2e);
    !ctx && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    return ctx;
}
function $f6bd5ad5dd65be62$var$useDataRouterState(hookName) {
    let state = $k116o.useContext($f6bd5ad5dd65be62$export$145dfa71566a64dc);
    !state && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    return state;
}
function $f6bd5ad5dd65be62$var$useRouteContext(hookName) {
    let route = $k116o.useContext($f6bd5ad5dd65be62$export$9072aa6dd1f93057);
    !route && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $f6bd5ad5dd65be62$var$useCurrentRouteId(hookName) {
    let route = $f6bd5ad5dd65be62$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $f6bd5ad5dd65be62$export$5fc8298006ad9e58() {
    return $f6bd5ad5dd65be62$var$useCurrentRouteId($f6bd5ad5dd65be62$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $f6bd5ad5dd65be62$export$d0fd4b7106de2769() {
    let state = $f6bd5ad5dd65be62$var$useDataRouterState($f6bd5ad5dd65be62$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $f6bd5ad5dd65be62$export$600dc272ed516c15() {
    let dataRouterContext = $f6bd5ad5dd65be62$var$useDataRouterContext($f6bd5ad5dd65be62$var$DataRouterHook.UseRevalidator);
    let state = $f6bd5ad5dd65be62$var$useDataRouterState($f6bd5ad5dd65be62$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $f6bd5ad5dd65be62$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $f6bd5ad5dd65be62$var$useDataRouterState($f6bd5ad5dd65be62$var$DataRouterStateHook.UseMatches);
    return $k116o.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match;
            // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $f6bd5ad5dd65be62$export$1448a5050d252c4d() {
    let state = $f6bd5ad5dd65be62$var$useDataRouterState($f6bd5ad5dd65be62$var$DataRouterStateHook.UseLoaderData);
    let routeId = $f6bd5ad5dd65be62$var$useCurrentRouteId($f6bd5ad5dd65be62$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $f6bd5ad5dd65be62$export$fd5d37484eab868d(routeId) {
    let state = $f6bd5ad5dd65be62$var$useDataRouterState($f6bd5ad5dd65be62$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $f6bd5ad5dd65be62$export$fdc00f3f26066d5e() {
    let state = $f6bd5ad5dd65be62$var$useDataRouterState($f6bd5ad5dd65be62$var$DataRouterStateHook.UseActionData);
    let route = $k116o.useContext($f6bd5ad5dd65be62$export$9072aa6dd1f93057);
    !route && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $f6bd5ad5dd65be62$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $k116o.useContext($f6bd5ad5dd65be62$var$RouteErrorContext);
    let state = $f6bd5ad5dd65be62$var$useDataRouterState($f6bd5ad5dd65be62$var$DataRouterStateHook.UseRouteError);
    let routeId = $f6bd5ad5dd65be62$var$useCurrentRouteId($f6bd5ad5dd65be62$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $f6bd5ad5dd65be62$export$78a72ddb39bdd145() {
    let value = $k116o.useContext($f6bd5ad5dd65be62$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $f6bd5ad5dd65be62$export$17f53340677d5831() {
    let value = $k116o.useContext($f6bd5ad5dd65be62$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $f6bd5ad5dd65be62$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $f6bd5ad5dd65be62$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $f6bd5ad5dd65be62$var$useDataRouterContext($f6bd5ad5dd65be62$var$DataRouterHook.UseBlocker);
    let state = $f6bd5ad5dd65be62$var$useDataRouterState($f6bd5ad5dd65be62$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $k116o.useState("");
    let blockerFunction = $k116o.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $f6bd5ad5dd65be62$var$_extends({}, currentLocation, {
                pathname: (0, $d64590e8ac5fce5b$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $f6bd5ad5dd65be62$var$_extends({}, nextLocation, {
                pathname: (0, $d64590e8ac5fce5b$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $k116o.useEffect(()=>{
        let key = String(++$f6bd5ad5dd65be62$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $k116o.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $d64590e8ac5fce5b$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $f6bd5ad5dd65be62$var$useNavigateStable() {
    let { router: router } = $f6bd5ad5dd65be62$var$useDataRouterContext($f6bd5ad5dd65be62$var$DataRouterHook.UseNavigateStable);
    let id = $f6bd5ad5dd65be62$var$useCurrentRouteId($f6bd5ad5dd65be62$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $k116o.useRef(false);
    $f6bd5ad5dd65be62$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $k116o.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $f6bd5ad5dd65be62$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $f6bd5ad5dd65be62$var$alreadyWarned = {};
function $f6bd5ad5dd65be62$var$warningOnce(key, cond, message) {
    if (!cond && !$f6bd5ad5dd65be62$var$alreadyWarned[key]) $f6bd5ad5dd65be62$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $f6bd5ad5dd65be62$var$START_TRANSITION = "startTransition";
const $f6bd5ad5dd65be62$var$startTransitionImpl = $k116o[$f6bd5ad5dd65be62$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $f6bd5ad5dd65be62$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setStateImpl] = $k116o.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $k116o.useCallback((newState)=>{
        v7_startTransition && $f6bd5ad5dd65be62$var$startTransitionImpl ? $f6bd5ad5dd65be62$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $k116o.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $k116o.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $k116o.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $k116o.createElement($k116o.Fragment, null, /*#__PURE__*/ $k116o.createElement($f6bd5ad5dd65be62$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $k116o.createElement($f6bd5ad5dd65be62$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $k116o.createElement($f6bd5ad5dd65be62$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $k116o.createElement($f6bd5ad5dd65be62$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $f6bd5ad5dd65be62$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $f6bd5ad5dd65be62$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $f6bd5ad5dd65be62$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $k116o.useRef();
    if (historyRef.current == null) historyRef.current = (0, $d64590e8ac5fce5b$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $k116o.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $k116o.useCallback((newState)=>{
        v7_startTransition && $f6bd5ad5dd65be62$var$startTransitionImpl ? $f6bd5ad5dd65be62$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $k116o.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $k116o.createElement($f6bd5ad5dd65be62$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $f6bd5ad5dd65be62$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$f6bd5ad5dd65be62$export$9c954a9d03d32f4a() && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    let { matches: matches } = $k116o.useContext($f6bd5ad5dd65be62$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $f6bd5ad5dd65be62$export$45d76561a5302f2b();
    let navigate = $f6bd5ad5dd65be62$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $d64590e8ac5fce5b$export$cae722b0cc860f13)(to, (0, $d64590e8ac5fce5b$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $k116o.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $f6bd5ad5dd65be62$export$910ae8079b2c2852(props) {
    return $f6bd5ad5dd65be62$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $f6bd5ad5dd65be62$export$e7b0ac011bb776c6(_props) {
    (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $f6bd5ad5dd65be62$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $d64590e8ac5fce5b$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$f6bd5ad5dd65be62$export$9c954a9d03d32f4a() && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $k116o.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $d64590e8ac5fce5b$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $k116o.useMemo(()=>{
        let trailingPathname = (0, $d64590e8ac5fce5b$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $k116o.createElement($f6bd5ad5dd65be62$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $k116o.createElement($f6bd5ad5dd65be62$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $f6bd5ad5dd65be62$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $f6bd5ad5dd65be62$export$5d3fca4a98652595($f6bd5ad5dd65be62$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $f6bd5ad5dd65be62$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $k116o.createElement($f6bd5ad5dd65be62$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $k116o.createElement($f6bd5ad5dd65be62$var$ResolveAwait, null, children));
}
var $f6bd5ad5dd65be62$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($f6bd5ad5dd65be62$var$AwaitRenderStatus || ($f6bd5ad5dd65be62$var$AwaitRenderStatus = {}));
const $f6bd5ad5dd65be62$var$neverSettledPromise = new Promise(()=>{});
class $f6bd5ad5dd65be62$var$AwaitErrorBoundary extends $k116o.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $f6bd5ad5dd65be62$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $f6bd5ad5dd65be62$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $f6bd5ad5dd65be62$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $f6bd5ad5dd65be62$var$AwaitRenderStatus.error : promise._data !== undefined ? $f6bd5ad5dd65be62$var$AwaitRenderStatus.success : $f6bd5ad5dd65be62$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $f6bd5ad5dd65be62$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $f6bd5ad5dd65be62$var$AwaitRenderStatus.error && promise._error instanceof (0, $d64590e8ac5fce5b$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $f6bd5ad5dd65be62$var$neverSettledPromise;
        if (status === $f6bd5ad5dd65be62$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $f6bd5ad5dd65be62$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $k116o.createElement($f6bd5ad5dd65be62$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $f6bd5ad5dd65be62$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $k116o.createElement($f6bd5ad5dd65be62$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $f6bd5ad5dd65be62$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $f6bd5ad5dd65be62$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $k116o.createElement($k116o.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $f6bd5ad5dd65be62$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $k116o.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $k116o.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $k116o.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $f6bd5ad5dd65be62$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $f6bd5ad5dd65be62$export$e7b0ac011bb776c6) && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $f6bd5ad5dd65be62$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $f6bd5ad5dd65be62$export$daf73786167a7f72(matches) {
    return $f6bd5ad5dd65be62$var$_renderMatches(matches);
}
function $f6bd5ad5dd65be62$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $k116o.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $k116o.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $f6bd5ad5dd65be62$export$f30f7e456d254e83(routes, opts) {
    return (0, $d64590e8ac5fce5b$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $f6bd5ad5dd65be62$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $d64590e8ac5fce5b$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $f6bd5ad5dd65be62$export$52b333d321859367
    }).initialize();
}



function $b061e8b516dc3a67$var$_extends() {
    $b061e8b516dc3a67$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b061e8b516dc3a67$var$_extends.apply(this, arguments);
}
function $b061e8b516dc3a67$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $b061e8b516dc3a67$var$defaultMethod = "get";
const $b061e8b516dc3a67$var$defaultEncType = "application/x-www-form-urlencoded";
function $b061e8b516dc3a67$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $b061e8b516dc3a67$var$isButtonElement(object) {
    return $b061e8b516dc3a67$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $b061e8b516dc3a67$var$isFormElement(object) {
    return $b061e8b516dc3a67$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $b061e8b516dc3a67$var$isInputElement(object) {
    return $b061e8b516dc3a67$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $b061e8b516dc3a67$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $b061e8b516dc3a67$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$b061e8b516dc3a67$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $b061e8b516dc3a67$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $b061e8b516dc3a67$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $b061e8b516dc3a67$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    }
    return searchParams;
}
// One-time check for submitter support
let $b061e8b516dc3a67$var$_formDataSupportsSubmitter = null;
function $b061e8b516dc3a67$var$isFormDataSubmitterSupported() {
    if ($b061e8b516dc3a67$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $b061e8b516dc3a67$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $b061e8b516dc3a67$var$_formDataSupportsSubmitter = true;
    }
    return $b061e8b516dc3a67$var$_formDataSupportsSubmitter;
}
const $b061e8b516dc3a67$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $b061e8b516dc3a67$var$getFormEncType(encType) {
    if (encType != null && !$b061e8b516dc3a67$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $b061e8b516dc3a67$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($b061e8b516dc3a67$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $d64590e8ac5fce5b$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $b061e8b516dc3a67$var$defaultMethod;
        encType = $b061e8b516dc3a67$var$getFormEncType(target.getAttribute("enctype")) || $b061e8b516dc3a67$var$defaultEncType;
        formData = new FormData(target);
    } else if ($b061e8b516dc3a67$var$isButtonElement(target) || $b061e8b516dc3a67$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $d64590e8ac5fce5b$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $b061e8b516dc3a67$var$defaultMethod;
        encType = $b061e8b516dc3a67$var$getFormEncType(target.getAttribute("formenctype")) || $b061e8b516dc3a67$var$getFormEncType(form.getAttribute("enctype")) || $b061e8b516dc3a67$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$b061e8b516dc3a67$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($b061e8b516dc3a67$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $b061e8b516dc3a67$var$defaultMethod;
        action = null;
        encType = $b061e8b516dc3a67$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $b061e8b516dc3a67$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $b061e8b516dc3a67$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $b061e8b516dc3a67$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset"
];
function $b061e8b516dc3a67$export$1f3f55432a00e06d(routes, opts) {
    return (0, $d64590e8ac5fce5b$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b061e8b516dc3a67$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $d64590e8ac5fce5b$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $b061e8b516dc3a67$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $f6bd5ad5dd65be62$export$52b333d321859367)
    }).initialize();
}
function $b061e8b516dc3a67$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $d64590e8ac5fce5b$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b061e8b516dc3a67$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $d64590e8ac5fce5b$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $b061e8b516dc3a67$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $f6bd5ad5dd65be62$export$52b333d321859367)
    }).initialize();
}
function $b061e8b516dc3a67$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $b061e8b516dc3a67$var$_extends({}, state, {
        errors: $b061e8b516dc3a67$var$deserializeErrors(state.errors)
    });
    return state;
}
function $b061e8b516dc3a67$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $d64590e8ac5fce5b$export$acf1a680051f5031)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            let error = new Error(val.message);
            // Wipe away the client-side stack trace.  Nothing to fill it in with
            // because we don't serialize SSR stack traces for security reasons
            error.stack = "";
            serialized[key] = error;
        } else serialized[key] = val;
    }
    return serialized;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $b061e8b516dc3a67$var$START_TRANSITION = "startTransition";
const $b061e8b516dc3a67$var$startTransitionImpl = $k116o[$b061e8b516dc3a67$var$START_TRANSITION];
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $b061e8b516dc3a67$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref;
    let historyRef = $k116o.useRef();
    if (historyRef.current == null) historyRef.current = (0, $d64590e8ac5fce5b$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $k116o.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $k116o.useCallback((newState)=>{
        v7_startTransition && $b061e8b516dc3a67$var$startTransitionImpl ? $b061e8b516dc3a67$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $k116o.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $k116o.createElement((0, $f6bd5ad5dd65be62$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $b061e8b516dc3a67$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref2;
    let historyRef = $k116o.useRef();
    if (historyRef.current == null) historyRef.current = (0, $d64590e8ac5fce5b$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $k116o.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $k116o.useCallback((newState)=>{
        v7_startTransition && $b061e8b516dc3a67$var$startTransitionImpl ? $b061e8b516dc3a67$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $k116o.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $k116o.createElement((0, $f6bd5ad5dd65be62$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $b061e8b516dc3a67$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, future: future, history: history } = _ref3;
    let [state, setStateImpl] = $k116o.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $k116o.useCallback((newState)=>{
        v7_startTransition && $b061e8b516dc3a67$var$startTransitionImpl ? $b061e8b516dc3a67$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $k116o.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $k116o.createElement((0, $f6bd5ad5dd65be62$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $b061e8b516dc3a67$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $b061e8b516dc3a67$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $b061e8b516dc3a67$export$a6c7ac8248d6e38a = /*#__PURE__*/ $k116o.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $b061e8b516dc3a67$var$_objectWithoutPropertiesLoose(_ref4, $b061e8b516dc3a67$var$_excluded);
    let { basename: basename } = $k116o.useContext((0, $f6bd5ad5dd65be62$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $b061e8b516dc3a67$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($b061e8b516dc3a67$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $d64590e8ac5fce5b$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $f6bd5ad5dd65be62$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $b061e8b516dc3a67$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $k116o.createElement("a", $b061e8b516dc3a67$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $b061e8b516dc3a67$export$b0d92dbee9b5b60d = /*#__PURE__*/ $k116o.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $b061e8b516dc3a67$var$_objectWithoutPropertiesLoose(_ref5, $b061e8b516dc3a67$var$_excluded2);
    let path = (0, $f6bd5ad5dd65be62$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $f6bd5ad5dd65be62$export$45d76561a5302f2b)();
    let routerState = $k116o.useContext((0, $f6bd5ad5dd65be62$export$145dfa71566a64dc));
    let { navigator: navigator } = $k116o.useContext((0, $f6bd5ad5dd65be62$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $k116o.createElement($b061e8b516dc3a67$export$a6c7ac8248d6e38a, $b061e8b516dc3a67$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $b061e8b516dc3a67$export$a7fed597f4b8afd8 = /*#__PURE__*/ $k116o.forwardRef((props, ref)=>{
    let submit = $b061e8b516dc3a67$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $k116o.createElement($b061e8b516dc3a67$var$FormImpl, $b061e8b516dc3a67$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
const $b061e8b516dc3a67$var$FormImpl = /*#__PURE__*/ $k116o.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, method: method = $b061e8b516dc3a67$var$defaultMethod, action: action, onSubmit: onSubmit, submit: submit, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $b061e8b516dc3a67$var$_objectWithoutPropertiesLoose(_ref6, $b061e8b516dc3a67$var$_excluded3);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $b061e8b516dc3a67$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $k116o.createElement("form", $b061e8b516dc3a67$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $b061e8b516dc3a67$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $b061e8b516dc3a67$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $b061e8b516dc3a67$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($b061e8b516dc3a67$var$DataRouterHook || ($b061e8b516dc3a67$var$DataRouterHook = {}));
var $b061e8b516dc3a67$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($b061e8b516dc3a67$var$DataRouterStateHook || ($b061e8b516dc3a67$var$DataRouterStateHook = {}));
function $b061e8b516dc3a67$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $b061e8b516dc3a67$var$useDataRouterContext(hookName) {
    let ctx = $k116o.useContext((0, $f6bd5ad5dd65be62$export$3add0d5dce533e2e));
    !ctx && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    return ctx;
}
function $b061e8b516dc3a67$var$useDataRouterState(hookName) {
    let state = $k116o.useContext((0, $f6bd5ad5dd65be62$export$145dfa71566a64dc));
    !state && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $b061e8b516dc3a67$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $f6bd5ad5dd65be62$export$9770f232ac06a008)();
    let location = (0, $f6bd5ad5dd65be62$export$45d76561a5302f2b)();
    let path = (0, $f6bd5ad5dd65be62$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $k116o.useCallback((event)=>{
        if ($b061e8b516dc3a67$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $d64590e8ac5fce5b$export$fe53371bee54353d)(location) === (0, $d64590e8ac5fce5b$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $b061e8b516dc3a67$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $k116o.useRef($b061e8b516dc3a67$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $k116o.useRef(false);
    let location = (0, $f6bd5ad5dd65be62$export$45d76561a5302f2b)();
    let searchParams = $k116o.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $b061e8b516dc3a67$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $f6bd5ad5dd65be62$export$9770f232ac06a008)();
    let setSearchParams = $k116o.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $b061e8b516dc3a67$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $b061e8b516dc3a67$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $b061e8b516dc3a67$export$47c85c6e3a081d3() {
    let { router: router } = $b061e8b516dc3a67$var$useDataRouterContext($b061e8b516dc3a67$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $k116o.useContext((0, $f6bd5ad5dd65be62$export$26749e8557646306));
    let currentRouteId = (0, $f6bd5ad5dd65be62$export$5fc8298006ad9e58)();
    return $k116o.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $b061e8b516dc3a67$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $b061e8b516dc3a67$var$getFormSubmissionInfo(target, basename);
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            fromRouteId: currentRouteId
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $b061e8b516dc3a67$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    let { router: router } = $b061e8b516dc3a67$var$useDataRouterContext($b061e8b516dc3a67$var$DataRouterHook.UseSubmitFetcher);
    let { basename: basename } = $k116o.useContext((0, $f6bd5ad5dd65be62$export$26749e8557646306));
    return $k116o.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $b061e8b516dc3a67$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $b061e8b516dc3a67$var$getFormSubmissionInfo(target, basename);
        !(fetcherRouteId != null) && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $b061e8b516dc3a67$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $k116o.useContext((0, $f6bd5ad5dd65be62$export$26749e8557646306));
    let routeContext = $k116o.useContext((0, $f6bd5ad5dd65be62$export$9072aa6dd1f93057));
    !routeContext && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $b061e8b516dc3a67$var$_extends({}, (0, $f6bd5ad5dd65be62$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $f6bd5ad5dd65be62$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $d64590e8ac5fce5b$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $d64590e8ac5fce5b$export$fe53371bee54353d)(path);
}
function $b061e8b516dc3a67$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $k116o.forwardRef((props, ref)=>{
        let submit = $b061e8b516dc3a67$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $k116o.createElement($b061e8b516dc3a67$var$FormImpl, $b061e8b516dc3a67$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
let $b061e8b516dc3a67$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $b061e8b516dc3a67$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $b061e8b516dc3a67$var$useDataRouterContext($b061e8b516dc3a67$var$DataRouterHook.UseFetcher);
    let route = $k116o.useContext((0, $f6bd5ad5dd65be62$export$9072aa6dd1f93057));
    !route && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
    let [fetcherKey] = $k116o.useState(()=>String(++$b061e8b516dc3a67$var$fetcherId));
    let [Form] = $k116o.useState(()=>{
        !routeId && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
        return $b061e8b516dc3a67$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $k116o.useState(()=>(href)=>{
            !router && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
            !routeId && (0, $d64590e8ac5fce5b$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $b061e8b516dc3a67$var$useSubmitFetcher(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $k116o.useMemo(()=>$b061e8b516dc3a67$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $k116o.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $b061e8b516dc3a67$export$fa996778a3a31087() {
    let state = $b061e8b516dc3a67$var$useDataRouterState($b061e8b516dc3a67$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $b061e8b516dc3a67$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $b061e8b516dc3a67$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $b061e8b516dc3a67$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $b061e8b516dc3a67$var$useDataRouterContext($b061e8b516dc3a67$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $b061e8b516dc3a67$var$useDataRouterState($b061e8b516dc3a67$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $k116o.useContext((0, $f6bd5ad5dd65be62$export$26749e8557646306));
    let location = (0, $f6bd5ad5dd65be62$export$45d76561a5302f2b)();
    let matches = (0, $f6bd5ad5dd65be62$export$2378eb7f5ff86053)();
    let navigation = (0, $f6bd5ad5dd65be62$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $k116o.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $b061e8b516dc3a67$var$usePageHide($k116o.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $b061e8b516dc3a67$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $b061e8b516dc3a67$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($b061e8b516dc3a67$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $k116o.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $b061e8b516dc3a67$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $b061e8b516dc3a67$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $k116o.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($b061e8b516dc3a67$var$_extends({}, location, {
                    pathname: (0, $d64590e8ac5fce5b$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($b061e8b516dc3a67$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $k116o.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $b061e8b516dc3a67$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $k116o.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $b061e8b516dc3a67$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $k116o.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $b061e8b516dc3a67$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $f6bd5ad5dd65be62$export$2af03a1de5c0910)(when);
    $k116o.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $k116o.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}


// API
const $d87e1b304aec4d6d$export$c6e57d4df408c13c = "/createCache";
const $d87e1b304aec4d6d$export$80fdcb5a3142d1bd = "/createDeferred";
const $d87e1b304aec4d6d$export$b0030bce8559349f = "/createExternallyManagedCache";
const $d87e1b304aec4d6d$export$4eda7113e54677aa = "/createIntervalCache";
const $d87e1b304aec4d6d$export$ced0558925123210 = "/createSingleEntryCache";
const $d87e1b304aec4d6d$export$1d56bcf14907e007 = "/createStreamingCache";
const $d87e1b304aec4d6d$export$1237172d87df4b0f = "/isPromiseLike";
const $d87e1b304aec4d6d$export$630373a46fa30388 = "/Record-and-RecordData-utils";
const $d87e1b304aec4d6d$export$a7f6f2cd4cc90607 = "/useCacheMutation";
const $d87e1b304aec4d6d$export$4eb9f97e3e3a1e88 = "/useCacheStatus";
const $d87e1b304aec4d6d$export$a9a6e7732aaecca6 = "/useImperativeCacheValue";
const $d87e1b304aec4d6d$export$e1b81feb0c103c86 = "/useImperativeIntervalCacheValues";
const $d87e1b304aec4d6d$export$6c09fcd90d770bc4 = "/useIntervalCacheStatus";
const $d87e1b304aec4d6d$export$ab0a2769ad209342 = "/useStreamingValue";
const $d87e1b304aec4d6d$export$a1a38004ba5076cd = "/guide/abort-a-request";
const $d87e1b304aec4d6d$export$9ccf183b65eb2452 = "/guide/debugging-slow-requests";
const $d87e1b304aec4d6d$export$f240987ac561f7ec = "/guide/rendering-cache-status";
const $d87e1b304aec4d6d$export$a5c1c7acf17ea32a = "/guide/memory-management";
const $d87e1b304aec4d6d$export$5c5abf861764150e = "/guide/mutating-cache-values";
const $d87e1b304aec4d6d$export$f17b62024bc7b6e0 = "/guide/optimizing-immutable-caches";
const $d87e1b304aec4d6d$export$866f2572af03bc6 = "/guide/writing-a-streaming-cache";




var $6fa5df31d5bff28c$exports = {};

$parcel$export($6fa5df31d5bff28c$exports, "Block", () => $6fa5df31d5bff28c$export$d96a8827a60d6b69, (v) => $6fa5df31d5bff28c$export$d96a8827a60d6b69 = v);
var $6fa5df31d5bff28c$export$d96a8827a60d6b69;
$6fa5df31d5bff28c$export$d96a8827a60d6b69 = `ovOCrq_Block`;


function $c563c48496378798$export$2e2bcd8739ae039({ children: children, type: type }) {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6fa5df31d5bff28c$exports))).Block,
        "data-type": type,
        children: children
    });
}



var $e5544cfad8fcfd8e$exports = {};

$parcel$export($e5544cfad8fcfd8e$exports, "Container", () => $e5544cfad8fcfd8e$export$42a852a2b6b56249, (v) => $e5544cfad8fcfd8e$export$42a852a2b6b56249 = v);
var $e5544cfad8fcfd8e$export$42a852a2b6b56249;
$e5544cfad8fcfd8e$export$42a852a2b6b56249 = `g1m8ra_Container`;


function $aa6eba4c47b97eb7$export$2e2bcd8739ae039({ children: children, className: className = "" }) {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("div", {
        className: `${className} ${(0, (/*@__PURE__*/$parcel$interopDefault($e5544cfad8fcfd8e$exports))).Container}`,
        children: children
    });
}




var $k116o = parcelRequire("k116o");


var $k116o = parcelRequire("k116o");

var $1LbwH = parcelRequire("1LbwH");

var $hB7kI = parcelRequire("hB7kI");

var $6yW7d = parcelRequire("6yW7d");
const $131b3f6f00984c1a$export$1af79998fa14ea8 = "not-found";
const $131b3f6f00984c1a$export$102c3f975dbe36bd = "pending";
const $131b3f6f00984c1a$export$dfcaef926891432a = "aborted";
const $131b3f6f00984c1a$export$89864f7e9466db1c = "rejected";
const $131b3f6f00984c1a$export$95b9efe7da5fb195 = "resolved";


const $988843a0d5347818$export$df77466336fe5355 = false;



var $k116o = parcelRequire("k116o");


function $1d0742bf523b27d5$export$e673efccd97e4223(debugLabel) {
    let status = (0, $131b3f6f00984c1a$export$102c3f975dbe36bd);
    let rejectPromise;
    let resolvePromise;
    const promise = new Promise((resolve, reject)=>{
        rejectPromise = reject;
        resolvePromise = resolve;
    });
    promise.catch(()=>{
    // Prevent unhandled promise rejection warning.
    });
    function assertPending() {
        if (status !== (0, $131b3f6f00984c1a$export$102c3f975dbe36bd)) throw Error(`Deferred has already been ${status}`);
    }
    const deferred = {
        debugLabel: // @ts-ignore
        debugLabel,
        promise: promise,
        reject (error) {
            assertPending();
            status = (0, $131b3f6f00984c1a$export$89864f7e9466db1c);
            rejectPromise(error);
        },
        resolve (value) {
            assertPending();
            status = (0, $131b3f6f00984c1a$export$95b9efe7da5fb195);
            resolvePromise(value);
        },
        get status () {
            return status;
        }
    };
    return deferred;
}




function $edc5383ff35cf8f5$export$a7b70004b7ffafb1(deferred = (0, $1d0742bf523b27d5$export$e673efccd97e4223)(), abortController = new AbortController()) {
    return {
        abortController: abortController,
        deferred: deferred,
        status: (0, $131b3f6f00984c1a$export$102c3f975dbe36bd)
    };
}
function $edc5383ff35cf8f5$export$cec56b5b1c706d4e(error) {
    return {
        error: error,
        status: (0, $131b3f6f00984c1a$export$89864f7e9466db1c)
    };
}
function $edc5383ff35cf8f5$export$150c74f26dcb3ff1(value, metadata = null) {
    return {
        metadata: metadata,
        status: (0, $131b3f6f00984c1a$export$95b9efe7da5fb195),
        value: value
    };
}


function $19c637b0d2d7681e$export$53e0f549136dd099(deferred = (0, $1d0742bf523b27d5$export$e673efccd97e4223)(), abortController = new AbortController()) {
    return {
        data: (0, $edc5383ff35cf8f5$export$a7b70004b7ffafb1)(deferred, abortController)
    };
}
function $19c637b0d2d7681e$export$6308e5cad30e61ad(error) {
    return {
        data: (0, $edc5383ff35cf8f5$export$cec56b5b1c706d4e)(error)
    };
}
function $19c637b0d2d7681e$export$6f5139686a08d721(value) {
    return {
        data: (0, $edc5383ff35cf8f5$export$150c74f26dcb3ff1)(value)
    };
}
function $19c637b0d2d7681e$export$3f3237309c3173f8(record, deferred = (0, $1d0742bf523b27d5$export$e673efccd97e4223)(), abortController = new AbortController()) {
    record.data = (0, $edc5383ff35cf8f5$export$a7b70004b7ffafb1)(deferred, abortController);
}
function $19c637b0d2d7681e$export$fabf043b34d5c98b(record, error) {
    record.data = (0, $edc5383ff35cf8f5$export$cec56b5b1c706d4e)(error);
}
function $19c637b0d2d7681e$export$bf8e65ce0c179a6a(record, value) {
    record.data = (0, $edc5383ff35cf8f5$export$150c74f26dcb3ff1)(value);
}


function $a11de30297c18820$export$a7a9523472993e97(expectedCondition, message = "Assertion failed!") {
    if (!expectedCondition) {
        console.error(message);
        throw Error(message);
    }
}



function $3138a7e7e2612756$export$457b50c8400bb39e(record) {
    return record.data.status === (0, $131b3f6f00984c1a$export$102c3f975dbe36bd);
}
function $3138a7e7e2612756$export$7a8d61c3a7386616(recordData) {
    return recordData.status === (0, $131b3f6f00984c1a$export$102c3f975dbe36bd);
}
function $3138a7e7e2612756$export$2285469376868a97(record) {
    return record.data.status === (0, $131b3f6f00984c1a$export$89864f7e9466db1c);
}
function $3138a7e7e2612756$export$5b07f29fa6c18ca1(recordData) {
    return recordData.status === (0, $131b3f6f00984c1a$export$89864f7e9466db1c);
}
function $3138a7e7e2612756$export$893ad6457b7fbafc(record) {
    return record.data.status === (0, $131b3f6f00984c1a$export$95b9efe7da5fb195);
}
function $3138a7e7e2612756$export$90352bcdf6aa81f7(recordData) {
    return recordData.status === (0, $131b3f6f00984c1a$export$95b9efe7da5fb195);
}


function $a95b1a9483edd973$export$5720014d5c94137d(record) {
    (0, $a11de30297c18820$export$a7a9523472993e97)((0, $3138a7e7e2612756$export$457b50c8400bb39e)(record));
    return true;
}
function $a95b1a9483edd973$export$7412ab40cd107449(recordData) {
    (0, $a11de30297c18820$export$a7a9523472993e97)((0, $3138a7e7e2612756$export$7a8d61c3a7386616)(recordData));
    return true;
}
function $a95b1a9483edd973$export$6fd7364af55f6b5d(record) {
    (0, $a11de30297c18820$export$a7a9523472993e97)((0, $3138a7e7e2612756$export$2285469376868a97)(record));
    return true;
}
function $a95b1a9483edd973$export$6062888c08478450(recordData) {
    (0, $a11de30297c18820$export$a7a9523472993e97)((0, $3138a7e7e2612756$export$5b07f29fa6c18ca1)(recordData));
    return true;
}
function $a95b1a9483edd973$export$cd67208b6b991a86(record) {
    (0, $a11de30297c18820$export$a7a9523472993e97)((0, $3138a7e7e2612756$export$893ad6457b7fbafc)(record));
    return true;
}
function $a95b1a9483edd973$export$4478164a0cdab625(recordData) {
    (0, $a11de30297c18820$export$a7a9523472993e97)((0, $3138a7e7e2612756$export$90352bcdf6aa81f7)(recordData));
    return true;
}




let $f054b0183784f191$var$enabled = false;
function $f054b0183784f191$export$2968ba5c8d1a3c5e() {
    $f054b0183784f191$var$enabled = false;
}
function $f054b0183784f191$export$afb4acdcd6d309d3() {
    $f054b0183784f191$var$enabled = true;
}
function $f054b0183784f191$export$bef1f36f5486a6a3(enableDebugLogging = $f054b0183784f191$var$enabled, args) {
    if (0, $988843a0d5347818$export$df77466336fe5355) {
        if (enableDebugLogging) console.log(...args);
    }
}


function $b00f2db37bcf9917$export$d7854a9563654036() {
    return new Map();
}


function $e9018c4b997035fe$export$48ebe0dfb65ba56c(...params) {
    return params.join(",");
}


function $2e69071d085c545a$export$ae936b9d47e5870e(value) {
    return value != null && typeof value.then === "function";
}



if ((0, $k116o.unstable_getCacheForType) == null) throw new Error('unstable_getCacheForType is not a function.\n\nThis probably means that the wrong version of React has been specified as a dependency. The "suspense" package requires the @experimental release of "react" and "react-dom".\n\nFor more information, see https://react.dev/community/versioning-policy#experimental-channel');
function $1e2a96dfa0b62734$export$cf6fa0bbcc94b912(options) {
    let { config: config = {}, debugLabel: debugLabel, debugLogging: debugLogging, getKey: getKey = (0, $e9018c4b997035fe$export$48ebe0dfb65ba56c), load: load } = options;
    const { getCache: getCache = (0, $b00f2db37bcf9917$export$d7854a9563654036), immutable: immutable = false } = config;
    if (0, $988843a0d5347818$export$df77466336fe5355) {
        let didLogWarning = false;
        let decoratedGetKey = getKey;
        getKey = (params)=>{
            const key = decoratedGetKey(params);
            if (!didLogWarning) {
                if (key.includes("[object Object]")) {
                    didLogWarning = true;
                    console.warn(`Warning: createCache() key "${key}" contains a stringified object and may not be unique`);
                }
            }
            return key;
        };
    }
    const debugLog = (message, params, ...args)=>{
        const cacheKey = params ? `"${getKey(params)}"` : "";
        const prefix = debugLabel ? `createCache[${debugLabel}]` : "createCache";
        (0, $f054b0183784f191$export$bef1f36f5486a6a3)(debugLogging, [
            `%c${prefix}`,
            "font-weight: bold; color: yellow;",
            message,
            cacheKey,
            ...args
        ]);
    };
    debugLog("Cache created");
    // This map enables selective mutations to be scheduled with React
    // (one record can be invalidated without affecting others)
    // Reads will query the map created by createRecordMap first,
    // and fall back to this map if no match is found
    const recordMap = getCache(onExternalCacheEviction);
    // Stores status of in-progress mutation
    // If no entry is present here, the Record map will be used instead
    // Storing this information separately enables status to be updated during mutation
    // without modifying the actual record (which may trigger an unintentional update/fallback)
    const mutationAbortControllerMap = new Map();
    // Stores a set of callbacks (by key) for status subscribers.
    const subscriberMap = new Map();
    // Immutable caches should read from backing cache directly.
    // Only mutable caches should use React-managed cache
    // in order to reduce re-renders when caches are refreshed for mutations.
    const getCacheForType = immutable ? ()=>recordMap : (0, $k116o.unstable_getCacheForType);
    function abort(...params) {
        const cacheKey = getKey(params);
        const pendingMutationRecordMap = getCacheForType(createPendingMutationRecordMap);
        // In-progress mutations aren't guaranteed to be in the recordMap.
        // So we check the mutationAbortControllerMap to infer this.
        const abortController = mutationAbortControllerMap.get(cacheKey);
        if (abortController) {
            debugLog("abort()", params);
            abortController.abort();
            notifySubscribers(params);
            return true;
        } else {
            const record = pendingMutationRecordMap.get(cacheKey) ?? recordMap.get(cacheKey);
            if (record && (0, $3138a7e7e2612756$export$457b50c8400bb39e)(record)) {
                debugLog("abort()", params);
                pendingMutationRecordMap.delete(cacheKey);
                // Only delete the main cache if it's the same record/request
                // Aborting a mutation should not affect the main cache
                if (recordMap.get(cacheKey) === record) recordMap.delete(cacheKey);
                record.data.abortController.abort();
                notifySubscribers(params);
                return true;
            }
        }
        return false;
    }
    function cache(value, ...params) {
        debugLog("cache()", params);
        const cacheKey = getKey(params);
        const pendingMutationRecordMap = getCacheForType(createPendingMutationRecordMap);
        let record = getRecord(...params);
        if (record != null) {
            if ((0, $3138a7e7e2612756$export$457b50c8400bb39e)(record)) {
                const { abortController: abortController, deferred: deferred } = record.data;
                abortController.abort();
                (0, $19c637b0d2d7681e$export$bf8e65ce0c179a6a)(record, value);
                // Don't leave any pending request hanging
                deferred.resolve(value);
                notifySubscribers(params);
                return;
            }
        }
        record = (0, $19c637b0d2d7681e$export$6f5139686a08d721)(value);
        recordMap.set(cacheKey, record);
        pendingMutationRecordMap.set(cacheKey, record);
        notifySubscribers(params);
    }
    function createPendingMutationRecordMap() {
        return getCache(()=>{
        // We don't really need to do anything here
        // This map will almost always be a subset of the recordMap
        // but we also don't want it to bypass the getCache() eviction logic (if any)
        });
    }
    function disableDebugLogging() {
        debugLogging = false;
    }
    function enableDebugLogging() {
        debugLogging = true;
    }
    function evict(...params) {
        const cacheKey = getKey(params);
        const pendingMutationRecordMap = getCacheForType(createPendingMutationRecordMap);
        debugLog("evict()", params);
        const didDelete = recordMap.delete(cacheKey);
        pendingMutationRecordMap.delete(cacheKey);
        notifySubscribers(params);
        return didDelete;
    }
    function evictAll() {
        const pendingMutationRecordMap = getCacheForType(createPendingMutationRecordMap);
        debugLog("evictAll()", undefined);
        recordMap.clear();
        pendingMutationRecordMap.clear();
        subscriberMap.forEach((set)=>{
            set.forEach((callback)=>{
                callback({
                    status: (0, $131b3f6f00984c1a$export$1af79998fa14ea8)
                });
            });
        });
        subscriberMap.clear();
    }
    function getRecord(...params) {
        const cacheKey = getKey(params);
        const pendingMutationRecordMap = getCacheForType(createPendingMutationRecordMap);
        return pendingMutationRecordMap.get(cacheKey) ?? recordMap.get(cacheKey);
    }
    function getOrCreateRecord(...params) {
        const cacheKey = getKey(params);
        const pendingMutationRecordMap = getCacheForType(createPendingMutationRecordMap);
        let record = getRecord(...params);
        if (record == null) {
            debugLog("read() Cache miss", params);
            const abortController = new AbortController();
            const deferred = (0, $1d0742bf523b27d5$export$e673efccd97e4223)(debugLabel ? `${debugLabel} ${cacheKey}` : cacheKey);
            record = (0, $19c637b0d2d7681e$export$53e0f549136dd099)(deferred, abortController);
            recordMap.set(cacheKey, record);
            pendingMutationRecordMap.set(cacheKey, record);
            notifySubscribers(params);
            processPendingRecord(abortController.signal, record, ...params);
        } else debugLog("read() Cache hit", params);
        return record;
    }
    function getStatus(...params) {
        debugLog("getStatus()", params);
        const cacheKey = getKey(params);
        // Check for pending mutations first
        if (mutationAbortControllerMap.has(cacheKey)) return 0, $131b3f6f00984c1a$export$102c3f975dbe36bd;
        // Else fall back to Record status
        const record = recordMap.get(cacheKey);
        if (!record) return 0, $131b3f6f00984c1a$export$1af79998fa14ea8;
        else if ((0, $3138a7e7e2612756$export$893ad6457b7fbafc)(record)) return record.data.status;
        return record.data.status;
    }
    function getValue(...params) {
        debugLog("getValue()", params);
        const cacheKey = getKey(params);
        const record = recordMap.get(cacheKey);
        if (record == null) throw Error("No record found");
        else if ((0, $3138a7e7e2612756$export$2285469376868a97)(record)) throw record.data.error;
        else if ((0, $3138a7e7e2612756$export$893ad6457b7fbafc)(record)) return record.data.value;
        else throw Error(`Record found with status "${record.data.status}"`);
    }
    function getValueIfCached(...params) {
        debugLog("getValueIfCached()", params);
        const cacheKey = getKey(params);
        const record = recordMap.get(cacheKey);
        if (record && (0, $3138a7e7e2612756$export$893ad6457b7fbafc)(record)) return record.data.value;
    }
    function onExternalCacheEviction(key) {
        const set = subscriberMap.get(key);
        if (set) set.forEach((callback)=>{
            callback({
                status: (0, $131b3f6f00984c1a$export$1af79998fa14ea8)
            });
        });
    }
    function prefetch(...params) {
        debugLog("prefetch()", params);
        try {
            const promiseOrValue = readAsync(...params);
            if ((0, $2e69071d085c545a$export$ae936b9d47e5870e)(promiseOrValue)) promiseOrValue.then(()=>{}, (error)=>{
            // Don't let readAsync throw an uncaught error.
            });
        } catch  {
        // Don't throw an already-cached error
        }
    }
    function readAsync(...params) {
        // getOrCreateRecord() will call debugLog (cache hit or miss)
        const record = getOrCreateRecord(...params);
        if ((0, $3138a7e7e2612756$export$457b50c8400bb39e)(record)) return record.data.deferred.promise;
        if ((0, $3138a7e7e2612756$export$893ad6457b7fbafc)(record)) return record.data.value;
        throw record.data.error;
    }
    function read(...params) {
        // getOrCreateRecord() will call debugLog (cache hit or miss)
        const record = getOrCreateRecord(...params);
        if ((0, $3138a7e7e2612756$export$457b50c8400bb39e)(record)) throw record.data.deferred.promise;
        else if ((0, $3138a7e7e2612756$export$893ad6457b7fbafc)(record)) return record.data.value;
        else throw record.data.error;
    }
    function getSubscriptionData(params) {
        const status = getStatus(...params);
        const record = getRecord(...params);
        if (status === (0, $131b3f6f00984c1a$export$102c3f975dbe36bd)) // Special case pending, async mutation
        return {
            status: status
        };
        if (record) {
            if ((0, $3138a7e7e2612756$export$893ad6457b7fbafc)(record)) return {
                status: (0, $131b3f6f00984c1a$export$95b9efe7da5fb195),
                value: record.data.value
            };
            else if ((0, $3138a7e7e2612756$export$2285469376868a97)(record)) return {
                error: record.data.error,
                status: (0, $131b3f6f00984c1a$export$89864f7e9466db1c)
            };
        }
        return {
            status: status
        };
    }
    function notifySubscribers(params, data) {
        const cacheKey = getKey(params);
        const set = subscriberMap.get(cacheKey);
        if (set) {
            if (data === undefined) data = getSubscriptionData(params);
            set.forEach((callback)=>{
                callback(data);
            });
        }
    }
    async function processPendingRecord(abortSignal, record, ...params) {
        (0, $a95b1a9483edd973$export$5720014d5c94137d)(record);
        const { abortController: abortController, deferred: deferred } = record.data;
        try {
            const valueOrPromiseLike = load(params, abortController);
            const value = (0, $2e69071d085c545a$export$ae936b9d47e5870e)(valueOrPromiseLike) ? await valueOrPromiseLike : valueOrPromiseLike;
            if (!abortSignal.aborted) {
                debugLog("read() Pending request resolved", params, value);
                (0, $19c637b0d2d7681e$export$bf8e65ce0c179a6a)(record, value);
                deferred.resolve(value);
            }
        } catch (error) {
            if (!abortSignal.aborted) {
                debugLog("read() Pending request rejected", params, error);
                (0, $19c637b0d2d7681e$export$fabf043b34d5c98b)(record, error);
                deferred.reject(error);
            }
        } finally{
            if (!abortSignal.aborted) notifySubscribers(params);
        }
    }
    function subscribe(callback, ...params) {
        debugLog("subscribe()", params);
        const cacheKey = getKey(params);
        let set = subscriberMap.get(cacheKey);
        if (set) set.add(callback);
        else {
            set = new Set([
                callback
            ]);
            subscriberMap.set(cacheKey, set);
        }
        try {
            const data = getSubscriptionData(params);
            callback(data);
        } finally{
            return ()=>{
                set.delete(callback);
                if (set.size === 0) subscriberMap.delete(cacheKey);
            };
        }
    }
    const value = {
        // Internal API (used by useCacheMutation)
        __createPendingMutationRecordMap: createPendingMutationRecordMap,
        __getKey: getKey,
        __getOrCreateRecord: getOrCreateRecord,
        __isImmutable: ()=>immutable,
        __mutationAbortControllerMap: mutationAbortControllerMap,
        __notifySubscribers: notifySubscribers,
        __recordMap: recordMap,
        abort: // Public API
        abort,
        cache: cache,
        disableDebugLogging: disableDebugLogging,
        enableDebugLogging: enableDebugLogging,
        evict: evict,
        evictAll: evictAll,
        getStatus: getStatus,
        getValue: getValue,
        getValueIfCached: getValueIfCached,
        readAsync: readAsync,
        read: read,
        prefetch: prefetch,
        subscribe: subscribe
    };
    return value;
}





function $1925eaa3ea3b32f2$export$1b3de7f46ad5e501(options) {
    const { timeout: timeout, timeoutMessage: timeoutMessage = "Timed out", ...rest } = options;
    const decoratedCache = (0, $1e2a96dfa0b62734$export$cf6fa0bbcc94b912)({
        ...rest,
        load: async (params, loadOptions)=>new Promise((resolve, reject)=>{
                if (timeout != null) setTimeout(()=>{
                    if (!loadOptions.signal.aborted) reject(timeoutMessage);
                }, timeout);
            })
    });
    const { __getKey: __getKey, __getOrCreateRecord: __getOrCreateRecord, __notifySubscribers: __notifySubscribers, __recordMap: __recordMap } = decoratedCache;
    const { cache: cache, ...api } = decoratedCache;
    return {
        ...api,
        cacheError (error, ...params) {
            const key = __getKey(params);
            const record = __getOrCreateRecord(...params);
            if ((0, $3138a7e7e2612756$export$457b50c8400bb39e)(record)) {
                const { abortController: abortController, deferred: deferred } = record.data;
                abortController.abort();
                (0, $19c637b0d2d7681e$export$fabf043b34d5c98b)(record, error);
                // Don't leave any pending request hanging
                deferred.reject(error);
            }
            __recordMap.set(key, record);
            __notifySubscribers(params);
        },
        cacheValue (value, ...params) {
            const key = __getKey(params);
            const record = __getOrCreateRecord(...params);
            if ((0, $3138a7e7e2612756$export$457b50c8400bb39e)(record)) {
                const { abortController: abortController, deferred: deferred } = record.data;
                abortController.abort();
                (0, $19c637b0d2d7681e$export$bf8e65ce0c179a6a)(record, value);
                // Don't leave any pending request hanging
                deferred.resolve(value);
            }
            __recordMap.set(key, record);
            __notifySubscribers(params);
        }
    };
}



function $23c5c3302ddce618$export$8d21e34596265fa2(compareValues) {
    function find(sortedItems, targetItem) {
        const index = findIndex(sortedItems, targetItem, true);
        if (index >= 0) return sortedItems[index];
        else return null;
    }
    // Note that for non-exact matches to work
    // the comparison function should return more fine-grained delta values than the typical -1, 0, or 1.
    function findIndex(sortedItems, targetItem, exactMatch = true) {
        let lowIndex = 0;
        let highIndex = sortedItems.length - 1;
        let middleIndex = -1;
        while(lowIndex <= highIndex){
            middleIndex = lowIndex + highIndex >>> 1;
            const currentItem = sortedItems[middleIndex];
            const value = compareValues(targetItem, currentItem);
            if (value === 0) return middleIndex;
            else if (value > 0) lowIndex = middleIndex + 1;
            else highIndex = middleIndex - 1;
        }
        if (exactMatch) return -1;
        else {
            switch(sortedItems.length){
                case 0:
                    return -1;
                case 1:
                    return 0;
            }
            const value = compareValues(targetItem, sortedItems[middleIndex]);
            if (value === 0) return middleIndex;
            else {
                let lowIndex = middleIndex;
                let highIndex = middleIndex;
                if (value > 0) highIndex = Math.min(middleIndex + 1, sortedItems.length - 1);
                else lowIndex = Math.max(0, middleIndex - 1);
                return Math.abs(compareValues(targetItem, sortedItems[lowIndex])) < Math.abs(compareValues(targetItem, sortedItems[highIndex])) ? lowIndex : highIndex;
            }
        }
    }
    function findInsertIndex(sortedItems, item) {
        let lowIndex = 0;
        let highIndex = sortedItems.length;
        while(lowIndex < highIndex){
            let middleIndex = lowIndex + highIndex >>> 1;
            const currentItem = sortedItems[middleIndex];
            if (compareValues(item, currentItem) > 0) lowIndex = middleIndex + 1;
            else highIndex = middleIndex;
        }
        return lowIndex;
    }
    function insert(sortedItems, item) {
        const insertAtIndex = findInsertIndex(sortedItems, item);
        sortedItems.splice(insertAtIndex, 0, item);
        return sortedItems;
    }
    return {
        find: find,
        findIndex: findIndex,
        findInsertIndex: findInsertIndex,
        insert: insert
    };
}






function $b822e0460ddd0c69$export$8d21e34596265fa2(comparePoints) {
    function binarySearch(sortedPoints, targetPoint, exactMatch) {
        if (sortedPoints.length === 0) return -1;
        let lowIndex = 0;
        let highIndex = sortedPoints.length - 1;
        let middleIndex = -1;
        while(lowIndex <= highIndex){
            middleIndex = lowIndex + highIndex >>> 1;
            const currentPoint = sortedPoints[middleIndex];
            const value = comparePoints(targetPoint, currentPoint);
            if (value === 0) return middleIndex;
            else if (value > 0) lowIndex = middleIndex + 1;
            else highIndex = middleIndex - 1;
        }
        if (exactMatch) return -1;
        const middlePoint = sortedPoints[middleIndex];
        const value = comparePoints(targetPoint, middlePoint);
        if (value === 0) return middleIndex;
        else {
            let lowIndex = middleIndex;
            let highIndex = middleIndex;
            if (value > 0) highIndex = Math.min(middleIndex + 1, sortedPoints.length - 1);
            else lowIndex = Math.max(0, middleIndex - 1);
            const lowPoint = sortedPoints[lowIndex];
            const highPoint = sortedPoints[highIndex];
            return Math.abs(comparePoints(targetPoint, lowPoint)) < Math.abs(comparePoints(targetPoint, highPoint)) ? lowIndex : highIndex;
        }
    }
    function compare(a, b) {
        const result = comparePoints(a, b);
        if (result === 0) return 0;
        else return result < 0 ? -1 : 1;
    }
    function equals(a, b) {
        return comparePoints(a, b) === 0;
    }
    function findIndex(sortedPoints, point) {
        return binarySearch(sortedPoints, point, true);
    }
    function findNearestIndex(sortedPoints, point) {
        return binarySearch(sortedPoints, point, false);
    }
    function findNearestIndexAfter(sortedPoints, targetPoint) {
        if (sortedPoints.length === 0) return -1;
        const index = binarySearch(sortedPoints, targetPoint, false);
        const foundPoint = sortedPoints[index];
        const comparison = comparePoints(foundPoint, targetPoint);
        return comparison < 0 ? index + 1 : index;
    }
    function findNearestIndexBefore(sortedPoints, targetPoint) {
        if (sortedPoints.length === 0) return -1;
        const index = binarySearch(sortedPoints, targetPoint, false);
        const foundPoint = sortedPoints[index];
        const comparison = comparePoints(foundPoint, targetPoint);
        return comparison > 0 ? index - 1 : index;
    }
    function greaterThan(a, b) {
        return comparePoints(a, b) > 0;
    }
    function greaterThanOrEqualTo(a, b) {
        return comparePoints(a, b) >= 0;
    }
    function lessThan(a, b) {
        return comparePoints(a, b) < 0;
    }
    function lessThanOrEqualTo(a, b) {
        return comparePoints(a, b) <= 0;
    }
    return {
        compare: compare,
        equals: equals,
        findIndex: findIndex,
        findNearestIndex: findNearestIndex,
        findNearestIndexAfter: findNearestIndexAfter,
        findNearestIndexBefore: findNearestIndexBefore,
        greaterThan: greaterThan,
        greaterThanOrEqualTo: greaterThanOrEqualTo,
        lessThan: lessThan,
        lessThanOrEqualTo: lessThanOrEqualTo
    };
}






function $bbc74fbbdcd4039f$export$8d21e34596265fa2(comparePoints) {
    const pointUtils = (0, $b822e0460ddd0c69$export$8d21e34596265fa2)(comparePoints);
    function compare(a, b) {
        const start = pointUtils.compare(a[0], b[0]);
        const end = pointUtils.compare(a[1], b[1]);
        return start === 0 ? end : start;
    }
    function contains(a, b) {
        return pointUtils.lessThanOrEqualTo(a[0], b[0]) && pointUtils.greaterThanOrEqualTo(a[1], b[1]);
    }
    function equals(a, b) {
        return pointUtils.equals(a[0], b[0]) && pointUtils.equals(a[1], b[1]);
    }
    function greaterThan(a, b) {
        if (pointUtils.greaterThan(a[0], b[0])) return true;
        else if (pointUtils.equals(a[0], b[0])) return pointUtils.greaterThan(a[1], b[1]);
        else return false;
    }
    function greaterThanOrEqualTo(a, b) {
        return !lessThan(a, b);
    }
    function intersects(a, b) {
        return pointUtils.greaterThanOrEqualTo(a[1], b[0]) && pointUtils.greaterThanOrEqualTo(b[1], a[0]);
    }
    function lessThan(a, b) {
        if (pointUtils.lessThan(a[0], b[0])) return true;
        else if (pointUtils.equals(a[0], b[0])) return pointUtils.lessThan(a[1], b[1]);
        else return false;
    }
    function lessThanOrEqualTo(a, b) {
        return !greaterThan(a, b);
    }
    function merge(a, b) {
        if (contains(a, b)) return [
            a
        ];
        else if (contains(b, a)) return [
            b
        ];
        else if (!intersects(a, b)) return pointUtils.lessThan(a[0], b[0]) ? [
            a,
            b
        ] : [
            b,
            a
        ];
        else {
            if (pointUtils.lessThan(a[0], b[0])) return [
                [
                    a[0],
                    b[1]
                ]
            ];
            else return [
                [
                    b[0],
                    a[1]
                ]
            ];
        }
    }
    function mergeAll(...sortedIntervals) {
        if (sortedIntervals.length === 0) return [];
        else if (sortedIntervals.length === 1) return sortedIntervals;
        const merged = [];
        let prevInterval = sortedIntervals[0];
        let currentInterval = null;
        for(let index = 1; index < sortedIntervals.length; index++){
            currentInterval = sortedIntervals[index];
            const tempMerged = merge(prevInterval, currentInterval);
            prevInterval = tempMerged.pop();
            merged.push(...tempMerged);
        }
        merged.push(prevInterval);
        return merged;
    }
    function separate(a, b) {
        const separated = {
            a: [],
            ab: [],
            b: []
        };
        if (equals(a, b)) separated.ab.push(a);
        else if (!intersects(a, b)) {
            separated.a.push(a);
            separated.b.push(b);
        } else {
            const [a0, a1] = a;
            const [b0, b1] = b;
            if (pointUtils.lessThan(a0, b0)) separated.a.push([
                a0,
                b0
            ]);
            else if (pointUtils.greaterThan(a0, b0)) separated.b.push([
                b0,
                a0
            ]);
            if (pointUtils.lessThan(a0, b0)) separated.ab.push([
                b0,
                pointUtils.lessThan(a1, b1) ? a1 : b1
            ]);
            else separated.ab.push([
                a0,
                pointUtils.lessThan(a1, b1) ? a1 : b1
            ]);
            if (pointUtils.lessThan(a1, b1)) separated.b.push([
                a1,
                b1
            ]);
            else if (pointUtils.greaterThan(a1, b1)) separated.a.push([
                b1,
                a1
            ]);
        }
        return separated;
    }
    function separateAll(a, b) {
        const separated = {
            a: [],
            ab: [],
            b: []
        };
        let currentA = a[0] ?? null;
        let currentB = b[0] ?? null;
        let indexA = 0;
        let indexB = 0;
        while(currentA !== null && currentB !== null){
            const separatedLoop = separate(currentA, currentB);
            // It's always okay to push all overlapping intervals
            separated.ab.push(...separatedLoop.ab);
            // If the ends of the current interval align, we can push all excluded intervals
            // Else we should keep the last interval for whichever comes last
            // because it might overlap with the next interval in the other set
            if (pointUtils.equals(currentA[1], currentB[1])) {
                separated.b.push(...separatedLoop.b);
                separated.a.push(...separatedLoop.a);
                currentA = a[++indexA] ?? null;
                currentB = b[++indexB] ?? null;
            } else if (pointUtils.greaterThan(currentA[1], currentB[1])) {
                currentA = separatedLoop.a.pop();
                separated.b.push(...separatedLoop.b);
                separated.a.push(...separatedLoop.a);
                currentB = b[++indexB] ?? null;
            } else {
                currentB = separatedLoop.b.pop();
                separated.b.push(...separatedLoop.b);
                separated.a.push(...separatedLoop.a);
                currentA = a[++indexA] ?? null;
            }
        }
        while(currentA !== null){
            separated.a.push(currentA);
            currentA = a[++indexA] ?? null;
        }
        while(currentB !== null){
            separated.b.push(currentB);
            currentB = b[++indexB] ?? null;
        }
        return separated;
    }
    function sort(...intervals) {
        return intervals.sort(compare);
    }
    return {
        compare: compare,
        contains: contains,
        equals: equals,
        greaterThan: greaterThan,
        greaterThanOrEqualTo: greaterThanOrEqualTo,
        intersects: intersects,
        lessThan: lessThan,
        lessThanOrEqualTo: lessThanOrEqualTo,
        merge: merge,
        mergeAll: mergeAll,
        separate: separate,
        separateAll: separateAll,
        sort: sort
    };
}






var $cd3e418e399ebf7a$exports = {};
"use strict";
// An augmented AVL Tree where each node maintains a list of records and their search intervals.
// Record is composed of an interval and its underlying data, sent by a client. This allows the
// interval tree to have the same interval inserted multiple times, as long its data is different.
// Both insertion and deletion require O(log n) time. Searching requires O(k*logn) time, where `k`
// is the number of intervals in the output list.
Object.defineProperty($cd3e418e399ebf7a$exports, "__esModule", {
    value: true
});
$cd3e418e399ebf7a$exports.PreOrder = $cd3e418e399ebf7a$exports.ReverseInOrder = $cd3e418e399ebf7a$exports.InOrder = $cd3e418e399ebf7a$exports.IntervalTree = $cd3e418e399ebf7a$exports.Node = void 0;
var $b4642ebd5ab4ee1c$exports = {};
//
$b4642ebd5ab4ee1c$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $cd3e418e399ebf7a$var$max(a, b) {
    return a < b ? b : a;
}
function $cd3e418e399ebf7a$var$height(node) {
    if (node === undefined) return -1;
    else return node.height;
}
var $cd3e418e399ebf7a$var$Node = /** @class */ function() {
    function Node(intervalTree, record) {
        this.intervalTree = intervalTree;
        this.records = [];
        this.height = 0;
        this.key = record.low;
        this.max = record.high;
        // Save the array of all records with the same key for this node
        this.records.push(record);
    }
    // Gets the highest record.high value for this node
    Node.prototype.getNodeHigh = function() {
        var high = this.records[0].high;
        for(var i = 1; i < this.records.length; i++)if (this.records[i].high > high) high = this.records[i].high;
        return high;
    };
    // Updates height value of the node. Called during insertion, rebalance, removal
    Node.prototype.updateHeight = function() {
        this.height = $cd3e418e399ebf7a$var$max($cd3e418e399ebf7a$var$height(this.left), $cd3e418e399ebf7a$var$height(this.right)) + 1;
    };
    // Updates the max value of all the parents after inserting into already existing node, as well as
    // removing the node completely or removing the record of an already existing node. Starts with
    // the parent of an affected node and bubbles up to root
    Node.prototype.updateMaxOfParents = function() {
        if (this === undefined) return;
        var thisHigh = this.getNodeHigh();
        if (this.left !== undefined && this.right !== undefined) this.max = $cd3e418e399ebf7a$var$max($cd3e418e399ebf7a$var$max(this.left.max, this.right.max), thisHigh);
        else if (this.left !== undefined && this.right === undefined) this.max = $cd3e418e399ebf7a$var$max(this.left.max, thisHigh);
        else if (this.left === undefined && this.right !== undefined) this.max = $cd3e418e399ebf7a$var$max(this.right.max, thisHigh);
        else this.max = thisHigh;
        if (this.parent) this.parent.updateMaxOfParents();
    };
    /*
    Left-Left case:
  
           z                                      y
          / \                                   /   \
         y   T4      Right Rotate (z)          x     z
        / \          - - - - - - - - ->       / \   / \
       x   T3                                T1 T2 T3 T4
      / \
    T1   T2
  
    Left-Right case:
  
         z                               z                           x
        / \                             / \                        /   \
       y   T4  Left Rotate (y)         x  T4  Right Rotate(z)     y     z
      / \      - - - - - - - - ->     / \      - - - - - - - ->  / \   / \
    T1   x                           y  T3                      T1 T2 T3 T4
        / \                         / \
      T2   T3                      T1 T2
    */ // Handles Left-Left case and Left-Right case after rebalancing AVL tree
    Node.prototype._updateMaxAfterRightRotate = function() {
        var parent = this.parent;
        var left = parent.left;
        // Update max of left sibling (x in first case, y in second)
        var thisParentLeftHigh = left.getNodeHigh();
        if (left.left === undefined && left.right !== undefined) left.max = $cd3e418e399ebf7a$var$max(thisParentLeftHigh, left.right.max);
        else if (left.left !== undefined && left.right === undefined) left.max = $cd3e418e399ebf7a$var$max(thisParentLeftHigh, left.left.max);
        else if (left.left === undefined && left.right === undefined) left.max = thisParentLeftHigh;
        else left.max = $cd3e418e399ebf7a$var$max($cd3e418e399ebf7a$var$max(left.left.max, left.right.max), thisParentLeftHigh);
        // Update max of itself (z)
        var thisHigh = this.getNodeHigh();
        if (this.left === undefined && this.right !== undefined) this.max = $cd3e418e399ebf7a$var$max(thisHigh, this.right.max);
        else if (this.left !== undefined && this.right === undefined) this.max = $cd3e418e399ebf7a$var$max(thisHigh, this.left.max);
        else if (this.left === undefined && this.right === undefined) this.max = thisHigh;
        else this.max = $cd3e418e399ebf7a$var$max($cd3e418e399ebf7a$var$max(this.left.max, this.right.max), thisHigh);
        // Update max of parent (y in first case, x in second)
        parent.max = $cd3e418e399ebf7a$var$max($cd3e418e399ebf7a$var$max(parent.left.max, parent.right.max), parent.getNodeHigh());
    };
    /*
    Right-Right case:
  
      z                               y
     / \                            /   \
    T1  y     Left Rotate(z)       z     x
       / \   - - - - - - - ->     / \   / \
      T2  x                      T1 T2 T3 T4
         / \
        T3 T4
  
    Right-Left case:
  
       z                            z                            x
      / \                          / \                         /   \
     T1  y   Right Rotate (y)     T1  x      Left Rotate(z)   z     y
        / \  - - - - - - - - ->      / \   - - - - - - - ->  / \   / \
       x  T4                        T2  y                   T1 T2 T3 T4
      / \                              / \
    T2   T3                           T3 T4
    */ // Handles Right-Right case and Right-Left case in rebalancing AVL tree
    Node.prototype._updateMaxAfterLeftRotate = function() {
        var parent = this.parent;
        var right = parent.right;
        // Update max of right sibling (x in first case, y in second)
        var thisParentRightHigh = right.getNodeHigh();
        if (right.left === undefined && right.right !== undefined) right.max = $cd3e418e399ebf7a$var$max(thisParentRightHigh, right.right.max);
        else if (right.left !== undefined && right.right === undefined) right.max = $cd3e418e399ebf7a$var$max(thisParentRightHigh, right.left.max);
        else if (right.left === undefined && right.right === undefined) right.max = thisParentRightHigh;
        else right.max = $cd3e418e399ebf7a$var$max($cd3e418e399ebf7a$var$max(right.left.max, right.right.max), thisParentRightHigh);
        // Update max of itself (z)
        var thisHigh = this.getNodeHigh();
        if (this.left === undefined && this.right !== undefined) this.max = $cd3e418e399ebf7a$var$max(thisHigh, this.right.max);
        else if (this.left !== undefined && this.right === undefined) this.max = $cd3e418e399ebf7a$var$max(thisHigh, this.left.max);
        else if (this.left === undefined && this.right === undefined) this.max = thisHigh;
        else this.max = $cd3e418e399ebf7a$var$max($cd3e418e399ebf7a$var$max(this.left.max, this.right.max), thisHigh);
        // Update max of parent (y in first case, x in second)
        parent.max = $cd3e418e399ebf7a$var$max($cd3e418e399ebf7a$var$max(parent.left.max, right.max), parent.getNodeHigh());
    };
    Node.prototype._leftRotate = function() {
        var rightChild = this.right;
        rightChild.parent = this.parent;
        if (rightChild.parent === undefined) this.intervalTree.root = rightChild;
        else {
            if (rightChild.parent.left === this) rightChild.parent.left = rightChild;
            else if (rightChild.parent.right === this) rightChild.parent.right = rightChild;
        }
        this.right = rightChild.left;
        if (this.right !== undefined) this.right.parent = this;
        rightChild.left = this;
        this.parent = rightChild;
        this.updateHeight();
        rightChild.updateHeight();
    };
    Node.prototype._rightRotate = function() {
        var leftChild = this.left;
        leftChild.parent = this.parent;
        if (leftChild.parent === undefined) this.intervalTree.root = leftChild;
        else {
            if (leftChild.parent.left === this) leftChild.parent.left = leftChild;
            else if (leftChild.parent.right === this) leftChild.parent.right = leftChild;
        }
        this.left = leftChild.right;
        if (this.left !== undefined) this.left.parent = this;
        leftChild.right = this;
        this.parent = leftChild;
        this.updateHeight();
        leftChild.updateHeight();
    };
    // Rebalances the tree if the height value between two nodes of the same parent is greater than
    // two. There are 4 cases that can happen which are outlined in the graphics above
    Node.prototype._rebalance = function() {
        if ($cd3e418e399ebf7a$var$height(this.left) >= 2 + $cd3e418e399ebf7a$var$height(this.right)) {
            var left = this.left;
            if ($cd3e418e399ebf7a$var$height(left.left) >= $cd3e418e399ebf7a$var$height(left.right)) {
                // Left-Left case
                this._rightRotate();
                this._updateMaxAfterRightRotate();
            } else {
                // Left-Right case
                left._leftRotate();
                this._rightRotate();
                this._updateMaxAfterRightRotate();
            }
        } else if ($cd3e418e399ebf7a$var$height(this.right) >= 2 + $cd3e418e399ebf7a$var$height(this.left)) {
            var right = this.right;
            if ($cd3e418e399ebf7a$var$height(right.right) >= $cd3e418e399ebf7a$var$height(right.left)) {
                // Right-Right case
                this._leftRotate();
                this._updateMaxAfterLeftRotate();
            } else {
                // Right-Left case
                right._rightRotate();
                this._leftRotate();
                this._updateMaxAfterLeftRotate();
            }
        }
    };
    Node.prototype.insert = function(record) {
        if (record.low < this.key) {
            // Insert into left subtree
            if (this.left === undefined) {
                this.left = new Node(this.intervalTree, record);
                this.left.parent = this;
            } else this.left.insert(record);
        } else // Insert into right subtree
        if (this.right === undefined) {
            this.right = new Node(this.intervalTree, record);
            this.right.parent = this;
        } else this.right.insert(record);
        // Update the max value of this ancestor if needed
        if (this.max < record.high) this.max = record.high;
        // Update height of each node
        this.updateHeight();
        // Rebalance the tree to ensure all operations are executed in O(logn) time. This is especially
        // important in searching, as the tree has a high chance of degenerating without the rebalancing
        this._rebalance();
    };
    Node.prototype._getOverlappingRecords = function(currentNode, low, high) {
        if (currentNode.key <= high && low <= currentNode.getNodeHigh()) {
            // Nodes are overlapping, check if individual records in the node are overlapping
            var tempResults = [];
            for(var i = 0; i < currentNode.records.length; i++)if (currentNode.records[i].high >= low) tempResults.push(currentNode.records[i]);
            return tempResults;
        }
        return [];
    };
    Node.prototype.search = function(low, high) {
        // Don't search nodes that don't exist
        if (this === undefined) return [];
        var leftSearch = [];
        var ownSearch = [];
        var rightSearch = [];
        // If interval is to the right of the rightmost point of any interval in this node and all its
        // children, there won't be any matches
        if (low > this.max) return [];
        // Search left children
        if (this.left !== undefined && this.left.max >= low) leftSearch = this.left.search(low, high);
        // Check this node
        ownSearch = this._getOverlappingRecords(this, low, high);
        // If interval is to the left of the start of this interval, then it can't be in any child to
        // the right
        if (high < this.key) return leftSearch.concat(ownSearch);
        // Otherwise, search right children
        if (this.right !== undefined) rightSearch = this.right.search(low, high);
        // Return accumulated results, if any
        return leftSearch.concat(ownSearch, rightSearch);
    };
    // Searches for a node by a `key` value
    Node.prototype.searchExisting = function(low) {
        if (this === undefined) return undefined;
        if (this.key === low) return this;
        else if (low < this.key) {
            if (this.left !== undefined) return this.left.searchExisting(low);
        } else {
            if (this.right !== undefined) return this.right.searchExisting(low);
        }
        return undefined;
    };
    // Returns the smallest node of the subtree
    Node.prototype._minValue = function() {
        if (this.left === undefined) return this;
        else return this.left._minValue();
    };
    Node.prototype.remove = function(node) {
        var parent = this.parent;
        if (node.key < this.key) {
            // Node to be removed is on the left side
            if (this.left !== undefined) return this.left.remove(node);
            else return undefined;
        } else if (node.key > this.key) {
            // Node to be removed is on the right side
            if (this.right !== undefined) return this.right.remove(node);
            else return undefined;
        } else {
            if (this.left !== undefined && this.right !== undefined) {
                // Node has two children
                var minValue = this.right._minValue();
                this.key = minValue.key;
                this.records = minValue.records;
                return this.right.remove(this);
            } else if (parent.left === this) {
                // One child or no child case on left side
                if (this.right !== undefined) {
                    parent.left = this.right;
                    this.right.parent = parent;
                } else {
                    parent.left = this.left;
                    if (this.left !== undefined) this.left.parent = parent;
                }
                parent.updateMaxOfParents();
                parent.updateHeight();
                parent._rebalance();
                return this;
            } else if (parent.right === this) {
                // One child or no child case on right side
                if (this.right !== undefined) {
                    parent.right = this.right;
                    this.right.parent = parent;
                } else {
                    parent.right = this.left;
                    if (this.left !== undefined) this.left.parent = parent;
                }
                parent.updateMaxOfParents();
                parent.updateHeight();
                parent._rebalance();
                return this;
            }
        }
        // Make linter happy
        return undefined;
    };
    return Node;
}();
$cd3e418e399ebf7a$exports.Node = $cd3e418e399ebf7a$var$Node;
var $cd3e418e399ebf7a$var$IntervalTree = /** @class */ function() {
    function IntervalTree() {
        this.count = 0;
    }
    IntervalTree.prototype.insert = function(record) {
        if (record.low > record.high) throw new Error("`low` value must be lower or equal to `high` value");
        if (this.root === undefined) {
            // Base case: Tree is empty, new node becomes root
            this.root = new $cd3e418e399ebf7a$var$Node(this, record);
            this.count++;
            return true;
        } else {
            // Otherwise, check if node already exists with the same key
            var node = this.root.searchExisting(record.low);
            if (node !== undefined) {
                // Check the records in this node if there already is the one with same low, high, data
                for(var i = 0; i < node.records.length; i++){
                    if ($b4642ebd5ab4ee1c$exports(node.records[i], record)) // This record is same as the one we're trying to insert; return false to indicate
                    // nothing has been inserted
                    return false;
                }
                // Add the record to the node
                node.records.push(record);
                // Update max of the node and its parents if necessary
                if (record.high > node.max) {
                    node.max = record.high;
                    if (node.parent) node.parent.updateMaxOfParents();
                }
                this.count++;
                return true;
            } else {
                // Node with this key doesn't already exist. Call insert function on root's node
                this.root.insert(record);
                this.count++;
                return true;
            }
        }
    };
    IntervalTree.prototype.search = function(low, high) {
        if (this.root === undefined) // Tree is empty; return empty array
        return [];
        else return this.root.search(low, high);
    };
    IntervalTree.prototype.remove = function(record) {
        if (this.root === undefined) // Tree is empty; nothing to remove
        return false;
        else {
            var node = this.root.searchExisting(record.low);
            if (node === undefined) return false;
            else if (node.records.length > 1) {
                var removedRecord = void 0;
                // Node with this key has 2 or more records. Find the one we need and remove it
                for(var i = 0; i < node.records.length; i++)if ($b4642ebd5ab4ee1c$exports(node.records[i], record)) {
                    removedRecord = node.records[i];
                    node.records.splice(i, 1);
                    break;
                }
                if (removedRecord) {
                    removedRecord = undefined;
                    // Update max of that node and its parents if necessary
                    if (record.high === node.max) {
                        var nodeHigh = node.getNodeHigh();
                        if (node.left !== undefined && node.right !== undefined) node.max = $cd3e418e399ebf7a$var$max($cd3e418e399ebf7a$var$max(node.left.max, node.right.max), nodeHigh);
                        else if (node.left !== undefined && node.right === undefined) node.max = $cd3e418e399ebf7a$var$max(node.left.max, nodeHigh);
                        else if (node.left === undefined && node.right !== undefined) node.max = $cd3e418e399ebf7a$var$max(node.right.max, nodeHigh);
                        else node.max = nodeHigh;
                        if (node.parent) node.parent.updateMaxOfParents();
                    }
                    this.count--;
                    return true;
                } else return false;
            } else if (node.records.length === 1) {
                // Node with this key has only 1 record. Check if the remaining record in this node is
                // actually the one we want to remove
                if ($b4642ebd5ab4ee1c$exports(node.records[0], record)) {
                    // The remaining record is the one we want to remove. Remove the whole node from the tree
                    if (this.root.key === node.key) {
                        // We're removing the root element. Create a dummy node that will temporarily take
                        // root's parent role
                        var rootParent = new $cd3e418e399ebf7a$var$Node(this, {
                            low: record.low,
                            high: record.low
                        });
                        rootParent.left = this.root;
                        this.root.parent = rootParent;
                        var removedNode = this.root.remove(node);
                        this.root = rootParent.left;
                        if (this.root !== undefined) this.root.parent = undefined;
                        if (removedNode) {
                            removedNode = undefined;
                            this.count--;
                            return true;
                        } else return false;
                    } else {
                        var removedNode = this.root.remove(node);
                        if (removedNode) {
                            removedNode = undefined;
                            this.count--;
                            return true;
                        } else return false;
                    }
                } else // The remaining record is not the one we want to remove
                return false;
            } else // No records at all in this node?! Shouldn't happen
            return false;
        }
    };
    IntervalTree.prototype.inOrder = function() {
        return new $cd3e418e399ebf7a$var$InOrder(this.root);
    };
    IntervalTree.prototype.reverseInOrder = function() {
        return new $cd3e418e399ebf7a$var$ReverseInOrder(this.root);
    };
    IntervalTree.prototype.preOrder = function() {
        return new $cd3e418e399ebf7a$var$PreOrder(this.root);
    };
    return IntervalTree;
}();
$cd3e418e399ebf7a$exports.IntervalTree = $cd3e418e399ebf7a$var$IntervalTree;
/**
 * The default export just wraps the `IntervalTree`, while providing a simpler API. Check out the
 * README for description on how to use each.
 */ var $cd3e418e399ebf7a$var$DataIntervalTree = /** @class */ function() {
    function DataIntervalTree() {
        this.tree = new $cd3e418e399ebf7a$var$IntervalTree();
    }
    DataIntervalTree.prototype.insert = function(low, high, data) {
        return this.tree.insert({
            low: low,
            high: high,
            data: data
        });
    };
    DataIntervalTree.prototype.remove = function(low, high, data) {
        return this.tree.remove({
            low: low,
            high: high,
            data: data
        });
    };
    DataIntervalTree.prototype.search = function(low, high) {
        return this.tree.search(low, high).map(function(v) {
            return v.data;
        });
    };
    DataIntervalTree.prototype.inOrder = function() {
        return this.tree.inOrder();
    };
    DataIntervalTree.prototype.reverseInOrder = function() {
        return this.tree.reverseInOrder();
    };
    DataIntervalTree.prototype.preOrder = function() {
        return this.tree.preOrder();
    };
    Object.defineProperty(DataIntervalTree.prototype, "count", {
        get: function() {
            return this.tree.count;
        },
        enumerable: false,
        configurable: true
    });
    return DataIntervalTree;
}();
$cd3e418e399ebf7a$exports.default = $cd3e418e399ebf7a$var$DataIntervalTree;
var $cd3e418e399ebf7a$var$InOrder = /** @class */ function() {
    function InOrder(startNode) {
        this.stack = [];
        if (startNode !== undefined) this.push(startNode);
    }
    InOrder.prototype[Symbol.iterator] = function() {
        return this;
    };
    InOrder.prototype.next = function() {
        // Will only happen if stack is empty and pop is called
        if (this.currentNode === undefined) return {
            done: true,
            value: undefined
        };
        // Process this node
        if (this.i < this.currentNode.records.length) return {
            done: false,
            value: this.currentNode.records[this.i++]
        };
        if (this.currentNode.right !== undefined) // Can we go right?
        this.push(this.currentNode.right);
        else // Otherwise go up
        // Might pop the last and set this.currentNode = undefined
        this.pop();
        return this.next();
    };
    InOrder.prototype.push = function(node) {
        this.currentNode = node;
        this.i = 0;
        while(this.currentNode.left !== undefined){
            this.stack.push(this.currentNode);
            this.currentNode = this.currentNode.left;
        }
    };
    InOrder.prototype.pop = function() {
        this.currentNode = this.stack.pop();
        this.i = 0;
    };
    return InOrder;
}();
$cd3e418e399ebf7a$exports.InOrder = $cd3e418e399ebf7a$var$InOrder;
var $cd3e418e399ebf7a$var$ReverseInOrder = /** @class */ function() {
    function ReverseInOrder(startNode) {
        this.stack = [];
        if (startNode !== undefined) this.push(startNode);
    }
    ReverseInOrder.prototype[Symbol.iterator] = function() {
        return this;
    };
    ReverseInOrder.prototype.next = function() {
        // Will only happen if stack is empty and pop is called
        if (this.currentNode === undefined) return {
            done: true,
            value: undefined
        };
        // Process this node
        if (this.currentNode.records.length && this.i >= 0) return {
            done: false,
            value: this.currentNode.records[this.i--]
        };
        if (this.currentNode.left !== undefined) // Can we go left?
        this.push(this.currentNode.left);
        else // Otherwise go up
        // Might pop the last and set this.currentNode = undefined
        this.pop();
        return this.next();
    };
    ReverseInOrder.prototype.push = function(node) {
        var _a, _b, _c, _d;
        this.currentNode = node;
        this.i = ((_b = (_a = this.currentNode) === null || _a === void 0 ? void 0 : _a.records.length) !== null && _b !== void 0 ? _b : 0) - 1;
        while(this.currentNode.right !== undefined){
            this.stack.push(this.currentNode);
            this.currentNode = this.currentNode.right;
            this.i = ((_d = (_c = this.currentNode) === null || _c === void 0 ? void 0 : _c.records.length) !== null && _d !== void 0 ? _d : 0) - 1;
        }
    };
    ReverseInOrder.prototype.pop = function() {
        var _a, _b;
        this.currentNode = this.stack.pop();
        this.i = ((_b = (_a = this.currentNode) === null || _a === void 0 ? void 0 : _a.records.length) !== null && _b !== void 0 ? _b : 0) - 1;
    };
    return ReverseInOrder;
}();
$cd3e418e399ebf7a$exports.ReverseInOrder = $cd3e418e399ebf7a$var$ReverseInOrder;
var $cd3e418e399ebf7a$var$PreOrder = /** @class */ function() {
    function PreOrder(startNode) {
        this.stack = [];
        this.i = 0;
        this.currentNode = startNode;
    }
    PreOrder.prototype[Symbol.iterator] = function() {
        return this;
    };
    PreOrder.prototype.next = function() {
        // Will only happen if stack is empty and pop is called,
        // which only happens if there is no right node (i.e we are done)
        if (this.currentNode === undefined) return {
            done: true,
            value: undefined
        };
        // Process this node
        if (this.i < this.currentNode.records.length) return {
            done: false,
            value: this.currentNode.records[this.i++]
        };
        if (this.currentNode.right !== undefined) this.push(this.currentNode.right);
        if (this.currentNode.left !== undefined) this.push(this.currentNode.left);
        this.pop();
        return this.next();
    };
    PreOrder.prototype.push = function(node) {
        this.stack.push(node);
    };
    PreOrder.prototype.pop = function() {
        this.currentNode = this.stack.pop();
        this.i = 0;
    };
    return PreOrder;
}();
$cd3e418e399ebf7a$exports.PreOrder = $cd3e418e399ebf7a$var$PreOrder;










function $62bfc6ba505dacc1$export$f7e1fc3814079caa(cachedIntervals, targetInterval, intervalUtils) {
    let targetIntervals = [
        targetInterval
    ];
    // Retry new intervals only if they are smaller than existing partial intervals
    // or if there's a partial overlap
    const retryIntersectingIntervals = cachedIntervals.partial.find((partialInterval)=>!intervalUtils.equals(partialInterval, targetInterval) && !intervalUtils.contains(targetInterval, partialInterval) && (intervalUtils.contains(partialInterval, targetInterval) || intervalUtils.intersects(partialInterval, targetInterval))) != null;
    // Find overlapping intervals containing partial results
    // Don't re-request those intervals unless requesting smaller ranges
    const { ab: partialAndRequestedIntervals, b: requestedIntervals } = intervalUtils.separateAll(cachedIntervals.partial, targetIntervals);
    // Find overlapping intervals containing failed results
    const { ab: failedIntervals } = intervalUtils.separateAll(cachedIntervals.failed, targetIntervals);
    targetIntervals = retryIntersectingIntervals ? intervalUtils.mergeAll(...partialAndRequestedIntervals, ...requestedIntervals) : requestedIntervals;
    const containsFailedResults = failedIntervals.length > 0;
    const containsPartialResults = !retryIntersectingIntervals && partialAndRequestedIntervals.length > 0;
    // Remove intervals that have already finished loading
    const { b: pendingOrNotLoadedIntervals } = intervalUtils.separateAll(cachedIntervals.loaded, targetIntervals);
    if (pendingOrNotLoadedIntervals.length === 0) // Everything has already been loaded
    return {
        containsFailedResults: containsFailedResults,
        containsPartialResults: containsPartialResults,
        missing: [],
        pending: []
    };
    else {
        // Separate the pending (in progress) intervals from the not-yet-loaded intervals
        const { b: missing, ab: pending } = intervalUtils.separateAll(cachedIntervals.pending, pendingOrNotLoadedIntervals);
        // Handle awkward edge cases by merging missing intervals
        // and filtering out any pending intervals that are contained within merged missing intervals
        const missingMerged = intervalUtils.mergeAll(...missing);
        const pendingFiltered = pending.filter((pendingInterval)=>{
            const contained = missingMerged.find((missingInterval)=>intervalUtils.contains(missingInterval, pendingInterval));
            return !contained;
        });
        return {
            containsFailedResults: containsFailedResults,
            containsPartialResults: containsPartialResults,
            missing: missingMerged,
            pending: pendingFiltered
        };
    }
}


function $9d95c6fe1b7a781a$export$9fb44ea51f14b4c6(sortedValues, start, end, getPointForValue, pointUtils) {
    if (sortedValues.length === 0) return [];
    const sortedPoints = sortedValues.map(getPointForValue);
    const startIndex = pointUtils.findNearestIndexAfter(sortedPoints, start);
    const endIndex = pointUtils.findNearestIndexBefore(sortedPoints, end);
    return sortedValues.slice(startIndex, endIndex + 1);
}


function $78d5b73e8134cc5f$export$6f7e956a8ae0712d(options) {
    let { debugLabel: debugLabel, debugLogging: debugLogging, getKey: getKey = (0, $e9018c4b997035fe$export$48ebe0dfb65ba56c), getPointForValue: getPointForValue, load: load } = options;
    if (0, $988843a0d5347818$export$df77466336fe5355) {
        let didLogWarning = false;
        let decoratedGetKey = getKey;
        getKey = (...params)=>{
            const key = decoratedGetKey(...params);
            if (!didLogWarning) {
                if (key.includes("[object Object]")) {
                    didLogWarning = true;
                    console.warn(`Warning: createCache() key "${key}" contains a stringified object and may not be unique`);
                }
            }
            return key;
        };
    }
    const arraySortUtils = (0, $23c5c3302ddce618$export$8d21e34596265fa2)((a, b)=>$78d5b73e8134cc5f$var$comparePoints(getPointForValue(a), getPointForValue(b)));
    const intervalUtils = (0, $bbc74fbbdcd4039f$export$8d21e34596265fa2)($78d5b73e8134cc5f$var$comparePoints);
    const pointUtils = (0, $b822e0460ddd0c69$export$8d21e34596265fa2)($78d5b73e8134cc5f$var$comparePoints);
    const metadataMap = new Map();
    // Subscribers are stored in a two-level data structure:
    // A key constructed from the params Array (getKey) points to an interval tree.
    // That interval tree maps an interval to a set of callbacks.
    const subscriberMap = new Map();
    const debugLog = (message, params, ...args)=>{
        const cacheKey = params ? `"${getKey(...params)}"` : "";
        const prefix = debugLabel ? `createIntervalCache[${debugLabel}]` : "createIntervalCache";
        (0, $f054b0183784f191$export$bef1f36f5486a6a3)(debugLogging, [
            `%c${prefix}`,
            "font-weight: bold; color: yellow;",
            message,
            cacheKey,
            ...args
        ]);
    };
    debugLog("Cache created");
    function abort(...params) {
        debugLog("abort()", params);
        const metadataMapKey = getKey(...params);
        let caught;
        let metadata = metadataMap.get(metadataMapKey);
        if (metadata) {
            const { pendingMetadata: pendingMetadata } = metadata;
            if (pendingMetadata.length > 0) {
                const cloned = [
                    ...pendingMetadata
                ];
                pendingMetadata.splice(0);
                for (let { interval: interval, record: record } of cloned)try {
                    const [start, end] = interval;
                    const recordKey = `${start}–${end}`;
                    metadata.recordMap.delete(recordKey);
                    record.data.abortController.abort();
                    notifySubscribers(start, end, params);
                } catch (error) {
                    caught = error;
                }
                if (caught !== undefined) throw caught;
                return true;
            }
        }
        return false;
    }
    class PartialArray extends Array {
        constructor(length){
            super(length);
            Object.defineProperty(this, "__partial", {
                value: true,
                enumerable: false
            });
        }
    }
    function arrayToPartialArray(values) {
        const partialArray = new PartialArray(values.length);
        values.forEach((value, index)=>{
            partialArray[index] = value;
        });
        return partialArray;
    }
    function createCacheKey(start, end) {
        return `${start}–${end}`;
    }
    function disableDebugLogging() {
        debugLogging = false;
    }
    function enableDebugLogging() {
        debugLogging = true;
    }
    function evict(...params) {
        debugLog("evict()", params);
        const cacheKey = getKey(...params);
        const result = metadataMap.delete(cacheKey);
        const tree = subscriberMap.get(cacheKey);
        if (tree) for (let node of tree.inOrder())node.data.callbacks.forEach((callback)=>callback({
                status: (0, $131b3f6f00984c1a$export$1af79998fa14ea8)
            }));
        return result;
    }
    function evictAll() {
        debugLog("evictAll()");
        const hadValues = metadataMap.size > 0;
        metadataMap.clear();
        subscriberMap.forEach((tree)=>{
            for (let node of tree.inOrder())node.data.callbacks.forEach((callback)=>callback({
                    status: (0, $131b3f6f00984c1a$export$1af79998fa14ea8)
                }));
        });
        return hadValues;
    }
    function getOrCreateIntervalMetadata(...params) {
        const cacheKey = getKey(...params);
        let metadata = metadataMap.get(cacheKey);
        if (metadata == null) {
            metadata = {
                intervals: {
                    failed: [],
                    loaded: [],
                    partial: []
                },
                pendingMetadata: [],
                recordMap: new Map(),
                sortedValues: []
            };
            metadataMap.set(cacheKey, metadata);
        }
        return metadata;
    }
    function getOrCreateRecord(start, end, ...params) {
        const metadata = getOrCreateIntervalMetadata(...params);
        const cacheKey = createCacheKey(start, end);
        let record = metadata.recordMap.get(cacheKey);
        if (record == null) {
            debugLog(`read(${start}, ${end}) Cache miss`, params);
            const abortController = new AbortController();
            const deferred = (0, $1d0742bf523b27d5$export$e673efccd97e4223)(debugLabel ? `${debugLabel}: ${cacheKey}` : `${cacheKey}`);
            record = {
                data: {
                    abortController: abortController,
                    deferred: deferred,
                    status: (0, $131b3f6f00984c1a$export$102c3f975dbe36bd)
                }
            };
            metadata.recordMap.set(cacheKey, record);
            notifySubscribers(start, end, params);
            processPendingRecord(metadata, record, start, end, ...params);
        } else debugLog(`read(${start}, ${end}) Cache hit`, params);
        return record;
    }
    function getStatus(start, end, ...params) {
        debugLog(`getStatus(${start}, ${end})`, params);
        const metadata = getOrCreateIntervalMetadata(...params);
        const cacheKey = createCacheKey(start, end);
        let record = metadata.recordMap.get(cacheKey);
        if (!record) {
            // If there is no exact match, we may also still be within a larger interval.
            const { containsFailedResults: containsFailedResults, missing: missing, pending: pending } = (0, $62bfc6ba505dacc1$export$f7e1fc3814079caa)({
                failed: metadata.intervals.failed,
                loaded: metadata.intervals.loaded,
                partial: metadata.intervals.partial,
                pending: metadata.pendingMetadata.map(({ interval: interval })=>interval)
            }, [
                start,
                end
            ], intervalUtils);
            if (pending.length > 0) return 0, $131b3f6f00984c1a$export$102c3f975dbe36bd;
            else if (containsFailedResults) return 0, $131b3f6f00984c1a$export$89864f7e9466db1c;
            else if (missing.length > 0) return 0, $131b3f6f00984c1a$export$1af79998fa14ea8;
            else return 0, $131b3f6f00984c1a$export$95b9efe7da5fb195;
        }
        return record.data.status;
    }
    function getAlreadyLoadedValues(start, end, metadata) {
        const { containsFailedResults: containsFailedResults, containsPartialResults: containsPartialResults, missing: missing } = (0, $62bfc6ba505dacc1$export$f7e1fc3814079caa)({
            failed: metadata.intervals.failed,
            loaded: metadata.intervals.loaded,
            partial: metadata.intervals.partial,
            pending: metadata.pendingMetadata.map(({ interval: interval })=>interval)
        }, [
            start,
            end
        ], intervalUtils);
        if (missing.length === 0) {
            if (!containsFailedResults) {
                const value = (0, $9d95c6fe1b7a781a$export$9fb44ea51f14b4c6)(metadata.sortedValues, start, end, getPointForValue, pointUtils);
                if (containsPartialResults) return arrayToPartialArray(value);
                else return value;
            }
        }
    }
    function getValue(start, end, ...params) {
        debugLog(`getValue(${start}, ${end})`, params);
        const metadata = getOrCreateIntervalMetadata(...params);
        const cacheKey = createCacheKey(start, end);
        const record = metadata.recordMap.get(cacheKey);
        if (record == null) {
            const value = getAlreadyLoadedValues(start, end, metadata);
            if (value) return value;
            else throw Error("No record found");
        } else if ((0, $3138a7e7e2612756$export$2285469376868a97)(record)) throw record.data.error;
        else if ((0, $3138a7e7e2612756$export$893ad6457b7fbafc)(record)) return record.data.value;
        else throw Error(`Record found with status "${record.data.status}"`);
    }
    function getValueIfCached(start, end, ...params) {
        debugLog(`getValueIfCached(${start}, ${end})`, params);
        const metadata = getOrCreateIntervalMetadata(...params);
        const cacheKey = createCacheKey(start, end);
        const record = metadata.recordMap.get(cacheKey);
        if (record == null) return getAlreadyLoadedValues(start, end, metadata);
        else if ((0, $3138a7e7e2612756$export$893ad6457b7fbafc)(record)) return record.data.value;
    }
    function isPartialResult(value) {
        return value instanceof PartialArray;
    }
    function getSubscriptionData(start, end, params) {
        const metadata = getOrCreateIntervalMetadata(...params);
        const cacheKey = createCacheKey(start, end);
        let record = metadata.recordMap.get(cacheKey);
        if (record) {
            if ((0, $3138a7e7e2612756$export$893ad6457b7fbafc)(record)) return {
                status: (0, $131b3f6f00984c1a$export$95b9efe7da5fb195),
                value: record.data.value
            };
            else if ((0, $3138a7e7e2612756$export$2285469376868a97)(record)) return {
                error: record.data.error,
                status: (0, $131b3f6f00984c1a$export$89864f7e9466db1c)
            };
        }
        const status = getStatus(start, end, ...params);
        return {
            status: status
        };
    }
    function notifySubscribers(start, end, params) {
        const cacheKey = getKey(...params);
        const tree = subscriberMap.get(cacheKey);
        if (tree) {
            const matches = tree.search(start, end);
            matches.forEach((match)=>{
                const data = getSubscriptionData(match.start, match.end, match.params);
                match.callbacks.forEach((callback)=>{
                    callback(data);
                });
            });
        }
    }
    async function processPendingInterval(metadata, pendingMetadata, start, end) {
        const { record: record, value: value } = pendingMetadata;
        (0, $a95b1a9483edd973$export$5720014d5c94137d)(record);
        const { abortController: abortController } = record.data;
        let values;
        try {
            values = (0, $2e69071d085c545a$export$ae936b9d47e5870e)(value) ? await value : value;
            if (abortController.signal.aborted) // Ignore results if the request was aborted
            return;
            // Store partially loaded intervals separately;
            // Future requests that contain them should also be flagged as partial
            if (isPartialResult(values)) {
                pendingMetadata.containsPartialResults();
                metadata.intervals.partial = intervalUtils.mergeAll(...intervalUtils.sort(...metadata.intervals.partial, [
                    start,
                    end
                ]));
            } else {
                metadata.intervals.loaded = intervalUtils.mergeAll(...intervalUtils.sort(...metadata.intervals.loaded, [
                    start,
                    end
                ]));
                // Prune partials interval to remove ones that have been newly loaded
                // note this intentionally includes intersections.
                // The thinking behind this is as follows:
                // 1. Loading part of a previously partial range
                //    might reduce the range enough so that the remainder can be fully loaded
                // 2. If we don't shrink partial intervals as we refine them,
                //    it may become impossible to fully remove them in some cases.
                for(let index = metadata.intervals.partial.length - 1; index >= 0; index--){
                    const partialInterval = metadata.intervals.partial[index];
                    if (intervalUtils.intersects([
                        start,
                        end
                    ], partialInterval)) {
                        metadata.intervals.partial.splice(index, 1);
                        const cacheKey = createCacheKey(partialInterval[0], partialInterval[1]);
                        metadata.recordMap.delete(cacheKey);
                    }
                }
            }
            // Merge in newly-loaded values; don't add duplicates though.
            // Duplicates may slip in at the edges (because of how intervals are split)
            // or they may be encountered as ranges of partial results are refined.
            for(let index = 0; index < values.length; index++){
                const value = values[index];
                const insertIndex = arraySortUtils.findInsertIndex(metadata.sortedValues, value);
                const itemAtIndex = metadata.sortedValues[insertIndex];
                if (itemAtIndex == null || $78d5b73e8134cc5f$var$comparePoints(getPointForValue(itemAtIndex), getPointForValue(value)) !== 0) metadata.sortedValues.splice(insertIndex, 0, value);
            }
        } catch (error) {
            // Ignore the error here; the caller will handle it.
            metadata.intervals.failed = intervalUtils.mergeAll(...intervalUtils.sort(...metadata.intervals.failed, [
                start,
                end
            ]));
        } finally{
            const index = metadata.pendingMetadata.indexOf(pendingMetadata);
            metadata.pendingMetadata.splice(index, 1);
        }
    }
    async function processPendingRecord(metadata, record, start, end, ...params) {
        (0, $a95b1a9483edd973$export$5720014d5c94137d)(record);
        const { abortController: abortController, deferred: deferred } = record.data;
        const { signal: signal } = abortController;
        const foundIntervals = (0, $62bfc6ba505dacc1$export$f7e1fc3814079caa)({
            failed: metadata.intervals.failed,
            loaded: metadata.intervals.loaded,
            partial: metadata.intervals.partial,
            pending: metadata.pendingMetadata.map(({ interval: interval })=>interval)
        }, [
            start,
            end
        ], intervalUtils);
        // If any of the unloaded intervals contain a failed request,
        // we shouldn't try loading them again
        // This is admittedly somewhat arbitrary but matches Replay's functionality
        const previouslyFailedInterval = foundIntervals.missing.find((missingInterval)=>metadata.intervals.failed.find((interval)=>intervalUtils.contains(missingInterval, interval)));
        if (previouslyFailedInterval != null) {
            const error = Error("Cannot load interval that contains previously failed interval");
            record.data = {
                error: error,
                status: (0, $131b3f6f00984c1a$export$89864f7e9466db1c)
            };
            deferred.reject(error);
            notifySubscribers(start, end, params);
            return;
        }
        let containsPartialResults = false;
        const missingPromiseLikes = [];
        foundIntervals.missing.forEach(([start, end])=>{
            const options = {
                returnAsPartial: arrayToPartialArray,
                signal: abortController.signal
            };
            const thenable = load(start, end, ...params, options);
            missingPromiseLikes.push(thenable);
            const pendingMetadata = {
                containsPartialResults: ()=>{
                    containsPartialResults = true;
                },
                interval: [
                    start,
                    end
                ],
                record: record,
                value: thenable
            };
            metadata.pendingMetadata.push(pendingMetadata);
            processPendingInterval(metadata, pendingMetadata, start, end);
        });
        // Gather all of the deferred requests the new interval blocks on.
        // Can we make this more efficient than a nested loop?
        // It's tricky since requests initiated separately (e.g. [1,2] and [2,4])
        // may end up reported as single/merged blocker (e.g. [1,3])
        const pendingPromiseLikes = [];
        foundIntervals.pending.forEach(([start, end])=>{
            metadata.pendingMetadata.forEach(({ interval: interval, value: value })=>{
                if (intervalUtils.contains(interval, [
                    start,
                    end
                ])) pendingPromiseLikes.push(value);
            });
        });
        try {
            const values = await Promise.all([
                ...missingPromiseLikes,
                ...pendingPromiseLikes
            ]);
            if (!signal.aborted) {
                let value = (0, $9d95c6fe1b7a781a$export$9fb44ea51f14b4c6)(metadata.sortedValues, start, end, getPointForValue, pointUtils);
                if (containsPartialResults) value = arrayToPartialArray(value);
                record.data = {
                    metadata: {
                        containsPartialResults: containsPartialResults
                    },
                    status: (0, $131b3f6f00984c1a$export$95b9efe7da5fb195),
                    value: value
                };
                debugLog(`read() Pending request resolved (${start}, ${end})`, params, values);
                deferred.resolve(value);
                notifySubscribers(start, end, params);
            }
        } catch (error) {
            let errorMessage = "Unknown Error";
            if (typeof error === "string") errorMessage = error;
            else if (error instanceof Error) errorMessage = error.message;
            debugLog(`read() Pending request rejected (${start}, ${end})`, params, errorMessage);
            if (!signal.aborted) {
                record.data = {
                    error: error,
                    status: (0, $131b3f6f00984c1a$export$89864f7e9466db1c)
                };
                deferred.reject(error);
                notifySubscribers(start, end, params);
            }
        }
    }
    function read(start, end, ...params) {
        // getOrCreateRecord() will call debugLog (cache hit or miss)
        const record = getOrCreateRecord(start, end, ...params);
        if (record.data.status === (0, $131b3f6f00984c1a$export$95b9efe7da5fb195)) return record.data.value;
        else if ((0, $3138a7e7e2612756$export$457b50c8400bb39e)(record)) throw record.data.deferred.promise;
        else throw record.data.error;
    }
    function readAsync(start, end, ...params) {
        // getOrCreateRecord() will call debugLog (cache hit or miss)
        const record = getOrCreateRecord(start, end, ...params);
        switch(record.data.status){
            case 0, $131b3f6f00984c1a$export$102c3f975dbe36bd:
                return record.data.deferred.promise;
            case 0, $131b3f6f00984c1a$export$95b9efe7da5fb195:
                return record.data.value;
            case 0, $131b3f6f00984c1a$export$89864f7e9466db1c:
                throw record.data.error;
        }
    }
    function subscribe(callback, start, end, ...params) {
        debugLog(`subscribe(${start}, ${end})`, params);
        const cacheKey = getKey(...params);
        let tree = subscriberMap.get(cacheKey);
        if (tree == null) {
            tree = new (0, (/*@__PURE__*/$parcel$interopDefault($cd3e418e399ebf7a$exports)))();
            subscriberMap.set(cacheKey, tree);
        }
        let match = tree.search(start, end).find((match)=>match.start === start && match.end === end);
        if (match) match.callbacks.add(callback);
        else {
            match = {
                callbacks: new Set([
                    callback
                ]),
                end: end,
                params: params,
                start: start
            };
            tree.insert(start, end, match);
        }
        try {
            const data = getSubscriptionData(match.start, match.end, match.params);
            callback(data);
        } finally{
            return ()=>{
                if (tree && match) {
                    match.callbacks.delete(callback);
                    if (match.callbacks.size === 0) tree.remove(start, end, match);
                }
            };
        }
    }
    return {
        abort: abort,
        disableDebugLogging: disableDebugLogging,
        enableDebugLogging: enableDebugLogging,
        evict: evict,
        evictAll: evictAll,
        getStatus: getStatus,
        getValue: getValue,
        getValueIfCached: getValueIfCached,
        isPartialResult: isPartialResult,
        readAsync: readAsync,
        read: read,
        subscribe: subscribe
    };
}
function $78d5b73e8134cc5f$var$comparePoints(a, b) {
    return Number(a - b);
}



const $addceb3cc5699e5a$var$key = Symbol.for("createSingleEntryCache").toString();
function $addceb3cc5699e5a$export$22a2a694ba0c34d3(options) {
    if (options.hasOwnProperty("getKey")) throw Error("createSingleEntryCache does not support a getKey option");
    return (0, $1e2a96dfa0b62734$export$cf6fa0bbcc94b912)({
        getKey: ()=>$addceb3cc5699e5a$var$key,
        ...options
    });
}








function $c7e99c794f4a465a$export$ea911cd21ad60992(options) {
    let { debugLabel: debugLabel, debugLogging: debugLogging, getKey: getKey = (0, $e9018c4b997035fe$export$48ebe0dfb65ba56c), load: load } = options;
    if (0, $988843a0d5347818$export$df77466336fe5355) {
        let didLogWarning = false;
        let decoratedGetKey = getKey;
        getKey = (...params)=>{
            const key = decoratedGetKey(...params);
            if (!didLogWarning) {
                if (key.includes("[object Object]")) {
                    didLogWarning = true;
                    console.warn(`Warning: createCache() key "${key}" contains a stringified object and may not be unique`);
                }
            }
            return key;
        };
    }
    const debugLog = (message, params, ...args)=>{
        const cacheKey = params ? `"${getKey(...params)}"` : "";
        const prefix = debugLabel ? `createCache[${debugLabel}]` : "createCache";
        (0, $f054b0183784f191$export$bef1f36f5486a6a3)(debugLogging, [
            `%c${prefix}`,
            "font-weight: bold; color: yellow;",
            message,
            cacheKey,
            ...args
        ]);
    };
    debugLog("Cache created");
    const abortControllerMap = new Map();
    const streamingValuesMap = new Map();
    function abort(...params) {
        debugLog("abort()", params);
        const cacheKey = getKey(...params);
        let abortController = abortControllerMap.get(cacheKey);
        if (abortController != null) {
            abortController.abort();
            return true;
        }
        return false;
    }
    function disableDebugLogging() {
        debugLogging = false;
    }
    function enableDebugLogging() {
        debugLogging = true;
    }
    function evict(...params) {
        debugLog("evict()", params);
        const cacheKey = getKey(...params);
        return streamingValuesMap.delete(cacheKey);
    }
    function evictAll() {
        debugLog("evictAll()");
        const hadValues = streamingValuesMap.size > 0;
        streamingValuesMap.clear();
        return hadValues;
    }
    function getOrCreateStreamingValue(...params) {
        const cacheKey = getKey(...params);
        let cached = streamingValuesMap.get(cacheKey);
        if (cached == null) {
            debugLog("stream() Cache miss", params);
            const deferred = (0, $1d0742bf523b27d5$export$e673efccd97e4223)(debugLabel ? `${debugLabel}: ${cacheKey}` : cacheKey);
            const subscribers = new Set();
            const streamingValues = {
                complete: false,
                data: undefined,
                error: undefined,
                progress: undefined,
                resolver: deferred.promise,
                status: (0, $131b3f6f00984c1a$export$102c3f975dbe36bd),
                subscribe: (callback)=>{
                    subscribers.add(callback);
                    return ()=>{
                        subscribers.delete(callback);
                    };
                },
                value: undefined
            };
            const notifySubscribers = ()=>{
                subscribers.forEach((subscriber)=>{
                    try {
                        subscriber();
                    } catch (error) {}
                });
            };
            const assertPending = ()=>{
                if (streamingValues.status !== (0, $131b3f6f00984c1a$export$102c3f975dbe36bd)) throw Error(`Stream with status "${streamingValues.status}" cannot be updated`);
            };
            const abortController = new AbortController();
            abortController.signal.addEventListener("abort", ()=>{
                if (streamingValues.complete) return false;
                debugLog(`stream() Pending request aborted`, params);
                streamingValues.status = (0, $131b3f6f00984c1a$export$dfcaef926891432a);
                streamingValuesMap.delete(cacheKey);
                notifySubscribers();
                deferred.resolve();
            });
            abortControllerMap.set(cacheKey, abortController);
            const options = {
                update: (value, progress, data)=>{
                    assertPending();
                    streamingValues.data = data == undefined ? streamingValues.data : data;
                    streamingValues.value = value;
                    if (progress != null) {
                        if (0, $988843a0d5347818$export$df77466336fe5355) {
                            if (progress < 0 || progress > 1) console.warn(`Invalid progress: ${progress}; value must be between 0-1.`);
                        }
                        streamingValues.progress = progress;
                    }
                    notifySubscribers();
                },
                resolve: ()=>{
                    debugLog(`stream() Pending request resolved`, params);
                    assertPending();
                    streamingValues.complete = true;
                    streamingValues.progress = 1;
                    streamingValues.status = (0, $131b3f6f00984c1a$export$95b9efe7da5fb195);
                    notifySubscribers();
                    deferred.resolve(streamingValues);
                },
                reject: (error)=>{
                    debugLog(`stream() Pending request rejected`, params);
                    assertPending();
                    streamingValues.complete = true;
                    streamingValues.error = error;
                    streamingValues.status = (0, $131b3f6f00984c1a$export$89864f7e9466db1c);
                    notifySubscribers();
                    deferred.reject(error);
                },
                signal: abortController.signal
            };
            streamingValuesMap.set(cacheKey, streamingValues);
            loadAndCatchErrors(cacheKey, streamingValues, options, ...params);
            return streamingValues;
        }
        debugLog("stream() Cache hit", params);
        return cached;
    }
    function prefetch(...params) {
        debugLog("prefetch()", params);
        getOrCreateStreamingValue(...params);
    }
    function read(...params) {
        const { data: data, error: error, status: status, resolver: resolver, value: value } = stream(...params);
        switch(status){
            case 0, $131b3f6f00984c1a$export$102c3f975dbe36bd:
                throw resolver;
            case 0, $131b3f6f00984c1a$export$89864f7e9466db1c:
                throw error;
            case 0, $131b3f6f00984c1a$export$95b9efe7da5fb195:
                (0, $a11de30297c18820$export$a7a9523472993e97)(value != null);
                return {
                    data: data,
                    value: value
                };
            default:
                throw new Error(`Unexpected cache status "${status}"`);
        }
    }
    async function readAsync(...params) {
        const { resolver: resolver } = stream(...params);
        const { data: data, value: value } = await resolver;
        return {
            data: data,
            value: value
        };
    }
    function stream(...params) {
        // getOrCreateStreamingValue() will call debugLog (cache hit or miss)
        return getOrCreateStreamingValue(...params);
    }
    async function loadAndCatchErrors(cacheKey, streamingValues, options, ...params) {
        try {
            await load(options, ...params);
        } catch (error) {
            if (streamingValues.status === (0, $131b3f6f00984c1a$export$102c3f975dbe36bd)) options.reject(error);
        } finally{
            abortControllerMap.delete(cacheKey);
        }
    }
    return {
        abort: abort,
        disableDebugLogging: disableDebugLogging,
        enableDebugLogging: enableDebugLogging,
        evict: evict,
        evictAll: evictAll,
        prefetch: prefetch,
        read: read,
        readAsync: readAsync,
        stream: stream
    };
}



var $k116o = parcelRequire("k116o");




function $b7edf20f84cd4e8f$export$29dc6b9369528985(cache) {
    const { __createPendingMutationRecordMap: createPendingMutationRecordMap, __getKey: getKey, __isImmutable: isImmutable, __mutationAbortControllerMap: mutationAbortControllerMap, __notifySubscribers: notifySubscribers, __recordMap: recordMap } = cache;
    (0, $a11de30297c18820$export$a7a9523472993e97)(!isImmutable(), "Cannot mutate an immutable cache");
    const [isPending, startTransition] = (0, $k116o.useTransition)();
    const refresh = (0, $k116o.unstable_useCacheRefresh)();
    const mutateSync = (0, $k116o.useCallback)((params, newValue)=>{
        const cacheKey = getKey(params);
        if (mutationAbortControllerMap.has(cacheKey)) {
            const abortController = mutationAbortControllerMap.get(cacheKey);
            abortController.abort();
            mutationAbortControllerMap.delete(cacheKey);
        }
        const record = (0, $19c637b0d2d7681e$export$6f5139686a08d721)(newValue);
        recordMap.set(cacheKey, record);
        const pendingMutationRecordMap = createPendingMutationRecordMap();
        pendingMutationRecordMap.set(cacheKey, record);
        startTransition(()=>{
            refresh(createPendingMutationRecordMap, pendingMutationRecordMap);
        });
        notifySubscribers(params);
    }, [
        refresh,
        startTransition
    ]);
    const mutateAsync = (0, $k116o.useCallback)(async (params, callback)=>{
        const cacheKey = getKey(params);
        if (mutationAbortControllerMap.has(cacheKey)) {
            const abortController = mutationAbortControllerMap.get(cacheKey);
            abortController.abort();
            mutationAbortControllerMap.delete(cacheKey);
        }
        const abortController = new AbortController();
        const deferred = (0, $1d0742bf523b27d5$export$e673efccd97e4223)();
        let record = {
            data: {
                abortController: abortController,
                deferred: deferred,
                status: (0, $131b3f6f00984c1a$export$102c3f975dbe36bd)
            }
        };
        // Don't mutate the module-level cache yet;
        // this might cause other components to suspend (and fallback)
        // if they happened to re-render before the mutation finished
        const pendingMutationRecordMap = createPendingMutationRecordMap();
        pendingMutationRecordMap.set(cacheKey, record);
        mutationAbortControllerMap.set(cacheKey, abortController);
        startTransition(()=>{
            refresh(createPendingMutationRecordMap, pendingMutationRecordMap);
        });
        notifySubscribers(params, {
            status: (0, $131b3f6f00984c1a$export$102c3f975dbe36bd)
        });
        try {
            // Wait until the mutation finishes or is aborted
            const newValue = await Promise.race([
                callback(),
                new Promise((resolve)=>{
                    abortController.signal.onabort = ()=>resolve();
                })
            ]);
            if (abortController.signal.aborted) {
                // The mutation was aborted;
                // if we can restore the previous record, do it
                const backupRecord = recordMap.get(cacheKey);
                if (backupRecord) pendingMutationRecordMap.set(cacheKey, backupRecord);
                else pendingMutationRecordMap.delete(cacheKey);
            } else {
                // This method determines whether to store the value in a WeakRef
                (0, $19c637b0d2d7681e$export$bf8e65ce0c179a6a)(record, newValue);
                deferred.resolve(newValue);
                recordMap.set(cacheKey, record);
            }
            startTransition(()=>{
                refresh(createPendingMutationRecordMap, pendingMutationRecordMap);
            });
            notifySubscribers(params, {
                status: (0, $131b3f6f00984c1a$export$95b9efe7da5fb195),
                value: newValue
            });
        } catch (error) {
            record.data = {
                error: error,
                status: (0, $131b3f6f00984c1a$export$89864f7e9466db1c)
            };
            try {
                deferred.reject(error);
                await deferred.promise;
            } catch (error) {
            // Don't trigger an unhandled rejection
            }
            recordMap.set(cacheKey, record);
            startTransition(()=>{
                refresh(createPendingMutationRecordMap, pendingMutationRecordMap);
            });
            notifySubscribers(params, {
                error: error,
                status: (0, $131b3f6f00984c1a$export$89864f7e9466db1c)
            });
        } finally{
            // Cleanup after mutation by deleting the abort controller
            // If this mutation has already been preempted by a newer mutation
            // don't delete the newer controller
            if (abortController === mutationAbortControllerMap.get(cacheKey)) mutationAbortControllerMap.delete(cacheKey);
        }
    }, [
        refresh,
        startTransition
    ]);
    return {
        isPending: isPending,
        mutateAsync: mutateAsync,
        mutateSync: mutateSync
    };
}
$b7edf20f84cd4e8f$export$29dc6b9369528985.displayName = "useCacheMutation";



var $k116o = parcelRequire("k116o");
function $d70beb1831956ba7$export$a0b0284d625c6d1d(cache, ...params) {
    return (0, $k116o.useSyncExternalStore)((callback)=>cache.subscribe(callback, ...params), ()=>cache.getStatus(...params), ()=>cache.getStatus(...params));
}
$d70beb1831956ba7$export$a0b0284d625c6d1d.displayName = "useCacheStatus";



var $k116o = parcelRequire("k116o");
var $4a31c07ea431e8cc$exports = {};
"use strict";
var $dfd98480ca099e65$exports = {};
"use strict";
var $14397c6d5d22ee98$exports = {};
"use strict";
var $6f712504e9fa9490$exports = {};
"use strict";
var $6f712504e9fa9490$var$slice = Array.prototype.slice;

var $5IH7g = parcelRequire("5IH7g");
var $6f712504e9fa9490$var$origKeys = Object.keys;

var $6f712504e9fa9490$var$keysShim = $6f712504e9fa9490$var$origKeys ? function keys(o) {
    return $6f712504e9fa9490$var$origKeys(o);
} : (parcelRequire("4XBEa"));
var $6f712504e9fa9490$var$originalKeys = Object.keys;
$6f712504e9fa9490$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($5IH7g(object)) return $6f712504e9fa9490$var$originalKeys($6f712504e9fa9490$var$slice.call(object));
            return $6f712504e9fa9490$var$originalKeys(object);
        };
    } else Object.keys = $6f712504e9fa9490$var$keysShim;
    return Object.keys || $6f712504e9fa9490$var$keysShim;
};
$6f712504e9fa9490$exports = $6f712504e9fa9490$var$keysShim;


var $14397c6d5d22ee98$var$hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var $14397c6d5d22ee98$var$toStr = Object.prototype.toString;
var $14397c6d5d22ee98$var$concat = Array.prototype.concat;
var $14397c6d5d22ee98$var$origDefineProperty = Object.defineProperty;
var $14397c6d5d22ee98$var$isFunction = function(fn) {
    return typeof fn === "function" && $14397c6d5d22ee98$var$toStr.call(fn) === "[object Function]";
};

var $14397c6d5d22ee98$var$hasPropertyDescriptors = (parcelRequire("9ft5k"))();
var $14397c6d5d22ee98$var$supportsDescriptors = $14397c6d5d22ee98$var$origDefineProperty && $14397c6d5d22ee98$var$hasPropertyDescriptors;
var $14397c6d5d22ee98$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$14397c6d5d22ee98$var$isFunction(predicate) || !predicate()) return;
    }
    if ($14397c6d5d22ee98$var$supportsDescriptors) $14397c6d5d22ee98$var$origDefineProperty(object, name, {
        configurable: true,
        enumerable: false,
        value: value,
        writable: true
    });
    else object[name] = value; // eslint-disable-line no-param-reassign
};
var $14397c6d5d22ee98$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $6f712504e9fa9490$exports(map);
    if ($14397c6d5d22ee98$var$hasSymbols) props = $14397c6d5d22ee98$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$14397c6d5d22ee98$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$14397c6d5d22ee98$var$defineProperties.supportsDescriptors = !!$14397c6d5d22ee98$var$supportsDescriptors;
$14397c6d5d22ee98$exports = $14397c6d5d22ee98$var$defineProperties;



var $j2lnW = parcelRequire("j2lnW");
var $2a4157f488121dd6$exports = {};
"use strict";


var $2a4157f488121dd6$var$hasSymbols = (parcelRequire("i50ZI"))();

var $f5Ljh = parcelRequire("f5Ljh");
var $2a4157f488121dd6$var$toObject = Object;
var $2a4157f488121dd6$var$$push = $f5Ljh("Array.prototype.push");
var $2a4157f488121dd6$var$$propIsEnumerable = $f5Ljh("Object.prototype.propertyIsEnumerable");
var $2a4157f488121dd6$var$originalGetSymbols = $2a4157f488121dd6$var$hasSymbols ? Object.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
$2a4157f488121dd6$exports = function assign(target, source1) {
    if (target == null) throw new TypeError("target must be an object");
    var to = $2a4157f488121dd6$var$toObject(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $2a4157f488121dd6$var$toObject(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $6f712504e9fa9490$exports(from);
        var getSymbols = $2a4157f488121dd6$var$hasSymbols && (Object.getOwnPropertySymbols || $2a4157f488121dd6$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($2a4157f488121dd6$var$$propIsEnumerable(from, key)) $2a4157f488121dd6$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($2a4157f488121dd6$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};


var $af2ea74c8b7b6409$exports = {};
"use strict";

var $af2ea74c8b7b6409$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = "abcdefghijklmnopqrst";
    var letters = str.split("");
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = "";
    for(var k in obj)actual += k;
    return str !== actual;
};
var $af2ea74c8b7b6409$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, "xy");
    } catch (e) {
        return thrower[1] === "y";
    }
    return false;
};
$af2ea74c8b7b6409$exports = function getPolyfill() {
    if (!Object.assign) return $2a4157f488121dd6$exports;
    if ($af2ea74c8b7b6409$var$lacksProperEnumerationOrder()) return $2a4157f488121dd6$exports;
    if ($af2ea74c8b7b6409$var$assignHasPendingExceptions()) return $2a4157f488121dd6$exports;
    return Object.assign;
};


var $b127151c3d89a5b8$exports = {};
"use strict";


$b127151c3d89a5b8$exports = function shimAssign() {
    var polyfill = $af2ea74c8b7b6409$exports();
    $14397c6d5d22ee98$exports(Object, {
        assign: polyfill
    }, {
        assign: function() {
            return Object.assign !== polyfill;
        }
    });
    return polyfill;
};


var $dfd98480ca099e65$var$polyfill = $j2lnW.apply($af2ea74c8b7b6409$exports());
// eslint-disable-next-line no-unused-vars
var $dfd98480ca099e65$var$bound = function assign(target, source1) {
    return $dfd98480ca099e65$var$polyfill(Object, arguments);
};
$14397c6d5d22ee98$exports($dfd98480ca099e65$var$bound, {
    getPolyfill: $af2ea74c8b7b6409$exports,
    implementation: $2a4157f488121dd6$exports,
    shim: $b127151c3d89a5b8$exports
});
$dfd98480ca099e65$exports = $dfd98480ca099e65$var$bound;



var $f5Ljh = parcelRequire("f5Ljh");
var $e71eab4fe8329ea3$exports = {};
"use strict";


var $j2lnW = parcelRequire("j2lnW");
var $5d73426aee85d63f$exports = {};
"use strict";

var $5d73426aee85d63f$var$functionsHaveConfigurableNames = (parcelRequire("66x4O")).functionsHaveConfigurableNames();
var $5d73426aee85d63f$var$$Object = Object;
var $5d73426aee85d63f$var$$TypeError = TypeError;
$5d73426aee85d63f$exports = function flags() {
    if (this != null && this !== $5d73426aee85d63f$var$$Object(this)) throw new $5d73426aee85d63f$var$$TypeError("RegExp.prototype.flags getter called on non-object");
    var result = "";
    if (this.hasIndices) result += "d";
    if (this.global) result += "g";
    if (this.ignoreCase) result += "i";
    if (this.multiline) result += "m";
    if (this.dotAll) result += "s";
    if (this.unicode) result += "u";
    if (this.unicodeSets) result += "v";
    if (this.sticky) result += "y";
    return result;
};
if ($5d73426aee85d63f$var$functionsHaveConfigurableNames && Object.defineProperty) Object.defineProperty($5d73426aee85d63f$exports, "name", {
    value: "get flags"
});


var $08153e2a1e15f2b4$exports = {};
"use strict";


var $08153e2a1e15f2b4$require$supportsDescriptors = $14397c6d5d22ee98$exports.supportsDescriptors;
var $08153e2a1e15f2b4$var$$gOPD = Object.getOwnPropertyDescriptor;
$08153e2a1e15f2b4$exports = function getPolyfill() {
    if ($08153e2a1e15f2b4$require$supportsDescriptors && /a/mig.flags === "gim") {
        var descriptor = $08153e2a1e15f2b4$var$$gOPD(RegExp.prototype, "flags");
        if (descriptor && typeof descriptor.get === "function" && typeof RegExp.prototype.dotAll === "boolean" && typeof RegExp.prototype.hasIndices === "boolean") {
            /* eslint getter-return: 0 */ var calls = "";
            var o = {};
            Object.defineProperty(o, "hasIndices", {
                get: function() {
                    calls += "d";
                }
            });
            Object.defineProperty(o, "sticky", {
                get: function() {
                    calls += "y";
                }
            });
            if (calls === "dy") return descriptor.get;
        }
    }
    return $5d73426aee85d63f$exports;
};


var $3cb442d6255d9f1a$exports = {};
"use strict";

var $3cb442d6255d9f1a$require$supportsDescriptors = $14397c6d5d22ee98$exports.supportsDescriptors;

var $3cb442d6255d9f1a$var$gOPD = Object.getOwnPropertyDescriptor;
var $3cb442d6255d9f1a$var$defineProperty = Object.defineProperty;
var $3cb442d6255d9f1a$var$TypeErr = TypeError;
var $3cb442d6255d9f1a$var$getProto = Object.getPrototypeOf;
var $3cb442d6255d9f1a$var$regex = /a/;
$3cb442d6255d9f1a$exports = function shimFlags() {
    if (!$3cb442d6255d9f1a$require$supportsDescriptors || !$3cb442d6255d9f1a$var$getProto) throw new $3cb442d6255d9f1a$var$TypeErr("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
    var polyfill = $08153e2a1e15f2b4$exports();
    var proto = $3cb442d6255d9f1a$var$getProto($3cb442d6255d9f1a$var$regex);
    var descriptor = $3cb442d6255d9f1a$var$gOPD(proto, "flags");
    if (!descriptor || descriptor.get !== polyfill) $3cb442d6255d9f1a$var$defineProperty(proto, "flags", {
        configurable: true,
        enumerable: false,
        get: polyfill
    });
    return polyfill;
};


var $e71eab4fe8329ea3$var$flagsBound = $j2lnW($08153e2a1e15f2b4$exports());
$14397c6d5d22ee98$exports($e71eab4fe8329ea3$var$flagsBound, {
    getPolyfill: $08153e2a1e15f2b4$exports,
    implementation: $5d73426aee85d63f$exports,
    shim: $3cb442d6255d9f1a$exports
});
$e71eab4fe8329ea3$exports = $e71eab4fe8329ea3$var$flagsBound;



var $gXypp = parcelRequire("gXypp");
var $696ba1128dba56bf$exports = {};

var $4Jj9n = parcelRequire("4Jj9n");
"use strict";
var $429e9a47dda5abb1$exports = {};
"use strict";

var $429e9a47dda5abb1$var$hasToStringTag = (parcelRequire("61Tck"))();

var $f5Ljh = parcelRequire("f5Ljh");
var $429e9a47dda5abb1$var$$toString = $f5Ljh("Object.prototype.toString");
var $429e9a47dda5abb1$var$isStandardArguments = function isArguments(value) {
    if ($429e9a47dda5abb1$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $429e9a47dda5abb1$var$$toString(value) === "[object Arguments]";
};
var $429e9a47dda5abb1$var$isLegacyArguments = function isArguments(value) {
    if ($429e9a47dda5abb1$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $429e9a47dda5abb1$var$$toString(value) !== "[object Array]" && $429e9a47dda5abb1$var$$toString(value.callee) === "[object Function]";
};
var $429e9a47dda5abb1$var$supportsStandardArguments = function() {
    return $429e9a47dda5abb1$var$isStandardArguments(arguments);
}();
$429e9a47dda5abb1$var$isStandardArguments.isLegacyArguments = $429e9a47dda5abb1$var$isLegacyArguments; // for tests
$429e9a47dda5abb1$exports = $429e9a47dda5abb1$var$supportsStandardArguments ? $429e9a47dda5abb1$var$isStandardArguments : $429e9a47dda5abb1$var$isLegacyArguments;


var $74e2ea7fde7623ca$exports = {};
"use strict";
var $5097e61bd8426247$exports = {};
"use strict";

var $gXypp = parcelRequire("gXypp");

var $lkSdN = parcelRequire("lkSdN");

var $5097e61bd8426247$var$channel = (parcelRequire("40Tvb"))();
var $5097e61bd8426247$var$$TypeError = $gXypp("%TypeError%");
var $5097e61bd8426247$var$SLOT = {
    assert: function(O, slot) {
        if (!O || typeof O !== "object" && typeof O !== "function") throw new $5097e61bd8426247$var$$TypeError("`O` is not an object");
        if (typeof slot !== "string") throw new $5097e61bd8426247$var$$TypeError("`slot` must be a string");
        $5097e61bd8426247$var$channel.assert(O);
        if (!$5097e61bd8426247$var$SLOT.has(O, slot)) throw new $5097e61bd8426247$var$$TypeError("`" + slot + "` is not present on `O`");
    },
    get: function(O, slot) {
        if (!O || typeof O !== "object" && typeof O !== "function") throw new $5097e61bd8426247$var$$TypeError("`O` is not an object");
        if (typeof slot !== "string") throw new $5097e61bd8426247$var$$TypeError("`slot` must be a string");
        var slots = $5097e61bd8426247$var$channel.get(O);
        return slots && slots["$" + slot];
    },
    has: function(O, slot) {
        if (!O || typeof O !== "object" && typeof O !== "function") throw new $5097e61bd8426247$var$$TypeError("`O` is not an object");
        if (typeof slot !== "string") throw new $5097e61bd8426247$var$$TypeError("`slot` must be a string");
        var slots = $5097e61bd8426247$var$channel.get(O);
        return !!slots && $lkSdN(slots, "$" + slot);
    },
    set: function(O, slot, V) {
        if (!O || typeof O !== "object" && typeof O !== "function") throw new $5097e61bd8426247$var$$TypeError("`O` is not an object");
        if (typeof slot !== "string") throw new $5097e61bd8426247$var$$TypeError("`slot` must be a string");
        var slots = $5097e61bd8426247$var$channel.get(O);
        if (!slots) {
            slots = {};
            $5097e61bd8426247$var$channel.set(O, slots);
        }
        slots["$" + slot] = V;
    }
};
if (Object.freeze) Object.freeze($5097e61bd8426247$var$SLOT);
$5097e61bd8426247$exports = $5097e61bd8426247$var$SLOT;


var $74e2ea7fde7623ca$var$$SyntaxError = SyntaxError;
var $74e2ea7fde7623ca$var$$StopIteration = typeof StopIteration === "object" ? StopIteration : null;
$74e2ea7fde7623ca$exports = function getStopIterationIterator(origIterator) {
    if (!$74e2ea7fde7623ca$var$$StopIteration) throw new $74e2ea7fde7623ca$var$$SyntaxError("this environment lacks StopIteration");
    $5097e61bd8426247$exports.set(origIterator, "[[Done]]", false);
    var siIterator = {
        next: function next() {
            var iterator = $5097e61bd8426247$exports.get(this, "[[Iterator]]");
            var done = $5097e61bd8426247$exports.get(iterator, "[[Done]]");
            try {
                return {
                    done: done,
                    value: done ? void 0 : iterator.next()
                };
            } catch (e) {
                $5097e61bd8426247$exports.set(iterator, "[[Done]]", true);
                if (e !== $74e2ea7fde7623ca$var$$StopIteration) throw e;
                return {
                    done: true,
                    value: void 0
                };
            }
        }
    };
    $5097e61bd8426247$exports.set(siIterator, "[[Iterator]]", origIterator);
    return siIterator;
};










if ((parcelRequire("eke6n"))() || (parcelRequire("i50ZI"))()) {
    var $696ba1128dba56bf$var$$iterator = Symbol.iterator;
    // Symbol is available natively or shammed
    // natively:
    //  - Chrome >= 38
    //  - Edge 12-14?, Edge >= 15 for sure
    //  - FF >= 36
    //  - Safari >= 9
    //  - node >= 0.12
    $696ba1128dba56bf$exports = function getIterator(iterable) {
        // alternatively, `iterable[$iterator]?.()`
        if (iterable != null && typeof iterable[$696ba1128dba56bf$var$$iterator] !== "undefined") return iterable[$696ba1128dba56bf$var$$iterator]();
        if ($429e9a47dda5abb1$exports(iterable)) // arguments objects lack Symbol.iterator
        // - node 0.12
        return Array.prototype[$696ba1128dba56bf$var$$iterator].call(iterable);
    };
} else {
    // Symbol is not available, native or shammed
    var $696ba1128dba56bf$var$isArray = (parcelRequire("5JxkD"));
    var $696ba1128dba56bf$var$isString = (parcelRequire("3jOv9"));
    var $696ba1128dba56bf$var$GetIntrinsic = (parcelRequire("gXypp"));
    var $696ba1128dba56bf$var$$Map = $696ba1128dba56bf$var$GetIntrinsic("%Map%", true);
    var $696ba1128dba56bf$var$$Set = $696ba1128dba56bf$var$GetIntrinsic("%Set%", true);
    var $696ba1128dba56bf$var$callBound = (parcelRequire("f5Ljh"));
    var $696ba1128dba56bf$var$$arrayPush = $696ba1128dba56bf$var$callBound("Array.prototype.push");
    var $696ba1128dba56bf$var$$charCodeAt = $696ba1128dba56bf$var$callBound("String.prototype.charCodeAt");
    var $696ba1128dba56bf$var$$stringSlice = $696ba1128dba56bf$var$callBound("String.prototype.slice");
    var $696ba1128dba56bf$var$advanceStringIndex = function advanceStringIndex(S, index) {
        var length = S.length;
        if (index + 1 >= length) return index + 1;
        var first = $696ba1128dba56bf$var$$charCodeAt(S, index);
        if (first < 0xD800 || first > 0xDBFF) return index + 1;
        var second = $696ba1128dba56bf$var$$charCodeAt(S, index + 1);
        if (second < 0xDC00 || second > 0xDFFF) return index + 1;
        return index + 2;
    };
    var $696ba1128dba56bf$var$getArrayIterator = function getArrayIterator(arraylike) {
        var i = 0;
        return {
            next: function next() {
                var done = i >= arraylike.length;
                var value;
                if (!done) {
                    value = arraylike[i];
                    i += 1;
                }
                return {
                    done: done,
                    value: value
                };
            }
        };
    };
    var $696ba1128dba56bf$var$getNonCollectionIterator = function getNonCollectionIterator(iterable, noPrimordialCollections) {
        if ($696ba1128dba56bf$var$isArray(iterable) || $429e9a47dda5abb1$exports(iterable)) return $696ba1128dba56bf$var$getArrayIterator(iterable);
        if ($696ba1128dba56bf$var$isString(iterable)) {
            var i = 0;
            return {
                next: function next() {
                    var nextIndex = $696ba1128dba56bf$var$advanceStringIndex(iterable, i);
                    var value = $696ba1128dba56bf$var$$stringSlice(iterable, i, nextIndex);
                    i = nextIndex;
                    return {
                        done: nextIndex > iterable.length,
                        value: value
                    };
                }
            };
        }
        // es6-shim and es-shims' es-map use a string "_es6-shim iterator_" property on different iterables, such as MapIterator.
        if (noPrimordialCollections && typeof iterable["_es6-shim iterator_"] !== "undefined") return iterable["_es6-shim iterator_"]();
    };
    if (!$696ba1128dba56bf$var$$Map && !$696ba1128dba56bf$var$$Set) // the only language iterables are Array, String, arguments
    // - Safari <= 6.0
    // - Chrome < 38
    // - node < 0.12
    // - FF < 13
    // - IE < 11
    // - Edge < 11
    $696ba1128dba56bf$exports = function getIterator(iterable) {
        if (iterable != null) return $696ba1128dba56bf$var$getNonCollectionIterator(iterable, true);
    };
    else {
        // either Map or Set are available, but Symbol is not
        // - es6-shim on an ES5 browser
        // - Safari 6.2 (maybe 6.1?)
        // - FF v[13, 36)
        // - IE 11
        // - Edge 11
        // - Safari v[6, 9)
        var $696ba1128dba56bf$var$isMap = (parcelRequire("3GgX7"));
        var $696ba1128dba56bf$var$isSet = (parcelRequire("c2Ook"));
        // Firefox >= 27, IE 11, Safari 6.2 - 9, Edge 11, es6-shim in older envs, all have forEach
        var $696ba1128dba56bf$var$$mapForEach = $696ba1128dba56bf$var$callBound("Map.prototype.forEach", true);
        var $696ba1128dba56bf$var$$setForEach = $696ba1128dba56bf$var$callBound("Set.prototype.forEach", true);
        if (typeof $4Jj9n === "undefined" || !$4Jj9n.versions || !$4Jj9n.versions.node) {
            // Firefox 17 - 26 has `.iterator()`, whose iterator `.next()` either
            // returns a value, or throws a StopIteration object. These browsers
            // do not have any other mechanism for iteration.
            var $696ba1128dba56bf$var$$mapIterator = $696ba1128dba56bf$var$callBound("Map.prototype.iterator", true);
            var $696ba1128dba56bf$var$$setIterator = $696ba1128dba56bf$var$callBound("Set.prototype.iterator", true);
        }
        // Firefox 27-35, and some older es6-shim versions, use a string "@@iterator" property
        // this returns a proper iterator object, so we should use it instead of forEach.
        // newer es6-shim versions use a string "_es6-shim iterator_" property.
        var $696ba1128dba56bf$var$$mapAtAtIterator = $696ba1128dba56bf$var$callBound("Map.prototype.@@iterator", true) || $696ba1128dba56bf$var$callBound("Map.prototype._es6-shim iterator_", true);
        var $696ba1128dba56bf$var$$setAtAtIterator = $696ba1128dba56bf$var$callBound("Set.prototype.@@iterator", true) || $696ba1128dba56bf$var$callBound("Set.prototype._es6-shim iterator_", true);
        var $696ba1128dba56bf$var$getCollectionIterator = function getCollectionIterator(iterable) {
            if ($696ba1128dba56bf$var$isMap(iterable)) {
                if ($696ba1128dba56bf$var$$mapIterator) return $74e2ea7fde7623ca$exports($696ba1128dba56bf$var$$mapIterator(iterable));
                if ($696ba1128dba56bf$var$$mapAtAtIterator) return $696ba1128dba56bf$var$$mapAtAtIterator(iterable);
                if ($696ba1128dba56bf$var$$mapForEach) {
                    var entries = [];
                    $696ba1128dba56bf$var$$mapForEach(iterable, function(v, k) {
                        $696ba1128dba56bf$var$$arrayPush(entries, [
                            k,
                            v
                        ]);
                    });
                    return $696ba1128dba56bf$var$getArrayIterator(entries);
                }
            }
            if ($696ba1128dba56bf$var$isSet(iterable)) {
                if ($696ba1128dba56bf$var$$setIterator) return $74e2ea7fde7623ca$exports($696ba1128dba56bf$var$$setIterator(iterable));
                if ($696ba1128dba56bf$var$$setAtAtIterator) return $696ba1128dba56bf$var$$setAtAtIterator(iterable);
                if ($696ba1128dba56bf$var$$setForEach) {
                    var values = [];
                    $696ba1128dba56bf$var$$setForEach(iterable, function(v) {
                        $696ba1128dba56bf$var$$arrayPush(values, v);
                    });
                    return $696ba1128dba56bf$var$getArrayIterator(values);
                }
            }
        };
        $696ba1128dba56bf$exports = function getIterator(iterable) {
            return $696ba1128dba56bf$var$getCollectionIterator(iterable) || $696ba1128dba56bf$var$getNonCollectionIterator(iterable);
        };
    }
}



var $40Tvb = parcelRequire("40Tvb");
var $46cbabaa228a1e87$exports = {};
"use strict";


var $j2lnW = parcelRequire("j2lnW");
var $371cc0a49a6920ce$exports = {};
"use strict";
var $371cc0a49a6920ce$var$numberIsNaN = function(value) {
    return value !== value;
};
$371cc0a49a6920ce$exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($371cc0a49a6920ce$var$numberIsNaN(a) && $371cc0a49a6920ce$var$numberIsNaN(b)) return true;
    return false;
};


var $33fceb270e96119f$exports = {};
"use strict";

$33fceb270e96119f$exports = function getPolyfill() {
    return typeof Object.is === "function" ? Object.is : $371cc0a49a6920ce$exports;
};


var $f57320309d36d081$exports = {};
"use strict";


$f57320309d36d081$exports = function shimObjectIs() {
    var polyfill = $33fceb270e96119f$exports();
    $14397c6d5d22ee98$exports(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};


var $46cbabaa228a1e87$var$polyfill = $j2lnW($33fceb270e96119f$exports(), Object);
$14397c6d5d22ee98$exports($46cbabaa228a1e87$var$polyfill, {
    getPolyfill: $33fceb270e96119f$exports,
    implementation: $371cc0a49a6920ce$exports,
    shim: $f57320309d36d081$exports
});
$46cbabaa228a1e87$exports = $46cbabaa228a1e87$var$polyfill;




var $5JxkD = parcelRequire("5JxkD");
var $3c3f96257fa5b625$exports = {};
"use strict";

var $j2lnW = parcelRequire("j2lnW");

var $f5Ljh = parcelRequire("f5Ljh");

var $gXypp = parcelRequire("gXypp");
var $a4f85a04b9bb1beb$exports = {};
"use strict";
var $3ce7fcd60dd2fc78$exports = {};
"use strict";
var $6d69560fa6c74dba$exports = {};
"use strict";
var $6d69560fa6c74dba$var$fnToStr = Function.prototype.toString;
var $6d69560fa6c74dba$var$reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
var $6d69560fa6c74dba$var$badArrayLike;
var $6d69560fa6c74dba$var$isCallableMarker;
if (typeof $6d69560fa6c74dba$var$reflectApply === "function" && typeof Object.defineProperty === "function") try {
    $6d69560fa6c74dba$var$badArrayLike = Object.defineProperty({}, "length", {
        get: function() {
            throw $6d69560fa6c74dba$var$isCallableMarker;
        }
    });
    $6d69560fa6c74dba$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $6d69560fa6c74dba$var$reflectApply(function() {
        throw 42;
    }, null, $6d69560fa6c74dba$var$badArrayLike);
} catch (_) {
    if (_ !== $6d69560fa6c74dba$var$isCallableMarker) $6d69560fa6c74dba$var$reflectApply = null;
}
else $6d69560fa6c74dba$var$reflectApply = null;
var $6d69560fa6c74dba$var$constructorRegex = /^\s*class\b/;
var $6d69560fa6c74dba$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $6d69560fa6c74dba$var$fnToStr.call(value);
        return $6d69560fa6c74dba$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $6d69560fa6c74dba$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($6d69560fa6c74dba$var$isES6ClassFn(value)) return false;
        $6d69560fa6c74dba$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $6d69560fa6c74dba$var$toStr = Object.prototype.toString;
var $6d69560fa6c74dba$var$objectClass = "[object Object]";
var $6d69560fa6c74dba$var$fnClass = "[object Function]";
var $6d69560fa6c74dba$var$genClass = "[object GeneratorFunction]";
var $6d69560fa6c74dba$var$ddaClass = "[object HTMLAllCollection]"; // IE 11
var $6d69560fa6c74dba$var$ddaClass2 = "[object HTML document.all class]";
var $6d69560fa6c74dba$var$ddaClass3 = "[object HTMLCollection]"; // IE 9-10
var $6d69560fa6c74dba$var$hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $6d69560fa6c74dba$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $6d69560fa6c74dba$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === "object") {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $6d69560fa6c74dba$var$all = document.all;
    if ($6d69560fa6c74dba$var$toStr.call($6d69560fa6c74dba$var$all) === $6d69560fa6c74dba$var$toStr.call(document.all)) $6d69560fa6c74dba$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($6d69560fa6c74dba$var$isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) try {
            var str = $6d69560fa6c74dba$var$toStr.call(value);
            return (str === $6d69560fa6c74dba$var$ddaClass || str === $6d69560fa6c74dba$var$ddaClass2 || str === $6d69560fa6c74dba$var$ddaClass3 // opera 12.16
             || str === $6d69560fa6c74dba$var$objectClass // IE 6-8
            ) && value("") == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
$6d69560fa6c74dba$exports = $6d69560fa6c74dba$var$reflectApply ? function isCallable(value) {
    if ($6d69560fa6c74dba$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    try {
        $6d69560fa6c74dba$var$reflectApply(value, null, $6d69560fa6c74dba$var$badArrayLike);
    } catch (e) {
        if (e !== $6d69560fa6c74dba$var$isCallableMarker) return false;
    }
    return !$6d69560fa6c74dba$var$isES6ClassFn(value) && $6d69560fa6c74dba$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($6d69560fa6c74dba$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    if ($6d69560fa6c74dba$var$hasToStringTag) return $6d69560fa6c74dba$var$tryFunctionObject(value);
    if ($6d69560fa6c74dba$var$isES6ClassFn(value)) return false;
    var strClass = $6d69560fa6c74dba$var$toStr.call(value);
    if (strClass !== $6d69560fa6c74dba$var$fnClass && strClass !== $6d69560fa6c74dba$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $6d69560fa6c74dba$var$tryFunctionObject(value);
};


var $3ce7fcd60dd2fc78$var$toStr = Object.prototype.toString;
var $3ce7fcd60dd2fc78$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $3ce7fcd60dd2fc78$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($3ce7fcd60dd2fc78$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $3ce7fcd60dd2fc78$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $3ce7fcd60dd2fc78$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($3ce7fcd60dd2fc78$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $3ce7fcd60dd2fc78$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$6d69560fa6c74dba$exports(iterator)) throw new TypeError("iterator must be a function");
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($3ce7fcd60dd2fc78$var$toStr.call(list) === "[object Array]") $3ce7fcd60dd2fc78$var$forEachArray(list, iterator, receiver);
    else if (typeof list === "string") $3ce7fcd60dd2fc78$var$forEachString(list, iterator, receiver);
    else $3ce7fcd60dd2fc78$var$forEachObject(list, iterator, receiver);
};
$3ce7fcd60dd2fc78$exports = $3ce7fcd60dd2fc78$var$forEach;


var $eecc525ad7efcf99$exports = {};
"use strict";
var $eecc525ad7efcf99$var$possibleNames = [
    "BigInt64Array",
    "BigUint64Array",
    "Float32Array",
    "Float64Array",
    "Int16Array",
    "Int32Array",
    "Int8Array",
    "Uint16Array",
    "Uint32Array",
    "Uint8Array",
    "Uint8ClampedArray"
];
var $eecc525ad7efcf99$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
$eecc525ad7efcf99$exports = function availableTypedArrays() {
    var out = [];
    for(var i = 0; i < $eecc525ad7efcf99$var$possibleNames.length; i++)if (typeof $eecc525ad7efcf99$var$g[$eecc525ad7efcf99$var$possibleNames[i]] === "function") out[out.length] = $eecc525ad7efcf99$var$possibleNames[i];
    return out;
};



var $f5Ljh = parcelRequire("f5Ljh");
var $a4f85a04b9bb1beb$var$$toString = $f5Ljh("Object.prototype.toString");

var $a4f85a04b9bb1beb$var$hasToStringTag = (parcelRequire("61Tck"))();
var $7cf947408a7dc41a$exports = {};
"use strict";

var $gXypp = parcelRequire("gXypp");
var $7cf947408a7dc41a$var$$gOPD = $gXypp("%Object.getOwnPropertyDescriptor%", true);
if ($7cf947408a7dc41a$var$$gOPD) try {
    $7cf947408a7dc41a$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $7cf947408a7dc41a$var$$gOPD = null;
}
$7cf947408a7dc41a$exports = $7cf947408a7dc41a$var$$gOPD;


var $a4f85a04b9bb1beb$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $a4f85a04b9bb1beb$var$typedArrays = $eecc525ad7efcf99$exports();
var $a4f85a04b9bb1beb$var$$indexOf = $f5Ljh("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
var $a4f85a04b9bb1beb$var$$slice = $f5Ljh("String.prototype.slice");
var $a4f85a04b9bb1beb$var$toStrTags = {};
var $a4f85a04b9bb1beb$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($a4f85a04b9bb1beb$var$hasToStringTag && $7cf947408a7dc41a$exports && $a4f85a04b9bb1beb$var$getPrototypeOf) $3ce7fcd60dd2fc78$exports($a4f85a04b9bb1beb$var$typedArrays, function(typedArray) {
    var arr = new $a4f85a04b9bb1beb$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $a4f85a04b9bb1beb$var$getPrototypeOf(arr);
        var descriptor = $7cf947408a7dc41a$exports(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $a4f85a04b9bb1beb$var$getPrototypeOf(proto);
            descriptor = $7cf947408a7dc41a$exports(superProto, Symbol.toStringTag);
        }
        $a4f85a04b9bb1beb$var$toStrTags[typedArray] = descriptor.get;
    }
});
var $a4f85a04b9bb1beb$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var anyTrue = false;
    $3ce7fcd60dd2fc78$exports($a4f85a04b9bb1beb$var$toStrTags, function(getter, typedArray) {
        if (!anyTrue) try {
            anyTrue = getter.call(value) === typedArray;
        } catch (e) {}
    });
    return anyTrue;
};
$a4f85a04b9bb1beb$exports = function isTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!$a4f85a04b9bb1beb$var$hasToStringTag || !(Symbol.toStringTag in value)) {
        var tag = $a4f85a04b9bb1beb$var$$slice($a4f85a04b9bb1beb$var$$toString(value), 8, -1);
        return $a4f85a04b9bb1beb$var$$indexOf($a4f85a04b9bb1beb$var$typedArrays, tag) > -1;
    }
    if (!$7cf947408a7dc41a$exports) return false;
    return $a4f85a04b9bb1beb$var$tryTypedArrays(value);
};


var $3c3f96257fa5b625$var$$ArrayBuffer = $gXypp("ArrayBuffer", true);
var $3c3f96257fa5b625$var$$Float32Array = $gXypp("Float32Array", true);
var $3c3f96257fa5b625$var$$byteLength = $f5Ljh("ArrayBuffer.prototype.byteLength", true);
// in node 0.10, ArrayBuffers have no prototype methods, but have an own slot-checking `slice` method
var $3c3f96257fa5b625$var$abSlice = $3c3f96257fa5b625$var$$ArrayBuffer && !$3c3f96257fa5b625$var$$byteLength && new $3c3f96257fa5b625$var$$ArrayBuffer().slice;
var $3c3f96257fa5b625$var$$abSlice = $3c3f96257fa5b625$var$abSlice && $j2lnW($3c3f96257fa5b625$var$abSlice);
$3c3f96257fa5b625$exports = $3c3f96257fa5b625$var$$byteLength || $3c3f96257fa5b625$var$$abSlice ? function isArrayBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    try {
        if ($3c3f96257fa5b625$var$$byteLength) $3c3f96257fa5b625$var$$byteLength(obj);
        else $3c3f96257fa5b625$var$$abSlice(obj, 0);
        return true;
    } catch (e) {
        return false;
    }
} : $3c3f96257fa5b625$var$$Float32Array ? function IsArrayBuffer(obj) {
    try {
        return new $3c3f96257fa5b625$var$$Float32Array(obj).buffer === obj && !$a4f85a04b9bb1beb$exports(obj);
    } catch (e) {
        return typeof obj === "object" && e.name === "RangeError";
    }
} : function isArrayBuffer(obj) {
    return false;
};


var $b5d6f4e464b07c8a$exports = {};
"use strict";
var $b5d6f4e464b07c8a$var$getDay = Date.prototype.getDay;
var $b5d6f4e464b07c8a$var$tryDateObject = function tryDateGetDayCall(value) {
    try {
        $b5d6f4e464b07c8a$var$getDay.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $b5d6f4e464b07c8a$var$toStr = Object.prototype.toString;
var $b5d6f4e464b07c8a$var$dateClass = "[object Date]";

var $b5d6f4e464b07c8a$var$hasToStringTag = (parcelRequire("61Tck"))();
$b5d6f4e464b07c8a$exports = function isDateObject(value) {
    if (typeof value !== "object" || value === null) return false;
    return $b5d6f4e464b07c8a$var$hasToStringTag ? $b5d6f4e464b07c8a$var$tryDateObject(value) : $b5d6f4e464b07c8a$var$toStr.call(value) === $b5d6f4e464b07c8a$var$dateClass;
};


var $f029da861f327a10$exports = {};
"use strict";

var $f5Ljh = parcelRequire("f5Ljh");

var $f029da861f327a10$var$hasToStringTag = (parcelRequire("61Tck"))();
var $f029da861f327a10$var$has;
var $f029da861f327a10$var$$exec;
var $f029da861f327a10$var$isRegexMarker;
var $f029da861f327a10$var$badStringifier;
if ($f029da861f327a10$var$hasToStringTag) {
    $f029da861f327a10$var$has = $f5Ljh("Object.prototype.hasOwnProperty");
    $f029da861f327a10$var$$exec = $f5Ljh("RegExp.prototype.exec");
    $f029da861f327a10$var$isRegexMarker = {};
    var $f029da861f327a10$var$throwRegexMarker = function() {
        throw $f029da861f327a10$var$isRegexMarker;
    };
    $f029da861f327a10$var$badStringifier = {
        toString: $f029da861f327a10$var$throwRegexMarker,
        valueOf: $f029da861f327a10$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === "symbol") $f029da861f327a10$var$badStringifier[Symbol.toPrimitive] = $f029da861f327a10$var$throwRegexMarker;
}
var $f029da861f327a10$var$$toString = $f5Ljh("Object.prototype.toString");
var $f029da861f327a10$var$gOPD = Object.getOwnPropertyDescriptor;
var $f029da861f327a10$var$regexClass = "[object RegExp]";
$f029da861f327a10$exports = $f029da861f327a10$var$hasToStringTag ? function isRegex(value) {
    if (!value || typeof value !== "object") return false;
    var descriptor = $f029da861f327a10$var$gOPD(value, "lastIndex");
    var hasLastIndexDataProperty = descriptor && $f029da861f327a10$var$has(descriptor, "value");
    if (!hasLastIndexDataProperty) return false;
    try {
        $f029da861f327a10$var$$exec(value, $f029da861f327a10$var$badStringifier);
    } catch (e) {
        return e === $f029da861f327a10$var$isRegexMarker;
    }
} : function isRegex(value) {
    // In older browsers, typeof regex incorrectly returns 'function'
    if (!value || typeof value !== "object" && typeof value !== "function") return false;
    return $f029da861f327a10$var$$toString(value) === $f029da861f327a10$var$regexClass;
};


var $acbf7f791aaebff2$exports = {};
"use strict";

var $f5Ljh = parcelRequire("f5Ljh");
var $acbf7f791aaebff2$var$$byteLength = $f5Ljh("SharedArrayBuffer.prototype.byteLength", true);
$acbf7f791aaebff2$exports = $acbf7f791aaebff2$var$$byteLength ? function isSharedArrayBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    try {
        $acbf7f791aaebff2$var$$byteLength(obj);
        return true;
    } catch (e) {
        return false;
    }
} : function isSharedArrayBuffer(obj) {
    return false;
};



var $70549758e725f660$exports = {};
"use strict";

var $3jOv9 = parcelRequire("3jOv9");
var $d8bb0d546ef265c1$exports = {};
"use strict";
var $d8bb0d546ef265c1$var$numToStr = Number.prototype.toString;
var $d8bb0d546ef265c1$var$tryNumberObject = function tryNumberObject(value) {
    try {
        $d8bb0d546ef265c1$var$numToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $d8bb0d546ef265c1$var$toStr = Object.prototype.toString;
var $d8bb0d546ef265c1$var$numClass = "[object Number]";

var $d8bb0d546ef265c1$var$hasToStringTag = (parcelRequire("61Tck"))();
$d8bb0d546ef265c1$exports = function isNumberObject(value) {
    if (typeof value === "number") return true;
    if (typeof value !== "object") return false;
    return $d8bb0d546ef265c1$var$hasToStringTag ? $d8bb0d546ef265c1$var$tryNumberObject(value) : $d8bb0d546ef265c1$var$toStr.call(value) === $d8bb0d546ef265c1$var$numClass;
};


var $50329db4abd89b4d$exports = {};
"use strict";

var $f5Ljh = parcelRequire("f5Ljh");
var $50329db4abd89b4d$var$$boolToStr = $f5Ljh("Boolean.prototype.toString");
var $50329db4abd89b4d$var$$toString = $f5Ljh("Object.prototype.toString");
var $50329db4abd89b4d$var$tryBooleanObject = function booleanBrandCheck(value) {
    try {
        $50329db4abd89b4d$var$$boolToStr(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $50329db4abd89b4d$var$boolClass = "[object Boolean]";

var $50329db4abd89b4d$var$hasToStringTag = (parcelRequire("61Tck"))();
$50329db4abd89b4d$exports = function isBoolean(value) {
    if (typeof value === "boolean") return true;
    if (value === null || typeof value !== "object") return false;
    return $50329db4abd89b4d$var$hasToStringTag && Symbol.toStringTag in value ? $50329db4abd89b4d$var$tryBooleanObject(value) : $50329db4abd89b4d$var$$toString(value) === $50329db4abd89b4d$var$boolClass;
};


var $9d2c68f74b126a2e$exports = {};
"use strict";
var $9d2c68f74b126a2e$var$toStr = Object.prototype.toString;

var $9d2c68f74b126a2e$var$hasSymbols = (parcelRequire("eke6n"))();
if ($9d2c68f74b126a2e$var$hasSymbols) {
    var $9d2c68f74b126a2e$var$symToStr = Symbol.prototype.toString;
    var $9d2c68f74b126a2e$var$symStringRegex = /^Symbol\(.*\)$/;
    var $9d2c68f74b126a2e$var$isSymbolObject = function isRealSymbolObject(value) {
        if (typeof value.valueOf() !== "symbol") return false;
        return $9d2c68f74b126a2e$var$symStringRegex.test($9d2c68f74b126a2e$var$symToStr.call(value));
    };
    $9d2c68f74b126a2e$exports = function isSymbol(value) {
        if (typeof value === "symbol") return true;
        if ($9d2c68f74b126a2e$var$toStr.call(value) !== "[object Symbol]") return false;
        try {
            return $9d2c68f74b126a2e$var$isSymbolObject(value);
        } catch (e) {
            return false;
        }
    };
} else $9d2c68f74b126a2e$exports = function isSymbol(value) {
    // this environment does not support Symbols.
    return false;
};


var $ae5550ea5d860126$exports = {};
"use strict";

var $ae5550ea5d860126$var$hasBigInts = (parcelRequire("h6a0S"))();
if ($ae5550ea5d860126$var$hasBigInts) {
    var $ae5550ea5d860126$var$bigIntValueOf = BigInt.prototype.valueOf;
    var $ae5550ea5d860126$var$tryBigInt = function tryBigIntObject(value) {
        try {
            $ae5550ea5d860126$var$bigIntValueOf.call(value);
            return true;
        } catch (e) {}
        return false;
    };
    $ae5550ea5d860126$exports = function isBigInt(value) {
        if (value === null || typeof value === "undefined" || typeof value === "boolean" || typeof value === "string" || typeof value === "number" || typeof value === "symbol" || typeof value === "function") return false;
        if (typeof value === "bigint") return true;
        return $ae5550ea5d860126$var$tryBigInt(value);
    };
} else $ae5550ea5d860126$exports = function isBigInt(value) {
    return false;
};


// eslint-disable-next-line consistent-return
$70549758e725f660$exports = function whichBoxedPrimitive(value) {
    // eslint-disable-next-line eqeqeq
    if (value == null || typeof value !== "object" && typeof value !== "function") return null;
    if ($3jOv9(value)) return "String";
    if ($d8bb0d546ef265c1$exports(value)) return "Number";
    if ($50329db4abd89b4d$exports(value)) return "Boolean";
    if ($9d2c68f74b126a2e$exports(value)) return "Symbol";
    if ($ae5550ea5d860126$exports(value)) return "BigInt";
};


var $08d53dfc0f70402a$exports = {};
"use strict";

var $3GgX7 = parcelRequire("3GgX7");

var $c2Ook = parcelRequire("c2Ook");
var $3ed178a7597af60e$exports = {};
"use strict";
var $3ed178a7597af60e$var$$WeakMap = typeof WeakMap === "function" && WeakMap.prototype ? WeakMap : null;
var $3ed178a7597af60e$var$$WeakSet = typeof WeakSet === "function" && WeakSet.prototype ? WeakSet : null;
var $3ed178a7597af60e$var$exported;
if (!$3ed178a7597af60e$var$$WeakMap) // eslint-disable-next-line no-unused-vars
$3ed178a7597af60e$var$exported = function isWeakMap(x) {
    // `WeakMap` is not present in this environment.
    return false;
};
var $3ed178a7597af60e$var$$mapHas = $3ed178a7597af60e$var$$WeakMap ? $3ed178a7597af60e$var$$WeakMap.prototype.has : null;
var $3ed178a7597af60e$var$$setHas = $3ed178a7597af60e$var$$WeakSet ? $3ed178a7597af60e$var$$WeakSet.prototype.has : null;
if (!$3ed178a7597af60e$var$exported && !$3ed178a7597af60e$var$$mapHas) // eslint-disable-next-line no-unused-vars
$3ed178a7597af60e$var$exported = function isWeakMap(x) {
    // `WeakMap` does not have a `has` method
    return false;
};
$3ed178a7597af60e$exports = $3ed178a7597af60e$var$exported || function isWeakMap(x) {
    if (!x || typeof x !== "object") return false;
    try {
        $3ed178a7597af60e$var$$mapHas.call(x, $3ed178a7597af60e$var$$mapHas);
        if ($3ed178a7597af60e$var$$setHas) try {
            $3ed178a7597af60e$var$$setHas.call(x, $3ed178a7597af60e$var$$setHas);
        } catch (e) {
            return true;
        }
        return x instanceof $3ed178a7597af60e$var$$WeakMap; // core-js workaround, pre-v3
    } catch (e) {}
    return false;
};


var $1acbe8761d9313ec$exports = {};
"use strict";

var $gXypp = parcelRequire("gXypp");

var $f5Ljh = parcelRequire("f5Ljh");
var $1acbe8761d9313ec$var$$WeakSet = $gXypp("%WeakSet%", true);
var $1acbe8761d9313ec$var$$setHas = $f5Ljh("WeakSet.prototype.has", true);
if ($1acbe8761d9313ec$var$$setHas) {
    var $1acbe8761d9313ec$var$$mapHas = $f5Ljh("WeakMap.prototype.has", true);
    $1acbe8761d9313ec$exports = function isWeakSet(x) {
        if (!x || typeof x !== "object") return false;
        try {
            $1acbe8761d9313ec$var$$setHas(x, $1acbe8761d9313ec$var$$setHas);
            if ($1acbe8761d9313ec$var$$mapHas) try {
                $1acbe8761d9313ec$var$$mapHas(x, $1acbe8761d9313ec$var$$mapHas);
            } catch (e) {
                return true;
            }
            return x instanceof $1acbe8761d9313ec$var$$WeakSet; // core-js workaround, pre-v3
        } catch (e) {}
        return false;
    };
} else // eslint-disable-next-line no-unused-vars
$1acbe8761d9313ec$exports = function isWeakSet(x) {
    // `WeakSet` does not exist, or does not have a `has` method
    return false;
};


$08d53dfc0f70402a$exports = function whichCollection(value) {
    if (value && typeof value === "object") {
        if ($3GgX7(value)) return "Map";
        if ($c2Ook(value)) return "Set";
        if ($3ed178a7597af60e$exports(value)) return "WeakMap";
        if ($1acbe8761d9313ec$exports(value)) return "WeakSet";
    }
    return false;
};


var $d42039be31319452$exports = {};
"use strict";



var $f5Ljh = parcelRequire("f5Ljh");

var $d42039be31319452$var$$toString = $f5Ljh("Object.prototype.toString");

var $d42039be31319452$var$hasToStringTag = (parcelRequire("61Tck"))();
var $d42039be31319452$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $d42039be31319452$var$typedArrays = $eecc525ad7efcf99$exports();
var $d42039be31319452$var$$slice = $f5Ljh("String.prototype.slice");
var $d42039be31319452$var$toStrTags = {};
var $d42039be31319452$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($d42039be31319452$var$hasToStringTag && $7cf947408a7dc41a$exports && $d42039be31319452$var$getPrototypeOf) $3ce7fcd60dd2fc78$exports($d42039be31319452$var$typedArrays, function(typedArray) {
    if (typeof $d42039be31319452$var$g[typedArray] === "function") {
        var arr = new $d42039be31319452$var$g[typedArray]();
        if (Symbol.toStringTag in arr) {
            var proto = $d42039be31319452$var$getPrototypeOf(arr);
            var descriptor = $7cf947408a7dc41a$exports(proto, Symbol.toStringTag);
            if (!descriptor) {
                var superProto = $d42039be31319452$var$getPrototypeOf(proto);
                descriptor = $7cf947408a7dc41a$exports(superProto, Symbol.toStringTag);
            }
            $d42039be31319452$var$toStrTags[typedArray] = descriptor.get;
        }
    }
});
var $d42039be31319452$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var foundName = false;
    $3ce7fcd60dd2fc78$exports($d42039be31319452$var$toStrTags, function(getter, typedArray) {
        if (!foundName) try {
            var name = getter.call(value);
            if (name === typedArray) foundName = name;
        } catch (e) {}
    });
    return foundName;
};

$d42039be31319452$exports = function whichTypedArray(value) {
    if (!$a4f85a04b9bb1beb$exports(value)) return false;
    if (!$d42039be31319452$var$hasToStringTag || !(Symbol.toStringTag in value)) return $d42039be31319452$var$$slice($d42039be31319452$var$$toString(value), 8, -1);
    return $d42039be31319452$var$tryTypedArrays(value);
};


var $a7711d92edf091ca$exports = {};
"use strict";

var $f5Ljh = parcelRequire("f5Ljh");
var $a7711d92edf091ca$var$$byteLength = $f5Ljh("ArrayBuffer.prototype.byteLength", true);

$a7711d92edf091ca$exports = function byteLength(ab) {
    if (!$3c3f96257fa5b625$exports(ab)) return NaN;
    return $a7711d92edf091ca$var$$byteLength ? $a7711d92edf091ca$var$$byteLength(ab) : ab.byteLength;
}; // in node < 0.11, byteLength is an own nonconfigurable property


var $4a31c07ea431e8cc$var$sabByteLength = $f5Ljh("SharedArrayBuffer.prototype.byteLength", true);
var $4a31c07ea431e8cc$var$$getTime = $f5Ljh("Date.prototype.getTime");
var $4a31c07ea431e8cc$var$gPO = Object.getPrototypeOf;
var $4a31c07ea431e8cc$var$$objToString = $f5Ljh("Object.prototype.toString");
var $4a31c07ea431e8cc$var$$Set = $gXypp("%Set%", true);
var $4a31c07ea431e8cc$var$$mapHas = $f5Ljh("Map.prototype.has", true);
var $4a31c07ea431e8cc$var$$mapGet = $f5Ljh("Map.prototype.get", true);
var $4a31c07ea431e8cc$var$$mapSize = $f5Ljh("Map.prototype.size", true);
var $4a31c07ea431e8cc$var$$setAdd = $f5Ljh("Set.prototype.add", true);
var $4a31c07ea431e8cc$var$$setDelete = $f5Ljh("Set.prototype.delete", true);
var $4a31c07ea431e8cc$var$$setHas = $f5Ljh("Set.prototype.has", true);
var $4a31c07ea431e8cc$var$$setSize = $f5Ljh("Set.prototype.size", true);
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L401-L414
function $4a31c07ea431e8cc$var$setHasEqualElement(set, val1, opts, channel) {
    var i = $696ba1128dba56bf$exports(set);
    var result;
    while((result = i.next()) && !result.done)if ($4a31c07ea431e8cc$var$internalDeepEqual(val1, result.value, opts, channel)) {
        // Remove the matching element to make sure we do not check that again.
        $4a31c07ea431e8cc$var$$setDelete(set, result.value);
        return true;
    }
    return false;
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L416-L439
function $4a31c07ea431e8cc$var$findLooseMatchingPrimitives(prim) {
    if (typeof prim === "undefined") return null;
    if (typeof prim === "object") return void 0;
    if (typeof prim === "symbol") return false;
    if (typeof prim === "string" || typeof prim === "number") // Loose equal entries exist only if the string is possible to convert to a regular number and not NaN.
    return +prim === +prim; // eslint-disable-line no-implicit-coercion
    return true;
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L449-L460
function $4a31c07ea431e8cc$var$mapMightHaveLoosePrim(a, b, prim, item, opts, channel) {
    var altValue = $4a31c07ea431e8cc$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = $4a31c07ea431e8cc$var$$mapGet(b, altValue);
    var looseOpts = $dfd98480ca099e65$exports({}, opts, {
        strict: false
    });
    if (typeof curB === "undefined" && !$4a31c07ea431e8cc$var$$mapHas(b, altValue) || !$4a31c07ea431e8cc$var$internalDeepEqual(item, curB, looseOpts, channel)) return false;
    // eslint-disable-next-line no-use-before-define
    return !$4a31c07ea431e8cc$var$$mapHas(a, altValue) && $4a31c07ea431e8cc$var$internalDeepEqual(item, curB, looseOpts, channel);
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L441-L447
function $4a31c07ea431e8cc$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $4a31c07ea431e8cc$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return $4a31c07ea431e8cc$var$$setHas(b, altValue) && !$4a31c07ea431e8cc$var$$setHas(a, altValue);
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L518-L533
function $4a31c07ea431e8cc$var$mapHasEqualEntry(set, map, key1, item1, opts, channel) {
    var i = $696ba1128dba56bf$exports(set);
    var result;
    var key2;
    while((result = i.next()) && !result.done){
        key2 = result.value;
        if (// eslint-disable-next-line no-use-before-define
        $4a31c07ea431e8cc$var$internalDeepEqual(key1, key2, opts, channel) && $4a31c07ea431e8cc$var$internalDeepEqual(item1, $4a31c07ea431e8cc$var$$mapGet(map, key2), opts, channel)) {
            $4a31c07ea431e8cc$var$$setDelete(set, key2);
            return true;
        }
    }
    return false;
}
function $4a31c07ea431e8cc$var$internalDeepEqual(actual, expected, options, channel) {
    var opts = options || {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (opts.strict ? $46cbabaa228a1e87$exports(actual, expected) : actual === expected) return true;
    var actualBoxed = $70549758e725f660$exports(actual);
    var expectedBoxed = $70549758e725f660$exports(expected);
    if (actualBoxed !== expectedBoxed) return false;
    // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
    if (!actual || !expected || typeof actual !== "object" && typeof expected !== "object") return opts.strict ? $46cbabaa228a1e87$exports(actual, expected) : actual == expected; // eslint-disable-line eqeqeq
    /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */ // see https://github.com/nodejs/node/commit/d3aafd02efd3a403d646a3044adcf14e63a88d32 for memos/channel inspiration
    var hasActual = channel.has(actual);
    var hasExpected = channel.has(expected);
    var sentinel;
    if (hasActual && hasExpected) {
        if (channel.get(actual) === channel.get(expected)) return true;
    } else sentinel = {};
    if (!hasActual) channel.set(actual, sentinel);
    if (!hasExpected) channel.set(expected, sentinel);
    // eslint-disable-next-line no-use-before-define
    return $4a31c07ea431e8cc$var$objEquiv(actual, expected, opts, channel);
}
function $4a31c07ea431e8cc$var$isBuffer(x) {
    if (!x || typeof x !== "object" || typeof x.length !== "number") return false;
    if (typeof x.copy !== "function" || typeof x.slice !== "function") return false;
    if (x.length > 0 && typeof x[0] !== "number") return false;
    return !!(x.constructor && x.constructor.isBuffer && x.constructor.isBuffer(x));
}
function $4a31c07ea431e8cc$var$setEquiv(a, b, opts, channel) {
    if ($4a31c07ea431e8cc$var$$setSize(a) !== $4a31c07ea431e8cc$var$$setSize(b)) return false;
    var iA = $696ba1128dba56bf$exports(a);
    var iB = $696ba1128dba56bf$exports(b);
    var resultA;
    var resultB;
    var set;
    while((resultA = iA.next()) && !resultA.done){
        if (resultA.value && typeof resultA.value === "object") {
            if (!set) set = new $4a31c07ea431e8cc$var$$Set();
            $4a31c07ea431e8cc$var$$setAdd(set, resultA.value);
        } else if (!$4a31c07ea431e8cc$var$$setHas(b, resultA.value)) {
            if (opts.strict) return false;
            if (!$4a31c07ea431e8cc$var$setMightHaveLoosePrim(a, b, resultA.value)) return false;
            if (!set) set = new $4a31c07ea431e8cc$var$$Set();
            $4a31c07ea431e8cc$var$$setAdd(set, resultA.value);
        }
    }
    if (set) {
        while((resultB = iB.next()) && !resultB.done){
            // We have to check if a primitive value is already matching and only if it's not, go hunting for it.
            if (resultB.value && typeof resultB.value === "object") {
                if (!$4a31c07ea431e8cc$var$setHasEqualElement(set, resultB.value, opts.strict, channel)) return false;
            } else if (!opts.strict && !$4a31c07ea431e8cc$var$$setHas(a, resultB.value) && !$4a31c07ea431e8cc$var$setHasEqualElement(set, resultB.value, opts.strict, channel)) return false;
        }
        return $4a31c07ea431e8cc$var$$setSize(set) === 0;
    }
    return true;
}
function $4a31c07ea431e8cc$var$mapEquiv(a, b, opts, channel) {
    if ($4a31c07ea431e8cc$var$$mapSize(a) !== $4a31c07ea431e8cc$var$$mapSize(b)) return false;
    var iA = $696ba1128dba56bf$exports(a);
    var iB = $696ba1128dba56bf$exports(b);
    var resultA;
    var resultB;
    var set;
    var key;
    var item1;
    var item2;
    while((resultA = iA.next()) && !resultA.done){
        key = resultA.value[0];
        item1 = resultA.value[1];
        if (key && typeof key === "object") {
            if (!set) set = new $4a31c07ea431e8cc$var$$Set();
            $4a31c07ea431e8cc$var$$setAdd(set, key);
        } else {
            item2 = $4a31c07ea431e8cc$var$$mapGet(b, key);
            if (typeof item2 === "undefined" && !$4a31c07ea431e8cc$var$$mapHas(b, key) || !$4a31c07ea431e8cc$var$internalDeepEqual(item1, item2, opts, channel)) {
                if (opts.strict) return false;
                if (!$4a31c07ea431e8cc$var$mapMightHaveLoosePrim(a, b, key, item1, opts, channel)) return false;
                if (!set) set = new $4a31c07ea431e8cc$var$$Set();
                $4a31c07ea431e8cc$var$$setAdd(set, key);
            }
        }
    }
    if (set) {
        while((resultB = iB.next()) && !resultB.done){
            key = resultB.value[0];
            item2 = resultB.value[1];
            if (key && typeof key === "object") {
                if (!$4a31c07ea431e8cc$var$mapHasEqualEntry(set, a, key, item2, opts, channel)) return false;
            } else if (!opts.strict && (!a.has(key) || !$4a31c07ea431e8cc$var$internalDeepEqual($4a31c07ea431e8cc$var$$mapGet(a, key), item2, opts, channel)) && !$4a31c07ea431e8cc$var$mapHasEqualEntry(set, a, key, item2, $dfd98480ca099e65$exports({}, opts, {
                strict: false
            }), channel)) return false;
        }
        return $4a31c07ea431e8cc$var$$setSize(set) === 0;
    }
    return true;
}
function $4a31c07ea431e8cc$var$objEquiv(a, b, opts, channel) {
    /* eslint max-statements: [2, 100], max-lines-per-function: [2, 120], max-depth: [2, 5], max-lines: [2, 400] */ var i, key;
    if (typeof a !== typeof b) return false;
    if (a == null || b == null) return false;
    if ($4a31c07ea431e8cc$var$$objToString(a) !== $4a31c07ea431e8cc$var$$objToString(b)) return false;
    if ($429e9a47dda5abb1$exports(a) !== $429e9a47dda5abb1$exports(b)) return false;
    var aIsArray = $5JxkD(a);
    var bIsArray = $5JxkD(b);
    if (aIsArray !== bIsArray) return false;
    // TODO: replace when a cross-realm brand check is available
    var aIsError = a instanceof Error;
    var bIsError = b instanceof Error;
    if (aIsError !== bIsError) return false;
    if (aIsError || bIsError) {
        if (a.name !== b.name || a.message !== b.message) return false;
    }
    var aIsRegex = $f029da861f327a10$exports(a);
    var bIsRegex = $f029da861f327a10$exports(b);
    if (aIsRegex !== bIsRegex) return false;
    if ((aIsRegex || bIsRegex) && (a.source !== b.source || $e71eab4fe8329ea3$exports(a) !== $e71eab4fe8329ea3$exports(b))) return false;
    var aIsDate = $b5d6f4e464b07c8a$exports(a);
    var bIsDate = $b5d6f4e464b07c8a$exports(b);
    if (aIsDate !== bIsDate) return false;
    if (aIsDate || bIsDate) {
        if ($4a31c07ea431e8cc$var$$getTime(a) !== $4a31c07ea431e8cc$var$$getTime(b)) return false;
    }
    if (opts.strict && $4a31c07ea431e8cc$var$gPO && $4a31c07ea431e8cc$var$gPO(a) !== $4a31c07ea431e8cc$var$gPO(b)) return false;
    var aWhich = $d42039be31319452$exports(a);
    var bWhich = $d42039be31319452$exports(b);
    if ((aWhich || bWhich) && aWhich !== bWhich) return false;
    var aIsBuffer = $4a31c07ea431e8cc$var$isBuffer(a);
    var bIsBuffer = $4a31c07ea431e8cc$var$isBuffer(b);
    if (aIsBuffer !== bIsBuffer) return false;
    if (aIsBuffer || bIsBuffer) {
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    var aIsArrayBuffer = $3c3f96257fa5b625$exports(a);
    var bIsArrayBuffer = $3c3f96257fa5b625$exports(b);
    if (aIsArrayBuffer !== bIsArrayBuffer) return false;
    if (aIsArrayBuffer || bIsArrayBuffer) {
        if ($a7711d92edf091ca$exports(a) !== $a7711d92edf091ca$exports(b)) return false;
        return typeof Uint8Array === "function" && $4a31c07ea431e8cc$var$internalDeepEqual(new Uint8Array(a), new Uint8Array(b), opts, channel);
    }
    var aIsSAB = $acbf7f791aaebff2$exports(a);
    var bIsSAB = $acbf7f791aaebff2$exports(b);
    if (aIsSAB !== bIsSAB) return false;
    if (aIsSAB || bIsSAB) {
        if ($4a31c07ea431e8cc$var$sabByteLength(a) !== $4a31c07ea431e8cc$var$sabByteLength(b)) return false;
        return typeof Uint8Array === "function" && $4a31c07ea431e8cc$var$internalDeepEqual(new Uint8Array(a), new Uint8Array(b), opts, channel);
    }
    if (typeof a !== typeof b) return false;
    var ka = $6f712504e9fa9490$exports(a);
    var kb = $6f712504e9fa9490$exports(b);
    // having the same number of owned properties (keys incorporates hasOwnProperty)
    if (ka.length !== kb.length) return false;
    // the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    // ~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
         // eslint-disable-line eqeqeq
    }
    // equivalent values for every corresponding key, and ~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$4a31c07ea431e8cc$var$internalDeepEqual(a[key], b[key], opts, channel)) return false;
    }
    var aCollection = $08d53dfc0f70402a$exports(a);
    var bCollection = $08d53dfc0f70402a$exports(b);
    if (aCollection !== bCollection) return false;
    if (aCollection === "Set" || bCollection === "Set") return $4a31c07ea431e8cc$var$setEquiv(a, b, opts, channel);
    if (aCollection === "Map") return $4a31c07ea431e8cc$var$mapEquiv(a, b, opts, channel);
    return true;
}
$4a31c07ea431e8cc$exports = function deepEqual(a, b, opts) {
    return $4a31c07ea431e8cc$var$internalDeepEqual(a, b, opts, $40Tvb());
};




function $12ca2170c1ecb2f7$export$a5ec0cdf75e7b1ce(cache, ...params) {
    const status = (0, $d70beb1831956ba7$export$a0b0284d625c6d1d)(cache, ...params);
    const [prevParams, setPrevParams] = (0, $k116o.useState)(undefined);
    const [prevValue, setPrevValue] = (0, $k116o.useState)(undefined);
    let error = undefined;
    let value = undefined;
    (0, $k116o.useEffect)(()=>{
        switch(status){
            case 0, $131b3f6f00984c1a$export$1af79998fa14ea8:
                cache.prefetch(...params);
                break;
            case 0, $131b3f6f00984c1a$export$95b9efe7da5fb195:
                {
                    // Cache most recently resolved value in case of a mutation
                    setPrevParams((prevParams)=>{
                        if (prevParams == params || (0, (/*@__PURE__*/$parcel$interopDefault($4a31c07ea431e8cc$exports)))(prevParams, params)) return prevParams;
                        else return params;
                    });
                    const value = cache.getValue(...params);
                    setPrevValue((prevValue)=>{
                        if (prevValue == value || (0, (/*@__PURE__*/$parcel$interopDefault($4a31c07ea431e8cc$exports)))(prevValue, value)) return prevValue;
                        else return value;
                    });
                    break;
                }
        }
    }, [
        cache,
        status,
        ...params
    ]);
    switch(status){
        case 0, $131b3f6f00984c1a$export$89864f7e9466db1c:
            try {
                cache.getValue(...params);
            } catch (caught) {
                error = caught;
            }
            break;
        case 0, $131b3f6f00984c1a$export$95b9efe7da5fb195:
            value = cache.getValue(...params);
            break;
        case 0, $131b3f6f00984c1a$export$102c3f975dbe36bd:
            value = prevParams == params || (0, (/*@__PURE__*/$parcel$interopDefault($4a31c07ea431e8cc$exports)))(prevParams, params) ? prevValue : undefined;
            break;
    }
    return (0, $k116o.useMemo)(()=>({
            error: error,
            status: status,
            value: value
        }), [
        error,
        status,
        value
    ]);
}
$12ca2170c1ecb2f7$export$a5ec0cdf75e7b1ce.displayName = "useImperativeCacheValue";



var $k116o = parcelRequire("k116o");


var $k116o = parcelRequire("k116o");
function $b9b09269484de0c3$export$820bacc5016fd7d4(cache, start, end, ...params) {
    return (0, $k116o.useSyncExternalStore)((callback)=>cache.subscribe(callback, start, end, ...params), ()=>cache.getStatus(start, end, ...params), ()=>cache.getStatus(start, end, ...params));
}
$b9b09269484de0c3$export$820bacc5016fd7d4.displayName = "useIntervalCacheStatus";


function $c27b1d95780ff956$export$660cca5bd4d339e3(cache, start, end, ...params) {
    const status = (0, $b9b09269484de0c3$export$820bacc5016fd7d4)(cache, start, end, ...params);
    (0, $k116o.useEffect)(()=>{
        switch(status){
            case 0, $131b3f6f00984c1a$export$1af79998fa14ea8:
                cache.readAsync(start, end, ...params);
        }
    }, [
        cache,
        status,
        start,
        end,
        ...params
    ]);
    switch(status){
        case 0, $131b3f6f00984c1a$export$89864f7e9466db1c:
            let caught;
            try {
                cache.getValue(start, end, ...params);
            } catch (error) {
                caught = error;
            }
            return {
                error: caught,
                status: (0, $131b3f6f00984c1a$export$89864f7e9466db1c),
                value: undefined
            };
        case 0, $131b3f6f00984c1a$export$95b9efe7da5fb195:
            try {
                const value = cache.getValue(start, end, ...params);
                const isPartialResult = cache.isPartialResult(value);
                return {
                    error: undefined,
                    isPartialResult: isPartialResult,
                    status: (0, $131b3f6f00984c1a$export$95b9efe7da5fb195),
                    value: value
                };
            } catch (error) {}
        default:
    }
    return {
        error: undefined,
        status: (0, $131b3f6f00984c1a$export$102c3f975dbe36bd),
        value: undefined
    };
}
$c27b1d95780ff956$export$660cca5bd4d339e3.displayName = "useImperativeIntervalCacheValues";




var $k116o = parcelRequire("k116o");

function $098632d8bf7446bd$export$de363e709c412c8a(callback, throttleByAmount) {
    let lastCalledAt = -Infinity;
    let timeoutId = null;
    const throttled = (...args)=>{
        const elapsed = performance.now() - lastCalledAt;
        if (elapsed >= throttleByAmount) {
            lastCalledAt = performance.now();
            callback(...args);
        } else {
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(()=>{
                lastCalledAt = performance.now();
                callback(...args);
            }, throttleByAmount - elapsed);
        }
    };
    throttled.cancel = ()=>{
        if (timeoutId) clearTimeout(timeoutId);
    };
    return throttled;
}


function $11b66dd26bd4c709$export$7b254c479e244ce4(streamingValues, options = {}) {
    const { throttleUpdatesBy: throttleUpdatesBy = 150 } = options;
    const ref = (0, $k116o.useRef)({
        complete: false,
        data: undefined,
        error: undefined,
        progress: 0,
        status: (0, $131b3f6f00984c1a$export$102c3f975dbe36bd),
        value: undefined
    });
    const getValue = ()=>{
        const value = ref.current;
        if (value.complete !== streamingValues.complete || value.data !== streamingValues.data || value.progress !== streamingValues.progress || value.status !== streamingValues.status || value.value !== streamingValues.value) ref.current = {
            complete: streamingValues.complete,
            data: streamingValues.data,
            error: streamingValues.error,
            progress: streamingValues.progress,
            status: streamingValues.status,
            value: streamingValues.value
        };
        return ref.current;
    };
    const throttledSubscribe = (0, $k116o.useCallback)((callback)=>{
        const callbackWrapper = (0, $098632d8bf7446bd$export$de363e709c412c8a)(()=>{
            callback();
        }, throttleUpdatesBy);
        return streamingValues.subscribe(callbackWrapper);
    }, [
        streamingValues.subscribe
    ]);
    return (0, $k116o.useSyncExternalStore)(throttledSubscribe, getValue, getValue);
}
$11b66dd26bd4c709$export$7b254c479e244ce4.displayName = "useStreamingValue";





function $f3fb5004cf8ef5e6$export$f0e4809aa1287def(suspenseCache) {
    return function createInfallibleSuspenseCache(...params) {
        try {
            return suspenseCache(...params);
        } catch (errorOrPromiseLike) {
            if ((0, $2e69071d085c545a$export$ae936b9d47e5870e)(errorOrPromiseLike)) throw errorOrPromiseLike;
            else return undefined;
        }
    };
}





function $33c3e217cca5d477$export$ea1b43b85e3a4fd8(...callbacks) {
    const values = [];
    let thrownValue = null;
    callbacks.forEach((callback)=>{
        try {
            values.push(callback());
        } catch (error) {
            thrownValue = error;
        }
    });
    if (thrownValue !== null) throw thrownValue;
    return values;
}


class $ed6dec86e70e7b2b$export$f6415c0affcb0fbf {
    constructor(finalizerCallback){
        this.finalizerCallback = finalizerCallback;
        this.map = new Map();
        this.finalizationRegistry = new FinalizationRegistry((key)=>{
            this.map.delete(key);
            finalizerCallback(key);
        });
    }
    unregister(key) {
        const weakRef = this.map.get(key);
        if (weakRef) {
            const value = weakRef.deref();
            if (value != null) this.finalizationRegistry.unregister(value);
        }
    }
    delete(key) {
        const result = this.map.delete(key);
        this.unregister(key);
        return result;
    }
    get(key) {
        const weakRef = this.map.get(key);
        return weakRef ? weakRef.deref() : undefined;
    }
    has(key) {
        // Don't just use map.has(key) in case value has been GC'ed
        // and FinalizationRegistry callback has not yet run.
        const weakRef = this.map.get(key);
        return weakRef != null && weakRef.deref() != null;
    }
    set(key, value) {
        if (this.map.has(key)) {
            this.unregister(key);
            // FinalizationRegistry won't trigger if we unregister.
            this.finalizerCallback(key);
        }
        this.map.set(key, new WeakRef(value));
        if (value != null) this.finalizationRegistry.register(value, key, value);
        return this;
    }
    clear() {
        this.map.clear();
    }
}













const { readAsync: $bc8a2192c9b99919$export$ecd75350b0814c5b, read: $bc8a2192c9b99919$export$4ebdf975e29eb947 } = (0, $1e2a96dfa0b62734$export$cf6fa0bbcc94b912)({
    debugLabel: "ImportCache",
    load: async ([path])=>{
        switch(path){
            case "@codemirror/lang-css":
                return await (parcelRequire("f9x8D"));
            case "@codemirror/lang-html":
                return await (parcelRequire("6Gk4g"));
            case "@codemirror/lang-javascript":
                return await (parcelRequire("32IhZ"));
            case "@codemirror/lang-markdown":
                return await (parcelRequire("l2fOX"));
            default:
                throw Error(`Unknown path: ${path}`);
        }
    }
});


const $643e58fdd81a3bb8$export$e75f75ae6a127ac1 = 500000;
const $643e58fdd81a3bb8$export$656dc3249b75d6af = 5000;
const { readAsync: $643e58fdd81a3bb8$export$8ef8505207e9ad01, read: $643e58fdd81a3bb8$export$d98036f94aae2a34 } = (0, $1e2a96dfa0b62734$export$cf6fa0bbcc94b912)({
    debugLabel: "SyntaxParsingCache",
    getKey: ([code, language])=>`${code.length}-${language}`,
    load: async ([code, language])=>{
        const languageExtension = await $643e58fdd81a3bb8$var$getLanguageExtension(language);
        const parsedTokens = [];
        const currentLineState = {
            parsedTokens: [],
            rawString: ""
        };
        // The logic below to trim code sections only works with "\n"
        code = code.replace(/\r\n?|\n|\u2028|\u2029/g, "\n");
        if (code.length > $643e58fdd81a3bb8$export$e75f75ae6a127ac1) {
            let index = $643e58fdd81a3bb8$export$e75f75ae6a127ac1 - 1;
            while(index > 0 && code.charAt(index) !== "\n")index--;
            if (index === 0) while(index < code.length && code.charAt(index) !== "\n")index++;
            code = code.slice(0, index + 1);
        }
        const state = (0, $hB7kI.EditorState).create({
            doc: code,
            extensions: [
                languageExtension
            ]
        });
        const tree = (0, $1LbwH.ensureSyntaxTree)(state, $643e58fdd81a3bb8$export$e75f75ae6a127ac1, $643e58fdd81a3bb8$export$656dc3249b75d6af);
        if (tree === null) return [];
        let characterIndex = 0;
        let parsedCharacterIndex = 0;
        (0, $6yW7d.highlightTree)(tree, (0, $6yW7d.classHighlighter), (from, to, className)=>{
            if (from > characterIndex) // No style applied to the token between position and from.
            // This typically indicates white space or newline characters.
            $643e58fdd81a3bb8$var$processSection(currentLineState, parsedTokens, code.slice(characterIndex, from), "");
            $643e58fdd81a3bb8$var$processSection(currentLineState, parsedTokens, code.slice(from, to), className);
            characterIndex = to;
        });
        const maxPosition = code.length - 1;
        if (characterIndex < maxPosition) // No style applied on the trailing text.
        // This typically indicates white space or newline characters.
        $643e58fdd81a3bb8$var$processSection(currentLineState, parsedTokens, code.slice(characterIndex, maxPosition), "");
        if (currentLineState.parsedTokens.length) parsedTokens.push(currentLineState.parsedTokens);
        parsedCharacterIndex += characterIndex + 1;
        // Anything that's left should de-opt to plain text.
        if (parsedCharacterIndex < code.length) {
            let nextIndex = code.indexOf("\n", parsedCharacterIndex);
            let parsedLineTokens = [];
            while(true){
                const line = nextIndex >= 0 ? code.substring(parsedCharacterIndex, nextIndex) : code.substring(parsedCharacterIndex);
                parsedLineTokens.push({
                    columnIndex: 0,
                    type: null,
                    value: line
                });
                if (nextIndex >= 0) {
                    parsedTokens.push(parsedLineTokens);
                    parsedLineTokens = [];
                } else if (nextIndex === -1) break;
                parsedCharacterIndex = nextIndex + 1;
                nextIndex = code.indexOf("\n", parsedCharacterIndex);
            }
            if (parsedLineTokens.length) parsedTokens.push(parsedLineTokens);
        }
        return parsedTokens;
    }
});
function $643e58fdd81a3bb8$var$processSection(currentLineState, parsedTokens, section, className) {
    const tokenType = className?.substring(4) ?? null; // Remove "tok-" prefix;
    let index = 0;
    let nextIndex = section.indexOf("\n");
    while(true){
        const substring = nextIndex >= 0 ? section.substring(index, nextIndex) : section.substring(index);
        const token = {
            columnIndex: currentLineState.rawString.length,
            type: tokenType,
            value: substring
        };
        currentLineState.parsedTokens.push(token);
        currentLineState.rawString += substring;
        if (nextIndex === -1) break;
        if (nextIndex >= 0) {
            parsedTokens.push(currentLineState.parsedTokens);
            currentLineState.parsedTokens = [];
            currentLineState.rawString = "";
        }
        index = nextIndex + 1;
        nextIndex = section.indexOf("\n", index);
    }
}
function $643e58fdd81a3bb8$export$8f611fed3c043989(tokens) {
    return tokens.map((token)=>{
        const className = token.type ? `tok-${token.type}` : "";
        const escapedValue = $643e58fdd81a3bb8$export$2bf939f54de7f222(token.value);
        return `<span class="${className}">${escapedValue}</span>`;
    }).join("");
}
function $643e58fdd81a3bb8$export$2bf939f54de7f222(rawString) {
    return rawString.replace(/[\u00A0-\u9999<>\&]/g, (substring)=>"&#" + substring.charCodeAt(0) + ";");
}
async function $643e58fdd81a3bb8$var$getLanguageExtension(language) {
    switch(language){
        case "css":
            const { cssLanguage: cssLanguage } = await (0, $bc8a2192c9b99919$export$ecd75350b0814c5b)("@codemirror/lang-css");
            return cssLanguage.extension;
        case "html":
            const { htmlLanguage: htmlLanguage } = await (0, $bc8a2192c9b99919$export$ecd75350b0814c5b)("@codemirror/lang-html");
            return htmlLanguage.extension;
        case "javascript":
            const { javascriptLanguage: javascriptLanguage } = await (0, $bc8a2192c9b99919$export$ecd75350b0814c5b)("@codemirror/lang-javascript");
            return javascriptLanguage.extension;
        case "jsx":
            const { jsxLanguage: jsxLanguage } = await (0, $bc8a2192c9b99919$export$ecd75350b0814c5b)("@codemirror/lang-javascript");
            return jsxLanguage.extension;
        case "markdown":
            const { markdownLanguage: markdownLanguage } = await (0, $bc8a2192c9b99919$export$ecd75350b0814c5b)("@codemirror/lang-markdown");
            return markdownLanguage.extension;
        case "tsx":
            const { tsxLanguage: tsxLanguage } = await (0, $bc8a2192c9b99919$export$ecd75350b0814c5b)("@codemirror/lang-javascript");
            return tsxLanguage.extension;
        case "typescript":
            const { typescriptLanguage: typescriptLanguage } = await (0, $bc8a2192c9b99919$export$ecd75350b0814c5b)("@codemirror/lang-javascript");
            return typescriptLanguage.extension;
        default:
            throw Error(`Unsupported language: "${language}"`);
    }
}


var $5e669079b5dbe311$exports = {};

$parcel$export($5e669079b5dbe311$exports, "Code", () => $5e669079b5dbe311$export$52f0f02147b12c03, (v) => $5e669079b5dbe311$export$52f0f02147b12c03 = v);
$parcel$export($5e669079b5dbe311$exports, "LineNumber", () => $5e669079b5dbe311$export$d733a4bfd9217ad6, (v) => $5e669079b5dbe311$export$d733a4bfd9217ad6 = v);
var $5e669079b5dbe311$export$52f0f02147b12c03;
var $5e669079b5dbe311$export$d733a4bfd9217ad6;
$5e669079b5dbe311$export$52f0f02147b12c03 = `_4m7TbG_Code`;
$5e669079b5dbe311$export$d733a4bfd9217ad6 = `_4m7TbG_LineNumber`;


function $e68ad523dd2ddf2d$export$f6d32c6d49be0014({ className: className, code: code, showLineNumbers: showLineNumbers }) {
    const htmlLines = (0, $k116o.useMemo)(()=>{
        return code.split("\n").map((line, index)=>{
            const escaped = (0, $643e58fdd81a3bb8$export$2bf939f54de7f222)(line);
            if (showLineNumbers) return `<span class="${(0, (/*@__PURE__*/$parcel$interopDefault($5e669079b5dbe311$exports))).LineNumber}">${index + 1}</span> ${escaped}`;
            return escaped;
        });
    }, [
        showLineNumbers,
        code
    ]);
    const maxLineNumberLength = `${htmlLines.length + 1}`.length;
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
        className: [
            (0, (/*@__PURE__*/$parcel$interopDefault($5e669079b5dbe311$exports))).Code,
            className
        ].join(" "),
        dangerouslySetInnerHTML: {
            __html: htmlLines.join("<br/>")
        },
        style: {
            // @ts-ignore
            "--max-line-number-length": `${maxLineNumberLength}ch`
        }
    });
}




var $k116o = parcelRequire("k116o");


function $d3b452cc31d8ba37$export$f2635dc835274d7({ className: className, code: code, language: language, showLineNumbers: showLineNumbers }) {
    const tokens = (0, $643e58fdd81a3bb8$export$d98036f94aae2a34)(code, language);
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($d3b452cc31d8ba37$var$TokenRenderer, {
        className: className,
        tokens: tokens,
        showLineNumbers: showLineNumbers
    });
}
function $d3b452cc31d8ba37$var$TokenRenderer({ className: className, showLineNumbers: showLineNumbers, tokens: tokens }) {
    const maxLineNumberLength = `${tokens.length + 1}`.length;
    const html = (0, $k116o.useMemo)(()=>{
        return tokens.map((lineTokens, index)=>{
            const html = (0, $643e58fdd81a3bb8$export$8f611fed3c043989)(lineTokens);
            if (showLineNumbers) return `<span class="${(0, (/*@__PURE__*/$parcel$interopDefault($5e669079b5dbe311$exports))).LineNumber}">${index + 1}</span> ${html}`;
            return html;
        }).join("<br/>");
    }, [
        showLineNumbers,
        tokens
    ]);
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
        className: [
            (0, (/*@__PURE__*/$parcel$interopDefault($5e669079b5dbe311$exports))).Code,
            className
        ].join(" "),
        dangerouslySetInnerHTML: {
            __html: html
        },
        style: {
            // @ts-ignore
            "--max-line-number-length": `${maxLineNumberLength}ch`
        }
    });
}


function $b7652cd56eb7f50a$export$2e2bcd8739ae039({ className: className = "", code: code, language: language = "jsx", showLineNumbers: showLineNumbers = false }) {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $k116o.Suspense), {
        fallback: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $e68ad523dd2ddf2d$export$f6d32c6d49be0014), {
            className: className,
            code: code,
            showLineNumbers: showLineNumbers
        }),
        children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $d3b452cc31d8ba37$export$f2635dc835274d7), {
            className: className,
            code: code,
            language: language,
            showLineNumbers: showLineNumbers
        })
    });
}


parcelRequire("7SsmL");
var $e615f5d44a43b294$exports = {};
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4Jj9n = parcelRequire("4Jj9n");
"use strict";
function $e615f5d44a43b294$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $e615f5d44a43b294$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $e615f5d44a43b294$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $e615f5d44a43b294$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $4Jj9n.cwd();
                path = cwd;
            }
            $e615f5d44a43b294$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $e615f5d44a43b294$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $e615f5d44a43b294$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $e615f5d44a43b294$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $e615f5d44a43b294$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $e615f5d44a43b294$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $e615f5d44a43b294$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $e615f5d44a43b294$var$assertPath(from);
        $e615f5d44a43b294$var$assertPath(to);
        if (from === to) return "";
        from = $e615f5d44a43b294$var$posix.resolve(from);
        to = $e615f5d44a43b294$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $e615f5d44a43b294$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $e615f5d44a43b294$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $e615f5d44a43b294$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $e615f5d44a43b294$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $e615f5d44a43b294$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$e615f5d44a43b294$var$posix.posix = $e615f5d44a43b294$var$posix;
$e615f5d44a43b294$exports = $e615f5d44a43b294$var$posix;


function $58f88c7e2d2afb29$var$processExample(text) {
    let index = text.indexOf("// REMOVE_BEFORE");
    if (index >= 0) text = text.substring(index + 16);
    index = text.indexOf("// REMOVE_AFTER");
    if (index >= 0) text = text.substring(0, index);
    return text.trim();
}
const $58f88c7e2d2afb29$export$cf6fa0bbcc94b912 = {
    abort: $58f88c7e2d2afb29$var$processExample('import { userProfileCache } from "./cache";\n\nconst userId = "123";\n\n// REMOVE_BEFORE\nuserProfileCache.abort(userId);\n'),
    async: $58f88c7e2d2afb29$var$processExample('import { userProfileCache } from "./cache";\n\n// REMOVE_BEFORE\nasync function load(userId: string) {\n  const userProfile = await userProfileCache.readAsync(userId);\n\n  // ...\n}\n'),
    cache: $58f88c7e2d2afb29$var$processExample('import { createCache } from "suspense";\n\nexport const userProfileCache = createCache<[userId: string], JSON>({\n  load: async ([userId]) => {\n    const response = await fetch(`/api/user?id=${userId}`);\n    const json = await response.json();\n    return json;\n  },\n});\n'),
    cacheWithKey: $58f88c7e2d2afb29$var$processExample('import { createCache } from "suspense";\n\nclass ApiClient {\n  async loadData(id: string) {\n    return JSON.parse("");\n  }\n}\n\n// REMOVE_BEFORE\n\ncreateCache<[client: ApiClient, id: string], JSON>({\n  // The "client" parameter can\'t be serialized to a string\n  // The "id" parameter is unique, so it can be the key\n  getKey: ([client, id]) => id,\n\n  // In this example, data is loaded by a "client" object\n  load: async ([client, id]) => client.loadData(id),\n});\n'),
    cacheWithSignal: $58f88c7e2d2afb29$var$processExample('import { CacheLoadOptions, createCache } from "suspense";\n\n// REMOVE_BEFORE\n\ncreateCache<[userId: string], JSON>({\n  load: async ([userId], options: CacheLoadOptions) => {\n    // An AbortSignal is passed in as the final parameter with each request\n    const { signal } = options;\n\n    // The native fetch API supports AbortSignals\n    // All that\'s required to support cancellation is to forward the signal\n    const response = await fetch(`/api/user?id=${userId}`, {\n      signal,\n    });\n    const json = await response.json();\n    return json;\n  },\n});\n'),
    cacheWithLRU: $58f88c7e2d2afb29$var$processExample('import { createCache, Record } from "suspense";\n\nconst load = async () => null as any;\n\n// REMOVE_BEFORE\n\nimport LRUCache from "lru-cache";\n\ncreateCache<[userId: string], JSON>({\n  config: {\n    getCache: (onEvict) =>\n      new LRUCache<string, Record<JSON>>({\n        max: 100,\n        dispose: (value, key, reason) => {\n          if (reason === "evict") {\n            onEvict(key);\n          }\n        },\n      }),\n  },\n  load,\n  // ...\n});\n'),
    cacheWithWeakRefMap: $58f88c7e2d2afb29$var$processExample('import { createCache } from "suspense";\n\nconst load = async () => null as any;\n\n// REMOVE_BEFORE\n\nimport { WeakRefMap } from "suspense";\n\ncreateCache<[userId: string], JSON>({\n  config: {\n    getCache: (onEvict) => new WeakRefMap(onEvict),\n  },\n  load,\n  // ...\n});\n'),
    evict: $58f88c7e2d2afb29$var$processExample('import { userProfileCache } from "./cache";\n\n// REMOVE_BEFORE\nconst userId = "123";\n\nuserProfileCache.evict(userId);\n'),
    hook: $58f88c7e2d2afb29$var$processExample('import { userProfileCache } from "./cache";\n\n// REMOVE_BEFORE\nimport { useCacheStatus } from "suspense";\n\nfunction StatusBadge({ userId }: { userId: string }) {\n  const status = useCacheStatus(userProfileCache, userId);\n\n  switch (status) {\n    case "not-found":\n      // ...\n      break;\n    case "pending":\n      // ...\n      break;\n    case "resolved":\n      // ...\n      break;\n    case "rejected":\n      // ...\n      break;\n  }\n}\n'),
    immutable: $58f88c7e2d2afb29$var$processExample('import { createCache } from "suspense";\n\nexport const sourceCodeCache = createCache<[path: string], JSON>({\n  config: {\n    // Signals that this cache will never be mutated\n    immutable: true,\n  },\n  load: async ([path]) => {\n    const response = await fetch(`/api/source?path=${path}`);\n    const json = await response.json();\n    return json;\n  },\n});\n'),
    prefetch: $58f88c7e2d2afb29$var$processExample('import { userProfileCache } from "./cache";\n\nfunction getQueryParam(key: string): string {\n  return "dummy";\n}\n\n// REMOVE_BEFORE\nconst userId = getQueryParam("userId");\n\n// Start loading user data eagerly, while route renders.\nuserProfileCache.prefetch(userId);\n\nfunction UserProfileRoute() {\n  // ...\n}\n'),
    suspense: $58f88c7e2d2afb29$var$processExample('import { userProfileCache } from "./cache";\n\n// REMOVE_BEFORE\nfunction UserProfile({ userId }: { userId: string }) {\n  const userProfile = userProfileCache.read(userId);\n\n  // ...\n}\n'),
    sync: $58f88c7e2d2afb29$var$processExample('import { userProfileCache } from "./cache";\n\nconst userId = "fake";\n// REMOVE_BEFORE\n// Returns a cached value if one has already been saved in the cache\nconst userProfileOrUndefined = userProfileCache.getValueIfCached(userId);\n\n// Returns a cached value or throws if none has been loaded\nconst userProfile = userProfileCache.getValue(userId);\n')
};
const $58f88c7e2d2afb29$export$e673efccd97e4223 = {
    control: $58f88c7e2d2afb29$var$processExample('import { createDeferred } from "suspense";\n\nconst deferred = createDeferred<string>();\n\n// REMOVE_BEFORE\n// It can be (sync/async) resolved with a value:\ndeferred.resolve("Example value");\n\n// Or it can be rejected with an error:\ndeferred.reject("Something went wrong");\n'),
    create: $58f88c7e2d2afb29$var$processExample('import { createDeferred } from "suspense";\n\nconst deferred = createDeferred<string>();\n'),
    observe: $58f88c7e2d2afb29$var$processExample('import { createDeferred } from "suspense";\n\nconst deferred = createDeferred<string>();\n\n// REMOVE_BEFORE\ndeferred.promise.then(\n  function onFulfill(value: string) {\n    // ..\n  },\n  function onReject(error: Error) {\n    // ...\n  }\n);\n')
};
const $58f88c7e2d2afb29$export$1b3de7f46ad5e501 = {
    cacheError: $58f88c7e2d2afb29$var$processExample('import { managedCache } from "./createCache";\n\n// REMOVE_BEFORE\n\nconst error = Error("Could not load JSON with id:example");\n\nmanagedCache.cacheError(error, "example");\n'),
    cacheValue: $58f88c7e2d2afb29$var$processExample('import { managedCache } from "./createCache";\n\nconst json = {} as JSON;\n\n// REMOVE_BEFORE\n\nmanagedCache.cacheValue(json, "example");\n'),
    createCache: $58f88c7e2d2afb29$var$processExample('import { createExternallyManagedCache } from "suspense";\n\nconst managedCache = createExternallyManagedCache<[id: string], JSON>({\n  getKey: ([id]) => id,\n});\n\n// REMOVE_AFTER\n\nexport { managedCache };\n')
};
const $58f88c7e2d2afb29$export$6f7e956a8ae0712d = {
    cache: $58f88c7e2d2afb29$var$processExample('type Token = any;\n\n// REMOVE_BEFORE\n\nimport { createIntervalCache } from "suspense";\n\ninterface Line {\n  index: number;\n  parsedText: Token[];\n  rawText: string;\n}\n\nconst sourceCodeCache = createIntervalCache<number, [fileName: string], Line>({\n  // Load lines within the specified start/end interval\n  // Note the first two params passed to function are the start/end points\n  load: async (start: number, end: number, fileName: string) => {\n    const response = await fetch(\n      `/api/parse-code?file=${fileName}&startLine=${start}&stopLine=${end}`\n    );\n    const json = await response.json();\n    return json;\n  },\n\n  // Determine where a value falls within a interval\n  // The cache uses this to merged and sort loaded values\n  // The "point" is the line number in this example\n  getPointForValue: (value: Line): number => {\n    return value.index;\n  },\n});\n\n// REMOVE_AFTER\n\nexport { sourceCodeCache };\n'),
    cacheWithPartialResults: $58f88c7e2d2afb29$var$processExample('type Token = any;\n\ninterface Result {}\n\nconst getPointForValue = () => 1;\n\n// REMOVE_BEFORE\n\nimport { IntervalCacheLoadOptions, createIntervalCache } from "suspense";\n\nconst searchResultsCache = createIntervalCache<number, [], Result>({\n  load: async (\n    startTimestamp: number,\n    endTimestamp: number,\n    options: IntervalCacheLoadOptions<Result>\n  ) => {\n    const response = await fetch(\n      `/api/search?start=${startTimestamp}&end=${endTimestamp}`\n    );\n\n    const json = await response.json();\n    if (json.hasMore) {\n      // Notify the cache that this value only contains partial results\n      // by calling the returnAsPartial() method.\n      return options.returnAsPartial(json.results);\n    } else {\n      return json.results;\n    }\n  },\n  getPointForValue,\n});\n\n// REMOVE_AFTER\n\nexport { searchResultsCache };\n'),
    callingAbort: $58f88c7e2d2afb29$var$processExample('import { sourceCodeCache } from "./cache";\n\nconst fileName = "";\n\n// REMOVE_BEFORE\n\nsourceCodeCache.abort(fileName);\n'),
    detectingPartialResults: $58f88c7e2d2afb29$var$processExample('import { searchResultsCache } from "./cacheWithPartialResults";\n\n// REMOVE_BEFORE\n\nconst results = searchResultsCache.read(1672531200000, 1673136000000);\nconst showPartialResultsUI = searchResultsCache.isPartialResult(results);\n'),
    evict: $58f88c7e2d2afb29$var$processExample('import { sourceCodeCache } from "./cache";\n\nconst fileName = "";\n\n// REMOVE_BEFORE\n\n// Evict all loaded lines for a specific file\nsourceCodeCache.evict(fileName);\n\n// Evict all loaded lines for ever file\nsourceCodeCache.evictAll();\n'),
    hook: $58f88c7e2d2afb29$var$processExample('import { sourceCodeCache } from "./cache";\n\n// REMOVE_BEFORE\n\nimport { useIntervalCacheStatus } from "suspense";\n\nfunction StatusBadge({\n  fileName,\n  lineEnd,\n  lineStart,\n}: {\n  fileName: string;\n  lineEnd: number;\n  lineStart: number;\n}) {\n  const status = useIntervalCacheStatus(\n    sourceCodeCache,\n    lineStart,\n    lineEnd,\n    fileName\n  );\n\n  switch (status) {\n    case "not-found":\n      // ...\n      break;\n    case "pending":\n      // ...\n      break;\n    case "resolved":\n      // ...\n      break;\n    case "rejected":\n      // ...\n      break;\n  }\n}\n'),
    loadWithAbortSignal: $58f88c7e2d2afb29$var$processExample('type Token = any;\n\ninterface Line {\n  index: number;\n}\n\nconst getPointForValue = (value: Line) => value.index;\n\n// REMOVE_BEFORE\n\nimport { CacheLoadOptions, createIntervalCache } from "suspense";\n\ncreateIntervalCache<number, [fileName: string], Line>({\n  load: async (\n    start: number,\n    end: number,\n    fileName: string,\n    options: CacheLoadOptions\n  ) => {\n    // An AbortSignal is passed in as the final parameter with each request\n    const { signal } = options;\n\n    // The native fetch API supports AbortSignals\n    // All that\'s required to support cancellation is to forward the signal\n    const response = await fetch(\n      `/api/parse-code?file=${fileName}&startLine=${start}&stopLine=${end}`,\n      { signal }\n    );\n    const json = await response.json();\n    return json;\n  },\n\n  getPointForValue,\n});\n')
};
const $58f88c7e2d2afb29$export$22a2a694ba0c34d3 = {
    cache: $58f88c7e2d2afb29$var$processExample('import { createSingleEntryCache } from "suspense";\n\nconst articlesCache = createSingleEntryCache<[], JSON>({\n  load: async () => {\n    const response = await fetch(`/api/articles/?sort=DESC&limit=10`);\n    const json = await response.json();\n    return json;\n  },\n});\n'),
    cacheWithParameters: $58f88c7e2d2afb29$var$processExample('import { createSingleEntryCache } from "suspense";\n\nclass ApiClient {\n  async getRecentArticles() {\n    return JSON.parse("");\n  }\n}\n\n// REMOVE_BEFORE\n\ncreateSingleEntryCache<[ApiClient], JSON>({\n  load: async ([apiClient]) => apiClient.getRecentArticles(),\n});\n')
};
const $58f88c7e2d2afb29$export$ea911cd21ad60992 = {
    abort: $58f88c7e2d2afb29$var$processExample('import { userCommentsCache } from "./cache";\n\nconst userId = "123";\n\n// REMOVE_BEFORE\nuserCommentsCache.abort(userId);\n'),
    cache: $58f88c7e2d2afb29$var$processExample('type Comment = any;\ntype Message = any;\n\n// REMOVE_BEFORE\nimport { createStreamingCache, StreamingCacheLoadOptions } from "suspense";\n\nconst socket = new WebSocket("...");\n\nexport const userCommentsCache = createStreamingCache<\n  [userId: string],\n  Comment[]\n>({\n  // Stream data for params\n  load: async (\n    options: StreamingCacheLoadOptions<Comment[]>,\n    userId: string\n  ) => {\n    const { reject, update, resolve } = options;\n\n    let comments: Comment[] = [];\n    let countTotal = 0;\n\n    socket.onerror = (error) => {\n      // If loading fails, notify the cache\n      reject(error);\n    };\n\n    socket.onmessage = (event) => {\n      const data = JSON.parse(event.data) as Message;\n      if (data.requestType === "fetchComments" && data.userId === userId) {\n        switch (data.responseType) {\n          case "initialize":\n            // Some caches can calculate progress (but this is optional)\n            countTotal = data.count as number;\n            break;\n          case "update":\n            comments.splice(comments.length, 0, ...data.comments);\n\n            const countLoaded = comments.length;\n\n            // When new data streams in, notify the cache\n            update(data.comments, countLoaded / countTotal);\n            break;\n          case "complete":\n            // Once loading has finished, notify the cache\n            resolve();\n            break;\n        }\n      }\n    };\n    socket.send(\n      JSON.stringify({\n        type: "fetchComments",\n        userId,\n      })\n    );\n  },\n});\n'),
    cacheWithKey: $58f88c7e2d2afb29$var$processExample('import { createStreamingCache, StreamingCacheLoadOptions } from "suspense";\n\nclass ApiClient {\n  async fetchComments(\n    id: string,\n    onData: (data: string[]) => void,\n    onComplete: () => void\n  ) {\n    return JSON.parse("");\n  }\n}\n\ntype Comment = any;\n\n// REMOVE_BEFORE\n\ncreateStreamingCache<[client: ApiClient, id: string], Comment>({\n  // The "client" parameter can\'t be serialized to a string\n  // The "id" parameter is unique, so it can be the key\n  getKey: (client: ApiClient, id: string) => id,\n\n  // In this example, comments are fetched using a "client" object\n  load: async (\n    options: StreamingCacheLoadOptions<Comment>,\n    client: ApiClient,\n    id: string\n  ) => {\n    const { resolve, update } = options;\n\n    return client.fetchComments(\n      id,\n      (comments: Comment[]) => update(comments),\n      () => resolve()\n    );\n  },\n});\n'),
    cacheWithSignal: $58f88c7e2d2afb29$var$processExample('import { createStreamingCache, StreamingCacheLoadOptions } from "suspense";\n\ntype Comment = any;\n\n// REMOVE_BEFORE\n\ncreateStreamingCache<[userId: string], Comment>({\n  load: async (options: StreamingCacheLoadOptions<Comment>, userId: string) => {\n    // An AbortSignal is included in the options parameter with each request\n    const { signal } = options;\n\n    signal.onabort = () => {\n      // Abort the in-progress request here.\n      // How to do this depends on how the data is loaded.\n    };\n\n    // ...\n  },\n});\n'),
    evict: $58f88c7e2d2afb29$var$processExample('import { userCommentsCache } from "./cache";\n\n// REMOVE_BEFORE\nconst userId = "123";\n\nuserCommentsCache.evict(userId);\n'),
    hook: $58f88c7e2d2afb29$var$processExample('import { userCommentsCache } from "./cache";\n// REMOVE_BEFORE\nimport { useStreamingValue } from "suspense";\n\nfunction ReactComponent({ path }: { path: string }) {\n  const stream = userCommentsCache.stream(path);\n\n  // Uses useSyncExternalStore to subscribe to changes\n  const { complete, progress, status, value } = useStreamingValue(stream);\n\n  // ...\n}\n'),
    prefetch: $58f88c7e2d2afb29$var$processExample('import { userCommentsCache } from "./cache";\n\n// REMOVE_BEFORE\nconst path = "example";\nuserCommentsCache.prefetch(path);\n')
};
const $58f88c7e2d2afb29$export$9d0a8ca9f3291d1c = {
    global: $58f88c7e2d2afb29$var$processExample('import { disableDebugLogging, enableDebugLogging } from "suspense";\n\n// Turns debug logging on for all caches\nenableDebugLogging();\n\n// Turns debug logging off for all caches\ndisableDebugLogging();\n'),
    perCache: $58f88c7e2d2afb29$var$processExample('const load: any = null;\n\n// REMOVE_BEFORE\n\nimport { createCache } from "suspense";\n\n// Cache can be configured during initialization\nconst cache = createCache({\n  debugLogging: true,\n  load,\n});\n\n// They can also be turned on/off later\ncache.disableDebugLogging();\ncache.enableDebugLogging();\n')
};
const $58f88c7e2d2afb29$export$7eb1b49cd2af1357 = {
    abortRequest: {
        abort: $58f88c7e2d2afb29$var$processExample('const cache = { abort: (key: string) => {} };\n\nconst key = "123";\n\n// REMOVE_BEFORE\ncache.abort(key);\n')
    },
    mutatingCacheValue: {
        addItem: $58f88c7e2d2afb29$var$processExample('import {\n  ForwardedRef,\n  forwardRef,\n  KeyboardEvent,\n  MutableRefObject,\n  useRef,\n} from "react";\n\nimport Icon from "../../../components/Icon";\nimport { ApiClient, itemsCache } from "./index";\nimport styles from "./style.module.css";\n\nconst Input = forwardRef(\n  (\n    {\n      disabled,\n      onEnter,\n      placeholder,\n    }: {\n      disabled: boolean;\n      onEnter: () => void;\n      placeholder: string;\n    },\n    ref: ForwardedRef<HTMLInputElement>\n  ) => {\n    const onClick = () => {\n      (ref as MutableRefObject<HTMLInputElement>).current.focus();\n    };\n\n    const onKeyDown = (event: KeyboardEvent) => {\n      switch (event.key) {\n        case "Enter":\n          onEnter();\n          break;\n      }\n    };\n\n    return (\n      <div\n        className={styles.InputRow}\n        data-disabled={disabled || undefined}\n        onClick={onClick}\n      >\n        <Icon type="edit" />\n        <input\n          className={styles.Input}\n          disabled={disabled}\n          onKeyDown={onKeyDown}\n          placeholder={placeholder}\n          ref={ref}\n        />\n      </div>\n    );\n  }\n);\n\n// REMOVE_BEFORE\n\nimport { useCacheMutation } from "suspense";\n\nfunction AddItem({ apiClient }: { apiClient: ApiClient }) {\n  const inputRef = useRef<HTMLInputElement>(null);\n\n  // Pass the cache we want to mutate to the mutation hook\n  const { isPending, mutateAsync } = useCacheMutation(itemsCache);\n\n  const addItem = async () => {\n    const input = inputRef.current!;\n    if (input.value) {\n      mutateAsync([apiClient], async () => {\n        // Add the new item to the remote list (async)\n        const newItems = await apiClient.addItem({\n          body: input.value,\n          complete: false,\n        });\n\n        // Clear the input field once the new item has been added\n        inputRef.current!.value = "";\n\n        // Pre-seed the cache with the updated list of items\n        return newItems;\n      });\n    }\n  };\n\n  // Disable form inputs while a mutation is pending\n  return (\n    <Input\n      disabled={isPending}\n      onEnter={addItem}\n      placeholder="What needs to be done?"\n      ref={inputRef}\n    />\n  );\n}\n\n// REMOVE_AFTER\n\nexport { AddItem };\n')
    },
    renderingCacheStatus: {
        UserStatusBadge: $58f88c7e2d2afb29$var$processExample('import { userProfileCache } from "./index";\nimport Icon, { IconType } from "../../../components/Icon";\n\n// REMOVE_BEFORE\n\nimport { useCacheStatus } from "suspense";\n\nfunction UserStatusBadge({ id }: { id: number }) {\n  const status = useCacheStatus(userProfileCache, id);\n\n  let type: IconType;\n  switch (status) {\n    case "not-found":\n      type = "status-not-found";\n      break;\n    case "pending":\n      type = "status-pending";\n      break;\n    case "resolved":\n      type = "status-resolved";\n      break;\n    default:\n      return null;\n  }\n\n  return <Icon type={type} />;\n}\n\n// REMOVE_AFTER\n\nexport { UserStatusBadge };\n')
    },
    streamingCache: {
        Posts: $58f88c7e2d2afb29$var$processExample('import { Metadata, Post, ProgressBar, Rows, User } from "./index";\n\n// REMOVE_BEFORE\n\nimport { StreamingValue, useStreamingValue } from "suspense";\n\nfunction Posts({\n  stream,\n  users,\n}: {\n  stream: StreamingValue<Post[], Metadata>;\n  users: User[];\n}) {\n  // * progress is a number (0-1) indicating the loading percentage\n  // * values is an array of posts\n  // * data contains extra metadata provided by the cache;\n  //   in this case that data includes the total number of posts\n  const { data, progress = 0, value = [] } = useStreamingValue(stream);\n\n  return (\n    <>\n      <ProgressBar progress={progress} />\n      <Rows postCount={data?.postCount ?? 0} posts={value} users={users} />\n    </>\n  );\n}\n\n// REMOVE_AFTER\n\nexport { Posts };\n')
    }
};
const $58f88c7e2d2afb29$export$ae936b9d47e5870e = {
    util: $58f88c7e2d2afb29$var$processExample('const commentsCache = {\n  fetchUserCommentsSuspense: (userId: string): any[] => [],\n};\n\nconst userId = "123";\n\n// REMOVE_BEFORE\nimport { isPromiseLike } from "suspense";\n\nfunction UserComments({ userId }: { userId: string }) {\n  let comments: string[];\n  try {\n    // Try to load comments using Suspense\n    comments = commentsCache.fetchUserCommentsSuspense(userId);\n  } catch (errorOrPromiseLike) {\n    if (isPromiseLike(errorOrPromiseLike)) {\n      // Re-throw thenables so that Suspense works\n      throw errorOrPromiseLike;\n    } else {\n      // Ignore other types of errors though\n      comments = [];\n    }\n  }\n\n  // ...\n}\n')
};
const $58f88c7e2d2afb29$export$51b6c95406a498ed = {
    assertRecordStatus: $58f88c7e2d2afb29$var$processExample('import { createResolvedRecord } from "suspense";\n\nconst record = createResolvedRecord(1);\n\n// REMOVE_BEFORE\n\nimport {\n  assertPendingRecord,\n  assertRejectedRecord,\n  assertResolvedRecord,\n} from "suspense";\n\nassertPendingRecord<number>(record); // record is PendingRecord<Type>\nassertRejectedRecord(record); // record is RejectedRecord<Type>\nassertResolvedRecord<number>(record); // record is ResolvedRecord<Type>\n'),
    createPendingRecord: $58f88c7e2d2afb29$var$processExample('import { createDeferred, createPendingRecord } from "suspense";\n\nconst abortController = new AbortController();\nconst deferred = createDeferred<number>();\n\ncreatePendingRecord(deferred, abortController);\n'),
    createPendingRecordData: $58f88c7e2d2afb29$var$processExample('import { createDeferred, createPendingRecordData } from "suspense";\n\nconst abortController = new AbortController();\nconst deferred = createDeferred<number>();\n\nconst data = createPendingRecordData(deferred, abortController);\n'),
    createRejectedRecord: $58f88c7e2d2afb29$var$processExample('import { createRejectedRecord } from "suspense";\n\ncreateRejectedRecord(new Error("This is an example"));\n'),
    createRejectedRecordData: $58f88c7e2d2afb29$var$processExample('import { createRejectedRecordData } from "suspense";\n\nconst data = createRejectedRecordData(new Error("This is an example"));\n'),
    createResolvedRecord: $58f88c7e2d2afb29$var$processExample('import { createResolvedRecord } from "suspense";\n\ncreateResolvedRecord("some value");\n'),
    createResolvedRecordData: $58f88c7e2d2afb29$var$processExample('import { createResolvedRecordData } from "suspense";\n\nconst data = createResolvedRecordData("some value");\n'),
    isRecordStatus: $58f88c7e2d2afb29$var$processExample('import { createResolvedRecord } from "suspense";\n\nconst record = createResolvedRecord(1);\n\n// REMOVE_BEFORE\n\nimport { isRejectedRecord, isPendingRecord, isResolvedRecord } from "suspense";\n\nif (isPendingRecord(record)) {\n  // ...\n} else if (isRejectedRecord(record)) {\n  // ...\n} else if (isResolvedRecord(record)) {\n  // ...\n}\n'),
    updateRecordToPending: $58f88c7e2d2afb29$var$processExample('import { createPendingRecord } from "suspense";\n\nconst record = createPendingRecord();\n\n// REMOVE_BEFORE\n\nimport { createDeferred, updateRecordToPending } from "suspense";\n\nconst abortController = new AbortController();\nconst deferred = createDeferred<number>();\n\nupdateRecordToPending(record, deferred, abortController);\n'),
    updateRecordToRejected: $58f88c7e2d2afb29$var$processExample('import { createPendingRecord } from "suspense";\n\nconst record = createPendingRecord();\n\n// REMOVE_BEFORE\n\nimport { updateRecordToRejected } from "suspense";\n\nupdateRecordToRejected(record, new Error("Something went wrong"));\n'),
    updateRecordToResolved: $58f88c7e2d2afb29$var$processExample('import { createPendingRecord } from "suspense";\n\nconst record = createPendingRecord();\n\n// REMOVE_BEFORE\n\nimport { updateRecordToResolved } from "suspense";\n\nupdateRecordToResolved(record, "some loaded value");\n')
};
const $58f88c7e2d2afb29$export$29dc6b9369528985 = {
    async: $58f88c7e2d2afb29$var$processExample('import { userCache, User } from "./shared";\n\nimport { useCacheMutation } from "suspense";\n\nconst apiClient = {\n  updateUserName: async (id: string, name: string) => {\n    return { id } as User;\n  },\n};\n\nconst userId = "1";\n\n// REMOVE_BEFORE\n\nconst { isPending, mutateAsync } = useCacheMutation(userCache);\n\nconst onClick = () => {\n  // The mutate method requires the same params as the read method\n  // so that it can identify which record is being mutated\n  // In this example, that means the user id\n  mutateAsync([userId], async () => {\n    const updatedUser = await apiClient.updateUserName(userId, "New name");\n\n    // This value will be added to the cache\n    return updatedUser;\n  });\n};\n\n// isPending can be used to disable form inputs while saving the new name\n'),
    hook: $58f88c7e2d2afb29$var$processExample('import { userCache } from "./shared";\n\n// REMOVE_BEFORE\n\nimport { useCacheMutation } from "suspense";\n\nfunction Example() {\n  const api = useCacheMutation(userCache);\n\n  // ...\n}\n'),
    sync: $58f88c7e2d2afb29$var$processExample('import { userCache, User } from "./shared";\n\nimport { RefObject } from "react";\nimport { useCacheMutation } from "suspense";\n\nconst userId = "1";\n\nconst inputRef: RefObject<HTMLInputElement> = null as any;\n\n// REMOVE_BEFORE\n\nconst { mutateSync } = useCacheMutation(userCache);\n\nconst onClick = () => {\n  const newName = inputRef.current!.value;\n\n  mutateSync([userId], {\n    id: userId,\n    name: newName,\n  });\n};\n')
};
const $58f88c7e2d2afb29$export$a5ec0cdf75e7b1ce = {
    hook: $58f88c7e2d2afb29$var$processExample('import { userProfileCache } from "../createCache/cache";\n\n// REMOVE_BEFORE\n\nimport {\n  STATUS_PENDING,\n  STATUS_REJECTED,\n  STATUS_RESOLVED,\n  useImperativeCacheValue,\n} from "suspense";\n\nfunction Example({ userId }: { userId: string }) {\n  const { error, status, value } = useImperativeCacheValue(\n    userProfileCache,\n    userId\n  );\n\n  switch (status) {\n    case STATUS_PENDING:\n    // Rending loading UI ...\n    case STATUS_REJECTED:\n    // Render "error" ...\n    case STATUS_RESOLVED:\n    // Render "value" ...\n  }\n}\n')
};
const $58f88c7e2d2afb29$export$660cca5bd4d339e3 = {
    hook: $58f88c7e2d2afb29$var$processExample('import { sourceCodeCache } from "../createIntervalCache/cache";\n\nconst lineStart = 0;\nconst lineEnd = 0;\nconst fileName = "";\n\n// REMOVE_BEFORE\n\nimport {\n  STATUS_PENDING,\n  STATUS_REJECTED,\n  STATUS_RESOLVED,\n  useImperativeIntervalCacheValues,\n} from "suspense";\n\nfunction Example({ userId }: { userId: string }) {\n  const { error, status, value } = useImperativeIntervalCacheValues(\n    sourceCodeCache,\n    lineStart,\n    lineEnd,\n    fileName\n  );\n\n  switch (status) {\n    case STATUS_PENDING:\n    // Rending loading UI ...\n    case STATUS_REJECTED:\n    // Render "error" ...\n    case STATUS_RESOLVED:\n    // Render "value" ...\n  }\n}\n')
};






function $7ec290908b96eb45$export$b2bf131c9f9cce5d({ children: children, className: className = "", to: to }) {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("a", {
        className: className,
        href: to,
        rel: "noopener noreferrer",
        target: "_blank",
        children: children
    });
}


var $3672f95247819ec1$exports = {};

$parcel$export($3672f95247819ec1$exports, "Icon", () => $3672f95247819ec1$export$f04a61298a47a40f, (v) => $3672f95247819ec1$export$f04a61298a47a40f = v);
$parcel$export($3672f95247819ec1$exports, "Label", () => $3672f95247819ec1$export$b04be29aa201d4f5, (v) => $3672f95247819ec1$export$b04be29aa201d4f5 = v);
$parcel$export($3672f95247819ec1$exports, "Link", () => $3672f95247819ec1$export$a6c7ac8248d6e38a, (v) => $3672f95247819ec1$export$a6c7ac8248d6e38a = v);
var $3672f95247819ec1$export$f04a61298a47a40f;
var $3672f95247819ec1$export$b04be29aa201d4f5;
var $3672f95247819ec1$export$a6c7ac8248d6e38a;
$3672f95247819ec1$export$f04a61298a47a40f = `IqvVoW_Icon`;
$3672f95247819ec1$export$b04be29aa201d4f5 = `IqvVoW_Label`;
$3672f95247819ec1$export$a6c7ac8248d6e38a = `IqvVoW_Link`;



var $fda21b9d9d56d3ae$exports = {};

$parcel$export($fda21b9d9d56d3ae$exports, "Icon", () => $fda21b9d9d56d3ae$export$f04a61298a47a40f, (v) => $fda21b9d9d56d3ae$export$f04a61298a47a40f = v);
var $fda21b9d9d56d3ae$export$f04a61298a47a40f;
$fda21b9d9d56d3ae$export$f04a61298a47a40f = `_2lY6ZG_Icon`;


function $db8e31d0e9379e8d$export$2e2bcd8739ae039({ className: className = "", type: type }) {
    let path = "";
    switch(type){
        case "complete":
            path = "M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z";
            break;
        case "delete":
            path = "M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M9,8H11V17H9V8M13,8H15V17H13V8Z";
            break;
        case "edit":
            path = "M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z";
            break;
        case "github":
            path = "M12,2A10,10 0 0,0 2,12C2,16.42 4.87,20.17 8.84,21.5C9.34,21.58 9.5,21.27 9.5,21C9.5,20.77 9.5,20.14 9.5,19.31C6.73,19.91 6.14,17.97 6.14,17.97C5.68,16.81 5.03,16.5 5.03,16.5C4.12,15.88 5.1,15.9 5.1,15.9C6.1,15.97 6.63,16.93 6.63,16.93C7.5,18.45 8.97,18 9.54,17.76C9.63,17.11 9.89,16.67 10.17,16.42C7.95,16.17 5.62,15.31 5.62,11.5C5.62,10.39 6,9.5 6.65,8.79C6.55,8.54 6.2,7.5 6.75,6.15C6.75,6.15 7.59,5.88 9.5,7.17C10.29,6.95 11.15,6.84 12,6.84C12.85,6.84 13.71,6.95 14.5,7.17C16.41,5.88 17.25,6.15 17.25,6.15C17.8,7.5 17.45,8.54 17.35,8.79C18,9.5 18.38,10.39 18.38,11.5C18.38,15.32 16.04,16.16 13.81,16.41C14.17,16.72 14.5,17.33 14.5,18.26C14.5,19.6 14.5,20.68 14.5,21C14.5,21.27 14.66,21.59 15.17,21.5C19.14,20.16 22,16.42 22,12A10,10 0 0,0 12,2Z";
            break;
        case "incomplete":
            path = "M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z";
            break;
        case "loading":
            path = "M13,2.03V2.05L13,4.05C17.39,4.59 20.5,8.58 19.96,12.97C19.5,16.61 16.64,19.5 13,19.93V21.93C18.5,21.38 22.5,16.5 21.95,11C21.5,6.25 17.73,2.5 13,2.03M11,2.06C9.05,2.25 7.19,3 5.67,4.26L7.1,5.74C8.22,4.84 9.57,4.26 11,4.06V2.06M4.26,5.67C3,7.19 2.25,9.04 2.05,11H4.05C4.24,9.58 4.8,8.23 5.69,7.1L4.26,5.67M2.06,13C2.26,14.96 3.03,16.81 4.27,18.33L5.69,16.9C4.81,15.77 4.24,14.42 4.06,13H2.06M7.1,18.37L5.67,19.74C7.18,21 9.04,21.79 11,22V20C9.58,19.82 8.23,19.25 7.1,18.37M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z";
            break;
        case "note":
            path = "M12,6A6,6 0 0,1 18,12C18,14.22 16.79,16.16 15,17.2V19A1,1 0 0,1 14,20H10A1,1 0 0,1 9,19V17.2C7.21,16.16 6,14.22 6,12A6,6 0 0,1 12,6M14,21V22A1,1 0 0,1 13,23H11A1,1 0 0,1 10,22V21H14M20,11H23V13H20V11M1,11H4V13H1V11M13,1V4H11V1H13M4.92,3.5L7.05,5.64L5.63,7.05L3.5,4.93L4.92,3.5M16.95,5.63L19.07,3.5L20.5,4.93L18.37,7.05L16.95,5.63Z";
            break;
        case "quote":
            path = "M10,7L8,11H11V17H5V11L7,7H10M18,7L16,11H19V17H13V11L15,7H18Z";
            break;
        case "saving":
            path = "M13,2.03V2.05L13,4.05C17.39,4.59 20.5,8.58 19.96,12.97C19.5,16.61 16.64,19.5 13,19.93V21.93C18.5,21.38 22.5,16.5 21.95,11C21.5,6.25 17.73,2.5 13,2.03M11,2.06C9.05,2.25 7.19,3 5.67,4.26L7.1,5.74C8.22,4.84 9.57,4.26 11,4.06V2.06M4.26,5.67C3,7.19 2.25,9.04 2.05,11H4.05C4.24,9.58 4.8,8.23 5.69,7.1L4.26,5.67M2.06,13C2.26,14.96 3.03,16.81 4.27,18.33L5.69,16.9C4.81,15.77 4.24,14.42 4.06,13H2.06M7.1,18.37L5.67,19.74C7.18,21 9.04,21.79 11,22V20C9.58,19.82 8.23,19.25 7.1,18.37M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z";
            break;
        case "status-not-found":
            path = "M17,13H7V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z";
            break;
        case "status-pending":
            path = "M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M16.24,7.76C15.07,6.58 13.53,6 12,6V12L7.76,16.24C10.1,18.58 13.9,18.58 16.24,16.24C18.59,13.9 18.59,10.1 16.24,7.76Z";
            break;
        case "status-resolved":
            path = "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z";
            break;
        case "warn":
            path = "M20 17H22V15H20V17M20 7V13H22V7M4 2C2.89 2 2 2.89 2 4V20C2 21.11 2.89 22 4 22H16C17.11 22 18 21.11 18 20V8L12 2M11 3.5L16.5 9H11Z";
            break;
    }
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("svg", {
        className: [
            className,
            (0, (/*@__PURE__*/$parcel$interopDefault($fda21b9d9d56d3ae$exports))).Icon
        ].join(" "),
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("path", {
            fill: "currentColor",
            d: path
        })
    });
}


function $732095c59660ffdd$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $7ec290908b96eb45$export$b2bf131c9f9cce5d), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($3672f95247819ec1$exports))).Link,
        to: "https://github.com/bvaughn/suspense/",
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3672f95247819ec1$exports))).Label,
                children: "Suspense"
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $db8e31d0e9379e8d$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3672f95247819ec1$exports))).Icon,
                type: "github"
            })
        ]
    });
}


var $007b871297a7bfc2$exports = {};

$parcel$export($007b871297a7bfc2$exports, "Arrow", () => $007b871297a7bfc2$export$21b07c8f274aebd5, (v) => $007b871297a7bfc2$export$21b07c8f274aebd5 = v);
$parcel$export($007b871297a7bfc2$exports, "Header", () => $007b871297a7bfc2$export$8b251419efc915eb, (v) => $007b871297a7bfc2$export$8b251419efc915eb = v);
$parcel$export($007b871297a7bfc2$exports, "HomeLink", () => $007b871297a7bfc2$export$8e6b12661156fe2f, (v) => $007b871297a7bfc2$export$8e6b12661156fe2f = v);
$parcel$export($007b871297a7bfc2$exports, "Nav", () => $007b871297a7bfc2$export$39140c7d8b0ba7b3, (v) => $007b871297a7bfc2$export$39140c7d8b0ba7b3 = v);
$parcel$export($007b871297a7bfc2$exports, "Title", () => $007b871297a7bfc2$export$f99233281efd08a0, (v) => $007b871297a7bfc2$export$f99233281efd08a0 = v);
var $007b871297a7bfc2$export$21b07c8f274aebd5;
var $007b871297a7bfc2$export$8b251419efc915eb;
var $007b871297a7bfc2$export$8e6b12661156fe2f;
var $007b871297a7bfc2$export$39140c7d8b0ba7b3;
var $007b871297a7bfc2$export$f99233281efd08a0;
$007b871297a7bfc2$export$21b07c8f274aebd5 = `dKKula_Arrow`;
$007b871297a7bfc2$export$8b251419efc915eb = `dKKula_Header`;
$007b871297a7bfc2$export$8e6b12661156fe2f = `dKKula_HomeLink`;
$007b871297a7bfc2$export$39140c7d8b0ba7b3 = `dKKula_Nav`;
$007b871297a7bfc2$export$f99233281efd08a0 = `dKKula_Title`;


function $4b3065620e983e4c$export$2e2bcd8739ae039({ title: title }) {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($007b871297a7bfc2$exports))).Header,
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($007b871297a7bfc2$exports))).Nav,
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b061e8b516dc3a67$export$a6c7ac8248d6e38a), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($007b871297a7bfc2$exports))).HomeLink,
                        to: "/",
                        children: "Home"
                    }),
                    title && /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $110956e5e1cd1426$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($007b871297a7bfc2$exports))).Arrow,
                                children: "/"
                            }),
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($007b871297a7bfc2$exports))).Title,
                                children: title
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $732095c59660ffdd$export$2e2bcd8739ae039), {})
        ]
    });
}



var $5fb00f56294ab7d8$exports = {};

$parcel$export($5fb00f56294ab7d8$exports, "SubHeading", () => $5fb00f56294ab7d8$export$210dc657affc8afd, (v) => $5fb00f56294ab7d8$export$210dc657affc8afd = v);
var $5fb00f56294ab7d8$export$210dc657affc8afd;
$5fb00f56294ab7d8$export$210dc657affc8afd = `CIidyq_SubHeading`;


function $fcca5122c6dc254a$export$2e2bcd8739ae039({ level: level = 1, title: title }) {
    const id = title.toLowerCase().replace(/\s/g, "-");
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("h2", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5fb00f56294ab7d8$exports))).SubHeading,
        "data-level": level,
        id: id,
        children: title
    });
}






var $3051616f4178b0b0$exports = {};

$parcel$export($3051616f4178b0b0$exports, "Content", () => $3051616f4178b0b0$export$7c6e2c02157bb7d2, (v) => $3051616f4178b0b0$export$7c6e2c02157bb7d2 = v);
$parcel$export($3051616f4178b0b0$exports, "Header", () => $3051616f4178b0b0$export$8b251419efc915eb, (v) => $3051616f4178b0b0$export$8b251419efc915eb = v);
$parcel$export($3051616f4178b0b0$exports, "Icon", () => $3051616f4178b0b0$export$f04a61298a47a40f, (v) => $3051616f4178b0b0$export$f04a61298a47a40f = v);
$parcel$export($3051616f4178b0b0$exports, "Note", () => $3051616f4178b0b0$export$6c88bf799aca3d2b, (v) => $3051616f4178b0b0$export$6c88bf799aca3d2b = v);
var $3051616f4178b0b0$export$7c6e2c02157bb7d2;
var $3051616f4178b0b0$export$8b251419efc915eb;
var $3051616f4178b0b0$export$f04a61298a47a40f;
var $3051616f4178b0b0$export$6c88bf799aca3d2b;
$3051616f4178b0b0$export$7c6e2c02157bb7d2 = `rbfKnq_Content`;
$3051616f4178b0b0$export$8b251419efc915eb = `rbfKnq_Header`;
$3051616f4178b0b0$export$f04a61298a47a40f = `rbfKnq_Icon`;
$3051616f4178b0b0$export$6c88bf799aca3d2b = `rbfKnq_Note`;


function $b466a4c2331ccdd9$export$2e2bcd8739ae039({ children: children, title: title = "Note", type: type = "note" }) {
    let iconType;
    switch(type){
        case "note":
            iconType = "note";
            break;
        case "quote":
            iconType = "quote";
            break;
        case "warn":
            iconType = "warn";
            break;
    }
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($3051616f4178b0b0$exports))).Note,
        "data-type": type,
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3051616f4178b0b0$exports))).Header,
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $db8e31d0e9379e8d$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3051616f4178b0b0$exports))).Icon,
                        type: iconType
                    }),
                    title
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3051616f4178b0b0$exports))).Content,
                children: children
            })
        ]
    });
}



function $5c0e60e4690bae0b$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $aa6eba4c47b97eb7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $4b3065620e983e4c$export$2e2bcd8739ae039), {
                    title: "createCache"
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Creating a cache"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "For the purposes of this library– a ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("strong", {
                                children: "cache"
                            }),
                            " is a key-value store that can be lazily loaded by a React component while it is rendering. (This is done using an experimental React feature known as",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $7ec290908b96eb45$export$b2bf131c9f9cce5d), {
                                to: "https://beta.reactjs.org/blog/2022/03/29/react-v18#suspense-in-data-frameworks",
                                children: "suspense"
                            }),
                            ".)"
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: "Implementing one of these caches typically only requires a single method (to load the data). For example, a cache that loads user data from a (JSON) API might look like this:"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$cf6fa0bbcc94b912).cache
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: "If one of the cache key parameters can't be stringified, a second method should also be provided to compute a unique key."
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$cf6fa0bbcc94b912).cacheWithKey
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Use the",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $7ec290908b96eb45$export$b2bf131c9f9cce5d), {
                                    to: "https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal",
                                    children: "AbortSignal"
                                })
                            }),
                            " ",
                            "that's provided to support cancellation."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$cf6fa0bbcc94b912).cacheWithSignal
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                            children: [
                                "Caches use ",
                                /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                    children: "WeakRef"
                                }),
                                " and",
                                " ",
                                /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                    children: "FinalizationRegistry"
                                }),
                                " by default,",
                                " ",
                                /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b061e8b516dc3a67$export$a6c7ac8248d6e38a), {
                                    to: (0, $d87e1b304aec4d6d$export$a5c1c7acf17ea32a),
                                    children: "but this is configurable"
                                }),
                                "."
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Using a cache with suspense"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: 'Caches can be used within a React component to fetch data. If the data has already been loaded, it will be returned synchronously. Otherwise the component will "suspend" while the data is fetched.'
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$cf6fa0bbcc94b912).suspense
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                            children: [
                                "Caches currently suspend by throwing",
                                " ",
                                /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b061e8b516dc3a67$export$a6c7ac8248d6e38a), {
                                    to: (0, $d87e1b304aec4d6d$export$1237172d87df4b0f),
                                    children: '"thenables"'
                                }),
                                ". This may change as the",
                                " ",
                                /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $7ec290908b96eb45$export$b2bf131c9f9cce5d), {
                                    to: "https://github.com/reactjs/rfcs/pull/229",
                                    children: "React API"
                                }),
                                " ",
                                "changes."
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Other ways to use a cache"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: "For convenience, caches can also be used within async methods."
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$cf6fa0bbcc94b912).async
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: "Data loaded this way will be stored in such a way as to be shared with data loaded via suspense."
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: "Although not commonly needed, data can even be loaded synchronously from the cache."
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$cf6fa0bbcc94b912).sync
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Pre-fetching a cache"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "When possible, it's best to pre-fetch data to avoid",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $7ec290908b96eb45$export$b2bf131c9f9cce5d), {
                                to: "https://beta.reactjs.org/blog/2022/03/29/react-v18#suspense-in-data-frameworks",
                                children: '"waterfalls"'
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$cf6fa0bbcc94b912).prefetch
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Evicting stale values"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: "Stale values can be evicted from a cache."
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$cf6fa0bbcc94b912).evict
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Caches can also be configured to",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b061e8b516dc3a67$export$a6c7ac8248d6e38a), {
                                to: (0, $d87e1b304aec4d6d$export$a5c1c7acf17ea32a),
                                children: "automatically evict stale values"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                            children: [
                                "Evicting cache values does not currently schedule an update with React. Use the",
                                " ",
                                /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                    children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b061e8b516dc3a67$export$a6c7ac8248d6e38a), {
                                        to: (0, $d87e1b304aec4d6d$export$a7f6f2cd4cc90607),
                                        children: "useCacheMutation"
                                    })
                                }),
                                " ",
                                "hook if an update is required."
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Aborting a request"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: "In-progress requests can be cancelled."
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$cf6fa0bbcc94b912).abort
                    }),
                    " ",
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                        children: "Requests can be aborted where side effects are permitted (e.g. event handlers, effect cleanup functions)."
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                            children: [
                                "A cache must use the ",
                                /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                    children: "AbortSignal"
                                }),
                                " parameter to support cancellation."
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Observing status"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "A value's ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("em", {
                                children: "status"
                            }),
                            ' ("not-found", "pending", "resolved", or "rejected") can be queried as well using ',
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "cache.getStatus"
                            }),
                            "– although the recommended way to subscribe to this value is using the",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b061e8b516dc3a67$export$a6c7ac8248d6e38a), {
                                    to: (0, $d87e1b304aec4d6d$export$4eb9f97e3e3a1e88),
                                    children: "useCacheStatus"
                                })
                            }),
                            " ",
                            "hook:"
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$cf6fa0bbcc94b912).hook
                    })
                ]
            })
        ]
    });
}









function $97b24782e8f29b8c$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $aa6eba4c47b97eb7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $4b3065620e983e4c$export$2e2bcd8739ae039), {
                    title: "createDeferred"
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                type: "warn",
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                    children: [
                        "Although this package exports the ",
                        /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                            children: "createDeferred"
                        }),
                        " API, you probably won't need to use it directly in most cases."
                    ]
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: "Deferred objects are a lower level concept that the caches in this package are built on top of."
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$e673efccd97e4223).create
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: "Like promises, deferred objects can be observed:"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$e673efccd97e4223).observe
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Unlike promises, deferred objects can also be resolved or rejected",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("em", {
                                children: "by external code"
                            }),
                            " (e.g. by a cache):"
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$e673efccd97e4223).control
                    })
                ]
            })
        ]
    });
}











function $41550aba7a770505$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $aa6eba4c47b97eb7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $4b3065620e983e4c$export$2e2bcd8739ae039), {
                    title: "createExternallyManagedCache"
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Convenience wrapper around",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b061e8b516dc3a67$export$a6c7ac8248d6e38a), {
                                    to: (0, $d87e1b304aec4d6d$export$c6e57d4df408c13c),
                                    children: "createCache"
                                })
                            }),
                            " ",
                            "for caches that are externally managed."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$1b3de7f46ad5e501).createCache
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Store values in an externally managed cache with the",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "cacheValue"
                            }),
                            " method."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$1b3de7f46ad5e501).cacheValue
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Store errors in an externally managed cache with the",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "cacheError"
                            }),
                            " method."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$1b3de7f46ad5e501).cacheError
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                type: "warn",
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $110956e5e1cd1426$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                            children: "An externally managed cache is one that does not load its own data."
                        }),
                        /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                            children: "Data must be explicitly written by external code."
                        })
                    ]
                })
            })
        ]
    });
}











function $20901ab293a05bd1$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $aa6eba4c47b97eb7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $4b3065620e983e4c$export$2e2bcd8739ae039), {
                    title: "createIntervalCache"
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            'An "interval cache" is a specialized cache that incrementally loads and merges sets of values over time. Values are loaded for "intervals" which are a range of either numbers (or',
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $7ec290908b96eb45$export$b2bf131c9f9cce5d), {
                                    to: "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt",
                                    children: "BigInts"
                                })
                            }),
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "An example of an interval cache can be found in",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $7ec290908b96eb45$export$b2bf131c9f9cce5d), {
                                to: "https://replay.io",
                                children: "Replay.io"
                            }),
                            ' which fetches console logs for the region of a recording a user has "focused" on. If the user changes the focused region, additional logs may need to be fetched. As logs are fetched, they are merged into the larger data set to avoid re-fetching data when possible.'
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Creating an interval cache"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Unlike a regular cache, multiple methods are required to configure an interval cache. At a minimum– one to load values (",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "load"
                            }),
                            ") and one to specify where values fall within an interval (",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "getPointForValue"
                            }),
                            ")."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: "For example, a cache could incrementally load syntax–highlighted source code for a range of lines."
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$6f7e956a8ae0712d).cache
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Aborting requests"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Interval cache supports cancellation the same way as other caches– by passing an",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $7ec290908b96eb45$export$b2bf131c9f9cce5d), {
                                    to: "https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal",
                                    children: "AbortSignal"
                                })
                            }),
                            " ",
                            "to the custom ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "load"
                            }),
                            " method."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$6f7e956a8ae0712d).loadWithAbortSignal
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Requests can be cancelled from the outside using the",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "abort"
                            }),
                            " method."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$6f7e956a8ae0712d).callingAbort
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                            children: [
                                "Aborting an interval requests cancels",
                                " ",
                                /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("strong", {
                                    children: "all pending requests"
                                }),
                                " for that set of parameters. It is not possible to abort a specific interval."
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Evicting values"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Values can be evicted from an interval cache using the",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "evict"
                            }),
                            " and ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "evictAll"
                            }),
                            " methods."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$6f7e956a8ae0712d).evict
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                            children: [
                                "Evicting values from an interval cache will evict",
                                " ",
                                /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("strong", {
                                    children: "all loaded values"
                                }),
                                " for that set of parameters. It is not possible to evict a specific interval."
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Partial results"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "If data cannot be fully fetched for a given intervals, the value returned can be flagged as ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("em", {
                                children: "partial results"
                            }),
                            " as shown below."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$6f7e956a8ae0712d).cacheWithPartialResults
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "The ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "isPartialResult"
                            }),
                            " method can be used to check if a value only contains partial results."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$6f7e956a8ae0712d).detectingPartialResults
                    })
                ]
            })
        ]
    });
}










function $6ab3d0c82f1bacb0$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $aa6eba4c47b97eb7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $4b3065620e983e4c$export$2e2bcd8739ae039), {
                    title: "createSingleEntryCache"
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Convenience wrapper around",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b061e8b516dc3a67$export$a6c7ac8248d6e38a), {
                                    to: (0, $d87e1b304aec4d6d$export$c6e57d4df408c13c),
                                    children: "createCache"
                                })
                            }),
                            " ",
                            "for caches that only contain a single value."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$22a2a694ba0c34d3).cache
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: "This type of cache can still accept parameters, although they won't be used to store the cached value."
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$22a2a694ba0c34d3).cacheWithParameters
                    })
                ]
            })
        ]
    });
}













function $4f58786280d7494d$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $aa6eba4c47b97eb7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $4b3065620e983e4c$export$2e2bcd8739ae039), {
                    title: "createStreamingCache"
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Creating a streaming cache"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            'A "streaming cache" fits a different use case than a normal cache. Rather than ',
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("em", {
                                children: "suspending"
                            }),
                            " until a value has been fully loaded, it provides a subscription interface that can be used to re-render as data incrementally loads."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Like a regular cache, implementing a streaming cache typically only requires a single method– to stream the data using an API like a",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "WebSocket"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$ea911cd21ad60992).cache
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: "A second method can be provided to compute the cache key if one of the parameters can't be stringified."
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$ea911cd21ad60992).cacheWithKey
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Use the",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $7ec290908b96eb45$export$b2bf131c9f9cce5d), {
                                    to: "https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal",
                                    children: "AbortSignal"
                                })
                            }),
                            " ",
                            "that's provided to support cancellation."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$ea911cd21ad60992).cacheWithSignal
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Using a streaming cache"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "The easiest way to use a streaming cache is with the",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b061e8b516dc3a67$export$a6c7ac8248d6e38a), {
                                    to: (0, $d87e1b304aec4d6d$export$ab0a2769ad209342),
                                    children: "useStreamingValue"
                                })
                            }),
                            " ",
                            "hook."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$ea911cd21ad60992).hook
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Pre-fetching values"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: "Like a normal cache, streaming values can be pre-fetched."
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$ea911cd21ad60992).prefetch
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Evicting stale values"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: "Stale values can be evicted from a cache."
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$ea911cd21ad60992).evict
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                        children: "Evicting cache values does not currently schedule an update with React."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Aborting a request"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: "In-progress requests can be cancelled."
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$ea911cd21ad60992).abort
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                        children: "Requests can be aborted where side effects are permitted (e.g. event handlers, effect cleanup functions)."
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                            children: [
                                "A cache must use the ",
                                /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                    children: "AbortSignal"
                                }),
                                " parameter to support cancellation."
                            ]
                        })
                    })
                ]
            })
        ]
    });
}










var $6e457da17b83f5e9$exports = {};

$parcel$export($6e457da17b83f5e9$exports, "Code", () => $6e457da17b83f5e9$export$52f0f02147b12c03, (v) => $6e457da17b83f5e9$export$52f0f02147b12c03 = v);
$parcel$export($6e457da17b83f5e9$exports, "Link", () => $6e457da17b83f5e9$export$a6c7ac8248d6e38a, (v) => $6e457da17b83f5e9$export$a6c7ac8248d6e38a = v);
$parcel$export($6e457da17b83f5e9$exports, "ListItem", () => $6e457da17b83f5e9$export$a7b06bfba60a8a78, (v) => $6e457da17b83f5e9$export$a7b06bfba60a8a78 = v);
var $6e457da17b83f5e9$export$52f0f02147b12c03;
var $6e457da17b83f5e9$export$a6c7ac8248d6e38a;
var $6e457da17b83f5e9$export$a7b06bfba60a8a78;
$6e457da17b83f5e9$export$52f0f02147b12c03 = `y3RI_a_Code`;
$6e457da17b83f5e9$export$a6c7ac8248d6e38a = `y3RI_a_Link`;
$6e457da17b83f5e9$export$a7b06bfba60a8a78 = `y3RI_a_ListItem`;



function $dcd1f696b57a5202$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $aa6eba4c47b97eb7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $732095c59660ffdd$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "APIs to simplify data loading and caching, for use with",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $7ec290908b96eb45$export$b2bf131c9f9cce5d), {
                                to: "https://beta.reactjs.org/blog/2022/03/29/react-v18#suspense-in-data-frameworks",
                                children: "React Suspense"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "This library exposes techniques used in apps like the",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $7ec290908b96eb45$export$b2bf131c9f9cce5d), {
                                to: "https://github.com/facebook/react/tree/main/packages/react-devtools-shared",
                                children: "React DevTools extension"
                            }),
                            " ",
                            "and ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $7ec290908b96eb45$export$b2bf131c9f9cce5d), {
                                to: "https://www.replay.io/",
                                children: "Replay.io"
                            }),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                type: "warn",
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                    children: [
                        "Suspense is an ",
                        /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("strong", {
                            children: "experimental pre-release feature"
                        }),
                        "; these APIs may change."
                    ]
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Installation"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($dcd1f696b57a5202$var$InstallationPanel, {})
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "APIs"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        level: 2,
                        title: "Caches"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($dcd1f696b57a5202$var$LinkListItem, {
                                children: "createCache",
                                to: (0, $d87e1b304aec4d6d$export$c6e57d4df408c13c),
                                type: "code"
                            }),
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($dcd1f696b57a5202$var$LinkListItem, {
                                children: "createExternallyManagedCache",
                                to: (0, $d87e1b304aec4d6d$export$b0030bce8559349f),
                                type: "code"
                            }),
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($dcd1f696b57a5202$var$LinkListItem, {
                                children: "createIntervalCache",
                                to: (0, $d87e1b304aec4d6d$export$4eda7113e54677aa),
                                type: "code"
                            }),
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($dcd1f696b57a5202$var$LinkListItem, {
                                children: "createSingleEntryCache",
                                to: (0, $d87e1b304aec4d6d$export$ced0558925123210),
                                type: "code"
                            }),
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($dcd1f696b57a5202$var$LinkListItem, {
                                children: "createStreamingCache",
                                to: (0, $d87e1b304aec4d6d$export$1d56bcf14907e007),
                                type: "code"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        level: 2,
                        title: "Hooks"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($dcd1f696b57a5202$var$LinkListItem, {
                                children: "useCacheMutation",
                                to: (0, $d87e1b304aec4d6d$export$a7f6f2cd4cc90607),
                                type: "code"
                            }),
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($dcd1f696b57a5202$var$LinkListItem, {
                                children: "useCacheStatus",
                                to: (0, $d87e1b304aec4d6d$export$4eb9f97e3e3a1e88),
                                type: "code"
                            }),
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($dcd1f696b57a5202$var$LinkListItem, {
                                children: "useIntervalCacheStatus",
                                to: (0, $d87e1b304aec4d6d$export$6c09fcd90d770bc4),
                                type: "code"
                            }),
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($dcd1f696b57a5202$var$LinkListItem, {
                                children: "useImperativeCacheValue",
                                to: (0, $d87e1b304aec4d6d$export$a9a6e7732aaecca6),
                                type: "code"
                            }),
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($dcd1f696b57a5202$var$LinkListItem, {
                                children: "useImperativeIntervalCacheValues",
                                to: (0, $d87e1b304aec4d6d$export$e1b81feb0c103c86),
                                type: "code"
                            }),
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($dcd1f696b57a5202$var$LinkListItem, {
                                children: "useStreamingValue",
                                to: (0, $d87e1b304aec4d6d$export$ab0a2769ad209342),
                                type: "code"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        level: 2,
                        title: "Low-level API"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($dcd1f696b57a5202$var$LinkListItem, {
                                children: "createDeferred",
                                to: (0, $d87e1b304aec4d6d$export$80fdcb5a3142d1bd),
                                type: "code"
                            }),
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($dcd1f696b57a5202$var$LinkListItem, {
                                children: "isPromiseLike",
                                to: (0, $d87e1b304aec4d6d$export$1237172d87df4b0f),
                                type: "code"
                            }),
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($dcd1f696b57a5202$var$LinkListItem, {
                                children: "Record",
                                to: (0, $d87e1b304aec4d6d$export$630373a46fa30388),
                                type: "code"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Guides"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($dcd1f696b57a5202$var$LinkListItem, {
                                children: "Memory management",
                                to: (0, $d87e1b304aec4d6d$export$a5c1c7acf17ea32a),
                                type: "plaintext"
                            }),
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($dcd1f696b57a5202$var$LinkListItem, {
                                children: "Aborting a request",
                                to: (0, $d87e1b304aec4d6d$export$a1a38004ba5076cd),
                                type: "plaintext"
                            }),
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($dcd1f696b57a5202$var$LinkListItem, {
                                children: "Mutating cache values",
                                to: (0, $d87e1b304aec4d6d$export$5c5abf861764150e),
                                type: "plaintext"
                            }),
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($dcd1f696b57a5202$var$LinkListItem, {
                                children: "Creating a streaming cache",
                                to: (0, $d87e1b304aec4d6d$export$866f2572af03bc6),
                                type: "plaintext"
                            }),
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($dcd1f696b57a5202$var$LinkListItem, {
                                children: "Rendering cache status",
                                to: (0, $d87e1b304aec4d6d$export$f240987ac561f7ec),
                                type: "plaintext"
                            }),
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($dcd1f696b57a5202$var$LinkListItem, {
                                children: "Optimizing immutable caches",
                                to: (0, $d87e1b304aec4d6d$export$f17b62024bc7b6e0),
                                type: "plaintext"
                            }),
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($dcd1f696b57a5202$var$LinkListItem, {
                                children: "Debugging slow requests",
                                to: (0, $d87e1b304aec4d6d$export$9ccf183b65eb2452),
                                type: "plaintext"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $dcd1f696b57a5202$var$LinkListItem({ children: children, to: to, type: type }) {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6e457da17b83f5e9$exports))).ListItem,
        "data-type": type,
        children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b061e8b516dc3a67$export$a6c7ac8248d6e38a), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($6e457da17b83f5e9$exports))).Link,
            to: to,
            children: children
        })
    });
}
function $dcd1f696b57a5202$var$InstallationPanel() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("code", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6e457da17b83f5e9$exports))).Code,
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("span", {
                className: "tok-comment",
                children: "# npm"
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("span", {
                className: "tok-operator",
                children: "npm install "
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("span", {
                className: "tok-variableName",
                children: "suspense"
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("span", {
                className: "tok-comment",
                children: "# yarn"
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("span", {
                className: "tok-operator",
                children: "yarn add "
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("span", {
                className: "tok-variableName",
                children: "suspense"
            })
        ]
    });
}











function $cd252a7e342f7bc2$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $aa6eba4c47b97eb7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $4b3065620e983e4c$export$2e2bcd8739ae039), {
                    title: "isPromiseLike"
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                type: "warn",
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                    children: [
                        "Although this package exports the ",
                        /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                            children: "isPromiseLike"
                        }),
                        " API, you probably won't need to use it directly in most cases."
                    ]
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            'Things that are "promise like" (also sometimes called "thenables") are a lower level concept that the caches in this package are built on top of. To quote',
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $7ec290908b96eb45$export$b2bf131c9f9cce5d), {
                                to: "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise#thenables",
                                children: "the MDM docs"
                            }),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                        title: "Thenables",
                        type: "quote",
                        children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                            children: [
                                'A "thenable" implements the ',
                                /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                    children: ".then()"
                                }),
                                " method, which is called with two callbacks: one for when the promise is fulfilled, one for when it's rejected. Promises are thenables as well."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "isPromiseLike"
                            }),
                            ' can be used to determine if a value is a "thenable" or not.'
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Loading optional values"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: "You can use this utility method to ignore failures for a particular Suspense cache without also swallowing other types of errors."
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$ae936b9d47e5870e).util
                    })
                ]
            })
        ]
    });
}







function $d9450d3e371047b2$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $aa6eba4c47b97eb7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $4b3065620e983e4c$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "404 – Page not found"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: "Sorry. We couldn't find that page."
                    })
                ]
            })
        ]
    });
}










function $54d97e78c3eeeff5$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $aa6eba4c47b97eb7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $4b3065620e983e4c$export$2e2bcd8739ae039), {
                    title: "Record utils"
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: "Records are a lower level concept that the caches in this package are built on top of."
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                        type: "warn",
                        children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                            children: "These APIs are probably not useful unless you are building your own cache."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Record utils"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Typically a cache request will flow from ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("em", {
                                children: "pending"
                            }),
                            " to",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("em", {
                                children: "resolved"
                            }),
                            " (or ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("em", {
                                children: "rejected"
                            }),
                            "). This process is modeled by the ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "Record"
                            }),
                            " object. These objects are typically created once, stored in a map, and then mutated as the request progresses. The following methods can be used to create the initial record object."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "The most common type of record to create this way is a",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("em", {
                                children: "pending"
                            }),
                            " record. This is useful for when a new value is first requested."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$51b6c95406a498ed).createPendingRecord
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "If external code is caching a value, a record can be created in",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("em", {
                                children: "resolved"
                            }),
                            " state."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$51b6c95406a498ed).createResolvedRecord
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "A record can also be created in ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("em", {
                                children: "rejected"
                            }),
                            " state."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$51b6c95406a498ed).createRejectedRecord
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: "When a request transitions, a cache can update/mutate the record using one of the methods below."
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "It's uncommon for a record to transition back to ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("em", {
                                children: "pending"
                            }),
                            " ",
                            "status, but can happen (e.g. if a weakly held value has been garbage collected since it was last requested)."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$51b6c95406a498ed).updateRecordToPending
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Once data has been loaded, a pending record can be transitioned to",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("em", {
                                children: "resolved"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$51b6c95406a498ed).updateRecordToResolved
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "If something goes wrong, a pending record can be transitioned to",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("em", {
                                children: "rejected"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$51b6c95406a498ed).updateRecordToRejected
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Record status utils"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: "Convenience methods are provided to check if a record is in a specific state:"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$51b6c95406a498ed).isRecordStatus
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: "TypeScript assertion methods are also provided for the above:"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$51b6c95406a498ed).assertRecordStatus
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "RecordData utils"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "If you choose ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("em", {
                                children: "not"
                            }),
                            " to build your cache on top of the",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "Record"
                            }),
                            " structure, you may still find the internal data format useful. The following utilities can be used to create that structure."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$51b6c95406a498ed).createPendingRecordData
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$51b6c95406a498ed).createResolvedRecordData
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$51b6c95406a498ed).createRejectedRecordData
                    })
                ]
            })
        ]
    });
}













function $a5cb92a7e4623dcf$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $aa6eba4c47b97eb7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $4b3065620e983e4c$export$2e2bcd8739ae039), {
                    title: "useCacheMutation"
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Mutating a cache"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "The recommended way to mutate cache values is with the",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "useCacheMutation"
                            }),
                            " hook."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$29dc6b9369528985).hook
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                        type: "warn",
                        children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                            children: [
                                "Mutation requires unreleased React APIs currently only available in the",
                                " ",
                                /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $7ec290908b96eb45$export$b2bf131c9f9cce5d), {
                                    to: "https://reactjs.org/docs/release-channels.html#experimental-channel",
                                    children: '"experimental" channel'
                                }),
                                " ",
                                "(",
                                /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                    children: "react@experimental"
                                }),
                                " and",
                                " ",
                                /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                    children: "react-dom@experimental"
                                }),
                                ")."
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Async mutations"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Use ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "mutateAsync"
                            }),
                            " when an async operation is required (e.g. an API request)."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$29dc6b9369528985).async
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Sync mutations"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Use ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "mutateSync"
                            }),
                            " when a mutation can be done synchronously (or for optimistic updates)."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$29dc6b9369528985).sync
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                            children: [
                                "The",
                                " ",
                                /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b061e8b516dc3a67$export$a6c7ac8248d6e38a), {
                                    to: (0, $d87e1b304aec4d6d$export$5c5abf861764150e),
                                    children: '"mutating external data" guide'
                                }),
                                " ",
                                "shows an end-to-end mutation demo"
                            ]
                        })
                    }),
                    " "
                ]
            })
        ]
    });
}











function $5e91cb1880ea5837$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $aa6eba4c47b97eb7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $4b3065620e983e4c$export$2e2bcd8739ae039), {
                    title: "useCacheStatus"
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Observing status"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Subscribe to the ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("em", {
                                children: "status"
                            }),
                            " of a",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b061e8b516dc3a67$export$a6c7ac8248d6e38a), {
                                to: (0, $d87e1b304aec4d6d$export$c6e57d4df408c13c),
                                children: "cache"
                            }),
                            ' ("not-found", "pending", "resolved", or "rejected") using the ',
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "useCacheStatus"
                            }),
                            " hook:"
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$cf6fa0bbcc94b912).hook
                    })
                ]
            })
        ]
    });
}










function $a7ac143a014924e0$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $aa6eba4c47b97eb7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $4b3065620e983e4c$export$2e2bcd8739ae039), {
                    title: "useImperativeCacheValue"
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Loading data without Suspense"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Data can be fetched without suspending using the",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "useImperativeCacheValue"
                            }),
                            " hook. (This hook uses the imperative ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "readAsync"
                            }),
                            " API, called from an effect.)"
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$a5ec0cdf75e7b1ce).hook
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                type: "warn",
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                    children: [
                        "Components that use this hook",
                        " ",
                        /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("strong", {
                            children: "may mount before data has loaded"
                        }),
                        "."
                    ]
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                type: "warn",
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                    children: [
                        "This hook exists as an escape hatch. When possible, values should be loaded using the ",
                        /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                            children: "read"
                        }),
                        " API."
                    ]
                })
            })
        ]
    });
}










function $65a223e13908066b$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $aa6eba4c47b97eb7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $4b3065620e983e4c$export$2e2bcd8739ae039), {
                    title: "useImperativeIntervalCacheValues"
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Loading interval data without Suspense"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Data can be fetched without suspending using the",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "useImperativeIntervalCacheValues"
                            }),
                            " hook. (This hook uses the imperative ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "readAsync"
                            }),
                            " API, called from an effect.)"
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$660cca5bd4d339e3).hook
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                type: "warn",
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                    children: [
                        "Components that use this hook",
                        " ",
                        /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("strong", {
                            children: "may mount before data has loaded"
                        }),
                        "."
                    ]
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                type: "warn",
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                    children: [
                        "This hook exists as an escape hatch. When possible, values should be loaded using the ",
                        /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                            children: "read"
                        }),
                        " API."
                    ]
                })
            })
        ]
    });
}











function $8849c1eda432779d$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $aa6eba4c47b97eb7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $4b3065620e983e4c$export$2e2bcd8739ae039), {
                    title: "useIntervalCacheStatus"
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Observing status"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Subscribe to the ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("em", {
                                children: "status"
                            }),
                            " of an",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b061e8b516dc3a67$export$a6c7ac8248d6e38a), {
                                to: (0, $d87e1b304aec4d6d$export$4eda7113e54677aa),
                                children: "interval cache"
                            }),
                            ' ("not-found", "pending", "resolved", or "rejected") using the',
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "useIntervalCacheStatus"
                            }),
                            " hook:"
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$6f7e956a8ae0712d).hook
                    })
                ]
            })
        ]
    });
}










function $d31c17f93376807e$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $aa6eba4c47b97eb7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $4b3065620e983e4c$export$2e2bcd8739ae039), {
                    title: "useStreamingValue"
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "The easiest way to use a",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b061e8b516dc3a67$export$a6c7ac8248d6e38a), {
                                to: (0, $d87e1b304aec4d6d$export$1d56bcf14907e007),
                                children: "streaming cache"
                            }),
                            " is with the",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "useStreamingValue"
                            }),
                            " hook."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$ea911cd21ad60992).hook
                    })
                ]
            })
        ]
    });
}










function $39ff9f937b1011d2$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $aa6eba4c47b97eb7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $4b3065620e983e4c$export$2e2bcd8739ae039), {
                    title: "aborting a request"
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "In-progress requests can be cancelled by calling the cache",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "abort"
                            }),
                            " method."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$7eb1b49cd2af1357).abortRequest.abort
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                        children: "Requests can be aborted where side effects are permitted (e.g. event handlers, effect cleanup functions)."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "To accomplish this, a cache must forward the",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $7ec290908b96eb45$export$b2bf131c9f9cce5d), {
                                    to: "https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal",
                                    children: "AbortSignal"
                                })
                            }),
                            " ",
                            "provided. Both types of cache receive this signal as part of an",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "options"
                            }),
                            " parameter."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$cf6fa0bbcc94b912).cacheWithSignal
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$ea911cd21ad60992).cacheWithSignal
                    })
                ]
            })
        ]
    });
}








function $d64ce72ec23bcc04$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $aa6eba4c47b97eb7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $4b3065620e983e4c$export$2e2bcd8739ae039), {
                    title: "debugging slow requests"
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "In development mode, ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: '"suspense"'
                            }),
                            " can be configured to log timing information. Logging can be enabled/disabled per cache:"
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$9d0a8ca9f3291d1c).perCache
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: "It can also be done globally (for all caches)."
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$9d0a8ca9f3291d1c).global
                    })
                ]
            })
        ]
    });
}













function $7b5108a38f6180ee$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $aa6eba4c47b97eb7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $4b3065620e983e4c$export$2e2bcd8739ae039), {
                    title: "memory management"
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "By default, values stored in a",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b061e8b516dc3a67$export$a6c7ac8248d6e38a), {
                                    to: (0, $d87e1b304aec4d6d$export$c6e57d4df408c13c),
                                    children: "createCache"
                                })
                            }),
                            " ",
                            "will never be garbage collected unless they are explicitly removed from the cache. This is the default behavior because it is the most predictable. However this behavior can be customized using the",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "getCache"
                            }),
                            " configuration option as shown below."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                            children: "Caches that do not evict values may cause memory leaks for certain types of applications."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "LRU cache"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Caches can be configured to store values in a",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $7ec290908b96eb45$export$b2bf131c9f9cce5d), {
                                to: "https://en.wikipedia.org/wiki/Cache_replacement_policies",
                                children: "Least Recently Used (LRU) cache"
                            }),
                            ". The recommended way to do this is to use a pre-built cache like",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $7ec290908b96eb45$export$b2bf131c9f9cce5d), {
                                    to: "https://www.npmjs.com/package/lru-cache",
                                    children: "lru-cache"
                                })
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$cf6fa0bbcc94b912).cacheWithLRU
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "WeakRef cache"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Caches can also be configured to store values in a",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $7ec290908b96eb45$export$b2bf131c9f9cce5d), {
                                    to: "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/WeakRef",
                                    children: "WeakRef"
                                })
                            }),
                            ". The recommended way to do this is using the provided",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "WeakRefMap"
                            }),
                            " class."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$cf6fa0bbcc94b912).cacheWithWeakRefMap
                    })
                ]
            })
        ]
    });
}












var $k116o = parcelRequire("k116o");

var $65afa13ca6c0c325$exports = {};

$parcel$export($65afa13ca6c0c325$exports, "Button", () => $65afa13ca6c0c325$export$353f5b6fc5456de1, (v) => $65afa13ca6c0c325$export$353f5b6fc5456de1 = v);
$parcel$export($65afa13ca6c0c325$exports, "ButtonRow", () => $65afa13ca6c0c325$export$564cbe3426fc093a, (v) => $65afa13ca6c0c325$export$564cbe3426fc093a = v);
$parcel$export($65afa13ca6c0c325$exports, "Input", () => $65afa13ca6c0c325$export$f5b8910cec6cf069, (v) => $65afa13ca6c0c325$export$f5b8910cec6cf069 = v);
$parcel$export($65afa13ca6c0c325$exports, "InputRow", () => $65afa13ca6c0c325$export$2fe4f0576c8a371, (v) => $65afa13ca6c0c325$export$2fe4f0576c8a371 = v);
$parcel$export($65afa13ca6c0c325$exports, "Item", () => $65afa13ca6c0c325$export$6d08773d2e66f8f2, (v) => $65afa13ca6c0c325$export$6d08773d2e66f8f2 = v);
$parcel$export($65afa13ca6c0c325$exports, "Items", () => $65afa13ca6c0c325$export$b4399d239416b67f, (v) => $65afa13ca6c0c325$export$b4399d239416b67f = v);
var $65afa13ca6c0c325$export$353f5b6fc5456de1;
var $65afa13ca6c0c325$export$564cbe3426fc093a;
var $65afa13ca6c0c325$export$f5b8910cec6cf069;
var $65afa13ca6c0c325$export$2fe4f0576c8a371;
var $65afa13ca6c0c325$export$6d08773d2e66f8f2;
var $65afa13ca6c0c325$export$b4399d239416b67f;
$65afa13ca6c0c325$export$353f5b6fc5456de1 = `_7-PEsG_Button`;
$65afa13ca6c0c325$export$564cbe3426fc093a = `_7-PEsG_ButtonRow`;
$65afa13ca6c0c325$export$f5b8910cec6cf069 = `_7-PEsG_Input`;
$65afa13ca6c0c325$export$2fe4f0576c8a371 = `_7-PEsG_InputRow`;
$65afa13ca6c0c325$export$6d08773d2e66f8f2 = `_7-PEsG_Item`;
$65afa13ca6c0c325$export$b4399d239416b67f = `_7-PEsG_Items`;





var $0e75ff1c07174d0d$exports = {};

$parcel$export($0e75ff1c07174d0d$exports, "Loader", () => $0e75ff1c07174d0d$export$3b0d6d7590275603, (v) => $0e75ff1c07174d0d$export$3b0d6d7590275603 = v);
var $0e75ff1c07174d0d$export$3b0d6d7590275603;
$0e75ff1c07174d0d$export$3b0d6d7590275603 = `a5s1Ua_Loader`;


function $eadd3566518c92e3$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($0e75ff1c07174d0d$exports))).Loader,
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $db8e31d0e9379e8d$export$2e2bcd8739ae039), {
                type: "loading"
            }),
            " Loading"
        ]
    });
}




var $k116o = parcelRequire("k116o");




const $ff92865a9ab7f389$var$Input = /*#__PURE__*/ (0, $k116o.forwardRef)(({ disabled: disabled, onEnter: onEnter, placeholder: placeholder }, ref)=>{
    const onClick = ()=>{
        ref.current.focus();
    };
    const onKeyDown = (event)=>{
        switch(event.key){
            case "Enter":
                onEnter();
                break;
        }
    };
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($65afa13ca6c0c325$exports))).InputRow,
        "data-disabled": disabled || undefined,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $db8e31d0e9379e8d$export$2e2bcd8739ae039), {
                type: "edit"
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("input", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($65afa13ca6c0c325$exports))).Input,
                disabled: disabled,
                onKeyDown: onKeyDown,
                placeholder: placeholder,
                ref: ref
            })
        ]
    });
});
function $ff92865a9ab7f389$export$996d6d982dac0ef7({ apiClient: apiClient }) {
    const inputRef = (0, $k116o.useRef)(null);
    // Pass the cache we want to mutate to the mutation hook
    const { isPending: isPending, mutateAsync: mutateAsync } = (0, $b7edf20f84cd4e8f$export$29dc6b9369528985)((0, $8402c6cb05d536b0$export$9e8afc42c773366e));
    const addItem = async ()=>{
        const input = inputRef.current;
        if (input.value) mutateAsync([
            apiClient
        ], async ()=>{
            // Add the new item to the remote list (async)
            const newItems = await apiClient.addItem({
                body: input.value,
                complete: false
            });
            // Clear the input field once the new item has been added
            inputRef.current.value = "";
            // Pre-seed the cache with the updated list of items
            return newItems;
        });
    };
    // Disable form inputs while a mutation is pending
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($ff92865a9ab7f389$var$Input, {
        disabled: isPending,
        onEnter: addItem,
        placeholder: "What needs to be done?",
        ref: inputRef
    });
}


const $8402c6cb05d536b0$var$initialItems = [
    {
        complete: true,
        id: 1,
        body: "Read the documentation"
    },
    {
        complete: false,
        id: 2,
        body: "Write a test app"
    }
];
const $8402c6cb05d536b0$export$9e8afc42c773366e = (0, $addceb3cc5699e5a$export$22a2a694ba0c34d3)({
    debugLabel: "Items",
    load: async ([client])=>client.fetchItems()
});
function $8402c6cb05d536b0$var$createDummyApiClient() {
    // Simulate remote state
    const additions = [];
    const deletions = new Set();
    const edits = new Map();
    let id = $8402c6cb05d536b0$var$initialItems.reduce((max, item)=>Math.max(max, item.id), 0);
    const apiClient = {
        addItem: async (partialItem)=>{
            id++;
            additions.push({
                body: "",
                complete: false,
                ...partialItem,
                id: id
            });
            return await apiClient.fetchItems();
        },
        deleteItem: async (itemId)=>{
            deletions.add(itemId);
            return await apiClient.fetchItems();
        },
        editItem: async (id, partialItem)=>{
            edits.set(id, partialItem);
            return await apiClient.fetchItems();
        },
        fetchItems: async ()=>{
            // Simulate network latency
            await new Promise((resolve)=>setTimeout(resolve, 1000));
            return $8402c6cb05d536b0$var$initialItems.concat(...additions).filter((item)=>!deletions.has(item.id)).map((item)=>{
                const editedItem = edits.get(item.id) ?? {};
                return {
                    ...item,
                    ...editedItem
                };
            });
        }
    };
    return apiClient;
}
function $8402c6cb05d536b0$export$2e2bcd8739ae039() {
    const apiClient = (0, $k116o.useMemo)($8402c6cb05d536b0$var$createDummyApiClient, []);
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $k116o.Suspense), {
        fallback: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $eadd3566518c92e3$export$2e2bcd8739ae039), {}),
        children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($8402c6cb05d536b0$var$ItemsSuspends, {
            apiClient: apiClient
        })
    });
}
function $8402c6cb05d536b0$var$ItemsSuspends({ apiClient: apiClient }) {
    const items = $8402c6cb05d536b0$export$9e8afc42c773366e.read(apiClient);
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($65afa13ca6c0c325$exports))).Items,
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $110956e5e1cd1426$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("div", {}),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $ff92865a9ab7f389$export$996d6d982dac0ef7), {
                        apiClient: apiClient
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("div", {})
                ]
            }),
            items.map((item)=>/*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($8402c6cb05d536b0$var$Item, {
                    apiClient: apiClient,
                    item: item
                }, item.id))
        ]
    });
}
function $8402c6cb05d536b0$var$Item({ apiClient: apiClient, item: item }) {
    const inputRef = (0, $k116o.useRef)(null);
    const { isPending: isPending, mutateAsync: mutateAsync } = (0, $b7edf20f84cd4e8f$export$29dc6b9369528985)($8402c6cb05d536b0$export$9e8afc42c773366e);
    const editItem = ()=>{
        const body = inputRef.current.value;
        if (!body) return;
        mutateAsync([
            apiClient
        ], ()=>apiClient.editItem(item.id, {
                ...item,
                body: body
            }));
    };
    const onKeyDown = (event)=>{
        switch(event.key){
            case "Enter":
                editItem();
                break;
            case "Escape":
                inputRef.current.value = item.body;
                break;
        }
    };
    const toggleComplete = ()=>{
        mutateAsync([
            apiClient
        ], ()=>apiClient.editItem(item.id, {
                ...item,
                complete: !item.complete
            }));
    };
    const deleteItem = ()=>{
        mutateAsync([
            apiClient
        ], ()=>apiClient.deleteItem(item.id));
    };
    const setFocus = ()=>{
        inputRef.current?.focus();
    };
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $110956e5e1cd1426$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("button", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($65afa13ca6c0c325$exports))).Button,
                disabled: isPending,
                onClick: toggleComplete,
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $db8e31d0e9379e8d$export$2e2bcd8739ae039), {
                    type: item.complete ? "complete" : "incomplete"
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($65afa13ca6c0c325$exports))).InputRow,
                onClick: setFocus,
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $db8e31d0e9379e8d$export$2e2bcd8739ae039), {
                        type: "edit"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("input", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($65afa13ca6c0c325$exports))).Input,
                        defaultValue: item.body,
                        disabled: isPending,
                        onKeyDown: onKeyDown,
                        placeholder: "What needs to be done?",
                        ref: inputRef
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("button", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($65afa13ca6c0c325$exports))).Button,
                disabled: isPending,
                onClick: deleteItem,
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $db8e31d0e9379e8d$export$2e2bcd8739ae039), {
                    type: "delete"
                })
            })
        ]
    });
}



function $1f07ee8ebc443d0d$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $aa6eba4c47b97eb7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $4b3065620e983e4c$export$2e2bcd8739ae039), {
                    title: "mutating cache values"
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Cache values can be mutated using the",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b061e8b516dc3a67$export$a6c7ac8248d6e38a), {
                                    to: (0, $d87e1b304aec4d6d$export$a7f6f2cd4cc90607),
                                    children: "useCacheMutation"
                                })
                            }),
                            " ",
                            "hook. It supports two types of mutations:"
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("li", {
                                children: "synchronous (e.g. optimistic updates from user input)"
                            }),
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("li", {
                                children: "asynchronously (e.g. API request)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "The hook also returns an ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "isPending"
                            }),
                            " flag that can be used to update UI while a mutation is in progress."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Here's an example app that uses ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "useCacheMutation"
                            }),
                            " to add, edit, and delete entries from a TODO list."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                type: "demo",
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $8402c6cb05d536b0$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fcca5122c6dc254a$export$2e2bcd8739ae039), {
                        title: "Adding an item"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$7eb1b49cd2af1357).mutatingCacheValue.addItem
                    })
                ]
            })
        ]
    });
}











var $1c451d693212408b$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $1c451d693212408b$var$INFINITY = 1 / 0, $1c451d693212408b$var$MAX_SAFE_INTEGER = 9007199254740991, $1c451d693212408b$var$MAX_INTEGER = 1.7976931348623157e+308, $1c451d693212408b$var$NAN = 0 / 0;
/** Used as references for the maximum length and index of an array. */ var $1c451d693212408b$var$MAX_ARRAY_LENGTH = 4294967295;
/** `Object#toString` result references. */ var $1c451d693212408b$var$argsTag = "[object Arguments]", $1c451d693212408b$var$funcTag = "[object Function]", $1c451d693212408b$var$genTag = "[object GeneratorFunction]", $1c451d693212408b$var$mapTag = "[object Map]", $1c451d693212408b$var$objectTag = "[object Object]", $1c451d693212408b$var$promiseTag = "[object Promise]", $1c451d693212408b$var$setTag = "[object Set]", $1c451d693212408b$var$stringTag = "[object String]", $1c451d693212408b$var$symbolTag = "[object Symbol]", $1c451d693212408b$var$weakMapTag = "[object WeakMap]";
var $1c451d693212408b$var$dataViewTag = "[object DataView]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $1c451d693212408b$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match leading and trailing whitespace. */ var $1c451d693212408b$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $1c451d693212408b$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $1c451d693212408b$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect host constructors (Safari). */ var $1c451d693212408b$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect octal string values. */ var $1c451d693212408b$var$reIsOctal = /^0o[0-7]+$/i;
/** Used to detect unsigned integer values. */ var $1c451d693212408b$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to compose unicode character classes. */ var $1c451d693212408b$var$rsAstralRange = "\ud800-\udfff", $1c451d693212408b$var$rsComboMarksRange = "\\u0300-\\u036f\\ufe20-\\ufe23", $1c451d693212408b$var$rsComboSymbolsRange = "\\u20d0-\\u20f0", $1c451d693212408b$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $1c451d693212408b$var$rsAstral = "[" + $1c451d693212408b$var$rsAstralRange + "]", $1c451d693212408b$var$rsCombo = "[" + $1c451d693212408b$var$rsComboMarksRange + $1c451d693212408b$var$rsComboSymbolsRange + "]", $1c451d693212408b$var$rsFitz = "\ud83c[\udffb-\udfff]", $1c451d693212408b$var$rsModifier = "(?:" + $1c451d693212408b$var$rsCombo + "|" + $1c451d693212408b$var$rsFitz + ")", $1c451d693212408b$var$rsNonAstral = "[^" + $1c451d693212408b$var$rsAstralRange + "]", $1c451d693212408b$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $1c451d693212408b$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $1c451d693212408b$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $1c451d693212408b$var$reOptMod = $1c451d693212408b$var$rsModifier + "?", $1c451d693212408b$var$rsOptVar = "[" + $1c451d693212408b$var$rsVarRange + "]?", $1c451d693212408b$var$rsOptJoin = "(?:" + $1c451d693212408b$var$rsZWJ + "(?:" + [
    $1c451d693212408b$var$rsNonAstral,
    $1c451d693212408b$var$rsRegional,
    $1c451d693212408b$var$rsSurrPair
].join("|") + ")" + $1c451d693212408b$var$rsOptVar + $1c451d693212408b$var$reOptMod + ")*", $1c451d693212408b$var$rsSeq = $1c451d693212408b$var$rsOptVar + $1c451d693212408b$var$reOptMod + $1c451d693212408b$var$rsOptJoin, $1c451d693212408b$var$rsSymbol = "(?:" + [
    $1c451d693212408b$var$rsNonAstral + $1c451d693212408b$var$rsCombo + "?",
    $1c451d693212408b$var$rsCombo,
    $1c451d693212408b$var$rsRegional,
    $1c451d693212408b$var$rsSurrPair,
    $1c451d693212408b$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $1c451d693212408b$var$reUnicode = RegExp($1c451d693212408b$var$rsFitz + "(?=" + $1c451d693212408b$var$rsFitz + ")|" + $1c451d693212408b$var$rsSymbol + $1c451d693212408b$var$rsSeq, "g");
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $1c451d693212408b$var$reHasUnicode = RegExp("[" + $1c451d693212408b$var$rsZWJ + $1c451d693212408b$var$rsAstralRange + $1c451d693212408b$var$rsComboMarksRange + $1c451d693212408b$var$rsComboSymbolsRange + $1c451d693212408b$var$rsVarRange + "]");
/** Built-in method references without a dependency on `root`. */ var $1c451d693212408b$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $1c451d693212408b$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $1c451d693212408b$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1c451d693212408b$var$root = $1c451d693212408b$var$freeGlobal || $1c451d693212408b$var$freeSelf || Function("return this")();
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $1c451d693212408b$var$arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $1c451d693212408b$var$asciiToArray(string) {
    return string.split("");
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $1c451d693212408b$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $1c451d693212408b$var$baseValues(object, props) {
    return $1c451d693212408b$var$arrayMap(props, function(key) {
        return object[key];
    });
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $1c451d693212408b$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $1c451d693212408b$var$hasUnicode(string) {
    return $1c451d693212408b$var$reHasUnicode.test(string);
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $1c451d693212408b$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */ function $1c451d693212408b$var$iteratorToArray(iterator) {
    var data, result = [];
    while(!(data = iterator.next()).done)result.push(data.value);
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $1c451d693212408b$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $1c451d693212408b$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $1c451d693212408b$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $1c451d693212408b$var$stringToArray(string) {
    return $1c451d693212408b$var$hasUnicode(string) ? $1c451d693212408b$var$unicodeToArray(string) : $1c451d693212408b$var$asciiToArray(string);
}
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $1c451d693212408b$var$unicodeToArray(string) {
    return string.match($1c451d693212408b$var$reUnicode) || [];
}
/** Used for built-in method references. */ var $1c451d693212408b$var$funcProto = Function.prototype, $1c451d693212408b$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $1c451d693212408b$var$coreJsData = $1c451d693212408b$var$root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var $1c451d693212408b$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($1c451d693212408b$var$coreJsData && $1c451d693212408b$var$coreJsData.keys && $1c451d693212408b$var$coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var $1c451d693212408b$var$funcToString = $1c451d693212408b$var$funcProto.toString;
/** Used to check objects for own properties. */ var $1c451d693212408b$var$hasOwnProperty = $1c451d693212408b$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1c451d693212408b$var$objectToString = $1c451d693212408b$var$objectProto.toString;
/** Used to detect if a method is native. */ var $1c451d693212408b$var$reIsNative = RegExp("^" + $1c451d693212408b$var$funcToString.call($1c451d693212408b$var$hasOwnProperty).replace($1c451d693212408b$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var $1c451d693212408b$var$Symbol = $1c451d693212408b$var$root.Symbol, $1c451d693212408b$var$iteratorSymbol = $1c451d693212408b$var$Symbol ? $1c451d693212408b$var$Symbol.iterator : undefined, $1c451d693212408b$var$propertyIsEnumerable = $1c451d693212408b$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1c451d693212408b$var$nativeFloor = Math.floor, $1c451d693212408b$var$nativeKeys = $1c451d693212408b$var$overArg(Object.keys, Object), $1c451d693212408b$var$nativeRandom = Math.random;
/* Built-in method references that are verified to be native. */ var $1c451d693212408b$var$DataView = $1c451d693212408b$var$getNative($1c451d693212408b$var$root, "DataView"), $1c451d693212408b$var$Map = $1c451d693212408b$var$getNative($1c451d693212408b$var$root, "Map"), $1c451d693212408b$var$Promise = $1c451d693212408b$var$getNative($1c451d693212408b$var$root, "Promise"), $1c451d693212408b$var$Set = $1c451d693212408b$var$getNative($1c451d693212408b$var$root, "Set"), $1c451d693212408b$var$WeakMap = $1c451d693212408b$var$getNative($1c451d693212408b$var$root, "WeakMap");
/** Used to detect maps, sets, and weakmaps. */ var $1c451d693212408b$var$dataViewCtorString = $1c451d693212408b$var$toSource($1c451d693212408b$var$DataView), $1c451d693212408b$var$mapCtorString = $1c451d693212408b$var$toSource($1c451d693212408b$var$Map), $1c451d693212408b$var$promiseCtorString = $1c451d693212408b$var$toSource($1c451d693212408b$var$Promise), $1c451d693212408b$var$setCtorString = $1c451d693212408b$var$toSource($1c451d693212408b$var$Set), $1c451d693212408b$var$weakMapCtorString = $1c451d693212408b$var$toSource($1c451d693212408b$var$WeakMap);
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $1c451d693212408b$var$arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = $1c451d693212408b$var$isArray(value) || $1c451d693212408b$var$isArguments(value) ? $1c451d693212408b$var$baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || $1c451d693212408b$var$hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || $1c451d693212408b$var$isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $1c451d693212408b$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $1c451d693212408b$var$baseGetTag(value) {
    return $1c451d693212408b$var$objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $1c451d693212408b$var$baseIsNative(value) {
    if (!$1c451d693212408b$var$isObject(value) || $1c451d693212408b$var$isMasked(value)) return false;
    var pattern = $1c451d693212408b$var$isFunction(value) || $1c451d693212408b$var$isHostObject(value) ? $1c451d693212408b$var$reIsNative : $1c451d693212408b$var$reIsHostCtor;
    return pattern.test($1c451d693212408b$var$toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $1c451d693212408b$var$baseKeys(object) {
    if (!$1c451d693212408b$var$isPrototype(object)) return $1c451d693212408b$var$nativeKeys(object);
    var result = [];
    for(var key in Object(object))if ($1c451d693212408b$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */ function $1c451d693212408b$var$baseRandom(lower, upper) {
    return lower + $1c451d693212408b$var$nativeFloor($1c451d693212408b$var$nativeRandom() * (upper - lower + 1));
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $1c451d693212408b$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $1c451d693212408b$var$getNative(object, key) {
    var value = $1c451d693212408b$var$getValue(object, key);
    return $1c451d693212408b$var$baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $1c451d693212408b$var$getTag = $1c451d693212408b$var$baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ($1c451d693212408b$var$DataView && $1c451d693212408b$var$getTag(new $1c451d693212408b$var$DataView(new ArrayBuffer(1))) != $1c451d693212408b$var$dataViewTag || $1c451d693212408b$var$Map && $1c451d693212408b$var$getTag(new $1c451d693212408b$var$Map) != $1c451d693212408b$var$mapTag || $1c451d693212408b$var$Promise && $1c451d693212408b$var$getTag($1c451d693212408b$var$Promise.resolve()) != $1c451d693212408b$var$promiseTag || $1c451d693212408b$var$Set && $1c451d693212408b$var$getTag(new $1c451d693212408b$var$Set) != $1c451d693212408b$var$setTag || $1c451d693212408b$var$WeakMap && $1c451d693212408b$var$getTag(new $1c451d693212408b$var$WeakMap) != $1c451d693212408b$var$weakMapTag) $1c451d693212408b$var$getTag = function(value) {
    var result = $1c451d693212408b$var$objectToString.call(value), Ctor = result == $1c451d693212408b$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $1c451d693212408b$var$toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case $1c451d693212408b$var$dataViewCtorString:
            return $1c451d693212408b$var$dataViewTag;
        case $1c451d693212408b$var$mapCtorString:
            return $1c451d693212408b$var$mapTag;
        case $1c451d693212408b$var$promiseCtorString:
            return $1c451d693212408b$var$promiseTag;
        case $1c451d693212408b$var$setCtorString:
            return $1c451d693212408b$var$setTag;
        case $1c451d693212408b$var$weakMapCtorString:
            return $1c451d693212408b$var$weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $1c451d693212408b$var$isIndex(value, length) {
    length = length == null ? $1c451d693212408b$var$MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || $1c451d693212408b$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $1c451d693212408b$var$isIterateeCall(value, index, object) {
    if (!$1c451d693212408b$var$isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? $1c451d693212408b$var$isArrayLike(object) && $1c451d693212408b$var$isIndex(index, object.length) : type == "string" && index in object) return $1c451d693212408b$var$eq(object[index], value);
    return false;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $1c451d693212408b$var$isMasked(func) {
    return !!$1c451d693212408b$var$maskSrcKey && $1c451d693212408b$var$maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $1c451d693212408b$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $1c451d693212408b$var$objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $1c451d693212408b$var$toSource(func) {
    if (func != null) {
        try {
            return $1c451d693212408b$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Gets `n` random elements at unique keys from `collection` up to the
 * size of `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @param {number} [n=1] The number of elements to sample.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the random elements.
 * @example
 *
 * _.sampleSize([1, 2, 3], 2);
 * // => [3, 1]
 *
 * _.sampleSize([1, 2, 3], 4);
 * // => [2, 3, 1]
 */ function $1c451d693212408b$var$sampleSize(collection, n, guard) {
    var index = -1, result = $1c451d693212408b$var$toArray(collection), length = result.length, lastIndex = length - 1;
    if (guard ? $1c451d693212408b$var$isIterateeCall(collection, n, guard) : n === undefined) n = 1;
    else n = $1c451d693212408b$var$baseClamp($1c451d693212408b$var$toInteger(n), 0, length);
    while(++index < n){
        var rand = $1c451d693212408b$var$baseRandom(index, lastIndex), value = result[rand];
        result[rand] = result[index];
        result[index] = value;
    }
    result.length = n;
    return result;
}
/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */ function $1c451d693212408b$var$shuffle(collection) {
    return $1c451d693212408b$var$sampleSize(collection, $1c451d693212408b$var$MAX_ARRAY_LENGTH);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $1c451d693212408b$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $1c451d693212408b$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $1c451d693212408b$var$isArrayLikeObject(value) && $1c451d693212408b$var$hasOwnProperty.call(value, "callee") && (!$1c451d693212408b$var$propertyIsEnumerable.call(value, "callee") || $1c451d693212408b$var$objectToString.call(value) == $1c451d693212408b$var$argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $1c451d693212408b$var$isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $1c451d693212408b$var$isArrayLike(value) {
    return value != null && $1c451d693212408b$var$isLength(value.length) && !$1c451d693212408b$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $1c451d693212408b$var$isArrayLikeObject(value) {
    return $1c451d693212408b$var$isObjectLike(value) && $1c451d693212408b$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $1c451d693212408b$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $1c451d693212408b$var$isObject(value) ? $1c451d693212408b$var$objectToString.call(value) : "";
    return tag == $1c451d693212408b$var$funcTag || tag == $1c451d693212408b$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $1c451d693212408b$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $1c451d693212408b$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $1c451d693212408b$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $1c451d693212408b$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $1c451d693212408b$var$isString(value) {
    return typeof value == "string" || !$1c451d693212408b$var$isArray(value) && $1c451d693212408b$var$isObjectLike(value) && $1c451d693212408b$var$objectToString.call(value) == $1c451d693212408b$var$stringTag;
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $1c451d693212408b$var$isSymbol(value) {
    return typeof value == "symbol" || $1c451d693212408b$var$isObjectLike(value) && $1c451d693212408b$var$objectToString.call(value) == $1c451d693212408b$var$symbolTag;
}
/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */ function $1c451d693212408b$var$toArray(value) {
    if (!value) return [];
    if ($1c451d693212408b$var$isArrayLike(value)) return $1c451d693212408b$var$isString(value) ? $1c451d693212408b$var$stringToArray(value) : $1c451d693212408b$var$copyArray(value);
    if ($1c451d693212408b$var$iteratorSymbol && value[$1c451d693212408b$var$iteratorSymbol]) return $1c451d693212408b$var$iteratorToArray(value[$1c451d693212408b$var$iteratorSymbol]());
    var tag = $1c451d693212408b$var$getTag(value), func = tag == $1c451d693212408b$var$mapTag ? $1c451d693212408b$var$mapToArray : tag == $1c451d693212408b$var$setTag ? $1c451d693212408b$var$setToArray : $1c451d693212408b$var$values;
    return func(value);
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $1c451d693212408b$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $1c451d693212408b$var$toNumber(value);
    if (value === $1c451d693212408b$var$INFINITY || value === -$1c451d693212408b$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $1c451d693212408b$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $1c451d693212408b$var$toInteger(value) {
    var result = $1c451d693212408b$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $1c451d693212408b$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($1c451d693212408b$var$isSymbol(value)) return $1c451d693212408b$var$NAN;
    if ($1c451d693212408b$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $1c451d693212408b$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($1c451d693212408b$var$reTrim, "");
    var isBinary = $1c451d693212408b$var$reIsBinary.test(value);
    return isBinary || $1c451d693212408b$var$reIsOctal.test(value) ? $1c451d693212408b$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $1c451d693212408b$var$reIsBadHex.test(value) ? $1c451d693212408b$var$NAN : +value;
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $1c451d693212408b$var$keys(object) {
    return $1c451d693212408b$var$isArrayLike(object) ? $1c451d693212408b$var$arrayLikeKeys(object) : $1c451d693212408b$var$baseKeys(object);
}
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $1c451d693212408b$var$values(object) {
    return object ? $1c451d693212408b$var$baseValues(object, $1c451d693212408b$var$keys(object)) : [];
}
$1c451d693212408b$exports = $1c451d693212408b$var$shuffle;



var $k116o = parcelRequire("k116o");






function $6ad442de320ca11f$export$f25dae4ff53797bf({ id: id }) {
    const status = (0, $d70beb1831956ba7$export$a0b0284d625c6d1d)((0, $f3b1940c79cc12bc$export$b5d74b812cac8157), id);
    let type;
    switch(status){
        case "not-found":
            type = "status-not-found";
            break;
        case "pending":
            type = "status-pending";
            break;
        case "resolved":
            type = "status-resolved";
            break;
        default:
            return null;
    }
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $db8e31d0e9379e8d$export$2e2bcd8739ae039), {
        type: type
    });
}


var $ba040e451e378248$exports = {};

$parcel$export($ba040e451e378248$exports, "App", () => $ba040e451e378248$export$86fbec116b87613f, (v) => $ba040e451e378248$export$86fbec116b87613f = v);
$parcel$export($ba040e451e378248$exports, "ButtonRow", () => $ba040e451e378248$export$564cbe3426fc093a, (v) => $ba040e451e378248$export$564cbe3426fc093a = v);
$parcel$export($ba040e451e378248$exports, "Main", () => $ba040e451e378248$export$861edd1ccea2f746, (v) => $ba040e451e378248$export$861edd1ccea2f746 = v);
$parcel$export($ba040e451e378248$exports, "MainButton", () => $ba040e451e378248$export$a40a94c09692fa82, (v) => $ba040e451e378248$export$a40a94c09692fa82 = v);
$parcel$export($ba040e451e378248$exports, "Placeholder", () => $ba040e451e378248$export$84712d0562a614b8, (v) => $ba040e451e378248$export$84712d0562a614b8 = v);
$parcel$export($ba040e451e378248$exports, "SideNav", () => $ba040e451e378248$export$1a35787d6353cf6a, (v) => $ba040e451e378248$export$1a35787d6353cf6a = v);
$parcel$export($ba040e451e378248$exports, "UserButton", () => $ba040e451e378248$export$235493e82cf65451, (v) => $ba040e451e378248$export$235493e82cf65451 = v);
var $ba040e451e378248$export$86fbec116b87613f;
var $ba040e451e378248$export$564cbe3426fc093a;
var $ba040e451e378248$export$861edd1ccea2f746;
var $ba040e451e378248$export$a40a94c09692fa82;
var $ba040e451e378248$export$84712d0562a614b8;
var $ba040e451e378248$export$1a35787d6353cf6a;
var $ba040e451e378248$export$235493e82cf65451;
$ba040e451e378248$export$86fbec116b87613f = `BnM5mG_App`;
$ba040e451e378248$export$564cbe3426fc093a = `BnM5mG_ButtonRow`;
$ba040e451e378248$export$861edd1ccea2f746 = `BnM5mG_Main`;
$ba040e451e378248$export$a40a94c09692fa82 = `BnM5mG_MainButton`;
$ba040e451e378248$export$84712d0562a614b8 = `BnM5mG_Placeholder`;
$ba040e451e378248$export$1a35787d6353cf6a = `BnM5mG_SideNav`;
$ba040e451e378248$export$235493e82cf65451 = `BnM5mG_UserButton`;


var $e4daaf22c1549cc0$exports = {};
$e4daaf22c1549cc0$exports = JSON.parse('{"users":[{"id":1,"firstName":"Terry","lastName":"Medhurst","maidenName":"Smitham","age":50,"gender":"male","email":"atuny0@sohu.com","phone":"+63 791 675 8914","username":"atuny0","image":"https://robohash.org/hicveldicta.png","domain":"slashdot.org","address":{"address":"1745 T Street Southeast","city":"Washington","postalCode":"20020","state":"DC"}},{"id":2,"firstName":"Sheldon","lastName":"Quigley","maidenName":"Cole","age":28,"gender":"male","email":"hbingley1@plala.or.jp","phone":"+7 813 117 7139","username":"hbingley1","image":"https://robohash.org/doloremquesintcorrupti.png","domain":"51.la","address":{"address":"6007 Applegate Lane","city":"Louisville","postalCode":"40219","state":"KY"}},{"id":3,"firstName":"Terrill","lastName":"Hills","maidenName":"Hoeger","age":38,"gender":"male","email":"rshawe2@51.la","phone":"+63 739 292 7942","username":"rshawe2","image":"https://robohash.org/consequunturautconsequatur.png","domain":"earthlink.net","address":{"address":"560 Penstock Drive","city":"Grass Valley","postalCode":"95945","state":"CA"}},{"id":4,"firstName":"Miles","lastName":"Cummerata","maidenName":"Maggio","age":49,"gender":"male","email":"yraigatt3@nature.com","phone":"+86 461 145 4186","username":"yraigatt3","image":"https://robohash.org/facilisdignissimosdolore.png","domain":"homestead.com","address":{"address":"150 Carter Street","city":"Manchester","postalCode":"06040","state":"CT"}},{"id":5,"firstName":"Mavis","lastName":"Schultz","maidenName":"Yundt","age":38,"gender":"male","email":"kmeus4@upenn.edu","phone":"+372 285 771 1911","username":"kmeus4","image":"https://robohash.org/adverovelit.png","domain":"columbia.edu","address":{"address":"2721 Lindsay Avenue","city":"Louisville","postalCode":"40206","state":"KY"}},{"id":6,"firstName":"Alison","lastName":"Reichert","maidenName":"Franecki","age":21,"gender":"female","email":"jtreleven5@nhs.uk","phone":"+351 527 735 3642","username":"jtreleven5","image":"https://robohash.org/laboriosamfacilisrem.png","domain":"bandcamp.com","address":{"address":"18 Densmore Drive","city":"Essex","postalCode":"05452","state":"VT"}},{"id":7,"firstName":"Oleta","lastName":"Abbott","maidenName":"Wyman","age":31,"gender":"female","email":"dpettegre6@columbia.edu","phone":"+62 640 802 7111","username":"dpettegre6","image":"https://robohash.org/cupiditatererumquos.png","domain":"ovh.net","address":{"address":"637 Britannia Drive","city":"Vallejo","postalCode":"94591","state":"CA"}},{"id":8,"firstName":"Ewell","lastName":"Mueller","maidenName":"Durgan","age":29,"gender":"male","email":"ggude7@chron.com","phone":"+86 946 297 2275","username":"ggude7","image":"https://robohash.org/quiaharumsapiente.png","domain":"homestead.com","address":{"address":"5601 West Crocus Drive","city":"Glendale","postalCode":"85306","state":"AZ"}},{"id":9,"firstName":"Demetrius","lastName":"Corkery","maidenName":"Gleason","age":22,"gender":"male","email":"nloiterton8@aol.com","phone":"+86 356 590 9727","username":"nloiterton8","image":"https://robohash.org/excepturiiuremolestiae.png","domain":"goodreads.com","address":{"address":"5403 Illinois Avenue","city":"Nashville","postalCode":"37209","state":"TN"}},{"id":10,"firstName":"Eleanora","lastName":"Price","maidenName":"Cummings","age":37,"gender":"female","email":"umcgourty9@jalbum.net","phone":"+60 184 408 0824","username":"umcgourty9","image":"https://robohash.org/aliquamcumqueiure.png","domain":"alibaba.com","address":{"address":"8821 West Myrtle Avenue","city":"Glendale","postalCode":"85305","state":"AZ"}},{"id":11,"firstName":"Marcel","lastName":"Jones","maidenName":"Smith","age":39,"gender":"male","email":"acharlota@liveinternet.ru","phone":"+967 253 210 0344","username":"acharlota","image":"https://robohash.org/impeditautest.png","domain":"feedburner.com","address":{"address":"2203 7th Street Road","city":"Louisville","postalCode":"40208","state":"KY"}},{"id":12,"firstName":"Assunta","lastName":"Rath","maidenName":"Heller","age":42,"gender":"female","email":"rhallawellb@dropbox.com","phone":"+380 962 542 6549","username":"rhallawellb","image":"https://robohash.org/namquaerataut.png","domain":"123-reg.co.uk","address":{"address":"6463 Vrain Street","city":"Arvada","postalCode":"80003","state":"CO"}},{"id":13,"firstName":"Trace","lastName":"Douglas","maidenName":"Lemke","age":26,"gender":"male","email":"lgribbinc@posterous.com","phone":"+1 609 937 3468","username":"lgribbinc","image":"https://robohash.org/voluptatemsintnulla.png","domain":"histats.com","address":{"address":"87 Horseshoe Drive","city":"West Windsor","postalCode":"05037","state":"VT"}},{"id":14,"firstName":"Enoch","lastName":"Lynch","maidenName":"Heidenreich","age":21,"gender":"male","email":"mturleyd@tumblr.com","phone":"+94 912 100 5118","username":"mturleyd","image":"https://robohash.org/quisequienim.png","domain":"icio.us","address":{"address":"60 Desousa Drive","city":"Manchester","postalCode":"06040","state":"CT"}},{"id":15,"firstName":"Jeanne","lastName":"Halvorson","maidenName":"Cummerata","age":26,"gender":"female","email":"kminchelle@qq.com","phone":"+86 581 108 7855","username":"kminchelle","image":"https://robohash.org/autquiaut.png","domain":"google.co.uk","address":{"address":"4 Old Colony Way","city":"Yarmouth","postalCode":"02664","state":"MA"}},{"id":16,"firstName":"Trycia","lastName":"Fadel","maidenName":"Rosenbaum","age":41,"gender":"female","email":"dpierrof@vimeo.com","phone":"+420 833 708 0340","username":"dpierrof","image":"https://robohash.org/porronumquamid.png","domain":"tamu.edu","address":{"address":"314 South 17th Street","city":"Nashville","postalCode":"37206","state":"TN"}},{"id":17,"firstName":"Bradford","lastName":"Prohaska","maidenName":"Bins","age":43,"gender":"male","email":"vcholdcroftg@ucoz.com","phone":"+420 874 628 3710","username":"vcholdcroftg","image":"https://robohash.org/accusantiumvoluptateseos.png","domain":"wix.com","address":{"address":"1649 Timberridge Court","city":"Fayetteville","postalCode":"72704","state":"AR"}},{"id":18,"firstName":"Arely","lastName":"Skiles","maidenName":"Monahan","age":42,"gender":"male","email":"sberminghamh@chron.com","phone":"+55 886 766 8617","username":"sberminghamh","image":"https://robohash.org/nihilharumqui.png","domain":"seesaa.net","address":{"address":"5461 West Shades Valley Drive","city":"Montgomery","postalCode":"36108","state":"AL"}},{"id":19,"firstName":"Gust","lastName":"Purdy","maidenName":"Abshire","age":46,"gender":"male","email":"bleveragei@so-net.ne.jp","phone":"+86 886 889 0258","username":"bleveragei","image":"https://robohash.org/delenitipraesentiumvoluptatum.png","domain":"homestead.com","address":{"address":"629 Debbie Drive","city":"Nashville","postalCode":"37076","state":"TN"}},{"id":20,"firstName":"Lenna","lastName":"Renner","maidenName":"Schumm","age":41,"gender":"female","email":"aeatockj@psu.edu","phone":"+1 904 601 7177","username":"aeatockj","image":"https://robohash.org/ipsumutofficiis.png","domain":"sourceforge.net","address":{"address":"22572 Toreador Drive","city":"Salinas","postalCode":"93908","state":"CA"}},{"id":21,"firstName":"Doyle","lastName":"Ernser","maidenName":"Feeney","age":23,"gender":"male","email":"ckensleyk@pen.io","phone":"+86 634 419 6839","username":"ckensleyk","image":"https://robohash.org/providenttemporadelectus.png","domain":"free.fr","address":{"address":"3034 Mica Street","city":"Fayetteville","postalCode":"72704","state":"AR"}},{"id":22,"firstName":"Tressa","lastName":"Weber","maidenName":"Williamson","age":41,"gender":"female","email":"froachel@howstuffworks.com","phone":"+34 517 104 6248","username":"froachel","image":"https://robohash.org/temporarecusandaeest.png","domain":"indiatimes.com","address":{"address":"3729 East Mission Boulevard","city":"Fayetteville","postalCode":"72703","state":"AR"}},{"id":23,"firstName":"Felicity","lastName":"O\'Reilly","maidenName":"Rosenbaum","age":46,"gender":"female","email":"beykelhofm@wikispaces.com","phone":"+63 919 564 1690","username":"beykelhofm","image":"https://robohash.org/odioquivero.png","domain":"tamu.edu","address":{"address":"5114 Greentree Drive","city":"Nashville","postalCode":"37211","state":"TN"}},{"id":24,"firstName":"Jocelyn","lastName":"Schuster","maidenName":"Dooley","age":19,"gender":"male","email":"brickeardn@fema.gov","phone":"+7 968 462 1292","username":"brickeardn","image":"https://robohash.org/odiomolestiaealias.png","domain":"pen.io","address":{"address":"3466 Southview Avenue","city":"Montgomery","postalCode":"36111","state":"AL"}},{"id":25,"firstName":"Edwina","lastName":"Ernser","maidenName":"Kiehn","age":21,"gender":"female","email":"dfundello@amazon.co.jp","phone":"+86 376 986 8945","username":"dfundello","image":"https://robohash.org/doloremautdolores.png","domain":"apple.com","address":{"address":"1513 Cathy Street","city":"Savannah","postalCode":"31415","state":"GA"}},{"id":26,"firstName":"Griffin","lastName":"Braun","maidenName":"Deckow","age":35,"gender":"male","email":"lgronaverp@cornell.edu","phone":"+62 511 790 0161","username":"lgronaverp","image":"https://robohash.org/laboriosammollitiaut.png","domain":"foxnews.com","address":{"address":"600 West 19th Avenue","city":"Anchorage","postalCode":"99503","state":"AK"}},{"id":27,"firstName":"Piper","lastName":"Schowalter","maidenName":"Wuckert","age":47,"gender":"female","email":"fokillq@amazon.co.jp","phone":"+60 785 960 7918","username":"fokillq","image":"https://robohash.org/nequeodiosapiente.png","domain":"toplist.cz","address":{"address":"1208 Elkader Court North","city":"Nashville","postalCode":"37013","state":"TN"}},{"id":28,"firstName":"Kody","lastName":"Terry","maidenName":"Larkin","age":28,"gender":"male","email":"xisherwoodr@ask.com","phone":"+81 859 545 8951","username":"xisherwoodr","image":"https://robohash.org/consequunturabnon.png","domain":"elpais.com","address":{"address":"210 Green Road","city":"Manchester","postalCode":"06042","state":"CT"}},{"id":29,"firstName":"Macy","lastName":"Greenfelder","maidenName":"Koepp","age":45,"gender":"female","email":"jissetts@hostgator.com","phone":"+81 915 649 2384","username":"jissetts","image":"https://robohash.org/amettemporeea.png","domain":"ibm.com","address":{"address":"49548 Road 200","city":"O\'Neals","postalCode":"93645","state":"CA"}},{"id":30,"firstName":"Maurine","lastName":"Stracke","maidenName":"Abshire","age":31,"gender":"female","email":"kdulyt@umich.edu","phone":"+48 143 590 6847","username":"kdulyt","image":"https://robohash.org/perferendisideveniet.png","domain":"ow.ly","address":{"address":"81 Seaton Place Northwest","city":"Washington","postalCode":"20001","state":"DC"}},{"id":31,"firstName":"Luciano","lastName":"Sauer","maidenName":"Ankunding","age":27,"gender":"male","email":"smargiottau@altervista.org","phone":"+420 491 212 0935","username":"smargiottau","image":"https://robohash.org/rerumfugiatamet.png","domain":"xrea.com","address":{"address":"1267 Martin Street","city":"Nashville","postalCode":"37203","state":"TN"}},{"id":32,"firstName":"Kaya","lastName":"Emard","maidenName":"Johns","age":36,"gender":"female","email":"lskeelv@webeden.co.uk","phone":"+1 813 801 4535","username":"lskeelv","image":"https://robohash.org/etquiquibusdam.png","domain":"privacy.gov.au","address":{"address":"7431 Candace Way","city":"Louisville","postalCode":"40214","state":"KY"}},{"id":33,"firstName":"Lee","lastName":"Schmidt","maidenName":"Runolfsson","age":45,"gender":"male","email":"gsilcockw@infoseek.co.jp","phone":"+66 835 467 6865","username":"gsilcockw","image":"https://robohash.org/providentdoloremarchitecto.png","domain":"spotify.com","address":{"address":"1407 Walden Court","city":"Crofton","postalCode":"21114","state":"MD"}},{"id":34,"firstName":"Darien","lastName":"Witting","maidenName":"Huel","age":42,"gender":"male","email":"aaughtonx@businessweek.com","phone":"+33 888 700 6632","username":"aaughtonx","image":"https://robohash.org/utnonnobis.png","domain":"aol.com","address":{"address":"5906 Milton Avenue","city":"Deale","postalCode":"20751","state":"MD"}},{"id":35,"firstName":"Jacklyn","lastName":"Schimmel","maidenName":"Upton","age":35,"gender":"female","email":"mbrooksbanky@gnu.org","phone":"+63 967 545 4702","username":"mbrooksbanky","image":"https://robohash.org/nequeexercitationemanimi.png","domain":"sbwire.com","address":{"address":"74 Springfield Street","city":"Agawam","postalCode":"01001","state":"MA"}},{"id":36,"firstName":"Angelica","lastName":"Baumbach","maidenName":"Considine","age":46,"gender":"female","email":"dalmondz@joomla.org","phone":"+62 805 799 5971","username":"dalmondz","image":"https://robohash.org/vitaenonqui.png","domain":"house.gov","address":{"address":"2905 Stonebridge Court","city":"Norman","postalCode":"73071","state":"OK"}},{"id":37,"firstName":"Delfina","lastName":"Ziemann","maidenName":"Kertzmann","age":18,"gender":"female","email":"nwytchard10@blogspot.com","phone":"+84 580 557 5307","username":"nwytchard10","image":"https://robohash.org/officiisprovidentlaborum.png","domain":"prnewswire.com","address":{"address":"20930 Todd Valley Road","city":"Foresthill","postalCode":"95631","state":"CA"}},{"id":38,"firstName":"Thaddeus","lastName":"McCullough","maidenName":"Weimann","age":30,"gender":"male","email":"igannan11@microsoft.com","phone":"+62 358 347 4052","username":"igannan11","image":"https://robohash.org/veritatisperspiciatisqui.png","domain":"canalblog.com","address":{"address":"5928 West Mauna Loa Lane","city":"Glendale","postalCode":"85306","state":"AZ"}},{"id":39,"firstName":"Salvatore","lastName":"Fisher","maidenName":"Dickens","age":35,"gender":"male","email":"lgherardi12@washington.edu","phone":"+46 365 156 0334","username":"lgherardi12","image":"https://robohash.org/quosautquia.png","domain":"pcworld.com","address":{"address":"802 Madison Street Northwest","city":"Washington","postalCode":"20011","state":"DC"}},{"id":40,"firstName":"Jasmin","lastName":"Hermiston","maidenName":"Marvin","age":40,"gender":"male","email":"lgutridge13@sun.com","phone":"+81 649 401 1274","username":"lgutridge13","image":"https://robohash.org/voluptatesolutaconsequuntur.png","domain":"apple.com","address":{"address":"2811 Battery Place Northwest","city":"Washington","postalCode":"20016","state":"DC"}},{"id":41,"firstName":"Nicklaus","lastName":"Cruickshank","maidenName":"Barrows","age":23,"gender":"male","email":"cslateford14@blogspot.com","phone":"+62 873 274 2549","username":"cslateford14","image":"https://robohash.org/quiaconsecteturaut.png","domain":"jugem.jp","address":{"address":"210 Lacross Lane","city":"Westmore","postalCode":"05860","state":"VT"}},{"id":42,"firstName":"Tiara","lastName":"Rolfson","maidenName":"Pacocha","age":36,"gender":"female","email":"mhaslegrave15@springer.com","phone":"+351 554 736 8690","username":"mhaslegrave15","image":"https://robohash.org/perferendisestanimi.png","domain":"dyndns.org","address":{"address":"2010 Rising Hill Drive","city":"Norman","postalCode":"73071","state":"OK"}},{"id":43,"firstName":"Garret","lastName":"Klocko","maidenName":"Welch","age":44,"gender":"male","email":"kbrecknock16@marriott.com","phone":"+86 787 794 2189","username":"kbrecknock16","image":"https://robohash.org/amaioresqui.png","domain":"loc.gov","address":{"address":"388 East Main Street","postalCode":"05753","state":"VT"}},{"id":44,"firstName":"Reginald","lastName":"Wisoky","maidenName":"Koelpin","age":46,"gender":"male","email":"rlaxe17@tamu.edu","phone":"+420 762 758 3107","username":"rlaxe17","image":"https://robohash.org/vitaeharumquia.png","domain":"newsvine.com","address":{"address":"450 Kinhawk Drive","city":"Nashville","postalCode":"37211","state":"TN"}},{"id":45,"firstName":"Humberto","lastName":"Botsford","maidenName":"Kihn","age":37,"gender":"male","email":"pidill18@china.com.cn","phone":"+228 252 183 9834","username":"pidill18","image":"https://robohash.org/liberoquaeratquidem.png","domain":"aol.com","address":{"address":"131 Westerly Street","city":"Manchester","postalCode":"06042","state":"CT"}},{"id":46,"firstName":"Justus","lastName":"Sipes","maidenName":"Quigley","age":45,"gender":"male","email":"rmcritchie19@topsy.com","phone":"+504 281 452 1944","username":"rmcritchie19","image":"https://robohash.org/veritatismodiest.png","domain":"weibo.com","address":{"address":"308 Woodleaf Court","city":"Glen Burnie","postalCode":"21061","state":"MD"}},{"id":47,"firstName":"Coralie","lastName":"Boyle","maidenName":"Tremblay","age":18,"gender":"female","email":"rlangston1a@51.la","phone":"+352 643 270 7653","username":"rlangston1a","image":"https://robohash.org/quivoluptatepraesentium.png","domain":"webnode.com","address":{"address":"8502 Madrone Avenue","city":"Louisville","postalCode":"40258","state":"KY"}},{"id":48,"firstName":"Felicita","lastName":"Gibson","maidenName":"Leuschke","age":32,"gender":"female","email":"jevanson1b@admin.ch","phone":"+86 484 331 2036","username":"jevanson1b","image":"https://robohash.org/numquamcumquereiciendis.png","domain":"1und1.de","address":{"address":"23 Sable Run Lane","city":"Methuen","postalCode":"01844","state":"MA"}},{"id":49,"firstName":"Pearl","lastName":"Blick","maidenName":"Armstrong","age":26,"gender":"female","email":"ssarjant1c@statcounter.com","phone":"+261 856 633 1458","username":"ssarjant1c","image":"https://robohash.org/etnemoet.png","domain":"whitehouse.gov","address":{"address":"716 Waller Road","city":"Brentwood","postalCode":"37027","state":"TN"}},{"id":50,"firstName":"Johnathon","lastName":"Predovic","maidenName":"Will","age":18,"gender":"male","email":"xlinster1d@bravesites.com","phone":"+351 572 534 5789","username":"xlinster1d","image":"https://robohash.org/nisietqui.png","domain":"booking.com","address":{"address":"416 McIver Street","city":"Nashville","postalCode":"37211","state":"TN"}},{"id":51,"firstName":"Jerry","lastName":"Kertzmann","maidenName":"Smitham","age":43,"gender":"male","email":"tmullender1e@scientificamerican.com","phone":"+1 281 300 2097","username":"tmullender1e","image":"https://robohash.org/aliquideosquidem.png","domain":"linkedin.com","address":{"address":"1508 Massachusetts Avenue Southeast","city":"Washington","postalCode":"20003","state":"DC"}},{"id":52,"firstName":"Elbert","lastName":"Gottlieb","maidenName":"Konopelski","age":41,"gender":"male","email":"gmein1f@nasa.gov","phone":"+86 820 969 6388","username":"gmein1f","image":"https://robohash.org/omnisipsasit.png","domain":"mozilla.com","address":{"address":"5615 West Villa Maria Drive","city":"Glendale","postalCode":"85308","state":"AZ"}},{"id":53,"firstName":"Sincere","lastName":"Mueller","maidenName":"Keeling","age":44,"gender":"female","email":"gmaccumeskey1g@buzzfeed.com","phone":"+62 206 931 3800","username":"gmaccumeskey1g","image":"https://robohash.org/minimaquamcorrupti.png","domain":"miitbeian.gov.cn","address":{"address":"3162 Martin Luther King Junior Boulevard","city":"Fayetteville","postalCode":"72704","state":"AR"}},{"id":54,"firstName":"Telly","lastName":"Spinka","maidenName":"Conroy","age":22,"gender":"female","email":"bpetts1h@smugmug.com","phone":"+62 820 759 6656","username":"bpetts1h","image":"https://robohash.org/quianonquia.png","domain":"free.fr","address":{"address":"5306 Ritchie Highway","city":"Baltimore","postalCode":"21225","state":"MD"}},{"id":55,"firstName":"Hal","lastName":"Keebler","maidenName":"Huel","age":45,"gender":"male","email":"ajozef1i@usatoday.com","phone":"+48 553 262 8275","username":"ajozef1i","image":"https://robohash.org/animiautillo.png","domain":"hud.gov","address":{"address":"109 Summit Street","city":"Burlington","postalCode":"05401","state":"VT"}},{"id":56,"firstName":"Megane","lastName":"Armstrong","maidenName":"Homenick","age":46,"gender":"female","email":"oyakushkev1j@oracle.com","phone":"+1 941 123 2756","username":"oyakushkev1j","image":"https://robohash.org/voluptatemexplicaboasperiores.png","domain":"nps.gov","address":{"address":"816 West 19th Avenue","city":"Anchorage","postalCode":"99503","state":"AK"}},{"id":57,"firstName":"Toy","lastName":"Olson","maidenName":"Gerhold","age":27,"gender":"male","email":"bpickering1k@clickbank.net","phone":"+1 423 134 5423","username":"bpickering1k","image":"https://robohash.org/eumestdolor.png","domain":"washington.edu","address":{"address":"172 Alburg Springs Road","city":"Alburgh","postalCode":"05440","state":"VT"}},{"id":58,"firstName":"Deanna","lastName":"Glover","maidenName":"Beatty","age":30,"gender":"female","email":"nworley1l@thetimes.co.uk","phone":"+994 653 357 2437","username":"nworley1l","image":"https://robohash.org/porroaccusamuseveniet.png","domain":"arstechnica.com","address":{"address":"159 Downey Drive","city":"Manchester","postalCode":"06040","state":"CT"}},{"id":59,"firstName":"Marcella","lastName":"Shanahan","maidenName":"Luettgen","age":26,"gender":"female","email":"klife1m@i2i.jp","phone":"+62 248 837 6818","username":"klife1m","image":"https://robohash.org/eaipsaaliquam.png","domain":"bing.com","address":{"address":"125 John Street","city":"Santa Cruz","postalCode":"95060","state":"CA"}},{"id":60,"firstName":"Rachel","lastName":"Jacobson","maidenName":"Raynor","age":31,"gender":"female","email":"dlambarth1n@blinklist.com","phone":"+420 101 364 3391","username":"dlambarth1n","image":"https://robohash.org/doloremtemporamolestiae.png","domain":"unc.edu","address":{"address":"1101 Lotus Avenue","city":"Glen Burnie","postalCode":"21061","state":"MD"}},{"id":61,"firstName":"Nora","lastName":"Sawayn","maidenName":"Bailey","age":46,"gender":"female","email":"cepgrave1o@biblegateway.com","phone":"+1 614 425 6745","username":"cepgrave1o","image":"https://robohash.org/corporisvoluptatumdicta.png","domain":"cpanel.net","address":{"address":"8376 Albacore Drive","city":"Pasadena","postalCode":"21122","state":"MD"}},{"id":62,"firstName":"Mozell","lastName":"O\'Connell","maidenName":"Harvey","age":33,"gender":"female","email":"mpoyner1p@google.co.uk","phone":"+86 694 202 1947","username":"mpoyner1p","image":"https://robohash.org/sintsequitenetur.png","domain":"squarespace.com","address":{"address":"491 Arabian Way","city":"Grand Junction","postalCode":"81504","state":"CO"}},{"id":63,"firstName":"Nasir","lastName":"Leuschke","maidenName":"Prosacco","age":37,"gender":"male","email":"eburras1q@go.com","phone":"+62 770 940 9687","username":"eburras1q","image":"https://robohash.org/dignissimosplaceatet.png","domain":"ftc.gov","address":{"address":"12245 West 71st Place","city":"Arvada","postalCode":"80004","state":"CO"}},{"id":64,"firstName":"Quinn","lastName":"Witting","maidenName":"Gleichner","age":49,"gender":"male","email":"gfernandes1r@virginia.edu","phone":"+220 898 206 2696","username":"gfernandes1r","image":"https://robohash.org/distinctioullamsaepe.png","domain":"123-reg.co.uk","address":{"address":"80 North East Street","city":"Holyoke","postalCode":"01040","state":"MA"}},{"id":65,"firstName":"Jeanne","lastName":"O\'Keefe","maidenName":"Rogahn","age":26,"gender":"female","email":"hollet1s@trellian.com","phone":"+62 717 913 4633","username":"hollet1s","image":"https://robohash.org/reprehenderitquisanimi.png","domain":"noaa.gov","address":{"address":"4695 East Huntsville Road","city":"Fayetteville","postalCode":"72701","state":"AR"}},{"id":66,"firstName":"Terrence","lastName":"Koelpin","maidenName":"Nienow","age":28,"gender":"male","email":"hfasey1t@home.pl","phone":"+63 460 531 0660","username":"hfasey1t","image":"https://robohash.org/facilisomnisvoluptatem.png","domain":"woothemes.com","address":{"address":"310 Timrod Road","city":"Manchester","postalCode":"06040","state":"CT"}},{"id":67,"firstName":"Davonte","lastName":"Heaney","maidenName":"DuBuque","age":33,"gender":"male","email":"gbarhams1u@cnet.com","phone":"+52 250 381 1317","username":"gbarhams1u","image":"https://robohash.org/ipsadistinctiovero.png","domain":"msn.com","address":{"address":"1364 Capri Drive","city":"Panama City","postalCode":"32405","state":"FL"}},{"id":68,"firstName":"Everette","lastName":"Prohaska","maidenName":"Schumm","age":50,"gender":"female","email":"rstrettle1v@globo.com","phone":"+55 539 822 6581","username":"rstrettle1v","image":"https://robohash.org/cumquesedrem.png","domain":"meetup.com","address":{"address":"132 Laurel Green Court","city":"Savannah","postalCode":"31419","state":"GA"}},{"id":69,"firstName":"Oda","lastName":"Schmidt","maidenName":"Zemlak","age":22,"gender":"male","email":"btegler1w@elegantthemes.com","phone":"+55 537 574 0273","username":"btegler1w","image":"https://robohash.org/asperioressolutaet.png","domain":"mail.ru","address":{"address":"6657 West Rose Garden Lane","city":"Glendale","postalCode":"85308","state":"AZ"}},{"id":70,"firstName":"Twila","lastName":"Padberg","maidenName":"Kozey","age":42,"gender":"female","email":"cmasurel1x@baidu.com","phone":"+86 426 681 8895","username":"cmasurel1x","image":"https://robohash.org/quiaeaquefacere.png","domain":"dropbox.com","address":{"address":"519 West 75th Avenue","city":"Anchorage","postalCode":"99518","state":"AK"}},{"id":71,"firstName":"Amelia","lastName":"Mann","maidenName":"Satterfield","age":30,"gender":"female","email":"omarsland1y@washingtonpost.com","phone":"+62 924 155 6791","username":"omarsland1y","image":"https://robohash.org/voluptassimiliqueet.png","domain":"google.com.hk","address":{"address":"31353 Santa Elena Way","city":"Union City","postalCode":"94587","state":"CA"}},{"id":72,"firstName":"Frederique","lastName":"Boehm","maidenName":"Bergstrom","age":39,"gender":"female","email":"mcrumpe1z@techcrunch.com","phone":"+63 528 723 2388","username":"mcrumpe1z","image":"https://robohash.org/doloremqueatqueet.png","domain":"nature.com","address":{"address":"8398 West Denton Lane","city":"Glendale","postalCode":"85305","state":"AZ"}},{"id":73,"firstName":"Clotilde","lastName":"Larson","maidenName":"Zboncak","age":45,"gender":"female","email":"wfeldon20@netlog.com","phone":"+86 773 539 4246","username":"wfeldon20","image":"https://robohash.org/estipsamincidunt.png","domain":"mysql.com","address":{"address":"700 Winston Place","city":"Anchorage","postalCode":"99504","state":"AK"}},{"id":74,"firstName":"Moriah","lastName":"Mills","maidenName":"Bashirian","age":45,"gender":"male","email":"ahinckes21@google.es","phone":"+386 147 761 5345","username":"ahinckes21","image":"https://robohash.org/voluptatemdolorumvel.png","domain":"multiply.com","address":{"address":"232 Maine Avenue","city":"Panama City","postalCode":"32401","state":"FL"}},{"id":75,"firstName":"Claudia","lastName":"Dooley","maidenName":"O\'Reilly","age":36,"gender":"female","email":"ptilson22@360.cn","phone":"+86 477 915 2470","username":"ptilson22","image":"https://robohash.org/idvoluptatemrepellendus.png","domain":"mayoclinic.com","address":{"address":"1 Kempf Drive","city":"Easton","postalCode":"02375","state":"MA"}},{"id":76,"firstName":"Deon","lastName":"Gutkowski","maidenName":"Hudson","age":39,"gender":"male","email":"cgaber23@prlog.org","phone":"+30 927 372 5358","username":"cgaber23","image":"https://robohash.org/authicnon.png","domain":"yelp.com","address":{"address":"5811 Crossings Boulevard","city":"Nashville","postalCode":"37013","state":"TN"}},{"id":77,"firstName":"Amos","lastName":"Weimann","maidenName":"Reinger","age":22,"gender":"male","email":"rkingswood24@usa.gov","phone":"+230 749 323 8084","username":"rkingswood24","image":"https://robohash.org/quasialiquidrerum.png","domain":"wufoo.com","address":{"address":"5108 Franklin Street","city":"Savannah","postalCode":"31405","state":"GA"}},{"id":78,"firstName":"Frankie","lastName":"Hudson","maidenName":"Wiza","age":32,"gender":"male","email":"dbuist25@hao123.com","phone":"+33 604 197 4892","username":"dbuist25","image":"https://robohash.org/voluptaseligendiaut.png","domain":"adobe.com","address":{"address":"913 Fallview Trail","city":"Nashville","postalCode":"37211","state":"TN"}},{"id":79,"firstName":"Harrison","lastName":"Lemke","maidenName":"Gottlieb","age":20,"gender":"male","email":"pmoraleda26@symantec.com","phone":"+62 458 347 7200","username":"pmoraleda26","image":"https://robohash.org/hicadipisciodio.png","domain":"sina.com.cn","address":{"address":"270 Chrissy\'s Court","postalCode":"05443","state":"VT"}},{"id":80,"firstName":"Guy","lastName":"Franecki","maidenName":"Ruecker","age":31,"gender":"male","email":"vkohrt27@hostgator.com","phone":"+86 758 872 4898","username":"vkohrt27","image":"https://robohash.org/quaeratpariaturet.png","domain":"gizmodo.com","address":{"address":"130 Old Route 103","city":"Chester","postalCode":"05143","state":"VT"}},{"id":81,"firstName":"Sidney","lastName":"Rutherford","maidenName":"Senger","age":50,"gender":"male","email":"capplewhite28@nationalgeographic.com","phone":"+62 406 110 4091","username":"capplewhite28","image":"https://robohash.org/dolorumdelenitinon.png","domain":"salon.com","address":{"address":"10826 Pointe Royal Drive","city":"Bakersfield","postalCode":"93311","state":"CA"}},{"id":82,"firstName":"Maymie","lastName":"Yundt","maidenName":"Koch","age":42,"gender":"female","email":"kogilvy29@blogtalkradio.com","phone":"+354 978 613 2483","username":"kogilvy29","image":"https://robohash.org/providentquiaaut.png","domain":"hugedomains.com","address":{"address":"74 Ranch Drive","city":"Montgomery","postalCode":"36109","state":"AL"}},{"id":83,"firstName":"Rita","lastName":"Shields","maidenName":"Mante","age":47,"gender":"female","email":"gconford2a@wordpress.com","phone":"+86 148 509 2978","username":"gconford2a","image":"https://robohash.org/sapientelaborumminima.png","domain":"drupal.org","address":{"address":"6601 West Ocotillo Road","city":"Glendale","postalCode":"85301","state":"AZ"}},{"id":84,"firstName":"Aniya","lastName":"Wisozk","maidenName":"Koepp","age":49,"gender":"female","email":"dmantle2b@reuters.com","phone":"+63 811 971 2922","username":"dmantle2b","image":"https://robohash.org/aliasiurenam.png","domain":"tiny.cc","address":{"address":"19416 Barclay Road","city":"Castro Valley","postalCode":"94546","state":"CA"}},{"id":85,"firstName":"Angelica","lastName":"Metz","maidenName":"Gutkowski","age":48,"gender":"female","email":"kpondjones2c@nsw.gov.au","phone":"+47 496 716 8666","username":"kpondjones2c","image":"https://robohash.org/atetsit.png","domain":"nymag.com","address":{"address":"1347 Blackwalnut Court","city":"Annapolis","postalCode":"21403","state":"MD"}},{"id":86,"firstName":"Rupert","lastName":"Upton","maidenName":"Schuster","age":22,"gender":"male","email":"whuman2d@hp.com","phone":"+1 907 460 1257","username":"whuman2d","image":"https://robohash.org/mollitiasimiliqueneque.png","domain":"usgs.gov","address":{"address":"1770 Colony Way","city":"Fayetteville","postalCode":"72704","state":"AR"}},{"id":87,"firstName":"Eleazar","lastName":"Torp","maidenName":"Reinger","age":28,"gender":"male","email":"fschlagman2e@deliciousdays.com","phone":"+57 170 928 2357","username":"fschlagman2e","image":"https://robohash.org/facerealiquidexercitationem.png","domain":"google.pl","address":{"address":"165 Saint John Street","city":"Manchester","postalCode":"06040","state":"CT"}},{"id":88,"firstName":"Anais","lastName":"Yundt","maidenName":"Rath","age":32,"gender":"female","email":"agreenhouse2f@mashable.com","phone":"+691 914 748 8902","username":"agreenhouse2f","image":"https://robohash.org/laborumvoluptatibusnulla.png","domain":"chronoengine.com","address":{"address":"2409 Research Boulevard","city":"Fort Collins","postalCode":"80526","state":"CO"}},{"id":89,"firstName":"Gayle","lastName":"Krajcik","maidenName":"Johnson","age":31,"gender":"male","email":"cdwyr2g@shop-pro.jp","phone":"+509 383 303 8524","username":"cdwyr2g","image":"https://robohash.org/inventoredelenitiquas.png","domain":"stanford.edu","address":{"address":"1903 Bashford Manor Lane","city":"Louisville","postalCode":"40218","state":"KY"}},{"id":90,"firstName":"Wilma","lastName":"Hickle","maidenName":"Nicolas","age":19,"gender":"female","email":"omottley2h@hugedomains.com","phone":"+7 330 984 6093","username":"omottley2h","image":"https://robohash.org/minimadoloreslaborum.png","domain":"squarespace.com","address":{"address":"8315 Surf Drive","city":"Panama City Beach","postalCode":"32408","state":"FL"}},{"id":91,"firstName":"Arne","lastName":"Jacobs","maidenName":"Botsford","age":29,"gender":"male","email":"hyaknov2i@hhs.gov","phone":"+36 610 490 0839","username":"hyaknov2i","image":"https://robohash.org/necessitatibusvoluptatemvero.png","domain":"upenn.edu","address":{"address":"3301 Old Muldoon Road","city":"Anchorage","postalCode":"99504","state":"AK"}},{"id":92,"firstName":"Emely","lastName":"Schmitt","maidenName":"Waters","age":48,"gender":"female","email":"clambol2j@bloglovin.com","phone":"+86 478 217 4353","username":"clambol2j","image":"https://robohash.org/cumqueharumsunt.png","domain":"pagesperso-orange.fr","address":{"address":"8800 Cordell Circle","city":"Anchorage","postalCode":"99502","state":"AK"}},{"id":93,"firstName":"Fabiola","lastName":"Oberbrunner","maidenName":"Breitenberg","age":43,"gender":"female","email":"dduggan2k@simplemachines.org","phone":"+86 614 316 0439","username":"dduggan2k","image":"https://robohash.org/undeutveritatis.png","domain":"squarespace.com","address":{"address":"117 East Cook Avenue","city":"Anchorage","postalCode":"99501","state":"AK"}},{"id":94,"firstName":"Kari","lastName":"Schinner","maidenName":"Monahan","age":21,"gender":"female","email":"jtossell2l@drupal.org","phone":"+60 470 340 3453","username":"jtossell2l","image":"https://robohash.org/quisquamhicin.png","domain":"google.com.br","address":{"address":"6231 North 67th Avenue","city":"Glendale","postalCode":"85301","state":"AZ"}},{"id":95,"firstName":"Rory","lastName":"Conn","maidenName":"Lehner","age":20,"gender":"male","email":"cchomiszewski2m@cbsnews.com","phone":"+62 215 871 4657","username":"cchomiszewski2m","image":"https://robohash.org/autcommodivoluptas.png","domain":"yolasite.com","address":{"address":"8505 Waters Avenue","city":"Savannah","postalCode":"31406","state":"GA"}},{"id":96,"firstName":"Cristobal","lastName":"Watsica","maidenName":"Romaguera","age":33,"gender":"male","email":"bgoby2n@washingtonpost.com","phone":"+380 842 468 9675","username":"bgoby2n","image":"https://robohash.org/deseruntfaciliset.png","domain":"slate.com","address":{"address":"7 Underwood Place Northwest","city":"Washington","postalCode":"20012","state":"DC"}},{"id":97,"firstName":"Allene","lastName":"Harber","maidenName":"Rosenbaum","age":32,"gender":"female","email":"cdavydochkin2o@globo.com","phone":"+389 880 536 3911","username":"cdavydochkin2o","image":"https://robohash.org/adipiscisiteius.png","domain":"yellowbook.com","address":{"address":"21950 Arnold Center Road","city":"Carson","postalCode":"90810","state":"CA"}},{"id":98,"firstName":"Lempi","lastName":"Runte","maidenName":"Rogahn","age":25,"gender":"female","email":"zstenning2p@list-manage.com","phone":"+81 529 266 5313","username":"zstenning2p","image":"https://robohash.org/estetlaudantium.png","domain":"state.gov","address":{"address":"1427 South Carolina Avenue Southeast","city":"Washington","postalCode":"20003","state":"DC"}},{"id":99,"firstName":"Terrell","lastName":"Schuppe","maidenName":"Bailey","age":38,"gender":"male","email":"flesslie2q@google.nl","phone":"+371 241 489 8335","username":"flesslie2q","image":"https://robohash.org/maioresethic.png","domain":"ovh.net","address":{"address":"1420 Turtleback Trail","city":"Panama City","postalCode":"32413","state":"FL"}},{"id":100,"firstName":"Tevin","lastName":"Prohaska","maidenName":"Rowe","age":34,"gender":"male","email":"pcumbes2r@networkadvertising.org","phone":"+46 185 553 3726","username":"pcumbes2r","image":"https://robohash.org/eosvoluptasquia.png","domain":"odnoklassniki.ru","address":{"address":"109 Summit Street","city":"Burlington","postalCode":"05401","state":"VT"}}],"total":100,"skip":0,"limit":100}');


function $f3b1940c79cc12bc$var$getRandomUsers() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1c451d693212408b$exports)))((0, $e4daaf22c1549cc0$exports.users)).slice(0, 5);
}
const $f3b1940c79cc12bc$export$b5d74b812cac8157 = (0, $1e2a96dfa0b62734$export$cf6fa0bbcc94b912)({
    debugLabel: "userProfileCache",
    load: async ([id])=>{
        return new Promise((resolve, reject)=>{
            const delay = 500 + Math.random() * 4500;
            setTimeout(()=>{
                const user = (0, $e4daaf22c1549cc0$exports.users).find((user)=>user.id === id);
                if (user) resolve(user);
                else reject(`User not found: ${id}`);
            }, delay);
        });
    }
});
const $f3b1940c79cc12bc$export$14237c299ae27867 = /*#__PURE__*/ (0, $k116o.createContext)(null);
function $f3b1940c79cc12bc$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $k116o.Suspense), {
        fallback: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $eadd3566518c92e3$export$2e2bcd8739ae039), {}),
        children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($f3b1940c79cc12bc$var$DemoSuspends, {})
    });
}
function $f3b1940c79cc12bc$var$DemoSuspends() {
    const [filteredUsers, setFilteredUsers] = (0, $k116o.useState)($f3b1940c79cc12bc$var$getRandomUsers);
    const [state, setState] = (0, $k116o.useState)("ready");
    const [selectedUserId, setSelectedUserId] = (0, $k116o.useState)(null);
    const context = (0, $k116o.useMemo)(()=>({
            selectedUserId: selectedUserId,
            setSelectedUserId: setSelectedUserId
        }), [
        selectedUserId
    ]);
    (0, $k116o.useEffect)(()=>{
        return ()=>{
            filteredUsers.map(({ id: id })=>$f3b1940c79cc12bc$export$b5d74b812cac8157.evict(id));
        };
    }, []);
    const handleClick = async ()=>{
        switch(state){
            case "ready":
                setState("running");
                await Promise.all(filteredUsers.map(({ id: id })=>$f3b1940c79cc12bc$export$b5d74b812cac8157.readAsync(id)));
                setState("complete");
                break;
            case "complete":
                filteredUsers.map(({ id: id })=>$f3b1940c79cc12bc$export$b5d74b812cac8157.evict(id));
                setFilteredUsers($f3b1940c79cc12bc$var$getRandomUsers());
                setSelectedUserId(null);
                setState("ready");
                break;
        }
    };
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)($f3b1940c79cc12bc$export$14237c299ae27867.Provider, {
        value: context,
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ba040e451e378248$exports))).ButtonRow,
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("button", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ba040e451e378248$exports))).MainButton,
                        disabled: state !== "ready",
                        onClick: handleClick,
                        children: "Start demo"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("button", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ba040e451e378248$exports))).MainButton,
                        disabled: state !== "complete",
                        onClick: handleClick,
                        children: "Reset demo"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("section", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ba040e451e378248$exports))).App,
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("nav", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ba040e451e378248$exports))).SideNav,
                        children: filteredUsers.map(({ id: id, firstName: firstName, lastName: lastName })=>/*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($f3b1940c79cc12bc$var$UserLink, {
                                id: id,
                                name: `${firstName} ${lastName}`
                            }, id))
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("main", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ba040e451e378248$exports))).Main,
                        children: selectedUserId ? /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $k116o.Suspense), {
                            fallback: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($f3b1940c79cc12bc$var$Placeholder, {
                                title: "Loading..."
                            }),
                            children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($f3b1940c79cc12bc$var$UserProfile, {
                                id: selectedUserId
                            })
                        }, selectedUserId) : /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($f3b1940c79cc12bc$var$Placeholder, {
                            title: "No user selected"
                        })
                    })
                ]
            })
        ]
    });
}
function $f3b1940c79cc12bc$var$Placeholder({ title: title }) {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ba040e451e378248$exports))).Placeholder,
        children: title
    });
}
function $f3b1940c79cc12bc$var$UserProfile({ id: id }) {
    const deferredId = (0, $k116o.useDeferredValue)(id);
    const userProfile = $f3b1940c79cc12bc$export$b5d74b812cac8157.read(deferredId);
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $110956e5e1cd1426$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("h3", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ba040e451e378248$exports))).Header,
                children: [
                    userProfile.firstName,
                    " ",
                    userProfile.lastName
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("label", {
                                children: "Address"
                            }),
                            ":",
                            userProfile.address.address,
                            ",",
                            " ",
                            userProfile.address.city,
                            ", ",
                            userProfile.address.state,
                            " ",
                            userProfile.address.postalCode
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("label", {
                                children: "Phone"
                            }),
                            ": ",
                            userProfile.phone
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("label", {
                                children: "Email"
                            }),
                            ": ",
                            userProfile.email
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("label", {
                                children: "Website"
                            }),
                            ": ",
                            userProfile.domain
                        ]
                    })
                ]
            })
        ]
    });
}
function $f3b1940c79cc12bc$var$UserLink({ id: id, name: name }) {
    const { selectedUserId: selectedUserId, setSelectedUserId: setSelectedUserId } = (0, $k116o.useContext)($f3b1940c79cc12bc$export$14237c299ae27867);
    const isCurrent = id === selectedUserId;
    const status = (0, $d70beb1831956ba7$export$a0b0284d625c6d1d)($f3b1940c79cc12bc$export$b5d74b812cac8157, id);
    const handleClick = ()=>{
        setSelectedUserId(id);
    };
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ba040e451e378248$exports))).UserButton,
        "data-current": isCurrent || undefined,
        "data-status": status,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $6ad442de320ca11f$export$f25dae4ff53797bf), {
                id: id
            }),
            " ",
            name
        ]
    });
}


function $fa86050eb0f28a0f$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $aa6eba4c47b97eb7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $4b3065620e983e4c$export$2e2bcd8739ae039), {
                    title: "render cache status"
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "The demo below shows how ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "useCacheStatus"
                            }),
                            " can be used to render UI based on the status of a cached item."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: 'Click the "start demo" button to fetch user data in the cache.'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                type: "demo",
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f3b1940c79cc12bc$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "Although the ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "UserStatusBadge"
                            }),
                            " component neither schedules the update with React nor suspends to load user data,",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: "useCacheStatus"
                            }),
                            " allows it to render status updates in response to cache changes."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$7eb1b49cd2af1357).renderingCacheStatus.UserStatusBadge
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "The full code for the demo can be found",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $7ec290908b96eb45$export$b2bf131c9f9cce5d), {
                                to: "https://github.com/bvaughn/suspense/tree/main/packages/suspense-website/src/examples/demos",
                                children: "here"
                            }),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                children: "The cache in this demo uses a timeout to simulate a slow network request."
            })
        ]
    });
}













var $k116o = parcelRequire("k116o");


var $c197f5c73b7078af$exports = {};

$parcel$export($c197f5c73b7078af$exports, "App", () => $c197f5c73b7078af$export$86fbec116b87613f, (v) => $c197f5c73b7078af$export$86fbec116b87613f = v);
$parcel$export($c197f5c73b7078af$exports, "Button", () => $c197f5c73b7078af$export$353f5b6fc5456de1, (v) => $c197f5c73b7078af$export$353f5b6fc5456de1 = v);
$parcel$export($c197f5c73b7078af$exports, "ButtonRow", () => $c197f5c73b7078af$export$564cbe3426fc093a, (v) => $c197f5c73b7078af$export$564cbe3426fc093a = v);
$parcel$export($c197f5c73b7078af$exports, "PlaceholderRow", () => $c197f5c73b7078af$export$7e13c2c4202bba3b, (v) => $c197f5c73b7078af$export$7e13c2c4202bba3b = v);
$parcel$export($c197f5c73b7078af$exports, "PostBody", () => $c197f5c73b7078af$export$2c130dfee87cd3dc, (v) => $c197f5c73b7078af$export$2c130dfee87cd3dc = v);
$parcel$export($c197f5c73b7078af$exports, "PostHeaderRow", () => $c197f5c73b7078af$export$591c53dde67e353b, (v) => $c197f5c73b7078af$export$591c53dde67e353b = v);
$parcel$export($c197f5c73b7078af$exports, "PostName", () => $c197f5c73b7078af$export$cb49b688ea2012b, (v) => $c197f5c73b7078af$export$cb49b688ea2012b = v);
$parcel$export($c197f5c73b7078af$exports, "PostRow", () => $c197f5c73b7078af$export$1bb021761b2f83a, (v) => $c197f5c73b7078af$export$1bb021761b2f83a = v);
$parcel$export($c197f5c73b7078af$exports, "PostTag", () => $c197f5c73b7078af$export$5eac470b63563a43, (v) => $c197f5c73b7078af$export$5eac470b63563a43 = v);
$parcel$export($c197f5c73b7078af$exports, "PostTags", () => $c197f5c73b7078af$export$2e77c620981dccc1, (v) => $c197f5c73b7078af$export$2e77c620981dccc1 = v);
$parcel$export($c197f5c73b7078af$exports, "PostTitle", () => $c197f5c73b7078af$export$a15effe9bab1a861, (v) => $c197f5c73b7078af$export$a15effe9bab1a861 = v);
$parcel$export($c197f5c73b7078af$exports, "Posts", () => $c197f5c73b7078af$export$d074f14c5fd21603, (v) => $c197f5c73b7078af$export$d074f14c5fd21603 = v);
$parcel$export($c197f5c73b7078af$exports, "ProgressBarInner", () => $c197f5c73b7078af$export$bd997b82f594ccf6, (v) => $c197f5c73b7078af$export$bd997b82f594ccf6 = v);
$parcel$export($c197f5c73b7078af$exports, "ProgressBarOuter", () => $c197f5c73b7078af$export$b6bb8c51b2303d8, (v) => $c197f5c73b7078af$export$b6bb8c51b2303d8 = v);
var $c197f5c73b7078af$export$86fbec116b87613f;
var $c197f5c73b7078af$export$353f5b6fc5456de1;
var $c197f5c73b7078af$export$564cbe3426fc093a;
var $c197f5c73b7078af$export$7e13c2c4202bba3b;
var $c197f5c73b7078af$export$2c130dfee87cd3dc;
var $c197f5c73b7078af$export$591c53dde67e353b;
var $c197f5c73b7078af$export$cb49b688ea2012b;
var $c197f5c73b7078af$export$1bb021761b2f83a;
var $c197f5c73b7078af$export$5eac470b63563a43;
var $c197f5c73b7078af$export$2e77c620981dccc1;
var $c197f5c73b7078af$export$a15effe9bab1a861;
var $c197f5c73b7078af$export$d074f14c5fd21603;
var $c197f5c73b7078af$export$bd997b82f594ccf6;
var $c197f5c73b7078af$export$b6bb8c51b2303d8;
$c197f5c73b7078af$export$86fbec116b87613f = `_0zsRbW_App`;
$c197f5c73b7078af$export$353f5b6fc5456de1 = `_0zsRbW_Button`;
$c197f5c73b7078af$export$564cbe3426fc093a = `_0zsRbW_ButtonRow`;
$c197f5c73b7078af$export$7e13c2c4202bba3b = `_0zsRbW_PlaceholderRow`;
$c197f5c73b7078af$export$2c130dfee87cd3dc = `_0zsRbW_PostBody`;
$c197f5c73b7078af$export$591c53dde67e353b = `_0zsRbW_PostHeaderRow`;
$c197f5c73b7078af$export$cb49b688ea2012b = `_0zsRbW_PostName`;
$c197f5c73b7078af$export$1bb021761b2f83a = `_0zsRbW_PostRow`;
$c197f5c73b7078af$export$5eac470b63563a43 = `_0zsRbW_PostTag`;
$c197f5c73b7078af$export$2e77c620981dccc1 = `_0zsRbW_PostTags`;
$c197f5c73b7078af$export$a15effe9bab1a861 = `_0zsRbW_PostTitle`;
$c197f5c73b7078af$export$d074f14c5fd21603 = `_0zsRbW_Posts`;
$c197f5c73b7078af$export$bd997b82f594ccf6 = `_0zsRbW_ProgressBarInner`;
$c197f5c73b7078af$export$b6bb8c51b2303d8 = `_0zsRbW_ProgressBarOuter`;


var $0600775e0f3da28b$exports = {};
$0600775e0f3da28b$exports = JSON.parse('{"posts":[{"id":1,"title":"His mother had always taught him","body":"His mother had always taught him not to ever think of himself as better than others. He\'d tried to live by this motto. He never looked down on those who were less fortunate or who had less money than him. But the stupidity of the group of people he was talking to made him change his mind.","userId":9,"tags":["history","american","crime"]},{"id":2,"title":"He was an expert but not in a discipline","body":"He was an expert but not in a discipline that anyone could fully appreciate. He knew how to hold the cone just right so that the soft server ice-cream fell into it at the precise angle to form a perfect cone each and every time. It had taken years to perfect and he could now do it without even putting any thought behind it.","userId":13,"tags":["french","fiction","english"]},{"id":3,"title":"Dave watched as the forest burned up on the hill.","body":"Dave watched as the forest burned up on the hill, only a few miles from her house. The car had been hastily packed and Marta was inside trying to round up the last of the pets. Dave went through his mental list of the most important papers and documents that they couldn\'t leave behind. He scolded himself for not having prepared these better in advance and hoped that he had remembered everything that was needed. He continued to wait for Marta to appear with the pets, but she still was nowhere to be seen.","userId":32,"tags":["magical","history","french"]},{"id":4,"title":"All he wanted was a candy bar.","body":"All he wanted was a candy bar. It didn\'t seem like a difficult request to comprehend, but the clerk remained frozen and didn\'t seem to want to honor the request. It might have had something to do with the gun pointed at his face.","userId":12,"tags":["mystery","english","american"]},{"id":5,"title":"Hopes and dreams were dashed that day.","body":"Hopes and dreams were dashed that day. It should have been expected, but it still came as a shock. The warning signs had been ignored in favor of the possibility, however remote, that it could actually happen. That possibility had grown from hope to an undeniable belief it must be destiny. That was until it wasn\'t and the hopes and dreams came crashing down.","userId":41,"tags":["crime","mystery","love"]},{"id":6,"title":"Dave wasn\'t exactly sure how he had ended up","body":"Dave wasn\'t exactly sure how he had ended up in this predicament. He ran through all the events that had lead to this current situation and it still didn\'t make sense. He wanted to spend some time to try and make sense of it all, but he had higher priorities at the moment. The first was how to get out of his current situation of being naked in a tree with snow falling all around and no way for him to get down.","userId":47,"tags":["english","classic","american"]},{"id":7,"title":"This is important to remember.","body":"This is important to remember. Love isn\'t like pie. You don\'t need to divide it among all your friends and loved ones. No matter how much love you give, you can always give more. It doesn\'t run out, so don\'t try to hold back giving it as if it may one day run out. Give it freely and as much as you want.","userId":12,"tags":["magical","crime"]},{"id":8,"title":"One can cook on and with an open fire.","body":"One can cook on and with an open fire. These are some of the ways to cook with fire outside. Cooking meat using a spit is a great way to evenly cook meat. In order to keep meat from burning, it\'s best to slowly rotate it.","userId":31,"tags":["american","english"]},{"id":9,"title":"There are different types of secrets.","body":"There are different types of secrets. She had held onto plenty of them during her life, but this one was different. She found herself holding onto the worst type. It was the type of secret that could gnaw away at your insides if you didn\'t tell someone about it, but it could end up getting you killed if you did.","userId":42,"tags":["american","history","magical"]},{"id":10,"title":"They rushed out the door.","body":"They rushed out the door, grabbing anything and everything they could think of they might need. There was no time to double-check to make sure they weren\'t leaving something important behind. Everything was thrown into the car and they sped off. Thirty minutes later they were safe and that was when it dawned on them that they had forgotten the most important thing of all.","userId":1,"tags":["fiction","magical","history"]},{"id":11,"title":"It wasn\'t quite yet time to panic.","body":"It wasn\'t quite yet time to panic. There was still time to salvage the situation. At least that is what she was telling himself. The reality was that it was time to panic and there wasn\'t time to salvage the situation, but he continued to delude himself into believing there was.","userId":25,"tags":["mystery","american","history"]},{"id":12,"title":"She was aware that things could go wrong.","body":"She was aware that things could go wrong. In fact, she had trained her entire life in anticipation that things would go wrong one day. She had quiet confidence as she started to see that this was the day that all her training would be worthwhile and useful. At this point, she had no idea just how wrong everything would go that day.","userId":26,"tags":["love","english"]},{"id":13,"title":"She wanted rainbow hair.","body":"She wanted rainbow hair. That\'s what she told the hairdresser. It should be deep rainbow colors, too. She wasn\'t interested in pastel rainbow hair. She wanted it deep and vibrant so there was no doubt that she had done this on purpose.","userId":44,"tags":["mystery","classic","french"]},{"id":14,"title":"The paper was blank.","body":"The paper was blank. It shouldn\'t have been. There should have been writing on the paper, at least a paragraph if not more. The fact that the writing wasn\'t there was frustrating. Actually, it was even more than frustrating. It was downright distressing.","userId":1,"tags":["mystery","english","love"]},{"id":15,"title":"The trees, therefore, must be such old","body":"The trees, therefore, must be such old and primitive techniques that they thought nothing of them, deeming them so inconsequential that even savages like us would know of them and not be suspicious. At that, they probably didn\'t have too much time after they detected us orbiting and intending to land. And if that were true, there could be only one place where their civilization was hidden.","userId":15,"tags":["fiction","history","crime"]},{"id":16,"title":"There was only one way to do things in the Statton house.","body":"There was only one way to do things in the Statton house. That one way was to do exactly what the father, Charlie, demanded. He made the decisions and everyone else followed without question. That was until today.","userId":31,"tags":["magical","french","american"]},{"id":17,"title":"She was in a hurry.","body":"She was in a hurry. Not the standard hurry when you\'re in a rush to get someplace, but a frantic hurry. The type of hurry where a few seconds could mean life or death. She raced down the road ignoring speed limits and weaving between cars. She was only a few minutes away when traffic came to a dead standstill on the road ahead.","userId":5,"tags":["french","magical","english"]},{"id":18,"title":"She had a terrible habit o comparing her life to others","body":"She had a terrible habit o comparing her life to others. She realized that their life experiences were completely different than her own and that she saw only what they wanted her to see, but that didn\'t matter. She still compared herself and yearned for what she thought they had and she didn\'t.","userId":28,"tags":["history","french","love"]},{"id":19,"title":"The rain and wind abruptly stopped.","body":"The rain and wind abruptly stopped, but the sky still had the gray swirls of storms in the distance. Dave knew this feeling all too well. The calm before the storm. He only had a limited amount of time before all Hell broke loose, but he stopped to admire the calmness. Maybe it would be different this time, he thought, with the knowledge deep within that it wouldn\'t.","userId":46,"tags":["fiction","crime","magical"]},{"id":20,"title":"He couldn\'t remember exactly where he had read it","body":"He couldn\'t remember exactly where he had read it, but he was sure that he had. The fact that she didn\'t believe him was quite frustrating as he began to search the Internet to find the article. It wasn\'t as if it was something that seemed impossible. Yet she insisted on always seeing the source whenever he stated a fact.","userId":38,"tags":["french","classic"]},{"id":21,"title":"He wandered down the stairs and into the basement","body":"He wandered down the stairs and into the basement. The damp, musty smell of unuse hung in the air. A single, small window let in a glimmer of light, but this simply made the shadows in the basement deeper. He inhaled deeply and looked around at a mess that had been accumulating for over 25 years. He was positive that this was the place he wanted to live.","userId":37,"tags":["french","american"]},{"id":22,"title":"She has seen this scene before.","body":"She has seen this scene before. It had come to her in dreams many times before. She had to pinch herself to make sure it wasn\'t a dream again. As her fingers squeezed against her arm, she felt the pain. It was this pain that immediately woke her up.","userId":30,"tags":["classic","love","history"]},{"id":23,"title":"It\'s an unfortunate reality that we don\'t teach people how to make money","body":"It\'s an unfortunate reality that we don\'t teach people how to make money (beyond getting a 9 to 5 job) as part of our education system. The truth is there are a lot of different, legitimate ways to make money. That doesn\'t mean they are easy and that you won\'t have to work hard to succeed, but it does mean that if you\'re willing to open your mind a bit you don\'t have to be stuck in an office from 9 to 5 for the next fifty years o your life.","userId":2,"tags":["crime","english"]},{"id":24,"title":"The robot clicked disapprovingly.","body":"The robot clicked disapprovingly, gurgled briefly inside its cubical interior and extruded a pony glass of brownish liquid. \\"Sir, you will undoubtedly end up in a drunkard\'s grave, dead of hepatic cirrhosis,\\" it informed me virtuously as it returned my ID card. I glared as I pushed the glass across the table.","userId":34,"tags":["crime","american","love"]},{"id":25,"title":"It went through such rapid contortions","body":"It went through such rapid contortions that the little bear was forced to change his hold on it so many times he became confused in the darkness, and could not, for the life of him, tell whether he held the sheep right side up, or upside down. But that point was decided for him a moment later by the animal itself, who, with a sudden twist, jabbed its horns so hard into his lowest ribs that he gave a grunt of anger and disgust.","userId":27,"tags":["fiction","history","french"]},{"id":26,"title":"She patiently waited for his number to be called.","body":"She patiently waited for his number to be called. She had no desire to be there, but her mom had insisted that she go. She\'s resisted at first, but over time she realized it was simply easier to appease her and go. Mom tended to be that way. She would keep insisting until you wore down and did what she wanted. So, here she sat, patiently waiting for her number to be called.","userId":27,"tags":["french","mystery","crime"]},{"id":27,"title":"Ten more steps.","body":"If he could take ten more steps it would be over, but his legs wouldn\'t move. He tried to will them to work, but they wouldn\'t listen to his brain. Ten more steps and it would be over but it didn\'t appear he would be able to do it.","userId":17,"tags":["mystery","classic","love"]},{"id":28,"title":"He had three simple rules by which he lived.","body":"He had three simple rules by which he lived. The first was to never eat blue food. There was nothing in nature that was edible that was blue. People often asked about blueberries, but everyone knows those are actually purple. He understood it was one of the stranger rules to live by, but it had served him well thus far in the 50+ years of his life.","userId":22,"tags":["crime","love"]},{"id":29,"title":"The chair sat in the corner where it had been","body":"The chair sat in the corner where it had been for over 25 years. The only difference was there was someone actually sitting in it. How long had it been since someone had done that? Ten years or more he imagined. Yet there was no denying the presence in the chair now.","userId":38,"tags":["mystery","american"]},{"id":30,"title":"Things aren\'t going well at all","body":"Things aren\'t going well at all with mom today. She is just a limp noodle and wants to sleep all the time. I sure hope that things get better soon.","userId":2,"tags":["american","love","fiction"]}],"total":150,"skip":0,"limit":30}');






function $da9de4dc762ab941$export$d074f14c5fd21603({ stream: stream, users: users }) {
    // * progress is a number (0-1) indicating the loading percentage
    // * values is an array of posts
    // * data contains extra metadata provided by the cache;
    //   in this case that data includes the total number of posts
    const { data: data, progress: progress = 0, value: value = [] } = (0, $11b66dd26bd4c709$export$7b254c479e244ce4)(stream);
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $110956e5e1cd1426$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $a67418439e9e3831$export$c17561cb55d4db30), {
                progress: progress
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $a67418439e9e3831$export$9ba739f4e3fc4d9), {
                postCount: data?.postCount ?? 0,
                posts: value,
                users: users
            })
        ]
    });
}


const $a67418439e9e3831$var$streamingCache = (0, $c7e99c794f4a465a$export$ea911cd21ad60992)({
    getKey: (posts)=>`${posts.map((post)=>post.id).join(":")}`,
    load: async (options, posts)=>{
        const { signal: signal } = options;
        for(let i = 0; i < posts.length; i++){
            await new Promise((resolve)=>setTimeout(resolve, i % 10 === 0 ? 500 : 1));
            if (signal.aborted) return;
            const progress = i / posts.length;
            options.update(posts.slice(0, i + 1), progress, {
                postCount: posts.length
            });
        }
        options.resolve();
    }
});
function $a67418439e9e3831$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $k116o.Suspense), {
        fallback: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $eadd3566518c92e3$export$2e2bcd8739ae039), {}),
        children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($a67418439e9e3831$var$DemoSuspends, {})
    });
}
function $a67418439e9e3831$var$DemoSuspends() {
    const [state, setState] = (0, $k116o.useState)("ready");
    const [stream, setStream] = (0, $k116o.useState)(null);
    const handleAbort = ()=>{
        if (state === "running") $a67418439e9e3831$var$streamingCache.abort((0, $0600775e0f3da28b$exports.posts));
    };
    const handleChangeState = async ()=>{
        switch(state){
            case "ready":
                const stream = $a67418439e9e3831$var$streamingCache.stream((0, $0600775e0f3da28b$exports.posts));
                setStream(stream);
                setState("running");
                await stream.resolver;
                setState("complete");
                break;
            case "complete":
                $a67418439e9e3831$var$streamingCache.evict((0, $0600775e0f3da28b$exports.posts));
                setStream(null);
                setState("ready");
                break;
        }
    };
    let label;
    switch(state){
        case "ready":
            label = "Start demo";
            break;
        case "running":
            label = "Loading data";
            break;
        case "complete":
            label = "Reset demo";
            break;
    }
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c197f5c73b7078af$exports))).App,
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c197f5c73b7078af$exports))).ButtonRow,
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("button", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c197f5c73b7078af$exports))).Button,
                        disabled: state !== "ready",
                        onClick: handleChangeState,
                        children: "Start demo"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("button", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c197f5c73b7078af$exports))).Button,
                        disabled: state !== "running",
                        onClick: handleAbort,
                        children: "Abort stream"
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("button", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c197f5c73b7078af$exports))).Button,
                        disabled: state !== "complete",
                        onClick: handleChangeState,
                        children: "Reset demo"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("main", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c197f5c73b7078af$exports))).App,
                children: stream ? /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $da9de4dc762ab941$export$d074f14c5fd21603), {
                    stream: stream,
                    users: (0, $e4daaf22c1549cc0$exports.users)
                }) : /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($a67418439e9e3831$var$Placeholder, {})
            })
        ]
    });
}
function $a67418439e9e3831$var$Placeholder() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $110956e5e1cd1426$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($a67418439e9e3831$export$c17561cb55d4db30, {
                progress: 0
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c197f5c73b7078af$exports))).Posts
            })
        ]
    });
}
function $a67418439e9e3831$export$9ba739f4e3fc4d9({ postCount: postCount, posts: posts, users: users }) {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c197f5c73b7078af$exports))).Posts,
        children: Array(postCount).fill(null).map((_, index)=>{
            const post = posts[index] ?? null;
            const user = post ? users.find(({ id: id })=>id === post.userId) ?? null : null;
            if (post && !user) debugger;
            return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($a67418439e9e3831$var$PostRow, {
                post: post,
                user: user
            }, index);
        })
    });
}
function $a67418439e9e3831$export$c17561cb55d4db30({ progress: progress }) {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c197f5c73b7078af$exports))).ProgressBarOuter,
        children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c197f5c73b7078af$exports))).ProgressBarInner,
            style: {
                width: `${progress * 100}%`
            }
        })
    });
}
function $a67418439e9e3831$var$PostRow({ post: post, user: user }) {
    if (post === null || user == null) return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)($a67418439e9e3831$var$PlaceholderRow, {});
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c197f5c73b7078af$exports))).PostRow,
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c197f5c73b7078af$exports))).PostHeaderRow,
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c197f5c73b7078af$exports))).PostName,
                        children: [
                            user.firstName,
                            " ",
                            user.lastName,
                            " (@",
                            user.username,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c197f5c73b7078af$exports))).PostTags,
                        children: post.tags.map((tag)=>/*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c197f5c73b7078af$exports))).PostTag,
                                children: tag
                            }, tag))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c197f5c73b7078af$exports))).PostTitle,
                children: [
                    '"',
                    post.title,
                    '"'
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c197f5c73b7078af$exports))).PostBody,
                children: post.body
            })
        ]
    });
}
function $a67418439e9e3831$var$PlaceholderRow() {
    const width = (0, $k116o.useMemo)(()=>25 + Math.random() * 75, []);
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c197f5c73b7078af$exports))).PlaceholderRow,
        style: {
            width: `${width}%`
        }
    });
}



function $add8680d6d1b2196$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $aa6eba4c47b97eb7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $4b3065620e983e4c$export$2e2bcd8739ae039), {
                    title: "writing a streaming cache"
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "The demo below shows how a",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b061e8b516dc3a67$export$a6c7ac8248d6e38a), {
                                to: (0, $d87e1b304aec4d6d$export$1d56bcf14907e007),
                                children: "streaming cache"
                            }),
                            " can be used to render a larger data set as it incrementally loads."
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("p", {
                        children: 'Click the "start demo" button to fetch user data in the cache.'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                type: "demo",
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $a67418439e9e3831$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "The demo above uses the",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b061e8b516dc3a67$export$a6c7ac8248d6e38a), {
                                    to: (0, $d87e1b304aec4d6d$export$ab0a2769ad209342),
                                    children: "useStreamingValue"
                                })
                            }),
                            " ",
                            "hook to incrementally render posts as they stream in. At a high level that usage looks like this:"
                        ]
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                        code: (0, $58f88c7e2d2afb29$export$7eb1b49cd2af1357).streamingCache.Posts
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                        children: [
                            "The full code for the demo can be found",
                            " ",
                            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $7ec290908b96eb45$export$b2bf131c9f9cce5d), {
                                to: "https://github.com/bvaughn/suspense/tree/main/packages/suspense-website/src/examples/demos",
                                children: "here"
                            }),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                children: "The cache in this demo uses a timeout to simulate a slow network request."
            })
        ]
    });
}












function $6f5c6b67bc5a7ab5$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $aa6eba4c47b97eb7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $4b3065620e983e4c$export$2e2bcd8739ae039), {
                    title: "optimizing immutable caches"
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                    children: [
                        "If a cache contains values that will never be mutated, the",
                        " ",
                        /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                            children: "immutable"
                        }),
                        " config flag can be used to avoid potential unnecessary renders after other caches have been mutated. (To learn more about this optimization, check out this",
                        " ",
                        /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $7ec290908b96eb45$export$b2bf131c9f9cce5d), {
                            to: "https://www.loom.com/share/dde355b8a9e643adb146768cbd943d39",
                            children: "deep dive video"
                        }),
                        ".)"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $c563c48496378798$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b7652cd56eb7f50a$export$2e2bcd8739ae039), {
                    code: (0, $58f88c7e2d2afb29$export$cf6fa0bbcc94b912).immutable
                })
            }),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b466a4c2331ccdd9$export$2e2bcd8739ae039), {
                type: "warn",
                children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)("p", {
                    children: [
                        "Passing an immutable cache to the",
                        " ",
                        /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)("code", {
                            children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $b061e8b516dc3a67$export$a6c7ac8248d6e38a), {
                                to: (0, $d87e1b304aec4d6d$export$a7f6f2cd4cc90607),
                                children: "useCacheMutation"
                            })
                        }),
                        " ",
                        "hook will throw an error."
                    ]
                })
            })
        ]
    });
}



var $k116o = parcelRequire("k116o");

function $0d3d0e8c4cab0f8f$export$2e2bcd8739ae039() {
    const { hash: hash } = (0, $f6bd5ad5dd65be62$export$45d76561a5302f2b)();
    const navigationType = (0, $f6bd5ad5dd65be62$export$1b3f31771c5d07c)();
    (0, $k116o.useEffect)(()=>{
        // Keep default behavior of restoring scroll position when user:
        // - clicked back button
        // - clicked on a link that programmatically calls `history.goBack()`
        // - manually changed the URL in the address bar (here we might want
        // to scroll to top, but we can't differentiate it from the others)
        if (navigationType === "POP") return;
        // In all other cases, check fragment/scroll to top
        if (hash) {
            let element = document.querySelector(hash);
            if (element) element.scrollIntoView({
                block: "start",
                behavior: "smooth"
            });
        } else window.scrollTo(0, 0);
    }, [
        hash,
        navigationType
    ]);
    return null;
}


const $c914b34ef04ab4a8$var$rootElement = document.getElementById("root");
const $c914b34ef04ab4a8$var$root = (0, $76965258e0e6e98a$export$882461b6382ed46c)($c914b34ef04ab4a8$var$rootElement);
$c914b34ef04ab4a8$var$root.render(/*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $k116o.StrictMode), {
    children: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $b061e8b516dc3a67$export$9ba4e89fdfa1fc54), {
        children: [
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $0d3d0e8c4cab0f8f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsxs)((0, $f6bd5ad5dd65be62$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f6bd5ad5dd65be62$export$e7b0ac011bb776c6), {
                        path: "*",
                        element: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $d9450d3e371047b2$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f6bd5ad5dd65be62$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $dcd1f696b57a5202$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f6bd5ad5dd65be62$export$e7b0ac011bb776c6), {
                        path: (0, $d87e1b304aec4d6d$export$c6e57d4df408c13c),
                        element: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $5c0e60e4690bae0b$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f6bd5ad5dd65be62$export$e7b0ac011bb776c6), {
                        path: (0, $d87e1b304aec4d6d$export$80fdcb5a3142d1bd),
                        element: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $97b24782e8f29b8c$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f6bd5ad5dd65be62$export$e7b0ac011bb776c6), {
                        path: (0, $d87e1b304aec4d6d$export$b0030bce8559349f),
                        element: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $41550aba7a770505$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f6bd5ad5dd65be62$export$e7b0ac011bb776c6), {
                        path: (0, $d87e1b304aec4d6d$export$4eda7113e54677aa),
                        element: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $20901ab293a05bd1$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f6bd5ad5dd65be62$export$e7b0ac011bb776c6), {
                        path: (0, $d87e1b304aec4d6d$export$ced0558925123210),
                        element: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $6ab3d0c82f1bacb0$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f6bd5ad5dd65be62$export$e7b0ac011bb776c6), {
                        path: (0, $d87e1b304aec4d6d$export$1d56bcf14907e007),
                        element: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $4f58786280d7494d$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f6bd5ad5dd65be62$export$e7b0ac011bb776c6), {
                        path: (0, $d87e1b304aec4d6d$export$a1a38004ba5076cd),
                        element: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $39ff9f937b1011d2$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f6bd5ad5dd65be62$export$e7b0ac011bb776c6), {
                        path: (0, $d87e1b304aec4d6d$export$9ccf183b65eb2452),
                        element: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $d64ce72ec23bcc04$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f6bd5ad5dd65be62$export$e7b0ac011bb776c6), {
                        path: (0, $d87e1b304aec4d6d$export$f240987ac561f7ec),
                        element: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $fa86050eb0f28a0f$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f6bd5ad5dd65be62$export$e7b0ac011bb776c6), {
                        path: (0, $d87e1b304aec4d6d$export$a5c1c7acf17ea32a),
                        element: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $7b5108a38f6180ee$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f6bd5ad5dd65be62$export$e7b0ac011bb776c6), {
                        path: (0, $d87e1b304aec4d6d$export$5c5abf861764150e),
                        element: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $1f07ee8ebc443d0d$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f6bd5ad5dd65be62$export$e7b0ac011bb776c6), {
                        path: (0, $d87e1b304aec4d6d$export$f17b62024bc7b6e0),
                        element: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $6f5c6b67bc5a7ab5$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f6bd5ad5dd65be62$export$e7b0ac011bb776c6), {
                        path: (0, $d87e1b304aec4d6d$export$866f2572af03bc6),
                        element: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $add8680d6d1b2196$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f6bd5ad5dd65be62$export$e7b0ac011bb776c6), {
                        path: (0, $d87e1b304aec4d6d$export$1237172d87df4b0f),
                        element: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $cd252a7e342f7bc2$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f6bd5ad5dd65be62$export$e7b0ac011bb776c6), {
                        path: (0, $d87e1b304aec4d6d$export$630373a46fa30388),
                        element: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $54d97e78c3eeeff5$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f6bd5ad5dd65be62$export$e7b0ac011bb776c6), {
                        path: (0, $d87e1b304aec4d6d$export$a7f6f2cd4cc90607),
                        element: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $a5cb92a7e4623dcf$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f6bd5ad5dd65be62$export$e7b0ac011bb776c6), {
                        path: (0, $d87e1b304aec4d6d$export$4eb9f97e3e3a1e88),
                        element: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $5e91cb1880ea5837$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f6bd5ad5dd65be62$export$e7b0ac011bb776c6), {
                        path: (0, $d87e1b304aec4d6d$export$6c09fcd90d770bc4),
                        element: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $8849c1eda432779d$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f6bd5ad5dd65be62$export$e7b0ac011bb776c6), {
                        path: (0, $d87e1b304aec4d6d$export$a9a6e7732aaecca6),
                        element: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $a7ac143a014924e0$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f6bd5ad5dd65be62$export$e7b0ac011bb776c6), {
                        path: (0, $d87e1b304aec4d6d$export$e1b81feb0c103c86),
                        element: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $65a223e13908066b$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $f6bd5ad5dd65be62$export$e7b0ac011bb776c6), {
                        path: (0, $d87e1b304aec4d6d$export$ab0a2769ad209342),
                        element: /*#__PURE__*/ (0, $110956e5e1cd1426$exports.jsx)((0, $d31c17f93376807e$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        ]
    })
}));


//# sourceMappingURL=index.097f1d61.js.map
